import { o as e, r as t } from "./rolldown-runtime-jwUa06l-.js";
import { Br as n, Bt as r, Cr as i, Dr as a, Ft as o, Gr as s, Hr as c, I as l, Ir as u, It as d, K as f, Kr as p, Lr as m, Mr as h, N as g, Nr as _, Nt as v, On as y, Or as b, P as x, Pn as S, Pt as C, Qn as w, Rt as T, Sn as ee, Sr as E, Tr as te, Ur as ne, Vr as re, Wr as ie, X as ae, Xn as oe, Yr as D, _n as se, bn as ce, cn as le, ct as ue, d as de, dr as fe, dt as pe, k as me, ln as he, lt as ge, mt as _e, o as ve, qr as ye, rn as be, rr as xe, rt as Se, u as Ce, vn as we, wr as Te, xr as Ee, yn as De, zr as Oe } from "./@global-configuration-CBGz_rZL.js";
import { Component as ke, Fragment as Ae, createContext as je, createElement as Me, useContext as Ne, useEffect as O, useMemo as k, useRef as Pe, useState as A } from "react";
import { AIAgentContextSourceType as Fe, APIResponseHandler as Ie, API_STATUS_CODES as Le, API_TOKEN_PREFIX as Re, ActionMenu as ze, ActivityIndicator as Be, AnimatedTimer as Ve, AppStatusModal as He, ApprovalConfigDataKindType as Ue, ApprovalRuntimeStateType as We, ArtifactInfoModal as Ge, BASE_CONFIGURATION_ENV_ID as Ke, BASE_ROUTES as j, BreadCrumb as qe, BreadcrumbText as Je, BulkSelection as Ye, BulkSelectionEvents as Xe, BulkSelectionProvider as Ze, Button as M, ButtonComponentType as Qe, ButtonStyleType as $e, ButtonVariantType as N, ButtonWithLoader as et, ButtonWithSelector as tt, CDMaterialResourceQuery as nt, CHECKBOX_VALUE as rt, Checkbox as it, ClipboardButton as at, CodeEditor as ot, CollapsibleList as st, CommitChipCell as ct, ComponentSizeType as P, ConditionalWrap as lt, ConfirmationModal as ut, ConfirmationModalVariantType as dt, ContextSwitcher as ft, CustomInput as pt, DATE_TIME_FORMATS as mt, DEPLOYMENT_STAGE_TO_NODE_MAP as ht, DEPLOYMENT_STATUS as gt, DEPLOYMENT_WINDOW_TYPE as _t, DOCUMENTATION as vt, DOCUMENTATION_HOME_PAGE as yt, DTSwitch as bt, DefaultUserKey as xt, DeleteConfirmationModal as St, DependencyType as Ct, DeploymentStageType as wt, DeploymentWithConfigType as Tt, DetectBottom as Et, DevtronProgressing as Dt, DocLink as Ot, DraggableButton as kt, DraggablePositionVariant as At, DraggableWrapper as jt, Drawer as Mt, ERROR_STATUS_CODE as Nt, EditableTextArea as Pt, EnvironmentTypeEnum as Ft, ErrorScreenManager as It, FeatureDescriptionModal as Lt, FeatureTitleWithInfo as Rt, FetchIdDataStatus as zt, FilterChips as Bt, FilterConditionType as Vt, FilterSelectPicker as Ht, FiltersTypeEnum as Ut, GenericDescription as Wt, GenericEmptyState as F, GenericFilterEmptyState as Gt, GenericSectionErrorState as Kt, GitCommitInfoGeneric as qt, HistoryComponentType as Jt, Icon as Yt, IframeContainer as Xt, ImageCard as Zt, ImageCardAccordion as Qt, ImageChipCell as $t, ImageType as en, ImageWithFallback as tn, InfoBlock as nn, InfoIconTippy as rn, LoadingIndicator as an, LogResizeButton as on, MESSAGES as sn, MODAL_TYPE as cn, MODES as ln, ModalSidebarPanel as un, ModuleNameMap as dn, ModuleStatus as fn, PageHeader as pn, PaginationEnum as mn, PatchOperationType as hn, PopupMenu as gn, Progressing as _n, PromiseAllStatusType as vn, RJSFForm as yn, ROUTER_URLS as I, ROUTES as bn, RadioGroup as xn, RadioGroupItem as Sn, RegistryIcon as Cn, RegistryType as wn, Reload as Tn, ResourceKindType as L, ResourceVersionType as R, SEMANTIC_VERSION_DOCUMENTATION_LINK as En, STAGE_TYPE as Dn, SearchBar as On, SegmentedControl as kn, SelectAllDialogStatus as An, SelectPicker as jn, ServerErrors as Mn, SidePanelTab as Nn, Sidebar as Pn, SortableTableHeaderCell as z, SortingOrder as Fn, SourceTypeMap as In, StatusComponent as Ln, StatusType as Rn, TIMELINE_STATUS as zn, TRIGGER_STATUS_PROGRESSING as Bn, TabGroup as Vn, Table as Hn, Textarea as Un, TippyCustomized as Wn, TippyTheme as Gn, ToastManager as B, ToastVariantType as V, Tooltip as Kn, TreeView as qn, TriggerOutput as Jn, URLS as Yn, UserIdentifier as Xn, UserStatusDto as Zn, VisibleModal as Qn, VisibleModal2 as $n, WFR_STATUS_DTO_TO_DEPLOYMENT_STATUS_MAP as er, YAMLStringify as tr, ZERO_TIME_STRING as nr, abortPreviousRequests as rr, asyncWrap as ir, capitalizeFirstLetter as ar, conformPathToPointers as or, convertJSONPointerToJSONPath as sr, deepEqual as cr, extractImage as lr, findRight as ur, get as H, getAlphabetIcon as dr, getCommonSelectStyle as fr, getDeploymentStageTitle as pr, getGitCommitInfo as mr, getHandleOpenURL as hr, getInferredTypeFromValueType as gr, getIsApprovalPolicyConfigured as _r, getIsMaterialInfoAvailable as vr, getIsRequestAborted as yr, getKeyToBooleanMapFromArray as br, getModuleConfigured as xr, getOrdinal as Sr, getRandomColor as Cr, getRedirectionProps as wr, getResourceApiUrl as Tr, getSecurityModalSidebarChildFromId as Er, getSecurityModalSidebarId as Dr, getSelectPickerOptionByValue as Or, getSidebarData as kr, getTimeDifference as Ar, getTriggerHistory as jr, getUniqueId as Mr, getUrlWithSearchParams as Nr, getWebhookEventIcon as Pr, getWebhookEventsForEventId as Fr, handleAnalyticsEvent as Ir, handleRelativeDateSorting as Lr, handleUTCTime as Rr, highlightSearchText as zr, isNullOrUndefined as Br, logExceptionToSentry as Vr, mapByKey as Hr, noop as U, numberComparatorBySortOrder as Ur, patch as Wr, post as Gr, prefixZeroIfSingleDigit as Kr, preventDefault as qr, processCDMaterialServiceResponse as Jr, put as Yr, renderValidInputButtonTippy as Xr, requiredField as Zr, sanitizeApprovalConfigData as Qr, sanitizeUserApprovalMetadata as $r, showError as W, stopPropagation as ei, stringComparatorBySortOrder as G, trash as ti, useAnimationControls as ni, useAsync as K, useBreadcrumb as ri, useBulkSelection as ii, useDebounce as ai, useDownload as oi, useGetUserRoles as si, useImageSelectionUtilityContext as ci, useInterval as li, useMainContext as ui, useQueryClient as di, useScrollable as fi, useSearchString as pi, useStateFilters as mi, useTriggerAutoClickTimestamp as hi, useUrlFilters as gi, validateAppName as _i, validateDescription as vi, validateDisplayName as yi, validateIfImageExist as bi, validateName as xi, validateSemanticVersioning as Si, validateURL as Ci } from "@devtron-labs/devtron-fe-common-lib";
import { Link as wi, Navigate as Ti, Route as Ei, Routes as Di, generatePath as q, useLocation as Oi, useNavigate as ki, useParams as Ai } from "react-router-dom";
import ji from "./assets/no-artifact.fd2d84d9.webp";
import Mi from "./assets/person-on-rocket.f16cb83a.png";
import Ni from "./assets/group-similar.d1527089.png";
import Pi from "./assets/empty-folder.4570c4ae.webp";
import Fi, { components as Ii } from "react-select";
import Li from "./assets/release-add-application.9090fe90.png";
import Ri from "./assets/person-working-on-pc.5efff7ef.png";
import zi from "./assets/no-target-tenants.0891629d.png";
import Bi from "./assets/release-not-ready.8d094f89.png";
import Vi from "./assets/requirements-not-locked.c0eb5da1.webp";
import Hi from "./assets/release-note-null-state.f92348ce.webp";
import Ui from "./assets/release-order-null-state.56740f29.png";
import Wi from "./assets/clip-delete-confirmation.77ab0429.png";
import Gi from "./assets/cloud-empty-state.9bb9b0ae.png";
import Ki from "./assets/teenage-package-delivery.e1185625.png";
import './assets/@software-distribution-hub.css';//#region src/Assets/Icons/ic-promote-deployment.svg?react
var J = ye(), qi = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...e,
	children: [/* @__PURE__ */ (0, J.jsx)("path", {
		d: "M2 1.33334H5.66667L8.33333 8.00001L5.66667 14.6667H2L4.66667 8.00001L2 1.33334Z",
		fill: "#1D2730"
	}), /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M7.66663 1.33334H11.3333L14 8.00001L11.3333 14.6667H7.66663L10.3333 8.00001L7.66663 1.33334Z",
		fill: "#FFB549"
	})]
}), Ji = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...e,
	children: /* @__PURE__ */ (0, J.jsxs)("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ (0, J.jsx)("path", { d: "M0 0h32v32H0z" }),
			/* @__PURE__ */ (0, J.jsx)("path", {
				fill: "#de350b",
				d: "M16 2.667C8.64 2.667 2.667 8.64 2.667 16S8.64 29.333 16 29.333 29.333 23.36 29.333 16 23.36 2.667 16 2.667z"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				fill: "#FFF",
				d: "M16 14.667c.736 0 1.333.597 1.333 1.333v5.333a1.333 1.333 0 1 1-2.666 0V16c0-.736.597-1.333 1.333-1.333zm0-5.334A1.333 1.333 0 1 1 16 12a1.333 1.333 0 0 1 0-2.667z"
			})
		]
	})
}), Yi = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		stroke: "#3B444C",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M4 22h16M5 18h14a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1Zm8.5-5 1.945-8.557A2 2 0 0 0 13.495 2h-2.99a2 2 0 0 0-1.95 2.443L10.5 13h3Z",
		vectorEffect: "non-scaling-stroke"
	})
}), Xi = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ (0, J.jsx)("circle", {
		cx: 10.0001,
		cy: 10.0001,
		r: 8.33333,
		fill: "#1DAD70"
	}), /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M13.3334 8.33325L8.88897 12.7775L6.66675 10.5555",
		stroke: "var(--N0)",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Zi = {
	NOT_CONFIGURED_EMPTY_STATE: {
		TITLE: "Image promotion is not configured",
		SUB_TITLE: "Please configure image promotion for this workflow to promote images."
	},
	REFRESH_LABEL: "Refresh Materials",
	SHOW_SEARCH_BAR: "Show search bar",
	SEARCH_IMAGE_TAG_PLACEHOLDER: "Search image tag",
	ENVIRONMENT_SELECTOR_LABEL: {
		[c.REQUEST]: {
			FROM_NO_ENVIRONMENT: "Show images from",
			FROM_ENVIRONMENT: "Show images passed from"
		},
		[c.PENDING]: "Show requests"
	},
	ENVIRONMENT_SELECTOR_GROUP_LABEL: {
		[ne.BULK_DEPLOY]: { [c.REQUEST]: "Image available at" },
		[ne.IMAGE_PROMOTION]: {
			[c.REQUEST]: "Passed from environments",
			[c.PENDING]: "Promotion requests for"
		}
	},
	ENVIRONMENT_SELECTOR_SHUTTER_LABEL: {
		[c.PENDING]: "All pending for me",
		[c.REQUEST]: {
			WEBHOOK: "External CI",
			CI: "CI Pipeline",
			LINKED_CI: "Linked CI",
			LINKED_CD: "Sync with Env",
			JOB_CI: "Job Pipeline"
		}
	},
	ENVIRONMENT_SELECTOR_SHUTTER_VALUE: {
		[c.REQUEST]: "Image source for workflow",
		[c.PENDING]: "All pending for me"
	},
	ENVIRONMENT_SELECTOR_SHUTTER_DESCRIPTION: {
		[c.REQUEST]: "Image source for workflow",
		[c.PENDING]: ""
	},
	ENVIRONMENT_SELECTOR_PLACEHOLDER: "Select environment",
	EMPTY_STATES: {
		[c.REQUEST]: {
			SOURCE: {
				TITLE: "No Image Available",
				SUBTITLE: "No images have been built/received from the connected CI Pipeline."
			},
			ENV: {
				TITLE: "No Image Available",
				getTitle: (e) => `No image available at '${e}'`,
				getSubtitle: (e, t) => {
					switch (t) {
						case ne.IMAGE_PROMOTION: return `No images have successfully passed all deployment stages for '${e}'`;
						case ne.BULK_DEPLOY: return "Images passed from the previous stage are available at a given stage";
						default: return Vr(`Invalid type ${t} found for use image list type`), "No images available";
					}
				}
			}
		},
		[c.PENDING]: {
			SELF: {
				TITLE: "No image promotion requests pending for you",
				SUBTITLE: "You can view environment specific image promotion requests by switching context from the above dropdown."
			},
			ENV: {
				getTitle: (e) => `No image promotion requests pending for '${e}'`,
				SUBTITLE: "Images which are requested to be promoted to this environment will be available here."
			}
		},
		NO_ARTIFACT_SEARCH: {
			TITLE: "No artifacts Found",
			SUBTITLE: "We could not find any artifact matching given criteria"
		}
	},
	VIEW_OTHER_REQUESTS: "View other requests…",
	CLEAR_FILTERS: "Clear filters",
	NOT_AUTHORIZED: "You are not authorized to view this page"
}, Qi = (e) => Array.from(e.entries()).reduce((e, [t, n]) => (e[t] = n, e), {}), $i = (e, t, n) => n === ne.BULK_DEPLOY ? "" : e === c.PENDING ? Zi.ENVIRONMENT_SELECTOR_LABEL[c.PENDING] : t ? Zi.ENVIRONMENT_SELECTOR_LABEL[c.REQUEST].FROM_ENVIRONMENT : Zi.ENVIRONMENT_SELECTOR_LABEL[c.REQUEST].FROM_NO_ENVIRONMENT, ea = (e, t, n, r) => {
	let i = Object.keys(e.environments).map((e) => ({
		value: e,
		label: e
	})).sort((e, t) => e.label.localeCompare(t.label)), a = {
		label: Zi.ENVIRONMENT_SELECTOR_GROUP_LABEL[r][t],
		options: i
	};
	return [{
		label: "",
		options: [{
			label: t === c.PENDING ? Zi.ENVIRONMENT_SELECTOR_SHUTTER_LABEL[c.PENDING] : n,
			value: Zi.ENVIRONMENT_SELECTOR_SHUTTER_VALUE[t],
			description: Zi.ENVIRONMENT_SELECTOR_SHUTTER_DESCRIPTION[t]
		}]
	}, a];
}, ta = (e) => {
	switch (e) {
		case nt.WEBHOOK: return Zi.ENVIRONMENT_SELECTOR_SHUTTER_LABEL[c.REQUEST].WEBHOOK;
		case nt.LINKED_CI: return Zi.ENVIRONMENT_SELECTOR_SHUTTER_LABEL[c.REQUEST].LINKED_CI;
		case nt.LINKED_CD: return Zi.ENVIRONMENT_SELECTOR_SHUTTER_LABEL[c.REQUEST].LINKED_CD;
		case nt.CI_JOB: return Zi.ENVIRONMENT_SELECTOR_SHUTTER_LABEL[c.REQUEST].JOB_CI;
		default: return Zi.ENVIRONMENT_SELECTOR_SHUTTER_LABEL[c.REQUEST].CI;
	}
}, na = (e, t, n) => e === c.PENDING || !n || !t ? null : ta(n.type), ra = (e, t) => !e || !t ? null : e.nodes.find((e) => e.environmentName === t) ?? null, ia = /* @__PURE__ */ function(e) {
	return e.SUCCESS = "SUCCESS", e.ERROR = "ERROR", e.INFO = "INFO", e.PENDING = "PENDING", e;
}({}), aa = /* @__PURE__ */ function(e) {
	return e.PROMOTE = "PROMOTE", e.CANCEL = "CANCEL", e.APPROVE = "APPROVE", e;
}({}), oa = (e) => {
	let t = Object.keys(e);
	return t.length === 1 && e[t[0]].promotionPossible ? { [t[0]]: e[t[0]] } : {};
}, sa = (e) => {
	let t = Object.keys(e);
	return t.length === 1 && e[t[0]].approvalAllowed ? { [t[0]]: e[t[0]] } : {};
}, ca = (e) => {
	let t = "icon-dim-16 dc__no-shrink mt-2";
	switch (e) {
		case ia.SUCCESS: return /* @__PURE__ */ (0, J.jsx)(Xi, { className: t });
		case ia.PENDING: return /* @__PURE__ */ (0, J.jsx)(Yi, { className: `${t} scv-5` });
		case ia.INFO: return /* @__PURE__ */ (0, J.jsx)(ie, { className: t });
		default: return /* @__PURE__ */ (0, J.jsx)(Ji, { className: t });
	}
}, la = (e, t) => t === nt.ENVIRONMENT ? e : ta(t), ua = (e, t) => e ? re.REQUEST_IN_PROGRESS : t ? null : re.NO_SELECTED_IMAGE, da = (e, t) => {
	let n = {
		eligibleEnvironmentsNames: [],
		inEligibleEnvironmentsNames: []
	};
	return t?.reduce((t, n) => (e[n].promotionPossible ? t.eligibleEnvironmentsNames.push(n) : t.inEligibleEnvironmentsNames.push(n), t), n) ?? n;
}, fa = (e, t) => e ? re.REQUEST_IN_PROGRESS : t === 0 ? re.NO_ENVIRONMENT_SELECTED : null, pa = ({ environment: e, ciSource: t, imagePromotionTab: n }) => n === c.PENDING || !t ? {
	sourceType: nt.PROMOTION_APPROVAL_PENDING_NODE,
	...e ? { sourceName: e } : {}
} : e ? {
	sourceName: e,
	sourceType: nt.ENVIRONMENT
} : {
	sourceName: t.name,
	sourceType: t.type
}, ma = ({ imagePromotionTab: e, environment: t, ciSource: n }) => e === c.PENDING ? {
	resource: nt.PROMOTION_APPROVAL_PENDING_NODE,
	...t ? { resourceName: t } : {}
} : t ? {
	resource: nt.ENVIRONMENT,
	resourceName: t
} : {
	resource: n.type,
	resourceName: n.name,
	resourceId: n.id
}, ha = {
	HEADING: "Promoted image",
	ELIGIBLE_DUE_TO_POLICY: "Eligible due to policy",
	PROMOTED_BY: "Promoted by",
	APPROVED_BY: "Approved by",
	getInfoText: (e, t) => `Image was promoted to '${e}' from '${t}'.`
}, ga = ({ promotedTo: e, promotedFrom: t, promotedBy: n, approvedBy: r, promotionPolicyName: i }) => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "p-12 flexbox-col dc__gap-12 h-200 dc__overflow-auto",
	children: [
		/* @__PURE__ */ (0, J.jsx)("p", {
			className: "m-0 cn-9 fs-13 fw-4 lh-20",
			children: ha.getInfoText(e, t)
		}),
		/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col dc__gap-8",
			children: [/* @__PURE__ */ (0, J.jsx)("h2", {
				className: "m-0 cn-9 fs-13 fw-6 lh-20",
				children: ha.ELIGIBLE_DUE_TO_POLICY
			}), /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox dc__gap-8",
				children: [/* @__PURE__ */ (0, J.jsx)(s, { className: "icon-dim-20 dc__no-shrink" }), /* @__PURE__ */ (0, J.jsx)("p", {
					className: "cn-9 dc__ellipsis-right fs-13 fw-4 lh-20 m-0",
					children: i
				})]
			})]
		}),
		/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col dc__gap-8",
			children: [/* @__PURE__ */ (0, J.jsx)("h2", {
				className: "m-0 cn-9 fs-13 fw-6 lh-20",
				children: ha.PROMOTED_BY
			}), /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox dc__gap-8",
				children: [dr(n, "dc__no-shrink m-0-imp"), /* @__PURE__ */ (0, J.jsx)("p", {
					className: "cn-9 dc__ellipsis-right fs-13 fw-4 lh-20 m-0",
					children: n
				})]
			})]
		}),
		r?.length > 0 && /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col dc__gap-8",
			children: [/* @__PURE__ */ (0, J.jsx)("h2", {
				className: "m-0 cn-9 fs-13 fw-6 lh-20",
				children: ha.APPROVED_BY
			}), r.map((e) => /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox dc__content-space dc__align-items-center",
				children: [/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox dc__gap-8 dc__ellipsis-right",
					children: [dr(e, "dc__no-shrink m-0-imp"), /* @__PURE__ */ (0, J.jsx)("p", {
						className: "cn-9 dc__ellipsis-right fs-13 fw-4 lh-20 m-0",
						children: e
					})]
				}), /* @__PURE__ */ (0, J.jsx)(p, { className: "icon-dim-16 scg-5 dc__no-shrink" })]
			}, e))]
		})
	]
}), _a = ({ promotedTo: e, promotedFrom: t, promotedFromType: n, promotedBy: r, approvedBy: i, promotionPolicyName: a, showBackgroundColor: o }) => {
	let s = la(t, n);
	return /* @__PURE__ */ (0, J.jsx)(Wn, {
		theme: Gn.white,
		className: "w-300 h-100",
		placement: "top-start",
		additionalContent: /* @__PURE__ */ (0, J.jsx)(ga, {
			promotedTo: e,
			promotedFrom: s,
			promotedBy: r,
			approvedBy: i,
			promotionPolicyName: a
		}),
		Icon: qi,
		heading: ha.HEADING,
		showCloseButton: !0,
		trigger: "click",
		interactive: !0,
		children: /* @__PURE__ */ (0, J.jsxs)("button", {
			className: `${o ? "bcy-1 ey-2 bw-1 pl-6" : "dc__no-background dc__no-border dc__hover-color-b500 pl-0"} cn-9 flexbox br-4 pt-2 pb-2 pr-6 dc__gap-6 dc__align-items-center dc__outline-none-imp dc__tab-focus`,
			type: "button",
			"data-testid": `image-promotion-info-chip-${t}-${r}`,
			children: [/* @__PURE__ */ (0, J.jsx)(qi, { className: "icon-dim-16 dc__no-shrink" }), /* @__PURE__ */ (0, J.jsx)("span", {
				className: "m-0 fs-13 fw-4 lh-20",
				children: s
			})]
		})
	});
}, va = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		stroke: "#3B444C",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "m16.389 9.077-5.524 5.524-2.762-2.762m13.7-1.832a10 10 0 0 0-3.045-5.38M18.63 19.49a9.998 9.998 0 0 0 3.137-5.325m-12.94 7.318c2.004.67 4.168.69 6.182.055M2.2 13.993a10.001 10.001 0 0 0 3.044 5.38M5.372 4.51a9.998 9.998 0 0 0-3.138 5.325m12.94-7.318a10.007 10.007 0 0 0-6.182-.054",
		vectorEffect: "non-scaling-stroke"
	})
}), ya = ({ handleDiscardDraft: e, handleClearPopupNode: t, isDraftDeleting: n, placement: r = "bottom-end", approvalType: i, children: a }) => {
	let { cancelRequestTitle: o, cancelRequestInfo: s } = Te[i];
	return /* @__PURE__ */ (0, J.jsx)(Wn, {
		theme: Gn.white,
		heading: o,
		className: "w-300 h-100",
		iconClass: "scv-5",
		showCloseButton: !0,
		interactive: !0,
		visible: !0,
		onClose: t,
		additionalContent: /* @__PURE__ */ (0, J.jsx)("div", {
			className: "mxh-250 br-4 bg__primary flexbox-col",
			children: /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col p-12 dc__gap-20",
				children: [/* @__PURE__ */ (0, J.jsx)("span", {
					className: "fs-13 fw-4 lh-20 cn-9",
					children: s
				}), /* @__PURE__ */ (0, J.jsx)("div", {
					className: "w-100 flexbox dc__content-end",
					children: /* @__PURE__ */ (0, J.jsx)(M, {
						text: o,
						size: P.small,
						variant: N.primary,
						style: $e.negative,
						onClick: e,
						dataTestId: "discard-draft-config-button",
						isLoading: n
					})
				})]
			})
		}),
		placement: r,
		children: a
	});
}, ba = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...e,
	children: [/* @__PURE__ */ (0, J.jsx)("circle", {
		cx: 12,
		cy: 12,
		r: 10,
		fill: "#664BEE"
	}), /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M11.0983 14.24V13.745C11.0983 13.305 11.1583 12.91 11.2783 12.56C11.4083 12.21 11.5633 11.93 11.7433 11.72C11.9333 11.51 12.1333 11.305 12.3433 11.105C12.5633 10.905 12.7633 10.73 12.9433 10.58C13.1333 10.43 13.2883 10.245 13.4083 10.025C13.5383 9.79501 13.6033 9.55001 13.6033 9.29001C13.6033 8.90001 13.4683 8.58501 13.1983 8.34501C12.9383 8.09501 12.5733 7.97001 12.1033 7.97001C11.5433 7.97001 11.1133 8.13501 10.8133 8.46501C10.5133 8.78501 10.3633 9.23001 10.3633 9.80001H8.65332C8.65332 8.72001 8.96832 7.87001 9.59832 7.25001C10.2283 6.63001 11.0633 6.32001 12.1033 6.32001C13.1233 6.32001 13.9183 6.60001 14.4883 7.16001C15.0583 7.72001 15.3433 8.43001 15.3433 9.29001C15.3433 9.75001 15.2533 10.16 15.0733 10.52C14.9033 10.87 14.6933 11.155 14.4433 11.375C14.2033 11.595 13.9583 11.81 13.7083 12.02C13.4683 12.22 13.2583 12.465 13.0783 12.755C12.9083 13.045 12.8233 13.38 12.8233 13.76V14.24H11.0983ZM12.8083 16.865C12.5883 17.085 12.3083 17.195 11.9683 17.195C11.6283 17.195 11.3433 17.085 11.1133 16.865C10.8933 16.635 10.7833 16.355 10.7833 16.025C10.7833 15.705 10.8983 15.43 11.1283 15.2C11.3583 14.97 11.6383 14.855 11.9683 14.855C12.2983 14.855 12.5783 14.97 12.8083 15.2C13.0383 15.43 13.1533 15.705 13.1533 16.025C13.1533 16.355 13.0383 16.635 12.8083 16.865Z",
		fill: "#FFF"
	})]
}), xa = "app/cd-pipeline/approve", Sa = {
	submit: 0,
	approve: 1,
	cancel: 2
}, Ca = {
	[u.SUBMIT]: "Image approval request submitted",
	[u.APPROVE]: "Image approved",
	[`${u.APPROVE}_AUTO_CD`]: "Image has been approved.",
	[u.CANCEL]: "Image approval request cancelled"
}, wa = {
	heading: "Approval for deployment to",
	tab: {
		first: "Request approval",
		second: "Approval pending"
	},
	approverInfoMsg: "‘Approver’ role can be provided to users via",
	noApproverInfoMsg: "No users have ‘Approver’ permission for this application and environment. ‘Approver’ role can be provided to users via",
	permissions: "User Permissions.",
	approverGroups: {
		user: "Users",
		token: "API Tokens"
	},
	specificUsersHeading: "Specific users",
	anyBelowUsers: "Any below users"
}, Ta = "Connect with super admin user to approve the changes", Ea = "No eligible changes found", Da = "Changes in an array cannot be done, since there are changes to some locked keys.", Oa = {
	imageBuilderTippy: "You triggered the build pipeline for this image. The builder of an image cannot approve it.",
	approvedByYou: "Approved by you",
	awaiting: "Awaiting approval",
	requestApproval: {
		heading: "Notify users for approvals",
		infoText: "Request approval for deploying this image. All users having ‘Approver’ permission for this application and environment can approve.",
		label: "Request approval"
	},
	cancelRequest: {
		heading: "Cancel approval request",
		infoText: "Are you sure you want to cancel approval request for this image? A new approval request would need to be raised if you want to deploy this image.",
		label: "Cancel request"
	},
	approveRequest: {
		heading: "Approve image",
		infoText: "Are you sure you want to approve deploying this image to",
		label: "Approve"
	},
	vulnerability: {
		found: "Security vulnerability found",
		notFound: "No vulnerabilities Found",
		notScanned: "Image was not scanned",
		scanDisabled: "Scan is Disabled",
		scanned: "Scanned on"
	},
	sourceInfo: {
		hide: "Hide Source Info",
		show: "Show Source Info"
	}
}, ka = {
	[u.SUBMIT]: "Submit request",
	[u.APPROVE]: "Approve request",
	[u.CANCEL]: "Cancel request"
}, Aa = {
	requestedBy: "Approval requested by",
	cancelRequest: "Are you sure you want to cancel the request?",
	noApprovals: "This image has not received any approvals.",
	deploymentBy: "Deployment initiated by"
}, ja = {
	noImage: {
		title: "No image available",
		subTitle: "Trigger build pipeline and find the image here",
		cdAutoMode: (e) => `Deployment to ${e} is set to Automatic. Deployment of an image is initiated as soon as it receives the required number of approvals.`,
		cdSubtitle: "Images will be available here for deployment after approval.",
		rollbackSubtitle: "Approved images which have been previously deployed will be available here for rollback.",
		label: "View images for approval"
	},
	noApprovedImages: {
		title: "No approved images",
		subTitle: "Trigger build pipeline and find the image here",
		label: "View images for approval"
	},
	noPendingImages: {
		title: "No images are pending for approval",
		subTitle: "Images for which approval is requested will be available here. All users having ‘Approver’ permission for this application and environment can approve.",
		label: "View images for approval"
	},
	noEligibleImages: {
		title: "No eligible image found",
		subTitle: (e) => `Latest ${e} images are not passing the filter conditions`
	}
}, Ma = "installed", Na = {
	strokeSolid: "var(--N400)",
	arrowColor: "var(--N600)"
}, Pa = {
	notConfiguredTitle: "Email sender is not configured",
	notConfiguredInfo: "Configure SES or SMTP to notify specific people for approval requests",
	noDefaultStateTitle: "No default email configuration found",
	noDefaultStateInfo: "The default SES or SMTP configuration is used to send notifications. Set an email configuration as default to notify specific people for approval requests."
}, Fa = "approval-state", Ia = /* @__PURE__ */ function(e) {
	return e.APPROVAL = "approval", e.PENDING = "pending", e;
}({}), La = (e) => !e && e !== 0, Ra = ({ requiredApprovalCount: e, currentApprovalCount: t }) => /* @__PURE__ */ (0, J.jsx)(Kn, {
	alwaysShowTippyOnHover: La(t),
	content: "Approvals required",
	children: /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flex dc__gap-4 br-10 bcn-1 px-6",
		children: [/* @__PURE__ */ (0, J.jsx)(Yi, { className: "dc__no-shrink icon-dim-12 scn-7 dc__no-shrink" }), /* @__PURE__ */ (0, J.jsx)("span", {
			className: "cn-7 fs-12 fw-6 lh-20",
			children: La(t) ? Kr(e) : `${t}/${e}`
		})]
	})
}), za = (e) => {
	let { eligibleApprovers: { anyUsers: t, specificUsers: n, userGroups: r } } = e;
	return t.approverList.length + n.approverList.length + r.flatMap(({ approverList: e }) => e).length;
}, Ba = (e) => e ? /* @__PURE__ */ (0, J.jsx)(p, { className: "icon-dim-16 scg-5 dc__no-shrink" }) : /* @__PURE__ */ (0, J.jsx)(Kn, {
	alwaysShowTippyOnHover: !0,
	content: "Approval pending",
	children: /* @__PURE__ */ (0, J.jsx)("div", {
		className: "icon-dim-16 dc__no-shrink",
		children: /* @__PURE__ */ (0, J.jsx)(E, { className: "icon-dim-16 scn-6 dc__no-shrink" })
	})
}), Va = (e) => e.filter((e) => !e.startsWith(Re) && e !== xt.admin), Ha = (e, t) => e.filter(({ identifier: e }) => !e.startsWith(Re) && e !== t).map(({ identifier: e }) => e), Ua = ({ showApprovalCountBadge: e = !0, showUserApprovalStatus: t = !0, approvalConfigData: n, approvalType: r }) => {
	let a = Pe(null), o = k(() => n.userGroupsApprovedInfo.userGroups.reduce((e, { approverList: t }) => e + t.length, n.anyUserApprovedInfo.approverList.length + n.specificUsersApprovedInfo.approverList.length), [n]), s = () => {
		a.current.scrollIntoView({
			behavior: "smooth",
			block: "end"
		});
	}, c = (t, n, r = 0) => /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox dc__gap-8",
		children: [/* @__PURE__ */ (0, J.jsx)(Kn, {
			content: t,
			children: /* @__PURE__ */ (0, J.jsx)("h4", {
				className: "m-0 dc__truncate cn-7 fs-12 fw-6 lh-20 dc__uppercase flex-grow-1",
				children: t
			})
		}), e && /* @__PURE__ */ (0, J.jsx)(Ra, {
			currentApprovalCount: r,
			requiredApprovalCount: n
		})]
	}), l = (e, n, i) => {
		let a = e.sort((e, t) => e.hasApproved === t.hasApproved ? G(e.identifier, t.identifier) : e.hasApproved ? -1 : 1);
		return a.length > 0 ? a.map(({ identifier: e, hasApproved: i, canApprove: a }) => /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox dc__gap-8 dc__align-items-center",
			children: [/* @__PURE__ */ (0, J.jsx)(Xn, {
				rootClassName: `flex-grow-1 ${a ? "" : "dc__disabled"}`,
				tooltipContent: a ? null : Te[r].notEligibleUser,
				identifier: e
			}), t && Ba(i)]
		}, `${n}-${e}-user`)) : /* @__PURE__ */ (0, J.jsx)("span", {
			className: "lh-20 cn-7 fs-13",
			children: i
		});
	};
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col dc__gap-12",
		children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col dc__gap-4",
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flex left dc__gap-4",
				children: [/* @__PURE__ */ (0, J.jsx)("h3", {
					className: "m-0 fs-13 fw-6 lh-20 cn-9",
					children: "Approvers"
				}), /* @__PURE__ */ (0, J.jsx)(M, {
					dataTestId: "help-icon",
					ariaLabel: "Help info",
					icon: /* @__PURE__ */ (0, J.jsx)(i, {}),
					showAriaLabelInTippy: !1,
					variant: N.borderLess,
					style: $e.neutral,
					size: P.xs,
					onClick: s
				})]
			}), n.requiredCount > 0 || o > 0 ? /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col dc__gap-16",
				children: [
					(n.specificUsersApprovedInfo.requiredCount > 0 || n.specificUsersApprovedInfo.approverList.length > 0) && /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox-col dc__gap-8",
						children: [c(wa.specificUsersHeading, n.specificUsersApprovedInfo.requiredCount, n.specificUsersApprovedInfo.currentCount), l(n.specificUsersApprovedInfo.approverList, "specific", "No specific users")]
					}),
					n.userGroupsApprovedInfo.userGroups.map(({ groupIdentifier: e, groupName: t, requiredCount: n, currentCount: r, approverList: i }) => n > 0 || i.length > 0 ? /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox-col dc__gap-8",
						children: [c(t, n, r), l(i, `user-group-${e}`, "No users in this group")]
					}, `${e}-user-group`) : null),
					(n.anyUserApprovedInfo.requiredCount > 0 || n.anyUserApprovedInfo.approverList.length > 0) && /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox-col dc__gap-8",
						children: [c(wa.anyBelowUsers, n.anyUserApprovedInfo.requiredCount, n.anyUserApprovedInfo.currentCount), l(n.anyUserApprovedInfo.approverList, "any", Te[r].noUsersFound)]
					})
				]
			}) : /* @__PURE__ */ (0, J.jsx)("p", {
				className: "m-0 fs-13 cn-7 lh-20 fw-4",
				children: "No approvals required"
			})]
		}), /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "px-12 py-8 flex top left dc__gap-8 bcv-1 ev-2 br-4 bw-1",
			ref: a,
			children: [/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("h5", {
				className: "fs-13 fw-6 lh-20 cn-9 m-0",
				children: "Approvers"
			}), /* @__PURE__ */ (0, J.jsxs)("p", {
				className: "m-0 fs-13 fw-4 lh-20 cn-9",
				children: [
					"Users with\xA0",
					/* @__PURE__ */ (0, J.jsxs)("span", {
						className: "dc__lowercase",
						children: [
							"‘",
							Te[r].title,
							"’"
						]
					}),
					"\xA0permission & meeting the",
					/* @__PURE__ */ (0, J.jsx)(wi, {
						to: I.APPLICATION_MANAGEMENT_POLICIES.APPROVAL_POLICY.APPLIED_POLICY.ROOT,
						target: "_blank",
						children: "\xA0applied approval policy\xA0"
					}),
					"criteria for this pipeline/scope."
				]
			})] }), /* @__PURE__ */ (0, J.jsx)(ba, { className: "dc__no-shrink icon-dim-20" })]
		})]
	});
}, Wa = ({ requestedUserId: e, userApprovalMetadata: t, isLoading: n, triggeredBy: r, handleCancelRequest: i, approvalType: a }) => {
	let { requestedUserData: o, approvalConfigData: s } = t ?? {}, c = o?.userId && o.userId === e;
	return /* @__PURE__ */ (0, J.jsx)("div", {
		className: "h-100 dc__overflow-hidden",
		children: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "p-12 flexbox-col dc__gap-12 h-100 mxh-250 dc__overflow-auto",
			children: [
				/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col dc__gap-8",
					children: [/* @__PURE__ */ (0, J.jsx)("h5", {
						className: "fs-13 fw-6 lh-20 m-0",
						children: Aa.requestedBy
					}), /* @__PURE__ */ (0, J.jsxs)("span", {
						className: "flex left fs-13 fw-4 dc__content-space dc__gap-4",
						children: [/* @__PURE__ */ (0, J.jsx)(Xn, { identifier: o?.userEmail ?? "" }), c && /* @__PURE__ */ (0, J.jsx)(M, {
							text: "Cancel",
							isLoading: n,
							dataTestId: "cancel-approval-request",
							onClick: i,
							variant: N.text,
							style: $e.negative
						})]
					})]
				}),
				/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-top-n1" }),
				/* @__PURE__ */ (0, J.jsx)(Ua, {
					approvalConfigData: s,
					approvalType: a
				}),
				!!r && /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-top-n1" }), /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col dc__gap-8",
					children: [/* @__PURE__ */ (0, J.jsx)("h5", {
						className: "fs-13 fw-6 lh-20 m-0",
						children: Aa.deploymentBy
					}), /* @__PURE__ */ (0, J.jsx)(Xn, { identifier: r })]
				})] })
			]
		})
	});
}, Ga = ({ children: e, placement: t, requestedUserId: n, userApprovalMetadata: r, cancelRequest: i, isLoading: a, showCount: o = !0, showOnlyCountInButton: s = !1, approvalType: c, ...l }) => {
	let [d, f] = A(!1), { requiredCount: p } = r.approvalConfigData, m = Math.min(r.approvalConfigData.currentCount, p), h = `${o ? `${m ?? 0}/${p ?? 0}` : ""}`, g = () => {
		f((e) => !e);
	}, _ = (e) => {
		i(e, u.CANCEL);
	}, v = () => /* @__PURE__ */ (0, J.jsx)("div", { children: e || /* @__PURE__ */ (0, J.jsx)(M, {
		startIcon: /* @__PURE__ */ (0, J.jsx)(va, {}),
		text: `${h}${s ? "" : " Approvals"}`,
		variant: N.borderLess,
		style: $e.neutral,
		dataTestId: "num-of-approvals-check",
		size: P.xs,
		onClick: U
	}) });
	return d ? /* @__PURE__ */ (0, J.jsx)(ya, {
		handleDiscardDraft: _,
		handleClearPopupNode: g,
		isDraftDeleting: a,
		placement: t,
		approvalType: c,
		children: v()
	}) : /* @__PURE__ */ (0, J.jsx)(Wn, {
		theme: Gn.white,
		className: "w-300 h-100",
		placement: t,
		Icon: va,
		iconClass: "scv-5",
		heading: `${h} Approvals`,
		additionalContent: /* @__PURE__ */ (0, J.jsx)(Wa, {
			...l,
			requestedUserId: n,
			userApprovalMetadata: r,
			isLoading: a,
			handleCancelRequest: g,
			approvalType: c
		}),
		showCloseButton: !0,
		trigger: "click",
		interactive: !0,
		children: v()
	});
}, Ka = (e) => Gr(xa, e), qa = async (e) => {
	try {
		let { result: t } = await H(`${_.PIPELINE_DEPLOYMENT_APPROVAL_CONFIG}/${e}`);
		return Qr(t?.config);
	} catch (e) {
		throw W(e), e;
	}
}, Ja = /* @__PURE__ */ t({ default: () => Ya }), Ya = ({ matId: e, appId: t, pipelineId: n, requestedUserId: r, userApprovalMetadata: i, showCount: a, triggeredBy: o, reloadMaterials: s, hideApprovalCheckIcon: c = !1, showInfoIcon: l = !1, isExceptionUser: u = !1 }) => {
	let [d, f] = A(!1), { currentCount: p } = i.approvalConfigData, h = i.approvalRuntimeState === We.approved, g = u && !h;
	return /* @__PURE__ */ (0, J.jsx)(Ga, {
		requestedUserId: r,
		userApprovalMetadata: i,
		cancelRequest: ((e, r) => (i) => {
			i.stopPropagation(), f(!0), Ka({
				appId: t,
				actionType: Sa.cancel,
				pipelineId: +n,
				artifactId: +e,
				approvalRequestId: +r
			}).then(() => {
				B.showToast({
					variant: V.success,
					description: "Image approval expired"
				}), s?.();
			}).catch((e) => {
				W(e);
			}).finally(() => {
				f(!1);
			});
		})(e, i?.approvalRequestId),
		isLoading: d,
		triggeredBy: o,
		showCount: g,
		approvalType: m.Image,
		children: !g && /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flex left cursor dc__hover-color-b500 dc__gap-6",
			children: [
				!c && /* @__PURE__ */ (0, J.jsx)(Yt, {
					name: "ic-checks",
					color: "N600"
				}),
				/* @__PURE__ */ (0, J.jsx)("span", {
					className: "fs-13 fw-4",
					children: `${a ? p : ""} Approved`
				}),
				l && /* @__PURE__ */ (0, J.jsx)(Oe, { className: "icon-dim-16" })
			]
		})
	});
}, Xa = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	width: 18,
	height: 16,
	viewBox: "0 0 18 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M17.25 8H0.75M0.75 8L7.5 1.25M0.75 8L7.5 14.75",
		stroke: "#596168",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
//#endregion
//#region src/Components/Filters/AppliedFilters/ConfiguredFilterDisplay.tsx
function Za({ name: e, expression: t }) {
	let n = k(() => t.split("\n"), [t]);
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col dc__align-self-stretch bg__primary dc__border dc__top-radius-4",
		children: [/* @__PURE__ */ (0, J.jsx)("div", {
			className: "flexbox pt-8 pb-8 pl-16 pr-16 dc__align-items-center dc__align-self-stretch dc__gap-10 dc__border-bottom",
			children: /* @__PURE__ */ (0, J.jsxs)("p", {
				className: "fw-4 m-0",
				children: ["Filter ", /* @__PURE__ */ (0, J.jsx)("span", {
					className: "fs-13 fw-6 m-0",
					children: e
				})]
			})
		}), /* @__PURE__ */ (0, J.jsx)("pre", {
			className: "flexbox-col p-8 fs-12 dc__align-start m-0 mh-150 mxh-210 dc__overflow-auto read-only-expression bg__primary dc__no-border",
			children: n.map((e, t) => /* @__PURE__ */ (0, J.jsx)("span", { children: e }, t))
		})]
	});
}
//#endregion
//#region src/Assets/Icons/ic-exit-fullscreen.svg?react
var Qa = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M9.5 3.5V6.5M9.5 6.5H12.5M9.5 6.5L13 3M3.5 9.5H6.5M6.5 9.5V12.5M6.5 9.5L3 13",
		stroke: "#596168",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $a = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		fill: "#767D84",
		fillRule: "evenodd",
		d: "M3.75 9.75c.385 0 .702.29.745.663l.005.087v1.938l2.432-2.43c.293-.294.768-.294 1.06 0 .271.27.292.695.063.99l-.062.07L5.56 13.5H7.5c.385 0 .702.29.745.663l.005.087c0 .385-.29.702-.663.745L7.5 15H3.75l-.078-.005-.049-.006-.051-.01-.054-.016c-.015-.004-.03-.01-.044-.015l-.05-.023c-.015-.006-.029-.014-.043-.022-.018-.01-.036-.021-.053-.033l-.033-.023c-.024-.02-.048-.04-.07-.061l-.005-.006c-.051-.051-.09-.103-.123-.16l-.005-.01-.018-.035c-.01-.019-.018-.039-.026-.06l-.014-.04-.016-.06-.008-.041-.005-.037-.002-.023L3 14.271V10.5c0-.414.336-.75.75-.75zM14.25 3l.076.004.05.007.052.01.054.016c.015.004.03.01.044.015l.05.023c.015.006.029.014.043.022.018.01.036.021.053.033.01.006.018.013.027.02l.034.026.031.028.016.016c.051.051.09.103.123.16l.005.01.018.035c.01.019.018.039.026.06l.014.04.016.06.008.041.003.018.005.046.001.03.001.03V7.5c0 .414-.336.75-.75.75-.385 0-.702-.29-.745-.663L13.5 7.5V5.56l-2.47 2.47c-.293.293-.767.293-1.06 0-.27-.27-.291-.695-.063-.99l.063-.07 2.469-2.471L10.5 4.5c-.385 0-.702-.29-.745-.663L9.75 3.75c0-.385.29-.702.663-.745L10.5 3h3.75z"
	})
}), eo = (e) => {
	let t = structuredClone(e.error), { data: n } = e;
	return t.appName = t.appName || Zr(n.appName).message || null, t.projectId = t.projectId || Zr(n.projectId ? String(n.projectId) : null).message || null, t.environmentId = t.environmentId || Zr(n.environmentId ? String(n.environmentId) : null).message || null, t.gitRepoUrl = t.gitRepoUrl || Zr(n.gitRepoUrl).message || null, t.gitAccountId = t.gitAccountId || Zr(n.gitAccountId ? String(n.gitAccountId) : null).message || null, t.dockerRepository = t.dockerRepository || Zr(n.dockerRepository).message || null, t.dockerRegistry = t.dockerRegistry || Zr(n.dockerRegistry ? String(n.dockerRegistry) : null).message || null, {
		areErrorsPresent: Object.values(t).some((e) => !!e),
		errors: t
	};
}, to = /* @__PURE__ */ function(e) {
	return e.USER = "USER", e.BOT = "BOT", e;
}({}), no = /* @__PURE__ */ function(e) {
	return e.COMPLETED = "COMPLETED", e.STARTED = "STARTED", e.FAILED = "FAILED", e.QUEUED = "QUEUED", e.IN_TRANSIT = "IN_TRANSIT", e.ABORTED = "ABORTED", e;
}({}), ro = /* @__PURE__ */ function(e) {
	return e.THINKING_STEP = "ThinkingStepText", e.MESSAGE_TEXT = "MessageText", e.TEXT = "text", e.GRAPH = "graph", e.FORM_DATA = "FormData", e.FORM_SUBMISSION = "FORM_SUBMISSION", e.STEP_PROGRESS = "StepProgress", e;
}({}), io = /* @__PURE__ */ function(e) {
	return e.LIKE = "LIKE", e.DISLIKE = "DISLIKE", e;
}({}), ao = /* @__PURE__ */ function(e) {
	return e.INCORRECT_MISLEADING = "Incorrect or misleading response", e.UNCLEAR_INCOMPLETE = "Unclear or incomplete response", e.MISUNDERSTOOD_QUESTION = "Misunderstood my question", e.TOO_SLOW = "Too slow to respond", e.OTHERS = "Others", e;
}({}), oo = [
	no.COMPLETED,
	no.FAILED,
	no.ABORTED
], so = {
	[Fe.APP_DETAILS]: "ic-application",
	[Fe.RESOURCE_BROWSER_CLUSTER]: "ic-cluster"
}, co = {
	[Fe.APP_DETAILS]: "App Details",
	[Fe.RESOURCE_BROWSER_CLUSTER]: "Cluster"
}, lo = {
	starting: {
		name: "ic-circle-loader",
		color: "B500"
	},
	pending: {
		name: "ic-timeout-dash",
		color: "N700"
	},
	running: {
		name: "ic-circle-loader",
		color: "B500"
	},
	succeeded: {
		name: "ic-check-circle",
		color: "G500"
	},
	progressing: {
		name: "ic-circle-loader",
		color: "B500"
	},
	error: {
		name: "ic-error",
		color: null
	},
	cancelled: {
		name: "ic-cancelled",
		color: null
	},
	timeout: {
		name: "ic-timeout-dash",
		color: "R500"
	},
	completed: {
		name: "ic-check-circle",
		color: "G500"
	},
	failed: {
		name: "ic-error",
		color: null
	},
	skipped: {
		name: "ic-arrow-right",
		color: "Y500"
	},
	unknown: {
		name: "ic-help-filled",
		color: null
	}
}, uo = {
	LIKE: "like",
	DISLIKE: "dislike"
}, fo = {
	[ao.MISUNDERSTOOD_QUESTION]: "Misunderstood my question",
	[ao.INCORRECT_MISLEADING]: "Incorrect or misleading response",
	[ao.UNCLEAR_INCOMPLETE]: "Unclear or incomplete response",
	[ao.TOO_SLOW]: "Too slow to respond",
	[ao.OTHERS]: "Others"
}, po = /* @__PURE__ */ e(w(), 1), mo = (e) => {
	if (!e) return null;
	if (e.action === "CREATE_APP") {
		let t = e.data?.templatePatch, n = t?.gitMaterial?.[0], r = t?.workflowConfig?.cd?.[0], i = t?.buildConfiguration;
		return {
			type: "createApp",
			action: e.action,
			formId: e.formId,
			data: {
				templateIdentifier: e.data?.templateIdentifier,
				appName: e.data?.appName || "",
				projectId: e.data?.teamId || null,
				environmentId: r?.environmentId || null,
				gitRepoUrl: n?.gitMaterialURL || "",
				gitAccountId: n?.gitAccountId || null,
				dockerRepository: i?.dockerRepository || "",
				dockerRegistry: i?.dockerRegistry || null
			},
			error: {
				appName: null,
				projectId: null,
				environmentId: null,
				gitRepoUrl: null,
				gitAccountId: null,
				dockerRepository: null,
				dockerRegistry: null
			}
		};
	}
	return e.action === "APP_CREATED_READY_TO_DEPLOY" ? {
		type: "appCreatedReadyToDeploy",
		action: e.action,
		formId: e.formId,
		data: e.data || null
	} : null;
}, ho = (e) => e.reduce((e, t) => {
	switch (t.type) {
		case "text-message":
			e += `${t.content}\n`;
			break;
		default: break;
	}
	return e;
}, ""), go = (e, t) => {
	(t.parts || []).forEach((n, r) => {
		switch (n.type) {
			case ro.TEXT:
			case ro.MESSAGE_TEXT: {
				let t = e.messages.length;
				if (t === 0 || e.messages[t - 1].type !== "text-message") {
					e.messages.push({
						type: "text-message",
						content: n.content || "",
						identifier: Mr()
					});
					break;
				}
				let r = e.messages[t - 1];
				r.type === "text-message" && (r.content += n.content || "");
				break;
			}
			case ro.GRAPH:
				if (!n.content?.objectId) break;
				e.messages.push({
					type: "graph",
					graphProps: {
						graphId: n.content?.objectId,
						title: n.content?.title || ""
					},
					identifier: Mr()
				});
				break;
			case ro.THINKING_STEP: {
				if (!n.content) break;
				if (e.messages.length === 0) {
					e.messages.push({
						type: "thoughts",
						content: [n.content],
						identifier: Mr()
					});
					break;
				}
				let t = e.messages[e.messages.length - 1];
				t.type === "thoughts" && t.content.push(n.content);
				break;
			}
			case ro.FORM_DATA: {
				if (r !== t.parts.length - 1) break;
				let i = mo(n.content);
				if (!i) break;
				e.messages.push({
					type: "form-data",
					content: i,
					identifier: Mr()
				});
				break;
			}
			case ro.FORM_SUBMISSION: break;
			case ro.STEP_PROGRESS: {
				if (!n.content) break;
				let t = "default-action-identifier";
				e.messages = e.messages.filter((e) => !(e.type === "step-progress" && e.content.actionIdentifier === t));
				let r = (n.content.steps || []).map((e) => ({
					id: e.id || Mr(),
					label: e.label || "",
					status: e.status || "unknown"
				}));
				e.messages.push({
					type: "step-progress",
					content: {
						title: n.content.title || "",
						actionIdentifier: t,
						steps: r,
						context: n.content.context || {}
					},
					identifier: Mr()
				});
				break;
			}
			default: break;
		}
	}), e.messageToCopy = ho(e.messages);
}, _o = (e) => (e || []).reduce((e, t) => {
	let { messageId: n } = t;
	if (t.senderType === to.USER) {
		let { context: r } = t, i = r?.data || {}, a = ("uiMarkup" in i ? i.uiMarkup : void 0) || (t.parts || []).map((e) => {
			if (e.type === ro.TEXT || e.type === ro.MESSAGE_TEXT) return e.content;
			if (e.type === ro.FORM_SUBMISSION) {
				let t = e.content?.action;
				return t === "APP_CREATED_READY_TO_DEPLOY" ? "Build & Deploy" : t === "CREATE_APP" ? "Create Application" : "Action Submitted";
			}
			return "";
		}).join("\n");
		return e.push({
			messageId: n,
			senderType: to.USER,
			content: a,
			context: Object.values(Fe).includes(r?.source) ? r : void 0,
			status: t.status
		}), e;
	}
	let r = {
		messageId: n,
		senderType: to.BOT,
		messages: [],
		messageToCopy: "",
		userFeedbackStatus: uo[t.ratings] || "none",
		status: t.status
	};
	return go(r, t), e.push(r), e;
}, []), vo = (e, t = !1) => {
	let n = t ? "cb-7 fs-13 fw-5 lh-20" : "cn-7 fs-12 fw-4 lh-1-5";
	switch (e.source) {
		case Fe.APP_DETAILS: return /* @__PURE__ */ (0, J.jsxs)("div", {
			className: `flexbox dc__align-items-center dc__gap-4 ${n}`,
			children: [
				/* @__PURE__ */ (0, J.jsx)("span", {
					className: "dc__no-shrink",
					children: e.data.appName || "Unknown App"
				}),
				/* @__PURE__ */ (0, J.jsx)("span", {
					className: "dc__no-shrink",
					children: "•"
				}),
				/* @__PURE__ */ (0, J.jsx)("span", {
					className: "dc__truncate",
					children: e.data.envName || e.data.namespace || "Unknown environment"
				})
			]
		});
		case Fe.RESOURCE_BROWSER_CLUSTER: return /* @__PURE__ */ (0, J.jsx)("span", {
			className: `dc__truncate ${n}`,
			children: e.data.clusterName || "Unknown Cluster"
		});
		default: return null;
	}
}, yo = (e) => e.type === "createApp" ? {
	formId: e.formId,
	action: e.action,
	data: {
		templateIdentifier: e.data.templateIdentifier,
		appName: e.data.appName,
		teamId: e.data.projectId,
		templatePatch: {
			gitMaterial: [{
				gitAccountId: e.data.gitAccountId,
				gitMaterialURL: e.data.gitRepoUrl
			}],
			buildConfiguration: {
				dockerRegistry: e.data.dockerRegistry,
				dockerRepository: e.data.dockerRepository
			},
			workflowConfig: { cd: [{ environmentId: e.data.environmentId }] }
		}
	}
} : e.type === "appCreatedReadyToDeploy" ? {
	formId: e.formId,
	action: e.action,
	data: e.data || null
} : null, bo = ({ messageId: e, threadId: t, feedbackStatus: n, reasons: r, additionalDetails: i }) => !n || n === "none" ? {
	threadId: t,
	messageId: e,
	ratings: null
} : n === "like" ? {
	threadId: t,
	messageId: e,
	ratings: io.LIKE
} : {
	threadId: t,
	messageId: e,
	ratings: io.DISLIKE,
	reasons: r,
	additionalDetails: i
}, xo = async ({ graphId: e, threadId: t, messageId: n, signal: r }) => (await H(q(`${bn.ATHENA}/${_.GRAPH_DATA}`, {
	threadId: t,
	messageId: n,
	graphId: e
}), {
	signal: r,
	isProxyHost: !0
}))?.result?.data, So = async ({ selectedThread: e, content: t, type: n, context: r, signal: i }) => {
	let a = {
		message: [{
			parts: [n === ro.TEXT ? {
				content: t,
				type: ro.TEXT
			} : {
				content: yo(t),
				type: ro.FORM_SUBMISSION
			}],
			senderType: to.USER,
			generatedAt: (0, po.default)().toISOString(),
			context: r
		}],
		messageThread: { threadId: e?.threadId || null }
	}, { result: o } = await Gr(`${bn.ATHENA}/${_.NEW_THREAD}`, a, {
		isProxyHost: !0,
		signal: i
	}), s = o.messages.find((e) => e.senderType === to.BOT);
	if (!s.messageId) throw Error("Bot message not found in the response");
	return {
		thread: {
			threadId: o.messageThread?.threadId || e.threadId,
			createdAt: o.messageThread?.createdAt || e.createdAt,
			threadName: o.messageThread?.threadName || e.threadName
		},
		botMessageId: s.messageId,
		chatMessageGroups: _o(o.messages)
	};
}, Co = async (e, t) => {
	let { result: n } = await H(Nr(`${bn.ATHENA}/${q(_.THREAD_MESSAGES_LIST, { threadId: e })}`, {
		limit: 50,
		offset: 0
	}), {
		isProxyHost: !0,
		signal: t
	});
	return _o(n?.messages || []);
}, wo = async (e) => {
	try {
		await Gr(`${bn.ATHENA}/${_.CHAT_FEEDBACK}`, bo(e), { isProxyHost: !0 });
	} catch {}
}, To = (e, t) => ti(q(`${bn.ATHENA}/${_.CHAT_GENERATION_STOP}`, {
	threadId: e,
	messageId: t
}), {}, { isProxyHost: !0 }), Eo = je({
	selectedThread: null,
	chatMessageGroups: [],
	messageInput: "",
	isStreamingChat: !1,
	handleInitiateStream: U,
	handleMessageInputChange: U,
	handleThreadChange: U,
	onScroll: U,
	onScrollToBottomClick: U,
	animationControl: null,
	scrollContainerRef: null,
	handleUpdateScrollContainerRef: U,
	useCurrentContext: !0,
	handleToggleUseCurrentContext: U,
	handleCreateNewChat: U,
	refetchInitialConversation: U,
	isFetchingInitialConversation: !1,
	initialConversationError: null,
	handleUpdateTextAreaRef: U,
	textAreaRef: null,
	handleCloseThread: U,
	handleAbortMessage: U,
	handleCreateAppFormChange: U,
	handleUpdateLastUserMessageRef: U,
	handleFeedbackClick: U,
	isAbortingMessage: !1
}), Do = () => {
	let e = Ne(Eo);
	if (!e) throw Error("useAIChat must be used within AIChatProvider");
	return e;
}, Oo = ({ children: e }) => {
	let { aiAgentContext: t, debugAgentContext: n, setDebugAgentContext: r } = ui(), [i, a] = A(null), [o, s] = A([]), [c, l] = A(""), [u, d] = A(!1), [f, p] = A(!0), [m, h] = A(null), [g, v] = A(null), [y, b] = A(!1), x = di(), S = Pe(new AbortController()), C = Pe(null), w = Pe(null), T = Pe(null), ee = (e) => {
		T.current = e;
	}, E = Pe(null), te = (e) => {
		e && (E.current = e);
	}, ne = Pe({ userHasControlOnScroll: !1 }), re = ni(), ie = (e) => {
		w.current = e;
	}, ae = () => {
		if (!E.current) return;
		let e = E.current.scrollHeight - E.current.scrollTop - E.current.clientHeight;
		ne.current.userHasControlOnScroll = e > 2, re.start({ scale: +(e > 32) }).catch(U);
	}, oe = (e = !0) => {
		E.current?.scrollTo({
			top: E.current.scrollHeight - E.current.clientHeight + 1,
			behavior: e ? "smooth" : "auto"
		});
	}, D = () => {
		d(!1), C.current && C.current.close();
	}, se = async () => {
		S.current.abort();
		let e = o[o.length - 1];
		if (e.senderType === to.BOT && !oo.includes(e.status)) {
			b(!0);
			try {
				await To(i.threadId, e.messageId);
			} catch (e) {
				W(e);
			} finally {
				b(!1);
			}
		}
		D();
	}, ce = (e) => {
		try {
			let { data: t } = e, n = JSON.parse(t);
			if (!n?.result || n.errors) {
				W(n.errors || /* @__PURE__ */ Error("Unable to receive message from server.")), D();
				return;
			}
			let r = n.result;
			s((e) => {
				let t = structuredClone(e), n = t.find((e) => e.senderType === to.BOT && e.messageId === r.messageId), i = n || {
					messageId: r.messageId,
					senderType: to.BOT,
					messages: [],
					messageToCopy: "",
					userFeedbackStatus: "none",
					status: r.status || no.IN_TRANSIT
				};
				return go(i, r), n || t.push(i), t;
			}), oo.includes(r.status) && C.current && D();
		} catch (e) {
			Vr(e), D();
		}
	}, le = (e, t) => {
		try {
			d(!0), C.current?.close(), ne.current.userHasControlOnScroll = !1, w.current?.scrollIntoView({ behavior: "smooth" });
			let n = q(_.THREAD_MESSAGES, {
				threadId: e,
				messageId: t
			}), r = new EventSource(`/proxy/${bn.ATHENA}/${n}`, { withCredentials: !0 });
			C.current = r, r.onmessage = ce, r.onerror = D;
		} catch (e) {
			W(e), d(!1);
		}
	}, ue = async ({ selectedThread: e = i, messageInput: o = c, debugAgentContext: u = n, useCurrentContext: p = f, type: m = ro.TEXT, formData: h }) => {
		d(!0), C.current?.close(), S.current.abort(), S.current = new AbortController();
		let { signal: g } = S.current;
		ne.current.userHasControlOnScroll = !1;
		let _ = structuredClone(u);
		_ && delete _.prompt;
		try {
			let { botMessageId: n, thread: i, chatMessageGroups: c } = await So({
				signal: g,
				selectedThread: e,
				context: p ? _ || t : null,
				...m === ro.TEXT ? {
					content: o,
					type: ro.TEXT
				} : {
					content: h,
					type: ro.FORM_SUBMISSION
				}
			});
			if (u?.data && "uiMarkup" in u.data) {
				let e = structuredClone(u);
				e.data && "uiMarkup" in e.data && delete e.data.uiMarkup, r(e);
			}
			l(""), s((e) => [...e, ...c]), a(i), le(i.threadId, n);
		} catch (e) {
			g.aborted || (W(e), d(!1));
		}
	}, de = (e) => {
		l(e.target.value);
	}, fe = () => {
		if (f) {
			p(!1), r(null);
			return;
		}
		t && p(!0);
	}, pe = async () => {
		S.current.abort(), C.current && C.current.close(), g && (await x.cancelQueries({ queryKey: ["getChatThreadInitialConversation", g] }), h(null), v(null)), a(null), d(!1), l(""), s([]), p(!0), re.set({ scale: 0 }), ne.current.userHasControlOnScroll = !1;
	}, me = async (e) => {
		try {
			if (!e) return;
			v(e.threadId), h(null);
			let t = await x.fetchQuery({
				queryKey: ["getChatThreadInitialConversation", e.threadId],
				queryFn: ({ signal: t }) => Co(e.threadId, t)
			});
			if (s(t), !t.length) return;
			let n = t[t.length - 1];
			n.senderType === to.BOT && n.status === no.IN_TRANSIT && le(e.threadId, n.messageId);
		} catch (e) {
			h(e);
		} finally {
			v(null);
		}
	}, he = async (e) => {
		r(null), await pe(), a(e), await me(e);
	}, ge = async () => {
		r(null), await pe(), a(null), T.current?.focus();
	}, _e = async () => {
		await me(i);
	}, ve = async ({ messageId: e, ...t }) => {
		let n = o.find((t) => t.senderType === to.BOT && t.messageId === e);
		if (!n) return;
		let r = structuredClone(n);
		r.isSendingFeedback = !0, r.userFeedbackStatus = t.feedbackStatus, s((t) => t.map((t) => t.messageId === e && t.senderType === to.BOT ? r : t)), await wo({
			...t,
			messageId: e
		}), r.isSendingFeedback = !1, s((t) => t.map((t) => t.messageId === e && t.senderType === to.BOT ? r : t));
	};
	O(() => () => {
		S.current.abort(), C.current && C.current.close();
	}, []);
	let ye = ({ messageId: e, identifier: t, action: n, payload: r }) => {
		s((i) => {
			let a = structuredClone(i), o = a.find((t) => t.senderType === to.BOT && t.messageId === e);
			if (!o) return i;
			let s = o.messages.find((e) => e.identifier === t);
			if (!s || s.type !== "form-data" || s.content.type !== "createApp") return i;
			switch (n) {
				case "updateAppName":
					s.content.data.appName = r.appName, s.content.error.appName = _i(r.appName).message || null;
					break;
				case "updateProjectId":
					s.content.data.projectId = r.projectId, s.content.error.projectId = null;
					break;
				case "updateEnvironmentId":
					s.content.data.environmentId = r.environmentId, s.content.error.environmentId = null;
					break;
				case "updateGitRepoUrl":
					s.content.data.gitRepoUrl = r.gitRepoUrl, s.content.error.gitRepoUrl = Zr(r.gitRepoUrl).message || null;
					break;
				case "updateGitAccountId":
					s.content.data.gitAccountId = r.gitAccountId, s.content.error.gitAccountId = null;
					break;
				case "updateDockerRegistry":
					s.content.data.dockerRegistry = r.dockerRegistry, s.content.error.dockerRegistry = null;
					break;
				case "updateDockerRepository":
					s.content.data.dockerRepository = r.dockerRepository, s.content.error.dockerRepository = Zr(r.dockerRepository).message || null;
					break;
				case "validateForm":
					s.content.error = eo(r.validateFormData).errors;
					break;
				default: break;
			}
			return a;
		});
	}, be = k(() => ({
		selectedThread: i,
		chatMessageGroups: o,
		messageInput: c,
		handleMessageInputChange: de,
		isStreamingChat: u,
		handleInitiateStream: ue,
		handleThreadChange: he,
		onScroll: ae,
		onScrollToBottomClick: oe,
		animationControl: re,
		scrollContainerRef: E,
		handleUpdateScrollContainerRef: te,
		useCurrentContext: f,
		handleToggleUseCurrentContext: fe,
		handleCreateNewChat: ge,
		isFetchingInitialConversation: g !== null,
		initialConversationError: m,
		refetchInitialConversation: _e,
		handleUpdateTextAreaRef: ee,
		textAreaRef: T,
		handleCloseThread: pe,
		handleAbortMessage: se,
		handleCreateAppFormChange: ye,
		handleUpdateLastUserMessageRef: ie,
		handleFeedbackClick: ve,
		isAbortingMessage: y
	}), [
		i,
		o,
		c,
		u,
		re,
		f,
		g,
		m,
		y
	]);
	return /* @__PURE__ */ (0, J.jsx)(Eo.Provider, {
		value: be,
		children: e
	});
}, ko = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M5.5 10.5H2.5V2.5H10.5V5.5M13.5001 5.50008H5.50008V13.5001H13.5001V5.50008Z",
		stroke: "#596168",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ao = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ (0, J.jsxs)("g", {
			transform: "translate(2.667 2.667)",
			children: [/* @__PURE__ */ (0, J.jsx)("rect", {
				width: 26.667,
				height: 26.667,
				className: "fill-color",
				fill: "#F33E3E",
				rx: 13.333
			}), /* @__PURE__ */ (0, J.jsx)("path", {
				fill: "var(--N0)",
				fillRule: "nonzero",
				d: "M8.62 8.62c.52-.521 1.364-.521 1.885 0l2.828 2.827 2.829-2.828a1.334 1.334 0 0 1 1.777-.097l.108.097c.521.521.521 1.365 0 1.886l-2.828 2.828 2.828 2.829c.486.486.519 1.254.098 1.777l-.098.108c-.52.521-1.365.521-1.885 0l-2.83-2.828-2.827 2.828a1.334 1.334 0 0 1-1.777.098l-.109-.098a1.333 1.333 0 0 1 0-1.885l2.828-2.83-2.828-2.827a1.334 1.334 0 0 1-.097-1.777z"
			})]
		})
	})
}), jo = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ (0, J.jsx)("path", {
		d: "M17.8363 6.24761L4.08998 29.9964C3.87002 30.3764 3.75403 30.8077 3.75366 31.2467C3.7533 31.6858 3.86858 32.1172 4.08791 32.4976C4.30724 32.878 4.62288 33.1939 5.00307 33.4135C5.38326 33.6332 5.81459 33.7488 6.25367 33.7488H33.7462C34.1853 33.7488 34.6167 33.6332 34.9968 33.4135C35.377 33.1939 35.6927 32.878 35.912 32.4976C36.1313 32.1172 36.2466 31.6858 36.2463 31.2467C36.2459 30.8077 36.1299 30.3764 35.9099 29.9964L22.1636 6.24761C21.944 5.86821 21.6285 5.55322 21.2488 5.33425C20.869 5.11527 20.4383 5 20 5C19.5616 5 19.1309 5.11527 18.7511 5.33425C18.3714 5.55322 18.0559 5.86821 17.8363 6.24761V6.24761Z",
		fill: "#FFB549"
	}), /* @__PURE__ */ (0, J.jsx)("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.6667 16.2497C21.6667 15.3292 20.9205 14.583 20 14.583C19.0795 14.583 18.3333 15.3292 18.3333 16.2497V22.4997C18.3333 23.4201 19.0795 24.1663 20 24.1663C20.9205 24.1663 21.6667 23.4201 21.6667 22.4997V16.2497ZM21.875 28.1247C21.875 29.1602 21.0355 29.9997 20 29.9997C18.9645 29.9997 18.125 29.1602 18.125 28.1247C18.125 27.0891 18.9645 26.2497 20 26.2497C21.0355 26.2497 21.875 27.0891 21.875 28.1247Z",
		fill: "#3B444C"
	})]
}), Mo = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ (0, J.jsx)("g", {
			fill: "#06C",
			fillRule: "nonzero",
			children: /* @__PURE__ */ (0, J.jsx)("g", { children: /* @__PURE__ */ (0, J.jsx)("g", { children: /* @__PURE__ */ (0, J.jsx)("g", { children: /* @__PURE__ */ (0, J.jsx)("path", {
				d: "M11.625 1.35c.232-.133.518-.133.75 0l8.66 5c.232.134.375.382.375.65v10c0 .268-.143.516-.375.65l-8.66 5c-.232.133-.518.133-.75 0l-8.66-5c-.232-.134-.375-.382-.375-.65V7c0-.268.143-.516.375-.65zM12 2.866L4.089 7.433v9.133L12 21.133l7.91-4.566V7.432L12 2.866zm-.375 3.484c.232-.133.518-.133.75 0l4.33 2.5c.232.134.375.382.375.65v5c0 .268-.143.516-.375.65l-4.33 2.5c-.232.133-.518.133-.75 0l-4.33-2.5c-.232-.134-.375-.382-.375-.65v-5c0-.268.143-.516.375-.65zM12 7.865L8.419 9.933v4.133L12 16.134l3.58-2.067V9.932L12 7.865z",
				transform: "translate(-863 -388) translate(439 248) translate(408 116) translate(16 24)"
			}) }) }) })
		})
	})
}), No = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ (0, J.jsxs)("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ (0, J.jsx)("path", { d: "M0 0h24v24H0z" }), /* @__PURE__ */ (0, J.jsx)("path", {
			fill: "#999",
			fillRule: "nonzero",
			d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
		})]
	})
}), Po = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M7.34808 14.4195C6.4642 17.0712 2.92867 17.0712 2.92867 17.0712C2.92867 17.0712 2.92867 13.5356 5.58032 12.6517M9.99973 13.5356L15.303 8.23232C17.3112 6.22418 17.2916 4.21605 17.1638 3.35963C17.1442 3.22777 17.0827 3.10571 16.9884 3.01144C16.8941 2.91717 16.7721 2.85567 16.6402 2.83602C15.7838 2.70824 13.7756 2.68865 11.7675 4.69679L6.4642 10.0001M9.99973 13.5356L6.4642 10.0001M9.99973 13.5356L10.6546 16.8099C10.6768 16.9208 10.7287 17.0236 10.8047 17.1074C10.8807 17.1912 10.9781 17.2527 11.0863 17.2855C11.1946 17.3183 11.3097 17.3211 11.4195 17.2936C11.5292 17.266 11.6294 17.2093 11.7094 17.1293L14.2361 14.6026C14.2941 14.5445 14.3402 14.4756 14.3716 14.3998C14.403 14.324 14.4192 14.2427 14.4192 14.1606V9.1162M6.4642 10.0001L3.18993 9.34523C3.079 9.32305 2.97617 9.27117 2.89241 9.19513C2.80865 9.1191 2.7471 9.02176 2.71432 8.91348C2.68154 8.80521 2.67875 8.69008 2.70627 8.58035C2.73379 8.47062 2.79057 8.37042 2.87056 8.29043L5.39726 5.76373C5.4553 5.70569 5.52419 5.65965 5.60002 5.62824C5.67585 5.59684 5.75712 5.58067 5.8392 5.58067H10.8836",
		stroke: "#596168",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fo = je(null), Io = ({ children: e, renderers: t }) => {
	let n = k(() => t, []);
	return /* @__PURE__ */ (0, J.jsx)(Fo.Provider, {
		value: n,
		children: e
	});
}, Lo = () => {
	let e = Ne(Fo);
	if (!e) throw Error("SoftwareDistributionHubRenderContext cannot be used outside SoftwareDistributionHub scope");
	return e;
}, Ro = {
	SELECT_LABEL: {
		LABEL: "Select image by label",
		PLACEHOLDER: "Select label"
	},
	UNSAVED_CHANGES_INDICATOR: "Unsaved changes",
	IMAGE_CTA: "Save",
	SEARCH_PLACEHOLDER: "Search by image tag",
	RIGHT_PANEL_ENVIRONMENTS_HEADING: "Environments in this workflow",
	NO_WORKFLOW_EMPTY_STATE: {
		title: "No workflow available",
		subTitle: "Application is not fully configured. Complete the configuration"
	},
	NO_ARTIFACT_FROM_SEARCH: {
		title: "No artifacts found",
		subTitle: "We could not find any image matching the criteria"
	},
	NO_ARTIFACT_FOUND: {
		title: "No artifacts found",
		subTitle: "We could not find any matching image"
	},
	UNABLE_TO_FETCH_EVENT_NAME: "Unable to fetch event name",
	SUCCESS_SAVE_MESSAGE: "Deployment source updated successfully",
	CLEAR_ARTIFACT_FILTERS: "Clear filters",
	SEARCH_SOURCE: { SEARCH_IMAGE_TAG: "Search image tag" },
	SELECT_ARTIFACT_CTA: "Select"
}, zo = (e, t) => `No previous deployment of '${e}' found in '${t}'`, Bo = (e, t) => `Images of '${e}' deployed from releases in '${t}' will be available here`, Vo = (e) => `Show only images deployed from '${e}'`, Ho = (e) => `Select image for release '${e}'`, Uo = (e) => e ? `Select a workflow for '${e}' to view available images` : "Select an application to view its workflows", Wo = (e) => `${e} Applications`, Go = (e) => {
	switch (e) {
		case nt.CI_JOB: return "Job Pipeline";
		case nt.WEBHOOK: return "External Service";
		case nt.LINKED_CI: return "Linked Build Pipeline";
		case nt.LINKED_CD: return "Sync with environment";
		default: return "-";
	}
}, Ko = (e, t) => {
	switch (e) {
		case nt.WEBHOOK: return "Webhook";
		default: return t;
	}
}, qo = (e, t) => e ? "Request in progress" : t ? null : "No changes to save", Jo = (e) => `No deployment pipelines exist for '${e}'`, Yo = (e) => `Tag '${e}' not found`, Xo = "deployment-source-select", Zo = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ (0, J.jsx)("g", {
			fill: "#06C",
			children: /* @__PURE__ */ (0, J.jsx)("g", { children: /* @__PURE__ */ (0, J.jsx)("g", { children: /* @__PURE__ */ (0, J.jsx)("g", { children: /* @__PURE__ */ (0, J.jsx)("path", {
				d: "M10 1.667c4.6 0 8.333 3.733 8.333 8.333S14.6 18.333 10 18.333 1.667 14.6 1.667 10 5.4 1.667 10 1.667zm0 1.666C6.32 3.333 3.333 6.32 3.333 10c0 3.68 2.987 6.667 6.667 6.667 3.68 0 6.667-2.987 6.667-6.667 0-3.68-2.987-6.667-6.667-6.667zm0 5.834c.46 0 .833.373.833.833v3.333c0 .46-.373.834-.833.834-.46 0-.833-.373-.833-.834V10c0-.46.373-.833.833-.833zm0-3.334c.46 0 .833.373.833.834 0 .46-.373.833-.833.833-.46 0-.833-.373-.833-.833 0-.46.373-.834.833-.834z",
				transform: "translate(-315.000000, -313.000000) translate(303.000000, 256.000000) translate(4.000000, 49.000000) translate(8.000000, 8.000000)"
			}) }) }) })
		})
	})
}), Qo = {
	DEFAULT_PLACEHOLDER: "Search by project or application name",
	GROUP_HEADING_SUFFIX: "project"
}, $o = {
	getTitle: (e, t) => t === L.releaseTrack ? `${e} / Manage Applications` : `Manage Applications in '${e}'`,
	SELECT_PLACEHOLDER: "Search and add applications",
	NO_RELEASE_ORDER_EMPTY_STATE: {
		TITLE: "Add Applications",
		SUB_TITLE: "Add applications now to kickstart your deployment."
	},
	NO_APPLICATIONS_IN_RELEASE_ORDER: {
		TITLE_FOR_RELEASE: "No applications in this stage",
		TITLE_FOR_TRACK: "Drag and drop the applications",
		SUB_TITLE_FOR_TRACK: "you wish to release after the ones listed above."
	},
	ADD_RELEASE_STAGE_BUTTON: "Add Release Stage",
	RESET_BUTTON: "Reset",
	SUBMIT_CTA_TEXT: "Save changes",
	UNSAVED_CHANGES: "Unsaved changes",
	DELETE_DIALOG: {
		DESCRIPTION: "Removing the application from the release will remove all requirements added against the application.",
		CONFIRMATION_TEXT: "Are you sure?",
		PRIMARY_TEXT: "Remove"
	},
	REQUEST_IN_PROGRESS: "Request in progress",
	NO_CHANGES: "No changes to save"
}, es = (e, t, n) => t === L.release ? n ? "Manage application release order" : "Applications in release" : `Manage release order for ${e} application(s)`, ts = (e, t) => `Remove '${e}' from '${t}'`, ns = (e, t) => e ? $o.REQUEST_IN_PROGRESS : t ? null : $o.NO_CHANGES, rs = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M1.33301 2V14M9.73301 11.5333H12.1997M12.1997 11.5333H14.6663M12.1997 11.5333V9.06667M12.1997 11.5333V14M1.33301 2.75H5.46634V3.95H9.06634V8.75H5.46634V7.55H1.33301V2.75Z",
		stroke: "#0066CC",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), is = je({}), as = ({ children: e, parentResourceKind: t, resourceId: n, resourceName: r, trackId: i, releaseOrderingFromApi: a, releaseOrdering: o, setReleaseOrdering: s, releaseOrderingForTrack: c, isReleaseOrderActive: l }) => {
	let [u, d] = A(null), [f, p] = A(l), m = t === L.releaseTrack, { selectedApplicationsMap: h, selectedApplicationsCount: g, trackApplicationsRequiredMap: _ } = k(() => {
		let e = Ml(o);
		return {
			selectedApplicationsMap: e,
			selectedApplicationsCount: Object.keys(e).length,
			trackApplicationsRequiredMap: Nl(c)
		};
	}, [o]);
	O(() => {
		p(l);
	}, [l]);
	let v = (e) => {
		if (e && h[e].selectedImage) {
			d(h[e]);
			return;
		}
		let { releaseOrderIndex: t, applicationIndex: n } = h[e] || u;
		s(Il({
			releaseOrdering: o,
			targetReleaseOrderIndex: t,
			targetApplicationIndex: n,
			clearReleaseOrdersIfEmpty: !0
		})), d(null);
	}, y = ({ applicationName: e, applicationId: t, isRequired: n }) => {
		!e || !t || s(Ll({
			releaseOrdering: o,
			applicationName: e,
			applicationId: t,
			isRequired: m || n
		}));
	}, b = (e) => {
		let n = e.reduce((e, t) => (e[t.label] = !0, e), {}), r = Object.keys(h).find((e) => !n[e] && (m || e in _));
		if (r) {
			v(r);
			return;
		}
		if (t === L.releaseTrack) {
			let t = e.find((e) => !h[e.label]), n = t?.label, r = t?.value ? Number(t?.value) : 0, { isRequired: i } = t;
			y({
				applicationName: n,
				applicationId: r,
				isRequired: i
			});
			return;
		}
		let i = c.map(({ applications: e, ...t }) => ({
			...t,
			applications: e.filter((e) => n[e.name])
		}));
		s(f ? i : [{
			...i[0],
			applications: i.flatMap(({ applications: e }) => e).filter((e) => !!n[e.name])
		}]);
	}, x = () => {
		s(Rl(o));
	}, S = (e, t, n) => {
		let { releaseOrderIndex: r, applicationIndex: i, selectedImage: a, registryType: c, applicationId: l, artifactId: u, artifactSourceAppWorkflowId: d, sourceReleaseConfiguration: f, isRequired: p, isDeleted: m } = h[e];
		s(Vl(Il({
			releaseOrdering: o,
			targetReleaseOrderIndex: r,
			targetApplicationIndex: i
		}), t, n, {
			name: e,
			selectedImage: a,
			registryType: c,
			appId: l,
			artifactId: u,
			artifactSourceAppWorkflowId: d,
			sourceReleaseConfiguration: f,
			isRequired: p,
			isDeleted: m
		}));
	}, C = (e) => {
		s(Bl(o, e));
	}, w = () => {
		d(null);
	}, T = (e) => {
		let { releaseOrderIndex: t, applicationIndex: n, selectedImage: r, registryType: i, applicationId: a, artifactId: c, artifactSourceAppWorkflowId: l, sourceReleaseConfiguration: u, isRequired: d, isDeleted: f } = h[e];
		s(Hl(o, t, n, {
			name: e,
			selectedImage: r,
			registryType: i,
			appId: a,
			artifactId: c,
			artifactSourceAppWorkflowId: l,
			sourceReleaseConfiguration: u,
			isRequired: !d,
			isDeleted: f
		}));
	}, ee = () => {
		s(c);
	}, E = () => {
		p((e) => e ? (s([{
			...o[0],
			applications: o.flatMap(({ applications: e }) => e).filter((e) => !!h[e.name])
		}]), !1) : (s(c.map(({ applications: e, ...t }) => ({
			...t,
			applications: e.filter((e) => !!h[e.name])
		}))), !0));
	}, te = k(() => ({
		parentResourceKind: t,
		resourceId: n,
		resourceName: r,
		trackId: i,
		releaseOrderingFromApi: a,
		releaseOrdering: o,
		releaseOrderingForTrack: c,
		selectedApplicationsMap: h,
		trackApplicationsRequiredMap: _,
		selectedApplicationsCount: g,
		isReleaseOrderActive: f,
		deleteApplicationData: u,
		isParentResourceReleaseTrack: m,
		isReleaseOrderingDifferentFromTrack: !m && Pl(o, c, { shouldCheckForSelectedImage: !1 }),
		setReleaseOrdering: s,
		toggleIsReleaseOrderActive: E,
		handleDeleteApplication: v,
		handleApplicationSelection: b,
		handleAddNewReleaseOrder: x,
		handleMoveApplicationOrder: S,
		handleDeleteReleaseOrder: C,
		handleCloseDeleteModal: w,
		toggleApplicationRequired: T,
		resetReleaseOrderingToTrackOrdering: ee
	}), [
		t,
		n,
		r,
		i,
		a,
		o,
		c,
		h,
		_,
		g,
		f,
		u
	]);
	return /* @__PURE__ */ (0, J.jsx)(is.Provider, {
		value: te,
		children: e
	});
}, os = () => {
	let e = Ne(is);
	if (!e) throw Error("Wrap with ManageReleaseOrderProvider");
	return e;
}, ss = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M10.3335 9.33325C10.8858 9.33325 11.3335 8.88554 11.3335 8.33325C11.3335 7.78097 10.8858 7.33325 10.3335 7.33325C9.78121 7.33325 9.3335 7.78097 9.3335 8.33325C9.3335 8.88554 9.78121 9.33325 10.3335 9.33325Z",
			fill: "#596168"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M5.66675 9.33325C6.21903 9.33325 6.66675 8.88554 6.66675 8.33325C6.66675 7.78097 6.21903 7.33325 5.66675 7.33325C5.11446 7.33325 4.66675 7.78097 4.66675 8.33325C4.66675 8.88554 5.11446 9.33325 5.66675 9.33325Z",
			fill: "#596168"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M10.3335 5.33325C10.8858 5.33325 11.3335 4.88554 11.3335 4.33325C11.3335 3.78097 10.8858 3.33325 10.3335 3.33325C9.78121 3.33325 9.3335 3.78097 9.3335 4.33325C9.3335 4.88554 9.78121 5.33325 10.3335 5.33325Z",
			fill: "#596168"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M5.66675 5.33325C6.21903 5.33325 6.66675 4.88554 6.66675 4.33325C6.66675 3.78097 6.21903 3.33325 5.66675 3.33325C5.11446 3.33325 4.66675 3.78097 4.66675 4.33325C4.66675 4.88554 5.11446 5.33325 5.66675 5.33325Z",
			fill: "#596168"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M10.3335 13.3333C10.8858 13.3333 11.3335 12.8855 11.3335 12.3333C11.3335 11.781 10.8858 11.3333 10.3335 11.3333C9.78121 11.3333 9.3335 11.781 9.3335 12.3333C9.3335 12.8855 9.78121 13.3333 10.3335 13.3333Z",
			fill: "#596168"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M5.66675 13.3333C6.21903 13.3333 6.66675 12.8855 6.66675 12.3333C6.66675 11.781 6.21903 11.3333 5.66675 11.3333C5.11446 11.3333 4.66675 11.781 4.66675 12.3333C4.66675 12.8855 5.11446 13.3333 5.66675 13.3333Z",
			fill: "#596168"
		})
	]
}), cs = ({ application: { name: e, isRequired: t, isDeleted: n }, releaseOrderIndex: r, applicationIndex: i, draggingApplicationName: a, handleClearDraggingApplicationName: o, handleSetDraggingApplicationName: s }) => {
	let { handleMoveApplicationOrder: c, handleDeleteApplication: l, toggleApplicationRequired: u, parentResourceKind: d, trackApplicationsRequiredMap: f } = os(), p = d === L.releaseTrack, m = p ? t : f[e] ?? !1, h = !p && m, g = () => {
		s(e);
	}, _ = () => {
		c(a, r, i);
	}, v = () => {
		l(e);
	}, y = () => {
		u(e);
	}, b = (t) => /* @__PURE__ */ (0, J.jsx)(D, {
		className: "default-tt",
		arrow: !1,
		content: `'${e}' must be part of the release`,
		children: t
	});
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: `p-8 flexbox dc__gap-8 dc__align-items-center dc__content-space br-4 ${a === e ? "bcb-1 eb-2" : "bg__primary dc__hover-n50 dc__no-border"}`,
		...p && {
			draggable: a === e,
			onDragOver: qr,
			onDragEnter: _,
			onDragEnd: o,
			onDrop: o
		},
		children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flex left center dc__gap-8",
			children: [p ? /* @__PURE__ */ (0, J.jsx)("button", {
				type: "button",
				className: "p-0 dc__no-background dc__no-border dc__outline-none-imp flex dc__grabbable dc__no-shrink",
				"data-testid": `drag-${e}`,
				"aria-label": `drag ${e}`,
				onMouseDown: g,
				onMouseUp: o,
				children: /* @__PURE__ */ (0, J.jsx)(ss, { className: "icon-dim-16 dc__no-shrink" })
			}) : /* @__PURE__ */ (0, J.jsx)(me, { className: "dc__no-shrink icon-dim-24" }), /* @__PURE__ */ (0, J.jsxs)("span", {
				className: `flex left dc__gap-8 flex-grow-1 fs-13 fw-4 lh-20 ${n ? "cr-5" : "cn-9"}`,
				children: [/* @__PURE__ */ (0, J.jsxs)("span", {
					className: "dc__truncate",
					children: [
						e,
						" ",
						m && /* @__PURE__ */ (0, J.jsx)(Al, {})
					]
				}), n && /* @__PURE__ */ (0, J.jsx)("span", {
					className: "dc__no-shrink",
					children: "Application not found"
				})]
			})]
		}), /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flex left center dc__gap-8 dc__no-shrink",
			children: [p && /* @__PURE__ */ (0, J.jsx)(bt, {
				name: `app-${e}-required`,
				ariaLabel: `Toggle ${e} required in release order`,
				isChecked: m,
				onChange: y,
				shape: "square",
				variant: "theme",
				iconName: "ic-asterisk",
				iconColor: "R500"
			}), /* @__PURE__ */ (0, J.jsx)(lt, {
				condition: h,
				wrap: b,
				children: /* @__PURE__ */ (0, J.jsx)("div", { children: /* @__PURE__ */ (0, J.jsx)("button", {
					className: `p-0 dc__no-background dc__no-border dc__outline-none-imp flex icon-dim-16 ${h ? "dc__disabled" : "icon-delete__hover"}`,
					type: "button",
					onClick: v,
					"aria-label": `remove-${e}-from-release-order`,
					disabled: h,
					children: /* @__PURE__ */ (0, J.jsx)(T, { className: "icon-dim-16 dc__no-shrink" })
				}) })
			})]
		})]
	});
}, ls = ({ releaseOrder: e, isLastReleaseOrder: t, draggingApplicationName: n, handleClearDraggingApplicationName: r, handleSetDraggingApplicationName: i }) => {
	let { handleDeleteReleaseOrder: a, handleMoveApplicationOrder: o, isParentResourceReleaseTrack: s } = os(), { id: c, title: l, icon: u, applications: d } = e, f = () => {
		a(c);
	}, p = () => {
		o(n, c, 0);
	}, m = () => d.length === 0 ? /* @__PURE__ */ (0, J.jsx)("div", {
		className: "dc__border-dashed pt-20 pb-20 pl-20 pr-20 flex bg__secondary br-4",
		...s && {
			onDragOver: qr,
			onDrop: r,
			onDragEnter: p
		},
		children: /* @__PURE__ */ (0, J.jsx)("div", {
			className: "w-236 cn-7 fs-12 dc__align-center",
			children: s ? /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsxs)("span", {
				className: "fw-6 lh-18",
				children: [$o.NO_APPLICATIONS_IN_RELEASE_ORDER.TITLE_FOR_TRACK, "\xA0"]
			}), /* @__PURE__ */ (0, J.jsx)("span", {
				className: "fw-4 lh-18",
				children: $o.NO_APPLICATIONS_IN_RELEASE_ORDER.SUB_TITLE_FOR_TRACK
			})] }) : /* @__PURE__ */ (0, J.jsx)("span", {
				className: "fw-6 lh-18",
				children: $o.NO_APPLICATIONS_IN_RELEASE_ORDER.TITLE_FOR_RELEASE
			})
		})
	}) : /* @__PURE__ */ (0, J.jsx)("div", {
		className: "flexbox-col p-4 br-8 bg__primary dc__info-card dc__info-card--no-hover",
		children: d.map((t, a) => /* @__PURE__ */ (0, J.jsx)(cs, {
			application: t,
			handleClearDraggingApplicationName: r,
			handleSetDraggingApplicationName: i,
			applicationIndex: a,
			releaseOrderIndex: e.id,
			draggingApplicationName: n
		}, t.name))
	}), h = c === 0;
	return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col dc__gap-4",
		children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: `pl-12 pr-12 pt-4 pb-4 flexbox dc__content-space ${h ? "" : "dc__hover-n50 dc__visible-hover dc__visible-hover--parent"}`,
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flex dc__gap-8",
				children: [u, /* @__PURE__ */ (0, J.jsx)("h3", {
					className: "m-0 dc__ellipsis-right cn-7 fs-12 fw-6 lh-20 dc__uppercase",
					children: l
				})]
			}), !h && s && /* @__PURE__ */ (0, J.jsx)("button", {
				type: "button",
				className: "p-0 dc__no-background dc__no-border dc__outline-none-imp dc__visible-hover--child dc__no-shrink",
				"data-testid": `remove-release-stage-${c}-button`,
				"aria-label": "remove-release-stage-button",
				onClick: f,
				children: "—"
			})]
		}), m()]
	}), (s || !t) && /* @__PURE__ */ (0, J.jsx)("div", { className: "w-24 h-16 dc__border-dashed--n3-right" })] });
}, us = () => {
	let { releaseOrdering: e, selectedApplicationsCount: t, handleAddNewReleaseOrder: n, parentResourceKind: r, resetReleaseOrderingToTrackOrdering: i, isReleaseOrderActive: a, toggleIsReleaseOrderActive: o, isReleaseOrderingDifferentFromTrack: s, isParentResourceReleaseTrack: c, releaseOrderingForTrack: l } = os(), u = l.length > 1, [d, p] = A(null), m = () => {
		p(null);
	}, h = (e) => {
		p(e);
	};
	if (!e.length) return /* @__PURE__ */ (0, J.jsx)("div", {
		className: "pt-16 flexbox-col h-100",
		children: /* @__PURE__ */ (0, J.jsx)(F, {
			title: $o.NO_RELEASE_ORDER_EMPTY_STATE.TITLE,
			subTitle: $o.NO_RELEASE_ORDER_EMPTY_STATE.SUB_TITLE,
			image: Li,
			classname: "dc__border-dashed--n3 br-4",
			imageClassName: "dc__blend-luminosity dc__opacity-0_2"
		})
	});
	let g = () => c && /* @__PURE__ */ (0, J.jsxs)("button", {
		className: "dc__tab-focus flex dc__gap-4 px-8 py-4 dc__no-background dc__no-border dc__outline-none-imp dc__w-fit-content dc__hover-n50",
		type: "button",
		onClick: n,
		"data-testid": "add-release-stage-button",
		children: [/* @__PURE__ */ (0, J.jsx)(rs, { className: "icon-dim-16 dc__no-shrink" }), /* @__PURE__ */ (0, J.jsx)("span", {
			className: "cb-5 fs-13 fw-6 lh-20 dc__ellipsis-right",
			children: $o.ADD_RELEASE_STAGE_BUTTON
		})]
	});
	return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [
		/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox dc__content-space py-16 dc__gap-4",
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flex dc__gap-4",
				children: [/* @__PURE__ */ (0, J.jsx)("h2", {
					className: "m-0 cn-9 fs-13 fw-6 lh-20 dc__truncate",
					children: es(t, r, a)
				}), /* @__PURE__ */ (0, J.jsx)(Oe, { className: "icon-dim-16 dc__no-shrink" })]
			}), /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flex center dc__gap-8 dc__no-shrink",
				children: [g(), !c && /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [u && /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flex center dc__gap-4",
					children: [/* @__PURE__ */ (0, J.jsx)("span", {
						className: "fs-13 fw-6 lh-20 cn-9",
						children: "Release order"
					}), /* @__PURE__ */ (0, J.jsx)(bt, {
						name: "toggle-enable-release-ordering",
						ariaLabel: "Enable release ordering toggle",
						isChecked: a,
						onChange: o,
						size: P.small
					})]
				}), a && s && /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [u && /* @__PURE__ */ (0, J.jsx)("div", { className: "dc__divider h-20 bcn-1" }), /* @__PURE__ */ (0, J.jsx)(D, {
					content: "Reset to ordering from release track",
					className: "default-tt",
					arrow: !1,
					children: /* @__PURE__ */ (0, J.jsxs)("button", {
						className: "dc__tab-focus flex dc__gap-4 py-2 dc__no-background dc__no-border dc__outline-none-imp dc__w-fit-content dc__hover-n50",
						type: "button",
						onClick: i,
						"data-testid": "reset-order-to-track",
						children: [/* @__PURE__ */ (0, J.jsx)(f, { className: "icon-dim-16 dc__no-shrink scb-5" }), /* @__PURE__ */ (0, J.jsx)("span", {
							className: "cb-5 fs-13 fw-6 lh-20 dc__ellipsis-right",
							children: $o.RESET_BUTTON
						})]
					})
				})] })] })]
			})]
		}),
		/* @__PURE__ */ (0, J.jsx)("div", {
			className: "pt-8 flexbox-col",
			children: e.map((t, n) => /* @__PURE__ */ (0, J.jsx)(ls, {
				releaseOrder: t,
				isLastReleaseOrder: n === e.length - 1,
				draggingApplicationName: d,
				handleSetDraggingApplicationName: h,
				handleClearDraggingApplicationName: m
			}))
		}),
		g()
	] });
}, ds = async ({ resourceKind: e, resourceId: t }) => {
	try {
		let { result: n } = await H(Tr({
			baseUrl: _.RESOURCE_DEPENDENCIES_OPTIONS,
			kind: e,
			version: R.alpha1,
			...t && { queryParams: { id: t } }
		}));
		return Wl(n?.[0]?.projectWiseAppList);
	} catch (e) {
		return W(e), [];
	}
}, fs = () => {
	let { selectedApplicationsMap: e, handleApplicationSelection: t, resourceId: n, isParentResourceReleaseTrack: r, parentResourceKind: i } = os(), [a, o] = K(() => ds(i === L.releaseTrack ? { resourceKind: i } : {
		resourceKind: i,
		resourceId: n
	})), s = Gl(e, o);
	return /* @__PURE__ */ (0, J.jsx)(jn, {
		inputId: "release-order-app-selector",
		isMulti: !0,
		options: o,
		value: s,
		onChange: t,
		isSearchable: !0,
		isClearable: !1,
		isLoading: a,
		placeholder: $o.SELECT_PLACEHOLDER,
		formatOptionLabel: Kl,
		isOptionDisabled: r ? void 0 : (t) => e[t.label] && t.isRequired,
		menuListFooterConfig: r ? null : {
			type: "text",
			value: /* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("p", {
				className: "m-0",
				children: "Only applications added to the release track can be included in the release."
			}), /* @__PURE__ */ (0, J.jsxs)("p", {
				className: "m-0",
				children: [
					"Applications marked with ",
					/* @__PURE__ */ (0, J.jsx)(Al, {}),
					" must be part of the release."
				]
			})] })
		},
		icon: /* @__PURE__ */ (0, J.jsx)(Se, {}),
		controlShouldRenderValue: !1,
		showSelectedOptionsCount: !0,
		size: P.large
	});
}, ps = () => {
	let { deleteApplicationData: e, handleCloseDeleteModal: t, handleDeleteApplication: n } = os();
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col h-100 dc__overflow-auto pt-16 pb-16 pl-20 pr-20",
		children: [
			/* @__PURE__ */ (0, J.jsx)(fs, {}),
			/* @__PURE__ */ (0, J.jsx)(us, {}),
			!!e?.applicationId && /* @__PURE__ */ (0, J.jsx)(ut, {
				variant: dt.delete,
				title: ts(e?.applicationName, e?.releaseOrderName),
				subtitle: $o.DELETE_DIALOG.DESCRIPTION,
				buttonConfig: {
					secondaryButtonConfig: {
						onClick: t,
						text: "Cancel"
					},
					primaryButtonConfig: {
						onClick: () => n(),
						text: $o.DELETE_DIALOG.PRIMARY_TEXT
					}
				},
				handleClose: t,
				children: /* @__PURE__ */ (0, J.jsx)("p", {
					className: "fs-13 cn-7 lh-20 m-0",
					children: $o.DELETE_DIALOG.CONFIRMATION_TEXT
				})
			})
		]
	});
}, ms = ({ handleSuccess: e, handleCloseManageReleaseModal: t }) => {
	let [n, r] = A(!1), { releaseOrdering: i, releaseOrderingFromApi: a, resourceId: o, parentResourceKind: s, isReleaseOrderActive: c } = os(), l = k(() => Pl(i, a), [JSON.stringify(i), JSON.stringify(a)]), u = async (n) => {
		qr(n);
		try {
			r(!0), await ru(o, s, i, c), await e(), B.showToast({
				variant: V.success,
				description: "Saved successfully"
			}), t();
		} catch (e) {
			W(e), r(!1);
		}
	}, d = ns(n, l);
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: `flexbox pt-16 pb-16 pl-20 pr-20 dc__align-items-center dc__no-shrink dc__border-top ${l ? "dc__content-space" : "dc__content-end"}`,
		children: [l && /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox dc__align-item-center dc__gap-6",
			children: [/* @__PURE__ */ (0, J.jsx)(jo, { className: "icon-dim-20 dc__no-shrink" }), /* @__PURE__ */ (0, J.jsx)("span", {
				className: "cn-9 fs-13 fw-4 lh-20",
				children: $o.UNSAVED_CHANGES
			})]
		}), /* @__PURE__ */ (0, J.jsx)(lt, {
			condition: !!d,
			wrap: (e) => /* @__PURE__ */ (0, J.jsx)(D, {
				content: d,
				placement: "top",
				className: "default-tt",
				arrow: !1,
				children: /* @__PURE__ */ (0, J.jsx)("span", { children: e })
			}),
			children: /* @__PURE__ */ (0, J.jsx)(et, {
				rootClassName: "cta flex h-36",
				isLoading: n,
				onClick: u,
				disabled: !!d,
				children: $o.SUBMIT_CTA_TEXT
			})
		})]
	});
}, hs = ({ handleCloseManageReleaseModal: e, handleSuccess: t, parentResourceKind: n, resourceName: r, resourceId: i, trackId: a }) => {
	let o = n === L.releaseTrack, [s, c] = A([]), [l, u, d, f] = K(() => Promise.all([nu(i, n), o ? null : nu(a, L.releaseTrack)])), p = u?.[0]?.releaseOrdering ?? [], m = u?.[0]?.isReleaseOrderActive ?? !0, h = u?.[1]?.releaseOrdering ?? [];
	return O(() => {
		u?.[0] && c(p);
	}, [u]), /* @__PURE__ */ (0, J.jsx)(Qn, {
		className: "",
		onEscape: e,
		close: e,
		children: /* @__PURE__ */ (0, J.jsx)(as, {
			parentResourceKind: n,
			resourceId: i,
			resourceName: r,
			trackId: a,
			releaseOrderingFromApi: p,
			releaseOrdering: s,
			setReleaseOrdering: c,
			releaseOrderingForTrack: h,
			isReleaseOrderActive: m,
			children: /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col dc__content-space w-600",
				onClick: ei,
				children: [/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col h-100 dc__content-space bg__primary dc__overflow-auto",
					children: [/* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox dc__content-space dc__align-items-center dc__border-bottom pb-12 pt-12 pl-20 pr-20",
						children: [/* @__PURE__ */ (0, J.jsx)("h2", {
							className: "m-0 cn-9 fs-16 fw-6 lh-24 dc__truncate",
							children: $o.getTitle(r, n)
						}), /* @__PURE__ */ (0, J.jsx)("button", {
							className: "flex dc__transparent dc__outline-none-imp dc__no-border p-0 dc__tab-focus",
							type: "button",
							onClick: e,
							"aria-label": "close-release-order-modal",
							children: /* @__PURE__ */ (0, J.jsx)(Ee, { className: "icon-dim-24 dc__no-shrink fcn-6" })
						})]
					}), /* @__PURE__ */ (0, J.jsxs)(Ie, {
						isLoading: l,
						progressingProps: { pageLoader: !0 },
						error: d,
						errorScreenManagerProps: {
							code: d?.code,
							reload: f
						},
						children: [o && /* @__PURE__ */ (0, J.jsx)(nn, {
							description: `Only applications defined here can be used in releases of '${r}'.`,
							borderConfig: {
								top: !1,
								left: !1,
								right: !1
							},
							borderRadiusConfig: {
								top: !1,
								left: !1,
								right: !1,
								bottom: !1
							}
						}), /* @__PURE__ */ (0, J.jsx)(ps, {})]
					})]
				}), !l && !d && /* @__PURE__ */ (0, J.jsx)(ms, {
					handleSuccess: t,
					handleCloseManageReleaseModal: e
				})]
			})
		})
	});
}, gs = je(null), _s = ({ value: e, children: t }) => /* @__PURE__ */ (0, J.jsx)(gs.Provider, {
	value: e,
	children: t
}), vs = () => {
	let e = Ne(gs);
	if (!e) throw Error("Wrap with ReleaseTrackDetailProvider");
	return e;
}, ys = /* @__PURE__ */ function(e) {
	return e.VulnerabilityFound = "10001", e.ApprovalNodeFail = "10002", e.FilteringConditionFail = "10003", e.DeploymentWindowFail = "10004", e.PreCDDoesNotExists = "10005", e.PostCDDoesNotExists = "10006", e.ArtifactNotAvailable = "10007", e.MandatoryPluginNotAdded = "10009", e.MandatoryTagNotAdded = "10010", e.ExceptionUser = "10013", e.CannotTrigger = "CannotTrigger", e.NotAuthorized = "403", e.CanTriggerInDeploymentWindow = "10008", e.CanTrigger = "200", e;
}({}), bs = (e = 0) => `${e} ${e === 1 ? "Installation" : "Installations"}`, xs = (e) => {
	let { name: t = "", overview: { installationId: n = "" }, upstreamDepCount: r = 0, subscriptionConfig: i } = e || {};
	return {
		name: t,
		installationId: n,
		environmentCount: r,
		releaseChannelId: i?.identifier ?? null
	};
}, Ss = (e) => {
	let { metadata: t, id: n = 0 } = e || {}, { envName: r, namespace: i, default: a, clusterName: o, isVirtualEnvironment: s = !1 } = t || {};
	return {
		id: n,
		name: r,
		namespace: i,
		environmentType: a ? Ft.production : Ft.nonProduction,
		cluster: o,
		isVirtual: s
	};
}, Cs = (e, t) => {
	let { name: n = "", installationId: r = "", dependencies: i = [], releaseChannelId: a = null, releaseChannelName: o = null } = e || {}, { deploymentConfig: s } = t ?? {};
	return {
		name: n,
		installationId: r,
		releaseChannelId: a,
		releaseChannelName: o,
		environments: i.map(Ss),
		deploymentConfig: s ? {
			dockerRegistryId: s.dockerRegistryId ?? null,
			pushToRemote: s.pushToRemote ?? !1,
			repository: s.repository ?? "",
			tokenId: s.tokenId ?? null,
			token: s.token ?? null,
			tokenName: s.tokenName ?? "",
			hostName: s.hostName ?? "",
			dockerRegistryType: s.dockerRegistryType ?? wn.DOCKER
		} : null
	};
}, ws = (e) => {
	let { name: t = "", overview: n, childObjects: r = [], childDepCount: i = 0, catalogSchemaResourceId: a } = e || {}, { tenantId: o = "", icon: s = "", createdBy: c, createdOn: l = "", description: u = "", readme: d } = n || {}, { name: f = "" } = c || {}, { value: p = "" } = d || {};
	return {
		name: t,
		tenantId: o,
		image: s,
		createdBy: f,
		createdOn: l && l !== nr ? (0, po.default)(l).format(mt.TWELVE_HOURS_FORMAT) : "",
		description: u,
		note: p,
		installations: r.map(xs),
		installationsCount: i ?? 0,
		catalogSchemaResourceId: a
	};
}, Ts = ({ releaseChannelId: e }) => e.length ? e.map((e) => `${L.releaseChannel}|identifier|${e}`) : [], Es = (e) => e?.name && e?.installationConfig?.name ? `${e.name} (${e.installationConfig.name})` : "-", Ds = (e) => e.tenantId && e.installationConfig.installationId ? `${e.tenantId}/${e.installationConfig.installationId}` : "", Os = (e) => {
	let t = {
		isReleaseTriggered: e?.isReleaseTriggered ?? !1,
		tenantId: e?.tenantId ?? "",
		name: e?.tenantName ?? "",
		image: e?.tenantIcon ?? "",
		installationConfig: {
			installationId: e?.installationId ?? "",
			name: e?.installationName ?? "",
			releaseChannelId: e?.releaseChannelId ?? null,
			releaseChannelName: e?.releaseChannelName ?? null,
			installationIdentifier: e?.installationIdentifier ?? ""
		}
	};
	return {
		...t,
		displayText: Es(t),
		identifier: Ds(t)
	};
}, ks = (e) => Os({
	installationId: `installation-id-${e}`,
	installationName: `installation-${e}`,
	tenantIcon: "",
	tenantId: `tenant-id-${e}`,
	tenantName: `tenant-${e}`,
	releaseChannelId: null,
	releaseChannelName: null
}), As = (e) => {
	let { id: t, identifier: n, data: r, mappingConfig: i } = e || {}, { clusterName: a = "", namespace: o = "", default: s = !1, isVirtualEnvironment: c = !1 } = r || {}, l = Os(i);
	return {
		id: t,
		name: n,
		namespace: o,
		environmentType: s ? Ft.production : Ft.nonProduction,
		cluster: a,
		tenantConfig: l,
		isVirtual: c
	};
}, js = (e) => {
	let t = 0;
	return Object.values(e).reduce((e, n) => e.concat(Object.keys(n).map((e) => ({
		identifier: e,
		index: t++,
		typeOfDependency: Ct.UPSTREAM,
		resourceKind: L.environment,
		resourceVersion: R.v1
	}))), []);
}, Ms = ({ tenantId: e, installationId: t }) => `${e}-${t}`, Ns = /* @__PURE__ */ function(e) {
	return e.isolated = "isolated", e.nonIsolated = "nonIsolated", e.empty = "empty", e;
}({}), Ps = /* @__PURE__ */ function(e) {
	return e.environment = "environment", e.namespace = "namespace", e.environmentType = "environmentType", e.tenantInstallation = "tenantInstallation", e;
}({}), Fs = Array.from([
	,
	,
	,
].keys()).map((e) => ({
	id: e,
	name: `env-${e}`,
	namespace: `namespace-${e}`,
	environmentType: Ft.nonProduction,
	cluster: `cluster-${e}`,
	tenantConfig: ks(e),
	isVirtual: !1
})), Is = ({ tenantConfig: e }, t) => e?.name === t.tenantName && e?.installationConfig?.name === t.installationName || !(e?.name && e?.installationConfig?.name), Ls = (e) => Object.keys(e ?? {}).filter(Boolean).length, Rs = (e) => e?.some(({ isVirtual: e }) => e) || !1, zs = (e) => Object.values(e).reduce((e, t) => {
	let n = Object.values(t);
	return n.length ? Rs(n) ? Ns.isolated : Ns.nonIsolated : e;
}, Ns.empty), Bs = (e, t) => {
	let n = zs(e), r = Object.values(t).reduce((e, { isVirtual: t }) => t ? Ns.isolated : Ns.nonIsolated, Ns.empty);
	return !(n === r || n === Ns.empty || r === Ns.empty);
}, Vs = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13,
	height: 18,
	viewBox: "0 0 13 18",
	fill: "none",
	...e,
	children: [/* @__PURE__ */ (0, J.jsx)("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.83333 2.33398H1V10.6673H6.83333V12.334H12.6667V4.00065H6.83333V2.33398Z",
		fill: "#1DAD70"
	}), /* @__PURE__ */ (0, J.jsx)("line", {
		x1: .916626,
		y1: 1.41699,
		x2: .916626,
		y2: 16.5837,
		stroke: "#596168",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Hs = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13,
	height: 18,
	viewBox: "0 0 13 18",
	fill: "none",
	...e,
	children: [/* @__PURE__ */ (0, J.jsx)("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.83333 2.33398H1V10.6673H6.83333V12.334H12.6667V4.00065H6.83333V2.33398Z",
		fill: "#596168"
	}), /* @__PURE__ */ (0, J.jsx)("line", {
		x1: .916626,
		y1: 1.41699,
		x2: .916626,
		y2: 16.5837,
		stroke: "#596168",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Us = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.47754 2.44836L5.62571 5.23457C7.06096 5.68858 7.59619 6.28011 8.13143 6.87163C8.14232 6.88367 8.15321 6.8957 8.16411 6.90774L9.01594 4.12153C9.00504 4.10949 8.99415 4.09746 8.98325 4.08542L8.98323 4.08539C8.44801 3.49388 7.91279 2.90238 6.47754 2.44836Z",
			fill: "#3B494D"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.77344 8.02075L3.92161 10.807C5.35686 11.261 5.89209 11.8525 6.42732 12.444C6.43822 12.4561 6.44911 12.4681 6.46 12.4801L7.31183 9.69392C7.30094 9.68188 7.29004 9.66985 7.27915 9.65781L7.27913 9.65778C6.7439 9.06627 6.20869 8.47476 4.77344 8.02075Z",
			fill: "#3B494D"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.62598 5.23462L4.77415 8.02083C6.2094 8.47484 6.74463 9.06636 7.27986 9.65788C7.29075 9.66992 7.30165 9.68196 7.31254 9.69399L8.16437 6.90778C8.15347 6.89575 8.14258 6.88371 8.13169 6.87168L8.13167 6.87165C7.59644 6.28013 7.06123 5.68863 5.62598 5.23462Z",
			fill: "#E4E4E4"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.1638 6.90779L9.01562 4.12158C9.55014 4.71183 10.1029 5.29929 11.5685 5.74736C11.5685 5.74736 11.5685 5.74737 11.5685 5.74737L10.7167 8.53358C10.7167 8.53357 10.7166 8.53357 10.7166 8.53356C9.25107 8.0855 8.69831 7.49803 8.1638 6.90779Z",
			fill: "#E4E4E4"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.46067 12.4802L7.3125 9.69397C7.84702 10.2842 8.39977 10.8717 9.86533 11.3197C9.86535 11.3197 9.86536 11.3198 9.86538 11.3198L9.01355 14.106C9.01354 14.106 9.01352 14.106 9.0135 14.1059C7.54794 13.6579 6.99519 13.0704 6.46067 12.4802Z",
			fill: "#E4E4E4"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.31223 9.69392L8.16406 6.90771C8.69858 7.49796 9.25133 8.08542 10.7169 8.53349C10.7169 8.53349 10.7169 8.5335 10.7169 8.5335L9.86511 11.3197C9.8651 11.3197 9.86508 11.3197 9.86507 11.3197C8.39951 10.8716 7.84675 10.2842 7.31223 9.69392Z",
			fill: "#3B494D"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.7172 8.53356L11.569 5.74735C12.9515 6.17002 13.7991 6.05667 14.5744 5.89316L13.7226 8.67934C12.9473 8.84288 12.0997 8.95623 10.7172 8.53356Z",
			fill: "#3B494D"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.01309 14.1059L9.86492 11.3197C11.2474 11.7424 12.095 11.6291 12.8703 11.4655L12.0185 14.2517C11.2432 14.4153 10.3956 14.5286 9.01309 14.1059Z",
			fill: "#3B494D"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.86563 11.3197L10.7175 8.53348C12.1 8.95615 12.9475 8.84281 13.7228 8.67929L12.871 11.4655C12.0957 11.629 11.2482 11.7424 9.86563 11.3197Z",
			fill: "#E4E4E4"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.7219 8.67931L14.5737 5.89313C14.6609 5.87474 14.7472 5.85571 14.8332 5.83675L14.8332 5.83674L14.8334 5.8367C15.6203 5.66319 16.3858 5.49437 17.6339 5.85946L16.7821 8.64567C15.5339 8.28055 14.7683 8.44937 13.9814 8.62293C13.8953 8.6419 13.8091 8.66092 13.7219 8.67931Z",
			fill: "#E4E4E4"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.0188 14.2517L12.8706 11.4655C12.9578 11.4471 13.044 11.4281 13.1301 11.4091L13.1301 11.4091L13.1303 11.4091C13.9171 11.2356 14.6827 11.0668 15.9308 11.4319L15.079 14.2181C13.8308 13.8529 13.0652 14.0218 12.2782 14.1953C12.1922 14.2143 12.106 14.2333 12.0188 14.2517Z",
			fill: "#E4E4E4"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.8703 11.4656L13.7222 8.67938C13.8093 8.66099 13.8956 8.64197 13.9816 8.623L13.9817 8.62299L13.9818 8.62296C14.7687 8.44944 15.5343 8.28062 16.7824 8.64572L15.9306 11.4319C14.6824 11.0668 13.9168 11.2356 13.1298 11.4092C13.0438 11.4282 12.9575 11.4472 12.8703 11.4656Z",
			fill: "#3B494D"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.84378 1.24999C7.17388 1.35091 7.35966 1.70032 7.25874 2.03042L2.75135 16.7734C2.65043 17.1035 2.30102 17.2893 1.97092 17.1884C1.64083 17.0875 1.45504 16.7381 1.55596 16.408L6.06336 1.66495C6.16428 1.33486 6.51369 1.14907 6.84378 1.24999Z",
			fill: "#E7C837"
		})
	]
}), Ws = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 15,
	height: 14,
	viewBox: "0 0 15 14",
	fill: "none",
	...e,
	children: [/* @__PURE__ */ (0, J.jsx)("path", {
		d: "M5.53129 5.39551V3.42676C5.53129 2.90461 5.73871 2.40385 6.10792 2.03464C6.47714 1.66543 6.9779 1.45801 7.50004 1.45801C8.02219 1.45801 8.52294 1.66543 8.89216 2.03464C9.26137 2.40385 9.46879 2.90461 9.46879 3.42676V5.39551M3.65534 5.39551H11.3447C11.5571 5.39551 11.7292 5.59138 11.7292 5.83301V11.958C11.7292 12.1996 11.5571 12.3955 11.3447 12.3955H3.65534C3.44301 12.3955 3.27087 12.1996 3.27087 11.958V5.83301C3.27087 5.59138 3.44301 5.39551 3.65534 5.39551Z",
		stroke: "#596168",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M7.5 9.55176C7.86244 9.55176 8.15625 9.25794 8.15625 8.89551C8.15625 8.53307 7.86244 8.23926 7.5 8.23926C7.13756 8.23926 6.84375 8.53307 6.84375 8.89551C6.84375 9.25794 7.13756 9.55176 7.5 9.55176Z",
		fill: "#596168"
	})]
}), Y = /* @__PURE__ */ function(e) {
	return e.PRE_POST_INITIATED = "Starting", e.PRE_POST_RUNNING = "Running", e.DEPLOY_INITIATED = "Initiating", e.PROGRESSING = "Progressing", e.QUEUED = "Queued", e.ABORTED = "Aborted", e.TIMED_OUT = "TimedOut", e.DEGRADED = "Degraded", e.ERROR = "Error", e.CANCELLED = "CANCELLED", e.FAILED = "Failed", e.SUCCEEDED = "Succeeded", e.HEALTHY = "Healthy", e.NOT_TRIGGERED = "Not Triggered", e.UNABLE_TO_FETCH = "UnableToFetch", e.MISSING = "Missing", e.WAITING_TO_START = "WaitingToStart", e.UNKNOWN = "Unknown", e;
}({}), X = /* @__PURE__ */ function(e) {
	return e.yetToTrigger = "yetToTrigger", e.onGoing = "onGoing", e.failed = "failed", e.completed = "completed", e;
}({}), Gs = /* @__PURE__ */ function(e) {
	return e.IMAGE_TAG = "artifactTag", e.IMAGE_LABEL = "imageTag", e.RELEASE = "release", e;
}({}), Ks = /* @__PURE__ */ function(e) {
	return e.RELEASE_TRACK = "release-track", e.RELEASE = "release", e.CD_PIPELINE = "cd-pipeline", e;
}({}), qs = /* @__PURE__ */ function(e) {
	return e.ALPHA_1 = "alpha1", e.V1 = "v1", e;
}({}), Js = /* @__PURE__ */ function(e) {
	return e.PARTIALLY_RELEASED = "partiallyReleased", e.COMPLETELY_RELEASED = "completelyReleased", e.CORRUPTED = "corrupted", e;
}({}), Z = /* @__PURE__ */ function(e) {
	return e.DRAFT = "draft", e.READY_FOR_RELEASE = "readyForRelease", e.HOLD = "hold", e.RESCINDED = "rescind", e;
}({}), Ys = /* @__PURE__ */ function(e) {
	return e.RELEASE_STAGE = "level", e.APPLICATION = "upstream", e;
}({}), Xs = /* @__PURE__ */ function(e) {
	return e.ENVIRONMENTS = "environments", e;
}({}), Zs = /* @__PURE__ */ function(e) {
	return e.ARTIFACT = "artifact", e;
}({}), Qs = /* @__PURE__ */ function(e) {
	return e.bundled = "bundled", e.nonBundled = "non-bundled", e;
}({}), $s = /* @__PURE__ */ function(e) {
	return e.processed = "200", e.processedAndPushed = "201", e.notProcessed = "11001", e.notExecuted = "11002", e;
}({}), ec = {
	DEPLOY: "Deployment stage",
	PRE_DEPLOY: "Pre deployment stage",
	POST_DEPLOY: "Post deployment stage "
}, tc = {
	IN_PROGRESS: "In progress",
	QUEUED: "Queued",
	FAILED: "Failed",
	ABORTED: "Aborted",
	TIMED_OUT: "Timeout",
	DEGRADED: "Degraded",
	ERROR: "Error",
	SUCCEEDED: "Success",
	HEALTHY: "Healthy",
	UNABLE_TO_FETCH: "Unable to fetch",
	NOT_TRIGGERED: "Not triggered",
	MISSING: "Missing",
	UNKNOWN: "Unknown",
	WAITING_TO_START: "Waiting to start"
}, nc = {
	[Y.DEPLOY_INITIATED]: tc.IN_PROGRESS,
	[Y.PRE_POST_INITIATED]: tc.IN_PROGRESS,
	[Y.PRE_POST_RUNNING]: tc.IN_PROGRESS,
	[Y.PROGRESSING]: tc.IN_PROGRESS,
	[Y.QUEUED]: tc.QUEUED,
	[Y.FAILED]: tc.FAILED,
	[Y.TIMED_OUT]: tc.TIMED_OUT,
	[Y.DEGRADED]: tc.DEGRADED,
	[Y.ERROR]: tc.ERROR,
	[Y.CANCELLED]: tc.ABORTED,
	[Y.ABORTED]: tc.ABORTED,
	[Y.SUCCEEDED]: tc.SUCCEEDED,
	[Y.HEALTHY]: tc.HEALTHY,
	[Y.NOT_TRIGGERED]: tc.NOT_TRIGGERED,
	[Y.UNABLE_TO_FETCH]: tc.UNABLE_TO_FETCH,
	[Y.MISSING]: tc.MISSING,
	[Y.UNKNOWN]: tc.UNKNOWN,
	[Y.WAITING_TO_START]: tc.WAITING_TO_START
}, rc = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	...e,
	children: /* @__PURE__ */ (0, J.jsxs)("g", {
		clipPath: "url(#clip0_2382_27793)",
		children: [/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.00016 1.75016C4.10067 1.75016 1.75016 4.10067 1.75016 7.00016C1.75016 9.89966 4.10067 12.2502 7.00016 12.2502C9.89966 12.2502 12.2502 9.89966 12.2502 7.00016C12.2502 4.10067 9.89966 1.75016 7.00016 1.75016ZM0.583496 7.00016C0.583496 3.45634 3.45634 0.583496 7.00016 0.583496C10.544 0.583496 13.4168 3.45634 13.4168 7.00016C13.4168 10.544 10.544 13.4168 7.00016 13.4168C3.45634 13.4168 0.583496 10.544 0.583496 7.00016Z",
			fill: "#FFB549"
		}), /* @__PURE__ */ (0, J.jsx)("path", {
			d: "M4.94656 9.83432C5.39385 10.1584 5.91148 10.372 6.45713 10.4576C7.00278 10.5433 7.56096 10.4986 8.08603 10.3272C8.61111 10.1559 9.08816 9.86263 9.4782 9.47154C9.86823 9.08046 10.1602 8.60262 10.3301 8.07708C10.5001 7.55155 10.5433 6.99325 10.4562 6.44783C10.369 5.90241 10.154 5.38536 9.82879 4.93895C9.50354 4.49253 9.07724 4.12944 8.58477 3.87934C8.0923 3.62925 7.54763 3.49926 6.99529 3.5L7 7L4.94656 9.83432Z",
			fill: "#8C6324"
		})]
	})
}), ic = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...e,
	children: [/* @__PURE__ */ (0, J.jsx)("circle", {
		cx: 12,
		cy: 12,
		r: 10,
		stroke: "#596168",
		strokeWidth: 2
	}), /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M14.9068 6.75117C13.9954 6.24639 12.9682 5.98767 11.9264 6.00045L12 12L14.9068 6.75117Z",
		fill: "#596168"
	})]
}), ac = "allInstallation", oc = {
	[ac]: 0,
	[X.yetToTrigger]: 0,
	[X.onGoing]: 0,
	[X.failed]: 0,
	[X.completed]: 0
}, sc = Array.from([
	,
	,
	,
].keys()).map((e) => ({
	tenantConfig: ks(e),
	tenantInstallationRolloutStatus: X.onGoing,
	apps: [],
	rolloutStatusSummary: { ...oc },
	isTenantInstallationIsolated: !1
})), cc = /* @__PURE__ */ function(e) {
	return e.tenantInstallation = "tenantInstallation", e;
}({}), lc = {
	[ac]: "All Tenants",
	[X.yetToTrigger]: "Yet to trigger",
	[X.onGoing]: "Ongoing",
	[X.failed]: "Failed (Any stage)",
	[X.completed]: "Completed"
}, uc = [
	{
		value: ac,
		tippyContent: "Rollout status for all tenant (installations)",
		icon: /* @__PURE__ */ (0, J.jsx)(se, { className: "w-100 h-100" })
	},
	{
		value: X.yetToTrigger,
		tippyContent: "Tenant (Installations) for which no rollouts are triggered",
		icon: /* @__PURE__ */ (0, J.jsx)(ic, { className: "w-100 h-100" })
	},
	{
		value: X.onGoing,
		tippyContent: "Tenant (Installations) for which rollouts are ongoing and no deployment stage has failed",
		icon: /* @__PURE__ */ (0, J.jsx)(rc, { className: "w-100 h-100 ic-in-progress-orange" })
	},
	{
		value: X.failed,
		tippyContent: "Tenant (Installations) for which any deployment stage is failed",
		icon: /* @__PURE__ */ (0, J.jsx)(Ao, { className: "w-100 h-100" })
	},
	{
		value: X.completed,
		tippyContent: "Tenant (Installations) for which all rollouts have completed successfully",
		icon: /* @__PURE__ */ (0, J.jsx)(Xi, { className: "w-100 h-100" })
	}
], dc = {
	[ac]: {
		countBackgroundClass: "bg__primary dc__border-n1 h-20",
		iconClass: "dc__hide-section"
	},
	[X.yetToTrigger]: {
		countBackgroundClass: "bg__secondary",
		iconClass: "bcn-3"
	},
	[X.onGoing]: {
		countBackgroundClass: "bco-50",
		iconClass: "bco-5"
	},
	[X.failed]: {
		countBackgroundClass: "bcr-50",
		iconClass: "bcr-5"
	},
	[X.completed]: {
		countBackgroundClass: "bcg-50",
		iconClass: "bcg-5"
	}
}, fc = [
	X.yetToTrigger,
	X.onGoing,
	X.failed,
	X.completed
], pc = [
	ac,
	X.yetToTrigger,
	X.onGoing,
	X.failed,
	X.completed
], mc = /* @__PURE__ */ function(e) {
	return e.notTriggered = "Not Triggered", e.failed = "Failed", e.inProgress = "Progressing", e.succeeded = "Succeeded", e.queued = "Queued", e.others = "Others", e;
}({}), hc = {
	"Not Triggered": nc[Y.NOT_TRIGGERED],
	Failed: nc[Y.FAILED],
	Progressing: nc[Y.PROGRESSING],
	Succeeded: nc[Y.SUCCEEDED],
	Queued: nc[Y.QUEUED],
	Others: "Others"
}, gc = [
	{
		label: hc["Not Triggered"],
		value: "Not Triggered"
	},
	{
		label: hc.Failed,
		value: "Failed"
	},
	{
		label: hc.Progressing,
		value: "Progressing"
	},
	{
		label: hc.Succeeded,
		value: "Succeeded"
	}
], _c = [
	{
		stageType: wt.PRE,
		options: [...gc]
	},
	{
		stageType: wt.DEPLOY,
		options: [
			...gc,
			{
				label: hc.Queued,
				value: "Queued",
				hideIfCountZero: !0
			},
			{
				label: hc.Others,
				value: "Others",
				hideIfCountZero: !0
			}
		]
	},
	{
		stageType: wt.POST,
		options: [...gc]
	}
], vc = (e) => `${e.appId}-${e.envId}`, yc = (e, t) => ({
	appId: e.appId,
	pipelineId: e.pipelineId,
	envId: e.envId,
	existingStages: e.existingStages,
	levelIndex: t
}), bc = (e) => {
	if (!e?.length) return {};
	let t = {};
	return e.forEach((e) => {
		e.applications.forEach((e) => {
			t[e.name] = JSON.parse(JSON.stringify(e));
		});
	}), t;
}, xc = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, J.jsxs)("g", {
		id: "Icon/ic-diff-file-added",
		children: [/* @__PURE__ */ (0, J.jsx)("rect", {
			id: "Rectangle 15",
			x: 2.41699,
			y: 2.41663,
			width: 15.1667,
			height: 15.1667,
			rx: 1.25,
			stroke: "#1DAD70",
			strokeWidth: 1.5
		}), /* @__PURE__ */ (0, J.jsx)("path", {
			id: "Vector",
			d: "M5.83301 10H14.1663M9.99967 5.83337V14.1667",
			stroke: "#1DAD70",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})
}), Sc = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, J.jsxs)("g", {
		id: "Icon/ic-diff-file-removed",
		children: [/* @__PURE__ */ (0, J.jsx)("rect", {
			id: "Rectangle 15",
			x: 2.41699,
			y: 2.41663,
			width: 15.1667,
			height: 15.1667,
			rx: 1.25,
			stroke: "#F33E3E",
			strokeWidth: 1.5
		}), /* @__PURE__ */ (0, J.jsx)("path", {
			id: "Vector",
			d: "M5.83301 10H14.1663",
			stroke: "#F33E3E",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})
}), Cc = /* @__PURE__ */ function(e) {
	return e.deleted = "deleted", e.added = "added", e.removed = "removed", e;
}({}), wc = {
	added: /* @__PURE__ */ (0, J.jsx)(xc, { className: "w-100 h-100" }),
	removed: /* @__PURE__ */ (0, J.jsx)(Sc, { className: "w-100 h-100" }),
	deleted: /* @__PURE__ */ (0, J.jsx)(Sc, { className: "w-100 h-100" })
}, Tc = {
	value: "",
	updatedOn: "",
	updatedBy: {
		id: 0,
		icon: !1,
		name: ""
	}
}, Ec = fr(), Dc = {
	...Ec,
	control: (e, t) => ({
		...Ec.control(e, t),
		width: "100%",
		height: 36,
		minHeight: 36
	})
}, Oc = "Please select a release track", kc = "Please select a release track from the available options", Ac = "Release created successfully", jc = "Release updated successfully", Mc = {
	value: "",
	error: ""
}, Nc = "Saved Changes", Pc = [
	ys.CanTrigger,
	ys.CanTriggerInDeploymentWindow,
	ys.ExceptionUser
], Fc = {
	SDH_SWITCH_RELEASE_ITEM_CLICKED: "SDH_SWITCH_RELEASE_ITEM_CLICKED",
	SDH_SWITCH_TENANTS_ITEM_CLICKED: "SDH_SWITCH_TENANTS_ITEM_CLICKED"
}, Ic = ({ baseUrl: e, kind: t, version: n = qs.ALPHA_1, payload: r }) => Nr(`${e}/${t}/${n}`, r), Lc = (e) => !e || e.areAllTargeted ? { areAllInstallationsTargeted: !0 } : { installations: (e.installations || []).map(({ identifier: e }) => ({ identifier: e || "" })) }, Rc = (e) => {
	if (!e) return null;
	let { id: t, name: n, overview: r, configStatus: i, parentConfig: a, depStatus: o, catalogSchemaResourceId: s } = e, { description: c = "", createdBy: l = { name: "" }, createdOn: u = "", note: d, releaseVersion: f = "", tags: p = {}, firstReleasedOn: m = "" } = r || {}, h = Object.keys(p).map((e) => ({
		label: e,
		value: p[e].value
	})).sort((e, t) => G(e.label, t.label));
	return {
		id: t,
		name: n,
		status: i?.status || Z.DRAFT,
		isLocked: i?.isLocked || !1,
		description: c,
		note: {
			value: d?.value ?? "",
			updatedBy: {
				icon: d?.updatedBy?.icon ?? !1,
				id: d?.updatedBy?.id ?? 0,
				name: d?.updatedBy?.name ?? ""
			},
			updatedOn: d?.updatedOn ?? ""
		},
		trackId: a?.id,
		track: a?.identifier ?? "",
		version: f,
		createdBy: l.name,
		createdOn: u && u !== nr ? (0, po.default)(u).format(te.TWELVE_HOURS_FORMAT) : "",
		tags: h,
		firstReleasedOn: m && m !== nr ? (0, po.default)(m).format(te.DATE_FORMAT) : "",
		areAllImagesSelected: o?.areAllImagesSelected || !1,
		areDepPresent: o?.areDepPresent || !1,
		installationsMappedToRelease: Lc(e.target),
		catalogSchemaResourceId: s
	};
}, zc = (e) => e?.map(Rc) ?? [], Bc = (e) => {
	if (!e) return null;
	let { id: t, name: n, overview: r, childObjects: i } = e, { description: a = "", createdBy: o = { name: "" }, createdOn: s = "" } = r || {};
	return {
		id: t,
		name: n,
		description: a,
		releases: zc(i),
		createdBy: o.name,
		createdOn: s && s !== nr ? (0, po.default)(s).format(te.TWELVE_HOURS_FORMAT) : ""
	};
}, Vc = (e) => e?.map(Bc) ?? [], Hc = (e, t) => {
	let n = e === 0;
	return t && !n ? {
		title: "Release Last",
		icon: /* @__PURE__ */ (0, J.jsx)(Us, { className: "icon-dim-16 dc__no-shrink" })
	} : {
		title: `Release ${Sr(e + 1)}`,
		icon: n ? /* @__PURE__ */ (0, J.jsx)(Vs, { className: "icon-dim-16 dc__no-shrink" }) : /* @__PURE__ */ (0, J.jsx)(Hs, { className: "icon-dim-16 dc__no-shrink" })
	};
}, Uc = (e) => ({
	resourceKind: L.devtronApplication,
	resourceVersion: R.v1,
	identifier: e
}), Wc = (e) => e ? e.sort((e, t) => G(e.name, t.name)).map(({ mappingConfig: e, ...t }) => ({
	...t,
	tenantConfig: Os(e)
})) : [], Gc = (e) => {
	let t = e?.commitSource?.map((e) => ({
		hash: e.revision ?? "",
		shortHash: e.revision?.substring(0, 7),
		message: e.message ?? ""
	})) ?? [], n = e?.image ?? "";
	return {
		commitDetails: t,
		imageDetails: {
			artifactId: e?.artifactId,
			image: n,
			imagePath: lr(n),
			registryType: e?.registryType || wn.OTHER,
			sourceMessage: t[0]?.message ?? ""
		}
	};
}, Kc = ({ identifier: e, config: t, deleted: n }) => {
	let { commitDetails: r, imageDetails: i } = Gc(t?.artifactConfig);
	return {
		isDeleted: n ?? !1,
		name: e ?? "-",
		commitDetails: r,
		imageDetails: i,
		releaseInstructions: t?.releaseInstruction ?? ""
	};
}, qc = (e) => {
	let t = e.flatMap(({ childObjects: e }) => Wc(e?.find((e) => e.type === Xs.ENVIRONMENTS)?.data)), n = t.filter(({ tenantConfig: e }) => !e.identifier).map(({ name: e }) => e).sort(G), { releaseChannelToTenantInstallationMap: r, tenantInstallationsNotSubscribedToReleaseChannel: i, tenantInstallationDetailsMap: a } = t.reduce((e, { tenantConfig: t, name: n }) => {
		let { releaseChannelId: r, installationIdentifier: i, releaseChannelName: a } = t.installationConfig || {};
		return i ? (r ? e.releaseChannelToTenantInstallationMap[r] ? e.releaseChannelToTenantInstallationMap[r].tenantDetails.add(i) : e.releaseChannelToTenantInstallationMap[r] = {
			releaseChannelName: a,
			tenantDetails: new Set([i])
		} : e.tenantInstallationsNotSubscribedToReleaseChannel.add(i), e.tenantInstallationDetailsMap[i] ? e.tenantInstallationDetailsMap[i].environments.add(n) : e.tenantInstallationDetailsMap[i] = {
			environments: new Set([n]),
			tenantInstallationConfig: t
		}, e) : e;
	}, {
		releaseChannelToTenantInstallationMap: {},
		tenantInstallationsNotSubscribedToReleaseChannel: /* @__PURE__ */ new Set(),
		tenantInstallationDetailsMap: {}
	});
	return {
		unmappedEnvironments: [...new Set(n)],
		releaseChannelToTenantInstallationMap: r,
		tenantInstallationsNotSubscribedToReleaseChannel: i,
		tenantInstallationDetailsMap: a
	};
}, Jc = (e) => {
	if (!e) return {
		applicationsByStages: [],
		environments: [],
		tenantsWithInstallations: [],
		unmappedEnvironments: [],
		releaseChannels: []
	};
	let t = e.sort((e, t) => Ur(e.level, t.level)), n = t.length, r = t.flatMap((e) => e.dependencies ?? []).sort((e, t) => G(e.envName, t.envName)).map(({ mappingConfig: e, ...t }) => ({
		...t,
		tenantConfig: Os(e)
	})), i = r.map(({ tenantConfig: e }) => structuredClone(e)).filter(({ identifier: e }) => !!e), a = {}, o = {};
	return {
		applicationsByStages: t.map((e, t) => ({
			...Hc(t, t === n - 1),
			id: e.level,
			applications: [...new Set(e?.dependencies?.map(({ appName: e }) => e) ?? [])]
		})).filter((e) => e.applications.length > 0),
		environments: [...new Set(r.map(({ envName: e }) => e))],
		tenantsWithInstallations: i.filter(({ identifier: e }) => a[e] ? !1 : (a[e] = !0, !0)),
		unmappedEnvironments: [...new Set(r.filter(({ tenantConfig: { identifier: e } }) => !e).map(({ envName: e }) => e))],
		releaseChannels: r.map(({ tenantConfig: e }) => ({
			name: e.installationConfig.releaseChannelName,
			channelId: e.installationConfig.releaseChannelId
		})).filter(({ channelId: e }) => e && !o[e] ? (o[e] = !0, !0) : !1)
	};
}, Yc = (e) => {
	if (!e) return {
		deploymentsCount: {
			totalCount: 0,
			filteredCount: 0
		},
		tenantsCount: {
			totalCount: 0,
			filteredCount: 0
		},
		rolloutStatus: {
			...oc,
			[ac]: 0
		},
		filterDeploymentStatus: {
			[wt.PRE]: {
				[mc.notTriggered]: 0,
				[mc.failed]: 0,
				[mc.inProgress]: 0,
				[mc.succeeded]: 0,
				[mc.queued]: 0,
				[mc.others]: 0
			},
			[wt.DEPLOY]: {
				[mc.notTriggered]: 0,
				[mc.failed]: 0,
				[mc.inProgress]: 0,
				[mc.succeeded]: 0,
				[mc.queued]: 0,
				[mc.others]: 0
			},
			[wt.POST]: {
				[mc.notTriggered]: 0,
				[mc.failed]: 0,
				[mc.inProgress]: 0,
				[mc.succeeded]: 0,
				[mc.queued]: 0,
				[mc.others]: 0
			}
		}
	};
	let { installationDeploymentRolloutStatus: t = {}, stageWiseDeploymentStatus: n = {}, mappingConfigCount: r = {}, deploymentsCount: i = {} } = e ?? {
		mappingConfigCount: {},
		deploymentsCount: {},
		installationDeploymentRolloutStatus: {},
		stageWiseDeploymentStatus: {}
	}, a = Object.keys(wt).reduce((e, t) => {
		let r = n[t.toLowerCase()];
		return e[t] = {
			[mc.notTriggered]: r[mc.notTriggered] ?? 0,
			[mc.failed]: r[mc.failed] ?? 0,
			[mc.inProgress]: r[mc.inProgress] ?? 0,
			[mc.succeeded]: r[mc.succeeded] ?? 0,
			[mc.queued]: r[mc.queued] ?? 0,
			[mc.others]: r[mc.others] ?? 0
		}, e;
	}, {});
	return {
		tenantsCount: {
			totalCount: r.totalCount ?? 0,
			filteredCount: r.filteredCount ?? 0
		},
		deploymentsCount: {
			totalCount: i.totalCount ?? 0,
			filteredCount: i.filteredCount ?? 0
		},
		rolloutStatus: {
			[ac]: t.allInstallation ?? 0,
			[X.yetToTrigger]: t[X.yetToTrigger] ?? 0,
			[X.failed]: t[X.failed] ?? 0,
			[X.onGoing]: t[X.onGoing] ?? 0,
			[X.completed]: t[X.completed] ?? 0
		},
		filterDeploymentStatus: a
	};
}, Xc = (e) => ({
	appId: e.appId,
	appName: e.appName,
	envId: e.envId,
	envName: e.envName,
	pipelineId: e.pipelineId,
	deployStatus: e.deployStatus || Y.NOT_TRIGGERED,
	preStatus: e.preStatus || Y.NOT_TRIGGERED,
	postStatus: e.postStatus || Y.NOT_TRIGGERED,
	existingStages: {
		pre: e.existingStages?.pre || !1,
		deploy: e.existingStages?.deploy || !0,
		post: e.existingStages?.post || !1
	},
	isDeployable: e.taskRunAllowed || !1,
	tenantConfig: Os(e.mappingConfig),
	preCdWorkflowRunnerId: e.preCdWorkflowRunnerId || 0,
	cdWorkflowRunnerId: e.cdWorkflowRunnerId || 0,
	postCdWorkflowRunnerId: e.postCdWorkflowRunnerId || 0,
	isVirtualEnvironment: e.isVirtualEnvironment || !1
}), Zc = (e, t) => {
	let n = e?.sort((e, t) => Ur(e.level, t.level)) ?? [], r = n.length;
	return {
		countSummary: Yc(t),
		releaseStageList: n.map((e, t) => ({
			...Hc(t, t === r - 1),
			id: e.level,
			applications: (e.dependencies ?? []).map((e) => Xc(e))
		}))
	};
}, Qc = (e) => e?.map(Xc) ?? [], $c = (e) => {
	switch (e) {
		case ys.CanTriggerInDeploymentWindow:
		case ys.CanTrigger:
		case ys.ExceptionUser: return {
			code: e,
			icon: /* @__PURE__ */ (0, J.jsx)(p, { className: "w-100 h-100 scg-7" }),
			text: /* @__PURE__ */ (0, J.jsx)("span", {
				className: "cg-7 fw-6",
				children: "Can trigger"
			}),
			statusCode: ys.CanTrigger,
			sortPriority: 3
		};
		case ys.NotAuthorized: return {
			code: e,
			icon: /* @__PURE__ */ (0, J.jsx)(Ws, { className: "w-100 h-100 scy-7" }),
			text: /* @__PURE__ */ (0, J.jsx)("span", {
				className: "cy-7 fw-6",
				children: "Not authorized"
			}),
			statusCode: ys.NotAuthorized,
			sortPriority: 2
		};
		default: return {
			code: e ?? ys.CannotTrigger,
			icon: /* @__PURE__ */ (0, J.jsx)(d, { className: "w-100 h-100 fcr-7" }),
			text: /* @__PURE__ */ (0, J.jsx)("span", {
				className: "cr-7 fw-6",
				children: "Cannot trigger"
			}),
			statusCode: ys.CannotTrigger,
			sortPriority: 1
		};
	}
}, el = (e = []) => e?.map((e) => ({
	appId: e.appId,
	appName: e.appName,
	envId: e.envId,
	envName: e.envName,
	feasibility: $c(e.feasibility?.code),
	message: e.feasibility?.userMessage ?? "",
	tenantConfig: Os(e.mappingConfig)
})) ?? [], tl = (e) => {
	let t = e.reduce((e, { feasibility: t }) => (e[t.statusCode] += 1, e), {
		[ys.NotAuthorized]: 0,
		[ys.CannotTrigger]: 0,
		[ys.CanTrigger]: 0
	}), n = t[ys.NotAuthorized] + t[ys.CannotTrigger];
	return n > 0 ? {
		statusCode: ys.CannotTrigger,
		sortPriority: 1,
		icon: /* @__PURE__ */ (0, J.jsx)(d, { className: "w-100 h-100 fcr-7" }),
		text: /* @__PURE__ */ (0, J.jsx)("span", {
			className: "cr-7 fw-6",
			children: "Cannot trigger"
		}),
		message: `${n} out ${e.length} pipelines cannot be triggered`
	} : {
		statusCode: ys.CanTrigger,
		sortPriority: 2,
		icon: /* @__PURE__ */ (0, J.jsx)(p, { className: "w-100 h-100 scg-7" }),
		text: /* @__PURE__ */ (0, J.jsx)("span", {
			className: "cg-7 fw-6",
			children: "Can trigger"
		})
	};
}, nl = (e) => {
	let t = el(e).reduce((e, { tenantConfig: t, ...n }) => (e[t.identifier] || (e[t.identifier] = {
		tenantConfig: t,
		feasibilityList: []
	}), e[t.identifier].feasibilityList.push(n), e), {});
	return Object.values(t).map((e) => ({
		...e,
		tenantFeasibility: tl(e.feasibilityList),
		feasibilityList: e.feasibilityList.filter((e) => !Pc.includes(e.feasibility.code))
	}));
}, rl = (e, t) => {
	let n = e?.code, r = e?.userMessage;
	switch (n) {
		case $s.processed: return {
			code: n,
			icon: /* @__PURE__ */ (0, J.jsx)(Xi, { className: "w-100 h-100" }),
			text: /* @__PURE__ */ (0, J.jsx)("span", {
				className: "cg-7 fw-6",
				children: t ? "Succeeded" : "Initiated"
			}),
			sortPriority: t ? 5 : 6,
			message: r
		};
		case $s.processedAndPushed: return {
			code: n,
			icon: /* @__PURE__ */ (0, J.jsx)(Xi, { className: "w-100 h-100" }),
			text: /* @__PURE__ */ (0, J.jsx)("span", {
				className: "cg-7 fw-6",
				children: "Generated & pushed to OCI"
			}),
			sortPriority: t ? 7 : 8,
			message: r
		};
		case $s.notExecuted: return {
			code: n,
			icon: /* @__PURE__ */ (0, J.jsx)(d, { className: "w-100 h-100 fcn-6" }),
			text: /* @__PURE__ */ (0, J.jsx)("span", {
				className: "cn-9 fw-6",
				children: "Not executed"
			}),
			sortPriority: t ? 4 : 3,
			message: r
		};
		default: return {
			code: n ?? $s.notProcessed,
			icon: /* @__PURE__ */ (0, J.jsx)(Ao, { className: "w-100 h-100" }),
			text: /* @__PURE__ */ (0, J.jsx)("span", {
				className: "cr-7 fw-6",
				children: t ? "Failed" : "Not triggered"
			}),
			sortPriority: t ? 2 : 1,
			message: r
		};
	}
}, il = (e, t) => {
	let n = e.reduce((e, { triggerStatus: t }) => (e[t.code] += 1, e), {
		[$s.processed]: 0,
		[$s.processedAndPushed]: 0,
		[$s.notProcessed]: 0,
		[$s.notExecuted]: 0
	}), r = n[$s.notProcessed] + n[$s.notExecuted] + +!![$s.notExecuted, $s.notProcessed].includes(t.code);
	return r > 0 ? {
		code: $s.notProcessed,
		icon: /* @__PURE__ */ (0, J.jsx)(Ao, { className: "w-100 h-100" }),
		text: /* @__PURE__ */ (0, J.jsx)("span", {
			className: "cr-7 fw-6",
			children: "Failed"
		}),
		sortPriority: 1,
		message: `${r} out of ${e.length + 1} failed`
	} : {
		code: $s.processed,
		sortPriority: 2,
		icon: /* @__PURE__ */ (0, J.jsx)(Xi, { className: "w-100 h-100" }),
		text: /* @__PURE__ */ (0, J.jsx)("span", {
			className: "cg-7 fw-6",
			children: n[$s.processedAndPushed] > 0 ? "Generated & pushed to OCI" : "Generated"
		}),
		message: ""
	};
}, al = (e = []) => e?.map((e) => {
	let t = e.isVirtualEnv || !1, n = t ? {
		isVirtualEnv: t,
		helmPackageName: e.helmPackageName
	} : {};
	return {
		appId: e.appId,
		appName: e.appName,
		envId: e.envId,
		envName: e.envName,
		triggerStatus: rl(e.triggerStatus, t),
		tenantConfig: Os(e.mappingConfig),
		romStatus: rl(e.romStatus, t),
		stage: e.cdWorkflowType ?? wt.DEPLOY,
		...n
	};
}) ?? [], ol = (e) => {
	let t = al(e).reduce((e, { tenantConfig: t, romStatus: n, ...r }) => (e[t.identifier] || (e[t.identifier] = {
		tenantConfig: t,
		deploymentList: [],
		romStatus: n ?? {
			code: $s.notExecuted,
			icon: /* @__PURE__ */ (0, J.jsx)(d, { className: "w-100 h-100 fcn-6" }),
			text: /* @__PURE__ */ (0, J.jsx)("span", {
				className: "cn-9 fw-6",
				children: "Not executed"
			}),
			message: ""
		}
	}), e[t.identifier].deploymentList.push(r), e), {});
	return Object.values(t).map((e) => ({
		...e,
		tenantTriggerStatus: il(e.deploymentList, e.romStatus)
	}));
}, sl = (e, t) => Object.values(e ?? {}).flatMap((e) => Object.values(e).map(({ appId: e, pipelineId: n, levelIndex: r }) => ({
	appId: e,
	pipelineId: n,
	deploymentWithConfig: Tt.LAST_SAVED_CONFIG,
	cdWorkflowType: t,
	levelIndex: r
}))), cl = (e) => e?.length ? e.map((e) => {
	let { ciPipeline: t, cdPipelines: n } = e;
	return {
		id: e.id,
		workflowName: e.workflowName || "",
		pipelineType: t?.pipelineType || nt.CI,
		pipelineName: t?.name || "",
		sourceInfo: t?.ciMaterial?.map((e) => ({
			ciMaterialId: e?.id || 0,
			repositoryName: e?.gitMaterialName || "",
			sourceValue: e?.source?.value || "",
			sourceType: e?.source?.type || In.BranchFixed
		})) ?? [],
		environments: n?.map((e) => ({
			environmentName: e?.environmentName ?? "",
			environmentId: e?.environmentId
		}))?.sort((e, t) => G(e.environmentName, t.environmentName)) ?? []
	};
}) : [], ll = (e, t, n) => {
	let r = !!e?.sourceReleaseConfiguration?.releaseVersion;
	return n === e?.artifactId ? r ? e.sourceReleaseConfiguration.releaseVersion !== t?.releaseVersion : !!t?.releaseVersion : !0;
}, ul = ({ artifactId: e, registryName: t, registryType: n, artifactSourceAppWorkflowId: r, sourceReleaseConfiguration: i, appName: a }) => ({
	dependencyInfo: Uc(a),
	query: [{
		op: hn.replace,
		path: "image",
		value: {
			artifactId: e,
			registryName: t,
			registryType: n,
			artifactSourceAppWorkflowId: r,
			...i ? { sourceReleaseConfiguration: i } : {}
		}
	}]
}), dl = (e, t, n) => {
	let r = bc(t);
	return {
		id: e,
		dependencyPatch: Object.keys(n).reduce((e, t) => {
			let { selectedImage: i, artifactId: a, registryName: o, registryType: s, sourceReleaseConfiguration: c, artifactSourceAppWorkflowId: l } = n[t];
			return ll(r[t], c, a) ? i ? (e.push(ul({
				artifactId: a,
				registryName: o,
				registryType: s,
				sourceReleaseConfiguration: c,
				artifactSourceAppWorkflowId: l,
				appName: t
			})), e) : (e.push({
				dependencyInfo: Uc(t),
				query: [{
					op: hn.remove,
					path: "image"
				}]
			}), e) : e;
		}, [])
	};
}, fl = (e, t) => e.reduce((e, n) => {
	let { applicationsToArtifactsMap: r, appNameToIdMap: i } = e;
	return r[n.identifier] = Jr(n.data, null, t, null, !0), i[n.identifier] = n.id, {
		applicationsToArtifactsMap: r,
		appNameToIdMap: i
	};
}, {
	applicationsToArtifactsMap: {},
	appNameToIdMap: {}
}), pl = (e) => {
	let t = [...new Set(e.map((e) => e.rolloutStatus))];
	return t.includes(X.failed) ? X.failed : t.length === 1 ? t[0] : X.onGoing;
}, ml = (e, t) => {
	let n = e?.map(({ installationDeploymentRolloutStatus: e, ...t }) => ({
		...Xc(t),
		installationDeploymentRolloutStatus: e ?? X.yetToTrigger
	})) ?? [], r = Object.values(n.reduce((e, { tenantConfig: t, envId: n, envName: r, appId: i, appName: a, preStatus: o, deployStatus: s, postStatus: c, existingStages: l, installationDeploymentRolloutStatus: u, cdWorkflowRunnerId: d, preCdWorkflowRunnerId: f, postCdWorkflowRunnerId: p, pipelineId: m, isVirtualEnvironment: h }) => (e[t.identifier] || (e[t.identifier] = {
		tenantConfig: t,
		apps: []
	}), e[t.identifier].apps.push({
		envId: n,
		envName: r,
		appId: i,
		appName: a,
		deployStatus: s,
		preStatus: o,
		postStatus: c,
		existingStages: l,
		rolloutStatus: u,
		cdWorkflowRunnerId: d,
		preCdWorkflowRunnerId: f,
		postCdWorkflowRunnerId: p,
		pipelineId: m,
		isVirtualEnvironment: h
	}), e), {})).map(({ apps: e, ...t }) => {
		let n = e.sort((e, t) => G(e.appName, t.appName));
		return {
			...t,
			tenantInstallationRolloutStatus: pl(n),
			apps: n,
			isTenantInstallationIsolated: Rs(e.map(({ isVirtualEnvironment: e }) => ({ isVirtual: e }))),
			rolloutStatusSummary: e.reduce((e, t) => (e[t.rolloutStatus] += 1, e), { ...oc })
		};
	});
	return {
		countSummary: Yc(t),
		rolloutStatusList: r
	};
}, hl = ({ rolloutStatus: e = ac, preStage: t = [], deployStage: n = [], postStage: r = [], env: i = [], app: a = [], tenantInstallation: o = [], releaseChannelId: s = [] }) => {
	let c = [];
	if (e && e !== "allInstallation" && c.push(`installationDeploymentRolloutStatus|${e}`), t.length && c.push(`stageWiseDeploymentStatus|${wt.PRE}|${t}`), n.length && c.push(`stageWiseDeploymentStatus|${wt.DEPLOY}|${n}`), r.length && c.push(`stageWiseDeploymentStatus|${wt.POST}|${r}`), i.length && c.push(`environment|identifier|${i}`), a.length && c.push(`${L.devtronApplication}|identifier|${a}`), s.length && c.push(`${L.releaseChannel}|identifier|${s}`), o.length) {
		let e = o.reduce((e, t) => {
			let [n, r] = t?.split("/") ?? [];
			return e[n] ? e[n].push(r) : e[n] = [r], e;
		}, {}), t = Object.keys(e).map((t) => `tenant/installation|identifier|${t}|${e[t]}`);
		c.push(...t);
	}
	return { filterCriteria: c };
}, gl = (e, t) => {
	let n = [];
	return e && n.push(`${Ks.RELEASE_TRACK}|identifier|${e}`), t && n.push(`appWorkflow|id|${t}`), n;
}, _l = (e) => {
	let t = e?.groupedDeps;
	return t ? t.map((e) => {
		let { commitDetails: t, imageDetails: n } = Gc(e.data);
		return {
			appName: e.identifier,
			commitDetails: t,
			imageDetails: n
		};
	}) : [];
}, vl = (e) => e ? e.sort((e, t) => Lr(e.performedAtTime, t.performedAtTime, Fn.ASC)).map((e) => ({
	appId: e.id,
	appName: e.identifier,
	userEmail: e.userEmail,
	type: e.state,
	performedAtTime: e.performedAtTime && e.performedAtTime !== nr ? (0, po.default)(e.performedAtTime).format(te.TWELVE_HOURS_FORMAT) : ""
})) : [], yl = (e, t) => ({
	id: e,
	dependencyPatch: t.map(({ appName: e, type: t }) => ({
		dependencyInfo: Uc(e),
		query: [{
			path: "application",
			op: t === Cc.added ? hn.add : hn.remove
		}]
	}))
}), bl = () => ({ "software-release-management": {
	component: /* @__PURE__ */ (0, J.jsx)(M, {
		dataTestId: "redirect-to-overview-btn",
		component: Qe.link,
		size: P.xs,
		icon: /* @__PURE__ */ (0, J.jsx)(Yt, {
			name: "ic-software-release-management",
			color: null
		}),
		variant: N.borderLess,
		linkProps: { to: I.RELEASES.ROOT },
		ariaLabel: "Software Release Management",
		showAriaLabelInTippy: !0
	}),
	linked: !0
} }), xl = Array.from([
	,
	,
	,
].keys()).map((e) => ({
	id: e,
	...Hc(e, !1),
	applications: Array.from([
		,
		,
		,
	].keys()).map((e) => ({
		name: `app-${e}`,
		appId: e,
		description: "",
		isRequired: !1,
		isDeleted: !1
	}))
})), Sl = /* @__PURE__ */ function(e) {
	return e.description = "description", e.application = "application", e;
}({}), Cl = (e) => {
	let t = e?.groupedDeps;
	return t ? t.map((e) => {
		let t = (e.groupedDeps ?? []).sort((e, t) => Lr(e.data?.triggeredAt, t.data?.triggeredAt, Fn.ASC)).map(({ id: e, data: t }) => ({
			appName: t.appName ?? "",
			appId: t.appId,
			envId: t.envId,
			envName: t.envName ?? "",
			cdWorkflowRunnerId: t.latestReleaseTriggerWfrId,
			pipelineId: e,
			lastTriggeredRelease: {
				version: t.runSource?.releaseVersion ?? "",
				name: t.runSource?.name ?? "",
				deployStatus: t.deploymentStatus ?? Y.NOT_TRIGGERED,
				triggerTime: t.triggeredAt && t.triggeredAt !== nr ? (0, po.default)(t.triggeredAt).format(mt.TWELVE_HOURS_FORMAT) : ""
			}
		})), n = t[0]?.lastTriggeredRelease;
		return {
			tenantConfig: Os(e.data),
			lastTriggeredRelease: n,
			apps: t
		};
	}) : [];
}, wl = async (e) => {
	try {
		let { result: t } = await H(Tr({
			baseUrl: _.RESOURCE,
			version: R.alpha1,
			kind: L.releaseTrack,
			queryParams: { identifier: e }
		}));
		return Bc(t);
	} catch (e) {
		throw W(e), e;
	}
}, Tl = (e) => Wr(Tr({
	baseUrl: _.RESOURCE,
	kind: L.releaseTrack,
	version: R.alpha1
}), e), El = ({ id: e, description: t }) => Tl({
	id: e,
	query: [{
		op: hn.replace,
		path: Sl.description,
		value: t
	}]
}), Dl = ({ id: e, appName: t }) => {
	let n = {
		id: e,
		dependencyPatch: [{
			dependencyInfo: Uc(t),
			query: [{
				op: hn.remove,
				path: Sl.application
			}]
		}]
	};
	return Wr(Tr({
		baseUrl: _.RESOURCE_DEPENDENCIES,
		kind: L.releaseTrack,
		version: R.alpha1
	}), n);
}, Ol = async (e) => {
	try {
		let { result: t } = await H(Tr({
			baseUrl: _.RESOURCE_SUMMARY,
			version: R.alpha1,
			kind: L.releaseTrack,
			queryParams: { identifier: e }
		}));
		return Cl(t);
	} catch (e) {
		throw W(e), e;
	}
}, kl = ({ appName: e, handleClose: t, handleSuccess: n }) => {
	let { name: r, id: i } = vs(), [a, o] = A(!1);
	return /* @__PURE__ */ (0, J.jsx)(ut, {
		variant: dt.delete,
		title: `Remove '${e}' from '${r}'`,
		subtitle: "Removing the application from the track will remove it from all releases in the track.",
		buttonConfig: {
			secondaryButtonConfig: {
				onClick: t,
				text: "Cancel"
			},
			primaryButtonConfig: {
				isLoading: a,
				onClick: async () => {
					o(!0);
					let r = {
						id: i,
						appName: e
					};
					try {
						await Dl(r), await n(), o(!1), B.showToast({
							variant: V.success,
							description: "Application deleted successfully"
						}), t();
					} catch (e) {
						W(e), o(!1);
					}
				},
				text: "Delete"
			}
		},
		confirmationConfig: {
			identifier: "delete-application-from-track",
			confirmationKeyword: "Remove"
		},
		handleClose: t,
		children: /* @__PURE__ */ (0, J.jsxs)("p", {
			className: "fs-13 cn-8 m-0 flexbox-col dc__gap-12",
			children: [
				/* @__PURE__ */ (0, J.jsxs)("span", {
					className: "lh-20",
					children: [
						"1. ",
						e,
						" will need to be removed from draft releases."
					]
				}),
				/* @__PURE__ */ (0, J.jsx)("span", {
					className: "lh-20",
					children: "2. Already released releases will not be impacted."
				}),
				/* @__PURE__ */ (0, J.jsx)("span", {
					className: "lh-20 mt-22",
					children: "Are you sure?"
				})
			]
		})
	});
}, Al = () => /* @__PURE__ */ (0, J.jsx)("span", {
	className: "cr-5",
	children: "*"
}), jl = () => {
	let [e, t] = A(!1), [n, r] = A(null), { name: i, id: a } = vs(), [s, c, l, u] = K(() => nu(a, L.releaseTrack), [i], !!i), d = c?.releaseOrdering ?? [], f = !s && l, p = () => {
		t((e) => !e);
	}, m = (e) => () => {
		r(e);
	};
	return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [!s && !l && !d.length ? /* @__PURE__ */ (0, J.jsx)("section", {
		className: "flexbox-col dc__overflow-auto dc__border br-4 bg__primary flex-grow-1",
		children: /* @__PURE__ */ (0, J.jsx)(F, {
			title: `Add applications to '${i}'`,
			subTitle: "Add applications to define the components that make up this software. Applications added here will be automatically included in new release versions of this software.",
			image: Ni,
			classname: "flex-grow-1",
			isButtonAvailable: !0,
			renderButton: () => /* @__PURE__ */ (0, J.jsxs)("button", {
				type: "button",
				className: "cta flex dc__gap-8 h-36",
				onClick: p,
				children: [/* @__PURE__ */ (0, J.jsx)(o, { className: "icon-dim-16 dc__no-shrink fcb-5" }), "Add Applications"]
			})
		})
	}) : /* @__PURE__ */ (0, J.jsxs)("section", {
		className: "flexbox-col dc__overflow-auto dc__border br-4 bg__primary",
		children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flex dc__content-space dc__gap-8 py-8 px-16 dc__border-bottom bg__secondary",
			children: [/* @__PURE__ */ (0, J.jsxs)("h4", {
				className: "cn-9 fs-13 fw-6 lh-20 dc__truncate m-0",
				children: [
					"Applications part of '",
					i,
					"'"
				]
			}), d.length > 0 && /* @__PURE__ */ (0, J.jsxs)("button", {
				type: "button",
				className: "dc__transparent p-0 dc__hover-n50 fs-13 fw-6 lh-20 cn-7 dc__no-shrink flex dc__gap-6",
				onClick: p,
				disabled: f,
				children: [/* @__PURE__ */ (0, J.jsx)(v, { className: "icon-dim-14 dc__no-shrink scn-7" }), /* @__PURE__ */ (0, J.jsx)("span", { children: "Edit" })]
			})]
		}), /* @__PURE__ */ (0, J.jsx)(Ie, {
			isLoading: !1,
			error: f,
			genericSectionErrorProps: { reload: u },
			children: /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col",
				children: [
					/* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox-col dc__overflow-auto",
						children: [/* @__PURE__ */ (0, J.jsxs)("div", {
							className: "display-grid dc__column-gap-16 releases__manage-apps-row releases__manage-apps-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center px-16 dc__uppercase bg__primary",
							children: [
								/* @__PURE__ */ (0, J.jsx)("span", {}),
								/* @__PURE__ */ (0, J.jsx)(z, {
									title: "Application",
									isSortable: !1
								}),
								/* @__PURE__ */ (0, J.jsx)(z, {
									title: "Description",
									isSortable: !1
								})
							]
						}), /* @__PURE__ */ (0, J.jsx)("div", {
							className: "dc__overflow-auto",
							children: s ? xl.map((e) => /* @__PURE__ */ (0, J.jsxs)("div", {
								className: "display-grid dc__column-gap-16 releases__manage-apps-row fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-16 show-shimmer-loading",
								children: [
									/* @__PURE__ */ (0, J.jsx)("span", { className: "child-shimmer-loading" }),
									/* @__PURE__ */ (0, J.jsx)("span", { className: "child-shimmer-loading" }),
									/* @__PURE__ */ (0, J.jsx)("span", { className: "child-shimmer-loading" })
								]
							}, e.id)) : d.map((e) => /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
								className: "display-grid dc__column-gap-16 releases__manage-apps-row releases__manage-apps-row--header fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-16",
								children: [/* @__PURE__ */ (0, J.jsx)("span", {
									className: "flex",
									children: e.icon
								}), /* @__PURE__ */ (0, J.jsx)("span", {
									className: "dc__truncate cn-7 fs-12 fw-6 dc__uppercase",
									children: e.title
								})]
							}, e.id), e.applications.map((e) => /* @__PURE__ */ (0, J.jsxs)("div", {
								className: "display-grid dc__column-gap-16 releases__manage-apps-row fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-16",
								children: [
									/* @__PURE__ */ (0, J.jsx)(me, { className: "dc__no-shrink icon-dim-24" }),
									/* @__PURE__ */ (0, J.jsxs)(wi, {
										to: q(I.DEVTRON_APP_DETAILS.OVERVIEW, { appId: String(e.appId) }),
										className: `dc__truncate anchor ${e.isDeleted ? "cr-5" : ""}`,
										target: "_blank",
										children: [
											e.name,
											" ",
											e.isRequired && /* @__PURE__ */ (0, J.jsx)(Al, {})
										]
									}),
									e.isDeleted ? /* @__PURE__ */ (0, J.jsxs)("div", {
										className: "flex left dc__gap-8",
										children: [/* @__PURE__ */ (0, J.jsx)("span", {
											className: "cr-5",
											children: "Application not found"
										}), /* @__PURE__ */ (0, J.jsxs)("button", {
											type: "button",
											className: "flex dc__gap-4 left cta text h-20 lh-20-imp",
											onClick: m(e.name),
											children: [/* @__PURE__ */ (0, J.jsx)("span", { children: "Remove application" }), /* @__PURE__ */ (0, J.jsx)(we, { className: "icon-dim-16 scb-5 dc__no-shrink" })]
										})]
									}) : /* @__PURE__ */ (0, J.jsx)("span", {
										className: "dc__truncate",
										children: e.description || "-"
									})
								]
							}, e.name))] }))
						})]
					}),
					/* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox dc__column-gap-8 dc__align-items-center px-16 py-8 dc__border-top-n1",
						children: [/* @__PURE__ */ (0, J.jsx)("div", {
							className: "px-4 flex",
							children: /* @__PURE__ */ (0, J.jsx)(Zo, { className: "dc__no-shrink icon-dim-16 fcn-6" })
						}), /* @__PURE__ */ (0, J.jsxs)("span", {
							className: "dc__truncate fs-12 fw-4 lh-16 cn-8",
							children: [
								"Applications marked with ",
								/* @__PURE__ */ (0, J.jsx)(Al, {}),
								" must be part of releases in '",
								i,
								"'"
							]
						})]
					}),
					!!n && /* @__PURE__ */ (0, J.jsx)(kl, {
						appName: n,
						handleClose: () => {
							r(null);
						},
						handleSuccess: u
					})
				]
			})
		})]
	}), e && /* @__PURE__ */ (0, J.jsx)(hs, {
		handleCloseManageReleaseModal: p,
		handleSuccess: u,
		parentResourceKind: L.releaseTrack,
		resourceName: i,
		resourceId: a
	})] });
}, Ml = (e) => {
	let t = {};
	return e.forEach((e) => e.applications.forEach((n, r) => {
		t[n.name] = {
			releaseOrderIndex: e.id,
			releaseOrderName: e.title,
			applicationIndex: r,
			applicationName: n.name,
			applicationId: n.appId,
			selectedImage: n.selectedImage,
			registryType: n.registryType,
			artifactId: n.artifactId,
			artifactSourceAppWorkflowId: n.artifactSourceAppWorkflowId,
			sourceReleaseConfiguration: n.sourceReleaseConfiguration,
			isRequired: n.isRequired,
			isDeleted: n.isDeleted
		};
	})), t;
}, Nl = (e) => {
	let t = {};
	return e.forEach((e) => e.applications.forEach((e) => {
		t[e.name] = e.isRequired;
	})), t;
}, Pl = (e, t, n) => {
	let { shouldCheckForSelectedImage: r = !0 } = n ?? {};
	return e.length === t.length ? e.some((e, n) => {
		let i = t[n];
		return e.applications.length === i.applications.length ? e.applications.some((e, t) => {
			let n = i.applications[t];
			return e.name !== n.name || e.isRequired !== n.isRequired || r && e.selectedImage !== n.selectedImage;
		}) : !0;
	}) : !0;
}, Fl = (e) => e.reduce((e, t) => e + t.applications.length, 0), Il = ({ releaseOrdering: e, targetReleaseOrderIndex: t, targetApplicationIndex: n, clearReleaseOrdersIfEmpty: r = !1 }) => {
	let i = [...e], a = i[t], o = [...a.applications.filter((e, t) => t !== n)];
	i[t] = {
		...a,
		applications: o
	};
	let s = Fl(i);
	return r && s === 0 ? [] : i;
}, Ll = ({ releaseOrdering: e, applicationName: t, applicationId: n, isRequired: r }) => {
	let i = [...e];
	return i.length > 0 ? [{
		...i[0],
		applications: [...i[0].applications, {
			name: t,
			appId: n,
			isRequired: r,
			isDeleted: null
		}]
	}, ...i.slice(1)] : [{
		id: 0,
		...Hc(0, !0),
		applications: [{
			name: t,
			appId: n,
			isRequired: r,
			isDeleted: null
		}]
	}];
}, Rl = (e) => {
	let t = [...e], n = t.length - 1;
	t[n] = {
		...t[n],
		...Hc(n, !1)
	};
	let r = {
		id: n + 1,
		applications: [],
		...Hc(n + 1, !0)
	};
	return [...t, r];
}, zl = (e) => e.map((t, n) => ({
	...Hc(n, n === e.length - 1),
	id: n,
	applications: t.applications
})), Bl = (e, t) => {
	let n = [...e], r = n[t].applications, i = n[t - 1];
	return n[t - 1] = {
		...i,
		applications: [...i.applications, ...r]
	}, zl(n.filter((e, n) => n !== t));
}, Vl = (e, t, n, r) => {
	let i = [...e], a = i[t], o = [...a?.applications ?? []];
	return i[t] = {
		...a,
		applications: [
			...o.slice(0, n),
			r,
			...o.slice(n)
		]
	}, i;
}, Hl = (e, t, n, r) => {
	let i = [...e], a = i[t], o = [...a.applications];
	return i[t] = {
		...a,
		applications: [
			...o.slice(0, n),
			r,
			...o.slice(n + 1)
		]
	}, i;
}, Ul = (e, t) => {
	let n = [], r = 1;
	return e.forEach((e) => {
		let { applications: i } = e, a = r;
		r += 1, i.length && (n.push({
			index: a,
			isLevelPropagatedFromParent: t,
			typeOfDependency: Ys.RELEASE_STAGE
		}), i.forEach((e) => {
			let { name: t, isRequired: i } = e;
			n.push({
				identifier: t,
				index: r,
				dependentOnIndexes: [a],
				typeOfDependency: Ys.APPLICATION,
				resourceKind: L.devtronApplication,
				resourceVersion: R.v1,
				toPropagateOnChild: i ?? !1
			}), r += 1;
		}));
	}), n;
}, Wl = (e) => e ? e.map((e) => ({
	label: `${e.projectName} ${Qo.GROUP_HEADING_SUFFIX}`,
	options: e.appList.map((e) => ({
		label: e.name,
		value: e.id,
		isRequired: e.toPropagateOnChild ?? !1
	})).sort((e, t) => G(e.label, t.label, Fn.ASC))
})).sort((e, t) => G(e.label, t.label, Fn.ASC)) : [], Gl = (e, t) => t?.length ? t.reduce((t, n) => {
	let r = n.options.filter((t) => e[t.label]);
	return [...t, ...r];
}, []) : [], Kl = (e) => /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [
	e.label,
	" ",
	e.isRequired && /* @__PURE__ */ (0, J.jsx)(Al, {})
] }), ql = async ({ id: e, releaseTrack: t, releaseVersion: n }) => {
	let r = e ? { id: e } : { identifier: `${t}-${n}` };
	try {
		let { result: e } = await H(Ic({
			baseUrl: _.RESOURCE,
			kind: Ks.RELEASE,
			payload: r
		}));
		return Rc(e);
	} catch (e) {
		throw W(e), e;
	}
}, Jl = async ({ id: e, name: t, description: n, version: r, tags: i, track: a, cloneSourceId: o }) => {
	let s = Ic({
		baseUrl: o ? _.RESOURCE_CLONE : _.RESOURCE,
		kind: Ks.RELEASE
	}), c = i.reduce((e, t) => (e[t.label] = {
		label: t.label,
		value: t.value
	}, e), {});
	return Gr(s, {
		id: e,
		name: t,
		parentConfig: {
			resourceKind: Ks.RELEASE_TRACK,
			resourceVersion: qs.ALPHA_1,
			identifier: a
		},
		overview: {
			description: n.trim(),
			releaseVersion: r,
			tags: c
		},
		...o ? { cloneFrom: { id: +o } } : {}
	});
}, Yl = async (e) => ti(Ic({
	baseUrl: _.RESOURCE,
	kind: Ks.RELEASE,
	payload: { id: e }
})), Xl = (e) => Wr(Ic({
	baseUrl: _.RESOURCE,
	kind: Ks.RELEASE
}), e), Zl = ({ id: e, description: t }) => Xl({
	id: e,
	query: [{
		op: hn.replace,
		path: "description",
		value: t
	}]
}), Ql = ({ id: e, name: t, description: n }) => Xl({
	id: e,
	query: [{
		op: hn.replace,
		path: "name",
		value: t
	}, {
		op: hn.replace,
		path: "description",
		value: n
	}]
}), $l = ({ id: e, status: t, comment: n }) => Xl({
	id: e,
	query: [{
		op: hn.replace,
		path: "status",
		value: {
			status: t,
			comment: n?.trim() ?? ""
		}
	}]
}), eu = ({ id: e, releaseNote: t }) => Xl({
	id: e,
	query: [{
		op: hn.replace,
		path: "note",
		value: t
	}]
}), tu = ({ id: e, isLocked: t }) => Xl({
	id: e,
	query: [{
		op: hn.replace,
		path: "lock",
		value: t
	}]
}), nu = async (e, t) => {
	try {
		let n = t === L.releaseTrack, { result: r } = await H(Ic({
			baseUrl: _.RESOURCE_DEPENDENCIES,
			kind: n ? Ks.RELEASE_TRACK : Ks.RELEASE,
			payload: {
				id: e,
				lite: n
			}
		})), i = r?.isDepsPresentOnParent ?? !1;
		if (!r?.dependencies?.length) return {
			isReleaseOrderActive: !0,
			isDepsPresentOnParent: i,
			applicationCount: 0,
			releaseOrdering: [],
			unmappedEnvironments: [],
			tenantInstallationDetailsMap: {},
			releaseChannelToTenantInstallationMap: {},
			tenantInstallationsNotSubscribedToReleaseChannel: /* @__PURE__ */ new Set()
		};
		let a = r.dependencies.filter((e) => e.typeOfDependency === Ys.APPLICATION).length, o = r.dependencies.reduce((e, t) => {
			if (t.typeOfDependency === Ys.RELEASE_STAGE) {
				let { index: n } = t;
				e[n] = {
					index: n,
					isReleaseOrderActive: t.isLevelPropagatedFromParent ?? !1,
					applications: []
				};
			}
			return e;
		}, {});
		r.dependencies.forEach((e) => {
			if (e.typeOfDependency === Ys.APPLICATION) {
				let { dependentOnIndexes: t } = e;
				o[t[0]] && o[t[0]].applications.push(e);
			}
		});
		let s = Object.values(o).filter((e) => e.applications.length).sort((e, t) => Ur(e.index, t.index)).map((e) => ({
			...e,
			applications: e.applications.sort((e, t) => Ur(e.index, t.index))
		})), c = s.length, l = s[0]?.isReleaseOrderActive ?? !1, u = s.flatMap((e) => e.applications);
		return {
			applicationCount: a,
			releaseOrdering: s.map((e, t) => ({
				id: t,
				...Hc(t, t === c - 1),
				applications: e.applications.map((e) => ({
					name: e.identifier ?? "-",
					appId: e.id,
					selectedImage: e.config?.artifactConfig?.image ?? "",
					registryType: e.config?.artifactConfig?.registryType || wn.OTHER,
					artifactId: e.config?.artifactConfig?.artifactId,
					artifactSourceAppWorkflowId: e.config?.artifactConfig?.artifactSourceAppWorkflowId,
					sourceReleaseConfiguration: e.config?.artifactConfig?.sourceReleaseConfiguration,
					isRequired: e.toPropagateOnChild ?? !1,
					description: e.metadata?.appDescription ?? "",
					isDeleted: e.deleted ?? !1
				}))
			})),
			isReleaseOrderActive: l,
			isDepsPresentOnParent: i,
			...qc(u)
		};
	} catch (e) {
		throw W(e), e;
	}
}, ru = (e, t, n, r) => Yr(Ic({
	baseUrl: _.RESOURCE_DEPENDENCIES,
	kind: t === L.releaseTrack ? Ks.RELEASE_TRACK : Ks.RELEASE
}), {
	id: e,
	dependencies: Ul(n, r)
}), iu = async (e, t) => {
	let { result: n } = await H(Ic({
		baseUrl: _.RESOURCE_DEPENDENCIES,
		kind: Ks.RELEASE,
		payload: {
			id: e,
			dependencyInfo: `${L.devtronApplication}|${R.v1}|identifier|${t}`
		}
	})), r = n?.dependencies?.[0];
	if (!r) throw new Mn({
		code: Le.NOT_FOUND,
		errors: []
	});
	return Kc(r);
}, au = (e) => Wr(Ic({
	baseUrl: _.RESOURCE_DEPENDENCIES,
	kind: Ks.RELEASE
}), e), ou = ({ id: e, appName: t }) => au({
	id: e,
	dependencyPatch: [{
		dependencyInfo: Uc(t),
		query: [{
			op: hn.remove,
			path: "application"
		}]
	}]
}), su = ({ id: e, appName: t, releaseInstructions: n }) => au({
	id: e,
	dependencyPatch: [{
		dependencyInfo: Uc(t),
		query: [{
			op: hn.replace,
			path: "releaseInstruction",
			value: n
		}]
	}]
}), cu = ({ id: e, appName: t, artifactId: n, registryName: r, registryType: i, artifactSourceAppWorkflowId: a, sourceReleaseConfiguration: o }) => au({
	id: e,
	dependencyPatch: [ul({
		appName: t,
		artifactId: n,
		registryName: r,
		registryType: i,
		artifactSourceAppWorkflowId: a,
		sourceReleaseConfiguration: o
	})]
}), lu = async (e, t, n) => au(dl(e, t, n)), uu = async (e, t) => {
	try {
		let { result: n } = await H(`${_.APP_APP_WF_LIST_COMPONENTS}/${e}`, { signal: t });
		return cl(n);
	} catch (e) {
		throw yr(e) || W(e), e;
	}
}, du = async ({ releaseId: e, applicationName: t, searchInput: n, searchType: r, workflowId: i, trackName: a, offset: o = 0, signal: s }) => {
	try {
		let c = t === "*" ? "*" : `identifier|${t}`, { result: l } = await H(Ic({
			baseUrl: _.RESOURCE_DEPENDENCIES_CONFIG_OPTIONS,
			kind: Ks.RELEASE,
			payload: {
				id: e,
				dependencyInfo: `${L.devtronApplication}|${R.v1}|${c}`,
				configOption: Zs.ARTIFACT,
				searchKey: n ? `${r}|${n}` : null,
				filterCriteria: gl(a, i),
				offset: o
			}
		}), { signal: s });
		return l ? fl(l, o) : {
			applicationsToArtifactsMap: {},
			appNameToIdMap: {}
		};
	} catch (e) {
		throw yr(e) || W(e), e;
	}
}, fu = async ({ lite: e = !1, fetchChild: t = !1 }) => {
	try {
		let { result: { data: n } } = await H(Ic({
			baseUrl: _.RESOURCE_LIST,
			kind: Ks.RELEASE_TRACK,
			payload: {
				lite: e,
				fetchChild: t
			}
		}));
		return Vc(n);
	} catch (e) {
		throw W(e), e;
	}
}, pu = async () => (await fu({
	lite: !0,
	fetchChild: !1
})).map((e) => e.name), mu = async (e) => {
	try {
		if (!e || Number.isNaN(+e)) throw Error("Invalid release track id");
		let { result: t } = await H(Ic({
			baseUrl: _.RESOURCE,
			kind: Ks.RELEASE_TRACK,
			payload: { id: +e }
		}));
		return Bc(t);
	} catch (e) {
		throw W(e), e;
	}
}, hu = async (e, t) => {
	let n = Ic({
		baseUrl: _.RESOURCE,
		kind: Ks.RELEASE_TRACK
	}), { id: r, name: i, description: a } = e, o = a.trim();
	return t ? Wr(n, {
		id: r,
		query: [{
			op: hn.replace,
			path: "description",
			value: o
		}]
	}) : Gr(n, {
		id: r,
		name: i,
		overview: { description: o }
	});
}, gu = async (e) => ti(Ic({
	baseUrl: _.RESOURCE,
	kind: Ks.RELEASE_TRACK,
	payload: { id: e }
})), _u = async ({ trackName: e, signal: t }) => {
	let { result: n } = await H(Ic({
		baseUrl: _.RESOURCE_LIST,
		kind: Ks.RELEASE,
		payload: {
			filterCriteria: [`${Ks.RELEASE_TRACK}|identifier|${e}`],
			lite: !0
		}
	}), { signal: t });
	return n?.data ? zc(n.data).map(({ name: e, version: t, status: n, id: r }) => ({
		name: e,
		version: t,
		status: n,
		id: r
	})) : [];
}, vu = async ({ releaseId: e }) => {
	let { result: t } = await Gr(Ic({
		baseUrl: _.RESOURCE_TASKS_INFO,
		kind: Ks.RELEASE,
		payload: {
			id: e,
			lite: !1,
			fetchWithUnmappedData: !0
		}
	}), {});
	return Jc(t?.data);
}, yu = async ({ releaseId: e }) => {
	let { result: t } = await Gr(Ic({
		baseUrl: _.RESOURCE_TASKS_INFO,
		kind: Ks.RELEASE,
		payload: {
			id: e,
			lite: !1,
			fetchWithUnmappedData: !1
		}
	}), {});
	return Jc(t?.data);
}, bu = async ({ releaseId: e }) => {
	let [t, n] = await Promise.allSettled([vu({ releaseId: e }), yu({ releaseId: e })]);
	if (n.status === "rejected") throw n.reason;
	return {
		...n.value,
		unmappedEnvironments: t.status === "fulfilled" ? t.value.unmappedEnvironments : []
	};
}, xu = async ({ releaseId: e, filterConfig: t }, n) => {
	try {
		let { result: r } = await Gr(Ic({
			baseUrl: _.RESOURCE_TASKS_INFO,
			kind: Ks.RELEASE,
			payload: {
				id: e,
				lite: !1
			}
		}), hl(t), { signal: n });
		return Zc(r?.data, r?.count);
	} catch (e) {
		throw yr(e) || W(e), e;
	}
}, Su = async ({ releaseId: e, stageId: t, filterConfig: n }, r) => {
	try {
		let i = await Gr(Ic({
			baseUrl: _.RESOURCE_TASKS_INFO,
			kind: Ks.RELEASE,
			payload: {
				id: e,
				lite: !1,
				levelIndex: t
			}
		}), hl(n), { signal: r });
		return {
			...i,
			result: Qc(i?.result?.data?.[0]?.dependencies)
		};
	} catch (e) {
		throw yr(e) || W(e), e;
	}
}, Cu = async ({ id: e, bulkSelectionState: t, stage: n }) => {
	try {
		let r = await Gr(Ic({
			baseUrl: _.RESOURCE_TASKS_EXECUTE,
			kind: Ks.RELEASE
		}), {
			id: e,
			tasks: sl(t, n),
			dryRun: !0,
			taskType: Qs.nonBundled
		});
		return {
			...r,
			result: el(r?.result)
		};
	} catch (e) {
		throw W(e), e;
	}
}, wu = async ({ id: e, bulkSelectionState: t }) => {
	try {
		return nl((await Gr(Ic({
			baseUrl: _.RESOURCE_TASKS_EXECUTE,
			kind: Ks.RELEASE
		}), {
			id: e,
			tasks: Object.values(t),
			taskType: Qs.bundled,
			dryRun: !0
		}))?.result);
	} catch (e) {
		throw W(e), e;
	}
}, Tu = async ({ id: e, bulkSelectionState: t, stage: n }) => {
	try {
		let r = await Gr(Ic({
			baseUrl: _.RESOURCE_TASKS_EXECUTE,
			kind: Ks.RELEASE
		}), {
			id: e,
			tasks: sl(t, n),
			dryRun: !1,
			taskType: Qs.nonBundled
		});
		return {
			...r,
			result: al(r?.result)
		};
	} catch (e) {
		throw W(e), e;
	}
}, Eu = async ({ id: e, bulkSelectionState: t }) => {
	try {
		return ol((await Gr(Ic({
			baseUrl: _.RESOURCE_TASKS_EXECUTE,
			kind: Ks.RELEASE
		}), {
			id: e,
			taskType: Qs.bundled,
			tasks: Object.values(t),
			dryRun: !1
		}, { timeout: window._env_.CONFIGURABLE_TIMEOUT ? parseInt(window._env_.CONFIGURABLE_TIMEOUT, 10) : null }))?.result);
	} catch (e) {
		throw W(e), e;
	}
}, Du = async ({ releaseId: e, filterConfig: t }, n) => {
	try {
		let { result: r } = await Gr(Ic({
			baseUrl: _.RESOURCE_TASKS_INFO,
			kind: Ks.RELEASE,
			payload: {
				id: e,
				lite: !1,
				showAll: !0
			}
		}), hl({
			...t,
			preStage: [],
			deployStage: [],
			postStage: []
		}), { signal: n });
		return ml(r?.data?.[0]?.dependencies, r?.count);
	} catch (e) {
		throw yr(e) || W(e), e;
	}
}, Ou = async (e, t) => {
	let n = Ic({
		baseUrl: _.RESOURCE_DEPENDENCIES,
		kind: Ks.RELEASE,
		payload: {
			id: e,
			dependencyInfo: `${L.devtronApplication}|${R.v1}|id|${t}`
		}
	});
	try {
		let { result: e } = await H(n);
		return Wc(e?.dependencies?.[0]?.childObjects?.[0].data ?? []);
	} catch (e) {
		throw W(e), e;
	}
}, ku = async (e) => {
	let t = Ic({
		baseUrl: _.RESOURCE_DEPENDENCIES,
		kind: Ks.RELEASE,
		payload: { id: e }
	});
	try {
		let { result: e } = await H(t);
		return (e?.dependencies ?? []).filter((e) => e.resourceKind === L.devtronApplication).sort((e, t) => G(e.identifier, t.identifier)).map((e) => ({
			value: e.id,
			label: e.identifier
		}));
	} catch (e) {
		throw W(e), e;
	}
}, Au = async (e) => {
	try {
		let { result: { name: t } } = await Fr(JSON.parse(e)?.eventId);
		return t;
	} catch (e) {
		throw W(e), e;
	}
}, ju = async (e) => {
	try {
		let { result: t } = await H(Ic({
			baseUrl: _.RESOURCE_SUMMARY,
			kind: Ks.RELEASE,
			payload: { id: e }
		}));
		return _l(t);
	} catch (e) {
		throw W(e), e;
	}
}, Mu = async (e) => {
	try {
		let { result: t } = await H(Ic({
			baseUrl: _.RESOURCE_DEPENDENCIES_OFFENDING,
			kind: Ks.RELEASE,
			payload: { id: e }
		}));
		return vl(t?.depStateStatus);
	} catch (e) {
		throw W(e), e;
	}
}, Nu = async (e, t) => au(yl(e, t)), Pu = je(null), Fu = ({ value: e, children: t }) => {
	let [n, r] = A(), i = k(() => ({
		...e,
		newReleaseStatus: n,
		setNewReleaseStatus: r
	}), [e, n]);
	return O(() => {
		r(null);
	}, [e.status]), /* @__PURE__ */ (0, J.jsx)(Pu.Provider, {
		value: i,
		children: t
	});
}, Q = () => {
	let e = Ne(Pu);
	if (!e) throw Error("Wrap with ReleaseDetailProvider");
	return e;
}, Iu = je(null), Lu = ({ children: e }) => {
	let { id: t } = Q(), { appId: n } = Ai(), [r, i] = K(() => ku(t), [t]), [a, o, , s] = K(() => Promise.allSettled([Ou(t, +n), By(+n)]), [n], !!n && !Number.isNaN(+n), { resetOnChange: !1 }), { environments: c, envIdToEnvApprovalConfigurationMap: l } = k(() => {
		if (o && o[0].status === "fulfilled" && o[1].status === "fulfilled" && o[0].value && o[1].value) {
			let [{ value: e }, { value: t }] = o;
			return {
				environments: e.map(({ id: e, name: t }) => ({
					id: e,
					name: t
				})),
				envIdToEnvApprovalConfigurationMap: t
			};
		}
		return {
			environments: [],
			envIdToEnvApprovalConfigurationMap: { [Ke]: null }
		};
	}, [o]), u = k(() => ({
		isAppListLoading: r,
		applications: i,
		environments: c,
		isEnvListLoading: a,
		reloadEnvironments: s,
		envIdToEnvApprovalConfigurationMap: l
	}), [
		c,
		i,
		a,
		r,
		l
	]);
	return /* @__PURE__ */ (0, J.jsx)(Iu.Provider, {
		value: u,
		children: e
	});
}, Ru = () => {
	let e = Ne(Iu);
	if (!e) throw Error("ReleaseConfigurationContext cannot be used outside Release Configuration scope");
	return e;
}, zu = () => {
	let { ReleaseConfigurations: e } = Lo();
	return /* @__PURE__ */ (0, J.jsx)(Lu, { children: /* @__PURE__ */ (0, J.jsx)(e, {}) });
}, Bu = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M8.75 3.75H3.75V8.75H8.75V3.75Z",
			stroke: "#596168",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M16.25 3.75H11.25V8.75H16.25V3.75Z",
			stroke: "#596168",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M8.75 11.25H3.75V16.25H8.75V11.25Z",
			stroke: "#596168",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M16.25 11.25H11.25V16.25H16.25V11.25Z",
			stroke: "#596168",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
}), Vu = ({ applicationsConfig: e, environmentsConfig: t }) => {
	let { appId: n, isLoading: r, onChange: i, options: a } = e, { envId: o, isLoading: s, onChange: c, options: l } = t;
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col dc__gap-4",
		children: [/* @__PURE__ */ (0, J.jsx)(jn, {
			inputId: "release-configuration-app-selector",
			classNamePrefix: "release-configuration-app-selector",
			icon: /* @__PURE__ */ (0, J.jsx)(Bu, { className: "scb-5" }),
			placeholder: "Select Application",
			isLoading: r,
			isDisabled: r || s,
			options: [{
				label: "Applications",
				options: a
			}],
			value: Or(a, n, null),
			onChange: i
		}), /* @__PURE__ */ (0, J.jsx)(Kn, {
			alwaysShowTippyOnHover: !n,
			content: "Select an application first",
			placement: "right",
			children: /* @__PURE__ */ (0, J.jsx)("div", { children: /* @__PURE__ */ (0, J.jsx)(jn, {
				inputId: "release-configuration-env-selector",
				classNamePrefix: "release-configuration-env-selector",
				icon: /* @__PURE__ */ (0, J.jsx)(Mo, {}),
				placeholder: "Select Environment",
				isLoading: s,
				isDisabled: s || !n,
				showSelectedOptionIcon: !1,
				options: [{
					label: "Environments",
					options: l
				}],
				value: Or(l, o, null),
				onChange: c
			}) })
		})]
	});
}, Hu = () => {
	let e = ki(), { appId: t, envId: n, releaseTrack: r, releaseVersion: i } = Ai(), { pathname: a } = Oi(), { applications: o, environments: s, isAppListLoading: c, isEnvListLoading: l } = Ru(), u = k(() => (s ?? []).map(({ id: e, name: t }) => ({
		label: t,
		value: e
	})), [s]), d = (n = "push") => ({ value: a }) => {
		+t !== a && e(q(I.RELEASES.DETAIL.CONFIGURATIONS, {
			releaseTrack: r,
			releaseVersion: i,
			appId: String(a),
			envId: null
		}), { replace: n === "replace" });
	}, f = (o = "push") => ({ value: s }) => {
		if (+n === s) return;
		let [c, l] = a.split(`/${t}/${n}/`)[1]?.split("/") ?? [], u = c ? `/${c}` : "", d = `${l ? `/${l}` : ""}`;
		e(`${q(I.RELEASES.DETAIL.CONFIGURATIONS, {
			releaseTrack: r,
			releaseVersion: i,
			appId: t,
			envId: String(s)
		})}${u}${d}`, { replace: o === "replace" });
	};
	return O(() => {
		c || (o.length === 1 && (!t || !Or(o, +t, null)) ? d("replace")(o[0]) : o.length && !Or(o, +t, null) && e(q(I.RELEASES.DETAIL.CONFIGURATIONS, {
			releaseTrack: r,
			releaseVersion: i,
			appId: null,
			envId: null
		}), { replace: !0 }));
	}, [
		t,
		o,
		c
	]), O(() => {
		t && !l && u.length && !Or(u, +n, null) && f("replace")(u[0]);
	}, [
		n,
		u,
		l,
		t
	]), /* @__PURE__ */ (0, J.jsx)("div", {
		className: "p-12 dc__border-bottom-n1",
		children: /* @__PURE__ */ (0, J.jsx)(Vu, {
			applicationsConfig: {
				appId: t ? +t : null,
				isLoading: c,
				onChange: d(),
				options: o
			},
			environmentsConfig: {
				envId: n ? +n : null,
				isLoading: l,
				onChange: f(),
				options: u
			}
		})
	});
}, Uu = /* @__PURE__ */ function(e) {
	return e.releaseChannelId = "releaseChannelId", e;
}({}), Wu = {
	label: "Not subscribed",
	value: "Not Subscribed"
}, Gu = { [Uu.releaseChannelId]: "Release Channel" }, Ku = (e) => /* @__PURE__ */ (0, J.jsx)(Kn, {
	content: "Exception user at the time of deployment",
	alwaysShowTippyOnHover: !0,
	children: /* @__PURE__ */ (0, J.jsx)("span", {
		className: "flex left cursor",
		children: e
	})
}), qu = [
	zn.DEPLOYMENT_INITIATED,
	zn.HELM_PACKAGE_GENERATED,
	zn.HELM_MANIFEST_PUSHED_TO_HELM_REPO
], Ju = (e) => (t) => {
	switch (e) {
		case t.status: return !0;
		case zn.HELM_PACKAGE_GENERATED: return t.status === zn.HELM_PACKAGE_GENERATION_FAILED;
		case zn.HELM_MANIFEST_PUSHED_TO_HELM_REPO: return t.status === zn.HELM_MANIFEST_PUSHED_TO_HELM_REPO_FAILED;
		default: return !1;
	}
}, Yu = (e) => {
	let t = {
		displaySubText: "",
		time: "",
		isCollapsed: !0,
		icon: "",
		timelineStatus: ""
	};
	return {
		deploymentAppType: e?.deploymentAppType,
		deploymentStatus: er[e?.wfrStatus] || gt.INPROGRESS,
		deploymentTriggerTime: e?.deploymentStartedOn || "",
		deploymentEndTime: e?.deploymentFinishedOn || "",
		triggeredBy: e?.triggeredBy || "",
		deploymentStatusBreakdown: {
			[zn.DEPLOYMENT_INITIATED]: {
				...t,
				icon: "success",
				displayText: /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)("span", { children: "Deployment initiated" }), !!e?.triggeredBy && /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)("span", { children: "\xA0by\xA0" }), /* @__PURE__ */ (0, J.jsxs)(lt, {
					condition: e.isDeploymentWithoutApproval,
					wrap: Ku,
					children: [e.isDeploymentWithoutApproval && /* @__PURE__ */ (0, J.jsx)(Yt, {
						name: "ic-lightning-fill",
						color: "Y500"
					}), e.triggeredBy]
				})] })] })
			},
			[zn.HELM_PACKAGE_GENERATED]: {
				...t,
				displayText: "Generate helm chart package"
			},
			[zn.HELM_MANIFEST_PUSHED_TO_HELM_REPO]: {
				...t,
				displayText: "Push package to repository",
				showHelmManifest: !1
			}
		}
	};
}, Xu = (e) => {
	let t = Yu(e);
	return e?.timelines?.length && qu.forEach((n) => {
		let r = ur(e.timelines, Ju(n)), i = t.deploymentStatusBreakdown[n];
		if (r) switch (i.time = r.statusTime, n) {
			case zn.HELM_PACKAGE_GENERATED:
				i.icon = r.status === zn.HELM_PACKAGE_GENERATION_FAILED ? "failed" : "success";
				break;
			case zn.HELM_MANIFEST_PUSHED_TO_HELM_REPO: {
				let e = r.status === zn.HELM_MANIFEST_PUSHED_TO_HELM_REPO_FAILED;
				i.showHelmManifest = !0, i.icon = e ? "failed" : "success", e && (i.displaySubText = "Failed", i.isCollapsed = !1, i.timelineStatus = /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col dc__gap-4",
					children: [/* @__PURE__ */ (0, J.jsx)("span", {
						className: "dc__word-break lh-20",
						children: r.statusDetail
					}), /* @__PURE__ */ (0, J.jsxs)("ol", {
						className: "m-0 pl-20",
						children: [/* @__PURE__ */ (0, J.jsx)("li", { children: "Ensure provided repository path is valid" }), /* @__PURE__ */ (0, J.jsx)("li", { children: "Check if credentials provided for OCI registry are valid and have PUSH permission" })]
					})]
				}));
				break;
			}
			default: break;
		}
	}), t;
}, Zu = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M8 1.99976V11.4998M8 11.4998L3.5 6.99975M8 11.4998L12.5 6.99975M2.5 13.4998H13.5",
		stroke: "#0066CC",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qu = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M3.69231 19.5L3.69011 20.25H3.69231V19.5ZM3 18.8077H2.25L2.25 18.8099L3 18.8077ZM21 18.8333H21.75H21ZM3.75 4.5V5.25V4.5ZM8.68934 4.5V5.25V4.5ZM9.21967 4.71967L8.68934 5.25L8.68934 5.25L9.21967 4.71967ZM11.4697 8.03033C11.7626 8.32322 12.2374 8.32322 12.5303 8.03033C12.8232 7.73744 12.8232 7.26256 12.5303 6.96967L11.4697 8.03033ZM14 8.5C13.5858 8.5 13.25 8.83579 13.25 9.25C13.25 9.66421 13.5858 10 14 10V8.5ZM15.5 10H16.25V8.5H15.5V10ZM14 16.5C13.5858 16.5 13.25 16.8358 13.25 17.25C13.25 17.6642 13.5858 18 14 18V16.5ZM15.5 18H16.25V16.5H15.5V18ZM14 12.5C13.5858 12.5 13.25 12.8358 13.25 13.25C13.25 13.6642 13.5858 14 14 14V12.5ZM15.5 14H16.25V12.5H15.5V14ZM16 10.5H15.25V12H16V10.5ZM17.5 12C17.9142 12 18.25 11.6642 18.25 11.25C18.25 10.8358 17.9142 10.5 17.5 10.5V12ZM16 14.5H15.25V16H16V14.5ZM17.5 16C17.9142 16 18.25 15.6642 18.25 15.25C18.25 14.8358 17.9142 14.5 17.5 14.5V16ZM16.5 8.75V8H15V8.75H16.5ZM15 18.25V19H16.5V18.25H15ZM20.3333 18.75H3.69231V20.25H20.3333V18.75ZM3.6945 18.75C3.70921 18.75 3.7233 18.7559 3.7337 18.7663L2.67304 19.827C2.94287 20.0968 3.30852 20.2489 3.69011 20.25L3.6945 18.75ZM3.7337 18.7663C3.74409 18.7767 3.74995 18.7908 3.75 18.8055L2.25 18.8099C2.25112 19.1915 2.4032 19.5571 2.67304 19.827L3.7337 18.7663ZM3.75 18.8077V7.5H2.25V18.8077H3.75ZM3 8.25H20.25V6.75H3V8.25ZM20.25 8.25V8.25L21.3107 7.18934C21.0294 6.90804 20.6478 6.75 20.25 6.75V8.25ZM20.25 8.25V8.25H21.75C21.75 7.85218 21.592 7.47065 21.3107 7.18934L20.25 8.25ZM20.25 8.25V18.8333H21.75V8.25H20.25ZM20.25 18.8333C20.25 18.8112 20.2588 18.79 20.2744 18.7744L21.3351 19.8351C21.6007 19.5694 21.75 19.2091 21.75 18.8333H20.25ZM20.2744 18.7744C20.29 18.7588 20.3112 18.75 20.3333 18.75V20.25C20.7091 20.25 21.0694 20.1007 21.3351 19.8351L20.2744 18.7744ZM3.75 7.5V5.25H2.25V7.5H3.75ZM3.75 5.25L3.75 5.25L2.68934 4.18934C2.40804 4.47064 2.25 4.85217 2.25 5.25H3.75ZM3.75 5.25L3.75 5.25V3.75C3.35217 3.75 2.97064 3.90804 2.68934 4.18934L3.75 5.25ZM3.75 5.25H8.68934V3.75H3.75V5.25ZM8.68934 5.25L8.68934 5.25L9.26337 3.86418C9.08138 3.7888 8.88632 3.75 8.68934 3.75V5.25ZM8.68934 5.25L8.68934 5.25L9.75 4.18934C9.61071 4.05005 9.44536 3.93956 9.26337 3.86418L8.68934 5.25ZM8.68934 5.25L11.4697 8.03033L12.5303 6.96967L9.75 4.18934L8.68934 5.25ZM14 10H15.5V8.5H14V10ZM14 18H15.5V16.5H14V18ZM14 14H15.5V12.5H14V14ZM16 12H17.5V10.5H16V12ZM16 16H17.5V14.5H16V16ZM15 8.75V18.25H16.5V8.75H15Z",
		fill: "#0066CC"
	})
}), $u = /* @__PURE__ */ t({ default: () => ed }), ed = ({ titleName: e, status: t, params: n }) => {
	let { isDownloading: r, handleDownload: i } = oi();
	return /* @__PURE__ */ (0, J.jsx)("div", {
		className: "h-100 dc__position-rel p-20",
		children: t.toLowerCase() === gt.FAILED ? /* @__PURE__ */ (0, J.jsx)(F, {
			title: S.NO_ARTIFACTS_TITLE,
			subTitle: S.NO_ARTIFACT_SUBTITLE
		}) : t.toLowerCase() === gt.PROGRESSING || t.toLowerCase() === gt.INPROGRESS ? /* @__PURE__ */ (0, J.jsx)(F, {
			imgName: "img-mechanical-operation",
			title: S.PIPELINE_PROGRESS_TITLE,
			subTitle: S.PIPELINE_PROGRESS_SUBTITLE
		}) : /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "dc__border p-16 flex left bg__primary w-100 dc__mxw-800 br-4",
			"data-testid": "hover-on-virtual-artifact",
			children: [
				/* @__PURE__ */ (0, J.jsx)("div", {
					className: "bcn-1 br-4 h-40 w-40 flex icon-dim-40",
					children: /* @__PURE__ */ (0, J.jsx)(Qu, { className: "icon-dim-24" })
				}),
				/* @__PURE__ */ (0, J.jsx)("div", {
					className: "fs-13 fw-4 ml-12",
					children: e
				}),
				r ? /* @__PURE__ */ (0, J.jsx)("span", {
					className: "dc__align-right",
					children: /* @__PURE__ */ (0, J.jsx)(_n, { size: 16 })
				}) : /* @__PURE__ */ (0, J.jsx)(Zu, {
					className: "icon-dim-16 dc__align-right cursor",
					"data-testid": "virtual-artifact-download-button",
					onClick: async () => {
						e || Vr(/* @__PURE__ */ Error("Cannot find helm package name in history artifact"));
						let t = e || "helm-package";
						await i({
							downloadUrl: y(n),
							fileName: t,
							downloadSuccessToastContent: "Manifest Downloaded Successfully"
						});
					}
				})
			]
		})
	});
}, td = {
	offset: 0,
	size: 20
}, nd = () => {
	let { appId: e, envId: t, pipelineId: n, triggerId: r, releaseTrack: i, releaseVersion: a } = Ai();
	return {
		appId: e ? Number(e) : null,
		envId: t ? Number(t) : null,
		pipelineId: n ? Number(n) : null,
		triggerId: r ? Number(r) : null,
		releaseTrack: i,
		releaseVersion: a
	};
}, rd = ({ appOptions: e, envOptions: t, envOptionsLoading: n }) => {
	let r = ki(), { appId: i, envId: a, ...o } = nd();
	return /* @__PURE__ */ (0, J.jsx)(Vu, {
		applicationsConfig: {
			appId: i ? +i : null,
			isLoading: !1,
			onChange: (e) => {
				i && i === Number(e.value) || r(q(I.RELEASES.DETAIL.HISTORY, {
					...o,
					appId: String(e.value),
					envId: a ? String(a) : null,
					triggerId: null,
					pipelineId: null
				}), { replace: !0 });
			},
			options: e
		},
		environmentsConfig: {
			options: t,
			envId: a ? +a : null,
			isLoading: n,
			onChange: (e) => {
				a && a === Number(e.value) || r(q(I.RELEASES.DETAIL.HISTORY, {
					...o,
					appId: String(i),
					envId: String(e.value),
					pipelineId: String(e.pipelineId),
					triggerId: null
				}), { replace: !0 });
			}
		}
	});
}, id = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M20 7.66663L7.10144 14.9275V28.7924C7.10144 29.1525 7.29502 29.4847 7.60826 29.6623L20 36.6875V7.66663Z",
			fill: "#376CFB"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M20.0015 7.66663L32.9 14.9275V28.7924C32.9 29.1525 32.7064 29.4847 32.3932 29.6623L20.0015 36.6875V7.66663Z",
			fill: "#275ED8"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M15.6397 26.1201C16.059 26.3533 16.5849 26.2558 16.8927 25.8879L20 22.1741L7.10137 14.9277L4.13961 18.3451C3.72388 18.8248 3.8545 19.5655 4.40925 19.874L15.6397 26.1201Z",
			fill: "#4294FF"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M24.5991 26.1244C24.1902 26.3565 23.6748 26.2724 23.3609 25.9223L20 22.1741L32.8985 14.9277L35.8674 18.3533C36.2808 18.8303 36.1543 19.5664 35.6053 19.8779L24.5991 26.1244Z",
			fill: "#4294FF"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M15.5218 3.73238C15.9352 3.5001 16.455 3.59018 16.7662 3.94804L19.9999 7.66683L7.10137 14.9277L4.13609 11.5062C3.72151 11.0279 3.85009 10.2895 4.40199 9.97946L15.5218 3.73238Z",
			fill: "#4294FF"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M24.4781 3.73238C24.0647 3.5001 23.5449 3.59017 23.2337 3.94804L20 7.66683L32.8986 14.9277L35.8638 11.5062C36.2784 11.0279 36.1498 10.2895 35.5979 9.97946L24.4781 3.73238Z",
			fill: "#4294FF"
		})
	]
}), ad = /* @__PURE__ */ t({ default: () => od });
function od({ userApprovalMetadata: e }) {
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "deployment-approval-container pl-20 pr-20 pt-20",
		children: [
			/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "deployment-status-breakdown-row pt-8 pb-8 pl-8 pr-8 bg__primary bw-1 border-collapse en-2",
				children: [/* @__PURE__ */ (0, J.jsx)(p, { className: "icon-dim-20 green-tick" }), /* @__PURE__ */ (0, J.jsx)("span", {
					className: "ml-12 mr-12 fs-13",
					children: /* @__PURE__ */ (0, J.jsxs)("span", { children: ["Approval requested by ", e.requestedUserData.userEmail] })
				})]
			}),
			/* @__PURE__ */ (0, J.jsx)("div", { className: "vertical-connector" }),
			!!e.approvalConfigData.currentCount && /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "deployment-status-breakdown-row pt-8 pb-8 pl-8 pr-8 bg__primary bw-1 border-collapse flexbox dc__gap-12 en-2",
				children: [/* @__PURE__ */ (0, J.jsx)(p, { className: "icon-dim-20 green-tick" }), /* @__PURE__ */ (0, J.jsx)(Ya, {
					userApprovalMetadata: e,
					showCount: !0,
					hideApprovalCheckIcon: !0,
					showInfoIcon: !0
				})]
			}), /* @__PURE__ */ (0, J.jsx)("div", { className: "vertical-connector" })] })
		]
	});
}
//#endregion
//#region src/Components/DeploymentWindow/DeploymentHistoryTriggerMetaText.tsx
var sd = /* @__PURE__ */ t({ default: () => cd }), cd = ({ triggerMetaData: e, onlyRenderIcon: t }) => t ? e.includes(_t.BLACKOUT.toLowerCase()) ? /* @__PURE__ */ (0, J.jsx)(l, { className: "icon-dim-20 dc__no-shrink" }) : /* @__PURE__ */ (0, J.jsx)(x, { className: "icon-dim-20 dc__no-shrink" }) : /* @__PURE__ */ (0, J.jsx)("span", {
	className: "dc__align-left py-8 fw-6 fs-12",
	children: e
}), ld = ({ userApprovalMetadata: e, triggeredBy: t, appliedFilters: n, appliedFiltersTimestamp: r, promotionApprovalMetadata: i, selectedEnvironmentName: a, isDeploymentWithoutApproval: o }) => /* @__PURE__ */ (0, J.jsx)(nb, {
	userApprovalMetadata: e,
	showApprovalCounts: !0,
	triggeredBy: t,
	appliedFilters: n ?? [],
	appliedFiltersTimestamp: r ?? "",
	promotionApprovalMetadata: i,
	selectedEnvironmentName: a,
	isDeploymentWithoutApproval: o
}), ud = (e) => /* @__PURE__ */ (0, J.jsx)(od, { userApprovalMetadata: e }), dd = (e, t = !1) => /* @__PURE__ */ (0, J.jsx)(cd, {
	triggerMetaData: e,
	onlyRenderIcon: t
}), fd = ({ status: e, title: t, params: n }) => /* @__PURE__ */ (0, J.jsx)(ed, {
	status: e,
	titleName: t,
	params: n
}), pd = (e, t) => /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)(id, { className: "icon-dim-14 dc__no-shrink" }), e ? /* @__PURE__ */ (0, J.jsx)("span", {
	className: "cn-9 fs-12 fw-5 lh-20",
	children: "This Release"
}) : /* @__PURE__ */ (0, J.jsxs)("span", {
	className: "flexbox cn-9 fs-12 lh-20 dc__mxw-180",
	children: [
		/* @__PURE__ */ (0, J.jsx)("span", {
			className: "fw-4 dc__mxw-100 dc__ellipsis-right",
			children: t.releaseTrackName
		}),
		/* @__PURE__ */ (0, J.jsx)("span", {
			className: "fw-4",
			children: "/"
		}),
		/* @__PURE__ */ (0, J.jsx)("span", {
			className: "fw-5 dc__mxw-100 dc__ellipsis-right",
			children: t.releaseVersion
		})
	]
})] }), md = (e, t) => e && e.kind === L.release ? /* @__PURE__ */ (0, J.jsx)("div", {
	className: `flexbox dc__align-items-center dc__gap-4 pl-6 pr-6 br-6 dc__w-fit-content ${t ? "bcn-1" : "bg__primary"}`,
	children: pd(t, e)
}) : null, hd = (e, t) => e && e.kind === L.release ? /* @__PURE__ */ (0, J.jsx)("div", {
	className: "flexbox dc__align-items-center dc__gap-4 pl-6 pr-6 br-6 dc__w-fit-content bg__primary",
	children: pd(t, e)
}) : null, gd = (e, { context: t }) => t === "menu" && e.tenantConfig.identifier ? /* @__PURE__ */ (0, J.jsxs)("span", {
	className: "flexbox-col dc__ellipsis-right",
	children: [/* @__PURE__ */ (0, J.jsx)("span", {
		className: "dc__ellipsis-right lh-20 fs-13 cn-9",
		children: e.label
	}), /* @__PURE__ */ (0, J.jsx)("span", {
		className: "dc__ellipsis-right lh-18 fs-12 cn-7",
		children: e.tenantConfig.displayText
	})]
}) : e.label, _d = ({ showCurrentReleaseDeployments: e, setShowCurrentReleaseDeployments: t }) => {
	let { appId: n, envId: r, pipelineId: i, triggerId: a, ...o } = nd(), s = ki(), c = Oi(), { id: l } = Q(), [u, d] = A(!1), [f, p] = A({ ...td }), [m, h] = A(null), [g, _] = A([]), [v, y] = A(null), [b, x] = A(!1), [S, C] = A(!1), [w, T] = A(/* @__PURE__ */ new Map()), [ee, E] = A([]), [te, ne] = A(!1), [re, ie] = A(!1), ae = w?.get(+a), [oe, D, se] = fi({ autoBottomScroll: ae && Bn.includes(ae.status.toLowerCase()) }), [ce, le, ue, de] = K(() => ku(l), [l]), [fe, pe] = K(() => Promise.allSettled([Ou(l, n), xr(dn.BLOB_STORAGE)]), [n], !!n), me = !!(!fe && pe?.[0]?.status === "fulfilled" && pe?.[0]?.value?.some((e) => e.id === r)), [he, ge, _e, ve] = K(() => jr({
		appId: n,
		envId: r,
		pagination: f,
		releaseId: l,
		showCurrentReleaseDeployments: e
	}), [
		n,
		r,
		e,
		f.offset,
		f.size
	], !!n && !!r && me), ye = (e, t, n) => {
		if (n) {
			ge.result?.cdWorkflows?.length && T(Hr(ge.result.cdWorkflows, "id")), y(zt.SUSPEND);
			return;
		}
		if (e === t?.id) {
			let n = w.get(e)?.appliedFilters ?? [], r = w.get(e)?.appliedFiltersTimestamp, i = w.get(e)?.promotionApprovalMetadata, a = w.get(e)?.runSource, o = w.get(e)?.targetConfig, s = w.get(e)?.userApprovalMetadata, c = {
				...n.length ? { appliedFilters: n } : {},
				...r ? { appliedFiltersTimestamp: r } : {},
				...i ? { promotionApprovalMetadata: i } : {},
				...a ? { runSource: a } : {},
				...o ? { targetConfig: o } : {},
				...s ? { userApprovalMetadata: s } : {}
			};
			T((n) => (n.set(e, {
				...t,
				...c
			}), new Map(n))), v === zt.FETCHING && y(zt.SUCCESS);
		}
	};
	O(() => {
		if (fe || !ge || !ge?.result?.cdWorkflows?.length || v === zt.FETCHING || v === zt.SUCCESS) return;
		ge.result?.cdWorkflows?.length === f.size ? (x(!0), C(!0)) : x(!1);
		let e = ge.result?.cdWorkflows?.[0]?.id, t = new URLSearchParams(c.search).get("type");
		if (t === Dn.PRECD || t === Dn.POSTCD) {
			let n = t === Dn.PRECD ? wt.PRE : wt.POST, r = ge.result?.cdWorkflows?.filter((e) => e.stage === n);
			r?.[0] && (e = r[0].id);
		}
		let l = (ge.result?.cdWorkflows || []).reduce((e, t) => (e.set(t.id, t), e), w);
		E(ge?.result?.appReleaseTagNames || []), ne(ge?.result?.tagsEditable || !1), ie(ge?.result?.hideImageTaggingHardDelete || !1), !a && r && i && ge.result?.cdWorkflows?.length && s(q(I.RELEASES.DETAIL.HISTORY, {
			...o,
			appId: String(n),
			envId: String(r),
			pipelineId: String(i),
			triggerId: String(e)
		}), { replace: !0 }), a && !l.has(+a) && v !== zt.SUSPEND ? (y(zt.FETCHING), l.clear()) : y(zt.SUSPEND), T(new Map(l));
	}, [ge, fe]), O(() => {
		let e = [];
		if (pe && pe[0].status === vn.FULFILLED) {
			pe[0].value.forEach((t) => e.push({
				pipelineId: t.pipelineId,
				value: t.id,
				label: t.name,
				tenantConfig: t.tenantConfig,
				description: t.tenantConfig.displayText
			})), n && !r && s(q(I.RELEASES.DETAIL.HISTORY, {
				...o,
				appId: String(n),
				envId: String(e?.[0]?.value),
				pipelineId: String(e?.[0]?.pipelineId),
				triggerId: null
			}), { replace: !0 });
			let t = e.find((e) => r === Number(e.value))?.pipelineId;
			!i && r && s(t ? q(I.RELEASES.DETAIL.HISTORY, {
				...o,
				appId: String(n),
				envId: String(r),
				pipelineId: String(t),
				triggerId: null
			}) : e ? q(I.RELEASES.DETAIL.HISTORY, {
				...o,
				appId: String(n),
				envId: String(e[0]?.value),
				pipelineId: String(e[0]?.pipelineId),
				triggerId: null
			}) : q(I.RELEASES.DETAIL.HISTORY, {
				...o,
				appId: String(n),
				envId: null,
				pipelineId: null,
				triggerId: null
			}), { replace: !0 }), n && r && i && i !== t && s(q(I.RELEASES.DETAIL.HISTORY, {
				...o,
				appId: String(n),
				envId: String(r),
				pipelineId: String(t),
				triggerId: null
			}), { replace: !0 }), _(e);
		}
	}, [fe, pe]), O(() => (pe && pe[0].status === vn.FULFILLED && h(pe[0].value?.find((e) => e.id === r)?.deploymentAppType), () => {
		T(/* @__PURE__ */ new Map()), C(!1), x(!1), y(null), p(td);
	}), [r, pe]);
	let be = () => {
		t(!e), T(/* @__PURE__ */ new Map()), p(td), s(q(I.RELEASES.DETAIL.HISTORY, {
			...o,
			appId: String(n),
			envId: String(r),
			pipelineId: String(i),
			triggerId: null
		}), { replace: !0 });
	}, xe = (!ce && le?.find((e) => Number(e.value) === n)) ?? null, Se = g.find((e) => Number(e.value) === r) ?? null, Ce = Se?.label;
	async function we() {
		if (!r || !v || v !== zt.SUSPEND) return;
		let [t, i] = await ir(jr({
			appId: n,
			envId: r,
			pagination: {
				offset: 0,
				size: f.offset + f.size
			},
			releaseId: l,
			showCurrentReleaseDeployments: e
		}));
		if (t) {
			W(t);
			return;
		}
		i?.result?.cdWorkflows?.forEach((e) => ye(e.id, e, t));
	}
	return li(we, 3e4), ce ? /* @__PURE__ */ (0, J.jsx)("div", {
		className: "flex flex-grow-1",
		children: /* @__PURE__ */ (0, J.jsx)(_n, { size: 48 })
	}) : ue ? /* @__PURE__ */ (0, J.jsx)(It, {
		reload: de,
		code: ue?.code,
		redirectURL: q(I.RELEASES.DETAIL.ROOT, { ...o })
	}) : !S && fe || he && w.size === 0 ? /* @__PURE__ */ (0, J.jsx)(_n, { pageLoader: !0 }) : le.length === 0 ? /* @__PURE__ */ (0, J.jsx)(F, {
		image: Ri,
		title: "No deployments from this release yet",
		subTitle: "History of deployments done from this release will be available here"
	}) : /* @__PURE__ */ (0, J.jsxs)("div", {
		className: `ci-details  ${u ? "ci-details--full-screen" : ""}`,
		children: [!u && /* @__PURE__ */ (0, J.jsx)("div", {
			className: "releases__deployment-history flexbox-col dc__overflow-hidden dc__border-right dc__no-shrink",
			children: /* @__PURE__ */ (0, J.jsx)(Pn, {
				filterOptions: [],
				type: Jt.CD,
				hasMore: b,
				triggerHistory: w,
				setPagination: p,
				fetchIdData: v,
				handleViewAllHistory: () => {
					ge.result?.cdWorkflows?.length && T(Hr(ge.result.cdWorkflows, "id")), y(zt.SUSPEND), s(q(I.RELEASES.DETAIL.HISTORY, {
						...o,
						appId: String(n),
						envId: String(r),
						pipelineId: String(i),
						triggerId: String(ge.result?.cdWorkflows?.[0]?.id)
					}));
				},
				renderRunSource: e ? null : md,
				resourceId: l,
				path: I.RELEASES.DETAIL.HISTORY,
				children: /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col px-16 py-12 dc__gap-12 fs-13-imp dc__border-bottom-n1 dc__zi-3",
					children: [/* @__PURE__ */ (0, J.jsx)(rd, {
						appOptions: le,
						envOptions: g,
						envOptionsLoading: fe
					}), xe && Se && /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox m-0",
						children: [/* @__PURE__ */ (0, J.jsx)(it, {
							id: "current-release-deployments",
							onChange: be,
							isChecked: e,
							value: rt.CHECKED,
							rootClassName: "mb-0"
						}), /* @__PURE__ */ (0, J.jsx)("label", {
							className: "m-0 fw-4 fs-13 lh-20 cursor",
							htmlFor: "current-release-deployments",
							children: "Deployments from this release only"
						})]
					})]
				})
			})
		}), _e ? /* @__PURE__ */ (0, J.jsx)("div", {
			className: "flex-grow-1",
			children: /* @__PURE__ */ (0, J.jsx)(It, {
				reload: ve,
				code: _e?.code,
				redirectURL: q(I.RELEASES.DETAIL.ROOT, { ...o })
			})
		}) : !xe || !Se ? /* @__PURE__ */ (0, J.jsx)("div", {
			className: "flex-grow-1",
			children: /* @__PURE__ */ (0, J.jsx)(F, {
				title: "No application x environment selected",
				subTitle: "Select application and environment to view deployment history"
			})
		}) : w.size === 0 ? /* @__PURE__ */ (0, J.jsx)("div", {
			className: "flex-grow-1",
			children: /* @__PURE__ */ (0, J.jsx)(F, {
				title: `No deployments${e ? " from this release" : ""}`,
				subTitle: `No deployments are done for selected application and environment${e ? " from this release" : ""}`
			})
		}) : /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "ci-details__body",
			children: [/* @__PURE__ */ (0, J.jsx)("div", {
				className: "flexbox-col flex-grow-1 dc__overflow-auto h-100",
				ref: oe,
				children: /* @__PURE__ */ (0, J.jsx)(Jn, {
					fullScreenView: u,
					triggerHistory: w,
					deploymentHistoryResult: ge ?? null,
					setTriggerHistory: T,
					setFullScreenView: d,
					deploymentAppType: m,
					isBlobStorageConfigured: pe?.[1]?.status === vn.FULFILLED ? pe[1].value?.result?.enabled : !1,
					appReleaseTags: ee,
					tagsEditable: te,
					hideImageTaggingHardDelete: re,
					fetchIdData: v,
					setFetchTriggerIdData: y,
					selectedEnvironmentName: Ce,
					renderRunSource: hd,
					resourceId: l,
					renderCIListHeader: ld,
					renderDeploymentApprovalInfo: ud,
					renderDeploymentHistoryTriggerMetaText: dd,
					renderVirtualHistoryArtifacts: fd,
					processVirtualEnvironmentDeploymentData: Xu,
					scrollToTop: D,
					scrollToBottom: se,
					renderTargetConfigInfo: () => {
						let { targetConfig: e, runSource: t } = w.get(a);
						if (!Ce || t?.kind !== L.release) return null;
						let { displayText: n, installationConfig: { releaseChannelName: r } } = Os({
							tenantIcon: e?.tenantIcon,
							tenantId: e?.tenantId,
							tenantName: e?.tenantName,
							installationId: e?.installationId,
							installationName: e?.installationName,
							releaseChannelId: e?.releaseChannelId,
							releaseChannelName: e?.releaseChannelName
						});
						return /* @__PURE__ */ (0, J.jsx)(Kn, {
							alwaysShowTippyOnHover: !0,
							content: /* @__PURE__ */ (0, J.jsxs)("div", {
								className: "fs-12 lh-18 fw-4 flex column left top dc__gap-6",
								children: [
									Ce && /* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("div", {
										className: "fw-6",
										children: "Environment"
									}), /* @__PURE__ */ (0, J.jsx)("div", { children: Ce })] }),
									/* @__PURE__ */ (0, J.jsx)("div", { className: "w-100 dc__border-bottom--n7" }),
									/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("div", {
										className: "fw-6",
										children: "Tenant (Installation)"
									}), /* @__PURE__ */ (0, J.jsx)("div", { children: n })] }),
									/* @__PURE__ */ (0, J.jsx)("div", { className: "w-100 dc__border-bottom--n7" }),
									/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("div", {
										className: "fw-6",
										children: "Release Channel"
									}), /* @__PURE__ */ (0, J.jsx)("div", { children: r || Wu.label })] })
								]
							}),
							children: /* @__PURE__ */ (0, J.jsx)("div", {
								className: "flex",
								children: /* @__PURE__ */ (0, J.jsx)(Oe, { className: "icon-dim-14 dc__no-shrink" })
							})
						});
					},
					appName: xe?.label,
					pathPattern: I.RELEASES.DETAIL.HISTORY
				})
			}), /* @__PURE__ */ (0, J.jsx)(on, {
				fullScreenView: u,
				setFullScreenView: d
			})]
		})]
	});
}, vd = Array.from([
	,
	,
	,
].keys()).map((e) => ({
	appId: e,
	envId: e,
	appName: `${e}`,
	envName: `${e}`,
	deployStatus: Y.ABORTED,
	preStatus: Y.DEPLOY_INITIATED,
	postStatus: Y.FAILED,
	existingStages: {
		pre: !0,
		post: !0,
		deploy: !0
	},
	pipelineId: e,
	tenantConfig: ks(e),
	isDeployable: !1,
	preCdWorkflowRunnerId: e,
	cdWorkflowRunnerId: e,
	postCdWorkflowRunnerId: e,
	isVirtualEnvironment: !1
})), yd = Array.from([
	,
	,
	,
].keys()).map((e) => ({
	appId: e,
	envId: e,
	appName: `${e}`,
	envName: `${e}`,
	feasibility: $c(ys.CanTrigger),
	message: "",
	tenantConfig: ks(e)
})), bd = Array.from([
	,
	,
	,
].keys()).map((e) => ({
	appId: e,
	envId: e,
	appName: `${e}`,
	envName: `${e}`,
	triggerStatus: rl({ code: $s.processed }, !1),
	message: "",
	tenantConfig: ks(e),
	romStatus: null,
	stage: null,
	cdWorkflowType: null
})), xd = /* @__PURE__ */ function(e) {
	return e.appName = "application", e.tenantInstallation = "tenantInstallation", e.envName = "environment", e;
}({}), Sd = /* @__PURE__ */ function(e) {
	return e.appName = "application", e.tenantInstallation = "tenantInstallation", e.envName = "environment", e.feasibility = "feasibility", e;
}({}), Cd = [
	{
		value: wt.PRE,
		label: "Trigger Pre-deployment stage"
	},
	{
		value: wt.DEPLOY,
		label: "Trigger Deployment"
	},
	{
		value: wt.POST,
		label: "Trigger Post-deployment stage"
	}
], wd = [
	Z.HOLD,
	Z.RESCINDED,
	Js.CORRUPTED
], Td = "view", Ed = /* @__PURE__ */ function(e) {
	return e.triggerRelease = "trigger-release", e.rolloutStatus = "rollout-status", e;
}({}), Dd = /* @__PURE__ */ function(e) {
	return e.installation = "installation", e.pipeline = "pipeline", e;
}({}), Od = {
	rolloutStatus: ac,
	preStage: [],
	deployStage: [],
	postStage: [],
	env: [],
	app: [],
	tenantInstallation: [],
	releaseChannelId: []
}, kd = {
	selectedRolloutStatus: ac,
	preStageMap: {},
	deployStageMap: {},
	postStageMap: {},
	envMap: {},
	appMap: {},
	tenantInstallationMap: {},
	releaseChannelIdMap: {}
}, Ad = /* @__PURE__ */ function(e) {
	return e.rolloutStatus = "rolloutStatus", e.preStage = "preStage", e.deployStage = "deployStage", e.postStage = "postStage", e.env = "env", e.app = "app", e.tenantInstallation = "tenantInstallation", e.releaseChannelId = "releaseChannelId", e;
}({}), jd = {
	rolloutStatus: "Rollout status",
	preStage: "Pre-deployment status",
	deployStage: "Deployment status",
	postStage: "Post-deployment status",
	env: "Environments",
	app: "Applications",
	tenantInstallation: "Tenant (Installations)",
	releaseChannelId: "Release channel"
}, Md = br(Object.values(mc)), Nd = [{
	label: "Rollout Status",
	value: "rollout-status"
}, {
	label: "Trigger Release",
	value: "trigger-release"
}], Pd = (e, t = {}) => Object.fromEntries(Object.entries(e ?? {}).map(([e, n]) => [e, Object.fromEntries(Object.entries(n).filter(([e]) => t[e]))])), Fd = (e) => {
	switch (e) {
		case Z.READY_FOR_RELEASE: return Ed.triggerRelease;
		default: return Ed.rolloutStatus;
	}
}, Id = (e) => jd[e], Ld = (e) => e === ac, Rd = (e, t) => {
	switch (e) {
		case Ad.rolloutStatus: return Ld(t) ? "" : lc[t];
		case Ad.preStage:
		case Ad.deployStage:
		case Ad.postStage: return hc[t];
		default: return t;
	}
}, zd = (e, t) => e.getAll(t).filter((e) => Md[e]), Bd = (e) => {
	let t = e.get(Ad.rolloutStatus);
	return {
		rolloutStatus: Ld(t) || Object.values(X).some((e) => e === t) ? t : ac,
		preStage: zd(e, Ad.preStage),
		deployStage: zd(e, Ad.deployStage),
		postStage: zd(e, Ad.postStage),
		env: e.getAll(Ad.env).filter((e) => !!e),
		app: e.getAll(Ad.app).filter((e) => !!e),
		tenantInstallation: e.getAll(Ad.tenantInstallation).filter((e) => !!e),
		releaseChannelId: e.getAll(Ad.releaseChannelId).filter((e) => !!e)
	};
}, Vd = ({ selectedRolloutStatus: e = kd.selectedRolloutStatus, preStageMap: t = kd.preStageMap, deployStageMap: n = kd.deployStageMap, postStageMap: r = kd.postStageMap, envMap: i = kd.envMap, appMap: a = kd.appMap, tenantInstallationMap: o = kd.tenantInstallationMap, releaseChannelIdMap: s = kd.releaseChannelIdMap }) => ({
	rolloutStatus: e,
	preStage: Object.keys(t).filter((e) => t[e]),
	deployStage: Object.keys(n).filter((e) => n[e]),
	postStage: Object.keys(r).filter((e) => r[e]),
	env: Object.keys(i).filter((e) => !!i[e]),
	app: Object.keys(a).filter((e) => !!a[e]),
	tenantInstallation: Object.keys(o).filter((e) => !!o[e]),
	releaseChannelId: Object.keys(s).filter((e) => !!s[e])
}), Hd = (e) => (e ?? []).reduce((e, t) => (e[t.identifier] = t.displayText, e), {}), Ud = (e) => (e ?? []).reduce((e, t) => (e[t.channelId] = t.name, e), { [Wu.value]: Wu.label }), Wd = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M5.6875 5.25V8.75M8.3125 5.25V8.75M12.25 7C12.25 9.89949 9.89949 12.25 7 12.25C4.1005 12.25 1.75 9.89949 1.75 7C1.75 4.1005 4.1005 1.75 7 1.75C9.89949 1.75 12.25 4.1005 12.25 7Z",
		stroke: "#B23412",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		vectorEffect: "non-scaling-stroke"
	})
}), Gd = {
	[Z.DRAFT]: {
		label: "Draft",
		value: Z.DRAFT
	},
	[Z.READY_FOR_RELEASE]: {
		label: "Ready for release",
		value: Z.READY_FOR_RELEASE
	},
	[Z.HOLD]: {
		label: "On hold",
		value: Z.HOLD
	},
	[Z.RESCINDED]: {
		label: "Rescinded",
		value: Z.RESCINDED
	},
	[Js.PARTIALLY_RELEASED]: {
		label: "Partially released",
		value: Js.PARTIALLY_RELEASED
	},
	[Js.COMPLETELY_RELEASED]: {
		label: "Completely released",
		value: Js.COMPLETELY_RELEASED
	},
	[Js.CORRUPTED]: {
		label: "Corrupted",
		value: Js.CORRUPTED
	}
}, Kd = {
	[Z.DRAFT]: [Gd[Z.DRAFT], Gd[Z.READY_FOR_RELEASE]],
	[Z.READY_FOR_RELEASE]: [Gd[Z.DRAFT], Gd[Z.READY_FOR_RELEASE]],
	[Z.HOLD]: [
		Gd[Z.READY_FOR_RELEASE],
		Gd[Z.HOLD],
		Gd[Z.RESCINDED]
	],
	[Z.RESCINDED]: [],
	[Js.PARTIALLY_RELEASED]: [
		Gd[Js.PARTIALLY_RELEASED],
		Gd[Z.HOLD],
		Gd[Z.RESCINDED]
	],
	[Js.COMPLETELY_RELEASED]: [
		Gd[Js.COMPLETELY_RELEASED],
		Gd[Z.HOLD],
		Gd[Z.RESCINDED]
	],
	[Js.CORRUPTED]: []
}, qd = {
	[Z.DRAFT]: /* @__PURE__ */ (0, J.jsx)(v, { className: "scn-7 w-100 h-100" }),
	[Z.READY_FOR_RELEASE]: /* @__PURE__ */ (0, J.jsx)(Vs, { className: "fcy-5 w-100 h-100" }),
	[Z.HOLD]: /* @__PURE__ */ (0, J.jsx)(Wd, { className: "w-100 h-100" }),
	[Z.RESCINDED]: /* @__PURE__ */ (0, J.jsx)(Ce, { className: "w-100 h-100 dc__flip-y scn-0" }),
	[Js.PARTIALLY_RELEASED]: /* @__PURE__ */ (0, J.jsx)(rc, { className: "w-100 h-100" }),
	[Js.COMPLETELY_RELEASED]: /* @__PURE__ */ (0, J.jsx)(n, { className: "w-100 h-100" }),
	[Js.CORRUPTED]: /* @__PURE__ */ (0, J.jsx)(Yt, {
		name: "ic-warning",
		color: null
	})
}, Jd = {
	[Z.DRAFT]: "cn-8",
	[Z.READY_FOR_RELEASE]: "cn-8",
	[Z.HOLD]: "co-7",
	[Z.RESCINDED]: "cn-0",
	[Js.PARTIALLY_RELEASED]: "cn-8",
	[Js.COMPLETELY_RELEASED]: "cg-7",
	[Js.CORRUPTED]: "text__white"
}, Yd = ({ type: e, userEmail: t, track: n }) => {
	switch (e) {
		case Cc.added: return `Added to '${n}' by ${t}`;
		case Cc.removed: return `Removed from '${n}' by ${t}`;
		case Cc.deleted: return `Application deleted by ${t}`;
		default: return "";
	}
}, Xd = ({ changesForReview: e, trackName: t, handleClose: n, handleSuccess: r }) => {
	let [i, a] = A(!1), { id: o, refetchReleaseDetail: s } = Q();
	return /* @__PURE__ */ (0, J.jsx)($n, {
		className: "visible-modal__body",
		children: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col dc__content-space dc__overflow-hidden dc__m-auto mt-40 br-8 bg__primary w-450 mxh-600",
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col flex-grow-1 dc__overflow-auto",
				children: [
					/* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flex dc__content-space px-20 py-12 dc__border-bottom",
						children: [/* @__PURE__ */ (0, J.jsxs)("h2", {
							className: "m-0 fs-16 fw-6 lh-24 cn-9 dc__truncate",
							children: [
								"Applications updated in '",
								t,
								"'"
							]
						}), /* @__PURE__ */ (0, J.jsx)("button", {
							type: "button",
							className: "dc__transparent dc__no-shrink flexbox",
							"aria-label": "close-modal",
							onClick: n,
							children: /* @__PURE__ */ (0, J.jsx)(Ee, { className: "icon-dim-20 fcn-6" })
						})]
					}),
					/* @__PURE__ */ (0, J.jsx)(nn, {
						description: /* @__PURE__ */ (0, J.jsxs)("span", {
							className: "flex column left fs-13 fw-4 lh-20 cn-9",
							children: [/* @__PURE__ */ (0, J.jsxs)("span", {
								className: "fw-6",
								children: [e.length, " updates pending review"]
							}), /* @__PURE__ */ (0, J.jsx)("span", { children: "Accept changes to apply them to this release" })]
						}),
						borderConfig: {
							top: !1,
							left: !1,
							right: !1
						},
						borderRadiusConfig: {
							top: !1,
							left: !1,
							right: !1,
							bottom: !1
						}
					}),
					/* @__PURE__ */ (0, J.jsx)("div", {
						className: "px-20 py-16 flexbox-col flex-grow-1 dc__overflow-auto",
						children: e.map((e) => /* @__PURE__ */ (0, J.jsxs)("div", {
							className: "flex top left dc__gap-8 py-8",
							children: [/* @__PURE__ */ (0, J.jsx)("div", {
								className: "icon-dim-20 dc__no-shrink p-2",
								children: wc[e.type]
							}), /* @__PURE__ */ (0, J.jsxs)("div", {
								className: "flexbox-col flex-grow-1",
								children: [/* @__PURE__ */ (0, J.jsx)(wi, {
									to: `${Yn.APPLICATION_MANAGEMENT_APP}/${e.appId}`,
									target: "_blank",
									className: "anchor fs-13 fw-4 lh-20 cb-5 dc__truncate",
									children: e.appName
								}), /* @__PURE__ */ (0, J.jsxs)("div", {
									className: "flex top dc__content-space dc__gap-8 fs-12 fw-4 lh-18 cn-7 dc__gap-8",
									children: [/* @__PURE__ */ (0, J.jsx)("span", {
										className: "dc__ellipsis-right__2nd-line",
										children: Yd({
											type: e.type,
											userEmail: e.userEmail,
											track: t
										})
									}), /* @__PURE__ */ (0, J.jsx)("span", {
										className: "dc__no-shrink",
										children: Rr(e.performedAtTime, !0)
									})]
								})]
							})]
						}, e.appName))
					})
				]
			}), /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "px-20 py-16 flex dc__gap-12 dc__content-end",
				children: [/* @__PURE__ */ (0, J.jsx)("button", {
					type: "button",
					className: "cta cancel",
					disabled: i,
					onClick: n,
					children: "Cancel"
				}), /* @__PURE__ */ (0, J.jsx)(et, {
					type: "button",
					rootClassName: "cta",
					disabled: i,
					onClick: async () => {
						try {
							a(!0);
							let { userMessage: t } = (await Nu(o, e))?.result ?? {};
							await s(), r(), B.showToast({
								variant: V.success,
								description: t || "Changes accepted successfully"
							}), a(!1), n();
						} catch (e) {
							a(!1), W(e);
						}
					},
					isLoading: i,
					children: "Accept Changes"
				})]
			})]
		})
	});
}, Zd = je({
	isCountSummaryLoading: !0,
	filterCountSummary: null,
	updateFilterCountSummary: U,
	resetFilterCountSummary: U,
	areFiltersActive: !1,
	urlFilterConfig: { ...Od },
	urlFilterConfigMap: { ...kd },
	handleRolloutStatusUpdate: U,
	updateFilters: U,
	updateFiltersByMap: U,
	clearFilters: U,
	stageListAccordionExpansionMap: {},
	setStageListAccordionExpansionMap: U,
	appEnvAndTenantListApiState: {
		isAppEnvAndTenantLoading: !1,
		appEnvAndTenantList: {},
		appEnvAndTenantListError: null,
		refetchAppEnvAndTenantList: U
	},
	triggerReleaseView: null,
	handleTriggerReleaseViewChange: U,
	shouldPoll: !1,
	handleUpdateShouldPoll: U,
	selectedTab: null,
	handleTabChange: U,
	appStatusModalConfig: null,
	setAppStatusModalConfig: U
}), Qd = ({ children: e, appEnvAndTenantListApiState: t }) => {
	let n = ki(), [r, i] = A({}), [a, o] = A(null), [s, c] = A(!1), [l, u] = A(null), { queryParams: d } = pi(), { status: f } = Q(), p = d.get("tab"), m = d.get(Td), h = !a, { rolloutStatus: g, preStage: _, deployStage: v, postStage: y, env: b, app: x, tenantInstallation: S, updateSearchParams: C, releaseChannelId: w } = gi({ parseSearchParams: Bd });
	O(() => {
		if (!p || !Object.values(Ed).some((e) => e === p)) {
			let e = new URLSearchParams(d);
			e.set("tab", Fd(f)), n({ search: e.toString() }, { replace: !0 });
		}
	}, [d]);
	let T = (e) => {
		let t = new URLSearchParams(d);
		t.set("tab", String(e.value)), n({ search: t.toString() }, { replace: !0 });
	}, ee = (e) => {
		let t = new URLSearchParams(d);
		t.set(Td, Object.values(Dd).some((t) => t === e) ? e : Dd.pipeline), n({ search: t.toString() }, { replace: !0 });
	}, E = (e) => {
		C({
			...Od,
			...e
		});
	}, te = (e) => {
		C(Vd({ ...e }));
	}, ne = () => {
		C({ ...Od });
	}, re = (e) => {
		C({ rolloutStatus: e });
	}, ie = (e) => {
		o(e);
	}, ae = () => {
		o(null);
	}, oe = () => {
		if (p === Ed.triggerRelease) {
			let e = g && !Ld(g) || w.length;
			return m === Dd.installation ? e : e || _.length || v.length || y.length || b.length || x.length || S.length;
		}
		return b.length || x.length || S.length || w.length;
	}, D = (e) => {
		c(e);
	}, se = k(() => ({
		isCountSummaryLoading: h,
		areFiltersActive: !!oe(),
		urlFilterConfig: {
			rolloutStatus: g,
			preStage: _,
			deployStage: v,
			postStage: y,
			env: b,
			app: x,
			tenantInstallation: S,
			releaseChannelId: w
		},
		urlFilterConfigMap: {
			selectedRolloutStatus: g,
			preStageMap: br(_),
			deployStageMap: br(v),
			postStageMap: br(y),
			envMap: br(b),
			appMap: br(x),
			tenantInstallationMap: br(S),
			releaseChannelIdMap: br(w)
		},
		filterCountSummary: a ?? Yc(null),
		updateFilterCountSummary: ie,
		resetFilterCountSummary: ae,
		updateFiltersByMap: te,
		handleRolloutStatusUpdate: re,
		updateFilters: E,
		clearFilters: ne,
		stageListAccordionExpansionMap: r,
		setStageListAccordionExpansionMap: i,
		appEnvAndTenantListApiState: t,
		triggerReleaseView: m,
		handleTriggerReleaseViewChange: ee,
		shouldPoll: s,
		handleUpdateShouldPoll: D,
		selectedTab: p,
		handleTabChange: T,
		appStatusModalConfig: l,
		setAppStatusModalConfig: u
	}), [
		r,
		p,
		a,
		g,
		_,
		v,
		y,
		b,
		x,
		S,
		w,
		t,
		m,
		s
	]);
	return /* @__PURE__ */ (0, J.jsx)(Zd.Provider, {
		value: se,
		children: e
	});
}, $d = () => {
	let e = Ne(Zd);
	if (!e) throw Error("Please wrap with DeployFilterProvider");
	return e;
}, ef = ({ label: e, value: t, onClick: n }) => /* @__PURE__ */ (0, J.jsx)("button", {
	type: "button",
	className: "dc__transparent dc__ellipsis-right flex dc__content-start dc__gap-8 pt-6 pb-6 pl-8 pr-8 cursor w-100 dc__hover-n50",
	onClick: () => {
		n(t);
	},
	children: /* @__PURE__ */ (0, J.jsx)("span", {
		className: "dc__ellipsis-right lh-20 fs-13 cn-9 fw-4",
		children: e
	})
}, t), tf = ({ existingStagesInBulkSelection: e, parentRef: t, count: n, handleButtonClick: r, handleClearBulkSelection: i }) => {
	let [a, o] = A(!1), [s, c] = A(!1), [l, u] = A([]), d = ki(), f = Ai(), { id: p, track: m } = Q(), { isCountSummaryLoading: h, triggerReleaseView: g } = $d(), _ = s || h, v = g === Dd.installation, y = (e) => {
		r(e);
	}, b = async (e) => {
		try {
			c(!0);
			let t = await Mu(p);
			if (t.length === 0) {
				v ? r(null) : y(e);
				return;
			}
			u(t), o(!0);
		} catch (e) {
			W(e);
		} finally {
			c(!1);
		}
	}, x = async () => {
		await b(null);
	}, S = async () => {
		await b(wt.DEPLOY);
	}, C = () => {
		d(q(I.RELEASES.DETAIL.REQUIREMENTS, {
			releaseTrack: f.releaseTrack,
			releaseVersion: f.releaseVersion,
			appName: null
		}));
	}, w = Cd.filter((t) => e[t.value.toLowerCase()]);
	return /* @__PURE__ */ (0, J.jsxs)(jt, {
		dragSelector: ".drag-selector",
		positionVariant: At.PARENT_BOTTOM_CENTER,
		parentRef: t,
		zIndex: "calc(var(--modal-index) - 1)",
		children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flex dc__gap-8 pt-12 pb-12 pr-12 pl-8 bulk-selection-widget br-8",
			children: [
				/* @__PURE__ */ (0, J.jsx)(kt, { dragClassName: "drag-selector" }),
				/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "fs-13 lh-20 fw-6 flex dc__gap-12",
					children: [/* @__PURE__ */ (0, J.jsx)("span", {
						className: "flex dc__gap-2 bcb-5 cn-0 br-4 pr-6 pl-6",
						children: n
					}), /* @__PURE__ */ (0, J.jsx)("span", {
						className: "cn-9",
						children: "Selected"
					})]
				}),
				/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__divider h-16" }),
				v ? /* @__PURE__ */ (0, J.jsx)(M, {
					text: "Deploy",
					dataTestId: "installation-view-deploy",
					startIcon: /* @__PURE__ */ (0, J.jsx)(Po, {}),
					onClick: x,
					size: P.small,
					disabled: _,
					isLoading: s
				}) : /* @__PURE__ */ (0, J.jsx)(tt, {
					content: /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flex left dc__gap-8",
						children: [/* @__PURE__ */ (0, J.jsx)(Po, { className: "icon-stroke__white dc__no-svg-fill dc__no-shrink icon-dim-16" }), "Deploy"]
					}),
					className: "fs-13",
					onClick: S,
					popUpBodyClassName: "mb-5",
					showPopUp: w.length > 1,
					disabled: _,
					isLoading: s,
					children: w.map((e) => /* @__PURE__ */ Me(ef, {
						...e,
						key: e.value,
						onClick: b
					}))
				}),
				/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__divider h-16" }),
				/* @__PURE__ */ (0, J.jsx)(D, {
					className: "default-tt",
					arrow: !1,
					placement: "top",
					content: "Clear Selection(s)",
					children: /* @__PURE__ */ (0, J.jsx)("button", {
						type: "button",
						className: "dc__transparent flex p-0 dc__hover-remove-btn",
						onClick: i,
						"aria-label": "Clear bulk selection",
						disabled: _,
						children: /* @__PURE__ */ (0, J.jsx)(Ee, { className: "fcn-6 icon-dim-28 p-6" })
					})
				})
			]
		}), a && /* @__PURE__ */ (0, J.jsx)(Xd, {
			changesForReview: l,
			handleClose: () => {
				o(!1);
			},
			handleSuccess: C,
			trackName: m
		})]
	});
}, nf = /* @__PURE__ */ function(e) {
	return e.appName = "application", e.tenantInstallation = "tenantInstallation", e.envName = "environment", e.triggerStatus = "triggerStatus", e;
}({}), rf = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.08611 3.62308C3.27152 3.43766 3.523 3.3335 3.78522 3.3335H10.5649C10.8271 3.3335 11.0786 3.43766 11.264 3.62308C11.4494 3.8085 11.5536 4.05998 11.5536 4.3222V7.85327H16.2146C16.4768 7.85327 16.7283 7.95744 16.9137 8.14285C17.0991 8.32827 17.2033 8.57975 17.2033 8.84197V16.3278H17.9099C18.1439 16.3278 18.3337 16.5176 18.3337 16.7516C18.3337 16.9856 18.1439 17.1753 17.9099 17.1753H2.09072C1.8567 17.1753 1.66699 16.9856 1.66699 16.7516C1.66699 16.5176 1.8567 16.3278 2.09072 16.3278H2.79652V4.3222C2.79652 4.05998 2.90069 3.8085 3.08611 3.62308ZM3.64398 16.3278H10.7061V4.3222C10.7061 4.28474 10.6912 4.24881 10.6648 4.22232C10.6383 4.19583 10.6023 4.18095 10.5649 4.18095H3.78522C3.74776 4.18095 3.71184 4.19583 3.68535 4.22232C3.65886 4.24881 3.64398 4.28474 3.64398 4.3222V16.3278ZM11.5536 8.70073V16.3278H16.3558V8.84197C16.3558 8.80451 16.341 8.76859 16.3145 8.7421C16.288 8.71561 16.2521 8.70073 16.2146 8.70073H11.5536ZM5.05641 6.58208C5.05641 6.34806 5.24612 6.15835 5.48014 6.15835H7.74002C7.97404 6.15835 8.16375 6.34806 8.16375 6.58208C8.16375 6.8161 7.97404 7.00581 7.74002 7.00581H5.48014C5.24612 7.00581 5.05641 6.8161 5.05641 6.58208ZM6.18635 11.1019C6.18635 10.8678 6.37606 10.6781 6.61008 10.6781H8.86997C9.10399 10.6781 9.2937 10.8678 9.2937 11.1019C9.2937 11.3359 9.10399 11.5256 8.86997 11.5256H6.61008C6.37606 11.5256 6.18635 11.3359 6.18635 11.1019ZM12.966 11.1019C12.966 10.8678 13.1557 10.6781 13.3897 10.6781H14.5197C14.7537 10.6781 14.9434 10.8678 14.9434 11.1019C14.9434 11.3359 14.7537 11.5256 14.5197 11.5256H13.3897C13.1557 11.5256 12.966 11.3359 12.966 11.1019ZM5.05641 13.9267C5.05641 13.6927 5.24612 13.503 5.48014 13.503H7.74002C7.97404 13.503 8.16375 13.6927 8.16375 13.9267C8.16375 14.1607 7.97404 14.3504 7.74002 14.3504H5.48014C5.24612 14.3504 5.05641 14.1607 5.05641 13.9267ZM12.966 13.9267C12.966 13.6927 13.1557 13.503 13.3897 13.503H14.5197C14.7537 13.503 14.9434 13.6927 14.9434 13.9267C14.9434 14.1607 14.7537 14.3504 14.5197 14.3504H13.3897C13.1557 14.3504 12.966 14.1607 12.966 13.9267Z",
		fill: "#0066CC"
	})
}), af = (e) => `${(e / 8).toFixed(2)}px`, of = ({ rootClassName: e, showEditIcon: t = !1, height: n = 48, width: r = 48 }) => {
	let i = r > 36 && n > 36;
	return /* @__PURE__ */ (0, J.jsx)("div", {
		className: `flex dc__align-self-start dc__no-shrink br-4 ${i ? "tenants__tenant-fallback-image" : ""} ${t ? "base-image" : ""} ${e || ""}`,
		style: {
			height: n,
			width: r,
			...i && {
				paddingBlock: af(n),
				paddingInline: af(r)
			}
		},
		children: /* @__PURE__ */ (0, J.jsx)(rf, { className: `w-100 h-100 dc__opacity-1 ${i ? "fcb-4" : ""}` })
	});
}, sf = ({ imageProps: e, fallbackImageProps: t }) => {
	let n = e?.height ?? 48, r = e?.width ?? 48;
	return /* @__PURE__ */ (0, J.jsx)(tn, {
		imageProps: {
			alt: "tenant-logo",
			...e,
			height: n,
			width: r,
			className: "base-image dc__chart-grid-item__icon br-4 dc__no-shrink"
		},
		fallbackImage: /* @__PURE__ */ (0, J.jsx)(of, {
			...t,
			height: n,
			width: r
		})
	});
}, cf = ({ appId: e, appName: t, envId: n, envName: r, triggerStatus: i, tenantConfig: a }) => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "display-grid dc__column-gap-16 releases__deploy-feasibility-table-row fs-13 fw-4 lh-20 cn-9 py-8 px-20",
	children: [
		/* @__PURE__ */ (0, J.jsx)(wi, {
			to: q(I.DEVTRON_APP_DETAILS.ENV_DETAILS, {
				appId: String(e),
				envId: String(n)
			}),
			className: "anchor dc__truncate",
			target: "_blank",
			children: t
		}),
		/* @__PURE__ */ (0, J.jsx)("span", { children: /* @__PURE__ */ (0, J.jsxs)("span", {
			className: "flexbox dc__align-items-center dc__gap-8",
			children: [/* @__PURE__ */ (0, J.jsx)(sf, { imageProps: {
				src: a.image,
				height: 20,
				width: 20
			} }), /* @__PURE__ */ (0, J.jsx)("span", {
				className: "dc__truncate",
				children: a.displayText
			})]
		}) }),
		/* @__PURE__ */ (0, J.jsx)("span", {
			className: "flexbox-col",
			children: /* @__PURE__ */ (0, J.jsx)("span", {
				className: "dc__truncate",
				children: r
			})
		}),
		/* @__PURE__ */ (0, J.jsx)("span", { children: /* @__PURE__ */ (0, J.jsxs)("span", {
			className: "flexbox dc__gap-4",
			children: [/* @__PURE__ */ (0, J.jsx)("span", {
				className: "icon-dim-20 dc__no-shrink p-2",
				children: i.icon
			}), /* @__PURE__ */ (0, J.jsxs)("span", {
				className: "flexbox-col",
				children: [/* @__PURE__ */ (0, J.jsx)("span", {
					className: "dc__truncate",
					children: i.text
				}), i.message && /* @__PURE__ */ (0, J.jsx)("span", {
					className: "dc__first-letter-capitalize fs-12 fw-4 lh-18 cn-9 dc__word-break",
					children: i.message
				})]
			})]
		}) })
	]
}, `${t}-${r}-feasibility`), lf = ({ isLoading: e, deployStatusList: t, filterConfig: { sortBy: n, sortOrder: r, handleSorting: i } }) => {
	let a = t.some((e) => e.isVirtualEnv && e.triggerStatus.code === $s.processed);
	return /* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
		className: `display-grid dc__column-gap-16 releases__deploy-feasibility-table-row releases__deploy-feasibility-table-row--header ${a ? "releases__deploy-feasibility-table-row--with-virtual-env" : ""} dc__border-bottom fs-12 fw-6 lh-20 cn-7 dc__align-items-center dc__uppercase dc__position-sticky dc__top-49 dc__zi-4 bg__primary px-20`,
		children: [
			/* @__PURE__ */ (0, J.jsx)(z, {
				isSorted: n === nf.appName,
				sortOrder: r,
				title: "Application",
				triggerSorting: () => {
					i(nf.appName);
				},
				disabled: e
			}),
			/* @__PURE__ */ (0, J.jsx)(z, {
				isSorted: n === nf.tenantInstallation,
				sortOrder: r,
				title: "Tenant (Installation)",
				triggerSorting: () => {
					i(nf.tenantInstallation);
				},
				disabled: e
			}),
			/* @__PURE__ */ (0, J.jsx)(z, {
				isSorted: n === nf.envName,
				sortOrder: r,
				title: "Environment",
				triggerSorting: () => {
					i(nf.envName);
				},
				disabled: e
			}),
			/* @__PURE__ */ (0, J.jsx)(z, {
				isSorted: n === nf.triggerStatus,
				sortOrder: r,
				title: "Trigger Status",
				triggerSorting: () => {
					i(nf.triggerStatus);
				},
				disabled: e
			})
		]
	}), /* @__PURE__ */ (0, J.jsx)("div", {
		className: "dc__even-child--bcn-50",
		children: e ? bd.map((e) => /* @__PURE__ */ (0, J.jsxs)("div", {
			className: `display-grid dc__column-gap-16 releases__deploy-feasibility-table-row ${a ? "releases__deploy-feasibility-table-row--with-virtual-env" : ""} py-8 show-shimmer-loading px-20`,
			children: [
				/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading" }),
				/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading" }),
				/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading" }),
				/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading" })
			]
		}, `${e.appName}-${e.envName}-feasibility-loading`)) : t.map((e) => /* @__PURE__ */ Me(cf, {
			...e,
			key: `${e.appName}-${e.envName}`
		}))
	})] });
}, uf = ({ handleClose: e, stage: t, filteredBulkSelectionState: n, handleRetryDeployment: r }) => {
	let i = Ai(), a = ki(), { search: o } = Oi(), { id: s } = Q(), { sortBy: c, sortOrder: l, handleSorting: u } = mi({ initialSortKey: nf.triggerStatus }), f = k(() => ({
		sortBy: c,
		sortOrder: l
	}), [c, l]), [p, m, h, g] = K(() => Tu({
		id: s,
		bulkSelectionState: n,
		stage: t
	}), [n], Object.keys(n).length > 0, { resetOnChange: !1 }), _ = p && !m, v = k(() => {
		if (m?.result?.length) {
			let { result: e } = m;
			return e.sort((e, t) => c === nf.envName ? G(e.envName, t.envName, l) : c === nf.triggerStatus ? Ur(e.triggerStatus.sortPriority, t.triggerStatus.sortPriority, l) : c === nf.tenantInstallation ? G(e.tenantConfig.displayText, t.tenantConfig.displayText, l) : G(e.appName, t.appName, l));
		}
		return [];
	}, [m, f]), y = v?.some((e) => e.triggerStatus?.code === $s.notProcessed), b = () => /* @__PURE__ */ (0, J.jsx)("button", {
		type: "button",
		className: "cta secondary flex",
		onClick: e,
		children: "Close"
	});
	if (!t || !Object.keys(n).length) return /* @__PURE__ */ (0, J.jsx)(F, {
		title: "Couldn't verify the images for selected deployment",
		classname: "flex-grow-1",
		isButtonAvailable: !0,
		renderButton: b
	});
	let x = (e) => {
		e.stopPropagation(), r(v.reduce((e, t) => (e[vc(t)] = t.triggerStatus.code === $s.notProcessed, e), {}));
	}, S = () => {
		e();
		let t = q(I.RELEASES.DETAIL.ROLLOUT_RELEASE, {
			releaseTrack: i.releaseTrack,
			releaseVersion: i.releaseVersion
		}), n = new URLSearchParams(o);
		n.set("tab", Ed.rolloutStatus), a({
			pathname: t,
			search: n.toString()
		});
	};
	return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)("div", {
		className: "flexbox-col flex-grow-1 dc__overflow-auto",
		children: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col flex-grow-1 dc__overflow-auto",
			children: [/* @__PURE__ */ (0, J.jsx)("div", {
				className: "dc__position-sticky dc__top-0 bg__primary dc__zi-20",
				children: /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flex flex-justify dc__border-bottom pt-10 pr-20 pb-10 pl-20",
					children: [/* @__PURE__ */ (0, J.jsxs)("h2", {
						className: "fs-16 fw-6 lh-24 m-0 dc__ellipsis-right",
						children: [/* @__PURE__ */ (0, J.jsx)("span", {
							className: "dc__inline-block dc__first-letter-capitalize",
							children: pr(t)
						}), "\xA0trigger status"]
					}), /* @__PURE__ */ (0, J.jsx)("button", {
						type: "button",
						className: "dc__transparent dc__no-shrink flexbox",
						"aria-label": "close-modal",
						onClick: e,
						children: /* @__PURE__ */ (0, J.jsx)(d, { className: "icon-dim-24 icon-use-fill-n6" })
					})]
				})
			}), /* @__PURE__ */ (0, J.jsx)(Ie, {
				isLoading: _,
				customLoader: /* @__PURE__ */ (0, J.jsx)(F, {
					title: "Fetching deployment trigger status...",
					subTitle: "It might take some time depending upon the number of deployments",
					classname: "flex-grow-1",
					imgName: "img-mechanical-operation"
				}),
				error: h,
				errorScreenManagerProps: {
					code: h?.code,
					reload: g
				},
				children: /* @__PURE__ */ (0, J.jsx)("div", {
					className: "flexbox-col flex-grow-1",
					children: !p && !v?.length ? /* @__PURE__ */ (0, J.jsx)(F, {
						title: "Could not find selected deployment pipeline(s)",
						subTitle: "Looks like the deployment pipeline(s) selected by you do not exist anymore",
						classname: "dc__text-center flex flex-grow-1"
					}) : /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)(nn, {
						description: "Pipelines are triggered asynchronously. You can close this drawer, the actions will be performed in the background.",
						borderConfig: {
							top: !1,
							left: !1,
							right: !1
						},
						borderRadiusConfig: {
							top: !1,
							left: !1,
							right: !1,
							bottom: !1
						}
					}), /* @__PURE__ */ (0, J.jsx)(lf, {
						deployStatusList: v,
						isLoading: p,
						filterConfig: {
							...f,
							handleSorting: u
						}
					})] })
				})
			})]
		})
	}), !_ && !h && /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "px-20 py-16 flex dc__content-end dc__gap-12 dc__border-top",
		children: [/* @__PURE__ */ (0, J.jsxs)("button", {
			className: `cta ${y ? "secondary" : ""} flex dc__no-shrink dc__gap-8 h-36`,
			type: "button",
			disabled: p,
			onClick: S,
			children: ["Go to rollout status", /* @__PURE__ */ (0, J.jsx)(we, { className: `${y ? "scn-6" : "scn-0"} dc__no-shrink icon-dim-16` })]
		}), y && /* @__PURE__ */ (0, J.jsxs)(et, {
			rootClassName: "cta flex dc__no-shrink dc__gap-8 h-36",
			type: "button",
			disabled: p,
			onClick: x,
			isLoading: p,
			children: [/* @__PURE__ */ (0, J.jsx)(De, { className: "scn-0 dc__no-svg-fill dc__no-shrink icon-dim-16" }), "Retry Failed"]
		})]
	})] });
}, df = (e) => {
	let { handleClose: t } = e;
	return /* @__PURE__ */ (0, J.jsx)(Mt, {
		position: "right",
		width: "1024px",
		onEscape: t,
		children: /* @__PURE__ */ (0, J.jsx)("div", {
			className: "bg__primary h-100 flexbox-col show-shimmer-loading",
			children: /* @__PURE__ */ (0, J.jsx)(uf, { ...e })
		})
	});
}, ff = ({ isLoading: e, filteredCount: t, totalCount: n, filterTargetText: r }) => /* @__PURE__ */ (0, J.jsxs)("p", {
	className: "m-0 cn-9 fs-13 fw-4 lh-20 dc__truncate",
	children: ["Showing filtered results\xA0", /* @__PURE__ */ (0, J.jsxs)("span", {
		className: "fw-6",
		children: [
			e ? "--" : t,
			" out of\xA0",
			e ? "--" : n,
			" ",
			r
		]
	})]
}), pf = ({ filterCountSummary: e, isCountSummaryLoading: t, showTenantSummary: n }) => n ? /* @__PURE__ */ (0, J.jsx)(ff, {
	isLoading: t,
	filteredCount: e.tenantsCount.filteredCount,
	totalCount: e.tenantsCount.totalCount,
	filterTargetText: "tenants (installation)"
}) : /* @__PURE__ */ (0, J.jsx)(ff, {
	isLoading: t,
	filteredCount: e.deploymentsCount.filteredCount,
	totalCount: e.deploymentsCount.totalCount,
	filterTargetText: "deployment pipeline(s)"
}), mf = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M13.5 6.25L13.4995 2.5005L9.75 2.5M8.99821 7.00179L13.4982 2.50179M11.5 9V13C11.5 13.1326 11.4473 13.2598 11.3536 13.3536C11.2598 13.4473 11.1326 13.5 11 13.5H3C2.86739 13.5 2.74021 13.4473 2.64645 13.3536C2.55268 13.2598 2.5 13.1326 2.5 13V5C2.5 4.86739 2.55268 4.74021 2.64645 4.64645C2.74021 4.55268 2.86739 4.5 3 4.5H7",
		stroke: "#FFF",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hf = () => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "flexbox-col dc__gap-4 lh-20",
	children: [/* @__PURE__ */ (0, J.jsx)("div", { children: "Map these environments to a tenant installation to deploy this release." }), /* @__PURE__ */ (0, J.jsxs)(wi, {
		to: I.TENANTS.ROOT,
		target: "_blank",
		className: "anchor fs-13 fw-4 lh-18 cb-5 flexbox dc__align-items-center dc__gap-6",
		children: [/* @__PURE__ */ (0, J.jsx)("span", {
			className: "dc__underline",
			children: "Map environments to tenant"
		}), /* @__PURE__ */ (0, J.jsx)(mf, { className: "icon-dim-14 dc__no-shrink scb-5" })]
	})]
}), gf = ({ unmappedEnvironments: e }) => /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)("div", {
	className: "p-8",
	children: /* @__PURE__ */ (0, J.jsx)(nn, {
		variant: "warning",
		description: /* @__PURE__ */ (0, J.jsx)(hf, {})
	})
}), /* @__PURE__ */ (0, J.jsx)("div", {
	className: "p-8",
	children: e.map((e) => /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "px-8 py-6 cn-9 fs-13 lh-20 flexbox dc__align-items-center dc__gap-8",
		children: [/* @__PURE__ */ (0, J.jsx)(Mo, { className: "dc__no-shrink icon-dim-16 scn-6" }), /* @__PURE__ */ (0, J.jsx)("span", {
			className: "dc__truncate",
			children: e
		})]
	}, e))
})] }), _f = ({ unmappedEnvironments: e, handleClose: t }) => /* @__PURE__ */ (0, J.jsx)(Mt, {
	position: "right",
	width: "420px",
	onEscape: t,
	onClose: t,
	children: /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col flex-grow-1 dc__overflow-auto h-100 bg__primary",
		onClick: ei,
		children: [/* @__PURE__ */ (0, J.jsx)("div", {
			className: "dc__position-sticky dc__top-0 bg__primary dc__zi-20",
			children: /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flex flex-justify dc__border-bottom pt-10 pr-20 pb-10 pl-20",
				children: [/* @__PURE__ */ (0, J.jsxs)("h2", {
					className: "fs-16 fw-6 lh-24 m-0 dc__ellipsis-right",
					children: [e.length, " unmapped environment(s) in this release"]
				}), /* @__PURE__ */ (0, J.jsx)("button", {
					type: "button",
					className: "dc__transparent dc__no-shrink flexbox",
					"aria-label": "close-modal",
					onClick: t,
					children: /* @__PURE__ */ (0, J.jsx)(d, { className: "icon-dim-20 icon-use-fill-n6" })
				})]
			})
		}), /* @__PURE__ */ (0, J.jsx)("div", {
			className: "flexbox-col flex-grow-1 dc__overflow-auto",
			children: /* @__PURE__ */ (0, J.jsx)(gf, { unmappedEnvironments: e })
		})]
	})
}), vf = ({ reloadData: e, isLoading: t, lastSyncedTimestamp: n, hidePollingToggle: r = !1, children: a }) => {
	let [o, s] = A("0s ago"), c = Pe(null), { urlFilterConfig: l, updateFilters: u, clearFilters: d, selectedTab: f, handleTabChange: p, triggerReleaseView: m, areFiltersActive: h, appEnvAndTenantListApiState: { appEnvAndTenantList: { tenantsWithInstallations: g, unmappedEnvironments: _, releaseChannels: v }, isAppEnvAndTenantLoading: y }, handleTriggerReleaseViewChange: b, shouldPoll: x, handleUpdateShouldPoll: S, filterCountSummary: C, isCountSummaryLoading: w } = $d(), T = () => `${n ? Ar({
		startTime: n,
		endTime: (/* @__PURE__ */ new Date()).toISOString(),
		fallbackString: ""
	}) : "0s"} ago`;
	O(() => (n && (s(T()), c.current = setInterval(() => {
		s(T());
	}, 1e3)), () => {
		c.current && clearInterval(c.current);
	}), [n]);
	let [ee, E] = A(!1), { tenantWithInstallationIdentifierToDisplayTextMap: te, releaseChannelIdToNameMap: ne } = k(() => ({
		tenantWithInstallationIdentifierToDisplayTextMap: Hd(g),
		releaseChannelIdToNameMap: Ud(v)
	}), [g, v]), re = f === Ed.rolloutStatus, ie = _.length, ae = f === Ed.triggerRelease && m === Dd.installation, oe = () => {
		b(ae ? Dd.pipeline : Dd.installation);
	}, D = () => {
		S(!x);
	}, se = () => {
		E((e) => !e);
	}, ce = (e, t) => e === Ad.tenantInstallation ? te[t] : e === Ad.releaseChannelId ? ne[t] : Rd(e, t);
	return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [
		/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "w-100 flex dc__content-space dc__gap-8 bg__primary border__primary--bottom",
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flex left dc__gap-12 p-12",
				children: [/* @__PURE__ */ (0, J.jsx)(kn, {
					segments: Nd,
					value: f,
					size: P.xs,
					name: "release-deploy-tabs",
					onChange: p
				}), !re && /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__divider h-20" }), /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flex left dc__gap-8",
					children: [/* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flex left dc__gap-4",
						children: [/* @__PURE__ */ (0, J.jsx)(Wn, {
							theme: Gn.white,
							className: "w-400 dc__align-left",
							placement: "bottom-start",
							Icon: de,
							iconClass: "fcv-5",
							infoText: /* @__PURE__ */ (0, J.jsxs)("div", {
								className: "fs-13 fw-4 lh-20 cn-9",
								children: [/* @__PURE__ */ (0, J.jsx)("div", { children: "Installation view allows you to initiate deployment for all applications to a tenant installation at once." }), /* @__PURE__ */ (0, J.jsx)("div", {
									className: "mt-20",
									children: "As of now, deployment from installation view is only available for installations with isolated environments."
								})]
							}),
							heading: "Installation view",
							showCloseButton: !0,
							trigger: "click",
							interactive: !0,
							documentationLink: "RELEASE_HUB",
							documentationLinkText: "View documentation",
							children: /* @__PURE__ */ (0, J.jsx)("div", {
								className: "flex cursor",
								children: /* @__PURE__ */ (0, J.jsx)(i, { className: "fcn-6 icon-dim-20 dc__no-shrink" })
							})
						}), /* @__PURE__ */ (0, J.jsx)("span", {
							className: "fs-13 fw-4 lh-20 cn-9",
							children: "Installation view"
						})]
					}), m && /* @__PURE__ */ (0, J.jsx)(bt, {
						name: "installation-view-toggle",
						ariaLabel: "Toggle installation view",
						isChecked: ae,
						onChange: oe,
						size: P.small
					})]
				})] })]
			}), /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flex dc__content-start dc__gap-8 fs-13 lh-20 fw-6 cn-9 h-100",
				children: [(y || ie > 0) && /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [y ? /* @__PURE__ */ (0, J.jsx)("div", { className: "shimmer-loading w-150 h-24 br-2" }) : /* @__PURE__ */ (0, J.jsxs)("button", {
					type: "button",
					className: "dc__transparent bcy-1 br-4 px-8 py-2 fs-12 fw-4 lh-20 cn-9 flexbox dc__align-items-center dc__gap-6",
					onClick: se,
					children: [/* @__PURE__ */ (0, J.jsx)(Yt, {
						name: "ic-warning",
						color: null,
						size: 16
					}), /* @__PURE__ */ (0, J.jsxs)("span", { children: [
						ie,
						" unmapped\xA0",
						ie === 1 ? "env" : "envs"
					] })]
				}), /* @__PURE__ */ (0, J.jsx)("div", { className: "divider__secondary h-100" })] }), !r && /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox dc__gap-8 pr-12 py-12 dc__align-items-center",
					children: [x ? t ? /* @__PURE__ */ (0, J.jsx)(Yt, {
						name: "ic-circle-loader",
						color: "O500",
						size: 20
					}) : /* @__PURE__ */ (0, J.jsx)(Ve, {
						duration: 30,
						onComplete: e,
						size: 20,
						tooltipContent: "Syncing every 30 Seconds"
					}) : t ? /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox dc__gap-6 py-2 px-8 dc__align-items-center",
						children: [/* @__PURE__ */ (0, J.jsx)(Yt, {
							name: "ic-circle-loader",
							color: "O500",
							size: 14
						}), /* @__PURE__ */ (0, J.jsx)("span", {
							className: "dc__loading-dots cn-7 fs-12 fw-6 lh-20",
							children: "Syncing"
						})]
					}) : /* @__PURE__ */ (0, J.jsx)(M, {
						dataTestId: "reload-content-button",
						onClick: e,
						variant: N.borderLess,
						size: P.xs,
						style: $e.neutral,
						startIcon: /* @__PURE__ */ (0, J.jsx)(Yt, {
							name: "ic-arrow-clockwise",
							color: null
						}),
						text: o
					}), /* @__PURE__ */ (0, J.jsx)(bt, {
						name: "should-poll-toggle",
						ariaLabel: "Toggle auto-sync",
						tooltipContent: `${x ? "Disable" : "Enable"} auto-sync`,
						isChecked: x,
						onChange: D,
						shape: "square",
						variant: "positive",
						iconName: "ic-arrows-clockwise"
					})]
				})]
			})]
		}),
		/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col dc__align-items-center dc__gap-12 flex-grow-1 dc__overflow-auto",
			children: [h && /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "w-100 flexbox-col dc__gap-8 px-12 pt-12",
				children: [/* @__PURE__ */ (0, J.jsx)(Bt, {
					filterConfig: {
						...l,
						...re && {
							preStage: [],
							deployStage: [],
							postStage: [],
							rolloutStatus: null
						},
						...ae && {
							preStage: [],
							deployStage: [],
							postStage: [],
							app: [],
							env: [],
							tenantInstallation: []
						}
					},
					onRemoveFilter: u,
					clearFilters: d,
					getFormattedLabel: Id,
					getFormattedValue: ce,
					className: "p-0 w-100",
					clearButtonClassName: "dc__no-background-imp dc__no-border-imp dc__tab-focus"
				}), /* @__PURE__ */ (0, J.jsx)("div", {
					className: "dc__no-shrink dc__mxw-1400",
					children: /* @__PURE__ */ (0, J.jsx)(pf, {
						isCountSummaryLoading: w,
						filterCountSummary: C,
						showTenantSummary: re || ae
					})
				})]
			}), a]
		}),
		ee && /* @__PURE__ */ (0, J.jsx)(_f, {
			handleClose: se,
			unmappedEnvironments: _
		})
	] });
}, yf = ({ urlFilterConfig: e, serviceHandler: t, additionalRequestMap: n }) => {
	let { refetchReleaseDetail: r } = Q(), [i, a] = A(!1), [o, s] = A(null), [c, l] = A(""), u = async () => {
		let e = await t();
		return await r(), l((/* @__PURE__ */ new Date()).toISOString()), e;
	}, [d, f, p, m, h] = K(u, [JSON.stringify(e)]);
	return {
		handleExternalSync: async () => {
			try {
				a(!0), s(null);
				let e = await u();
				await Promise.all(Object.values(n?.current || {}).map((e) => e ? e() : null)), e && h(e);
			} catch (e) {
				s(e);
			} finally {
				a(!1);
			}
		},
		isExternalSyncLoading: i || yr(o),
		isContentLoading: d || yr(p),
		lastSyncedTimestamp: c,
		refetchResponse: m,
		initialError: p,
		responseData: f
	};
}, bf = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M7.34833 14.419C6.46444 17.0707 2.92891 17.0707 2.92891 17.0707C2.92891 17.0707 2.92891 13.5351 5.58056 12.6513M9.99998 13.5351L15.3033 8.23183C17.3114 6.2237 17.2918 4.21556 17.164 3.35914C17.1444 3.22728 17.0829 3.10522 16.9886 3.01095C16.8944 2.91668 16.7723 2.85518 16.6404 2.83553C15.784 2.70775 13.7759 2.68816 11.7677 4.6963L6.46444 9.9996M9.99998 13.5351L6.46444 9.9996M9.99998 13.5351L10.6548 16.8094C10.677 16.9203 10.7289 17.0232 10.8049 17.1069C10.881 17.1907 10.9783 17.2522 11.0866 17.285C11.1949 17.3178 11.31 17.3206 11.4197 17.2931C11.5294 17.2655 11.6296 17.2088 11.7096 17.1288L14.2363 14.6021C14.2944 14.544 14.3404 14.4751 14.3718 14.3993C14.4032 14.3235 14.4194 14.2422 14.4194 14.1601V9.11572M6.46444 9.9996L3.19017 9.34474C3.07924 9.32256 2.97642 9.27068 2.89266 9.19465C2.8089 9.11861 2.74734 9.02127 2.71456 8.913C2.68178 8.80473 2.679 8.68959 2.70651 8.57986C2.73403 8.47013 2.79081 8.36993 2.8708 8.28994L5.3975 5.76324C5.45554 5.7052 5.52444 5.65917 5.60027 5.62776C5.6761 5.59635 5.75737 5.58018 5.83944 5.58018H10.8839",
		stroke: "#fff",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xf = /* @__PURE__ */ t({ default: () => Sf }), Sf = ({ type: e, setActionButtonDisabled: t, rootClassName: n = "" }) => {
	let [r, i] = A(""), a = () => {
		let t = "";
		switch (e) {
			case cn.RESOURCE:
			case cn.PIPELINE:
				t = "Delete ";
				break;
			default: t = "";
		}
		return `${t}${ar(cn[e].toLowerCase())}`;
	};
	return /* @__PURE__ */ (0, J.jsx)("div", {
		className: n,
		children: /* @__PURE__ */ (0, J.jsx)(pt, {
			placeholder: "Type to confirm",
			value: r,
			name: "delete-dialog-input",
			label: /* @__PURE__ */ (0, J.jsxs)("span", { children: [
				"Type\xA0",
				/* @__PURE__ */ (0, J.jsx)("span", {
					className: "fw-6",
					children: `'${a()}'`
				}),
				"\xA0 to confirm"
			] }),
			onChange: (e) => {
				i(e.target.value), t(e.target.value ? e.target.value !== a() : !0);
			},
			autoFocus: !0
		})
	});
}, Cf = /* @__PURE__ */ t({ default: () => wf }), wf = ({ actionHandler: e, handleOnClose: t, modalType: n }) => {
	let [r, i] = A(!0);
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "dc__border bg__primary br-4 w-300 dc__position-abs dc__right-20 dc__bottom-12 dc__box-shadow--overlay",
		children: [
			/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "dc__word-break dc__hyphens-auto flex left p-12 cn-9 dc__border-bottom-n1",
				children: [/* @__PURE__ */ (0, J.jsxs)("span", {
					className: "fs-14 fw-6 lh-20 mr-6",
					children: [oe[n], " is blocked"]
				}), /* @__PURE__ */ (0, J.jsx)("div", {
					className: "icon-dim-16 ml-auto",
					children: /* @__PURE__ */ (0, J.jsx)(d, {
						className: "icon-dim-16 cursor fcn-9",
						onClick: t
					})
				})]
			}),
			/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "dc__word-break dc__hyphens-auto fs-13 fw-4 lh-20 p-12",
				children: [oe[n], " for some applications is blocked due to deployment window"]
			}),
			/* @__PURE__ */ (0, J.jsx)(Sf, {
				type: n,
				rootClassName: "pl-12 pr-12",
				setActionButtonDisabled: i
			}),
			/* @__PURE__ */ (0, J.jsx)("hr", { className: "mt-12 mb-12" }),
			/* @__PURE__ */ (0, J.jsx)("div", {
				className: "flex flex-justify-end h-32 mb-12 mr-12",
				children: /* @__PURE__ */ (0, J.jsxs)("button", {
					className: `flex cta h-32 ${r ? "disabled-opacity" : ""}`,
					"data-testid": "bulk-deploy-confirm-button",
					type: "button",
					onClick: (t) => {
						r || e(t);
					},
					children: [/* @__PURE__ */ (0, J.jsx)(bf, { className: "icon-dim-16 dc__no-svg-fill mr-8" }), ar(n)]
				})
			})
		]
	});
}, Tf = ({ handleClose: e, handleSuccess: t }) => /* @__PURE__ */ (0, J.jsx)(ut, {
	variant: dt.warning,
	title: "Cannot change images once deployment is initiated",
	subtitle: "You will not be able to change images for this release once deployment is initiated",
	handleClose: e,
	buttonConfig: {
		secondaryButtonConfig: {
			text: "Cancel",
			onClick: e
		},
		primaryButtonConfig: {
			text: "Deploy",
			onClick: t
		}
	},
	children: /* @__PURE__ */ (0, J.jsx)("span", {
		className: "fs-13 cn-7 lh-20",
		children: "Are you sure to initiate deployment?"
	})
}), Ef = ({ isLoading: e, feasibilityList: t, filterConfig: { sortBy: n, sortOrder: r, handleSorting: i } }) => !e && !t?.length ? /* @__PURE__ */ (0, J.jsx)(F, {
	title: "Could not find selected deployment pipeline(s)",
	subTitle: "Looks like the deployment pipeline(s) selected by you do not exist anymore",
	classname: "dc__text-center"
}) : /* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
	className: "display-grid dc__column-gap-16 releases__deploy-feasibility-table-row releases__deploy-feasibility-table-row--header dc__border-bottom fs-12 fw-6 lh-20 cn-7 dc__align-items-center dc__uppercase dc__position-sticky dc__top-49 dc__zi-4 bg__primary px-20",
	children: [
		/* @__PURE__ */ (0, J.jsx)(z, {
			isSorted: n === Sd.appName,
			sortOrder: r,
			title: "Application",
			triggerSorting: () => {
				i(Sd.appName);
			},
			disabled: e
		}),
		/* @__PURE__ */ (0, J.jsx)(z, {
			isSorted: n === Sd.tenantInstallation,
			sortOrder: r,
			title: "Tenant (Installation)",
			triggerSorting: () => {
				i(Sd.tenantInstallation);
			},
			disabled: e
		}),
		/* @__PURE__ */ (0, J.jsx)(z, {
			isSorted: n === Sd.envName,
			sortOrder: r,
			title: "Environment",
			triggerSorting: () => {
				i(Sd.envName);
			},
			disabled: e
		}),
		/* @__PURE__ */ (0, J.jsx)(z, {
			isSorted: n === Sd.feasibility,
			sortOrder: r,
			title: "Feasibility",
			triggerSorting: () => {
				i(Sd.feasibility);
			},
			disabled: e
		})
	]
}), /* @__PURE__ */ (0, J.jsx)("div", {
	className: "dc__even-child--bcn-50",
	children: e ? yd.map((e) => /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "display-grid dc__column-gap-16 releases__deploy-feasibility-table-row py-8 show-shimmer-loading px-20",
		children: [
			/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading" }),
			/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading" }),
			/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading" }),
			/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading" })
		]
	}, `${e.appName}-${e.envName}-feasibility-loading`)) : t.map((e) => /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "display-grid dc__column-gap-16 releases__deploy-feasibility-table-row fs-13 fw-4 lh-20 cn-9 py-8 px-20",
		children: [
			/* @__PURE__ */ (0, J.jsx)("span", {
				className: "dc__truncate",
				children: e.appName
			}),
			/* @__PURE__ */ (0, J.jsx)("span", { children: /* @__PURE__ */ (0, J.jsxs)("span", {
				className: "flexbox dc__align-items-center dc__gap-8",
				children: [/* @__PURE__ */ (0, J.jsx)(sf, { imageProps: {
					src: e.tenantConfig.image,
					height: 20,
					width: 20
				} }), /* @__PURE__ */ (0, J.jsx)("span", {
					className: "dc__truncate",
					children: e.tenantConfig.displayText
				})]
			}) }),
			/* @__PURE__ */ (0, J.jsx)("span", {
				className: "dc__truncate",
				children: e.envName
			}),
			/* @__PURE__ */ (0, J.jsx)("span", { children: /* @__PURE__ */ (0, J.jsxs)("span", {
				className: "flexbox dc__gap-4",
				children: [/* @__PURE__ */ (0, J.jsx)("span", {
					className: "icon-dim-20 dc__no-shrink p-2",
					children: e.feasibility.icon
				}), /* @__PURE__ */ (0, J.jsxs)("span", {
					className: "flexbox-col",
					children: [/* @__PURE__ */ (0, J.jsx)("span", {
						className: "dc__truncate",
						children: e.feasibility.text
					}), e.message && /* @__PURE__ */ (0, J.jsx)("span", {
						"data-testid": "release-feasibility-message",
						className: "dc__first-letter-capitalize fs-12 fw-4 lh-18 cn-9 dc__word-break",
						children: e.message
					})]
				})]
			}) })
		]
	}, `${e.appName}-${e.envName}-feasibility`))
})] }), Df = ({ handleClose: e, handleSuccess: t, bulkSelectionState: n = {}, stage: r }) => {
	let { id: i, status: a } = Q(), [o, s] = A(!1), [c, l] = A(!1), { sortBy: u, sortOrder: d, handleSorting: f } = mi({ initialSortKey: Sd.feasibility }), p = k(() => ({
		sortBy: u,
		sortOrder: d
	}), [u, d]), [m, h, g, _] = K(() => Cu({
		id: i,
		bulkSelectionState: n,
		stage: r
	}), [], Object.keys(n).length > 0, { resetOnChange: !1 }), v = m && !h, y = k(() => {
		if (h?.result?.length) {
			let { result: e } = h;
			return e.sort((e, t) => u === Sd.envName ? G(e.envName, t.envName, d) : u === Sd.feasibility ? Ur(e.feasibility.sortPriority, t.feasibility.sortPriority, d) : u === Sd.tenantInstallation ? G(e.tenantConfig.displayText, t.tenantConfig.displayText, d) : G(e.appName, t.appName, d));
		}
		return [];
	}, [h, p]), b = () => /* @__PURE__ */ (0, J.jsx)("button", {
		type: "button",
		className: "cta secondary flex",
		onClick: e,
		children: "Close"
	});
	if (!r || !Object.keys(n).length) return /* @__PURE__ */ (0, J.jsx)(F, {
		title: "Couldn't verify the images for selected deployment",
		classname: "flex-grow-1",
		isButtonAvailable: !0,
		renderButton: b
	});
	let x = y.length, S = y.filter((e) => Pc.includes(e.feasibility.code)).length || 0, C = () => {
		s(!1);
	}, w = () => {
		l(!1);
	}, T = () => {
		s(!0);
	}, ee = () => {
		if (c) {
			l(!1), T();
			return;
		}
		o && s(!1), t(y.reduce((e, t) => (e[vc(t)] = t.feasibility.statusCode === ys.CanTrigger, e), {}));
	}, E = () => {
		if (y.some((e) => e.feasibility.code === ys.CanTriggerInDeploymentWindow)) {
			l(!0);
			return;
		}
		if (a === Z.READY_FOR_RELEASE) {
			T();
			return;
		}
		ee();
	};
	return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [
		/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col flex-grow-1 dc__overflow-auto",
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col flex-grow-1 dc__overflow-auto",
				children: [/* @__PURE__ */ (0, J.jsx)("div", {
					className: "dc__position-sticky dc__top-0 bg__primary dc__zi-20",
					children: /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flex flex-justify dc__border-bottom pt-10 pr-20 pb-10 pl-20",
						children: [/* @__PURE__ */ (0, J.jsxs)("h2", {
							className: "fs-16 fw-6 lh-24 m-0 dc__ellipsis-right",
							children: [
								"Review feasibility for ",
								pr(r),
								"(s)"
							]
						}), /* @__PURE__ */ (0, J.jsx)("button", {
							type: "button",
							className: "dc__transparent dc__no-shrink flexbox",
							"aria-label": "close-modal",
							onClick: e,
							children: /* @__PURE__ */ (0, J.jsx)(Ee, { className: "icon-dim-24 icon-use-fill-n6" })
						})]
					})
				}), /* @__PURE__ */ (0, J.jsx)(Ie, {
					isLoading: v,
					customLoader: /* @__PURE__ */ (0, J.jsx)(F, {
						title: "Verifying selected images for deployment",
						subTitle: "It might take some time depending upon the number of applications and environments",
						classname: "flex-grow-1",
						imgName: "img-mechanical-operation"
					}),
					error: g,
					errorScreenManagerProps: {
						code: g?.code,
						reload: _
					},
					children: /* @__PURE__ */ (0, J.jsx)("div", {
						className: "flexbox-col flex-grow-1",
						children: /* @__PURE__ */ (0, J.jsx)(Ef, {
							feasibilityList: y,
							isLoading: m,
							filterConfig: {
								...p,
								handleSorting: f
							}
						})
					})
				})]
			}), !v && !g && /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "px-20 py-10 flex dc__content-space dc__gap-12 dc__border-top",
				children: [/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox py-6 dc__gap-8",
					children: [/* @__PURE__ */ (0, J.jsx)(ce, { className: "icon-dim-20 dc__no-shrink warning-icon-y5-imp" }), /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox-col",
						children: [/* @__PURE__ */ (0, J.jsxs)("span", {
							className: "fs-13 fw-6 lh-20 cn-9 dc__truncate",
							children: [
								S,
								"/",
								x,
								" selected deployments can be initiated"
							]
						}), /* @__PURE__ */ (0, J.jsx)("span", {
							className: "fs-12 lh-18 cn-7 fw-4 dc__truncate",
							children: "You will not be able to change images for this release once deployment is initiated"
						})]
					})]
				}), /* @__PURE__ */ (0, J.jsxs)("button", {
					className: "cta flex dc__no-shrink dc__gap-8 h-36",
					type: "button",
					disabled: !S || m,
					onClick: E,
					children: [/* @__PURE__ */ (0, J.jsx)(Po, { className: "scn-0 dc__no-svg-fill dc__no-shrink icon-dim-16" }), "Deploy"]
				})]
			})]
		}),
		c && /* @__PURE__ */ (0, J.jsx)(wf, {
			actionHandler: ee,
			handleOnClose: w,
			modalType: cn.DEPLOY
		}),
		o && /* @__PURE__ */ (0, J.jsx)(Tf, {
			handleClose: C,
			handleSuccess: ee
		})
	] });
}, Of = (e) => {
	let { handleClose: t } = e;
	return /* @__PURE__ */ (0, J.jsx)(Mt, {
		position: "right",
		width: "1024px",
		onEscape: t,
		children: /* @__PURE__ */ (0, J.jsx)("div", {
			className: "bg__primary h-100 flexbox-col show-shimmer-loading",
			children: /* @__PURE__ */ (0, J.jsx)(Df, { ...e })
		})
	});
}, kf = ({ children: e, tenantConfig: t }) => /* @__PURE__ */ (0, J.jsx)(D, {
	content: /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flex column left dc__gap-4 fs-12 lh-18 fw-4",
		children: [
			/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("div", {
				className: "fw-6",
				children: "Tenant (Installation)"
			}), /* @__PURE__ */ (0, J.jsx)("div", { children: t.displayText })] }),
			/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-bottom--n7 w-100" }),
			/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("div", {
				className: "fw-6",
				children: "Release Channel"
			}), /* @__PURE__ */ (0, J.jsx)("div", { children: t.installationConfig.releaseChannelName || Wu.label })] })
		]
	}),
	className: "default-tt",
	arrow: !1,
	placement: "right",
	children: e
}), Af = (e) => {
	let t = null;
	switch (e) {
		case Y.DEPLOY_INITIATED:
		case Y.PRE_POST_INITIATED:
		case Y.PRE_POST_RUNNING:
		case Y.PROGRESSING:
		case Y.WAITING_TO_START:
			t = Rn.PROGRESSING;
			break;
		case Y.QUEUED:
			t = Rn.QUEUED;
			break;
		case Y.CANCELLED:
			t = Rn.CANCELLED;
			break;
		case Y.ABORTED:
			t = Rn.ABORTED;
			break;
		case Y.FAILED:
			t = Rn.FAILED;
			break;
		case Y.ERROR:
		case Y.UNABLE_TO_FETCH:
			t = Rn.ERROR;
			break;
		case Y.HEALTHY:
		case Y.SUCCEEDED:
			t = Rn.SUCCEEDED;
			break;
		case Y.TIMED_OUT:
			t = Rn.TIMED_OUT;
			break;
		case Y.NOT_TRIGGERED: return /* @__PURE__ */ (0, J.jsx)("div", {
			className: "dc__no-shrink flex icon-dim-16",
			children: /* @__PURE__ */ (0, J.jsx)(Be, {
				rootClassName: "dc__no-shrink",
				backgroundColorClass: "bcn-3",
				iconSizeClass: "icon-dim-8"
			})
		});
		default: return /* @__PURE__ */ (0, J.jsx)("span", { className: `dc__cd-trigger-status__icon ${(Object.values(Y).includes(e) ? e : Y.UNKNOWN).toLowerCase()} mr-0 w-16 h-16` });
	}
	return /* @__PURE__ */ (0, J.jsx)(Ln, {
		status: t,
		iconSize: 16,
		hideMessage: !0,
		hideIconTooltip: !0
	});
}, jf = (e) => {
	switch (e) {
		case Y.DEPLOY_INITIATED:
		case Y.PRE_POST_INITIATED:
		case Y.PRE_POST_RUNNING:
		case Y.QUEUED:
		case Y.PROGRESSING: return "co-7";
		case Y.SUCCEEDED:
		case Y.HEALTHY: return "cg-7";
		case Y.FAILED:
		case Y.ABORTED:
		case Y.TIMED_OUT:
		case Y.DEGRADED:
		case Y.ERROR:
		case Y.CANCELLED:
		case Y.UNABLE_TO_FETCH: return "cr-7";
		default: return "cn-9";
	}
}, Mf = (e) => {
	switch (e) {
		case Y.DEPLOY_INITIATED:
		case Y.PRE_POST_INITIATED:
		case Y.PRE_POST_RUNNING:
		case Y.QUEUED:
		case Y.PROGRESSING: return "eo-2 bw-1";
		case Y.SUCCEEDED:
		case Y.HEALTHY: return "eg-2 bw-1";
		case Y.FAILED:
		case Y.ABORTED:
		case Y.TIMED_OUT:
		case Y.DEGRADED:
		case Y.ERROR:
		case Y.CANCELLED:
		case Y.UNABLE_TO_FETCH: return "er-2 bw-1";
		default: return "en-2 bw-1";
	}
}, Nf = (e, t) => {
	switch (e) {
		case Y.DEPLOY_INITIATED:
		case Y.PROGRESSING:
		case Y.UNKNOWN:
		case Y.MISSING:
		case Y.UNABLE_TO_FETCH: return `${Yn.APPLICATION_MANAGEMENT_APP}/${t.appId}/details/${t.envId}`;
		case Y.PRE_POST_INITIATED:
		case Y.PRE_POST_RUNNING:
		case Y.QUEUED:
		case Y.SUCCEEDED:
		case Y.HEALTHY:
		case Y.FAILED:
		case Y.ABORTED:
		case Y.TIMED_OUT:
		case Y.DEGRADED:
		case Y.ERROR:
		case Y.CANCELLED: return t.triggerId ? q(I.RELEASES.DETAIL.HISTORY, {
			appId: String(t.appId),
			envId: String(t.envId),
			pipelineId: String(t.pipelineId),
			triggerId: String(t.triggerId),
			releaseTrack: t.releaseTrack,
			releaseVersion: t.releaseVersion
		}) : null;
		default: return null;
	}
}, Pf = ({ tippyContent: e, status: t, expandedModeProps: n = {}, stageType: r, redirectionParams: i, handleShowAppStatusModal: a }) => {
	let o = () => /* @__PURE__ */ (0, J.jsx)("div", {
		className: `flex dc__no-shrink icon-dim-24 dc__border-radius-50-per bg__primary ${Mf(t)}`,
		children: Af(t)
	});
	return /* @__PURE__ */ (0, J.jsx)(D, {
		content: e,
		arrow: !1,
		className: "default-tt",
		children: (() => {
			if (r === wt.DEPLOY) {
				let { isExpandedMode: e, appName: r, envName: i } = n;
				return /* @__PURE__ */ (0, J.jsx)("button", {
					type: "button",
					onClick: a,
					className: `dc__transparent ${e ? "flex-grow-1" : ""}`,
					"data-testid": `deployment-stage-status-${r}-${i}`,
					children: /* @__PURE__ */ (0, J.jsxs)("div", {
						className: `flexbox dc__align-items-center py-4 px-8 br-4 bg__primary ${e ? "w-100 dc__gap-4" : "dc__gap-8"} ${Mf(t)}`,
						children: [Af(t), e ? /* @__PURE__ */ (0, J.jsxs)("span", {
							className: `fs-12 fw-4 lh-20 ${jf(t)} dc__truncate`,
							children: [
								r,
								" (",
								i,
								")"
							]
						}) : /* @__PURE__ */ (0, J.jsx)(Po, { className: "icon-dim-16 dc__no-shrink" })]
					})
				});
			}
			let e = Nf(t, i), s = n?.isExpandedMode ?? !1;
			return e ? /* @__PURE__ */ (0, J.jsx)(wi, {
				to: e,
				target: "_blank",
				className: `dc__no-decor ${s ? "flex-grow-1" : ""}`,
				children: o()
			}) : o();
		})()
	});
}, Ff = (e, t, n) => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "flexbox-col dc__content-center dc__gap-8",
	children: [n.isExpandedMode && /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox dc__gap-4",
		children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col dc__align-items-center p-6",
			children: [
				/* @__PURE__ */ (0, J.jsx)("div", { className: "w-8 h-8 dc__border-radius-50-per border__white" }),
				/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__divider bcn-6" }),
				/* @__PURE__ */ (0, J.jsx)("div", { className: "w-8 h-8 dc__border-radius-50-per bg__white" })
			]
		}), /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col dc__gap-4",
			children: [/* @__PURE__ */ (0, J.jsx)("p", {
				className: "m-0 text__white fs-12 fw-6 lh-20 dc__truncate",
				children: n.appName
			}), /* @__PURE__ */ (0, J.jsx)("p", {
				className: "m-0 text__white fs-12 fw-6 lh-20 dc__truncate",
				children: n.envName
			})]
		})]
	}), /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col",
		children: [/* @__PURE__ */ (0, J.jsx)("h4", {
			className: "m-0 text__white fs-12 fw-6 lh-18",
			children: e
		}), /* @__PURE__ */ (0, J.jsx)("p", {
			className: "m-0 text__white fs-12 fw-4 lh-18",
			children: nc[t]
		})]
	})]
}), If = ({ deployStatus: e, preStatus: t, postStatus: n, isPreConfigured: r, isPostConfigured: i, expandedModeProps: a = {}, appId: o, envId: s, appName: c, envName: l, pipelineId: u, preCdWorkflowRunnerId: d, postCdWorkflowRunnerId: f }) => {
	let { track: p, version: m } = Q(), { setAppStatusModalConfig: h } = $d(), { isExpandedMode: g } = a, _ = !g || r, v = !g || i, y = {
		appId: o,
		envId: s,
		pipelineId: u,
		releaseTrack: p,
		releaseVersion: m
	}, b = () => {
		h({
			appId: o,
			envId: s,
			titleSegments: [c, l]
		});
	};
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: `flexbox ${g ? "w-214" : ""}`,
		children: [
			_ && /* @__PURE__ */ (0, J.jsxs)("div", {
				className: `flexbox dc__align-items-center ${r ? "" : "dc__visibility-hidden"}`,
				children: [/* @__PURE__ */ (0, J.jsx)(Pf, {
					status: t,
					tippyContent: Ff(ec.PRE_DEPLOY, t, a),
					redirectionParams: {
						...y,
						triggerId: d
					},
					stageType: wt.PRE
				}), /* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-bottom w-10" })]
			}),
			/* @__PURE__ */ (0, J.jsx)(Pf, {
				tippyContent: Ff(ec.DEPLOY, e, a),
				status: e,
				stageType: wt.DEPLOY,
				handleShowAppStatusModal: b,
				...g && { expandedModeProps: a }
			}),
			v && /* @__PURE__ */ (0, J.jsxs)("div", {
				className: `flexbox dc__align-items-center ${i ? "" : "dc__visibility-hidden"}`,
				children: [/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-bottom w-10" }), /* @__PURE__ */ (0, J.jsx)(Pf, {
					status: n,
					tippyContent: Ff(ec.POST_DEPLOY, n, a),
					redirectionParams: {
						...y,
						triggerId: f
					},
					stageType: wt.POST
				})]
			})
		]
	});
}, Lf = ({ status: e, showTippy: t }) => /* @__PURE__ */ (0, J.jsx)(lt, {
	condition: t,
	wrap: (t) => /* @__PURE__ */ (0, J.jsx)(D, {
		className: "default-tt",
		arrow: !1,
		content: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "dc__first-letter-capitalize",
			children: ["Deployment is ", nc[e]]
		}),
		children: t
	}),
	children: /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flex dc__content-start dc__gap-4 dc__no-shrink",
		children: [/* @__PURE__ */ (0, J.jsx)("div", {
			className: `flex dc__no-shrink icon-dim-14 dc__border-radius-50-per bg__primary ${Mf(e)}`,
			children: Af(e)
		}), /* @__PURE__ */ (0, J.jsx)("div", { children: nc[e] })]
	})
}), Rf = (e) => /* @__PURE__ */ (0, J.jsx)(D, {
	content: "No deployable pipeline(s) in this stage",
	placement: "top",
	className: "default-tt w-200",
	arrow: !1,
	children: /* @__PURE__ */ (0, J.jsx)("span", { children: e })
}), zf = ({ appEnv: e, isSomeRowChecked: t, bulkSelectionStateForStage: n, levelIndex: r }) => {
	let { appName: i, envName: a, deployStatus: o, preStatus: s, postStatus: c, existingStages: l, appId: u, envId: d, preCdWorkflowRunnerId: f, postCdWorkflowRunnerId: p, pipelineId: m } = e, { pre: h, post: g } = l, { isBulkSelectionApplied: _, handleBulkSelection: v } = ii(), y = vc(e), b = _ || !!n[y], x = t || b;
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: `display-grid dc__column-gap-16 releases__deploy-table-row dc__border-bottom-n1 fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-20 dc__visible-hover dc__visible-hover--parent ${b ? "bc-b50" : ""} dc__hover-n50`,
		children: [
			/* @__PURE__ */ (0, J.jsxs)("span", {
				className: "flex dc__content-start",
				children: [!x && /* @__PURE__ */ (0, J.jsx)(se, { className: "icon-dim-20 dc__visible-hover--hide-child" }), /* @__PURE__ */ (0, J.jsx)(lt, {
					condition: !e.isDeployable || e.isVirtualEnvironment,
					wrap: (t) => /* @__PURE__ */ (0, J.jsx)(D, {
						content: e.isDeployable ? "From the pipeline view, deployment is not available for isolated installations" : `Above application(s) in previous stage(s) must be deployed first on ${e.tenantConfig.displayText}`,
						placement: "top",
						className: "default-tt w-200",
						arrow: !1,
						children: /* @__PURE__ */ (0, J.jsx)("span", { children: t })
					}),
					children: /* @__PURE__ */ (0, J.jsx)(it, {
						isChecked: b ?? !1,
						onChange: () => {
							if (_) {
								v({
									action: Xe.CLEAR_IDENTIFIERS_AFTER_ACROSS_SELECTION,
									data: { identifierIds: [y] }
								});
								return;
							}
							v(n[y] ? {
								action: Xe.CLEAR_IDENTIFIERS,
								data: { identifierIds: [y] }
							} : {
								action: Xe.SELECT_IDENTIFIER,
								data: { identifierObject: {
									...n,
									[y]: yc(e, r)
								} }
							});
						},
						rootClassName: `mb-0 ${x ? "" : "dc__visible-hover--child"}`,
						value: rt.CHECKED,
						disabled: !e.isDeployable || e.isVirtualEnvironment
					})
				})]
			}),
			/* @__PURE__ */ (0, J.jsx)("span", {
				className: "dc__truncate",
				children: i
			}),
			/* @__PURE__ */ (0, J.jsx)(kf, {
				tenantConfig: e.tenantConfig,
				children: /* @__PURE__ */ (0, J.jsx)("span", {
					className: "dc__truncate dc__w-fit-content",
					children: e.tenantConfig.displayText
				})
			}),
			/* @__PURE__ */ (0, J.jsx)("span", {
				className: "dc__truncate",
				children: a
			}),
			/* @__PURE__ */ (0, J.jsx)(If, {
				deployStatus: o,
				preStatus: s,
				postStatus: c,
				isPreConfigured: h,
				isPostConfigured: g,
				appId: u,
				envId: d,
				appName: i,
				envName: a,
				preCdWorkflowRunnerId: f,
				postCdWorkflowRunnerId: p,
				pipelineId: m
			})
		]
	});
}, Bf = ({ id: e, isLoading: t, appEnvList: n, bulkSelectionStateConfig: { bulkSelectionStateForStage: r, setBulkSelectionState: i }, filterConfig: { sortBy: a, sortOrder: o, handleSorting: s }, allowedAllSelectionsLength: c }) => {
	let { selectedIdentifiers: l, handleBulkSelection: u, getSelectedIdentifiersCount: d } = ii(), f = d() > 0, p = c === 0;
	return O(() => {
		u({
			action: Xe.SELECT_IDENTIFIER,
			data: { identifierObject: r }
		});
	}, []), O(() => {
		Object.keys(r).length || u({ action: Xe.CLEAR_ALL_SELECTIONS });
	}, [r]), O(() => {
		let n = Object.keys(l).length, a = Object.keys(r).length;
		!t && a !== n && i((t) => ({
			...t,
			[e]: JSON.parse(JSON.stringify(l))
		}));
	}, [l, t]), /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "bg__primary",
		children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "display-grid dc__column-gap-16 dc__position-sticky dc__top-0 dc__zi-1 bg__primary releases__deploy-table-row releases__deploy-table-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center px-20 dc__uppercase",
			children: [
				/* @__PURE__ */ (0, J.jsx)("div", {
					className: `flex dc__content-start ${t ? "show-shimmer-loading" : ""}`,
					children: t ? /* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading w-100" }) : /* @__PURE__ */ (0, J.jsx)(lt, {
						condition: p,
						wrap: Rf,
						children: /* @__PURE__ */ (0, J.jsx)(Ye, {
							showPagination: !1,
							disabled: p
						})
					})
				}),
				/* @__PURE__ */ (0, J.jsx)(z, {
					isSorted: a === xd.appName,
					sortOrder: o,
					title: "Application",
					triggerSorting: () => {
						s(xd.appName);
					},
					disabled: t
				}),
				/* @__PURE__ */ (0, J.jsx)(z, {
					isSorted: a === xd.tenantInstallation,
					sortOrder: o,
					title: "Tenant (Installation)",
					triggerSorting: () => {
						s(xd.tenantInstallation);
					},
					disabled: t
				}),
				/* @__PURE__ */ (0, J.jsx)(z, {
					isSorted: a === xd.envName,
					sortOrder: o,
					title: "Environment",
					triggerSorting: () => {
						s(xd.envName);
					},
					disabled: t
				}),
				/* @__PURE__ */ (0, J.jsx)("span", { children: "Deployment Status" })
			]
		}), /* @__PURE__ */ (0, J.jsx)("div", { children: t ? vd.map((e) => /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "display-grid dc__column-gap-16 releases__deploy-table-row dc__border-bottom-n1 dc__align-items-center px-20 show-shimmer-loading",
			children: [
				/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading" }),
				/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading" }),
				/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading" }),
				/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading" }),
				/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading" })
			]
		}, `app-env-row--loading-${vc(e)}`)) : n.map((t) => /* @__PURE__ */ (0, J.jsx)(zf, {
			appEnv: t,
			isSomeRowChecked: f,
			bulkSelectionStateForStage: r,
			levelIndex: e
		}, `app-env-row-${vc(t)}`)) })]
	});
}, Vf = {
	[xd.appName]: "appName",
	[xd.envName]: "envName",
	[xd.tenantInstallation]: "tenantConfig.displayText"
}, Hf = (e, t) => t.split(".").reduce((e, t) => e[t], e), Uf = (e, t, n) => e.sort((e, r) => {
	let i = Vf[n], a = e[i], o = r[i];
	return a === o ? Object.keys(Vf).filter((e) => e !== n).map((e) => Vf[e]).reduce((n, i) => n === 0 ? G(Hf(e, i), Hf(r, i), t) : n, 0) : G(a, o, t);
}), Wf = () => An.OPEN, Gf = ({ id: e, handleUpdateIdToRefetchMapping: t, ...n }) => {
	let { id: r } = Q(), { sortBy: i, sortOrder: a, handleSorting: o } = mi({ initialSortKey: xd.appName }), { urlFilterConfig: s, areFiltersActive: c } = $d(), l = Pe(new AbortController()), u = async () => await rr(() => Su({
		releaseId: r,
		stageId: e,
		filterConfig: s
	}, l.current.signal), l), [d, f, p, m, h] = K(u, [e]), g = async () => {
		h(await u());
	};
	O(() => (t(e, g), () => {
		l.current.abort(), t(e, null);
	}), []);
	let _ = d || yr(p), v = k(() => ({
		sortBy: i,
		sortOrder: a
	}), [i, a]), y = k(() => {
		if (f?.result?.length) {
			let { result: e } = f;
			return Uf(e, a, i);
		}
		return [];
	}, [f, v]), b = k(() => y?.filter((e) => e.isDeployable && !e.isVirtualEnvironment)?.reduce((t, n) => (t[vc(n)] = yc(n, e), t), {}) ?? {}, [f]);
	if (!_) {
		if (p) return /* @__PURE__ */ (0, J.jsx)(Kt, {
			reload: m,
			rootClassName: "bg__primary"
		});
		if (!y?.length) return /* @__PURE__ */ (0, J.jsx)(Kt, {
			useInfoIcon: !0,
			title: c ? "No matching results found for selected filters" : "Could not find any mapped deployment pipeline(s)",
			subTitle: "",
			description: "",
			rootClassName: "p-32 bg__primary"
		});
	}
	return /* @__PURE__ */ (0, J.jsx)(Ze, {
		identifiers: b,
		getSelectAllDialogStatus: Wf,
		children: /* @__PURE__ */ (0, J.jsx)(Bf, {
			...n,
			id: e,
			isLoading: _,
			appEnvList: y,
			filterConfig: {
				...v,
				handleSorting: o
			},
			allowedAllSelectionsLength: Object.keys(b).length
		})
	});
}, Kf = ({ title: e, getContent: t, toggleAccordion: n, isExpanded: r }) => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "shadow__card--10 border__secondary br-8 dc__contain--paint",
	children: [/* @__PURE__ */ (0, J.jsxs)("button", {
		className: `dc__transparent py-10 pl-20 pr-8 flex dc__content-space dc__gap-8 w-100 ${r ? "bg__secondary" : "bg__primary"}`,
		type: "button",
		role: "tab",
		onClick: n,
		children: [/* @__PURE__ */ (0, J.jsx)("div", {
			className: "dc__truncate w-100",
			children: e
		}), /* @__PURE__ */ (0, J.jsx)(_e, { className: `icon-dim-24 p-2 dc__no-shrink dc__transition--transform ${r ? "dc__flip-180" : ""}` })]
	}), r && /* @__PURE__ */ (0, J.jsx)("div", { children: t() })]
}), qf = ({ id: e, icon: t, title: n, bulkSelectionStateConfig: r, handleUpdateIdToRefetchMapping: i }) => {
	let { stageListAccordionExpansionMap: a, setStageListAccordionExpansionMap: o } = $d();
	return /* @__PURE__ */ (0, J.jsx)(Kf, {
		title: /* @__PURE__ */ (0, J.jsx)("div", {
			className: "flex dc__gap-8 dc__content-space fs-13 lh-20",
			children: /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox dc__align-items-center dc__gap-8",
				children: [t, /* @__PURE__ */ (0, J.jsx)("span", {
					className: "dc__truncate dc__uppercase fw-6 cn-7",
					children: n
				})]
			})
		}),
		getContent: () => /* @__PURE__ */ (0, J.jsx)(Gf, {
			id: e,
			bulkSelectionStateConfig: r,
			handleUpdateIdToRefetchMapping: i
		}),
		isExpanded: a[e],
		toggleAccordion: () => {
			o((t) => ({
				...t,
				[e]: !t[e]
			}));
		}
	});
}, Jf = ({ selectedStage: e, setSelectedStage: t, isFeasibilityModalOpen: n, setIsFeasibilityModalOpen: r, handleClearBulkSelection: i, bulkSelectionState: a, setBulkSelectionState: o }) => {
	let { id: s, refetchReleaseDetail: c } = Q(), { urlFilterConfig: l, updateFilterCountSummary: u, resetFilterCountSummary: d, stageListAccordionExpansionMap: f, setStageListAccordionExpansionMap: p, triggerReleaseView: m, handleTriggerReleaseViewChange: h } = $d(), g = Pe({}), _ = Pe(new AbortController()), { handleExternalSync: v, isExternalSyncLoading: y, isContentLoading: b, lastSyncedTimestamp: x, refetchResponse: S, initialError: C, responseData: w } = yf({
		urlFilterConfig: l,
		serviceHandler: async () => await rr(() => xu({
			releaseId: s,
			filterConfig: l
		}, _.current.signal), _),
		additionalRequestMap: g
	}), [T, ee] = A({}), E = !!e && !n;
	O(() => (w && (Object.keys(f).length === 0 && p({ [w?.releaseStageList?.[0].id]: !0 }), u(w?.countSummary), (!m || !Object.values(Dd).some((e) => e === m)) && h(w.releaseStageList.flatMap((e) => e.applications).some((e) => e.isVirtualEnvironment) ? Dd.installation : Dd.pipeline)), () => {
		d();
	}), [w]);
	let te = () => {
		t(null), r(!1);
	}, ne = (e) => {
		ee(Pd(a, e)), r(!1);
	}, re = (e) => {
		ee(Pd(T, e));
	}, ie = async () => {
		t(null), i(), ee({}), S(), await c();
	}, ae = (e, t) => {
		g.current[e] = t;
	};
	return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [
		/* @__PURE__ */ (0, J.jsx)(vf, {
			reloadData: v,
			isLoading: y,
			lastSyncedTimestamp: x,
			hidePollingToggle: !!C || b || !m,
			children: (() => {
				if (b || !m) return /* @__PURE__ */ (0, J.jsx)("div", {
					className: "flex h-100",
					children: /* @__PURE__ */ (0, J.jsx)(_n, { pageLoader: !0 })
				});
				if (C) return /* @__PURE__ */ (0, J.jsx)(It, {
					code: C?.code,
					reload: S
				});
				let { releaseStageList: e } = w, t = e.length;
				return t ? /* @__PURE__ */ (0, J.jsx)("div", {
					className: "flexbox-col dc__mxw-1400 w-100 p-12",
					children: e.map((e, n) => /* @__PURE__ */ (0, J.jsxs)(Ae, { children: [/* @__PURE__ */ (0, J.jsx)(qf, {
						...e,
						handleUpdateIdToRefetchMapping: ae,
						bulkSelectionStateConfig: {
							bulkSelectionStateForStage: a[e.id] ?? {},
							setBulkSelectionState: o
						}
					}), n !== t - 1 && /* @__PURE__ */ (0, J.jsx)("div", { className: "w-28 h-24 dc__border-dashed--n3-right" })] }, e.id))
				}) : /* @__PURE__ */ (0, J.jsx)(F, {
					title: "No release stages found",
					subTitle: "There are no stages in given release"
				});
			})()
		}),
		n && /* @__PURE__ */ (0, J.jsx)(Of, {
			handleClose: te,
			handleSuccess: ne,
			bulkSelectionState: a,
			stage: e
		}),
		E && /* @__PURE__ */ (0, J.jsx)(df, {
			filteredBulkSelectionState: T,
			handleClose: ie,
			stage: e,
			handleRetryDeployment: re
		})
	] });
}, Yf = /* @__PURE__ */ function(e) {
	return e.tenantInstallation = "tenantInstallation", e;
}({}), Xf = /* @__PURE__ */ function(e) {
	return e.tenantInstallation = "tenantInstallation", e.feasibility = "feasibility", e;
}({}), Zf = ({ tenantConfig: e, tenantFeasibility: t, feasibilityList: n }) => {
	let [r, i] = A(!1);
	return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
		className: "display-grid dc__column-gap-16 releases__installation-feasibility-table-row fs-13 fw-4 lh-20 cn-9 py-8 px-20",
		children: [
			/* @__PURE__ */ (0, J.jsx)(sf, { imageProps: {
				src: e.image,
				height: 20,
				width: 20
			} }),
			/* @__PURE__ */ (0, J.jsx)("span", {
				className: "dc__truncate",
				children: e.displayText
			}),
			/* @__PURE__ */ (0, J.jsx)("span", { children: /* @__PURE__ */ (0, J.jsxs)("span", {
				className: "flexbox dc__gap-4",
				children: [/* @__PURE__ */ (0, J.jsx)("span", {
					className: "icon-dim-20 dc__no-shrink p-2",
					children: t.icon
				}), /* @__PURE__ */ (0, J.jsxs)("span", {
					className: "flexbox-col",
					children: [/* @__PURE__ */ (0, J.jsx)("span", {
						className: "dc__truncate",
						children: t.text
					}), t.message && /* @__PURE__ */ (0, J.jsx)("span", {
						className: "dc__first-letter-capitalize fs-12 fw-4 lh-18 cn-9",
						children: t.message
					})]
				})]
			}) }),
			t.statusCode === ys.CannotTrigger && /* @__PURE__ */ (0, J.jsx)("button", {
				type: "button",
				"aria-label": "expand",
				className: `p-8 dc__transparent br-4 dc__hover-n50 dc__h-fit-content flex dc__transition--transform ${r ? "dc__flip-180" : ""}`,
				onClick: () => {
					i((e) => !e);
				},
				children: /* @__PURE__ */ (0, J.jsx)(_e, { className: "icon-dim-16 dc__no-shrink scn-6" })
			})
		]
	}, e.identifier), r && /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "bg__secondary",
		children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "display-grid dc__column-gap-16 releases__installation-feasibility-pipeline-row releases__installation-feasibility-pipeline-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center px-20 dc__uppercase",
			children: [
				/* @__PURE__ */ (0, J.jsx)(z, {
					isSortable: !1,
					title: "Application"
				}),
				/* @__PURE__ */ (0, J.jsx)(z, {
					isSortable: !1,
					title: "Environment"
				}),
				/* @__PURE__ */ (0, J.jsx)("span", {})
			]
		}), /* @__PURE__ */ (0, J.jsx)("div", { children: n.map(({ appName: e, envName: t, feasibility: n, message: r }) => /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "display-grid dc__column-gap-16 releases__installation-feasibility-pipeline-row dc__border-bottom-n1 fs-13 fw-4 lh-20 cn-9 px-20 pt-8 pb-7",
			children: [
				/* @__PURE__ */ (0, J.jsx)("span", {
					className: "dc__truncate",
					children: e
				}),
				/* @__PURE__ */ (0, J.jsx)("span", {
					className: "dc__truncate",
					children: t
				}),
				/* @__PURE__ */ (0, J.jsx)("span", { children: /* @__PURE__ */ (0, J.jsxs)("span", {
					className: "flexbox dc__gap-4",
					children: [/* @__PURE__ */ (0, J.jsx)("span", {
						className: "icon-dim-20 dc__no-shrink p-2",
						children: n.icon
					}), /* @__PURE__ */ (0, J.jsx)("span", {
						className: "dc__first-letter-capitalize fs-13 fw-4 lh-20 cn-9 dc__word-break",
						children: r || n.text
					})]
				}) })
			]
		}, `${e}-${t}`)) })]
	})] });
}, Qf = ({ isLoading: e, groupedFeasibilityList: t, filterConfig: { sortBy: n, sortOrder: r, handleSorting: i } }) => {
	let a = (e) => () => {
		i(e);
	};
	return !e && !t?.length ? /* @__PURE__ */ (0, J.jsx)(F, {
		title: "Could not find selected installation(s)",
		subTitle: "Looks like the installation(s) selected by you do not exist anymore",
		classname: "dc__text-center"
	}) : /* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
		className: "display-grid dc__column-gap-16 releases__installation-feasibility-table-row releases__installation-feasibility-table-row--header dc__border-bottom fs-12 fw-6 lh-20 cn-7 dc__align-items-center dc__uppercase dc__position-sticky dc__top-49 dc__zi-4 bg__primary px-20",
		children: [
			/* @__PURE__ */ (0, J.jsx)("span", {}),
			/* @__PURE__ */ (0, J.jsx)(z, {
				isSorted: n === Xf.tenantInstallation,
				sortOrder: r,
				title: "Tenant (Installation)",
				triggerSorting: a(Xf.tenantInstallation),
				disabled: e
			}),
			/* @__PURE__ */ (0, J.jsx)(z, {
				isSorted: n === Xf.feasibility,
				sortOrder: r,
				title: "Feasibility",
				triggerSorting: a(Xf.feasibility),
				disabled: e
			})
		]
	}), /* @__PURE__ */ (0, J.jsx)("div", {
		className: "dc__even-child--bcn-50",
		children: e ? yd.map((e) => /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "display-grid dc__column-gap-16 releases__installation-feasibility-table-row py-8 show-shimmer-loading px-20",
			children: [
				/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading" }),
				/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading" }),
				/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading" })
			]
		}, `${e.appName}-${e.envName}-feasibility-loading`)) : t.map((e) => /* @__PURE__ */ Me(Zf, {
			...e,
			key: e.tenantConfig.identifier
		}))
	})] });
}, $f = ({ handleClose: e, handleSuccess: t, bulkSelectionState: n = {} }) => {
	let { id: r, status: i } = Q(), [a, o] = A(!1), [s, c] = A(!1), { sortBy: l, sortOrder: u, handleSorting: d } = mi({ initialSortKey: Xf.feasibility }), f = k(() => ({
		sortBy: l,
		sortOrder: u
	}), [l, u]), [p, m, h, g] = K(() => wu({
		id: r,
		bulkSelectionState: n
	}), [], Object.keys(n).length > 0, { resetOnChange: !1 }), _ = p && !m, v = k(() => m?.length ? l === Xf.feasibility ? m.sort((e, t) => Ur(e.tenantFeasibility.sortPriority, t.tenantFeasibility.sortPriority, u)) : m.sort((e, t) => G(e.tenantConfig.displayText, t.tenantConfig.displayText, u)) : [], [m, f]), y = () => /* @__PURE__ */ (0, J.jsx)(M, {
		text: "close",
		dataTestId: "close-modal",
		onClick: e,
		variant: N.secondary
	});
	if (!Object.keys(n).length) return /* @__PURE__ */ (0, J.jsx)(F, {
		title: "Couldn't verify the images for selected deployment",
		classname: "flex-grow-1",
		isButtonAvailable: !0,
		renderButton: y
	});
	let b = v.length, x = v.filter(({ tenantFeasibility: e }) => e.statusCode === ys.CanTrigger).length || 0, S = () => {
		o(!1);
	}, C = () => {
		c(!1);
	}, w = () => {
		o(!0);
	}, T = () => {
		if (s) {
			c(!1), w();
			return;
		}
		a && o(!1), t(v.filter(({ tenantFeasibility: e }) => e.statusCode === ys.CanTrigger).reduce((e, { tenantConfig: t }) => (e[t.identifier] = {
			tenantId: t.tenantId,
			installationId: t.installationConfig.installationId
		}, e), {}));
	}, ee = () => {
		if (v.some((e) => e.feasibilityList.some(({ feasibility: e }) => e.code === ys.CanTriggerInDeploymentWindow))) {
			c(!0);
			return;
		}
		if (i === Z.READY_FOR_RELEASE) {
			w();
			return;
		}
		T();
	};
	return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [
		/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col flex-grow-1 dc__overflow-auto",
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col flex-grow-1 dc__overflow-auto",
				children: [/* @__PURE__ */ (0, J.jsx)("div", {
					className: "dc__position-sticky dc__top-0 bg__primary dc__zi-20",
					children: /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flex flex-justify dc__border-bottom pt-10 pr-20 pb-10 pl-20",
						children: [/* @__PURE__ */ (0, J.jsx)("h2", {
							className: "fs-16 fw-6 lh-24 m-0 dc__ellipsis-right",
							children: "Review feasibility for deployments"
						}), /* @__PURE__ */ (0, J.jsx)("button", {
							type: "button",
							className: "dc__transparent dc__no-shrink flexbox",
							"aria-label": "close-modal",
							onClick: e,
							children: /* @__PURE__ */ (0, J.jsx)(Ee, { className: "icon-dim-24 icon-use-fill-n6" })
						})]
					})
				}), /* @__PURE__ */ (0, J.jsx)(Ie, {
					isLoading: _,
					customLoader: /* @__PURE__ */ (0, J.jsx)(F, {
						title: "Verifying selected images for deployment",
						subTitle: "It might take some time depending upon the number of applications and environments",
						classname: "flex-grow-1",
						imgName: "img-mechanical-operation"
					}),
					error: h,
					errorScreenManagerProps: {
						code: h?.code,
						reload: g
					},
					children: /* @__PURE__ */ (0, J.jsx)("div", {
						className: "flexbox-col flex-grow-1",
						children: /* @__PURE__ */ (0, J.jsx)(Qf, {
							groupedFeasibilityList: v,
							isLoading: p,
							filterConfig: {
								...f,
								handleSorting: d
							}
						})
					})
				})]
			}), !_ && !h && /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "px-20 py-10 flex dc__content-space dc__gap-12 dc__border-top",
				children: [/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox py-6 dc__gap-8",
					children: [/* @__PURE__ */ (0, J.jsx)(ce, { className: "icon-dim-20 dc__no-shrink warning-icon-y5-imp" }), /* @__PURE__ */ (0, J.jsxs)("span", {
						className: "fs-13 fw-6 lh-20 cn-9 dc__truncate",
						children: [
							x,
							"/",
							b,
							" selected installation(s) can be triggered"
						]
					})]
				}), /* @__PURE__ */ (0, J.jsx)(M, {
					text: "Deploy",
					startIcon: /* @__PURE__ */ (0, J.jsx)(Po, {}),
					disabled: !x || p,
					dataTestId: "deploy",
					onClick: ee
				})]
			})]
		}),
		s && /* @__PURE__ */ (0, J.jsx)(wf, {
			actionHandler: T,
			handleOnClose: C,
			modalType: cn.DEPLOY
		}),
		a && /* @__PURE__ */ (0, J.jsx)(Tf, {
			handleClose: S,
			handleSuccess: T
		})
	] });
}, ep = (e) => {
	let { handleClose: t } = e;
	return /* @__PURE__ */ (0, J.jsx)(Mt, {
		position: "right",
		width: "1024px",
		onEscape: t,
		children: /* @__PURE__ */ (0, J.jsx)("div", {
			className: "bg__primary h-100 flexbox-col show-shimmer-loading",
			children: /* @__PURE__ */ (0, J.jsx)($f, { ...e })
		})
	});
}, tp = /* @__PURE__ */ function(e) {
	return e.tenantInstallation = "tenantInstallation", e.triggerStatus = "triggerStatus", e;
}({}), np = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M11.8751 2.5H4.37451C4.20875 2.5 4.04978 2.56585 3.93257 2.68306C3.81536 2.80027 3.74951 2.95924 3.74951 3.125V16.875C3.74951 17.0408 3.81536 17.1997 3.93257 17.3169C4.04978 17.4342 4.20875 17.5 4.37451 17.5H15.6251C15.7072 17.5 15.7885 17.4838 15.8643 17.4524C15.9401 17.421 16.009 17.375 16.0671 17.3169C16.1251 17.2589 16.1711 17.19 16.2025 17.1142C16.234 17.0384 16.2501 16.9571 16.2501 16.875V6.875M11.8751 2.5L16.2501 6.875M11.8751 2.5V6.875H16.2501M7.50012 10.625H12.5001M7.50012 13.125H12.5001",
		stroke: "#596168",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rp = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M6.87502 10.537L13.8998 16.7188C13.9811 16.7903 14.0795 16.8395 14.1855 16.8615C14.2916 16.8836 14.4015 16.8777 14.5045 16.8445C14.6075 16.8112 14.7002 16.7518 14.7734 16.672C14.8465 16.5922 14.8977 16.4948 14.9219 16.3892L17.8605 3.56637C17.8859 3.4555 17.8805 3.3398 17.8451 3.23174C17.8096 3.12368 17.7453 3.02735 17.6591 2.95314C17.5729 2.87892 17.4681 2.82963 17.3559 2.81059C17.2438 2.79154 17.1286 2.80345 17.0227 2.84504L2.60423 8.50945C2.47857 8.55882 2.37227 8.64755 2.30125 8.76236C2.23022 8.87718 2.19828 9.01191 2.21021 9.14639C2.22214 9.28087 2.27729 9.40788 2.36742 9.5084C2.45755 9.60892 2.5778 9.67755 2.71019 9.70403L6.87502 10.537ZM6.87502 10.537L17.5088 2.85705M6.87502 10.537L6.87502 15.6238C6.87502 15.7475 6.91167 15.8683 6.98035 15.9711C7.04903 16.0739 7.14664 16.154 7.26084 16.2013C7.37504 16.2486 7.50071 16.2609 7.62195 16.2368C7.74319 16.2127 7.85455 16.1532 7.94196 16.0658L10.3834 13.6244",
		stroke: "#596168",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ip = ({ appId: e, envId: t, envName: n, appName: r, helmPackageName: i, cdWorkflowType: a }) => {
	let [o, s] = A(!1), { isDownloading: c, handleDownload: l } = oi();
	return /* @__PURE__ */ (0, J.jsx)(M, {
		variant: N.text,
		size: P.medium,
		startIcon: /* @__PURE__ */ (0, J.jsx)(Zu, {}),
		text: "Download",
		dataTestId: `download-package-${r}-${n}`,
		onClick: async (n) => {
			n.stopPropagation();
			let r = {
				appId: e,
				envId: t,
				appName: i || "helm-package",
				cdWorkflowType: a
			};
			await l({
				downloadUrl: y(r),
				fileName: r.appName,
				showSuccessfulToast: !1
			}) || s(!0);
		},
		isLoading: c,
		disabled: c,
		...o && { style: $e.neutral }
	});
}, ap = ({ tenantConfig: e, tenantTriggerStatus: t, deploymentList: n, romStatus: r }) => {
	let [i, a] = A(!1), o = t.code === $s.processed || t.code === $s.processedAndPushed, s = () => {
		a((e) => !e);
	};
	return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
		className: "display-grid dc__column-gap-16 releases__installation-feasibility-table-row releases__installation-feasibility-table-row--with-virtual-env fs-13 fw-4 lh-20 cn-9 py-8 px-20",
		children: [
			/* @__PURE__ */ (0, J.jsx)(sf, { imageProps: {
				src: e.image,
				height: 20,
				width: 20
			} }),
			/* @__PURE__ */ (0, J.jsx)("span", {
				className: "dc__truncate",
				children: e.displayText
			}),
			/* @__PURE__ */ (0, J.jsx)("span", { children: /* @__PURE__ */ (0, J.jsxs)("span", {
				className: "flexbox dc__gap-4",
				children: [/* @__PURE__ */ (0, J.jsx)("span", {
					className: "icon-dim-20 dc__no-shrink p-2",
					children: t.icon
				}), /* @__PURE__ */ (0, J.jsxs)("span", {
					className: "flexbox-col",
					children: [/* @__PURE__ */ (0, J.jsx)("span", {
						className: "dc__truncate",
						children: t.text
					}), t.message && /* @__PURE__ */ (0, J.jsx)("span", {
						className: "dc__first-letter-capitalize fs-12 fw-4 lh-18 cn-9",
						children: t.message
					})]
				})]
			}) }),
			/* @__PURE__ */ (0, J.jsx)("div", {
				className: "flex right",
				children: o ? /* @__PURE__ */ (0, J.jsx)(M, {
					variant: N.text,
					size: P.medium,
					style: $e.neutral,
					text: i ? "Hide Downloads" : "View Downloads",
					dataTestId: "toggle-downloads",
					onClick: s,
					endIcon: /* @__PURE__ */ (0, J.jsx)(_e, { className: `dc__transition--transform ${i ? "dc__flip-180" : ""}` })
				}) : /* @__PURE__ */ (0, J.jsx)("button", {
					type: "button",
					"aria-label": "expand",
					className: "p-2 dc__transparent br-4 dc__hover-n50 dc__h-fit-content flex",
					onClick: s,
					children: /* @__PURE__ */ (0, J.jsx)(_e, { className: `icon-dim-16 dc__no-shrink scn-6 dc__transition--transform ${i ? "dc__flip-180" : ""}` })
				})
			})
		]
	}, `${e.identifier}-deploy`), i && /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "bg__secondary",
		children: [
			/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "display-grid dc__column-gap-16 releases__installation-deploy-pipeline-row releases__installation-deploy-pipeline-row--rom-status dc__border-bottom-n1 fs-13 fw-4 lh-20 cn-9 px-20 pt-8 pb-7",
				children: [
					/* @__PURE__ */ (0, J.jsx)(np, { className: "icon-dim-20 scn-6" }),
					/* @__PURE__ */ (0, J.jsx)("span", {
						className: "dc__truncate",
						children: "Release orchestration manifest"
					}),
					/* @__PURE__ */ (0, J.jsx)("span", { children: /* @__PURE__ */ (0, J.jsxs)("span", {
						className: "flexbox dc__gap-4",
						children: [/* @__PURE__ */ (0, J.jsx)("span", {
							className: "icon-dim-20 dc__no-shrink p-2",
							children: r.icon
						}), /* @__PURE__ */ (0, J.jsx)("span", {
							className: "dc__first-letter-capitalize fs-13 fw-4 lh-20 cn-9 dc__word-break",
							children: r.message || r.text || "-"
						})]
					}) }),
					/* @__PURE__ */ (0, J.jsx)("span", {})
				]
			}),
			/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "display-grid dc__column-gap-16 releases__installation-deploy-pipeline-row releases__installation-deploy-pipeline-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center px-20 dc__uppercase",
				children: [
					/* @__PURE__ */ (0, J.jsx)("span", {}),
					/* @__PURE__ */ (0, J.jsx)(z, {
						isSortable: !1,
						title: "Application"
					}),
					/* @__PURE__ */ (0, J.jsx)(z, {
						isSortable: !1,
						title: "Environment"
					}),
					/* @__PURE__ */ (0, J.jsx)(z, {
						isSortable: !1,
						title: "Stage"
					}),
					/* @__PURE__ */ (0, J.jsx)("span", {})
				]
			}),
			/* @__PURE__ */ (0, J.jsx)("div", { children: n.map(({ appId: e, appName: t, envId: n, envName: r, triggerStatus: i, stage: a, helmPackageName: s }) => /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "display-grid dc__column-gap-16 releases__installation-deploy-pipeline-row dc__border-bottom-n1 fs-13 fw-4 lh-20 cn-9 px-20 pt-8 pb-7",
				children: [
					/* @__PURE__ */ (0, J.jsx)(rp, { className: "icon-dim-20 scn-6" }),
					/* @__PURE__ */ (0, J.jsx)("span", {
						className: "dc__truncate",
						children: t
					}),
					/* @__PURE__ */ (0, J.jsx)("span", {
						className: "dc__truncate",
						children: r
					}),
					/* @__PURE__ */ (0, J.jsx)("div", {
						className: "dc__ellipsis-right dc__first-letter-capitalize",
						children: pr(a)
					}),
					/* @__PURE__ */ (0, J.jsx)("span", { children: /* @__PURE__ */ (0, J.jsxs)("span", {
						className: "flexbox dc__gap-4",
						children: [/* @__PURE__ */ (0, J.jsx)("span", {
							className: "icon-dim-20 dc__no-shrink p-2",
							children: i.icon
						}), /* @__PURE__ */ (0, J.jsx)("span", {
							className: "dc__first-letter-capitalize fs-13 fw-4 lh-20 cn-9 dc__word-break",
							children: i.message || i.text || "-"
						})]
					}) }),
					o && /* @__PURE__ */ (0, J.jsx)(ip, {
						appId: e,
						appName: t,
						envId: n,
						envName: r,
						helmPackageName: s,
						cdWorkflowType: ht[a]
					})
				]
			}, `${t}-${r}`)) })
		]
	})] });
}, op = ({ isLoading: e, groupedDeployStatusList: t, filterConfig: { sortBy: n, sortOrder: r, handleSorting: i } }) => {
	let a = (e) => () => {
		i(e);
	};
	return /* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
		className: "display-grid dc__column-gap-16 releases__installation-feasibility-table-row releases__installation-feasibility-table-row--header releases__installation-feasibility-table-row--with-virtual-env dc__border-bottom fs-12 fw-6 lh-20 cn-7 dc__align-items-center dc__uppercase dc__position-sticky dc__top-49 dc__zi-4 bg__primary px-20",
		children: [
			/* @__PURE__ */ (0, J.jsx)("span", {}),
			/* @__PURE__ */ (0, J.jsx)(z, {
				isSorted: n === tp.tenantInstallation,
				sortOrder: r,
				title: "Tenant (Installation)",
				triggerSorting: a(tp.tenantInstallation),
				disabled: e
			}),
			/* @__PURE__ */ (0, J.jsx)(z, {
				isSorted: n === tp.triggerStatus,
				sortOrder: r,
				title: "Trigger Status",
				triggerSorting: a(tp.triggerStatus),
				disabled: e
			})
		]
	}), /* @__PURE__ */ (0, J.jsx)("div", {
		className: "dc__even-child--bcn-50",
		children: e ? bd.map(({ tenantConfig: e }) => /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "display-grid dc__column-gap-16 releases__installation-feasibility-table-row releases__installation-feasibility-table-row--with-virtual-env py-8 show-shimmer-loading px-20",
			children: [
				/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading" }),
				/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading" }),
				/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading" })
			]
		}, `${e.identifier}-feasibility-loading`)) : t.map((e) => /* @__PURE__ */ Me(ap, {
			...e,
			key: e.tenantConfig.identifier
		}))
	})] });
}, sp = ({ handleClose: e, filteredBulkSelectionState: t, handleRetryDeployment: n }) => {
	let r = Ai(), i = ki(), { search: a } = Oi(), { id: o } = Q(), { sortBy: s, sortOrder: c, handleSorting: l } = mi({ initialSortKey: tp.triggerStatus }), u = k(() => ({
		sortBy: s,
		sortOrder: c
	}), [s, c]), [f, p, m, h] = K(() => Eu({
		id: o,
		bulkSelectionState: t
	}), [t], Object.keys(t).length > 0, { resetOnChange: !1 }), g = f && !p, _ = k(() => p?.length ? s === tp.tenantInstallation ? p.sort((e, t) => G(e.tenantConfig.displayText, t.tenantConfig.displayText, c)) : p.sort((e, t) => Ur(e.tenantTriggerStatus.sortPriority, t.tenantTriggerStatus.sortPriority, c)) : [], [p, u]), v = _?.some((e) => e.tenantTriggerStatus?.code === $s.notProcessed), y = () => /* @__PURE__ */ (0, J.jsx)(M, {
		text: "close",
		dataTestId: "close-modal",
		onClick: e,
		variant: N.secondary
	});
	if (!Object.keys(t).length) return /* @__PURE__ */ (0, J.jsx)(F, {
		title: "Couldn't verify the images for selected deployment",
		classname: "flex-grow-1",
		isButtonAvailable: !0,
		renderButton: y
	});
	let b = (e) => {
		e.stopPropagation(), n(_.filter((e) => e.tenantTriggerStatus.code === $s.notProcessed).reduce((e, { tenantConfig: t }) => (e[t.identifier] = {
			tenantId: t.tenantId,
			installationId: t.installationConfig.installationId
		}, e), {}));
	}, x = () => {
		e();
		let t = q(I.RELEASES.DETAIL.ROLLOUT_RELEASE, {
			releaseTrack: r.releaseTrack,
			releaseVersion: r.releaseVersion
		}), n = new URLSearchParams(a);
		n.set("tab", Ed.rolloutStatus), i({
			pathname: t,
			search: n.toString()
		});
	};
	return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)("div", {
		className: "flexbox-col flex-grow-1 dc__overflow-auto",
		children: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col flex-grow-1 dc__overflow-auto",
			children: [/* @__PURE__ */ (0, J.jsx)("div", {
				className: "dc__position-sticky dc__top-0 bg__primary dc__zi-20",
				children: /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flex flex-justify dc__border-bottom pt-10 pr-20 pb-10 pl-20",
					children: [/* @__PURE__ */ (0, J.jsx)("h2", {
						className: "fs-16 fw-6 lh-24 m-0 dc__ellipsis-right",
						children: "Deployment status"
					}), /* @__PURE__ */ (0, J.jsx)("button", {
						type: "button",
						className: "dc__transparent dc__no-shrink flexbox",
						"aria-label": "close-modal",
						onClick: e,
						children: /* @__PURE__ */ (0, J.jsx)(d, { className: "icon-dim-24 icon-use-fill-n6" })
					})]
				})
			}), /* @__PURE__ */ (0, J.jsx)(Ie, {
				isLoading: g,
				customLoader: /* @__PURE__ */ (0, J.jsx)(F, {
					title: "Fetching deployment trigger status...",
					subTitle: "It might take some time depending upon the number of deployments",
					classname: "flex-grow-1",
					imgName: "img-mechanical-operation"
				}),
				error: m,
				errorScreenManagerProps: {
					code: m?.code,
					reload: h
				},
				children: /* @__PURE__ */ (0, J.jsx)("div", {
					className: "flexbox-col flex-grow-1",
					children: !f && !_?.length ? /* @__PURE__ */ (0, J.jsx)(F, {
						title: "Could not find selected installation(s)",
						subTitle: "Looks like the installation(s) selected by you do not exist anymore",
						classname: "dc__text-center flex flex-grow-1"
					}) : /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)(nn, {
						description: "Pipelines are triggered asynchronously. You can close this drawer, the actions will be performed in the background.",
						borderConfig: {
							top: !1,
							left: !1,
							right: !1
						},
						borderRadiusConfig: {
							top: !1,
							left: !1,
							right: !1,
							bottom: !1
						}
					}), /* @__PURE__ */ (0, J.jsx)(op, {
						groupedDeployStatusList: _,
						isLoading: f,
						filterConfig: {
							...u,
							handleSorting: l
						}
					})] })
				})
			})]
		})
	}), !g && !m && /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "px-20 py-16 flex dc__content-end dc__gap-12 dc__border-top",
		children: [/* @__PURE__ */ (0, J.jsx)(M, {
			text: "Go to rollout status",
			endIcon: /* @__PURE__ */ (0, J.jsx)(we, {}),
			variant: v ? N.secondary : N.primary,
			disabled: f,
			onClick: x,
			dataTestId: "go-to-rollout-status"
		}), v && /* @__PURE__ */ (0, J.jsx)(M, {
			disabled: f,
			onClick: b,
			isLoading: f,
			text: "Retry Failed",
			startIcon: /* @__PURE__ */ (0, J.jsx)(De, {}),
			dataTestId: "retry-failed-deployments"
		})]
	})] });
}, cp = (e) => {
	let { handleClose: t } = e;
	return /* @__PURE__ */ (0, J.jsx)(Mt, {
		position: "right",
		width: "1024px",
		onEscape: t,
		children: /* @__PURE__ */ (0, J.jsx)("div", {
			className: "bg__primary h-100 flexbox-col show-shimmer-loading",
			children: /* @__PURE__ */ (0, J.jsx)(sp, { ...e })
		})
	});
}, lp = ({ installationViewBulkSelectionState: e, setInstallationViewBulkSelectionState: t, isFeasibilityModalOpen: n, setIsFeasibilityModalOpen: r, handleClearBulkSelection: i }) => {
	let [a, o] = A(!1), [s, c] = A({}), [l, u] = A({}), { id: d, refetchReleaseDetail: f } = Q(), { urlFilterConfig: p, updateFilterCountSummary: m, resetFilterCountSummary: h, areFiltersActive: g } = $d(), _ = Pe(new AbortController()), { sortBy: v, sortOrder: y, handleSorting: b } = mi({ initialSortKey: Yf.tenantInstallation }), { handleExternalSync: x, isExternalSyncLoading: S, isContentLoading: C, lastSyncedTimestamp: w, refetchResponse: T, initialError: E, responseData: te } = yf({
		urlFilterConfig: p,
		serviceHandler: async () => await rr(() => Du({
			releaseId: d,
			filterConfig: {
				...p,
				env: [],
				app: [],
				tenantInstallation: []
			}
		}, _.current.signal), _)
	}), ne = k(() => te?.rolloutStatusList?.length ? te.rolloutStatusList.sort((e, t) => G(e.tenantConfig.displayText, t.tenantConfig.displayText, y)) : [], [te, y]), re = k(() => {
		if (ne.length > 0 && ne.map(({ tenantConfig: e }) => e.identifier).every((t) => e[t])) return rt.CHECKED;
		if (Object.keys(e).length > 0) return rt.INTERMEDIATE;
	}, [ne, e]), ie = re === rt.CHECKED || re === rt.INTERMEDIATE;
	O(() => (te && m(te?.countSummary), () => {
		h();
	}), [te]);
	let ae = (e) => () => {
		b(e);
	}, oe = (e) => () => {
		u((t) => {
			let n = structuredClone(t);
			return n[e] ? delete n[e] : n[e] = !0, n;
		});
	}, D = (e, n) => () => {
		t((t) => {
			let r = structuredClone(t);
			return r[e] ? delete r[e] : r[e] = n, r;
		});
	};
	return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [
		/* @__PURE__ */ (0, J.jsx)(vf, {
			isLoading: S,
			lastSyncedTimestamp: w,
			reloadData: x,
			hidePollingToggle: E && !C || C,
			children: /* @__PURE__ */ (0, J.jsx)("div", {
				className: "flexbox-col dc__mxw-1400 w-100 p-12 flex-grow-1",
				children: /* @__PURE__ */ (0, J.jsx)(Ie, {
					isLoading: C,
					progressingProps: { pageLoader: !0 },
					error: E,
					errorScreenManagerProps: {
						code: E?.code,
						reload: T
					},
					children: /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "w-100 br-8 dc__contain--paint dc__info-card dc__info-card--no-hover bg__primary",
						children: [/* @__PURE__ */ (0, J.jsxs)("div", {
							className: "px-20 pt-8 pb-7 flex left dc__gap-16 dc__border-bottom-n1 fs-12 fw-6 lh-20 dc__uppercase cn-7",
							children: [/* @__PURE__ */ (0, J.jsx)(it, {
								isChecked: ie,
								onChange: () => {
									if (ie) {
										t({});
										return;
									}
									t(ne.reduce((e, { tenantConfig: t, isTenantInstallationIsolated: n }) => (n && (e[t.identifier] = {
										tenantId: t.tenantId,
										installationId: t.installationConfig.installationId
									}), e), {}));
								},
								value: re,
								rootClassName: "mb-0 w-20 h-20"
							}), /* @__PURE__ */ (0, J.jsx)(z, {
								disabled: C,
								isSorted: v === Yf.tenantInstallation,
								sortOrder: y,
								title: "Tenant (Installation)",
								triggerSorting: ae(Yf.tenantInstallation)
							})]
						}), /* @__PURE__ */ (0, J.jsx)("div", {
							className: "fs-13 fw-4 lh-20 cn-9",
							children: ne.length ? ne.map(({ tenantConfig: t, apps: n, isTenantInstallationIsolated: r }) => {
								let i = !!e[t.identifier];
								return /* @__PURE__ */ (0, J.jsxs)(Ae, { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
									className: `px-20 pt-10 pb-9 flex dc__content-space dc__gap-8 dc__border-bottom-n1 last-child__no-border bg__hover--opaque dc__position-sticky dc__top-0 dc__zi-1 bg__primary ${i ? "bc-b50" : ""}`,
									children: [/* @__PURE__ */ (0, J.jsxs)("div", {
										className: "flex left dc__gap-16",
										children: [/* @__PURE__ */ (0, J.jsx)(Kn, {
											alwaysShowTippyOnHover: !r,
											content: "From the installation view, deployment is not available for connected installations",
											children: /* @__PURE__ */ (0, J.jsx)("div", { children: /* @__PURE__ */ (0, J.jsx)(it, {
												isChecked: i,
												onChange: D(t.identifier, {
													tenantId: t.tenantId,
													installationId: t.installationConfig.installationId
												}),
												value: rt.CHECKED,
												rootClassName: "mb-0 w-20 h-20",
												disabled: !r
											}) })
										}), /* @__PURE__ */ (0, J.jsx)(kf, {
											tenantConfig: t,
											children: /* @__PURE__ */ (0, J.jsx)("div", {
												className: "dc__truncate",
												children: t.displayText
											})
										})]
									}), /* @__PURE__ */ (0, J.jsxs)("button", {
										type: "button",
										className: "flex left dc__gap-4 dc__transparent p-0 br-4 dc__content-end flex-grow-1",
										onClick: oe(t.identifier),
										children: [/* @__PURE__ */ (0, J.jsxs)("div", {
											className: "dc__truncate",
											children: [n.length, " Pipelines"]
										}), /* @__PURE__ */ (0, J.jsx)(ee, { className: `icon-dim-16 scn-7 dc__no-shrink dc__transition--transform ${l[t.identifier] ? "dc__flip-90" : "dc__flip-270"}` })]
									})]
								}), l[t.identifier] && /* @__PURE__ */ (0, J.jsxs)("div", {
									className: "bg__secondary",
									children: [/* @__PURE__ */ (0, J.jsxs)("div", {
										className: "display-grid dc__column-gap-16 releases__installation-deploy-table-row releases__installation-deploy-table-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center px-20 dc__uppercase",
										children: [
											/* @__PURE__ */ (0, J.jsx)(z, {
												isSortable: !1,
												title: "Application"
											}),
											/* @__PURE__ */ (0, J.jsx)(z, {
												isSortable: !1,
												title: "Environment"
											}),
											/* @__PURE__ */ (0, J.jsx)(z, {
												isSortable: !1,
												title: "Deployment Status"
											})
										]
									}), /* @__PURE__ */ (0, J.jsx)("div", { children: n.map(({ appName: e, envName: t, deployStatus: n, preStatus: r, existingStages: { pre: i, post: a }, postStatus: o, appId: s, envId: c, postCdWorkflowRunnerId: l, preCdWorkflowRunnerId: u, pipelineId: d }) => /* @__PURE__ */ (0, J.jsxs)("div", {
										className: "display-grid dc__column-gap-16 releases__installation-deploy-table-row dc__border-bottom-n1 fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-20",
										children: [
											/* @__PURE__ */ (0, J.jsx)("span", {
												className: "dc__truncate",
												children: e
											}),
											/* @__PURE__ */ (0, J.jsx)("span", {
												className: "dc__truncate",
												children: t
											}),
											/* @__PURE__ */ (0, J.jsx)(If, {
												deployStatus: n,
												preStatus: r,
												postStatus: o,
												isPreConfigured: i,
												isPostConfigured: a,
												appId: s,
												envId: c,
												appName: e,
												envName: t,
												preCdWorkflowRunnerId: u,
												postCdWorkflowRunnerId: l,
												pipelineId: d
											})
										]
									}, `${e}-${t}`)) })]
								})] }, t.identifier);
							}) : /* @__PURE__ */ (0, J.jsx)(Kt, {
								useInfoIcon: !0,
								title: g ? "No matching results found for selected filters" : "Could not find any tenant installation(s)",
								subTitle: "",
								description: "",
								rootClassName: "p-32 bg__primary"
							})
						})]
					})
				})
			})
		}),
		n && /* @__PURE__ */ (0, J.jsx)(ep, {
			handleClose: () => {
				r(!1);
			},
			handleSuccess: (e) => {
				r(!1), o(!0), c(e);
			},
			bulkSelectionState: e
		}),
		a && /* @__PURE__ */ (0, J.jsx)(cp, {
			filteredBulkSelectionState: s,
			handleClose: async () => {
				o(!1), i(), c({}), T(), await f();
			},
			handleRetryDeployment: (e) => {
				c(e);
			}
		})
	] });
}, up = ({ label: e, value: t, isChecked: n, testIdPrefix: r, onChange: i }) => /* @__PURE__ */ (0, J.jsxs)("button", {
	type: "button",
	className: "dc__transparent w-100 br-4 px-8 py-6 dc__hover-n50 flexbox dc__align-items-center dc__gap-8",
	onClick: (e) => {
		e.preventDefault(), e.stopPropagation(), i(t, !n);
	},
	children: [/* @__PURE__ */ (0, J.jsx)(it, {
		isChecked: n ?? !1,
		onChange: U,
		value: rt.CHECKED,
		dataTestId: `${r}-${t}`,
		rootClassName: "dc__align-items-center mb-0"
	}), /* @__PURE__ */ (0, J.jsx)("span", {
		className: "dc__truncate fs-13 fw-4 lh-20 cn-9 dc__align-left",
		children: e
	})]
}), dp = ({ title: e, getContent: t, defaultExpanded: n = !1, showSearch: r = !1, searchBarProps: i }) => {
	let [a, o] = A(n);
	return O(() => {
		o(n);
	}, [n]), /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col dc__gap-4 bg__primary",
		children: [/* @__PURE__ */ (0, J.jsxs)("button", {
			className: "dc__transparent py-8 px-16 flex dc__content-space dc__gap-8 w-100 dc__hover-n50 dc__position-sticky dc__top-0 bg__primary dc__zi-4",
			type: "button",
			role: "tab",
			onClick: () => {
				o(!a);
			},
			children: [/* @__PURE__ */ (0, J.jsx)("div", {
				className: "dc__align-left dc__truncate w-100 cn-9 fs-13 fw-6 lh-20",
				children: e
			}), /* @__PURE__ */ (0, J.jsx)(_e, { className: `icon-dim-16 dc__no-shrink dc__transition--transform ${a ? "dc__flip-180" : ""}` })]
		}), a && /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "px-8",
			children: [r && i && /* @__PURE__ */ (0, J.jsx)(On, {
				...i,
				noBackgroundAndBorder: !0
			}), t()]
		})]
	});
}, fp = () => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "px-8 show-shimmer-loading",
	children: [
		/* @__PURE__ */ (0, J.jsx)("div", {
			className: "px-8 py-6",
			children: /* @__PURE__ */ (0, J.jsx)("div", { className: "child-shimmer-loading h-20 mt-0-imp w-100" })
		}),
		/* @__PURE__ */ (0, J.jsx)("div", {
			className: "px-8 py-6",
			children: /* @__PURE__ */ (0, J.jsx)("div", { className: "child-shimmer-loading h-20 mt-0-imp w-100" })
		}),
		/* @__PURE__ */ (0, J.jsx)("div", {
			className: "px-8 py-6",
			children: /* @__PURE__ */ (0, J.jsx)("div", { className: "child-shimmer-loading h-20 mt-0-imp w-100" })
		})
	]
}), pp = ({ isLoading: e, error: t, children: n, genericSectionErrorStateProps: r }) => /* @__PURE__ */ (0, J.jsx)(Ie, {
	isLoading: e,
	customLoader: /* @__PURE__ */ (0, J.jsx)(fp, {}),
	error: t,
	genericSectionErrorProps: {
		...r,
		withBorder: !0,
		description: "",
		rootClassName: "mt-4 mb-4"
	},
	children: n
}), mp = () => /* @__PURE__ */ (0, J.jsx)(Kt, {
	withBorder: !0,
	title: "No results",
	subTitle: "We could not find any matching results",
	description: "",
	rootClassName: "mt-4 mb-4",
	useInfoIcon: !0
}), hp = ({ appMap: e, handleApplicationUpdate: t, applicationsByStages: n }) => /* @__PURE__ */ (0, J.jsx)("div", {
	className: "flexbox-col dc__gap-4",
	children: n.map(({ title: n, applications: r }) => /* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("div", {
		className: "dc__truncate fs-12 fw-6 lh-20 cn-7 dc__uppercase px-8 py-4 dc__position-sticky dc__top-36 bg__primary dc__zi-2",
		children: n
	}), /* @__PURE__ */ (0, J.jsx)("div", { children: r.map((r) => /* @__PURE__ */ (0, J.jsx)(up, {
		label: r,
		value: r,
		isChecked: e[r],
		testIdPrefix: "app-option",
		onChange: t
	}, `${n}-app-option-${r}`)) })] }, n))
}), gp = ({ handleApplicationUpdate: e, appMap: t }) => {
	let [n, r] = A(""), { appEnvAndTenantListApiState: i } = $d(), { isAppEnvAndTenantLoading: a, appEnvAndTenantListError: o, refetchAppEnvAndTenantList: s, appEnvAndTenantList: { applicationsByStages: c } } = i, l = !a && !o, u = (e) => {
		r(e);
	}, d = k(() => {
		let e = n.trim().toLowerCase();
		return e ? c.map(({ applications: t, ...n }) => ({
			...n,
			applications: t.filter((t) => t.toLowerCase().includes(e))
		})).filter(({ applications: e }) => !!e.length) : c;
	}, [i.appEnvAndTenantList.applicationsByStages, n]);
	return /* @__PURE__ */ (0, J.jsx)(dp, {
		title: jd[Ad.app],
		showSearch: l,
		searchBarProps: {
			inputProps: { placeholder: "Search application" },
			initialSearchText: n,
			handleSearchChange: u
		},
		getContent: () => /* @__PURE__ */ (0, J.jsx)(pp, {
			isLoading: a,
			error: o,
			genericSectionErrorStateProps: {
				reload: s,
				subTitle: "Could not load applications."
			},
			children: d?.length ? /* @__PURE__ */ (0, J.jsx)(hp, {
				appMap: t,
				handleApplicationUpdate: e,
				applicationsByStages: d
			}) : /* @__PURE__ */ (0, J.jsx)(mp, {})
		})
	});
}, _p = ({ preStageMap: e, deployStageMap: t, postStageMap: n, handleDeploymentStatusUpdate: r }) => {
	let { filterCountSummary: i } = $d(), a = (r, i) => {
		switch (r) {
			case wt.PRE: return e[i];
			case wt.DEPLOY: return t[i];
			case wt.POST: return n[i];
			default: return !1;
		}
	}, o = (e) => (t, n) => {
		r(e, t, n);
	};
	return /* @__PURE__ */ (0, J.jsx)("div", {
		className: "flexbox-col dc__gap-4",
		children: _c.map(({ stageType: e, options: t }) => {
			let n = i.filterDeploymentStatus[e];
			return /* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "dc__truncate fs-12 fw-6 lh-20 cn-7 dc__uppercase px-8 py-4 dc__position-sticky dc__top-36 bg__primary dc__zi-2",
				children: [pr(e), " Stage"]
			}), /* @__PURE__ */ (0, J.jsx)("div", { children: t.map(({ label: t, value: r, hideIfCountZero: i }) => !(i && n[r] === 0) && /* @__PURE__ */ (0, J.jsx)(up, {
				label: t,
				value: r,
				isChecked: a(e, r),
				testIdPrefix: `${e}-status-option`,
				onChange: o(e)
			}, `${r}-${e}-status-option`)) })] }, `${e}-status-filter`);
		})
	});
}, vp = ({ environments: e, handleEnvironmentUpdate: t, envMap: n }) => /* @__PURE__ */ (0, J.jsx)(J.Fragment, { children: e.map((e) => /* @__PURE__ */ (0, J.jsx)(up, {
	label: e,
	value: e,
	isChecked: n[e],
	testIdPrefix: "env-option",
	onChange: t
}, `env-option-${e}`)) }), yp = ({ envMap: e, handleEnvironmentUpdate: t }) => {
	let [n, r] = A(""), { appEnvAndTenantListApiState: i } = $d(), { isAppEnvAndTenantLoading: a, appEnvAndTenantListError: o, refetchAppEnvAndTenantList: s, appEnvAndTenantList: { environments: c } } = i, l = !a && !o, u = (e) => {
		r(e);
	}, d = k(() => {
		let e = n.trim().toLowerCase();
		return e ? c.filter((t) => t.toLowerCase().includes(e)) : c;
	}, [i.appEnvAndTenantList.environments, n]);
	return /* @__PURE__ */ (0, J.jsx)(dp, {
		title: jd[Ad.env],
		showSearch: l,
		searchBarProps: {
			inputProps: { placeholder: "Search environment" },
			initialSearchText: n,
			handleSearchChange: u
		},
		getContent: () => /* @__PURE__ */ (0, J.jsx)(pp, {
			isLoading: a,
			error: o,
			genericSectionErrorStateProps: {
				reload: s,
				subTitle: "Could not load environments."
			},
			children: d?.length ? /* @__PURE__ */ (0, J.jsx)(vp, {
				envMap: e,
				handleEnvironmentUpdate: t,
				environments: d
			}) : /* @__PURE__ */ (0, J.jsx)(mp, {})
		})
	});
}, bp = ({ releaseChannelIdMap: e, handleReleaseChannelUpdate: t, releaseChannels: n }) => /* @__PURE__ */ (0, J.jsx)(J.Fragment, { children: n.map(({ name: n, channelId: r }) => /* @__PURE__ */ (0, J.jsx)(up, {
	label: n,
	value: r,
	isChecked: e[r],
	testIdPrefix: "release-channel-option",
	onChange: t
}, `release-channel-option-${r}`)) }), xp = ({ handleReleaseChannelUpdate: e, releaseChannelIdMap: t }) => {
	let [n, r] = A(""), { appEnvAndTenantListApiState: i } = $d(), { isAppEnvAndTenantLoading: a, appEnvAndTenantListError: o, refetchAppEnvAndTenantList: s, appEnvAndTenantList: { releaseChannels: c } } = i, l = !a && !o, u = (e) => {
		r(e);
	}, d = k(() => {
		let e = n.trim().toLowerCase(), t = [{
			name: Wu.label,
			channelId: Wu.value
		}, ...structuredClone(c)];
		return e ? t.filter((t) => t.name.toLowerCase().includes(e)) : t;
	}, [i.appEnvAndTenantList.releaseChannels, n]);
	return /* @__PURE__ */ (0, J.jsx)(dp, {
		title: jd[Ad.releaseChannelId],
		showSearch: l,
		searchBarProps: {
			inputProps: { placeholder: "Search release channel" },
			initialSearchText: n,
			handleSearchChange: u
		},
		getContent: () => /* @__PURE__ */ (0, J.jsx)(pp, {
			isLoading: a,
			error: o,
			genericSectionErrorStateProps: {
				reload: s,
				subTitle: "Could not load release channels."
			},
			children: d?.length ? /* @__PURE__ */ (0, J.jsx)(bp, {
				releaseChannelIdMap: t,
				handleReleaseChannelUpdate: e,
				releaseChannels: d
			}) : /* @__PURE__ */ (0, J.jsx)(mp, {})
		})
	});
}, Sp = ({ handleRolloutStatusUpdate: e, selectedRolloutStatus: t }) => /* @__PURE__ */ (0, J.jsx)(xn, {
	name: "rollout-status-filter",
	className: "dc__no-border-imp flexbox-col",
	value: t,
	disabled: !1,
	onChange: (t) => {
		e(t.target.value);
	},
	children: pc.map((e) => /* @__PURE__ */ (0, J.jsx)(Sn, {
		value: e,
		disabled: !1,
		dataTestId: e,
		children: /* @__PURE__ */ (0, J.jsx)("span", {
			className: "dc__truncate fs-13 fw-4 lh-20 cn-9 dc__align-left",
			children: lc[e]
		})
	}, e))
}), Cp = ({ tenantInstallationMap: e, handleTenantInstallationUpdate: t, tenantsWithInstallations: n }) => /* @__PURE__ */ (0, J.jsx)(J.Fragment, { children: n.map(({ identifier: n, displayText: r }) => /* @__PURE__ */ (0, J.jsx)(up, {
	label: r,
	value: n,
	isChecked: e[n],
	testIdPrefix: "tenant-installation-option",
	onChange: t
}, `tenant-installation-option-${n}`)) }), wp = ({ handleTenantInstallationUpdate: e, tenantInstallationMap: t }) => {
	let [n, r] = A(""), { appEnvAndTenantListApiState: i } = $d(), { isAppEnvAndTenantLoading: a, appEnvAndTenantListError: o, refetchAppEnvAndTenantList: s, appEnvAndTenantList: { tenantsWithInstallations: c } } = i, l = !a && !o, u = (e) => {
		r(e);
	}, d = k(() => {
		let e = n.trim().toLowerCase();
		return e ? c.filter(({ tenantId: t, installationConfig: n, name: r }) => t.toLowerCase().includes(e) || r.toLowerCase().includes(e) || n.installationId.toLowerCase().includes(e) || n.name.toLowerCase().includes(e)) : c;
	}, [c, n]);
	return /* @__PURE__ */ (0, J.jsx)(dp, {
		title: jd[Ad.tenantInstallation],
		showSearch: l,
		searchBarProps: {
			inputProps: { placeholder: "Search tenant (installations)" },
			initialSearchText: n,
			handleSearchChange: u
		},
		getContent: () => /* @__PURE__ */ (0, J.jsx)(pp, {
			isLoading: a,
			error: o,
			genericSectionErrorStateProps: {
				reload: s,
				subTitle: "Could not load tenant (installations)."
			},
			children: d?.length ? /* @__PURE__ */ (0, J.jsx)(Cp, {
				tenantInstallationMap: t,
				handleTenantInstallationUpdate: e,
				tenantsWithInstallations: d
			}) : /* @__PURE__ */ (0, J.jsx)(mp, {})
		})
	});
}, Tp = ({ showRolloutFilter: e }) => {
	let { triggerAutoClickTimestamp: t, setTriggerAutoClickTimestampToNow: n } = hi(), { updateFiltersByMap: r, urlFilterConfigMap: i, triggerReleaseView: a } = $d(), o = e && a && a === Dd.installation, [s, c] = A(structuredClone(i)), { selectedRolloutStatus: l, envMap: u, appMap: d, preStageMap: f, postStageMap: p, deployStageMap: m, tenantInstallationMap: h, releaseChannelIdMap: g } = s;
	O(() => {
		c(structuredClone(i));
	}, [JSON.stringify(i)]);
	let _ = (e) => {
		n(), c((t) => ({
			...t,
			...e
		}));
	}, v = (e) => {
		_({ selectedRolloutStatus: e });
	}, y = (e, t) => {
		_({ envMap: {
			...u,
			[e]: t
		} });
	}, b = (e, t) => {
		_({ appMap: {
			...d,
			[e]: t
		} });
	}, x = (e, t) => {
		_({ releaseChannelIdMap: {
			...g,
			[e]: t
		} });
	}, S = (e, t) => {
		_({ tenantInstallationMap: {
			...h,
			[e]: t
		} });
	}, C = (e, t, n) => {
		switch (e) {
			case wt.PRE:
				_({ preStageMap: {
					...f,
					[t]: n
				} });
				return;
			case wt.DEPLOY:
				_({ deployStageMap: {
					...m,
					[t]: n
				} });
				return;
			case wt.POST:
				_({ postStageMap: {
					...p,
					[t]: n
				} });
				return;
			default: throw Error(`Unsupported stage type: ${e}`);
		}
	};
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "w-250 dc__no-shrink bg__primary border__primary--right flexbox-col dc__overflow-auto dc__content-space releases__deploy-filter-sidebar",
		children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col flex-grow-1 dc__overflow-auto",
			children: [/* @__PURE__ */ (0, J.jsx)("div", {
				className: "fs-13 lh-24 cn-9 fw-6 dc__uppercase px-16 py-12 border__primary--bottom",
				children: "Filters"
			}), /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col dc__gap-4 flex-grow-1 dc__overflow-auto",
				children: [
					e && /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [
						/* @__PURE__ */ (0, J.jsx)(dp, {
							title: jd[Ad.rolloutStatus],
							getContent: () => /* @__PURE__ */ (0, J.jsx)(Sp, {
								selectedRolloutStatus: l,
								handleRolloutStatusUpdate: v
							}),
							defaultExpanded: !0
						}),
						/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-bottom-n1" }),
						!o && /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)(dp, {
							title: "Deployment status",
							getContent: () => /* @__PURE__ */ (0, J.jsx)(_p, {
								preStageMap: f,
								deployStageMap: m,
								postStageMap: p,
								handleDeploymentStatusUpdate: C
							})
						}), /* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-bottom-n1" })] })
					] }),
					!o && /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)(gp, {
						appMap: d,
						handleApplicationUpdate: b
					}), /* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-bottom-n1" })] }),
					/* @__PURE__ */ (0, J.jsx)(xp, {
						releaseChannelIdMap: g,
						handleReleaseChannelUpdate: x
					}),
					!o && /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [
						/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-bottom-n1" }),
						/* @__PURE__ */ (0, J.jsx)(wp, {
							tenantInstallationMap: h,
							handleTenantInstallationUpdate: S
						}),
						/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-bottom-n1" }),
						/* @__PURE__ */ (0, J.jsx)(yp, {
							envMap: u,
							handleEnvironmentUpdate: y
						})
					] })
				]
			})]
		}), /* @__PURE__ */ (0, J.jsx)("div", {
			className: "py-12 px-16 dc__border-top-n1",
			children: /* @__PURE__ */ (0, J.jsx)(M, {
				size: P.medium,
				fullWidth: !0,
				text: "Apply Filters",
				onClick: () => {
					r(s);
				},
				dataTestId: "apply-filters",
				triggerAutoClickTimestamp: t
			})
		})]
	});
}, Ep = ({ count: e = 0, countBackgroundClass: t = "", iconClass: n = "", isLoading: r = !1 }) => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: `px-6 flex dc__gap-4 br-10 mw-32 ${t}`,
	children: [/* @__PURE__ */ (0, J.jsx)("span", {
		className: "cn-7 fs-12 fw-6 lh-20 dc__truncate",
		children: r ? "--" : Kr(e)
	}), /* @__PURE__ */ (0, J.jsx)("div", { className: `dc__border-radius-50-per icon-dim-6 dc__no-shrink ${n}` })]
}), Dp = ({ title: e, count: t, countBackgroundClass: n, iconClass: r }) => /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
	className: "flexbox dc__gap-6 dc__align-items-center",
	children: [/* @__PURE__ */ (0, J.jsx)("div", {
		className: "cn-9 fs-13 fw-4 lh-20",
		children: e
	}), /* @__PURE__ */ (0, J.jsx)(Ep, {
		count: t,
		countBackgroundClass: n,
		iconClass: r
	})]
}), /* @__PURE__ */ (0, J.jsx)("div", { className: "dc__divider bcn-1 h-12 last-child__display-none" })] }), Op = ({ tenantId: e, rolloutStatusSummary: t }) => /* @__PURE__ */ (0, J.jsx)("div", {
	className: "flex dc__content-start dc__gap-12 flex-wrap",
	children: fc.map((n) => {
		let r = t[n];
		return r > 0 && /* @__PURE__ */ Me(Dp, {
			...dc[n],
			key: `${e}-${n}`,
			title: lc[n],
			count: r
		});
	})
}), kp = ({ tenantId: e, apps: t, rolloutStatusSummary: n }) => {
	let [r, i] = A(!1);
	if (!t?.length) return /* @__PURE__ */ (0, J.jsx)(J.Fragment, { children: "-" });
	let a = !r && t?.length > 0, o = a ? (e) => {
		e.preventDefault(), i(!0);
	} : U;
	return r ? /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col dc__gap-8 flex-grow-1",
		children: [/* @__PURE__ */ (0, J.jsxs)("button", {
			type: "button",
			className: "dc__transparent p-0 flex dc__content-space dc__gap-6",
			onClick: () => {
				i(!1);
			},
			children: [/* @__PURE__ */ (0, J.jsx)("span", {
				className: "dc__truncate fs-12 fw-6 lh-20 cn-7 py-2",
				children: "Applications with stages and status"
			}), /* @__PURE__ */ (0, J.jsx)(D, {
				content: "Hide deployment status for the app(s)",
				arrow: !1,
				className: "default-tt",
				placement: "top",
				children: /* @__PURE__ */ (0, J.jsx)("div", {
					className: "flexbox",
					children: /* @__PURE__ */ (0, J.jsx)(_e, { className: "icon-dim-24 p-2 dc__no-shrink dc__flip-180" })
				})
			})]
		}), /* @__PURE__ */ (0, J.jsx)("div", {
			className: "p-12 bg__secondary dc__border-n1 br-4 flexbox dc__column-gap-12 dc__row-gap-8 flex-wrap releases__rollout-status-table--expanded-app-list",
			children: t.map(({ deployStatus: e, preStatus: t, postStatus: n, existingStages: { pre: r, post: i }, appId: a, appName: o, envId: s, envName: c, preCdWorkflowRunnerId: l, postCdWorkflowRunnerId: u, pipelineId: d }) => /* @__PURE__ */ (0, J.jsx)(If, {
				deployStatus: e,
				preStatus: t,
				postStatus: n,
				isPreConfigured: r,
				isPostConfigured: i,
				appId: a,
				envId: s,
				appName: o,
				envName: c,
				preCdWorkflowRunnerId: l,
				postCdWorkflowRunnerId: u,
				pipelineId: d,
				expandedModeProps: {
					isExpandedMode: !0,
					appName: o,
					envName: c
				}
			}, `${s}-${a}-status`))
		})]
	}) : /* @__PURE__ */ (0, J.jsxs)("div", {
		className: `flex dc__content-space flex-grow-1 dc__gap-6 dc__visible-hover dc__visible-hover--parent ${r ? "cursor" : ""}`,
		onClick: o,
		role: "button",
		tabIndex: a ? 0 : -1,
		onKeyDown: o,
		children: [/* @__PURE__ */ (0, J.jsx)(Op, {
			tenantId: e,
			rolloutStatusSummary: n
		}), /* @__PURE__ */ (0, J.jsx)(D, {
			content: "Show deployment status for the app(s)",
			arrow: !1,
			className: "default-tt",
			placement: "top",
			children: /* @__PURE__ */ (0, J.jsx)("div", {
				className: "cursor dc__no-shrink dc__visible-hover--child flex dc__align-self-start",
				"aria-label": "Expand rollout status row",
				children: /* @__PURE__ */ (0, J.jsx)(_e, { className: "icon-dim-24 p-2 dc__no-shrink" })
			})
		})]
	});
}, Ap = ({ tenantConfig: e, apps: t, rolloutStatusSummary: n }) => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "display-grid releases__rollout-status-table fs-13 lh-20 cn-9 dc__border-bottom-n1 dc__hover-n50",
	children: [/* @__PURE__ */ (0, J.jsx)("div", {
		className: "px-16 py-10 dc__border-right--n1",
		children: /* @__PURE__ */ (0, J.jsx)(kf, {
			tenantConfig: e,
			children: /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox dc__align-items-center dc__gap-8 dc__w-fit-content",
				children: [/* @__PURE__ */ (0, J.jsx)(sf, { imageProps: {
					src: e.image,
					height: 20,
					width: 20
				} }), /* @__PURE__ */ (0, J.jsx)("span", {
					className: "dc__truncate ",
					children: e.displayText
				})]
			})
		})
	}), /* @__PURE__ */ (0, J.jsx)("div", {
		className: "px-12 py-8 flexbox dc__align-items-center",
		children: /* @__PURE__ */ (0, J.jsx)(kp, {
			tenantId: e.tenantId,
			apps: t,
			rolloutStatusSummary: n
		})
	})]
}), jp = (e) => {
	switch (e) {
		case X.yetToTrigger: return "var(--N500)";
		case X.onGoing: return "var(--O500)";
		case X.failed: return "var(--R500)";
		case X.completed: return "var(--G500)";
		default: return "var(--B500)";
	}
}, Mp = (e) => {
	switch (e) {
		case X.yetToTrigger: return {
			title: "Release rollout triggered for all tenants",
			subTitle: "Some or all application deployments are triggered for all tenants",
			image: ve
		};
		case X.onGoing: return {
			title: "No active rollouts",
			subTitle: "Tenants for which rollout is ongoing will be shown here. Failed and Completed rollouts will be shown in respective tabs.",
			image: Mi
		};
		case X.failed: return {
			title: "No failed deployments",
			subTitle: "This space is reserved for failed executions. When a deployment fails for any tenant, it will be shown here.",
			image: Ri
		};
		case X.completed: return {
			title: "Rollout is not complete for any tenant",
			subTitle: "This space is reserved for completed rollouts. When all deployments stages are completed for a tenant (installation), it will be shown here.",
			image: Ri
		};
		default: return {
			title: "No deployments available",
			subTitle: "This space is reserved for for all rollouts.",
			image: Ri
		};
	}
}, Np = (e, t) => e ? t && !Ld(t) ? e.filter(({ tenantInstallationRolloutStatus: e, apps: n }) => e === t && n.length > 0) : e : [], Pp = ({ selectedTab: e, tab: { value: t, tippyContent: n, icon: r }, handleTabChange: i, isLoading: a, countSummary: o }) => {
	let { areFiltersActive: s } = $d(), c = e === t, l = jp(t), u = o?.rolloutStatus?.[t] ?? 0, d = o?.tenantsCount?.filteredCount ?? 0;
	return /* @__PURE__ */ (0, J.jsx)(lt, {
		condition: !c,
		wrap: (e) => /* @__PURE__ */ (0, J.jsx)(D, {
			className: "default-tt w-200",
			arrow: !1,
			content: n,
			placement: "top",
			children: e
		}),
		children: /* @__PURE__ */ (0, J.jsxs)("button", {
			type: "button",
			className: `${c ? "bg__primary dc__position-rel cursor-default releases__rollout-status-tabs--item releases__rollout-status-tabs--selected" : ""} dc__transparent flexbox dc__content-space dc__gap-12 p-16 dc__hover-n0 dc__overflow-hidden`,
			onClick: () => {
				c || i(t);
			},
			style: { "--tabHighlightColor": l },
			children: [
				/* @__PURE__ */ (0, J.jsxs)("div", {
					className: `flexbox-col dc__align-start ${c ? "fw-6" : ""}`,
					children: [/* @__PURE__ */ (0, J.jsx)("div", {
						className: "fs-13 lh-20 cn-7",
						children: Ld(t) && s ? "Filtered Tenants" : lc[t]
					}), /* @__PURE__ */ (0, J.jsx)("div", {
						className: "fs-20 lh-26 dc__truncate cn-9",
						style: c && t !== X.yetToTrigger ? { color: l } : {},
						children: a ? "--" : `${u}/${d}`
					})]
				}),
				/* @__PURE__ */ (0, J.jsx)("div", {
					className: "icon-dim-24 dc__no-shrink dc__zi-1",
					children: r
				}),
				c && /* @__PURE__ */ (0, J.jsx)("div", { className: "w-80px h-80 dc__position-abs dc__blur-12 dc__opacity-0_2 dc__border-radius-50-per releases__rollout-status-tabs--selected-bg" })
			]
		}, t)
	});
}, Fp = ({ sortBy: e, sortOrder: t, handleSorting: n }) => {
	let { id: r } = Q(), { urlFilterConfig: { rolloutStatus: i, ...a }, urlFilterConfigMap: { selectedRolloutStatus: o }, handleRolloutStatusUpdate: s, areFiltersActive: c, clearFilters: l, updateFilterCountSummary: u, resetFilterCountSummary: d } = $d(), f = Pe(new AbortController()), { handleExternalSync: p, isExternalSyncLoading: m, isContentLoading: h, lastSyncedTimestamp: g, refetchResponse: _, initialError: v, responseData: y } = yf({
		urlFilterConfig: a,
		serviceHandler: async () => await rr(() => Du({
			releaseId: r,
			filterConfig: {
				...a,
				rolloutStatus: ac
			}
		}, f.current.signal), f)
	}), b = k(() => {
		if (y?.rolloutStatusList?.length) {
			let { rolloutStatusList: e } = y;
			return Np(e, o).sort((e, n) => G(e.tenantConfig.displayText, n.tenantConfig.displayText, t));
		}
		return [];
	}, [
		y,
		k(() => ({
			sortBy: e,
			sortOrder: t
		}), [e, t]),
		o
	]);
	O(() => (y && u(y?.countSummary), () => {
		d();
	}), [y]);
	let x = !h && !b?.length, S = v && !h, C = (e) => {
		s(e);
	};
	return /* @__PURE__ */ (0, J.jsx)(vf, {
		reloadData: p,
		isLoading: m,
		lastSyncedTimestamp: g,
		hidePollingToggle: S || h,
		children: S ? /* @__PURE__ */ (0, J.jsx)(It, {
			code: v.code,
			reload: _
		}) : /* @__PURE__ */ (0, J.jsx)("div", {
			className: "h-100 flexbox-col dc__align-items-center dc__mxw-1400 w-100 p-12",
			children: /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "releases__rollout-status dc__top-radius-4 dc__contain--paint bg__primary flexbox-col w-100 flex-grow-1",
				children: [/* @__PURE__ */ (0, J.jsx)("div", {
					className: "display-grid releases__rollout-status-tabs dc__no-shrink",
					children: uc.map((e) => /* @__PURE__ */ (0, J.jsx)(Pp, {
						tab: e,
						handleTabChange: C,
						isLoading: h,
						selectedTab: o,
						countSummary: y?.countSummary
					}, e.value))
				}), /* @__PURE__ */ (0, J.jsx)("div", {
					className: "h-100",
					children: x ? /* @__PURE__ */ (0, J.jsx)("div", {
						className: "flex h-100",
						children: c ? /* @__PURE__ */ (0, J.jsx)(Gt, { handleClearFilters: l }) : /* @__PURE__ */ (0, J.jsx)(F, { ...Mp(o) })
					}) : /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
						className: "display-grid releases__rollout-status-table releases__rollout-status-table--header dc__align-items-center fs-12 lh-20 fw-6 cn-7 dc__uppercase dc__border-bottom-n1 bg__primary dc__position-sticky dc__top-0 dc__zi-4",
						children: [/* @__PURE__ */ (0, J.jsx)("div", {
							className: "px-16 py-8 dc__border-right--n1",
							children: /* @__PURE__ */ (0, J.jsx)(z, {
								disabled: h,
								isSorted: e === cc.tenantInstallation,
								sortOrder: t,
								title: "Tenant (Installation)",
								triggerSorting: () => {
									n(cc.tenantInstallation);
								}
							})
						}), /* @__PURE__ */ (0, J.jsx)("div", {
							className: "px-12 py-8",
							children: Ld(o) ? "Release Status" : "Applications with status"
						})]
					}), /* @__PURE__ */ (0, J.jsx)("div", { children: h ? sc.map((e) => /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "display-grid releases__rollout-status-table fs-13 lh-20 cn-9 dc__border-bottom-n1 show-shimmer-loading",
						children: [/* @__PURE__ */ (0, J.jsx)("div", {
							className: "px-16 py-10 dc__border-right--n1",
							children: /* @__PURE__ */ (0, J.jsx)("div", { className: "child-shimmer-loading h-16 w-100" })
						}), /* @__PURE__ */ (0, J.jsx)("div", {
							className: "px-12 py-10",
							children: /* @__PURE__ */ (0, J.jsx)("div", { className: "child-shimmer-loading h-16 w-100" })
						})]
					}, `${e.tenantConfig.tenantId}-loading`)) : b.map((e) => /* @__PURE__ */ Me(Ap, {
						...e,
						key: e.tenantConfig.identifier
					})) })] })
				}, o)]
			})
		})
	});
}, Ip = () => {
	let e = Pe(null), t = mi({ initialSortKey: cc.tenantInstallation }), { triggerReleaseView: n, selectedTab: r, appStatusModalConfig: i, setAppStatusModalConfig: a } = $d(), { status: o } = Q(), s = r === Ed.triggerRelease && n === Dd.installation, [c, l] = A({}), [u, d] = A(), [f, p] = A(!1), [m, h] = A({}), g = r === Ed.rolloutStatus, { existingStagesInBulkSelection: _, selectedCount: v } = k(() => ({
		selectedCount: s ? Object.keys(m).length : Object.keys(c).reduce((e, t) => e + Object.keys(c[t]).length, 0),
		existingStagesInBulkSelection: Object.values(c).reduce((e, t) => (Object.values(t).forEach(({ existingStages: t }) => {
			e.pre = e.pre || t.pre, e.post = e.post || t.post;
		}), e), {
			pre: !1,
			post: !1,
			deploy: !0
		})
	}), [
		c,
		m,
		s
	]), y = () => {
		if (s) {
			h({});
			return;
		}
		l({});
	};
	return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox flex-grow-1 dc__overflow-auto",
		children: [/* @__PURE__ */ (0, J.jsx)(Tp, { showRolloutFilter: !g }), /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col flex-grow-1 dc__overflow-auto",
			ref: e,
			children: [!g && v > 0 && /* @__PURE__ */ (0, J.jsx)(tf, {
				existingStagesInBulkSelection: _,
				count: v,
				parentRef: e,
				handleButtonClick: (e) => {
					if (wd.includes(o)) {
						let { label: e } = Gd[o];
						B.showToast({
							variant: V.warn,
							title: `Release is ${e}`,
							description: `Cannot trigger deployments in ${e} state`
						});
						return;
					}
					e && d(e), p(!0);
				},
				handleClearBulkSelection: y
			}), g ? /* @__PURE__ */ (0, J.jsx)(Fp, { ...t }) : s ? /* @__PURE__ */ (0, J.jsx)(lp, {
				installationViewBulkSelectionState: m,
				setInstallationViewBulkSelectionState: h,
				isFeasibilityModalOpen: f,
				setIsFeasibilityModalOpen: p,
				handleClearBulkSelection: y
			}) : /* @__PURE__ */ (0, J.jsx)(Jf, {
				selectedStage: u,
				isFeasibilityModalOpen: f,
				setSelectedStage: d,
				setIsFeasibilityModalOpen: p,
				bulkSelectionState: c,
				setBulkSelectionState: l,
				handleClearBulkSelection: y
			})]
		})]
	}), i && /* @__PURE__ */ (0, J.jsx)(He, {
		titleSegments: i.titleSegments,
		handleClose: () => {
			a(null);
		},
		type: "release",
		appId: i.appId,
		envId: i.envId,
		isConfigDriftEnabled: !0,
		configDriftModal: Yy,
		processVirtualEnvironmentDeploymentData: Xu,
		debugWithAIButton: Zy
	})] });
}, Lp = () => {
	let { status: e, isLocked: t, setNewReleaseStatus: n, id: r, areAllImagesSelected: i, areDepPresent: a, installationsMappedToRelease: o } = Q(), s = Ai(), c = !t && (!i || !a), l = e === Z.DRAFT, [u, d, f, p] = K(() => bu({ releaseId: r }), [], !c && !l), [m, h] = A(!1), g = k(() => ({
		isAppEnvAndTenantLoading: u,
		appEnvAndTenantList: {
			applicationsByStages: d?.applicationsByStages ?? [],
			environments: d?.environments ?? [],
			tenantsWithInstallations: d?.tenantsWithInstallations ?? [],
			unmappedEnvironments: d?.unmappedEnvironments ?? [],
			releaseChannels: d?.releaseChannels ?? []
		},
		appEnvAndTenantListError: f,
		refetchAppEnvAndTenantList: p
	}), [
		u,
		d,
		f
	]), _ = q(I.RELEASES.DETAIL.REQUIREMENTS, {
		releaseTrack: s.releaseTrack,
		releaseVersion: s.releaseVersion,
		appName: null
	});
	if (c) return /* @__PURE__ */ (0, J.jsx)(F, {
		title: "Complete and lock requirements to deploy",
		subTitle: "Add applications and their images for deployment in this release. Create task lists for each deployment to manage critical changes.",
		isButtonAvailable: !0,
		renderButton: () => /* @__PURE__ */ (0, J.jsx)(wi, {
			to: _,
			className: "cta secondary flex anchor",
			children: "Go to requirements"
		}),
		image: Vi,
		classname: "flex-grow-1",
		contentClassName: "dc__align-center"
	});
	if (l) {
		let e = () => {
			n(Z.READY_FOR_RELEASE);
		};
		return /* @__PURE__ */ (0, J.jsx)(F, {
			title: "This release is not yet ready",
			subTitle: `Change release status to '${Gd[Z.READY_FOR_RELEASE].label}' to start deploying`,
			isButtonAvailable: !0,
			renderButton: () => /* @__PURE__ */ (0, J.jsxs)("button", {
				type: "button",
				className: "cta secondary flex anchor",
				onClick: e,
				children: [
					"Mark '",
					Gd[Z.READY_FOR_RELEASE].label,
					"'"
				]
			}),
			image: Bi,
			classname: "flex-grow-1"
		});
	}
	if (o.installations && o.installations.length === 0) return /* @__PURE__ */ (0, J.jsx)(F, {
		title: "Deployment is not enabled for any Tenant Installation",
		subTitle: "Enable tenant installations you want to rollout this release to and come back here",
		image: zi,
		isButtonAvailable: !0,
		renderButton: () => /* @__PURE__ */ (0, J.jsx)(M, {
			dataTestId: "go-to-requirements",
			component: Qe.link,
			linkProps: { to: _ },
			text: "Go to Requirements",
			endIcon: /* @__PURE__ */ (0, J.jsx)(Yt, {
				name: "ic-arrow-right",
				color: null
			}),
			size: P.large
		}),
		classname: "flex-grow-1"
	});
	if (!u && !f && !g?.appEnvAndTenantList?.environments?.length) {
		let e = g?.appEnvAndTenantList?.unmappedEnvironments?.length > 0, t = () => {
			h(!0);
		};
		return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)(F, {
			title: e ? "No environments are mapped to Tenant Installations" : "No deployment pipelines exist in applications in this release",
			subTitle: e ? "Environments must be mapped to a tenant (installation) to deploy this release" : "Create deployment pipelines for applications in this release and map the corresponding environments to tenant installations",
			image: ji,
			isButtonAvailable: e,
			renderButton: () => /* @__PURE__ */ (0, J.jsx)(M, {
				dataTestId: "view-unmapped-environments",
				text: "View Unmapped Environments",
				onClick: t,
				variant: N.text,
				size: P.large
			}),
			classname: "flex-grow-1"
		}), m && /* @__PURE__ */ (0, J.jsx)(_f, {
			unmappedEnvironments: g.appEnvAndTenantList.unmappedEnvironments,
			handleClose: () => {
				h(!1);
			}
		})] });
	}
	return /* @__PURE__ */ (0, J.jsx)(Qd, {
		appEnvAndTenantListApiState: g,
		children: /* @__PURE__ */ (0, J.jsx)(Ip, {})
	});
}, Rp = (e) => {
	let { label: t } = Gd[e], n = {
		icon: qd[e],
		iconContainerClass: "",
		title: `Change status to '${t}'`,
		buttonConfig: {
			text: `Change status to '${t}'`,
			style: $e.default
		}
	};
	switch (e) {
		case Z.DRAFT: return {
			...n,
			subTitle: "Draft state enables requirement open to modify."
		};
		case Z.READY_FOR_RELEASE: return {
			...n,
			subTitle: "You can start deploying once the release is ready.",
			buttonConfig: {
				...n.buttonConfig,
				text: "Mark ready for release"
			}
		};
		case Z.HOLD: return {
			...n,
			iconContainerClass: "scr-7 fcr-1",
			subTitle: "In 'On Hold' state, deployments cannot be triggered.",
			buttonConfig: {
				...n.buttonConfig,
				text: "Put release on hold",
				style: $e.negative
			},
			isCommentRequired: !0
		};
		case Z.RESCINDED: return {
			...n,
			iconContainerClass: "scr-5",
			subTitle: "Rescind release to mark it as buggy. Rescinded release cannot be modified or used for further deployments",
			buttonConfig: {
				...n.buttonConfig,
				text: "Rescind release",
				style: $e.negative
			},
			confirmationText: "rescind release",
			isCommentRequired: !0
		};
		default: throw Error(`Unknown release status ${e}`);
	}
}, zp = (e) => {
	switch (e) {
		case Z.RESCINDED:
		case Z.HOLD: return "scn-6";
		default: return "";
	}
}, Bp = (e) => {
	switch (e) {
		case Z.RESCINDED: return "scr-7";
		case Js.COMPLETELY_RELEASED: return "scg-7";
		default: return "";
	}
}, Vp = (e) => {
	switch (e) {
		case Z.HOLD:
		case Z.RESCINDED: return "cr-7";
		case Js.CORRUPTED: return "cy-7";
		case Js.COMPLETELY_RELEASED: return "cg-7";
		default: return "cn-7";
	}
}, Hp = fr(), Up = (e) => {
	switch (e) {
		case Z.READY_FOR_RELEASE:
		case Js.PARTIALLY_RELEASED: return { backgroundColor: "var(--Y100)" };
		case Z.HOLD: return { backgroundColor: "var(--O100)" };
		case Z.RESCINDED: return { backgroundColor: "var(--R700)" };
		case Js.COMPLETELY_RELEASED: return { backgroundColor: "var(--G100)" };
		case Js.CORRUPTED: return { backgroundColor: "var(--N500)" };
		case Z.DRAFT:
		default: return { backgroundColor: "var(--bg-secondary)" };
	}
}, Wp = (e) => ({
	...Hp,
	control: (t, n) => ({
		...Hp.control(t, n),
		minHeight: "26px",
		borderRadius: "20px",
		border: "none",
		padding: "4px 8px",
		...Up(e),
		"> div": { padding: 0 },
		"&.release-status-dropdown__control--menu-is-open .release-status-dropdown__indicator": { display: "flex" },
		":hover": { "&:not(.release-status-dropdown__control--is-disabled) .release-status-dropdown__indicator": { display: "flex" } }
	}),
	dropdownIndicator: (e, t) => ({
		...Hp.dropdownIndicator(e, t),
		padding: 0,
		paddingLeft: "2px",
		display: "none"
	}),
	menu: (e, t) => ({
		...Hp.menu(e, t),
		width: "185px"
	})
}), Gp = (e) => {
	switch (e) {
		case Js.COMPLETELY_RELEASED:
		case Js.PARTIALLY_RELEASED: return Gd[Z.READY_FOR_RELEASE].label;
		default: return "";
	}
}, Kp = ({ value: e, label: t }) => {
	let n = e, r = Gp(n);
	return /* @__PURE__ */ (0, J.jsxs)("span", {
		className: `dc__ellipsis-right flexbox dc__gap-8 ${r ? "" : "dc__align-items-center"}`,
		children: [/* @__PURE__ */ (0, J.jsx)("span", {
			className: `dc__no-shrink flex icon-dim-16 ${r ? "mt-2" : ""} ${zp(n)}`,
			children: qd[e]
		}), r ? /* @__PURE__ */ (0, J.jsxs)("span", {
			className: "flex column left dc__ellipsis-right",
			children: [/* @__PURE__ */ (0, J.jsx)("span", {
				className: "dc__ellipsis-right lh-20 fs-13 cn-9",
				children: r
			}), /* @__PURE__ */ (0, J.jsx)("span", {
				className: "dc__ellipsis-right lh-18 fs-12 cn-7",
				children: t
			})]
		}) : /* @__PURE__ */ (0, J.jsx)("span", {
			className: "dc__ellipsis-right lh-20 fs-13",
			children: t
		})]
	});
}, qp = ({ handleClose: e, handleSuccess: t, updatedStatus: n, id: r }) => {
	let { icon: i, iconContainerClass: a, title: o, subTitle: s, confirmationText: c, buttonConfig: l, isCommentRequired: u } = Rp(n), [d, f] = A(!1), [p, m] = A(""), [h, g] = A(""), _ = d || c && h !== c, v = () => /* @__PURE__ */ (0, J.jsxs)("span", { children: [
		"Type",
		/* @__PURE__ */ (0, J.jsxs)("span", {
			className: "fw-6",
			children: [
				"\xA0'",
				c,
				"'\xA0"
			]
		}),
		"to confirm"
	] }), y = (e) => {
		m(e.target.value);
	}, b = (e) => {
		g(e.target.value);
	}, x = async () => {
		if (d) return;
		if (u && !p?.trim()) {
			B.showToast({
				variant: V.error,
				description: "Add a comment why you want to change status"
			});
			return;
		}
		if (_) {
			B.showToast({
				variant: V.error,
				description: `Type '${c}' to confirm`
			});
			return;
		}
		f(!0);
		let i = {
			id: r,
			status: n,
			comment: p
		};
		try {
			let n = await $l(i);
			await t();
			let { userMessage: r = "Status updated successfully", detailMessage: a } = n?.result ?? {};
			B.showToast({
				variant: V.success,
				...a ? {
					title: r,
					description: a
				} : { description: r }
			}), f(!1), e();
		} catch (e) {
			if (e?.code === Le.BAD_REQUEST) {
				let { userMessage: t = "Cannot update status", internalMessage: n } = e?.errors?.[0] ?? {};
				B.showToast({
					variant: V.warn,
					...n ? {
						title: t,
						description: n
					} : { description: t }
				});
			} else W(e);
			f(!1);
		}
	};
	return /* @__PURE__ */ (0, J.jsx)(ut, {
		variant: dt.custom,
		Icon: /* @__PURE__ */ (0, J.jsx)("div", {
			className: `dc__fill-available-space ${a}`,
			children: i
		}),
		title: o,
		subtitle: s,
		handleClose: e,
		buttonConfig: {
			secondaryButtonConfig: {
				text: "Cancel",
				onClick: e,
				disabled: d
			},
			primaryButtonConfig: {
				text: l.text,
				onClick: x,
				isLoading: d,
				style: l.style
			}
		},
		children: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col dc__gap-12 w-100",
			children: [/* @__PURE__ */ (0, J.jsx)(Un, {
				name: "release-comment",
				label: `Add comment${u ? "" : " (Optional)"}`,
				onChange: y,
				placeholder: "Add a reason why you want to change status...",
				value: p,
				required: u
			}), c && /* @__PURE__ */ (0, J.jsx)(pt, {
				name: "status-change-confirmation",
				label: v(),
				required: !0,
				placeholder: "Type to confirm",
				onChange: b,
				value: h,
				onKeyDown: async (e) => {
					e.key === "Enter" && (e.preventDefault(), await x());
				}
			})]
		})
	});
}, Jp = (e) => {
	let { data: { label: t, value: n } } = e;
	return /* @__PURE__ */ (0, J.jsx)(Ii.SingleValue, {
		...e,
		children: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox dc__align-items-center dc__gap-6",
			children: [/* @__PURE__ */ (0, J.jsx)("span", {
				className: "icon-dim-14 dc__no-shrink dc__fill-available-space flex",
				children: qd[n]
			}), /* @__PURE__ */ (0, J.jsx)("span", {
				className: `dc__truncate fs-12 fw-6 lh-18 ${Jd[n]}`,
				children: t
			})]
		})
	});
}, Yp = ({ currentStatus: e, id: t, handleStatusChangeSuccess: n, newReleaseStatus: r, setNewReleaseStatus: i = U }) => {
	let [a, o] = A(r), [s, c] = A(!1), l = e === Js.CORRUPTED || e === Z.RESCINDED, u = Kd[e] ?? [], d = Wp(e);
	return O(() => {
		o(r), c(!!(r && r !== e));
	}, [r]), /* @__PURE__ */ (0, J.jsxs)("div", {
		onClick: ei,
		children: [/* @__PURE__ */ (0, J.jsx)(Fi, {
			options: u,
			placeholder: "Select release status",
			components: {
				IndicatorSeparator: null,
				SingleValue: Jp,
				LoadingIndicator: an,
				ClearIndicator: null
			},
			onChange: ({ value: t }) => {
				let n = t;
				n !== e && Object.values(Z).includes(n) && (o(n), c(!0));
			},
			formatOptionLabel: Kp,
			value: Gd[e],
			isSearchable: !1,
			styles: d,
			menuPlacement: "auto",
			menuPosition: "fixed",
			isDisabled: l,
			classNamePrefix: "release-status-dropdown"
		}), s && a && /* @__PURE__ */ (0, J.jsx)(qp, {
			id: t,
			updatedStatus: a,
			handleClose: () => {
				c(!1), i(null);
			},
			handleSuccess: n
		})]
	});
}, Xp = () => {
	let e = ki(), t = Oi(), n = Ai(), { name: r, version: i, track: a } = Q(), o = {
		label: r,
		value: i
	}, [s, c, l, u] = K(() => _u({ trackName: a }), [a]);
	return /* @__PURE__ */ (0, J.jsx)(ft, {
		options: [{
			label: "All Releases",
			options: (c ?? []).map((e) => ({
				label: e.name,
				value: e.version,
				description: e.version
			}))
		}],
		onChange: (r) => {
			if (r.value === i) return;
			Ir({
				category: "Release Selector",
				action: Fc.SDH_SWITCH_RELEASE_ITEM_CLICKED
			});
			let a = q(I.RELEASES.DETAIL.ROOT, {
				releaseTrack: n.releaseTrack,
				releaseVersion: n.releaseVersion
			}), o = t.pathname.replace(a, "").split("/")[1];
			e(`${q(I.RELEASES.DETAIL.ROOT, {
				releaseTrack: n.releaseTrack,
				releaseVersion: r.value
			})}/${o}`);
		},
		value: o,
		inputId: `release-switcher-${a}`,
		isLoading: s,
		optionListError: l,
		reloadOptionList: u,
		resource: "Release"
	});
}, Zp = () => {
	let { id: e, track: t, status: n, refetchReleaseDetail: r, isLocked: i, newReleaseStatus: a, setNewReleaseStatus: o } = Q(), { breadcrumbs: s } = ri(I.RELEASES.DETAIL.ROOT, { alias: {
		...bl(),
		releases: {
			component: /* @__PURE__ */ (0, J.jsx)(Je, { heading: "Release Hub" }),
			linked: !0
		},
		detail: { component: null },
		":releaseTrack": { component: /* @__PURE__ */ (0, J.jsx)(wi, {
			to: q(I.RELEASES.TRACK_DETAIL, { trackName: t }),
			className: "anchor cb-5 fs-16 fw-4 lh-24 dc__ellipsis-right dc__mxw-155",
			children: t
		}) },
		":releaseVersion": { component: /* @__PURE__ */ (0, J.jsx)(Xp, {}) }
	} }), c = () => /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox dc__gap-12 dc__align-items-center",
		children: [
			/* @__PURE__ */ (0, J.jsx)("div", {
				className: "flexbox dc__align-items-center",
				children: /* @__PURE__ */ (0, J.jsx)(qe, {
					breadcrumbs: s,
					path: I.RELEASES.DETAIL.ROOT
				})
			}),
			/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-right lh-20 h-20" }),
			/* @__PURE__ */ (0, J.jsx)(Yp, {
				id: e,
				currentStatus: n,
				handleStatusChangeSuccess: r,
				newReleaseStatus: a,
				setNewReleaseStatus: o
			}, n)
		]
	}), l = [
		{
			id: "releases-overview-tab",
			tabType: "navLink",
			label: "Overview",
			props: {
				to: j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.DETAIL.OVERVIEW,
				"data-action": "Overview Clicked",
				"data-testid": "Overview-click"
			}
		},
		{
			id: "releases-requirements-tab",
			tabType: "navLink",
			label: "Requirements",
			props: {
				to: j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.DETAIL.REQUIREMENTS.ROOT.split("/")[0],
				"data-action": "Requirement Clicked",
				"data-testid": "Requirement-click"
			},
			icon: i ? Ws : v
		},
		{
			id: "releases-rollout-tab",
			tabType: "navLink",
			label: "Rollout Release",
			props: {
				to: j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.DETAIL.ROLLOUT_RELEASE,
				"data-action": "Rollout Release Clicked",
				"data-testid": "Rollout-Release-click"
			}
		},
		{
			id: "releases-history-tab",
			tabType: "navLink",
			label: "Rollout History",
			props: {
				to: j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.DETAIL.HISTORY.split("/")[0],
				"data-action": "Release Rollout History Clicked",
				"data-testid": "Release-Rollout-History-click"
			}
		},
		{
			id: "releases-configurations-tab",
			tabType: "navLink",
			label: "Configurations",
			props: {
				to: j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.DETAIL.CONFIGURATIONS.split("/")[0],
				"data-action": "Release Configurations Clicked",
				"data-testid": "Release-configurations-click"
			}
		}
	];
	return /* @__PURE__ */ (0, J.jsx)(pn, {
		showTabs: !0,
		renderHeaderTabs: () => /* @__PURE__ */ (0, J.jsx)(Vn, {
			tabs: l,
			hideTopPadding: !0
		}),
		isBreadcrumbs: !0,
		breadCrumbs: c,
		docPath: vt.SOFTWARE_DISTRIBUTION_HUB
	});
}, Qp = /* @__PURE__ */ function(e) {
	return e.CUSTOM_PANEL = "CustomPanel", e;
}({}), $p = Symbol("expanded"), em = Symbol("collapsed"), tm = {
	GUI: "gui",
	JSON: "json"
}, nm = Object.values(Qp).reduce((e, t) => (e[t] = !0, e), {}), rm = /* @__PURE__ */ function(e) {
	return e.date = "date", e.dateTime = "date-time", e.uri = "uri", e;
}({}), im = {
	[L.job]: "Job",
	[L.devtronApplication]: "Devtron Application",
	[L.helmChart]: "Helm Applications",
	[L.cluster]: "Cluster",
	[L.release]: "Release",
	[L.tenant]: "Tenant"
}, am = [{
	value: tm.GUI,
	label: "GUI"
}, {
	value: tm.JSON,
	label: "JSON"
}], om = {
	SCHEMA: "schema",
	SAMPLE_SCHEMA: "sample-schema"
}, sm = {
	name: "schema-name",
	kind: "schema-kind",
	description: "schema-description"
}, cm = (e) => `Max ${e} characters allowed`, lm = "Please provide schema name", um = (e) => JSON.stringify(JSON.parse(e ?? "{}"), null, 2), dm = ({ name: e, schema: t, description: n, ...r }) => ({
	...r,
	displayName: e?.trim(),
	schema: um(t?.trim()),
	description: n?.trim()
}), fm = ({ devtronResourceId: e, displayName: t, kind: n, description: r }) => ({
	id: e,
	name: t ?? "",
	kind: h[n] ?? n,
	description: r
}), pm = [{
	label: "Schema",
	value: om.SCHEMA
}, {
	label: "Sample Schema",
	value: om.SAMPLE_SCHEMA
}], mm = async (e) => {
	try {
		let { result: t } = await H(Nr("resource/schema", { resourceId: e })), { versionSchemaDetails: n, displayName: r, description: i, kind: a, devtronResourceId: o } = t;
		return {
			...fm({
				displayName: r,
				description: i,
				kind: a,
				devtronResourceId: o
			}),
			schema: um(n[0].schema),
			sampleSchema: um(n[0].sampleSchema),
			devtronResourceSchemaId: n[0].devtronResourceSchemaId
		};
	} catch (e) {
		throw W(e), e;
	}
}, hm = (e, t = !1) => Yr(Nr("resource/schema", { dryRun: t }), dm(e)), gm = ({ formState: e, handleFieldUpdate: t }) => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "flexbox-col dc__gap-12 pr-20 pl-20 dc__mxw-960",
	children: [/* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox dc__gap-16",
		children: [/* @__PURE__ */ (0, J.jsx)("div", {
			className: "flex-1",
			children: /* @__PURE__ */ (0, J.jsx)(pt, {
				label: "Name",
				required: !0,
				placeholder: "Name for the schema",
				name: sm.name,
				value: e[sm.name].value,
				onChange: t,
				error: e[sm.name].error
			})
		}), /* @__PURE__ */ (0, J.jsx)("div", {
			className: "flex-1",
			children: /* @__PURE__ */ (0, J.jsx)(pt, {
				label: "Kind",
				required: !0,
				placeholder: "Kind for the schema",
				name: sm.kind,
				value: e[sm.kind].value,
				disabled: !0,
				onChange: null
			})
		})]
	}), /* @__PURE__ */ (0, J.jsx)(pt, {
		label: "Description",
		placeholder: "Description for the schema",
		name: sm.description,
		value: e[sm.description].value,
		onChange: t,
		error: e[sm.description].error,
		fullWidth: !0
	})]
}), _m = ({ schema: e, sampleSchema: t, validateSchema: n, isLoading: r, handleCancelManageSchema: i }) => {
	let [a, o] = A(om.SCHEMA), [s, c] = A(!1), [l, u] = A(e), f = a === om.SCHEMA, p = f ? l : t, m = r, h = (e) => {
		u(e);
	}, g = () => {
		c(!s);
	}, _ = () => {
		n(l);
	};
	return O(() => {
		u(e);
	}, [e]), /* @__PURE__ */ (0, J.jsx)("div", {
		className: "flexbox-col dc__align-start dc__align-self-stretch flex-grow-1 dc__no-shrink",
		children: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col dc__align-start flex-grow-1 dc__no-shrink dc__align-self-stretch",
			children: [!s && /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flex flex-justify pr-20 pl-20 pt-8 pb-8 dc__align-self-stretch dc__border-bottom-n1",
				children: [/* @__PURE__ */ (0, J.jsx)(kn, {
					name: "resource-detail-tabs",
					segments: pm,
					value: a,
					onChange: (e) => {
						o(e.value);
					}
				}), /* @__PURE__ */ (0, J.jsx)(at, {
					content: p,
					copiedTippyText: f ? "Copied schema" : "Copied sample schema"
				})]
			}), f ? /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [
				s && /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "bcn-1 flexbox dc__content-space w-100 h-32 dc__align-items-center",
					children: [/* @__PURE__ */ (0, J.jsxs)("div", {
						className: "dc__border-right fs-12 fw-6 cn-7 pt-8 pb-8 pl-12 pr-12 flex flex-justify",
						style: { width: "48.5%" },
						children: ["Saved", /* @__PURE__ */ (0, J.jsx)(d, {
							className: "icon-dim-16 mw-16 cursor",
							onClick: g
						})]
					}), /* @__PURE__ */ (0, J.jsx)("div", {
						className: "fs-12 fw-6 cn-7 flex-grow-1 dc__gap-4 flexbox pt-8 pb-8 pl-12 pr-12",
						children: "Editing"
					})]
				}),
				/* @__PURE__ */ (0, J.jsx)(ot, {
					mode: ln.JSON,
					diffView: s,
					noParsing: !0,
					height: "fitToParent",
					...s ? {
						diffView: !0,
						modifiedValue: p,
						originalValue: f ? e : t,
						onModifiedValueChange: h
					} : {
						diffView: !1,
						value: p,
						onChange: h
					}
				}),
				/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox pt-16 pb-16 pl-20 pr-20 dc__border-top-n1 dc__align-items-center dc__content-end dc__align-self-stretch dc__gap-8",
					children: [/* @__PURE__ */ (0, J.jsx)(M, {
						dataTestId: "cancel-edit-schema",
						disabled: m,
						onClick: s ? g : i,
						text: "Cancel",
						variant: N.secondary,
						style: $e.neutral,
						size: P.medium
					}), /* @__PURE__ */ (0, J.jsx)(M, {
						dataTestId: "schema-editor-save-button",
						disabled: m,
						onClick: s ? _ : g,
						isLoading: r,
						text: s ? "Save" : "Review Changes",
						endIcon: s ? null : /* @__PURE__ */ (0, J.jsx)(Yt, {
							name: "ic-arrow-right",
							color: null
						}),
						size: P.medium
					})]
				})
			] }) : /* @__PURE__ */ (0, J.jsx)(ot, {
				mode: ln.JSON,
				noParsing: !0,
				readOnly: !0,
				value: p,
				height: "fitToParent"
			})]
		})
	});
}, vm = ({ devtronResourceId: e, handleCancelManageSchema: t, resourceType: n }) => {
	let r = Pe(null), [i, a, o, s] = K(() => mm(e)), [c, l] = A({}), [u, d] = A(!1), [f, p] = A(!1), m = i || !a || Object.keys(c).length === 0;
	O(() => {
		a && l({
			[sm.name]: {
				value: a.name ?? "",
				error: null
			},
			[sm.description]: {
				value: a.description ?? "",
				error: null
			},
			[sm.kind]: {
				value: a.kind,
				error: null
			}
		});
	}, [a]);
	let h = (e) => {
		let t = e.target.name, n = e.target.value ?? "", r = n.trim(), i;
		t === sm.name ? r ? r.length > 50 && (i = cm(50)) : i = lm : t === sm.description && r.length > 300 && (i = cm(300)), l({
			...c,
			[t]: {
				...c[t],
				value: n,
				error: i
			}
		});
	}, g = () => {
		d(!u);
	}, _ = (e, t) => Object.values(c).some((e) => !!e.error) ? Promise.reject(Error(b)) : hm({
		name: c[sm.name].value,
		description: c[sm.description].value,
		devtronResourceSchemaId: a.devtronResourceSchemaId,
		schema: e
	}, t), v = async () => {
		try {
			p(!0), await _(r.current, !1), B.showToast({
				variant: V.success,
				description: "Schema updated successfully"
			}), s(), d(!1), t();
		} catch (e) {
			W(e);
		} finally {
			p(!1);
		}
	};
	return o ? o.code === 404 ? /* @__PURE__ */ (0, J.jsx)(F, {
		title: "The requested resource doesn't exist",
		classname: "flex-grow-1",
		isButtonAvailable: !0,
		renderButton: () => /* @__PURE__ */ (0, J.jsx)(M, {
			dataTestId: "go-to-overview",
			text: "Go to Overview",
			onClick: t
		})
	}) : /* @__PURE__ */ (0, J.jsx)(Tn, { reload: s }) : /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)(nn, { heading: `Following catalog schema will be applied for all ${im[n].toLowerCase()}s` }), /* @__PURE__ */ (0, J.jsx)("section", {
		className: "flexbox-col dc__content-space dc__gap-16 flex-grow-1 dc__overflow-hidden pt-16",
		children: m ? /* @__PURE__ */ (0, J.jsx)(_n, { pageLoader: !0 }) : /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [
			/* @__PURE__ */ (0, J.jsx)(gm, {
				handleFieldUpdate: h,
				formState: c
			}),
			/* @__PURE__ */ (0, J.jsx)(_m, {
				schema: a.schema,
				sampleSchema: a.sampleSchema,
				validateSchema: async (e) => {
					p(!0), r.current = e;
					try {
						let { result: { pathsToRemove: t = [] } } = await _(e, !0);
						t.length ? (p(!1), g()) : await v();
					} catch (e) {
						W(e), p(!1);
					}
				},
				isLoading: f,
				handleCancelManageSchema: t
			}),
			u && /* @__PURE__ */ (0, J.jsx)(ut, {
				variant: dt.warning,
				title: "Data will be cleared for updated fields",
				subtitle: "Some existing fields have been updated. Any saved values for the updated fields will be cleared and will need to be provided again.",
				buttonConfig: {
					secondaryButtonConfig: {
						text: "Cancel",
						disabled: f,
						onClick: g
					},
					primaryButtonConfig: {
						text: "Save changes",
						isLoading: f,
						onClick: v
					}
				},
				handleClose: g,
				children: /* @__PURE__ */ (0, J.jsx)("span", {
					className: "fs-13 lh-21 cn-7 fw-4",
					children: "Are you sure you want to proceed?"
				})
			})
		] })
	})] });
}, ym = class {
	add(e, t, n) {
		if (typeof arguments[0] != "string") for (let e in arguments[0]) this.add(e, arguments[0][e], arguments[1]);
		else (Array.isArray(e) ? e : [e]).forEach(function(e) {
			this[e] = this[e] || [], t && this[e][n ? "unshift" : "push"](t);
		}, this);
	}
	run(e, t) {
		this[e] = this[e] || [], this[e].forEach(function(e) {
			e.call(t && t.context ? t.context : t, t);
		});
	}
}, bm = class {
	constructor(e) {
		this.jsep = e, this.registered = {};
	}
	register() {
		[...arguments].forEach((e) => {
			if (typeof e != "object" || !e.name || !e.init) throw Error("Invalid JSEP plugin format");
			this.registered[e.name] || (e.init(this.jsep), this.registered[e.name] = e);
		});
	}
}, xm = class e {
	static get version() {
		return "1.4.0";
	}
	static toString() {
		return "JavaScript Expression Parser (JSEP) v" + e.version;
	}
	static addUnaryOp(t) {
		return e.max_unop_len = Math.max(t.length, e.max_unop_len), e.unary_ops[t] = 1, e;
	}
	static addBinaryOp(t, n, r) {
		return e.max_binop_len = Math.max(t.length, e.max_binop_len), e.binary_ops[t] = n, r ? e.right_associative.add(t) : e.right_associative.delete(t), e;
	}
	static addIdentifierChar(t) {
		return e.additional_identifier_chars.add(t), e;
	}
	static addLiteral(t, n) {
		return e.literals[t] = n, e;
	}
	static removeUnaryOp(t) {
		return delete e.unary_ops[t], t.length === e.max_unop_len && (e.max_unop_len = e.getMaxKeyLen(e.unary_ops)), e;
	}
	static removeAllUnaryOps() {
		return e.unary_ops = {}, e.max_unop_len = 0, e;
	}
	static removeIdentifierChar(t) {
		return e.additional_identifier_chars.delete(t), e;
	}
	static removeBinaryOp(t) {
		return delete e.binary_ops[t], t.length === e.max_binop_len && (e.max_binop_len = e.getMaxKeyLen(e.binary_ops)), e.right_associative.delete(t), e;
	}
	static removeAllBinaryOps() {
		return e.binary_ops = {}, e.max_binop_len = 0, e;
	}
	static removeLiteral(t) {
		return delete e.literals[t], e;
	}
	static removeAllLiterals() {
		return e.literals = {}, e;
	}
	get char() {
		return this.expr.charAt(this.index);
	}
	get code() {
		return this.expr.charCodeAt(this.index);
	}
	constructor(e) {
		this.expr = e, this.index = 0;
	}
	static parse(t) {
		return new e(t).parse();
	}
	static getMaxKeyLen(e) {
		return Math.max(0, ...Object.keys(e).map((e) => e.length));
	}
	static isDecimalDigit(e) {
		return e >= 48 && e <= 57;
	}
	static binaryPrecedence(t) {
		return e.binary_ops[t] || 0;
	}
	static isIdentifierStart(t) {
		return t >= 65 && t <= 90 || t >= 97 && t <= 122 || t >= 128 && !e.binary_ops[String.fromCharCode(t)] || e.additional_identifier_chars.has(String.fromCharCode(t));
	}
	static isIdentifierPart(t) {
		return e.isIdentifierStart(t) || e.isDecimalDigit(t);
	}
	throwError(e) {
		let t = /* @__PURE__ */ Error(e + " at character " + this.index);
		throw t.index = this.index, t.description = e, t;
	}
	runHook(t, n) {
		if (e.hooks[t]) {
			let r = {
				context: this,
				node: n
			};
			return e.hooks.run(t, r), r.node;
		}
		return n;
	}
	searchHook(t) {
		if (e.hooks[t]) {
			let n = { context: this };
			return e.hooks[t].find(function(e) {
				return e.call(n.context, n), n.node;
			}), n.node;
		}
	}
	gobbleSpaces() {
		let t = this.code;
		for (; t === e.SPACE_CODE || t === e.TAB_CODE || t === e.LF_CODE || t === e.CR_CODE;) t = this.expr.charCodeAt(++this.index);
		this.runHook("gobble-spaces");
	}
	parse() {
		this.runHook("before-all");
		let t = this.gobbleExpressions(), n = t.length === 1 ? t[0] : {
			type: e.COMPOUND,
			body: t
		};
		return this.runHook("after-all", n);
	}
	gobbleExpressions(t) {
		let n = [], r, i;
		for (; this.index < this.expr.length;) if (r = this.code, r === e.SEMCOL_CODE || r === e.COMMA_CODE) this.index++;
		else if (i = this.gobbleExpression()) n.push(i);
		else if (this.index < this.expr.length) {
			if (r === t) break;
			this.throwError("Unexpected \"" + this.char + "\"");
		}
		return n;
	}
	gobbleExpression() {
		let e = this.searchHook("gobble-expression") || this.gobbleBinaryExpression();
		return this.gobbleSpaces(), this.runHook("after-expression", e);
	}
	gobbleBinaryOp() {
		this.gobbleSpaces();
		let t = this.expr.substr(this.index, e.max_binop_len), n = t.length;
		for (; n > 0;) {
			if (e.binary_ops.hasOwnProperty(t) && (!e.isIdentifierStart(this.code) || this.index + t.length < this.expr.length && !e.isIdentifierPart(this.expr.charCodeAt(this.index + t.length)))) return this.index += n, t;
			t = t.substr(0, --n);
		}
		return !1;
	}
	gobbleBinaryExpression() {
		let t, n, r, i, a, o, s, c, l;
		if (o = this.gobbleToken(), !o || (n = this.gobbleBinaryOp(), !n)) return o;
		for (a = {
			value: n,
			prec: e.binaryPrecedence(n),
			right_a: e.right_associative.has(n)
		}, s = this.gobbleToken(), s || this.throwError("Expected expression after " + n), i = [
			o,
			a,
			s
		]; n = this.gobbleBinaryOp();) {
			if (r = e.binaryPrecedence(n), r === 0) {
				this.index -= n.length;
				break;
			}
			a = {
				value: n,
				prec: r,
				right_a: e.right_associative.has(n)
			}, l = n;
			let c = (e) => a.right_a && e.right_a ? r > e.prec : r <= e.prec;
			for (; i.length > 2 && c(i[i.length - 2]);) s = i.pop(), n = i.pop().value, o = i.pop(), t = {
				type: e.BINARY_EXP,
				operator: n,
				left: o,
				right: s
			}, i.push(t);
			t = this.gobbleToken(), t || this.throwError("Expected expression after " + l), i.push(a, t);
		}
		for (c = i.length - 1, t = i[c]; c > 1;) t = {
			type: e.BINARY_EXP,
			operator: i[c - 1].value,
			left: i[c - 2],
			right: t
		}, c -= 2;
		return t;
	}
	gobbleToken() {
		let t, n, r, i;
		if (this.gobbleSpaces(), i = this.searchHook("gobble-token"), i) return this.runHook("after-token", i);
		if (t = this.code, e.isDecimalDigit(t) || t === e.PERIOD_CODE) return this.gobbleNumericLiteral();
		if (t === e.SQUOTE_CODE || t === e.DQUOTE_CODE) i = this.gobbleStringLiteral();
		else if (t === e.OBRACK_CODE) i = this.gobbleArray();
		else {
			for (n = this.expr.substr(this.index, e.max_unop_len), r = n.length; r > 0;) {
				if (e.unary_ops.hasOwnProperty(n) && (!e.isIdentifierStart(this.code) || this.index + n.length < this.expr.length && !e.isIdentifierPart(this.expr.charCodeAt(this.index + n.length)))) {
					this.index += r;
					let t = this.gobbleToken();
					return t || this.throwError("missing unaryOp argument"), this.runHook("after-token", {
						type: e.UNARY_EXP,
						operator: n,
						argument: t,
						prefix: !0
					});
				}
				n = n.substr(0, --r);
			}
			e.isIdentifierStart(t) ? (i = this.gobbleIdentifier(), e.literals.hasOwnProperty(i.name) ? i = {
				type: e.LITERAL,
				value: e.literals[i.name],
				raw: i.name
			} : i.name === e.this_str && (i = { type: e.THIS_EXP })) : t === e.OPAREN_CODE && (i = this.gobbleGroup());
		}
		return i ? (i = this.gobbleTokenProperty(i), this.runHook("after-token", i)) : this.runHook("after-token", !1);
	}
	gobbleTokenProperty(t) {
		this.gobbleSpaces();
		let n = this.code;
		for (; n === e.PERIOD_CODE || n === e.OBRACK_CODE || n === e.OPAREN_CODE || n === e.QUMARK_CODE;) {
			let r;
			if (n === e.QUMARK_CODE) {
				if (this.expr.charCodeAt(this.index + 1) !== e.PERIOD_CODE) break;
				r = !0, this.index += 2, this.gobbleSpaces(), n = this.code;
			}
			this.index++, n === e.OBRACK_CODE ? (t = {
				type: e.MEMBER_EXP,
				computed: !0,
				object: t,
				property: this.gobbleExpression()
			}, t.property || this.throwError("Unexpected \"" + this.char + "\""), this.gobbleSpaces(), n = this.code, n !== e.CBRACK_CODE && this.throwError("Unclosed ["), this.index++) : n === e.OPAREN_CODE ? t = {
				type: e.CALL_EXP,
				arguments: this.gobbleArguments(e.CPAREN_CODE),
				callee: t
			} : (n === e.PERIOD_CODE || r) && (r && this.index--, this.gobbleSpaces(), t = {
				type: e.MEMBER_EXP,
				computed: !1,
				object: t,
				property: this.gobbleIdentifier()
			}), r && (t.optional = !0), this.gobbleSpaces(), n = this.code;
		}
		return t;
	}
	gobbleNumericLiteral() {
		let t = "", n, r;
		for (; e.isDecimalDigit(this.code);) t += this.expr.charAt(this.index++);
		if (this.code === e.PERIOD_CODE) for (t += this.expr.charAt(this.index++); e.isDecimalDigit(this.code);) t += this.expr.charAt(this.index++);
		if (n = this.char, n === "e" || n === "E") {
			for (t += this.expr.charAt(this.index++), n = this.char, (n === "+" || n === "-") && (t += this.expr.charAt(this.index++)); e.isDecimalDigit(this.code);) t += this.expr.charAt(this.index++);
			e.isDecimalDigit(this.expr.charCodeAt(this.index - 1)) || this.throwError("Expected exponent (" + t + this.char + ")");
		}
		return r = this.code, e.isIdentifierStart(r) ? this.throwError("Variable names cannot start with a number (" + t + this.char + ")") : (r === e.PERIOD_CODE || t.length === 1 && t.charCodeAt(0) === e.PERIOD_CODE) && this.throwError("Unexpected period"), {
			type: e.LITERAL,
			value: parseFloat(t),
			raw: t
		};
	}
	gobbleStringLiteral() {
		let t = "", n = this.index, r = this.expr.charAt(this.index++), i = !1;
		for (; this.index < this.expr.length;) {
			let e = this.expr.charAt(this.index++);
			if (e === r) {
				i = !0;
				break;
			} else if (e === "\\") switch (e = this.expr.charAt(this.index++), e) {
				case "n":
					t += "\n";
					break;
				case "r":
					t += "\r";
					break;
				case "t":
					t += "	";
					break;
				case "b":
					t += "\b";
					break;
				case "f":
					t += "\f";
					break;
				case "v":
					t += "\v";
					break;
				default: t += e;
			}
			else t += e;
		}
		return i || this.throwError("Unclosed quote after \"" + t + "\""), {
			type: e.LITERAL,
			value: t,
			raw: this.expr.substring(n, this.index)
		};
	}
	gobbleIdentifier() {
		let t = this.code, n = this.index;
		for (e.isIdentifierStart(t) ? this.index++ : this.throwError("Unexpected " + this.char); this.index < this.expr.length && (t = this.code, e.isIdentifierPart(t));) this.index++;
		return {
			type: e.IDENTIFIER,
			name: this.expr.slice(n, this.index)
		};
	}
	gobbleArguments(t) {
		let n = [], r = !1, i = 0;
		for (; this.index < this.expr.length;) {
			this.gobbleSpaces();
			let a = this.code;
			if (a === t) {
				r = !0, this.index++, t === e.CPAREN_CODE && i && i >= n.length && this.throwError("Unexpected token " + String.fromCharCode(t));
				break;
			} else if (a === e.COMMA_CODE) {
				if (this.index++, i++, i !== n.length) {
					if (t === e.CPAREN_CODE) this.throwError("Unexpected token ,");
					else if (t === e.CBRACK_CODE) for (let e = n.length; e < i; e++) n.push(null);
				}
			} else if (n.length !== i && i !== 0) this.throwError("Expected comma");
			else {
				let t = this.gobbleExpression();
				(!t || t.type === e.COMPOUND) && this.throwError("Expected comma"), n.push(t);
			}
		}
		return r || this.throwError("Expected " + String.fromCharCode(t)), n;
	}
	gobbleGroup() {
		this.index++;
		let t = this.gobbleExpressions(e.CPAREN_CODE);
		if (this.code === e.CPAREN_CODE) return this.index++, t.length === 1 ? t[0] : t.length ? {
			type: e.SEQUENCE_EXP,
			expressions: t
		} : !1;
		this.throwError("Unclosed (");
	}
	gobbleArray() {
		return this.index++, {
			type: e.ARRAY_EXP,
			elements: this.gobbleArguments(e.CBRACK_CODE)
		};
	}
}, Sm = new ym();
Object.assign(xm, {
	hooks: Sm,
	plugins: new bm(xm),
	COMPOUND: "Compound",
	SEQUENCE_EXP: "SequenceExpression",
	IDENTIFIER: "Identifier",
	MEMBER_EXP: "MemberExpression",
	LITERAL: "Literal",
	THIS_EXP: "ThisExpression",
	CALL_EXP: "CallExpression",
	UNARY_EXP: "UnaryExpression",
	BINARY_EXP: "BinaryExpression",
	ARRAY_EXP: "ArrayExpression",
	TAB_CODE: 9,
	LF_CODE: 10,
	CR_CODE: 13,
	SPACE_CODE: 32,
	PERIOD_CODE: 46,
	COMMA_CODE: 44,
	SQUOTE_CODE: 39,
	DQUOTE_CODE: 34,
	OPAREN_CODE: 40,
	CPAREN_CODE: 41,
	OBRACK_CODE: 91,
	CBRACK_CODE: 93,
	QUMARK_CODE: 63,
	SEMCOL_CODE: 59,
	COLON_CODE: 58,
	unary_ops: {
		"-": 1,
		"!": 1,
		"~": 1,
		"+": 1
	},
	binary_ops: {
		"||": 1,
		"??": 1,
		"&&": 2,
		"|": 3,
		"^": 4,
		"&": 5,
		"==": 6,
		"!=": 6,
		"===": 6,
		"!==": 6,
		"<": 7,
		">": 7,
		"<=": 7,
		">=": 7,
		"<<": 8,
		">>": 8,
		">>>": 8,
		"+": 9,
		"-": 9,
		"*": 10,
		"/": 10,
		"%": 10,
		"**": 11
	},
	right_associative: new Set(["**"]),
	additional_identifier_chars: new Set(["$", "_"]),
	literals: {
		true: !0,
		false: !1,
		null: null
	},
	this_str: "this"
}), xm.max_unop_len = xm.getMaxKeyLen(xm.unary_ops), xm.max_binop_len = xm.getMaxKeyLen(xm.binary_ops);
var Cm = (e) => new xm(e).parse(), wm = Object.getOwnPropertyNames(class {});
Object.getOwnPropertyNames(xm).filter((e) => !wm.includes(e) && Cm[e] === void 0).forEach((e) => {
	Cm[e] = xm[e];
}), Cm.Jsep = xm;
var Tm = "ConditionalExpression";
Cm.plugins.register({
	name: "ternary",
	init(e) {
		e.hooks.add("after-expression", function(t) {
			if (t.node && this.code === e.QUMARK_CODE) {
				this.index++;
				let n = t.node, r = this.gobbleExpression();
				if (r || this.throwError("Expected expression"), this.gobbleSpaces(), this.code === e.COLON_CODE) {
					this.index++;
					let i = this.gobbleExpression();
					if (i || this.throwError("Expected expression"), t.node = {
						type: Tm,
						test: n,
						consequent: r,
						alternate: i
					}, n.operator && e.binary_ops[n.operator] <= .9) {
						let r = n;
						for (; r.right.operator && e.binary_ops[r.right.operator] <= .9;) r = r.right;
						t.node.test = r.right, r.right = t.node, t.node = n;
					}
				} else this.throwError("Expected :");
			}
		});
	}
});
var Em = 47, Dm = 92, Om = {
	name: "regex",
	init(e) {
		e.hooks.add("gobble-token", function(t) {
			if (this.code === Em) {
				let n = ++this.index, r = !1;
				for (; this.index < this.expr.length;) {
					if (this.code === Em && !r) {
						let r = this.expr.slice(n, this.index), i = "";
						for (; ++this.index < this.expr.length;) {
							let e = this.code;
							if (e >= 97 && e <= 122 || e >= 65 && e <= 90 || e >= 48 && e <= 57) i += this.char;
							else break;
						}
						let a;
						try {
							a = new RegExp(r, i);
						} catch (e) {
							this.throwError(e.message);
						}
						return t.node = {
							type: e.LITERAL,
							value: a,
							raw: this.expr.slice(n - 1, this.index)
						}, t.node = this.gobbleTokenProperty(t.node), t.node;
					}
					this.code === e.OBRACK_CODE ? r = !0 : r && this.code === e.CBRACK_CODE && (r = !1), this.index += this.code === Dm ? 2 : 1;
				}
				this.throwError("Unclosed Regex");
			}
		});
	}
}, km = 43, Am = {
	name: "assignment",
	assignmentOperators: new Set([
		"=",
		"*=",
		"**=",
		"/=",
		"%=",
		"+=",
		"-=",
		"<<=",
		">>=",
		">>>=",
		"&=",
		"^=",
		"|=",
		"||=",
		"&&=",
		"??="
	]),
	updateOperators: [km, 45],
	assignmentPrecedence: .9,
	init(e) {
		let t = [e.IDENTIFIER, e.MEMBER_EXP];
		Am.assignmentOperators.forEach((t) => e.addBinaryOp(t, Am.assignmentPrecedence, !0)), e.hooks.add("gobble-token", function(e) {
			let n = this.code;
			Am.updateOperators.some((e) => e === n && e === this.expr.charCodeAt(this.index + 1)) && (this.index += 2, e.node = {
				type: "UpdateExpression",
				operator: n === km ? "++" : "--",
				argument: this.gobbleTokenProperty(this.gobbleIdentifier()),
				prefix: !0
			}, (!e.node.argument || !t.includes(e.node.argument.type)) && this.throwError(`Unexpected ${e.node.operator}`));
		}), e.hooks.add("after-token", function(e) {
			if (e.node) {
				let n = this.code;
				Am.updateOperators.some((e) => e === n && e === this.expr.charCodeAt(this.index + 1)) && (t.includes(e.node.type) || this.throwError(`Unexpected ${e.node.operator}`), this.index += 2, e.node = {
					type: "UpdateExpression",
					operator: n === km ? "++" : "--",
					argument: e.node,
					prefix: !1
				});
			}
		}), e.hooks.add("after-expression", function(e) {
			e.node && n(e.node);
		});
		function n(e) {
			Am.assignmentOperators.has(e.operator) ? (e.type = "AssignmentExpression", n(e.left), n(e.right)) : e.operator || Object.values(e).forEach((e) => {
				e && typeof e == "object" && n(e);
			});
		}
	}
};
Cm.plugins.register(Om, Am), Cm.addUnaryOp("typeof"), Cm.addUnaryOp("void"), Cm.addLiteral("null", null), Cm.addLiteral("undefined", void 0);
var jm = new Set([
	"constructor",
	"__proto__",
	"__defineGetter__",
	"__defineSetter__",
	"__lookupGetter__",
	"__lookupSetter__"
]), Mm = {
	evalAst(e, t) {
		switch (e.type) {
			case "BinaryExpression":
			case "LogicalExpression": return Mm.evalBinaryExpression(e, t);
			case "Compound": return Mm.evalCompound(e, t);
			case "ConditionalExpression": return Mm.evalConditionalExpression(e, t);
			case "Identifier": return Mm.evalIdentifier(e, t);
			case "Literal": return Mm.evalLiteral(e, t);
			case "MemberExpression": return Mm.evalMemberExpression(e, t);
			case "UnaryExpression": return Mm.evalUnaryExpression(e, t);
			case "ArrayExpression": return Mm.evalArrayExpression(e, t);
			case "CallExpression": return Mm.evalCallExpression(e, t);
			case "AssignmentExpression": return Mm.evalAssignmentExpression(e, t);
			default: throw SyntaxError("Unexpected expression", e);
		}
	},
	evalBinaryExpression(e, t) {
		return {
			"||": (e, t) => e || t(),
			"&&": (e, t) => e && t(),
			"|": (e, t) => e | t(),
			"^": (e, t) => e ^ t(),
			"&": (e, t) => e & t(),
			"==": (e, t) => e == t(),
			"!=": (e, t) => e != t(),
			"===": (e, t) => e === t(),
			"!==": (e, t) => e !== t(),
			"<": (e, t) => e < t(),
			">": (e, t) => e > t(),
			"<=": (e, t) => e <= t(),
			">=": (e, t) => e >= t(),
			"<<": (e, t) => e << t(),
			">>": (e, t) => e >> t(),
			">>>": (e, t) => e >>> t(),
			"+": (e, t) => e + t(),
			"-": (e, t) => e - t(),
			"*": (e, t) => e * t(),
			"/": (e, t) => e / t(),
			"%": (e, t) => e % t()
		}[e.operator](Mm.evalAst(e.left, t), () => Mm.evalAst(e.right, t));
	},
	evalCompound(e, t) {
		let n;
		for (let r = 0; r < e.body.length; r++) {
			e.body[r].type === "Identifier" && [
				"var",
				"let",
				"const"
			].includes(e.body[r].name) && e.body[r + 1] && e.body[r + 1].type === "AssignmentExpression" && (r += 1);
			let i = e.body[r];
			n = Mm.evalAst(i, t);
		}
		return n;
	},
	evalConditionalExpression(e, t) {
		return Mm.evalAst(e.test, t) ? Mm.evalAst(e.consequent, t) : Mm.evalAst(e.alternate, t);
	},
	evalIdentifier(e, t) {
		if (Object.hasOwn(t, e.name)) return t[e.name];
		throw ReferenceError(`${e.name} is not defined`);
	},
	evalLiteral(e) {
		return e.value;
	},
	evalMemberExpression(e, t) {
		let n = String(e.computed ? Mm.evalAst(e.property) : e.property.name), r = Mm.evalAst(e.object, t);
		if (r == null || !Object.hasOwn(r, n) && jm.has(n)) throw TypeError(`Cannot read properties of ${r} (reading '${n}')`);
		let i = r[n];
		return typeof i == "function" ? i.bind(r) : i;
	},
	evalUnaryExpression(e, t) {
		return {
			"-": (e) => -Mm.evalAst(e, t),
			"!": (e) => !Mm.evalAst(e, t),
			"~": (e) => ~Mm.evalAst(e, t),
			"+": (e) => +Mm.evalAst(e, t),
			typeof: (e) => typeof Mm.evalAst(e, t),
			void: (e) => void Mm.evalAst(e, t)
		}[e.operator](e.argument);
	},
	evalArrayExpression(e, t) {
		return e.elements.map((e) => Mm.evalAst(e, t));
	},
	evalCallExpression(e, t) {
		let n = e.arguments.map((e) => Mm.evalAst(e, t)), r = Mm.evalAst(e.callee, t);
		/* c8 ignore start  */
		if (r === Function) throw Error("Function constructor is disabled");
		/* c8 ignore end  */
		return r(...n);
	},
	evalAssignmentExpression(e, t) {
		if (e.left.type !== "Identifier") throw SyntaxError("Invalid left-hand side in assignment");
		let n = e.left.name;
		return t[n] = Mm.evalAst(e.right, t), t[n];
	}
}, Nm = class {
	constructor(e) {
		this.code = e, this.ast = Cm(this.code);
	}
	runInNewContext(e) {
		let t = Object.assign(Object.create(null), e);
		return Mm.evalAst(this.ast, t);
	}
};
function Pm(e, t) {
	return e = e.slice(), e.push(t), e;
}
function Fm(e, t) {
	return t = t.slice(), t.unshift(e), t;
}
var Im = class extends Error {
	constructor(e) {
		super("JSONPath should not be called with \"new\" (it prevents return of (unwrapped) scalar values)"), this.avoidNew = !0, this.value = e, this.name = "NewError";
	}
};
function $(e, t, n, r, i) {
	if (!(this instanceof $)) try {
		return new $(e, t, n, r, i);
	} catch (e) {
		if (!e.avoidNew) throw e;
		return e.value;
	}
	typeof e == "string" && (i = r, r = n, n = t, t = e, e = null);
	let a = e && typeof e == "object";
	if (e ||= {}, this.json = e.json || n, this.path = e.path || t, this.resultType = e.resultType || "value", this.flatten = e.flatten || !1, this.wrap = Object.hasOwn(e, "wrap") ? e.wrap : !0, this.sandbox = e.sandbox || {}, this.eval = e.eval === void 0 ? "safe" : e.eval, this.ignoreEvalErrors = e.ignoreEvalErrors === void 0 ? !1 : e.ignoreEvalErrors, this.parent = e.parent || null, this.parentProperty = e.parentProperty || null, this.callback = e.callback || r || null, this.otherTypeCallback = e.otherTypeCallback || i || function() {
		throw TypeError("You must supply an otherTypeCallback callback option with the @other() operator.");
	}, e.autostart !== !1) {
		let r = { path: a ? e.path : t };
		a ? "json" in e && (r.json = e.json) : r.json = n;
		let i = this.evaluate(r);
		if (!i || typeof i != "object") throw new Im(i);
		return i;
	}
}
$.prototype.evaluate = function(e, t, n, r) {
	let i = this.parent, a = this.parentProperty, { flatten: o, wrap: s } = this;
	if (this.currResultType = this.resultType, this.currEval = this.eval, this.currSandbox = this.sandbox, n ||= this.callback, this.currOtherTypeCallback = r || this.otherTypeCallback, t ||= this.json, e ||= this.path, e && typeof e == "object" && !Array.isArray(e)) {
		if (!e.path && e.path !== "") throw TypeError("You must supply a \"path\" property when providing an object argument to JSONPath.evaluate().");
		if (!Object.hasOwn(e, "json")) throw TypeError("You must supply a \"json\" property when providing an object argument to JSONPath.evaluate().");
		({json: t} = e), o = Object.hasOwn(e, "flatten") ? e.flatten : o, this.currResultType = Object.hasOwn(e, "resultType") ? e.resultType : this.currResultType, this.currSandbox = Object.hasOwn(e, "sandbox") ? e.sandbox : this.currSandbox, s = Object.hasOwn(e, "wrap") ? e.wrap : s, this.currEval = Object.hasOwn(e, "eval") ? e.eval : this.currEval, n = Object.hasOwn(e, "callback") ? e.callback : n, this.currOtherTypeCallback = Object.hasOwn(e, "otherTypeCallback") ? e.otherTypeCallback : this.currOtherTypeCallback, i = Object.hasOwn(e, "parent") ? e.parent : i, a = Object.hasOwn(e, "parentProperty") ? e.parentProperty : a, e = e.path;
	}
	if (i ||= null, a ||= null, Array.isArray(e) && (e = $.toPathString(e)), !e && e !== "" || !t) return;
	let c = $.toPathArray(e);
	c[0] === "$" && c.length > 1 && c.shift(), this._hasParentSelector = null;
	let l = this._trace(c, t, ["$"], i, a, n).filter(function(e) {
		return e && !e.isParentSelector;
	});
	return l.length ? !s && l.length === 1 && !l[0].hasArrExpr ? this._getPreferredOutput(l[0]) : l.reduce((e, t) => {
		let n = this._getPreferredOutput(t);
		return o && Array.isArray(n) ? e = e.concat(n) : e.push(n), e;
	}, []) : s ? [] : void 0;
}, $.prototype._getPreferredOutput = function(e) {
	let t = this.currResultType;
	switch (t) {
		case "all": {
			let t = Array.isArray(e.path) ? e.path : $.toPathArray(e.path);
			return e.pointer = $.toPointer(t), e.path = typeof e.path == "string" ? e.path : $.toPathString(e.path), e;
		}
		case "value":
		case "parent":
		case "parentProperty": return e[t];
		case "path": return $.toPathString(e[t]);
		case "pointer": return $.toPointer(e.path);
		default: throw TypeError("Unknown result type");
	}
}, $.prototype._handleCallback = function(e, t, n) {
	if (t) {
		let r = this._getPreferredOutput(e);
		e.path = typeof e.path == "string" ? e.path : $.toPathString(e.path), t(r, n, e);
	}
}, $.prototype._trace = function(e, t, n, r, i, a, o, s) {
	let c;
	if (!e.length) return c = {
		path: n,
		value: t,
		parent: r,
		parentProperty: i,
		hasArrExpr: o
	}, this._handleCallback(c, a, "value"), c;
	let l = e[0], u = e.slice(1), d = [];
	function f(e) {
		Array.isArray(e) ? e.forEach((e) => {
			d.push(e);
		}) : d.push(e);
	}
	if ((typeof l != "string" || s) && t && Object.hasOwn(t, l)) f(this._trace(u, t[l], Pm(n, l), t, l, a, o));
	else if (l === "*") this._walk(t, (e) => {
		f(this._trace(u, t[e], Pm(n, e), t, e, a, !0, !0));
	});
	else if (l === "..") f(this._trace(u, t, n, r, i, a, o)), this._walk(t, (r) => {
		typeof t[r] == "object" && f(this._trace(e.slice(), t[r], Pm(n, r), t, r, a, !0));
	});
	else if (l === "^") return this._hasParentSelector = !0, {
		path: n.slice(0, -1),
		expr: u,
		isParentSelector: !0
	};
	else if (l === "~") return c = {
		path: Pm(n, l),
		value: i,
		parent: r,
		parentProperty: null
	}, this._handleCallback(c, a, "property"), c;
	else if (l === "$") f(this._trace(u, t, n, null, null, a, o));
	else if (/^(-?\d*):(-?\d*):?(\d*)$/u.test(l)) f(this._slice(l, u, t, n, r, i, a));
	else if (l.indexOf("?(") === 0) {
		if (this.currEval === !1) throw Error("Eval [?(expr)] prevented in JSONPath expression.");
		let e = l.replace(/^\?\((.*?)\)$/u, "$1"), o = /@.?([^?]*)[['](\??\(.*?\))(?!.\)\])[\]']/gu.exec(e);
		o ? this._walk(t, (e) => {
			let s = [o[2]], c = o[1] ? t[e][o[1]] : t[e];
			this._trace(s, c, n, r, i, a, !0).length > 0 && f(this._trace(u, t[e], Pm(n, e), t, e, a, !0));
		}) : this._walk(t, (o) => {
			this._eval(e, t[o], o, n, r, i) && f(this._trace(u, t[o], Pm(n, o), t, o, a, !0));
		});
	} else if (l[0] === "(") {
		if (this.currEval === !1) throw Error("Eval [(expr)] prevented in JSONPath expression.");
		f(this._trace(Fm(this._eval(l, t, n.at(-1), n.slice(0, -1), r, i), u), t, n, r, i, a, o));
	} else if (l[0] === "@") {
		let e = !1, o = l.slice(1, -2);
		switch (o) {
			case "scalar":
				(!t || !["object", "function"].includes(typeof t)) && (e = !0);
				break;
			case "boolean":
			case "string":
			case "undefined":
			case "function":
				typeof t === o && (e = !0);
				break;
			case "integer":
				Number.isFinite(t) && !(t % 1) && (e = !0);
				break;
			case "number":
				Number.isFinite(t) && (e = !0);
				break;
			case "nonFinite":
				typeof t == "number" && !Number.isFinite(t) && (e = !0);
				break;
			case "object":
				t && typeof t === o && (e = !0);
				break;
			case "array":
				Array.isArray(t) && (e = !0);
				break;
			case "other":
				e = this.currOtherTypeCallback(t, n, r, i);
				break;
			case "null":
				t === null && (e = !0);
				break;
			/* c8 ignore next 2 */
			default: throw TypeError("Unknown value type " + o);
		}
		if (e) return c = {
			path: n,
			value: t,
			parent: r,
			parentProperty: i
		}, this._handleCallback(c, a, "value"), c;
	} else if (l[0] === "`" && t && Object.hasOwn(t, l.slice(1))) {
		let e = l.slice(1);
		f(this._trace(u, t[e], Pm(n, e), t, e, a, o, !0));
	} else if (l.includes(",")) {
		let e = l.split(",");
		for (let o of e) f(this._trace(Fm(o, u), t, n, r, i, a, !0));
	} else !s && t && Object.hasOwn(t, l) && f(this._trace(u, t[l], Pm(n, l), t, l, a, o, !0));
	if (this._hasParentSelector) for (let e = 0; e < d.length; e++) {
		let n = d[e];
		if (n && n.isParentSelector) {
			let s = this._trace(n.expr, t, n.path, r, i, a, o);
			if (Array.isArray(s)) {
				d[e] = s[0];
				let t = s.length;
				for (let n = 1; n < t; n++) e++, d.splice(e, 0, s[n]);
			} else d[e] = s;
		}
	}
	return d;
}, $.prototype._walk = function(e, t) {
	if (Array.isArray(e)) {
		let n = e.length;
		for (let e = 0; e < n; e++) t(e);
	} else e && typeof e == "object" && Object.keys(e).forEach((e) => {
		t(e);
	});
}, $.prototype._slice = function(e, t, n, r, i, a, o) {
	if (!Array.isArray(n)) return;
	let s = n.length, c = e.split(":"), l = c[2] && Number.parseInt(c[2]) || 1, u = c[0] && Number.parseInt(c[0]) || 0, d = c[1] && Number.parseInt(c[1]) || s;
	u = u < 0 ? Math.max(0, u + s) : Math.min(s, u), d = d < 0 ? Math.max(0, d + s) : Math.min(s, d);
	let f = [];
	for (let e = u; e < d; e += l) this._trace(Fm(e, t), n, r, i, a, o, !0).forEach((e) => {
		f.push(e);
	});
	return f;
}, $.prototype._eval = function(e, t, n, r, i, a) {
	this.currSandbox._$_parentProperty = a, this.currSandbox._$_parent = i, this.currSandbox._$_property = n, this.currSandbox._$_root = this.json, this.currSandbox._$_v = t;
	let o = e.includes("@path");
	o && (this.currSandbox._$_path = $.toPathString(r.concat([n])));
	let s = this.currEval + "Script:" + e;
	if (!$.cache[s]) {
		let t = e.replaceAll("@parentProperty", "_$_parentProperty").replaceAll("@parent", "_$_parent").replaceAll("@property", "_$_property").replaceAll("@root", "_$_root").replaceAll(/@([.\s)[])/gu, "_$_v$1");
		if (o && (t = t.replaceAll("@path", "_$_path")), this.currEval === "safe" || this.currEval === !0 || this.currEval === void 0) $.cache[s] = new this.safeVm.Script(t);
		else if (this.currEval === "native") $.cache[s] = new this.vm.Script(t);
		else if (typeof this.currEval == "function" && this.currEval.prototype && Object.hasOwn(this.currEval.prototype, "runInNewContext")) {
			let e = this.currEval;
			$.cache[s] = new e(t);
		} else if (typeof this.currEval == "function") $.cache[s] = { runInNewContext: (e) => this.currEval(t, e) };
		else throw TypeError(`Unknown "eval" property "${this.currEval}"`);
	}
	try {
		return $.cache[s].runInNewContext(this.currSandbox);
	} catch (t) {
		if (this.ignoreEvalErrors) return !1;
		throw Error("jsonPath: " + t.message + ": " + e);
	}
}, $.cache = {}, $.toPathString = function(e) {
	let t = e, n = t.length, r = "$";
	for (let e = 1; e < n; e++) /^(~|\^|@.*?\(\))$/u.test(t[e]) || (r += /^[0-9*]+$/u.test(t[e]) ? "[" + t[e] + "]" : "['" + t[e] + "']");
	return r;
}, $.toPointer = function(e) {
	let t = e, n = t.length, r = "";
	for (let e = 1; e < n; e++) /^(~|\^|@.*?\(\))$/u.test(t[e]) || (r += "/" + t[e].toString().replaceAll("~", "~0").replaceAll("/", "~1"));
	return r;
}, $.toPathArray = function(e) {
	let { cache: t } = $;
	if (t[e]) return t[e].concat();
	let n = [];
	return t[e] = e.replaceAll(/@(?:null|boolean|number|string|integer|undefined|nonFinite|scalar|array|object|function|other)\(\)/gu, ";$&;").replaceAll(/[['](\??\(.*?\))[\]'](?!.\])/gu, function(e, t) {
		return "[#" + (n.push(t) - 1) + "]";
	}).replaceAll(/\[['"]([^'\]]*)['"]\]/gu, function(e, t) {
		return "['" + t.replaceAll(".", "%@%").replaceAll("~", "%%@@%%") + "']";
	}).replaceAll("~", ";~;").replaceAll(/['"]?\.['"]?(?![^[]*\])|\[['"]?/gu, ";").replaceAll("%@%", ".").replaceAll("%%@@%%", "~").replaceAll(/(?:;)?(\^+)(?:;)?/gu, function(e, t) {
		return ";" + t.split("").join(";") + ";";
	}).replaceAll(/;;;|;;/gu, ";..;").replaceAll(/;$|'?\]|'$/gu, "").split(";").map(function(e) {
		let t = e.match(/#(\d+)/u);
		return !t || !t[1] ? e : n[t[1]];
	}), t[e].concat();
}, $.prototype.safeVm = { Script: Nm };
var Lm = function(e, t, n) {
	let r = e.length;
	for (let i = 0; i < r; i++) {
		let r = e[i];
		n(r) && t.push(e.splice(i--, 1)[0]);
	}
}, Rm = class {
	constructor(e) {
		this.code = e;
	}
	runInNewContext(e) {
		let t = this.code, n = Object.keys(e), r = [];
		Lm(n, r, (t) => typeof e[t] == "function");
		let i = n.map((t) => e[t]);
		t = r.reduce((t, n) => {
			let r = e[n].toString();
			return /function/u.test(r) || (r = "function " + r), "var " + n + "=" + r + ";" + t;
		}, "") + t, !/(['"])use strict\1/u.test(t) && !n.includes("arguments") && (t = "var arguments = undefined;" + t), t = t.replace(/;\s*$/u, "");
		let a = t.lastIndexOf(";"), o = a === -1 ? " return " + t : t.slice(0, a + 1) + " return " + t.slice(a + 1);
		return Function(...n, o)(...i);
	}
};
$.prototype.vm = { Script: Rm };
//#endregion
//#region src/Components/Catalog/utils.ts
var zm = (e) => {
	let t = gr(e);
	return [
		null,
		void 0,
		""
	].includes(t === "string" ? e.trim() : e) || t === "object" && Object.keys(e).length === 0 || t === "array" && e.length === 0;
}, Bm = ({ resourceId: e, resourceIdentifier: t }) => e ? { id: e } : { identifier: t }, Vm = (e, t) => {
	if (typeof e != "string" || !e.startsWith("#/")) return null;
	let n = e.slice(2).split("/").reduce((e, t) => e?.[t], t);
	return Array.isArray(n?.enumNames) ? n.enumNames : null;
}, Hm = (e, t) => {
	if (typeof e.$ref == "string" && e.$ref.startsWith("#/references/")) {
		let n = Vm(e.$ref, t);
		if (n) return { "ui:enumNames": n };
	}
	if (Array.isArray(e.enumNames)) return { "ui:enumNames": e.enumNames };
	if (e.items && typeof e.items == "object" && !Array.isArray(e.items)) {
		let n = Hm(e.items, t);
		if (n) return { items: n };
	}
	if (e.properties && typeof e.properties == "object") {
		let n = Object.entries(e.properties).reduce((e, [n, r]) => {
			let i = Hm(r, t);
			return i ? {
				...e,
				[n]: i
			} : e;
		}, {});
		if (Object.keys(n).length > 0) return n;
	}
	return null;
}, Um = (e) => !e?.properties || typeof e.properties != "object" ? {} : Object.entries(e.properties).reduce((t, [n, r]) => {
	let i = Hm(r, e);
	return i ? {
		...t,
		[n]: i
	} : t;
}, {}), Wm = (e, t, n) => e.updatePath ? $({
	json: n,
	path: sr(or(e.updatePath)),
	wrap: !1,
	resultType: "value"
}) : n[t], Gm = async ({ resourceType: e, version: t = R.v1, searchParams: { resourceId: n, resourceIdentifier: r } }) => {
	try {
		let { result: { schema: i = "", objectData: a = "", catalogSchemaResourceId: o, kind: s } } = await H(Nr(Tr({
			baseUrl: _.RESOURCE,
			kind: e,
			version: t
		}), Bm({
			resourceId: n,
			resourceIdentifier: r
		})));
		return { result: {
			schema: i === "" ? {} : JSON.parse(i),
			objectData: a === "" ? null : JSON.parse(a),
			kind: h[s] || s,
			catalogSchemaResourceId: o
		} };
	} catch (e) {
		throw W(e), e;
	}
}, Km = ({ resourceType: e, version: t = R.v1, data: { resourceId: n, resourceIdentifier: r, ...i } }) => {
	let a = Bm({
		resourceId: n,
		resourceIdentifier: r
	});
	return Yr(Tr({
		baseUrl: _.RESOURCE,
		kind: e,
		version: t
	}), {
		...i,
		...a
	});
};
//#endregion
//#region src/Components/Catalog/EditForm/EditCatalogModal.tsx
function qm({ resourceId: e, resourceType: t, onClose: n, schema: r, formData: i = {}, version: a, resourceIdentifier: o }) {
	let s = Pe(null), [c, l] = A(!1), [u, f] = A(i), p = k(() => Um(r), [r]), m = (e) => {
		e && e.key === "Escape" && typeof n == "function" && (e.preventDefault(), n(e));
	};
	return O(() => {
		f(i);
	}, [i]), O(() => (document.addEventListener("keydown", m), () => {
		document.removeEventListener("keydown", m);
	}), [m]), /* @__PURE__ */ (0, J.jsx)(Mt, {
		position: "right",
		width: "800px",
		children: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "h-100 bg__primary edit-catalog-modal flexbox-col",
			ref: s,
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flex dc__content-space pt-16 pb-16 pl-20 pr-20 dc__border-bottom",
				children: [/* @__PURE__ */ (0, J.jsx)("h2", {
					className: "fs-16 cn-9 fw-6 m-0",
					children: "Edit catalog details"
				}), /* @__PURE__ */ (0, J.jsx)(d, {
					className: "icon-dim-20 cursor",
					onClick: n
				})]
			}), /* @__PURE__ */ (0, J.jsx)("div", {
				className: "edit-catalog-modal__form dc__overflow-auto",
				children: /* @__PURE__ */ (0, J.jsx)(yn, {
					schema: r,
					uiSchema: p,
					onSubmit: (r, i) => {
						let s = r.formData;
						l(!0), f(s), Km({
							resourceType: t,
							version: a,
							data: {
								resourceId: Number(e),
								resourceIdentifier: o,
								objectData: JSON.stringify(s)
							}
						}).then(() => {
							n(i, { shouldRefetchDetails: !0 });
						}).catch((e) => {
							W(e), l(!1);
						});
					},
					formData: u,
					onError: (e = []) => {
						W(Error(b)), console.error("Form Validation Error", e);
					},
					children: /* @__PURE__ */ (0, J.jsxs)("footer", {
						className: "dc__border-top flex right bg__primary pt-16 pr-20 pb-16 pl-20 dc__position-fixed dc__bottom-0 w-800",
						children: [/* @__PURE__ */ (0, J.jsx)("button", {
							type: "button",
							className: "cta cancel flex h-36 mr-12",
							onClick: n,
							disabled: c,
							children: "Cancel"
						}), /* @__PURE__ */ (0, J.jsx)("button", {
							type: "submit",
							className: "cta flex h-36",
							disabled: c,
							children: c ? /* @__PURE__ */ (0, J.jsx)(_n, {}) : "Save"
						})]
					})
				})
			})]
		})
	});
}
//#endregion
//#region src/Assets/Img/catalog-schema-null-state.svg?react
var Jm = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	"data-style-override": "false",
	width: 213,
	height: 125,
	viewBox: "0 0 213 125",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsxs)("g", {
			clipPath: "url(#clip0_5214_18924)",
			children: [
				/* @__PURE__ */ (0, J.jsx)("rect", {
					width: 173.255,
					height: 10.8284,
					transform: "translate(39.645 5)",
					fill: "#A1C3FC"
				}),
				/* @__PURE__ */ (0, J.jsx)("circle", {
					cx: 190.16,
					cy: 10.4142,
					r: 2.16569,
					fill: "white"
				}),
				/* @__PURE__ */ (0, J.jsx)("circle", {
					cx: 197.74,
					cy: 10.4142,
					r: 2.16569,
					fill: "white"
				}),
				/* @__PURE__ */ (0, J.jsx)("circle", {
					cx: 205.32,
					cy: 10.4142,
					r: 2.16569,
					fill: "white"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					width: 173.255,
					height: 108.284,
					transform: "translate(39.645 15.8284)",
					fill: "url(#paint0_linear_5214_18924)"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 52.6392,
					y: 28.8225,
					width: 23.8226,
					height: 4.33138,
					rx: 1.08284,
					fill: "white"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 82.9587,
					y: 28.8225,
					width: 54.1422,
					height: 4.33138,
					rx: 1.08284,
					fill: "white"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 145.764,
					y: 59.1421,
					width: 54.1422,
					height: 6.49706,
					rx: 1.08284,
					fill: "white"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 150.095,
					y: 72.1362,
					width: 45.4794,
					height: 6.49706,
					rx: 1.08284,
					fill: "white"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 52.6392,
					y: 41.8167,
					width: 75.7991,
					height: 4.33138,
					rx: 1.08284,
					fill: "white"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 52.6392,
					y: 54.8108,
					width: 84.4618,
					height: 4.33138,
					rx: 1.08284,
					fill: "white"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 52.6392,
					y: 67.8049,
					width: 60.6393,
					height: 4.33138,
					rx: 1.08284,
					fill: "white"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 52.6392,
					y: 80.7991,
					width: 70.3848,
					height: 4.33138,
					rx: 1.08284,
					fill: "white"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 52.6392,
					y: 93.7932,
					width: 147.267,
					height: 17.3255,
					rx: 2.16569,
					fill: "white",
					stroke: "#A1C3FC",
					strokeWidth: 1.08284,
					strokeDasharray: "2.17 2.17"
				}),
				/* @__PURE__ */ (0, J.jsx)("ellipse", {
					cx: 172.835,
					cy: 37.4853,
					rx: 12.9941,
					ry: 12.9941,
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ (0, J.jsx)("rect", {
			x: 163.089,
			y: 120.503,
			width: 31.2822,
			height: 3.60948,
			rx: 1.08284,
			fill: "url(#paint1_linear_5214_18924)"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M167.902 120.504H189.559L188.055 114.488H169.406L167.902 120.504Z",
			fill: "url(#paint2_linear_5214_18924)"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M183.543 96.4401H173.918L174.711 93.2679C174.952 92.3038 175.818 91.6274 176.812 91.6274H180.649C181.643 91.6274 182.509 92.3038 182.75 93.2679L183.543 96.4401Z",
			fill: "url(#paint3_linear_5214_18924)"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M170.91 108.472L172.414 102.456H185.047L186.551 108.472H170.91Z",
			fill: "url(#paint4_linear_5214_18924)"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M172.414 102.456L173.918 96.4402H183.543L185.047 102.456H172.414Z",
			fill: "url(#paint5_linear_5214_18924)"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M169.406 114.487L170.91 108.471H186.551L188.055 114.487H169.406Z",
			fill: "url(#paint6_linear_5214_18924)"
		}),
		/* @__PURE__ */ (0, J.jsx)("rect", {
			x: 145.41,
			y: 124.13,
			width: 31.2822,
			height: 3.60948,
			rx: 1.08284,
			transform: "rotate(-112 145.41 124.13)",
			fill: "url(#paint7_linear_5214_18924)"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M143.607 119.668L135.494 99.5882L130.48 103.236L137.466 120.527L143.607 119.668Z",
			fill: "url(#paint8_linear_5214_18924)"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M115.437 114.18L119.043 123.105L115.804 123.558C114.82 123.696 113.868 123.146 113.496 122.224L112.059 118.667C111.686 117.745 111.989 116.689 112.793 116.104L115.437 114.18Z",
			fill: "url(#paint9_linear_5214_18924)"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M131.324 121.387L125.183 122.246L120.451 110.532L125.465 106.884L131.324 121.387Z",
			fill: "url(#paint10_linear_5214_18924)"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M125.184 122.245L119.042 123.105L115.437 114.18L120.451 110.532L125.184 122.245Z",
			fill: "url(#paint11_linear_5214_18924)"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M137.465 120.528L131.324 121.387L125.465 106.885L130.479 103.237L137.465 120.528Z",
			fill: "url(#paint12_linear_5214_18924)"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M54.9247 32.5545L58.9271 24.7865C61.42 23.2846 65.7127 21.5407 64.507 25.38C63.3012 29.2194 61.8913 31.8499 62.6454 33.7906L54.9247 32.5545Z",
			fill: "url(#paint13_linear_5214_18924)"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M67.3557 26.488C69.5935 25.3966 70.7975 22.5009 71.1197 21.1894C71.1197 21.1894 72.9811 20.6668 72.9091 20.1248C72.8371 19.5828 71.7972 17.3967 70.8626 15.9288C69.8745 14.377 69.1326 13.4835 68.4178 12.8886C65.5034 10.4629 62.7476 9.93998 60.0151 10.2541C56.9184 10.6102 53.4457 13.3621 52.9876 17.1441C52.5666 20.6197 57.3153 25.2291 59.3165 26.1768C61.3177 27.1244 64.5584 27.8524 67.3557 26.488Z",
			fill: "#FFBEB6"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M69.8288 18.5039C70.0042 18.6727 70.2676 18.8075 70.6206 18.8075C70.9735 18.8075 71.2369 18.6727 71.4124 18.5039C71.5962 18.327 71.6684 18.1293 71.6684 18.0215H72.1923C72.1923 18.3063 72.0343 18.6326 71.7756 18.8815C71.5085 19.1385 71.117 19.3314 70.6206 19.3314C70.1241 19.3314 69.7326 19.1385 69.4655 18.8815C69.2069 18.6326 69.0488 18.3063 69.0488 18.0215H69.5727C69.5727 18.1293 69.6449 18.327 69.8288 18.5039Z",
			fill: "#23286B"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M53.1834 22.2625C52.7643 23.861 52.7448 26.8547 55.6717 27.7643C59.5263 28.9622 63.2069 24.2815 63.0972 19.718C64.3732 20.4097 66.1798 19.5603 66.3617 17.1486C67.8539 17.3431 71.1543 16.8974 72.5241 13.5374C73.0236 12.3122 73.0012 10.9514 72.7471 9.82564C72.6199 9.26173 72.4334 8.7515 72.2207 8.34097C72.0105 7.9352 71.7656 7.60934 71.5123 7.43436L71.3071 7.73142C71.489 7.85716 71.7006 8.12204 71.9001 8.50709C72.0972 8.88737 72.2737 9.36803 72.3949 9.90512C72.6378 10.9814 72.6537 12.263 72.1897 13.4011C71.1682 15.9067 68.9989 16.6877 67.4473 16.809C69.6818 16.2669 71.6766 14.448 71.8305 12.3805C72.0087 9.98508 71.0272 7.57819 69.2534 7.09672C67.8343 6.71155 66.4308 8.40926 65.9064 9.30626C65.6096 8.0403 64.474 5.58053 62.6244 4.94357C60.194 4.10664 58.6863 4.36346 57.8258 5.36018C57.1103 6.18903 57.762 7.54828 58.2771 8.62272C58.3815 8.84036 58.4802 9.04631 58.5609 9.23381C57.7915 8.83957 55.8789 8.31034 54.384 9.34727C52.889 10.3842 53.6372 11.8918 54.1981 12.5159C53.4779 12.3542 51.5707 12.3354 49.7027 13.5542C47.3678 15.0778 46.6361 18.705 47.3183 20.1037C47.8703 21.2355 49.2787 22.8315 51.5255 22.5557C51.3978 22.5958 51.2674 22.6336 51.1352 22.6682C50.3024 22.8863 49.4286 22.9699 48.7395 22.7326C47.3409 22.251 46.8076 21.0057 46.7175 20.4558L46.3612 20.5141C46.4656 21.1519 47.0611 22.5366 48.6219 23.074C49.4125 23.3462 50.3707 23.2416 51.2267 23.0175C51.9975 22.8157 52.709 22.5106 53.1834 22.2625ZM53.2526 22.0218L53.2538 22.0181L53.2512 22.0193L53.2526 22.0218Z",
			fill: "#23286B"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M108.41 6.25094C108.847 5.84308 109.533 5.86702 109.94 6.30439L111.143 7.59424C111.551 8.03162 111.527 8.71682 111.09 9.12469L36.2071 78.9539L57.6453 101.944L54.7716 104.623L33.3333 81.6337L16.0909 97.7126L37.529 120.702L34.6552 123.382L13.2172 100.392L3.47164 109.48C3.03426 109.888 2.34907 109.864 1.9412 109.427L0.738399 108.137C0.330538 107.7 0.354463 107.014 0.79184 106.606L108.41 6.25094ZM132.528 32.1146C132.966 31.7068 133.651 31.7307 134.059 32.1681L135.261 33.4579C135.669 33.8953 135.645 34.5805 135.208 34.9884L27.5898 135.344C27.1525 135.752 26.4673 135.728 26.0594 135.29L24.8566 134.001C24.4487 133.563 24.4727 132.878 24.91 132.47L74.8876 85.8653L53.4495 62.8757L56.3232 60.1959L77.7613 83.1855L95.0036 67.1068L73.5653 44.117L76.439 41.4372L97.8774 64.427L115.12 48.3482L93.6815 25.3585L96.5552 22.6787L117.993 45.6684L132.528 32.1146Z",
			fill: "#428DFC"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M75.098 68.5887C78.5962 70.1519 80.9193 71.0956 82.0666 71.4193C83.4384 71.7876 84.2418 71.6536 87.3532 70.5492C87.754 70.4152 89.1263 69.5788 90.3978 68.776C93.5764 66.6682 94.3125 67.6722 91.6692 70.4489C90.9662 71.2192 90.4645 72.055 90.5985 72.3224C90.6983 72.5568 92.606 72.5898 94.7806 72.3561C95.5065 72.1075 97.3041 69.9758 97.4712 70.1428C97.8726 70.5442 96.3531 75.7348 94.8479 76.3711C94.1785 76.7052 88.7922 76.9396 82.8364 76.9396C78.866 76.9401 73.2662 76.729 66.0366 76.3079L75.098 68.5887Z",
			fill: "#FAB6AF"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M72.5854 102.232L64.0718 67.5227H48.3545C48.1362 70.5789 47.8306 77.608 48.3545 81.2754C49.0094 85.8596 52.2838 93.7183 52.2838 96.9927C52.2838 100.267 53.5936 112.055 53.5936 115.985C53.5936 119.914 52.9387 122.533 52.2838 125.153C51.6289 127.773 51.6289 133.667 52.2838 138.251C52.8077 141.918 54.6851 147.856 55.5582 150.039H71.2756L72.5854 102.232Z",
			fill: "#1D225F"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M66.0363 98.3025C66.0363 100.922 64.1273 112.725 63.4168 115.33C61.4521 122.533 54.2483 138.906 50.319 150.039H32.637C32.8553 146.546 34.2087 138.906 35.2565 136.286C36.5663 133.012 40.5816 128.454 41.1505 126.463C42.4603 121.879 42.4603 117.294 43.7701 114.02C45.0799 110.745 48.3543 104.851 48.3543 101.577C48.3543 98.3025 45.7348 94.3732 44.425 89.789C43.1152 85.2047 43.1152 79.3107 43.1152 76.6912C43.1152 73.9265 43.3335 69.7057 43.7701 67.5227H66.0363V98.3025Z",
			fill: "url(#paint14_linear_5214_18924)"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M65.3807 38.7084C65.9047 40.2801 70.4016 55.0806 72.5845 62.2844C73.2394 65.5591 70.6199 67.5232 68.0003 68.1781C65.3808 68.833 50.3183 68.8331 47.6987 68.833C43.7696 68.8329 40.4949 68.1781 37.2205 66.2135C33.946 64.2488 35.4631 58.0782 37.2205 55.7352C39.1854 53.1156 42.4596 50.4961 44.4243 47.2216C46.3889 43.9472 48.3536 39.363 49.0085 38.0532C49.6634 36.7434 51.3701 34.4816 53.5927 32.8143C56.2123 30.8493 59.4867 30.8497 61.4514 31.5046C63.051 32.0378 64.7258 36.7437 65.3807 38.7084Z",
			fill: "url(#paint15_linear_5214_18924)"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M80.4437 83.8958V63.5942C66.691 63.5942 64.0714 55.0807 63.4165 53.116C62.7616 51.1513 61.4519 45.9122 61.4519 41.9829C61.4519 38.0535 59.4516 36.3132 56.8676 36.7438C52.9383 37.3985 49.6638 41.9828 48.3541 46.567C47.0443 51.1512 45.7345 57.0453 45.7345 60.9747C45.7345 64.904 48.3541 68.8333 50.3187 70.798C52.2834 72.7627 56.8676 73.4176 59.4872 75.3822C62.1068 77.3469 65.3812 80.6214 68.6557 82.586C71.2752 84.1578 77.6058 84.1141 80.4437 83.8958Z",
			fill: "url(#paint16_linear_5214_18924)"
		}),
		/* @__PURE__ */ (0, J.jsxs)("defs", { children: [
			/* @__PURE__ */ (0, J.jsxs)("linearGradient", {
				id: "paint0_linear_5214_18924",
				x1: 86.6276,
				y1: 0,
				x2: 86.6276,
				y2: 108.284,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, J.jsx)("stop", { stopColor: "#F3F3F3" }), /* @__PURE__ */ (0, J.jsx)("stop", {
					offset: 1,
					stopColor: "#EEEEEE"
				})]
			}),
			/* @__PURE__ */ (0, J.jsxs)("linearGradient", {
				id: "paint1_linear_5214_18924",
				x1: 163.089,
				y1: 124.113,
				x2: 194.372,
				y2: 124.113,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, J.jsx)("stop", { stopColor: "#D99D05" }), /* @__PURE__ */ (0, J.jsx)("stop", {
					offset: .315157,
					stopColor: "#EFB305"
				})]
			}),
			/* @__PURE__ */ (0, J.jsxs)("linearGradient", {
				id: "paint2_linear_5214_18924",
				x1: 167.902,
				y1: 120.504,
				x2: 189.559,
				y2: 120.504,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, J.jsx)("stop", { stopColor: "#D99D05" }), /* @__PURE__ */ (0, J.jsx)("stop", {
					offset: 1,
					stopColor: "#EFB305"
				})]
			}),
			/* @__PURE__ */ (0, J.jsxs)("linearGradient", {
				id: "paint3_linear_5214_18924",
				x1: 173.918,
				y1: 96.4401,
				x2: 183.543,
				y2: 96.4401,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, J.jsx)("stop", { stopColor: "#D99D05" }), /* @__PURE__ */ (0, J.jsx)("stop", {
					offset: 1,
					stopColor: "#EFB305"
				})]
			}),
			/* @__PURE__ */ (0, J.jsxs)("linearGradient", {
				id: "paint4_linear_5214_18924",
				x1: 170.91,
				y1: 108.472,
				x2: 186.551,
				y2: 108.472,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, J.jsx)("stop", { stopColor: "#D99D05" }), /* @__PURE__ */ (0, J.jsx)("stop", {
					offset: 1,
					stopColor: "#EFB305"
				})]
			}),
			/* @__PURE__ */ (0, J.jsxs)("linearGradient", {
				id: "paint5_linear_5214_18924",
				x1: 172.113,
				y1: 103.659,
				x2: 185.348,
				y2: 103.659,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, J.jsx)("stop", { stopColor: "#EFEFEF" }), /* @__PURE__ */ (0, J.jsx)("stop", {
					offset: 1,
					stopColor: "white"
				})]
			}),
			/* @__PURE__ */ (0, J.jsxs)("linearGradient", {
				id: "paint6_linear_5214_18924",
				x1: 169.105,
				y1: 115.69,
				x2: 188.355,
				y2: 115.69,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, J.jsx)("stop", { stopColor: "#EFEFEF" }), /* @__PURE__ */ (0, J.jsx)("stop", {
					offset: 1,
					stopColor: "white"
				})]
			}),
			/* @__PURE__ */ (0, J.jsxs)("linearGradient", {
				id: "paint7_linear_5214_18924",
				x1: 145.41,
				y1: 127.74,
				x2: 176.692,
				y2: 127.74,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, J.jsx)("stop", { stopColor: "#D99D05" }), /* @__PURE__ */ (0, J.jsx)("stop", {
					offset: .315157,
					stopColor: "#EFB305"
				})]
			}),
			/* @__PURE__ */ (0, J.jsxs)("linearGradient", {
				id: "paint8_linear_5214_18924",
				x1: 143.607,
				y1: 119.668,
				x2: 135.494,
				y2: 99.5882,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, J.jsx)("stop", { stopColor: "#D99D05" }), /* @__PURE__ */ (0, J.jsx)("stop", {
					offset: 1,
					stopColor: "#EFB305"
				})]
			}),
			/* @__PURE__ */ (0, J.jsxs)("linearGradient", {
				id: "paint9_linear_5214_18924",
				x1: 119.043,
				y1: 123.105,
				x2: 115.437,
				y2: 114.18,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, J.jsx)("stop", { stopColor: "#D99D05" }), /* @__PURE__ */ (0, J.jsx)("stop", {
					offset: 1,
					stopColor: "#EFB305"
				})]
			}),
			/* @__PURE__ */ (0, J.jsxs)("linearGradient", {
				id: "paint10_linear_5214_18924",
				x1: 131.324,
				y1: 121.387,
				x2: 125.465,
				y2: 106.884,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, J.jsx)("stop", { stopColor: "#D99D05" }), /* @__PURE__ */ (0, J.jsx)("stop", {
					offset: 1,
					stopColor: "#EFB305"
				})]
			}),
			/* @__PURE__ */ (0, J.jsxs)("linearGradient", {
				id: "paint11_linear_5214_18924",
				x1: 126.412,
				y1: 122.074,
				x2: 121.454,
				y2: 109.803,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, J.jsx)("stop", { stopColor: "#EFEFEF" }), /* @__PURE__ */ (0, J.jsx)("stop", {
					offset: 1,
					stopColor: "white"
				})]
			}),
			/* @__PURE__ */ (0, J.jsxs)("linearGradient", {
				id: "paint12_linear_5214_18924",
				x1: 138.694,
				y1: 120.356,
				x2: 131.482,
				y2: 102.507,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, J.jsx)("stop", { stopColor: "#EFEFEF" }), /* @__PURE__ */ (0, J.jsx)("stop", {
					offset: 1,
					stopColor: "white"
				})]
			}),
			/* @__PURE__ */ (0, J.jsxs)("linearGradient", {
				id: "paint13_linear_5214_18924",
				x1: 61.7452,
				y1: 26.7261,
				x2: 59.8404,
				y2: 31.5322,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ (0, J.jsx)("stop", { stopColor: "#FBA19B" }),
					/* @__PURE__ */ (0, J.jsx)("stop", {
						offset: .349149,
						stopColor: "#F9ADA7"
					}),
					/* @__PURE__ */ (0, J.jsx)("stop", {
						offset: 1,
						stopColor: "#F9AFA9"
					})
				]
			}),
			/* @__PURE__ */ (0, J.jsxs)("linearGradient", {
				id: "paint14_linear_5214_18924",
				x1: 51.01,
				y1: 67.5227,
				x2: 24.9671,
				y2: 142.634,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, J.jsx)("stop", { stopColor: "#2A318C" }), /* @__PURE__ */ (0, J.jsx)("stop", {
					offset: 1,
					stopColor: "#1D225F"
				})]
			}),
			/* @__PURE__ */ (0, J.jsxs)("linearGradient", {
				id: "paint15_linear_5214_18924",
				x1: 53.9894,
				y1: 31.1128,
				x2: 53.9894,
				y2: 68.833,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, J.jsx)("stop", { stopColor: "#A1C3FC" }), /* @__PURE__ */ (0, J.jsx)("stop", {
					offset: 1,
					stopColor: "#91B9F7"
				})]
			}),
			/* @__PURE__ */ (0, J.jsxs)("linearGradient", {
				id: "paint16_linear_5214_18924",
				x1: 63.0891,
				y1: 36.6797,
				x2: 63.0891,
				y2: 84.0065,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, J.jsx)("stop", { stopColor: "#9FC2FC" }), /* @__PURE__ */ (0, J.jsx)("stop", {
					offset: 1,
					stopColor: "#A1C3FC"
				})]
			}),
			/* @__PURE__ */ (0, J.jsx)("clipPath", {
				id: "clip0_5214_18924",
				children: /* @__PURE__ */ (0, J.jsx)("rect", {
					x: 39.645,
					y: 5,
					width: 173.255,
					height: 119.113,
					rx: 2.16569,
					fill: "white"
				})
			})
		] })
	]
});
//#endregion
//#region src/Components/Catalog/CatalogSchemaNullState.tsx
function Ym({ kind: e, handleManageSchema: t }) {
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flex dc__content-space",
		children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col dc__gap-12 dc__mxw-600",
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col dc__gap-4 cn-9 lh-20",
				children: [/* @__PURE__ */ (0, J.jsxs)("h3", {
					className: "fs-14 fw-6 m-0",
					children: ["Define Catalog Framework for ", e]
				}), /* @__PURE__ */ (0, J.jsx)("p", {
					className: "fs-13 fw-4 m-0",
					children: "Catalog Framework (Schema) enables you to define and collaboratively collect information that matters the most to you, so you never have to look anywhere else."
				})]
			}), /* @__PURE__ */ (0, J.jsx)(M, {
				dataTestId: "create-catalog-framework",
				text: "Create Catalog Framework",
				onClick: t,
				endIcon: /* @__PURE__ */ (0, J.jsx)(Yt, {
					name: "ic-arrow-right",
					color: null
				}),
				variant: N.secondary
			})]
		}), /* @__PURE__ */ (0, J.jsx)("div", {
			className: "catalog__null-state-image",
			children: /* @__PURE__ */ (0, J.jsx)(Jm, { className: "w-100 h-100" })
		})]
	});
}
//#endregion
//#region src/Components/Catalog/CatalogErrorBoundary.tsx
var Xm = class extends ke {
	constructor(e) {
		super(e), this.state = { hasError: !1 };
	}
	static getDerivedStateFromError() {
		return { hasError: !0 };
	}
	componentDidUpdate(e) {
		let { children: t } = this.props;
		e.children !== t && this.setState({ hasError: !1 });
	}
	componentDidCatch(e) {
		Vr(e);
	}
	render() {
		let { hasError: e } = this.state;
		if (e) {
			let { fallback: e } = this.props;
			return e;
		}
		let { children: t } = this.props;
		return t;
	}
}, Zm = je({}), Qm = ({ value: e, ...t }) => /* @__PURE__ */ (0, J.jsx)(Zm.Provider, {
	value: e,
	...t
}), $m = () => Ne(Zm), eh = () => /* @__PURE__ */ (0, J.jsx)(J.Fragment, { children: "-" }), th = ({ value: e, icon: t }) => /* @__PURE__ */ (0, J.jsx)("div", {
	className: "dc__ellipsis-right",
	children: /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "dc__word-break flexbox flex-align-center dc__gap-8",
		children: [t && /* @__PURE__ */ (0, J.jsx)("div", {
			className: "icon-dim-20 mw-20 flexbox flex-justify-center flex-align-center dc__border-radius-50-per dc__uppercase cn-0 fw-4",
			style: { backgroundColor: Cr(e) },
			children: e[0]
		}), /* @__PURE__ */ (0, J.jsx)("span", {
			className: "cn-9 dc__ellipsis-right",
			children: e
		})]
	})
}), nh = ({ value: e, id: t }) => {
	let { jsonViewExpansionMap: n, currentView: r, updateJsonViewExpansionMap: i } = $m(), a = n[t], o = a === !0 || a === null && r === $p, s = JSON.stringify(e, null, 2), c = (e) => {
		i(t, e);
	};
	return O(() => {
		t in n || i(t, null);
	}, []), /* @__PURE__ */ (0, J.jsxs)("div", {
		id: `object-item__${t}`,
		className: "mw-none w-100",
		children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "catalog__object-item display-grid flex-align-center dc__gap-8 h-24",
			children: [
				o ? /* @__PURE__ */ (0, J.jsx)("div", {
					className: "fs-14 fw-6 lh-16",
					children: "Value"
				}) : /* @__PURE__ */ (0, J.jsx)("div", {
					className: "dc__ellipsis-right mono pt-4 pb-4 pr-6 pl-6 fs-12 lh-16 bg__secondary br-4",
					children: s
				}),
				o ? /* @__PURE__ */ (0, J.jsx)(Qa, {
					onClick: () => c(!1),
					className: "icon-dim-16 scn-6 cursor"
				}) : /* @__PURE__ */ (0, J.jsx)($a, {
					onClick: () => c(!0),
					className: "icon-dim-16 fcn-6 cursor"
				}),
				/* @__PURE__ */ (0, J.jsx)(at, { content: s })
			]
		}), o && /* @__PURE__ */ (0, J.jsx)("code", {
			className: "dc__word-break dc__block mxh-250 dc__overflow-auto br-4 bg__secondary pr-6 pl-6 pt-4 pb-4 cn-9 dc__white-space-pre mono fs-14 lh-16",
			children: s
		})]
	});
}, rh = ({ value: e }) => {
	let { url: t, ...n } = wr(e);
	return /* @__PURE__ */ (0, J.jsxs)("a", {
		className: "anchor cb-5 fs-13 fw-4 lh-24 dc__ellipsis-right flexbox flex-align-center dc__gap-4",
		...n,
		children: [/* @__PURE__ */ (0, J.jsx)(pe, { className: "icon-dim-16 mw-16" }), /* @__PURE__ */ (0, J.jsx)("span", {
			className: "dc__ellipsis-right",
			children: t
		})]
	});
}, ih = () => /* @__PURE__ */ (0, J.jsx)(th, { value: "Parsing error" });
function ah({ fieldSchema: e = {}, value: t, icon: n, id: r }) {
	try {
		if (zm(t)) return /* @__PURE__ */ (0, J.jsx)(eh, {});
		let { type: i = gr(t) } = e, a = !!e.additionalProperties, o = !!e.refType || i === "array" && !!e.items?.refType || a && !!e.additionalProperties?.refType, s = !!e.$ref || i === "array" && !!e.items?.$ref || a && !!e.additionalProperties?.$ref, c = i;
		switch (a ? c = "object" : o ? c = Array.isArray(t) ? "refType/array" : "refType/object" : (s || typeof c != "string") && (c = gr(t)), c) {
			case "number":
			case "integer": return /* @__PURE__ */ (0, J.jsx)(th, {
				value: t,
				icon: n
			});
			case "boolean": return /* @__PURE__ */ (0, J.jsx)("div", {
				className: "dc__capitalize",
				children: /* @__PURE__ */ (0, J.jsx)(th, {
					value: t?.toString() || "False",
					icon: n
				})
			});
			case "string": {
				let { format: r } = e, i = t;
				switch (r) {
					case rm.uri: return /* @__PURE__ */ (0, J.jsx)(rh, { value: i });
					case rm.date: return /* @__PURE__ */ (0, J.jsx)(th, {
						value: (0, po.default)(i || "").format(te.DATE_FORMAT_WITH_WEEKDAY),
						icon: n
					});
					case rm.dateTime: return /* @__PURE__ */ (0, J.jsx)(th, {
						value: (0, po.default)(i || "").format(te.TWELVE_HOURS_FORMAT_WITHOUT_WEEKDAY),
						icon: n
					});
					default: return /* @__PURE__ */ (0, J.jsx)(th, {
						value: i,
						icon: n
					});
				}
			}
			case "object": return /* @__PURE__ */ (0, J.jsx)(nh, {
				value: t,
				id: r
			});
			case "array": return /* @__PURE__ */ (0, J.jsx)("div", {
				className: "flexbox-col dc__gap-4 dc__ellipsis-right",
				children: t.map((t, n) => /* @__PURE__ */ (0, J.jsx)("div", {
					className: "catalog__item--array-bullets",
					children: /* @__PURE__ */ (0, J.jsx)(ah, {
						value: t,
						fieldSchema: e.items,
						id: `${r}-${n}`
					})
				}, n))
			});
			case "refType/array": return /* @__PURE__ */ (0, J.jsx)("div", {
				className: "flexbox-col dc__gap-4 dc__ellipsis-right",
				children: t.map((e, t) => /* @__PURE__ */ (0, J.jsx)("div", {
					className: "catalog__item--array-bullets",
					children: /* @__PURE__ */ (0, J.jsx)(ah, {
						value: e.name,
						icon: e.icon,
						fieldSchema: { type: gr(e.name) },
						id: `${r}-${t}`
					})
				}, t))
			});
			case "refType/object": return /* @__PURE__ */ (0, J.jsx)(ah, {
				value: t.name,
				icon: t.icon,
				fieldSchema: { type: gr(t.name) },
				id: r
			});
			case "null": return /* @__PURE__ */ (0, J.jsx)(eh, {});
			default: throw Error(`Unsupported type for Catalog Item: ${i}`);
		}
	} catch (e) {
		return Vr(e), /* @__PURE__ */ (0, J.jsx)(ih, {});
	}
}
var oh = (e) => /* @__PURE__ */ (0, J.jsx)(Xm, {
	fallback: /* @__PURE__ */ (0, J.jsx)(ih, {}),
	children: /* @__PURE__ */ (0, J.jsx)(ah, { ...e })
}), sh = ({ title: e, catalogItemProps: t }) => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "catalog__item fs-13 fw-4 lh-24",
	children: [/* @__PURE__ */ (0, J.jsx)("span", {
		className: "cn-7 dc__ellipsis-right",
		children: e
	}), /* @__PURE__ */ (0, J.jsx)(oh, { ...t })]
}), ch = ({ sectionData: e = {}, sectionSchema: t, sectionKey: n }) => /* @__PURE__ */ (0, J.jsx)(J.Fragment, { children: Object.entries(t.properties).map(([t, r]) => {
	let i = r, a = i.title || t, o = Wm(i, t, e), s = `${n}_${t}`;
	return /* @__PURE__ */ (0, J.jsx)(sh, {
		title: a,
		catalogItemProps: {
			id: s,
			value: o,
			fieldSchema: i
		}
	}, s);
}) }), lh = ({ originalFormData: e, originalSchema: t }) => {
	let n = t.type, r = !!t.additionalProperties, i = Object.entries(t.properties || {}).reduce((e, [t, n]) => (nm[t] || (e[t] = n), e), {}), a = {
		...t,
		properties: i
	}, o = Object.entries(e).reduce((e, [t, n]) => (nm[t] || (e[t] = n), e), {}), s = e[Qp.CUSTOM_PANEL];
	return n === "object" && !r ? /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [Object.entries(a.properties).map(([e, t]) => {
		let n = t, r = n.title || e, i = Wm(n, e, o), a = n.type || gr(i);
		return !n.additionalProperties && a === "object" && n?.properties ? /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col",
			children: [
				/* @__PURE__ */ (0, J.jsx)("div", {
					className: "fs-13 fw-6 cn-9",
					children: r
				}),
				/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-top-n1 mt-8 mb-12" }),
				/* @__PURE__ */ (0, J.jsx)("div", {
					className: "catalog__section",
					children: /* @__PURE__ */ (0, J.jsx)(ch, {
						sectionData: i,
						sectionSchema: n,
						sectionKey: e
					})
				})
			]
		}, e) : /* @__PURE__ */ (0, J.jsx)(sh, {
			title: r,
			catalogItemProps: {
				id: e,
				value: i,
				fieldSchema: n
			}
		}, e);
	}), !!s?.links?.length && /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col dc__gap-12",
		children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col dc__gap-8",
			children: [/* @__PURE__ */ (0, J.jsx)("h3", {
				className: "m-0 fs-13 fw-6 cn-9",
				children: "Custom Panel"
			}), /* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-top-n1" })]
		}), /* @__PURE__ */ (0, J.jsx)(Xt, {
			iframeList: s.links,
			maxHeight: 800,
			maxWidth: 900
		})]
	})] }) : /* @__PURE__ */ (0, J.jsx)(sh, {
		title: a.title || "Key not available",
		catalogItemProps: {
			id: "primitive-value",
			value: o,
			fieldSchema: a
		}
	});
}, uh = (e) => /* @__PURE__ */ (0, J.jsx)("div", {
	className: "shimmer-loading h-16",
	style: { width: e }
}), dh = () => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "catalog__item",
	children: [uh("100%"), uh("100%")]
});
function fh() {
	return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [
		uh(150),
		/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-n1 w-100" }),
		/* @__PURE__ */ (0, J.jsx)("div", {
			className: "catalog__section",
			children: dh()
		}),
		uh(250),
		/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-n1 w-100" }),
		/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "catalog__section",
			children: [dh(), dh()]
		})
	] });
}
//#endregion
//#region src/Components/Catalog/Catalog.tsx
function ph({ resourceId: e, resourceType: t, version: n, resourceIdentifier: r }) {
	let { setTempAppWindowConfig: i } = ui(), [a, o] = A(!1), [s, c] = A({}), [l, u] = A(tm.GUI), d = Object.entries(s).every(([, e]) => e) ? $p : em, f = Object.keys(s).length > 0, [p, m, h, g] = K(() => Gm({
		resourceType: t,
		version: n,
		searchParams: {
			resourceId: e,
			resourceIdentifier: r
		}
	})), { result: { objectData: _ = null, schema: v = {}, kind: y, catalogSchemaResourceId: b } = {} } = m ?? {}, x = !v || !Object.keys(v).length || !v.type, S = zm(_), C = !(p || h) && !x, w = (e, { shouldRefetchDetails: t = !1 } = {}) => {
		o(!1), t && g();
	}, T = () => {
		let e = d === $p;
		c(Object.keys(s).reduce((t, n) => (t[n] = e ? null : !0, t), {}));
	}, ee = (e, t) => {
		c((n) => ({
			...n,
			[e]: t
		}));
	}, E = () => {
		g(), i({
			open: !1,
			title: "",
			component: null
		});
	}, te = () => {
		i({
			open: !0,
			title: `${im[t]} Catalog Schema`,
			component: /* @__PURE__ */ (0, J.jsx)(vm, {
				devtronResourceId: b,
				handleCancelManageSchema: E,
				resourceType: t
			})
		});
	};
	return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsxs)("section", {
		className: "bg__primary en-2 br-4 bw-1 fs-13 fw-4 lh-20 cn-7 mb-12",
		children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "dc__border-bottom dc__top-radius-4 bg__secondary flex flex-justify pl-16 pr-16 pt-8 pb-8",
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox flex-align-center dc__gap-12",
				children: [/* @__PURE__ */ (0, J.jsx)("span", {
					className: "fw-6 cn-9 mr-8",
					children: "Catalog"
				}), C && !S && /* @__PURE__ */ (0, J.jsx)(kn, {
					name: "catalog-tabs",
					onChange: (e) => {
						u(e.value);
					},
					segments: am,
					value: l,
					size: P.small
				})]
			}), C && /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox flex-align-center dc__gap-16",
				children: [
					l === tm.GUI && f && /* @__PURE__ */ (0, J.jsx)("div", {
						onClick: T,
						className: "fw-6 cursor flex dc__gap-6",
						children: d === $p ? /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)(Qa, { className: "icon-dim-16 scn-6 cursor" }), /* @__PURE__ */ (0, J.jsx)("span", { children: "Collapse all" })] }) : /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)($a, { className: "icon-dim-16 fcn-6 cursor" }), /* @__PURE__ */ (0, J.jsx)("span", { children: "Expand all" })] })
					}),
					b && /* @__PURE__ */ (0, J.jsx)(M, {
						dataTestId: "manage-catalog-schema",
						startIcon: /* @__PURE__ */ (0, J.jsx)(Yt, {
							name: "ic-edit-lines",
							color: null
						}),
						text: "Manage Schema",
						onClick: te,
						style: $e.neutral,
						size: P.small,
						variant: N.text
					}),
					/* @__PURE__ */ (0, J.jsx)(M, {
						dataTestId: "edit-catalog",
						startIcon: /* @__PURE__ */ (0, J.jsx)(Yt, {
							name: "ic-pencil",
							color: null
						}),
						text: "Edit",
						onClick: () => {
							o(!0);
						},
						style: $e.neutral,
						size: P.small,
						variant: N.text
					})
				]
			})]
		}), /* @__PURE__ */ (0, J.jsx)("div", {
			className: l === tm.JSON ? "dc__position-rel" : "",
			children: /* @__PURE__ */ (0, J.jsx)("div", {
				className: "dc__overflow-auto mxh-504",
				children: /* @__PURE__ */ (0, J.jsx)("div", {
					className: "flexbox-col dc__gap-20 pl-16 pr-16 pt-16 pb-16",
					children: p ? /* @__PURE__ */ (0, J.jsx)(fh, {}) : h ? /* @__PURE__ */ (0, J.jsx)(Kt, { reload: g }) : x ? /* @__PURE__ */ (0, J.jsx)(Ym, {
						kind: y,
						handleManageSchema: te
					}) : S ? /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox-col dc__gap-12",
						children: [/* @__PURE__ */ (0, J.jsxs)("div", {
							className: "flexbox-col dc__gap-4",
							children: [
								/* @__PURE__ */ (0, J.jsx)("div", { children: "Sharing is caring! ✨" }),
								/* @__PURE__ */ (0, J.jsx)("div", { children: "Provide some required details about this application." }),
								/* @__PURE__ */ (0, J.jsx)("div", { children: "Your insights help everyone understand this application better, so that they can do their best work." })
							]
						}), /* @__PURE__ */ (0, J.jsxs)("div", {
							onClick: () => {
								o(!0);
							},
							className: "flex fw-6 dc__gap-4 btn-start-sharing dc__hover-n50",
							children: ["Start Sharing", /* @__PURE__ */ (0, J.jsx)(we, { className: "icon-dim-12 scb-5 dc__no-shrink" })]
						})]
					}) : l === tm.JSON ? /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)("div", {
						className: "catalog__json-tab-copy dc__position-abs",
						children: /* @__PURE__ */ (0, J.jsx)(at, { content: JSON.stringify(_, null, 2) })
					}), /* @__PURE__ */ (0, J.jsx)("code", {
						className: "dc__word-break dc__block cn-9 dc__white-space-pre mono fs-14 lh-20 dc__transparent p-0",
						children: JSON.stringify(_, null, 2)
					})] }) : /* @__PURE__ */ (0, J.jsx)(Qm, {
						value: {
							jsonViewExpansionMap: s,
							updateJsonViewExpansionMap: ee,
							currentView: d
						},
						children: /* @__PURE__ */ (0, J.jsx)(lh, {
							originalFormData: _,
							originalSchema: v
						})
					})
				})
			})
		})]
	}), a && /* @__PURE__ */ (0, J.jsx)(qm, {
		resourceType: t,
		resourceId: e,
		resourceIdentifier: r,
		onClose: w,
		schema: v,
		formData: _,
		version: n
	})] });
}
//#endregion
//#region src/Pages/Releases/Detail/Overview/ReleaseNote.tsx
var mh = () => {
	let { id: e, note: t, refetchReleaseDetail: n } = Q();
	return /* @__PURE__ */ (0, J.jsx)(Wt, {
		text: t.value,
		updatedBy: t.updatedBy.name,
		updatedOn: t.updatedOn,
		updateDescription: async (t) => {
			try {
				await eu({
					id: e,
					releaseNote: t
				}), B.showToast({
					variant: V.success,
					description: Nc
				}), await n();
			} catch (e) {
				W(e);
			}
		},
		title: "Release Note",
		emptyStateConfig: {
			img: Hi,
			subtitle: /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)("p", {
				className: "m-0",
				children: "Capture all new features, bug fixes, and enhancements in release notes for each software version."
			}), /* @__PURE__ */ (0, J.jsx)("p", {
				className: "m-0",
				children: "These detailed notes ensure transparency, enable seamless collaboration across teams, and serve as a comprehensive changelog for future reference."
			})] })
		}
	});
}, hh = "## Release instructions\n\nThis section is to add instructions for this release", gh = Array.from([
	,
	,
	,
].keys()).map((e) => ({
	appName: `app-${e}`,
	imageDetails: {
		artifactId: e,
		image: `image-${e}`,
		imagePath: "",
		registryType: wn.DOCKER,
		sourceMessage: ""
	},
	commitDetails: [{
		hash: "",
		shortHash: "",
		message: ""
	}]
})), _h = /* @__PURE__ */ function(e) {
	return e.application = "application", e;
}({}), vh = ({ appName: e, imageDetails: t, commitDetails: n, imageColumnClassName: r, isImageColumnExpanded: i, openArtifactInfoModal: a }) => {
	let s = ki(), c = Ai(), l = n?.map(({ hash: e }) => e) ?? [], u = () => {
		s(q(I.RELEASES.DETAIL.REQUIREMENTS_DEPLOYMENT_SOURCE, {
			releaseTrack: c.releaseTrack,
			releaseVersion: c.releaseVersion,
			appName: e
		}));
	}, d = () => {
		a({ ciArtifactId: t?.artifactId });
	};
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: `display-grid dc__column-gap-16 releases__req-summary-row ${r} fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-20`,
		children: [/* @__PURE__ */ (0, J.jsx)("span", {
			className: "dc__truncate",
			children: e
		}), t?.image ? /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)($t, {
			handleClick: d,
			imagePath: t.image,
			isExpanded: i,
			registryType: t.registryType
		}), /* @__PURE__ */ (0, J.jsx)(ct, {
			handleClick: d,
			commits: l
		})] }) : /* @__PURE__ */ (0, J.jsxs)("button", {
			type: "button",
			className: "cta text flex dc__content-start dc__gap-4 lh-20-imp cb-5 h-20 p-0-imp dc__w-fit-content",
			onClick: u,
			children: [/* @__PURE__ */ (0, J.jsx)(o, { className: "icon-dim-16 dc__no-shrink fcb-5" }), /* @__PURE__ */ (0, J.jsx)("span", { children: "Add Image" })]
		})]
	});
}, yh = () => {
	let [e, t] = A(null), n = ki(), r = Ai(), { id: i } = Q(), [a, o] = A(!1), s = a ? "image-column-expanded" : "", { sortBy: c, sortOrder: l, handleSorting: u } = mi({ initialSortKey: _h.application }), [d, f, p, m] = K(() => ju(i)), h = k(() => f?.length ? f.sort((e, t) => G(e.appName, t.appName, l)) : [], [f, l]), g = () => {
		o((e) => !e);
	}, _ = () => {
		u(_h.application);
	}, v = () => {
		n(q(I.RELEASES.DETAIL.REQUIREMENTS, {
			releaseTrack: r.releaseTrack,
			releaseVersion: r.releaseVersion,
			appName: null
		}));
	}, y = () => {
		t(null);
	}, b = (e) => {
		t(e);
	};
	return /* @__PURE__ */ (0, J.jsxs)("section", {
		className: "dc__overflow-hidden dc__border br-4 bg__primary",
		children: [/* @__PURE__ */ (0, J.jsx)("div", { children: /* @__PURE__ */ (0, J.jsx)("h4", {
			className: "cn-9 fs-13 fw-6 lh-20 dc__truncate py-8 px-16 dc__border-bottom bg__secondary m-0",
			children: "Release requirements"
		}) }), /* @__PURE__ */ (0, J.jsx)(Ie, {
			isLoading: !1,
			error: !d && p,
			genericSectionErrorProps: { reload: m },
			children: d || h?.length ? /* @__PURE__ */ (0, J.jsxs)("div", { children: [
				/* @__PURE__ */ (0, J.jsxs)("div", {
					className: `display-grid dc__column-gap-16 releases__req-summary-row releases__req-summary-row--header ${s} dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center px-20 dc__uppercase bg__primary`,
					children: [
						/* @__PURE__ */ (0, J.jsx)(z, {
							disabled: d,
							isSorted: c === _h.application,
							sortOrder: l,
							title: "Application",
							triggerSorting: _
						}),
						/* @__PURE__ */ (0, J.jsxs)("div", {
							className: "flexbox dc__align-items-center dc__gap-4",
							children: [/* @__PURE__ */ (0, J.jsx)("span", { children: "Image" }), /* @__PURE__ */ (0, J.jsx)("button", {
								type: "button",
								className: "dc__outline-none-imp p-0 dc__transparent flex",
								onClick: g,
								"aria-label": a ? "Collapse column" : "Expand image column",
								children: /* @__PURE__ */ (0, J.jsx)(Zu, { className: `icon-dim-14 scn-7 dc__transition--transform ${a ? "dc__flip-90" : "dc__flip-270"}` })
							})]
						}),
						/* @__PURE__ */ (0, J.jsx)("span", { children: "Commit" })
					]
				}),
				/* @__PURE__ */ (0, J.jsx)("div", {
					className: "dc__overflow-auto mxh-400",
					children: d ? gh.map((e) => /* @__PURE__ */ (0, J.jsxs)("div", {
						className: `display-grid dc__column-gap-16 releases__req-summary-row ${s} fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-20 show-shimmer-loading`,
						children: [
							/* @__PURE__ */ (0, J.jsx)("span", { className: "child-shimmer-loading" }),
							/* @__PURE__ */ (0, J.jsx)("span", { className: "child-shimmer-loading" }),
							/* @__PURE__ */ (0, J.jsx)("span", { className: "child-shimmer-loading" })
						]
					}, e.appName)) : h.map((e) => /* @__PURE__ */ Me(vh, {
						...e,
						imageColumnClassName: s,
						isImageColumnExpanded: a,
						openArtifactInfoModal: b,
						key: e.appName
					}))
				}),
				e && /* @__PURE__ */ (0, J.jsx)(Ge, {
					...e,
					handleClose: y,
					renderCIListHeader: ld,
					fetchOnlyArtifactInfo: !0
				})
			] }) : /* @__PURE__ */ (0, J.jsx)(Kt, {
				title: "No applications is added in this release",
				buttonText: "Add Application",
				reload: v,
				useInfoIcon: !0
			})
		})]
	});
}, bh = () => {
	let { id: e, track: t, version: n, name: r, description: i, createdBy: a, createdOn: o, refetchReleaseDetail: s } = Q();
	return /* @__PURE__ */ (0, J.jsxs)("aside", {
		className: "flexbox-col dc__gap-16",
		children: [
			/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col dc__gap-12",
				children: [
					/* @__PURE__ */ (0, J.jsx)(id, { className: "icon-dim-48 dc__icon-bg-color br-4 p-8" }),
					/* @__PURE__ */ (0, J.jsx)("h3", {
						className: "fs-16 fw-7 lh-24 cn-9 dc__word-break font-merriweather m-0",
						children: r
					}),
					/* @__PURE__ */ (0, J.jsx)(Pt, {
						emptyState: "Write a short description for this release",
						placeholder: "Write a short description for this release",
						initialText: i,
						updateContent: async (t) => {
							let n = {
								id: e,
								description: t
							};
							try {
								await Zl(n), B.showToast({
									variant: V.success,
									description: "Saved successfully"
								}), await s();
							} catch (e) {
								throw W(e), e;
							}
						},
						validations: { maxLength: {
							value: 350,
							message: "Max 350 characters allowed"
						} }
					})
				]
			}),
			/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-top-n1" }),
			/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col dc__gap-12",
				children: [
					/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("div", {
						className: "fs-13 fw-4 lh-20 cn-7 mb-4",
						children: "Release track"
					}), /* @__PURE__ */ (0, J.jsx)("div", {
						className: "fs-13 fw-6 lh-20 cn-9 dc__truncate",
						children: t
					})] }),
					/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("div", {
						className: "fs-13 fw-4 lh-20 cn-7 mb-4",
						children: "Release version"
					}), /* @__PURE__ */ (0, J.jsx)("div", {
						className: "fs-13 fw-6 lh-20 cn-9 dc__truncate",
						children: n
					})] }),
					/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("div", {
						className: "fs-13 fw-4 lh-20 cn-7 mb-4",
						children: "Created by"
					}), /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "fs-13 fw-6 lh-20 cn-9 dc__word-break flexbox flex-align-center dc__gap-8",
						children: [/* @__PURE__ */ (0, J.jsx)("div", {
							className: "icon-dim-20 mw-20 flexbox flex-justify-center flex-align-center dc__border-radius-50-per dc__uppercase cn-0 fw-4",
							style: { backgroundColor: Cr(a) },
							children: a[0]
						}), a]
					})] }),
					/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("div", {
						className: "fs-13 fw-4 lh-20 cn-7 mb-4",
						children: "Created on"
					}), /* @__PURE__ */ (0, J.jsx)("div", {
						className: "fs-13 fw-6 lh-20 cn-9 dc__truncate",
						children: o
					})] })
				]
			})
		]
	});
}, xh = () => {
	let { id: e } = Q();
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "pl-20 pr-20 pt-20 pb-20 software-hub__overview display-grid dc__gap-32 dc__content-center flex-grow-1 dc__overflow-auto",
		children: [/* @__PURE__ */ (0, J.jsx)(bh, {}), /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col dc__gap-12 flex-grow-1",
			children: [/* @__PURE__ */ (0, J.jsx)(yh, {}), /* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)(ph, {
				resourceType: L.release,
				resourceId: e,
				version: R.alpha1
			}), /* @__PURE__ */ (0, J.jsx)(mh, {})] })]
		})]
	});
}, Sh = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		stroke: "#3B444C",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "m16 13 3 3m0 0-3 3m3-3H5m3-5L5 8m0 0 3-3M5 8h14",
		vectorEffect: "non-scaling-stroke"
	})
}), Ch = ({ releaseVersion: e, isCardView: t }) => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: `flexbox dc__align-items-center dc__gap-4 br-4 dc__mxw-160 ${t ? "px-6 py-4 bcn-1" : ""}`,
	children: [/* @__PURE__ */ (0, J.jsx)(id, { className: "dc__no-shrink icon-dim-16" }), /* @__PURE__ */ (0, J.jsx)("span", {
		className: `dc__truncate lh-16 ${t ? "cn-9 fs-12 fw-5" : "cn-7 fs-13 fw-4"}`,
		children: e
	})]
}), wh = ({ selectedImage: e, registryType: t, releaseVersion: n, showNoSelectionText: r, children: i, selectedImageClass: a }) => n ? /* @__PURE__ */ (0, J.jsx)(Ch, { releaseVersion: n }) : e ? /* @__PURE__ */ (0, J.jsx)(lt, {
	wrap: (e) => /* @__PURE__ */ (0, J.jsx)(D, {
		content: i,
		arrow: !1,
		className: "default-tt",
		placement: "right",
		children: e
	}),
	condition: !!i,
	children: /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flex dc__gap-4 dc__content-start",
		children: [/* @__PURE__ */ (0, J.jsx)(Cn, {
			registryType: t,
			size: 16
		}), /* @__PURE__ */ (0, J.jsx)("p", {
			className: `m-0 dc__truncate text-left mono lh-16 ${a || ""}`,
			children: lr(e)
		})]
	})
}) : r ? /* @__PURE__ */ (0, J.jsx)("span", {
	className: "m-0 fs-12 lh-16 cn-7 dc__truncate text-left",
	children: "Image not selected"
}) : null, Th = ({ appName: e, handleClose: t, handleSuccess: n }) => {
	let { name: r, id: i } = Q(), [a, o] = A(!1);
	return /* @__PURE__ */ (0, J.jsx)(ut, {
		variant: dt.delete,
		title: `Remove '${e}' from '${r}'`,
		subtitle: "Removing the application from the release will remove all requirements added against the application.",
		buttonConfig: {
			secondaryButtonConfig: {
				onClick: t,
				text: "Cancel"
			},
			primaryButtonConfig: {
				isLoading: a,
				onClick: async () => {
					o(!0);
					let r = {
						id: i,
						appName: e
					};
					try {
						await ou(r), o(!1), await n(), B.showToast({
							variant: V.success,
							description: "Application deleted successfully"
						}), t();
					} catch (e) {
						W(e), o(!1);
					}
				},
				text: "Delete"
			}
		},
		confirmationConfig: {
			identifier: "delete-application-from-track",
			confirmationKeyword: "Remove"
		},
		handleClose: t,
		children: /* @__PURE__ */ (0, J.jsx)("p", {
			className: "fs-13 cn-7 lh-20 m-0",
			children: "Are you sure?"
		})
	});
}, Eh = ({ applications: e, title: t, appName: n, icon: r, reload: i }) => {
	let { releaseTrack: a, releaseVersion: o } = Ai(), s = ki(), [c, l] = A(null), { refetchReleaseDetail: u } = Q(), d = !!c, f = () => {
		l(null);
	}, p = (e) => {
		let t = n === e.name;
		return /* @__PURE__ */ (0, J.jsxs)(wi, {
			to: q(I.RELEASES.DETAIL.REQUIREMENTS, {
				releaseTrack: a,
				releaseVersion: o,
				appName: e.name
			}),
			className: `anchor flexbox dc__content-space dc__gap-8 py-8 pl-12 pr-8 br-4 cursor dc__transparent w-100 dc__visible-hover dc__visible-hover--parent ${t ? "bcb-1" : "dc__hover-n50"}`,
			children: [/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("h4", {
				className: `m-0 fs-13 lh-20 cn-9 dc__truncate text-left fw-4 ${t ? "cb-5" : ""}`,
				children: e.name
			}), e.isDeleted ? /* @__PURE__ */ (0, J.jsx)("span", {
				className: "fs-12 fw-4 lh-16 cr-5",
				children: "Application not found"
			}) : /* @__PURE__ */ (0, J.jsx)(wh, {
				selectedImage: e.selectedImage,
				registryType: e.registryType,
				releaseVersion: e.sourceReleaseConfiguration?.releaseVersion,
				showNoSelectionText: !0,
				selectedImageClass: "fs-14 cn-7",
				children: e.selectedImage
			})] }), /* @__PURE__ */ (0, J.jsx)("div", {
				className: "dc__visible-hover--child",
				children: /* @__PURE__ */ (0, J.jsx)("button", {
					type: "button",
					className: "dc__transparent p-4 cursor dc__no-shrink flex h-24",
					"aria-label": `Delete ${e.name} from release order`,
					onClick: (t) => {
						t.stopPropagation(), t.preventDefault(), l({ appName: e.name });
					},
					children: /* @__PURE__ */ (0, J.jsx)(T, { className: "icon-dim-16 dc__no-shrink scr-5" })
				})
			})]
		}, e.name);
	}, m = async () => {
		await i(), u(), s(q(I.RELEASES.DETAIL.REQUIREMENTS, {
			releaseTrack: a,
			releaseVersion: o,
			appName: null
		}));
	};
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "py-8 dc__border-bottom-n1 last-child__no-border",
		children: [
			/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox flex-align-center dc__gap-8 px-8 py-4",
				children: [/* @__PURE__ */ (0, J.jsx)("div", {
					className: "p-4 flex dc__no-shrink",
					children: r
				}), /* @__PURE__ */ (0, J.jsx)("h3", {
					className: "m-0 dc__uppercase cn-7 fs-12 lh-20 fw-6 dc__truncate",
					children: t
				})]
			}),
			/* @__PURE__ */ (0, J.jsx)("div", { children: e.map(p) }),
			d && /* @__PURE__ */ (0, J.jsx)(Th, {
				...c,
				handleSuccess: m,
				handleClose: f
			})
		]
	});
}, Dh = ({ handleClose: e, handleSuccess: t, id: n, name: r }) => /* @__PURE__ */ (0, J.jsx)(St, {
	title: r,
	onDelete: async () => {
		await Yl(n), t();
	},
	subtitle: "Deleting a release will delete all the requirements added against it.",
	closeConfirmationModal: e,
	confirmationConfig: {
		identifier: "release",
		confirmationKeyword: r
	},
	successToastMessage: "Release deleted successfully",
	onError: (e) => {
		e?.code === Le.BAD_REQUEST ? B.showToast({
			variant: V.warn,
			title: "Cannot Delete Release",
			description: "The release cannot be deleted since deployment is triggered for some of its releases."
		}) : W(e);
	}
}), Oh = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M37.1818 18.5H10.8182C10.0902 18.5 9.5 19.1716 9.5 20V41C9.5 41.8284 10.0902 42.5 10.8182 42.5H37.1818C37.9098 42.5 38.5 41.8284 38.5 41V20C38.5 19.1716 37.9098 18.5 37.1818 18.5Z",
			fill: "#FFE5BE",
			stroke: "#C58D36",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M17.25 18.5V11.75C17.25 9.95979 17.9612 8.2429 19.227 6.97703C20.4929 5.71116 22.2098 5 24 5C25.7902 5 27.5071 5.71116 28.773 6.97703C30.0388 8.2429 30.75 9.95979 30.75 11.75V18.5",
			stroke: "#C58D36",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M24 32.75C25.2426 32.75 26.25 31.7426 26.25 30.5C26.25 29.2574 25.2426 28.25 24 28.25C22.7574 28.25 21.75 29.2574 21.75 30.5C21.75 31.7426 22.7574 32.75 24 32.75Z",
			fill: "#C58D36"
		})
	]
}), kh = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M37.1818 18.5H10.8182C10.0902 18.5 9.5 19.1716 9.5 20V41C9.5 41.8284 10.0902 42.5 10.8182 42.5H37.1818C37.9098 42.5 38.5 41.8284 38.5 41V20C38.5 19.1716 37.9098 18.5 37.1818 18.5Z",
			fill: "#B6E9D3",
			stroke: "#1DAD70",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M30.1644 9C29.8313 8.25334 29.3623 7.56631 28.773 6.97703C27.5071 5.71116 25.7902 5 24 5C22.2098 5 20.4929 5.71116 19.227 6.97703C17.9612 8.2429 17.25 9.95979 17.25 11.75V18",
			stroke: "#1DAD70",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M24 32.75C25.2426 32.75 26.25 31.7426 26.25 30.5C26.25 29.2574 25.2426 28.25 24 28.25C22.7574 28.25 21.75 29.2574 21.75 30.5C21.75 31.7426 22.7574 32.75 24 32.75Z",
			fill: "#1DAD70"
		})
	]
}), Ah = (e) => e ? {
	Icon: kh,
	title: "Unlock Requirement",
	subTitle: "Once unlocked, Requirement will be opened to edit.",
	buttonText: "Unlock"
} : {
	Icon: Oh,
	title: "Lock Requirement",
	subTitle: "No one will be able to edit requirement in locked state. You can unlock to edit.",
	buttonText: "Lock"
}, jh = ({ handleClose: e }) => {
	let { id: t, isLocked: n, refetchReleaseDetail: r } = Q(), [i, a] = A(!1), { Icon: o, title: s, subTitle: c, buttonText: l } = Ah(n);
	return /* @__PURE__ */ (0, J.jsx)(ut, {
		variant: dt.custom,
		Icon: /* @__PURE__ */ (0, J.jsx)(o, {}),
		title: s,
		subtitle: c,
		buttonConfig: {
			secondaryButtonConfig: {
				text: "Cancel",
				disabled: i,
				onClick: e
			},
			primaryButtonConfig: {
				text: l,
				isLoading: i,
				onClick: async () => {
					a(!0);
					try {
						let i = await tu({
							id: t,
							isLocked: !n
						});
						await r();
						let { userMessage: a = `Requirement is ${n ? "unlocked" : "locked"}`, detailMessage: o } = i?.result ?? {};
						e(), B.showToast({
							variant: V.success,
							...o ? {
								title: a,
								description: o
							} : { description: a }
						});
					} catch (e) {
						if (e?.code === Le.BAD_REQUEST) {
							let { userMessage: t = `Cannot ${n ? "unlock" : "lock"} requirements`, internalMessage: r } = e?.errors?.[0] ?? {};
							B.showToast({
								variant: V.warn,
								...r ? {
									title: t,
									description: r
								} : { description: t }
							});
						} else W(e);
					} finally {
						a(!1);
					}
				}
			}
		},
		handleClose: e,
		children: /* @__PURE__ */ (0, J.jsx)("span", {
			className: "fs-13 cn-7 lh-20",
			children: "Are you sure?"
		})
	});
}, Mh = ({ releaseOrdering: e, appName: t, applicationCount: n, handleShowManageReleaseModal: r, reload: i, changesForReview: a }) => {
	let s = ki(), { id: c, name: l, isLocked: u, track: d } = Q(), f = a.length, [p, m] = A(!1), [h, g] = A(!1), [_, v] = A(!1), y = () => {
		m(!p);
	}, b = () => {
		g(!h);
	}, x = () => {
		s(I.RELEASES.ROOT);
	}, S = () => {
		v((e) => !e);
	};
	return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [
		/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "bg__primary flexbox-col dc__content-space h-100 border__primary--right w-250 dc__no-shrink",
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col flex-grow-1 dc__overflow-auto",
				children: [/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flex dc__content-space pl-20 border__secondary--bottom dc__gap-4 dc__no-shrink",
					children: [/* @__PURE__ */ (0, J.jsxs)("h3", {
						className: "m-0 cn-7 fs-13 fw-6 lh-20 dc__ellipsis-right py-12",
						children: [
							n,
							" ",
							n === 1 ? "Application" : "Applications"
						]
					}), /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flex dc__no-shrink",
						children: [/* @__PURE__ */ (0, J.jsx)(D, {
							content: "Manage release order",
							arrow: !1,
							className: "default-tt",
							placement: "top",
							children: /* @__PURE__ */ (0, J.jsx)("button", {
								type: "button",
								className: "p-14 dc__transparent flex border__secondary--left",
								"aria-label": "Manage release order",
								onClick: r,
								children: /* @__PURE__ */ (0, J.jsx)(Sh, { className: "icon-dim-20 scb-5 dc__flip-90" })
							})
						}), /* @__PURE__ */ (0, J.jsx)(D, {
							content: "Add application(s) to release",
							arrow: !1,
							className: "default-tt",
							placement: "top",
							children: /* @__PURE__ */ (0, J.jsx)("button", {
								type: "button",
								className: "p-14 dc__transparent flex border__secondary--left",
								"aria-label": "Add applications",
								onClick: r,
								children: /* @__PURE__ */ (0, J.jsx)(o, { className: "icon-dim-20 fcb-5" })
							})
						})]
					})]
				}), /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col flex-grow-1 dc__overflow-auto px-12 py-8",
					children: [f > 0 && /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox-col dc__gap-8",
						children: [/* @__PURE__ */ (0, J.jsx)(nn, {
							description: /* @__PURE__ */ (0, J.jsxs)("span", {
								className: "flex column left top dc__gap-4",
								children: [/* @__PURE__ */ (0, J.jsxs)("span", {
									className: "flexbox-col fs-13 fw-4 lh-20 cn-9",
									children: [/* @__PURE__ */ (0, J.jsx)("span", {
										className: "fw-6",
										children: "Action required"
									}), /* @__PURE__ */ (0, J.jsxs)("span", { children: [
										f,
										" ",
										f === 1 ? "update" : "updates",
										" pending review"
									] })]
								}), /* @__PURE__ */ (0, J.jsx)("button", {
									type: "button",
									className: "dc__transparent p-0 fs-13 lh-20 fw-6 cb-5",
									onClick: S,
									children: "Review update"
								})]
							}),
							variant: "warning"
						}), _ && /* @__PURE__ */ (0, J.jsx)(Xd, {
							changesForReview: a,
							handleClose: S,
							handleSuccess: i,
							trackName: d
						})]
					}), e.map((e) => /* @__PURE__ */ Me(Eh, {
						...e,
						appName: t,
						reload: i,
						key: e.id
					}))]
				})]
			}), /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "px-16 py-12 flex dc__gap-8 dc__content-space dc__no-shrink",
				children: [/* @__PURE__ */ (0, J.jsx)(M, {
					dataTestId: "delete-release",
					ariaLabel: "Delete release",
					onClick: y,
					showAriaLabelInTippy: !1,
					icon: /* @__PURE__ */ (0, J.jsx)(Yt, {
						name: "ic-delete",
						color: null
					}),
					variant: N.secondary,
					style: $e.negative,
					size: P.medium
				}), /* @__PURE__ */ (0, J.jsx)(M, {
					dataTestId: "lock-unlock-release",
					onClick: b,
					variant: N.secondary,
					disabled: h,
					text: u ? "Unlock to edit" : "Lock requirements",
					startIcon: u ? null : /* @__PURE__ */ (0, J.jsx)(Ws, {}),
					size: P.medium,
					fullWidth: !0
				})]
			})]
		}),
		p && /* @__PURE__ */ (0, J.jsx)(Dh, {
			handleClose: y,
			handleSuccess: x,
			id: c,
			name: l
		}),
		h && /* @__PURE__ */ (0, J.jsx)(jh, { handleClose: b })
	] });
}, Nh = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	width: 250,
	height: 200,
	viewBox: "0 0 250 200",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M210.529 199.892C210.529 199.784 209.448 196.809 208.149 193.239L205.769 186.748L199.712 186.586L193.707 186.424L191.112 188.587C188.948 190.427 179.113 195.664 177.86 196.377C177.024 196.851 175.922 198.059 174.554 200C198.538 199.965 210.529 199.928 210.529 199.892V199.892Z",
			fill: "#80AEF2"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M242 199.892C242 199.784 240.918 196.809 239.62 193.239L237.24 186.748L231.182 186.586L225.178 186.424L222.582 188.587C220.418 190.427 210.584 195.664 209.33 196.377C208.495 196.851 207.392 198.059 206.024 200C230.008 199.965 242 199.928 242 199.892Z",
			fill: "#94BBF8"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M201.064 123.494C200.042 126.455 199.352 129.025 198.993 131.202C198.637 133.379 196.632 151.977 192.982 186.997H209.84C211.194 184.542 211.871 182.817 211.871 181.822C211.871 180.331 211.015 178.287 211.015 176.132C211.015 174.696 212.922 169.734 216.739 161.25L213.053 124.351L201.064 123.494V123.494Z",
			fill: "#1D225F"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M224.601 186.996H240.35C240.725 185.698 241.092 183.945 241.451 181.739C242.155 177.25 241.62 174.275 238.591 168.109C235.562 161.997 234.028 158.664 234.028 155.202C233.974 149.793 232.882 144.591 230.015 138.965C227.798 134.53 226.738 134.196 226.522 131.492L226.128 125.676H206.363C205.883 127.02 205.71 129.497 205.847 133.107C205.983 136.717 212.235 154.68 224.602 186.996H224.601Z",
			fill: "url(#paint0_linear_3050_39389)"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M182.042 68.1519L166.25 48.6191H147.317L163.67 68.1519H182.042Z",
			fill: "#98BDF9"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M161.224 46.1777C159.932 46.1777 158.874 47.1811 158.789 48.4517L158.783 48.6196H159.325C159.325 47.5703 160.176 46.7207 161.224 46.7207C162.273 46.7207 163.123 47.5703 163.123 48.6196C163.123 49.6154 162.356 50.4331 161.38 50.5119L161.224 50.5185V51.0605C162.573 51.0605 163.666 49.968 163.666 48.6196C163.666 47.2711 162.573 46.1777 161.224 46.1777V46.1777ZM154.714 46.1777C153.421 46.1777 152.364 47.1811 152.277 48.4517L152.272 48.6196H152.815C152.815 47.5703 153.664 46.7207 154.714 46.7207C155.762 46.7207 156.612 47.5703 156.612 48.6196C156.612 49.6154 155.845 50.4331 154.869 50.5119L154.714 50.5185V51.0605C156.062 51.0605 157.155 49.968 157.155 48.6196C157.155 47.2711 156.062 46.1777 154.714 46.1777V46.1777Z",
			fill: "#2174DB"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M183.418 71.9116C180.786 71.0095 178.21 69.7558 175.69 68.1504H169.247C171.474 70.1853 172.971 71.6256 173.739 72.4733C174.508 73.3201 176.092 74.947 178.492 77.3541C179.515 82.7751 180.605 85.0529 181.761 84.1855C183.496 82.8858 189.206 73.9671 183.418 71.9107V71.9116Z",
			fill: "#F3A29D"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M179.872 77.3752C175.78 75.8111 173.14 74.6962 171.951 74.0304C170.544 73.2192 170.003 72.4616 168.381 69.0539C168.165 68.6216 167.732 66.8362 167.353 65.1595C166.488 60.8863 165.081 61.1029 164.973 65.484C164.919 66.6749 164.649 67.7561 164.324 67.8639C164.054 67.9727 162.485 66.4573 160.917 64.5106C159.348 62.563 157.833 60.9941 157.563 60.9941C156.914 60.9941 156.914 65.9706 157.617 67.7017C157.888 68.5128 162.052 73.0561 166.866 77.8703C170.075 81.0802 174.772 85.4359 180.957 90.9394L179.872 77.3752V77.3752Z",
			fill: "#FAB6AF"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M198.32 54.0447C197.596 51.1509 196.873 49.342 196.149 48.6181C197.234 47.5332 198.32 46.4482 200.491 45.3633C201.213 46.8102 202.66 48.2571 204.83 49.704C204.83 51.8739 204.107 53.3208 202.66 54.0447C201.214 54.7677 199.767 54.7677 198.319 54.0447H198.32Z",
			fill: "#F3A29D"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M225.769 126.444C227.987 126.281 231.611 125.524 233.721 124.821L237.669 123.522L237.777 119.465C238.048 108.269 237.236 100.101 234.694 89.6625C231.233 75.3285 221.28 60.6709 209.218 52.0701C204.567 48.7168 204.458 48.7168 203.106 50.9889C202.511 52.0701 201.268 53.1522 200.401 53.4767L198.375 54.0337C201.231 81.5315 200.128 104.324 195.064 122.41C196.149 123.496 196.888 123.987 197.697 124.334C198.671 124.712 199.914 125.091 200.563 125.145C201.213 125.199 203.377 125.632 205.486 126.118C209.434 126.984 218.035 127.146 225.769 126.443V126.444Z",
			fill: "url(#paint1_linear_3050_39389)"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M183.418 71.9136L181.761 82.5202L200.49 85.0004L199.453 70.3223C197.445 71.9492 195.379 72.9254 193.256 73.2508C191.134 73.5771 187.855 73.1307 183.419 71.9136H183.418Z",
			fill: "#D6D7D8"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M179.872 77.3751L175.274 99.0787C175.807 100.164 177.159 100.888 179.329 101.249C184.213 101.791 189.095 99.6207 195.064 99.6207C201.033 99.6207 200.775 103.418 209.456 100.165C215.244 97.9937 217.596 88.2273 216.511 70.8644L199.581 69.2422C199.654 74.6641 198.967 77.918 197.52 79.0029C196.102 80.0663 190.422 79.5665 180.481 77.5026L179.872 77.3751V77.3751Z",
			fill: "#E9E9E9"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M187.325 34.9799C186.322 36.4052 185.93 38.2957 186.151 40.6522C186.209 41.2673 186.503 41.4802 186.503 42.5764C186.503 43.6266 186.437 44.9263 186.304 46.4745L188.477 46.6255C190.561 48.8873 192.766 49.8887 195.093 49.6327C197.418 49.3749 199.079 48.3734 200.072 46.6255C202.116 42.853 201.592 39.6451 198.501 37.0026C195.411 34.3601 191.685 33.6858 187.325 34.9799V34.9799Z",
			fill: "#FAB6AF"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M197.321 28C194.884 28 191.96 28.9537 189.824 30.5694C187.689 32.1841 186.219 33.4013 185.558 35.3489C185.117 36.6467 185.325 38.4566 186.18 40.7793C186.059 38.5803 186.225 37.3594 186.68 37.1165C187.309 38.6666 188.176 38.9798 189.215 39.73C189.796 40.1501 191.832 40.2157 193.826 40.5711C196.29 42.1859 197.861 43.6937 198.39 45.1285C198.81 46.2706 198.767 47.574 198.251 49.0453L198.133 49.3632L198.639 49.5601C199.309 47.8413 199.399 46.2987 198.899 44.9418C198.409 43.6131 197.164 42.2806 195.247 40.8899C196.269 41.1778 197.171 41.597 197.717 42.2487C198.917 43.6797 199.619 45.7792 199.823 48.5465C202.417 48.0776 204.798 47.2027 206.966 45.9208C209.134 44.6399 211.134 42.9257 212.966 40.7793C212.594 39.9972 212.118 39.3502 211.539 38.8382C210.91 38.2831 209.725 37.7992 208.568 37.1297L208.629 37.1494L209.758 37.5254C210.939 37.923 211.592 38.194 212.003 38.4931C212.782 39.0567 213.185 39.6887 213.235 40.3986L213.239 40.5777L213.782 40.5842C213.794 39.61 213.298 38.7622 212.322 38.0533C211.922 37.7626 211.372 37.516 210.463 37.1944L208.816 36.6411L208.244 36.4414C207.687 36.2416 207.246 36.0654 206.895 35.8938C205.679 34.5819 204.86 32.1701 203.059 30.5694C201.076 28.8018 199.757 28 197.322 28H197.321Z",
			fill: "#E94A47"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M192.9 40.7312C192.341 39.1934 190.866 38.296 189.586 38.762C188.591 39.124 188.035 40.1911 188.098 41.3698C187.761 41.2845 187.452 41.2414 187.172 41.2423L186.977 41.2489C186.738 41.2676 186.54 41.3014 186.38 41.3558C185.9 40.1639 184.779 39.4588 183.802 39.8142C182.798 40.1799 182.397 41.5049 182.853 42.7586C183.309 44.0123 184.468 44.7691 185.473 44.4034C186.366 44.078 186.783 42.993 186.542 41.8743C186.638 41.8387 186.799 41.8068 187.018 41.7899C187.331 41.7665 187.709 41.8171 188.151 41.9447L188.18 41.954C188.214 42.1031 188.258 42.2522 188.311 42.4013C188.871 43.9392 190.346 44.8366 191.627 44.3705C192.908 43.9045 193.46 42.2691 192.9 40.7312V40.7312ZM183.988 40.3243C184.673 40.0748 185.549 40.6459 185.912 41.6446C186.275 42.6442 185.972 43.6438 185.287 43.8932C184.602 44.1427 183.727 43.5716 183.363 42.5729C182.999 41.5743 183.303 40.5737 183.988 40.3243ZM189.771 39.2721C190.743 38.9186 191.925 39.6379 192.39 40.9169C192.855 42.195 192.413 43.5069 191.441 43.8614C190.47 44.214 189.286 43.4938 188.821 42.2157C188.356 40.9375 188.8 39.6257 189.771 39.2712V39.2721Z",
			fill: "#222768"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M15.5039 35.2891L14.0117 41H12.9883L12.0352 37.5781C12.0117 37.4948 11.9857 37.3958 11.957 37.2812C11.9284 37.1667 11.8997 37.0495 11.8711 36.9297C11.8451 36.8099 11.8216 36.7005 11.8008 36.6016C11.7826 36.5 11.7695 36.4219 11.7617 36.3672C11.7565 36.4219 11.7448 36.4987 11.7266 36.5977C11.7083 36.6966 11.6862 36.806 11.6602 36.9258C11.6367 37.043 11.6107 37.1602 11.582 37.2773C11.5534 37.3919 11.5273 37.4935 11.5039 37.582L10.5664 41H9.54688L8.05859 35.2891H9L9.82422 38.6367C9.85026 38.7435 9.8763 38.8594 9.90234 38.9844C9.93099 39.1068 9.95703 39.2305 9.98047 39.3555C10.0065 39.4805 10.0299 39.6029 10.0508 39.7227C10.0716 39.8398 10.0885 39.9466 10.1016 40.043C10.1146 39.944 10.1315 39.8346 10.1523 39.7148C10.1732 39.5924 10.1953 39.4688 10.2188 39.3438C10.2448 39.2161 10.2708 39.0938 10.2969 38.9766C10.3255 38.8594 10.3542 38.7539 10.3828 38.6602L11.3125 35.2891H12.2266L13.1758 38.6719C13.2044 38.7682 13.2318 38.8763 13.2578 38.9961C13.2865 39.1159 13.3138 39.2383 13.3398 39.3633C13.3659 39.4883 13.3893 39.6094 13.4102 39.7266C13.431 39.8438 13.4479 39.9492 13.4609 40.043C13.4792 39.9154 13.5026 39.7695 13.5312 39.6055C13.5599 39.4414 13.5924 39.2747 13.6289 39.1055C13.6654 38.9362 13.7018 38.7799 13.7383 38.6367L14.5586 35.2891H15.5039ZM21.3828 38.1367C21.3828 38.5768 21.3268 38.9779 21.2148 39.3398C21.1055 39.6992 20.9401 40.0091 20.7188 40.2695C20.4974 40.5273 20.2201 40.7266 19.8867 40.8672C19.5534 41.0078 19.1628 41.0781 18.7148 41.0781C18.2591 41.0781 17.8633 41.0078 17.5273 40.8672C17.194 40.7266 16.9167 40.526 16.6953 40.2656C16.4766 40.0052 16.3125 39.694 16.2031 39.332C16.0938 38.9701 16.0391 38.569 16.0391 38.1289C16.0391 37.5404 16.1354 37.0273 16.3281 36.5898C16.5234 36.1497 16.819 35.8086 17.2148 35.5664C17.6133 35.3216 18.1159 35.1992 18.7227 35.1992C19.3164 35.1992 19.8099 35.3203 20.2031 35.5625C20.5964 35.8047 20.8906 36.1458 21.0859 36.5859C21.2839 37.0234 21.3828 37.5404 21.3828 38.1367ZM17.0234 38.1367C17.0234 38.5768 17.0833 38.9583 17.2031 39.2812C17.3229 39.6016 17.5065 39.849 17.7539 40.0234C18.0039 40.1953 18.3242 40.2812 18.7148 40.2812C19.1081 40.2812 19.4284 40.1953 19.6758 40.0234C19.9232 39.849 20.1055 39.6016 20.2227 39.2812C20.3398 38.9583 20.3984 38.5768 20.3984 38.1367C20.3984 37.4674 20.2643 36.944 19.9961 36.5664C19.7305 36.1862 19.306 35.9961 18.7227 35.9961C18.332 35.9961 18.0104 36.082 17.7578 36.2539C17.5078 36.4258 17.3229 36.6719 17.2031 36.9922C17.0833 37.3099 17.0234 37.6914 17.0234 38.1367ZM24.2148 35.2891C24.707 35.2891 25.1133 35.349 25.4336 35.4688C25.7565 35.5885 25.9961 35.7708 26.1523 36.0156C26.3112 36.2604 26.3906 36.5716 26.3906 36.9492C26.3906 37.2305 26.3385 37.4701 26.2344 37.668C26.1302 37.8659 25.9935 38.0299 25.8242 38.1602C25.6549 38.2904 25.474 38.3945 25.2812 38.4727L26.9023 41H25.8438L24.4648 38.7109H23.5469V41H22.6094V35.2891H24.2148ZM24.1523 36.0703H23.5469V37.9375H24.1953C24.6302 37.9375 24.9453 37.8568 25.1406 37.6953C25.3385 37.5339 25.4375 37.2956 25.4375 36.9805C25.4375 36.6497 25.332 36.4154 25.1211 36.2773C24.9128 36.1393 24.5898 36.0703 24.1523 36.0703ZM32.0742 41H30.9961L29.2188 38.4062L28.6562 38.8633V41H27.7188V35.2891H28.6562V38.0195C28.7708 37.8789 28.8867 37.7383 29.0039 37.5977C29.1211 37.457 29.2383 37.3164 29.3555 37.1758L30.9648 35.2891H32.0234L29.8906 37.7891L32.0742 41ZM33.7578 41H32.8281V35.2891H36.0547V36.0781H33.7578V37.8594H35.9062V38.6445H33.7578V41ZM37.0938 41V35.2891H38.0312V40.2031H40.457V41H37.0938ZM46.5156 38.1367C46.5156 38.5768 46.4596 38.9779 46.3477 39.3398C46.2383 39.6992 46.0729 40.0091 45.8516 40.2695C45.6302 40.5273 45.3529 40.7266 45.0195 40.8672C44.6862 41.0078 44.2956 41.0781 43.8477 41.0781C43.3919 41.0781 42.9961 41.0078 42.6602 40.8672C42.3268 40.7266 42.0495 40.526 41.8281 40.2656C41.6094 40.0052 41.4453 39.694 41.3359 39.332C41.2266 38.9701 41.1719 38.569 41.1719 38.1289C41.1719 37.5404 41.2682 37.0273 41.4609 36.5898C41.6562 36.1497 41.9518 35.8086 42.3477 35.5664C42.7461 35.3216 43.2487 35.1992 43.8555 35.1992C44.4492 35.1992 44.9427 35.3203 45.3359 35.5625C45.7292 35.8047 46.0234 36.1458 46.2188 36.5859C46.4167 37.0234 46.5156 37.5404 46.5156 38.1367ZM42.1562 38.1367C42.1562 38.5768 42.2161 38.9583 42.3359 39.2812C42.4557 39.6016 42.6393 39.849 42.8867 40.0234C43.1367 40.1953 43.457 40.2812 43.8477 40.2812C44.2409 40.2812 44.5612 40.1953 44.8086 40.0234C45.056 39.849 45.2383 39.6016 45.3555 39.2812C45.4727 38.9583 45.5312 38.5768 45.5312 38.1367C45.5312 37.4674 45.3971 36.944 45.1289 36.5664C44.8633 36.1862 44.4388 35.9961 43.8555 35.9961C43.4648 35.9961 43.1432 36.082 42.8906 36.2539C42.6406 36.4258 42.4557 36.6719 42.3359 36.9922C42.2161 37.3099 42.1562 37.6914 42.1562 38.1367ZM54.4961 35.2891L53.0039 41H51.9805L51.0273 37.5781C51.0039 37.4948 50.9779 37.3958 50.9492 37.2812C50.9206 37.1667 50.8919 37.0495 50.8633 36.9297C50.8372 36.8099 50.8138 36.7005 50.793 36.6016C50.7747 36.5 50.7617 36.4219 50.7539 36.3672C50.7487 36.4219 50.737 36.4987 50.7188 36.5977C50.7005 36.6966 50.6784 36.806 50.6523 36.9258C50.6289 37.043 50.6029 37.1602 50.5742 37.2773C50.5456 37.3919 50.5195 37.4935 50.4961 37.582L49.5586 41H48.5391L47.0508 35.2891H47.9922L48.8164 38.6367C48.8424 38.7435 48.8685 38.8594 48.8945 38.9844C48.9232 39.1068 48.9492 39.2305 48.9727 39.3555C48.9987 39.4805 49.0221 39.6029 49.043 39.7227C49.0638 39.8398 49.0807 39.9466 49.0938 40.043C49.1068 39.944 49.1237 39.8346 49.1445 39.7148C49.1654 39.5924 49.1875 39.4688 49.2109 39.3438C49.237 39.2161 49.263 39.0938 49.2891 38.9766C49.3177 38.8594 49.3464 38.7539 49.375 38.6602L50.3047 35.2891H51.2188L52.168 38.6719C52.1966 38.7682 52.224 38.8763 52.25 38.9961C52.2786 39.1159 52.306 39.2383 52.332 39.3633C52.3581 39.4883 52.3815 39.6094 52.4023 39.7266C52.4232 39.8438 52.4401 39.9492 52.4531 40.043C52.4714 39.9154 52.4948 39.7695 52.5234 39.6055C52.5521 39.4414 52.5846 39.2747 52.6211 39.1055C52.6576 38.9362 52.694 38.7799 52.7305 38.6367L53.5508 35.2891H54.4961Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ (0, J.jsxs)("g", {
			filter: "url(#filter0_d_3050_39389)",
			children: [
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M8 49H114C117.314 49 120 51.6863 120 55V89C120 92.3137 117.314 95 114 95H14C10.6863 95 8 92.3137 8 89V49Z",
					fill: "white"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M8.25 49.25H114C117.176 49.25 119.75 51.8244 119.75 55V89C119.75 92.1756 117.176 94.75 114 94.75H14C10.8244 94.75 8.25 92.1756 8.25 89V49.25Z",
					stroke: "#0066CC",
					strokeWidth: .5
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M16.7812 64V58.2891H17.4453V64H16.7812ZM23.5664 59.6406C24.0378 59.6406 24.3932 59.7643 24.6328 60.0117C24.8724 60.2565 24.9922 60.651 24.9922 61.1953V64H24.3516V61.2266C24.3516 60.8802 24.276 60.6211 24.125 60.4492C23.9766 60.2747 23.7552 60.1875 23.4609 60.1875C23.0469 60.1875 22.7461 60.3073 22.5586 60.5469C22.3711 60.7865 22.2773 61.1393 22.2773 61.6055V64H21.6328V61.2266C21.6328 60.9948 21.599 60.8021 21.5312 60.6484C21.4661 60.4948 21.3672 60.3802 21.2344 60.3047C21.1042 60.2266 20.9388 60.1875 20.7383 60.1875C20.4544 60.1875 20.2266 60.2461 20.0547 60.3633C19.8828 60.4805 19.7578 60.6549 19.6797 60.8867C19.6042 61.1159 19.5664 61.3984 19.5664 61.7344V64H18.918V59.7188H19.4414L19.5391 60.3242H19.5742C19.6602 60.1758 19.7682 60.0508 19.8984 59.9492C20.0286 59.8477 20.1745 59.7708 20.3359 59.7188C20.4974 59.6667 20.6693 59.6406 20.8516 59.6406C21.1771 59.6406 21.4492 59.7018 21.668 59.8242C21.8893 59.944 22.0495 60.1276 22.1484 60.375H22.1836C22.3242 60.1276 22.5169 59.944 22.7617 59.8242C23.0065 59.7018 23.2747 59.6406 23.5664 59.6406ZM27.9258 59.6484C28.4362 59.6484 28.8151 59.763 29.0625 59.9922C29.3099 60.2214 29.4336 60.5872 29.4336 61.0898V64H28.9609L28.8359 63.3672H28.8047C28.6849 63.5234 28.5599 63.6549 28.4297 63.7617C28.2995 63.8659 28.1484 63.9453 27.9766 64C27.8073 64.0521 27.599 64.0781 27.3516 64.0781C27.0911 64.0781 26.8594 64.0326 26.6562 63.9414C26.4557 63.8503 26.2969 63.7122 26.1797 63.5273C26.0651 63.3424 26.0078 63.1081 26.0078 62.8242C26.0078 62.3971 26.1771 62.069 26.5156 61.8398C26.8542 61.6107 27.3698 61.4857 28.0625 61.4648L28.8008 61.4336V61.1719C28.8008 60.8021 28.7214 60.543 28.5625 60.3945C28.4036 60.2461 28.1797 60.1719 27.8906 60.1719C27.6667 60.1719 27.4531 60.2044 27.25 60.2695C27.0469 60.3346 26.8542 60.4115 26.6719 60.5L26.4727 60.0078C26.6654 59.9089 26.8867 59.8242 27.1367 59.7539C27.3867 59.6836 27.6497 59.6484 27.9258 59.6484ZM28.793 61.8906L28.1406 61.918C27.6068 61.9388 27.2305 62.026 27.0117 62.1797C26.793 62.3333 26.6836 62.5508 26.6836 62.832C26.6836 63.0768 26.7578 63.2578 26.9062 63.375C27.0547 63.4922 27.2513 63.5508 27.4961 63.5508C27.8763 63.5508 28.1875 63.4453 28.4297 63.2344C28.6719 63.0234 28.793 62.707 28.793 62.2852V61.8906ZM31.9648 65.9219C31.4023 65.9219 30.9688 65.8164 30.6641 65.6055C30.3594 65.3971 30.207 65.1042 30.207 64.7266C30.207 64.4583 30.2917 64.2292 30.4609 64.0391C30.6328 63.849 30.8698 63.7227 31.1719 63.6602C31.0599 63.6081 30.9635 63.5299 30.8828 63.4258C30.8047 63.3216 30.7656 63.2018 30.7656 63.0664C30.7656 62.9102 30.8086 62.7734 30.8945 62.6562C30.9831 62.5365 31.1172 62.4219 31.2969 62.3125C31.0729 62.2214 30.8906 62.0677 30.75 61.8516C30.612 61.6328 30.543 61.3789 30.543 61.0898C30.543 60.7826 30.6068 60.5208 30.7344 60.3047C30.862 60.0859 31.0469 59.9193 31.2891 59.8047C31.5312 59.6901 31.8242 59.6328 32.168 59.6328C32.2435 59.6328 32.319 59.6367 32.3945 59.6445C32.4727 59.6497 32.5469 59.6589 32.6172 59.6719C32.6875 59.6823 32.7487 59.6953 32.8008 59.7109H34.2695V60.1289L33.4805 60.2266C33.5586 60.3281 33.6237 60.4505 33.6758 60.5938C33.7279 60.737 33.7539 60.8958 33.7539 61.0703C33.7539 61.4974 33.6094 61.8372 33.3203 62.0898C33.0312 62.3398 32.6341 62.4648 32.1289 62.4648C32.0091 62.4648 31.8867 62.4544 31.7617 62.4336C31.6341 62.5039 31.5365 62.582 31.4688 62.668C31.4036 62.7539 31.3711 62.8529 31.3711 62.9648C31.3711 63.0482 31.3958 63.1146 31.4453 63.1641C31.4974 63.2135 31.5716 63.25 31.668 63.2734C31.7643 63.2943 31.8802 63.3047 32.0156 63.3047H32.7695C33.2357 63.3047 33.5924 63.4023 33.8398 63.5977C34.0898 63.793 34.2148 64.0781 34.2148 64.4531C34.2148 64.9271 34.0221 65.2904 33.6367 65.543C33.2513 65.7956 32.694 65.9219 31.9648 65.9219ZM31.9844 65.4141C32.3385 65.4141 32.6315 65.3776 32.8633 65.3047C33.0977 65.2344 33.2721 65.1315 33.3867 64.9961C33.5039 64.8633 33.5625 64.7044 33.5625 64.5195C33.5625 64.3477 33.5234 64.2174 33.4453 64.1289C33.3672 64.043 33.2526 63.9857 33.1016 63.957C32.9505 63.9258 32.7656 63.9102 32.5469 63.9102H31.8047C31.612 63.9102 31.444 63.9401 31.3008 64C31.1576 64.0599 31.0469 64.1484 30.9688 64.2656C30.8932 64.3828 30.8555 64.5286 30.8555 64.7031C30.8555 64.9349 30.9531 65.1107 31.1484 65.2305C31.3438 65.3529 31.6224 65.4141 31.9844 65.4141ZM32.1523 61.9922C32.4622 61.9922 32.6953 61.9141 32.8516 61.7578C33.0078 61.6016 33.0859 61.3737 33.0859 61.0742C33.0859 60.7539 33.0065 60.5143 32.8477 60.3555C32.6888 60.194 32.4544 60.1133 32.1445 60.1133C31.8477 60.1133 31.6185 60.1966 31.457 60.3633C31.2982 60.5273 31.2188 60.7682 31.2188 61.0859C31.2188 61.3776 31.2995 61.6016 31.4609 61.7578C31.6224 61.9141 31.8529 61.9922 32.1523 61.9922ZM36.7617 59.6406C37.1263 59.6406 37.4388 59.7214 37.6992 59.8828C37.9596 60.0443 38.1589 60.2708 38.2969 60.5625C38.4349 60.8516 38.5039 61.1901 38.5039 61.5781V61.9805H35.5469C35.5547 62.4831 35.6797 62.8659 35.9219 63.1289C36.1641 63.3919 36.5052 63.5234 36.9453 63.5234C37.2161 63.5234 37.4557 63.4987 37.6641 63.4492C37.8724 63.3997 38.0885 63.3268 38.3125 63.2305V63.8008C38.0964 63.8971 37.8815 63.9674 37.668 64.0117C37.457 64.056 37.207 64.0781 36.918 64.0781C36.5065 64.0781 36.1471 63.9948 35.8398 63.8281C35.5352 63.6589 35.2982 63.4115 35.1289 63.0859C34.9596 62.7604 34.875 62.362 34.875 61.8906C34.875 61.4297 34.9518 61.0312 35.1055 60.6953C35.2617 60.3568 35.4805 60.0964 35.7617 59.9141C36.0456 59.7318 36.3789 59.6406 36.7617 59.6406ZM36.7539 60.1719C36.4076 60.1719 36.1315 60.2852 35.9258 60.5117C35.7201 60.7383 35.5977 61.0547 35.5586 61.4609H37.8242C37.8216 61.2057 37.7812 60.9818 37.7031 60.7891C37.6276 60.5938 37.5117 60.4427 37.3555 60.3359C37.1992 60.2266 36.9987 60.1719 36.7539 60.1719ZM44.4531 62.8281C44.4531 63.1016 44.3841 63.332 44.2461 63.5195C44.1107 63.7044 43.9154 63.8438 43.6602 63.9375C43.4076 64.0312 43.1055 64.0781 42.7539 64.0781C42.4544 64.0781 42.1953 64.0547 41.9766 64.0078C41.7578 63.9609 41.5664 63.8945 41.4023 63.8086V63.2109C41.5768 63.2969 41.7852 63.375 42.0273 63.4453C42.2695 63.5156 42.5169 63.5508 42.7695 63.5508C43.1393 63.5508 43.4076 63.4909 43.5742 63.3711C43.7409 63.2513 43.8242 63.0885 43.8242 62.8828C43.8242 62.7656 43.7904 62.6628 43.7227 62.5742C43.6576 62.4831 43.5469 62.3958 43.3906 62.3125C43.2344 62.2266 43.0182 62.1328 42.7422 62.0312C42.4688 61.9271 42.2318 61.8242 42.0312 61.7227C41.8333 61.6185 41.6797 61.4922 41.5703 61.3438C41.4635 61.1953 41.4102 61.0026 41.4102 60.7656C41.4102 60.4036 41.556 60.1263 41.8477 59.9336C42.1419 59.7383 42.5273 59.6406 43.0039 59.6406C43.2617 59.6406 43.5026 59.6667 43.7266 59.7188C43.9531 59.7682 44.1641 59.8359 44.3594 59.9219L44.1406 60.4414C43.9635 60.3659 43.7747 60.3021 43.5742 60.25C43.3737 60.1979 43.1693 60.1719 42.9609 60.1719C42.6615 60.1719 42.431 60.2214 42.2695 60.3203C42.1107 60.4193 42.0312 60.5547 42.0312 60.7266C42.0312 60.8594 42.0677 60.9688 42.1406 61.0547C42.2161 61.1406 42.3359 61.2214 42.5 61.2969C42.6641 61.3724 42.8802 61.4609 43.1484 61.5625C43.4167 61.6615 43.6484 61.7643 43.8438 61.8711C44.0391 61.9753 44.1888 62.1029 44.293 62.2539C44.3997 62.4023 44.4531 62.5938 44.4531 62.8281ZM49.1875 61.8516C49.1875 62.2031 49.1419 62.5169 49.0508 62.793C48.9596 63.069 48.8281 63.3021 48.6562 63.4922C48.4844 63.6823 48.276 63.8281 48.0312 63.9297C47.7891 64.0286 47.5143 64.0781 47.207 64.0781C46.9206 64.0781 46.6576 64.0286 46.418 63.9297C46.181 63.8281 45.9753 63.6823 45.8008 63.4922C45.6289 63.3021 45.4948 63.069 45.3984 62.793C45.3047 62.5169 45.2578 62.2031 45.2578 61.8516C45.2578 61.3828 45.3372 60.9844 45.4961 60.6562C45.6549 60.3255 45.8815 60.0742 46.1758 59.9023C46.4727 59.7279 46.8255 59.6406 47.2344 59.6406C47.625 59.6406 47.9661 59.7279 48.2578 59.9023C48.5521 60.0768 48.7799 60.3294 48.9414 60.6602C49.1055 60.9883 49.1875 61.3854 49.1875 61.8516ZM45.9297 61.8516C45.9297 62.1953 45.9753 62.4935 46.0664 62.7461C46.1576 62.9987 46.2982 63.194 46.4883 63.332C46.6784 63.4701 46.9232 63.5391 47.2227 63.5391C47.5195 63.5391 47.763 63.4701 47.9531 63.332C48.1458 63.194 48.2878 62.9987 48.3789 62.7461C48.4701 62.4935 48.5156 62.1953 48.5156 61.8516C48.5156 61.5104 48.4701 61.2161 48.3789 60.9688C48.2878 60.7188 48.1471 60.526 47.957 60.3906C47.7669 60.2552 47.5208 60.1875 47.2188 60.1875C46.7734 60.1875 46.4466 60.3346 46.2383 60.6289C46.0326 60.9232 45.9297 61.3307 45.9297 61.8516ZM53.8438 59.7188V64H53.3125L53.2188 63.3984H53.1836C53.0951 63.5469 52.9805 63.6719 52.8398 63.7734C52.6992 63.875 52.5404 63.9505 52.3633 64C52.1888 64.0521 52.0026 64.0781 51.8047 64.0781C51.4661 64.0781 51.1823 64.0234 50.9531 63.9141C50.724 63.8047 50.5508 63.6354 50.4336 63.4062C50.319 63.1771 50.2617 62.8828 50.2617 62.5234V59.7188H50.918V62.4766C50.918 62.8333 50.9987 63.1003 51.1602 63.2773C51.3216 63.4518 51.5677 63.5391 51.8984 63.5391C52.2161 63.5391 52.4688 63.4792 52.6562 63.3594C52.8464 63.2396 52.9831 63.0638 53.0664 62.832C53.1497 62.5977 53.1914 62.3112 53.1914 61.9727V59.7188H53.8438ZM57.1602 59.6406C57.2461 59.6406 57.3359 59.6458 57.4297 59.6562C57.5234 59.6641 57.6068 59.6758 57.6797 59.6914L57.5977 60.293C57.5273 60.2747 57.4492 60.2604 57.3633 60.25C57.2773 60.2396 57.1966 60.2344 57.1211 60.2344C56.9492 60.2344 56.7865 60.2695 56.6328 60.3398C56.4818 60.4076 56.349 60.5065 56.2344 60.6367C56.1198 60.7643 56.0299 60.9193 55.9648 61.1016C55.8997 61.2812 55.8672 61.4818 55.8672 61.7031V64H55.2148V59.7188H55.7539L55.8242 60.5078H55.8516C55.9401 60.349 56.0469 60.2044 56.1719 60.0742C56.2969 59.9414 56.4414 59.8359 56.6055 59.7578C56.7721 59.6797 56.957 59.6406 57.1602 59.6406ZM60.2031 64.0781C59.8177 64.0781 59.4779 63.9987 59.1836 63.8398C58.8893 63.681 58.6602 63.4388 58.4961 63.1133C58.332 62.7878 58.25 62.3776 58.25 61.8828C58.25 61.3646 58.3359 60.9414 58.5078 60.6133C58.6823 60.2826 58.9219 60.0378 59.2266 59.8789C59.5312 59.7201 59.8776 59.6406 60.2656 59.6406C60.4792 59.6406 60.6849 59.6628 60.8828 59.707C61.0833 59.7487 61.2474 59.8021 61.375 59.8672L61.1797 60.4102C61.0495 60.3581 60.8984 60.3112 60.7266 60.2695C60.5573 60.2279 60.3984 60.207 60.25 60.207C59.9531 60.207 59.7057 60.2708 59.5078 60.3984C59.3125 60.526 59.1654 60.7135 59.0664 60.9609C58.9701 61.2083 58.9219 61.513 58.9219 61.875C58.9219 62.2214 58.9688 62.5169 59.0625 62.7617C59.1589 63.0065 59.3008 63.194 59.4883 63.3242C59.6784 63.4518 59.9154 63.5156 60.1992 63.5156C60.4258 63.5156 60.6302 63.4922 60.8125 63.4453C60.9948 63.3958 61.1602 63.3385 61.3086 63.2734V63.8516C61.1654 63.9245 61.0052 63.9805 60.8281 64.0195C60.6536 64.0586 60.4453 64.0781 60.2031 64.0781ZM63.9727 59.6406C64.3372 59.6406 64.6497 59.7214 64.9102 59.8828C65.1706 60.0443 65.3698 60.2708 65.5078 60.5625C65.6458 60.8516 65.7148 61.1901 65.7148 61.5781V61.9805H62.7578C62.7656 62.4831 62.8906 62.8659 63.1328 63.1289C63.375 63.3919 63.7161 63.5234 64.1562 63.5234C64.4271 63.5234 64.6667 63.4987 64.875 63.4492C65.0833 63.3997 65.2995 63.3268 65.5234 63.2305V63.8008C65.3073 63.8971 65.0924 63.9674 64.8789 64.0117C64.668 64.056 64.418 64.0781 64.1289 64.0781C63.7174 64.0781 63.3581 63.9948 63.0508 63.8281C62.7461 63.6589 62.5091 63.4115 62.3398 63.0859C62.1706 62.7604 62.0859 62.362 62.0859 61.8906C62.0859 61.4297 62.1628 61.0312 62.3164 60.6953C62.4727 60.3568 62.6914 60.0964 62.9727 59.9141C63.2565 59.7318 63.5898 59.6406 63.9727 59.6406ZM63.9648 60.1719C63.6185 60.1719 63.3424 60.2852 63.1367 60.5117C62.931 60.7383 62.8086 61.0547 62.7695 61.4609H65.0352C65.0326 61.2057 64.9922 60.9818 64.9141 60.7891C64.8385 60.5938 64.7227 60.4427 64.5664 60.3359C64.4102 60.2266 64.2096 60.1719 63.9648 60.1719Z",
					fill: "#3B444C"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 16,
					y: 71,
					width: 96,
					height: 6,
					rx: 2,
					fill: "#ABCFF3"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 16,
					y: 81,
					width: 60,
					height: 6,
					rx: 2,
					fill: "#ABCFF3"
				})
			]
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M15.5039 110.289L14.0117 116H12.9883L12.0352 112.578C12.0117 112.495 11.9857 112.396 11.957 112.281C11.9284 112.167 11.8997 112.049 11.8711 111.93C11.8451 111.81 11.8216 111.701 11.8008 111.602C11.7826 111.5 11.7695 111.422 11.7617 111.367C11.7565 111.422 11.7448 111.499 11.7266 111.598C11.7083 111.697 11.6862 111.806 11.6602 111.926C11.6367 112.043 11.6107 112.16 11.582 112.277C11.5534 112.392 11.5273 112.493 11.5039 112.582L10.5664 116H9.54688L8.05859 110.289H9L9.82422 113.637C9.85026 113.743 9.8763 113.859 9.90234 113.984C9.93099 114.107 9.95703 114.23 9.98047 114.355C10.0065 114.48 10.0299 114.603 10.0508 114.723C10.0716 114.84 10.0885 114.947 10.1016 115.043C10.1146 114.944 10.1315 114.835 10.1523 114.715C10.1732 114.592 10.1953 114.469 10.2188 114.344C10.2448 114.216 10.2708 114.094 10.2969 113.977C10.3255 113.859 10.3542 113.754 10.3828 113.66L11.3125 110.289H12.2266L13.1758 113.672C13.2044 113.768 13.2318 113.876 13.2578 113.996C13.2865 114.116 13.3138 114.238 13.3398 114.363C13.3659 114.488 13.3893 114.609 13.4102 114.727C13.431 114.844 13.4479 114.949 13.4609 115.043C13.4792 114.915 13.5026 114.77 13.5312 114.605C13.5599 114.441 13.5924 114.275 13.6289 114.105C13.6654 113.936 13.7018 113.78 13.7383 113.637L14.5586 110.289H15.5039ZM21.3828 113.137C21.3828 113.577 21.3268 113.978 21.2148 114.34C21.1055 114.699 20.9401 115.009 20.7188 115.27C20.4974 115.527 20.2201 115.727 19.8867 115.867C19.5534 116.008 19.1628 116.078 18.7148 116.078C18.2591 116.078 17.8633 116.008 17.5273 115.867C17.194 115.727 16.9167 115.526 16.6953 115.266C16.4766 115.005 16.3125 114.694 16.2031 114.332C16.0938 113.97 16.0391 113.569 16.0391 113.129C16.0391 112.54 16.1354 112.027 16.3281 111.59C16.5234 111.15 16.819 110.809 17.2148 110.566C17.6133 110.322 18.1159 110.199 18.7227 110.199C19.3164 110.199 19.8099 110.32 20.2031 110.562C20.5964 110.805 20.8906 111.146 21.0859 111.586C21.2839 112.023 21.3828 112.54 21.3828 113.137ZM17.0234 113.137C17.0234 113.577 17.0833 113.958 17.2031 114.281C17.3229 114.602 17.5065 114.849 17.7539 115.023C18.0039 115.195 18.3242 115.281 18.7148 115.281C19.1081 115.281 19.4284 115.195 19.6758 115.023C19.9232 114.849 20.1055 114.602 20.2227 114.281C20.3398 113.958 20.3984 113.577 20.3984 113.137C20.3984 112.467 20.2643 111.944 19.9961 111.566C19.7305 111.186 19.306 110.996 18.7227 110.996C18.332 110.996 18.0104 111.082 17.7578 111.254C17.5078 111.426 17.3229 111.672 17.2031 111.992C17.0833 112.31 17.0234 112.691 17.0234 113.137ZM24.2148 110.289C24.707 110.289 25.1133 110.349 25.4336 110.469C25.7565 110.589 25.9961 110.771 26.1523 111.016C26.3112 111.26 26.3906 111.572 26.3906 111.949C26.3906 112.23 26.3385 112.47 26.2344 112.668C26.1302 112.866 25.9935 113.03 25.8242 113.16C25.6549 113.29 25.474 113.395 25.2812 113.473L26.9023 116H25.8438L24.4648 113.711H23.5469V116H22.6094V110.289H24.2148ZM24.1523 111.07H23.5469V112.938H24.1953C24.6302 112.938 24.9453 112.857 25.1406 112.695C25.3385 112.534 25.4375 112.296 25.4375 111.98C25.4375 111.65 25.332 111.415 25.1211 111.277C24.9128 111.139 24.5898 111.07 24.1523 111.07ZM32.0742 116H30.9961L29.2188 113.406L28.6562 113.863V116H27.7188V110.289H28.6562V113.02C28.7708 112.879 28.8867 112.738 29.0039 112.598C29.1211 112.457 29.2383 112.316 29.3555 112.176L30.9648 110.289H32.0234L29.8906 112.789L32.0742 116ZM33.7578 116H32.8281V110.289H36.0547V111.078H33.7578V112.859H35.9062V113.645H33.7578V116ZM37.0938 116V110.289H38.0312V115.203H40.457V116H37.0938ZM46.5156 113.137C46.5156 113.577 46.4596 113.978 46.3477 114.34C46.2383 114.699 46.0729 115.009 45.8516 115.27C45.6302 115.527 45.3529 115.727 45.0195 115.867C44.6862 116.008 44.2956 116.078 43.8477 116.078C43.3919 116.078 42.9961 116.008 42.6602 115.867C42.3268 115.727 42.0495 115.526 41.8281 115.266C41.6094 115.005 41.4453 114.694 41.3359 114.332C41.2266 113.97 41.1719 113.569 41.1719 113.129C41.1719 112.54 41.2682 112.027 41.4609 111.59C41.6562 111.15 41.9518 110.809 42.3477 110.566C42.7461 110.322 43.2487 110.199 43.8555 110.199C44.4492 110.199 44.9427 110.32 45.3359 110.562C45.7292 110.805 46.0234 111.146 46.2188 111.586C46.4167 112.023 46.5156 112.54 46.5156 113.137ZM42.1562 113.137C42.1562 113.577 42.2161 113.958 42.3359 114.281C42.4557 114.602 42.6393 114.849 42.8867 115.023C43.1367 115.195 43.457 115.281 43.8477 115.281C44.2409 115.281 44.5612 115.195 44.8086 115.023C45.056 114.849 45.2383 114.602 45.3555 114.281C45.4727 113.958 45.5312 113.577 45.5312 113.137C45.5312 112.467 45.3971 111.944 45.1289 111.566C44.8633 111.186 44.4388 110.996 43.8555 110.996C43.4648 110.996 43.1432 111.082 42.8906 111.254C42.6406 111.426 42.4557 111.672 42.3359 111.992C42.2161 112.31 42.1562 112.691 42.1562 113.137ZM54.4961 110.289L53.0039 116H51.9805L51.0273 112.578C51.0039 112.495 50.9779 112.396 50.9492 112.281C50.9206 112.167 50.8919 112.049 50.8633 111.93C50.8372 111.81 50.8138 111.701 50.793 111.602C50.7747 111.5 50.7617 111.422 50.7539 111.367C50.7487 111.422 50.737 111.499 50.7188 111.598C50.7005 111.697 50.6784 111.806 50.6523 111.926C50.6289 112.043 50.6029 112.16 50.5742 112.277C50.5456 112.392 50.5195 112.493 50.4961 112.582L49.5586 116H48.5391L47.0508 110.289H47.9922L48.8164 113.637C48.8424 113.743 48.8685 113.859 48.8945 113.984C48.9232 114.107 48.9492 114.23 48.9727 114.355C48.9987 114.48 49.0221 114.603 49.043 114.723C49.0638 114.84 49.0807 114.947 49.0938 115.043C49.1068 114.944 49.1237 114.835 49.1445 114.715C49.1654 114.592 49.1875 114.469 49.2109 114.344C49.237 114.216 49.263 114.094 49.2891 113.977C49.3177 113.859 49.3464 113.754 49.375 113.66L50.3047 110.289H51.2188L52.168 113.672C52.1966 113.768 52.224 113.876 52.25 113.996C52.2786 114.116 52.306 114.238 52.332 114.363C52.3581 114.488 52.3815 114.609 52.4023 114.727C52.4232 114.844 52.4401 114.949 52.4531 115.043C52.4714 114.915 52.4948 114.77 52.5234 114.605C52.5521 114.441 52.5846 114.275 52.6211 114.105C52.6576 113.936 52.694 113.78 52.7305 113.637L53.5508 110.289H54.4961Z",
			fill: "#3B444C"
		}),
		/* @__PURE__ */ (0, J.jsxs)("g", {
			filter: "url(#filter1_b_3050_39389)",
			children: [
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M8 122H114C117.314 122 120 124.686 120 128V162C120 165.314 117.314 168 114 168H14C10.6863 168 8 165.314 8 162V122Z",
					fill: "white"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M8.5 122.5H114C117.038 122.5 119.5 124.962 119.5 128V162C119.5 165.038 117.038 167.5 114 167.5H14C10.9624 167.5 8.5 165.038 8.5 162V122.5Z",
					stroke: "#D0D4D9"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M16.7812 137V131.289H17.4453V137H16.7812ZM23.5664 132.641C24.0378 132.641 24.3932 132.764 24.6328 133.012C24.8724 133.257 24.9922 133.651 24.9922 134.195V137H24.3516V134.227C24.3516 133.88 24.276 133.621 24.125 133.449C23.9766 133.275 23.7552 133.188 23.4609 133.188C23.0469 133.188 22.7461 133.307 22.5586 133.547C22.3711 133.786 22.2773 134.139 22.2773 134.605V137H21.6328V134.227C21.6328 133.995 21.599 133.802 21.5312 133.648C21.4661 133.495 21.3672 133.38 21.2344 133.305C21.1042 133.227 20.9388 133.188 20.7383 133.188C20.4544 133.188 20.2266 133.246 20.0547 133.363C19.8828 133.48 19.7578 133.655 19.6797 133.887C19.6042 134.116 19.5664 134.398 19.5664 134.734V137H18.918V132.719H19.4414L19.5391 133.324H19.5742C19.6602 133.176 19.7682 133.051 19.8984 132.949C20.0286 132.848 20.1745 132.771 20.3359 132.719C20.4974 132.667 20.6693 132.641 20.8516 132.641C21.1771 132.641 21.4492 132.702 21.668 132.824C21.8893 132.944 22.0495 133.128 22.1484 133.375H22.1836C22.3242 133.128 22.5169 132.944 22.7617 132.824C23.0065 132.702 23.2747 132.641 23.5664 132.641ZM27.9258 132.648C28.4362 132.648 28.8151 132.763 29.0625 132.992C29.3099 133.221 29.4336 133.587 29.4336 134.09V137H28.9609L28.8359 136.367H28.8047C28.6849 136.523 28.5599 136.655 28.4297 136.762C28.2995 136.866 28.1484 136.945 27.9766 137C27.8073 137.052 27.599 137.078 27.3516 137.078C27.0911 137.078 26.8594 137.033 26.6562 136.941C26.4557 136.85 26.2969 136.712 26.1797 136.527C26.0651 136.342 26.0078 136.108 26.0078 135.824C26.0078 135.397 26.1771 135.069 26.5156 134.84C26.8542 134.611 27.3698 134.486 28.0625 134.465L28.8008 134.434V134.172C28.8008 133.802 28.7214 133.543 28.5625 133.395C28.4036 133.246 28.1797 133.172 27.8906 133.172C27.6667 133.172 27.4531 133.204 27.25 133.27C27.0469 133.335 26.8542 133.411 26.6719 133.5L26.4727 133.008C26.6654 132.909 26.8867 132.824 27.1367 132.754C27.3867 132.684 27.6497 132.648 27.9258 132.648ZM28.793 134.891L28.1406 134.918C27.6068 134.939 27.2305 135.026 27.0117 135.18C26.793 135.333 26.6836 135.551 26.6836 135.832C26.6836 136.077 26.7578 136.258 26.9062 136.375C27.0547 136.492 27.2513 136.551 27.4961 136.551C27.8763 136.551 28.1875 136.445 28.4297 136.234C28.6719 136.023 28.793 135.707 28.793 135.285V134.891ZM31.9648 138.922C31.4023 138.922 30.9688 138.816 30.6641 138.605C30.3594 138.397 30.207 138.104 30.207 137.727C30.207 137.458 30.2917 137.229 30.4609 137.039C30.6328 136.849 30.8698 136.723 31.1719 136.66C31.0599 136.608 30.9635 136.53 30.8828 136.426C30.8047 136.322 30.7656 136.202 30.7656 136.066C30.7656 135.91 30.8086 135.773 30.8945 135.656C30.9831 135.536 31.1172 135.422 31.2969 135.312C31.0729 135.221 30.8906 135.068 30.75 134.852C30.612 134.633 30.543 134.379 30.543 134.09C30.543 133.783 30.6068 133.521 30.7344 133.305C30.862 133.086 31.0469 132.919 31.2891 132.805C31.5312 132.69 31.8242 132.633 32.168 132.633C32.2435 132.633 32.319 132.637 32.3945 132.645C32.4727 132.65 32.5469 132.659 32.6172 132.672C32.6875 132.682 32.7487 132.695 32.8008 132.711H34.2695V133.129L33.4805 133.227C33.5586 133.328 33.6237 133.451 33.6758 133.594C33.7279 133.737 33.7539 133.896 33.7539 134.07C33.7539 134.497 33.6094 134.837 33.3203 135.09C33.0312 135.34 32.6341 135.465 32.1289 135.465C32.0091 135.465 31.8867 135.454 31.7617 135.434C31.6341 135.504 31.5365 135.582 31.4688 135.668C31.4036 135.754 31.3711 135.853 31.3711 135.965C31.3711 136.048 31.3958 136.115 31.4453 136.164C31.4974 136.214 31.5716 136.25 31.668 136.273C31.7643 136.294 31.8802 136.305 32.0156 136.305H32.7695C33.2357 136.305 33.5924 136.402 33.8398 136.598C34.0898 136.793 34.2148 137.078 34.2148 137.453C34.2148 137.927 34.0221 138.29 33.6367 138.543C33.2513 138.796 32.694 138.922 31.9648 138.922ZM31.9844 138.414C32.3385 138.414 32.6315 138.378 32.8633 138.305C33.0977 138.234 33.2721 138.132 33.3867 137.996C33.5039 137.863 33.5625 137.704 33.5625 137.52C33.5625 137.348 33.5234 137.217 33.4453 137.129C33.3672 137.043 33.2526 136.986 33.1016 136.957C32.9505 136.926 32.7656 136.91 32.5469 136.91H31.8047C31.612 136.91 31.444 136.94 31.3008 137C31.1576 137.06 31.0469 137.148 30.9688 137.266C30.8932 137.383 30.8555 137.529 30.8555 137.703C30.8555 137.935 30.9531 138.111 31.1484 138.23C31.3438 138.353 31.6224 138.414 31.9844 138.414ZM32.1523 134.992C32.4622 134.992 32.6953 134.914 32.8516 134.758C33.0078 134.602 33.0859 134.374 33.0859 134.074C33.0859 133.754 33.0065 133.514 32.8477 133.355C32.6888 133.194 32.4544 133.113 32.1445 133.113C31.8477 133.113 31.6185 133.197 31.457 133.363C31.2982 133.527 31.2188 133.768 31.2188 134.086C31.2188 134.378 31.2995 134.602 31.4609 134.758C31.6224 134.914 31.8529 134.992 32.1523 134.992ZM36.7617 132.641C37.1263 132.641 37.4388 132.721 37.6992 132.883C37.9596 133.044 38.1589 133.271 38.2969 133.562C38.4349 133.852 38.5039 134.19 38.5039 134.578V134.98H35.5469C35.5547 135.483 35.6797 135.866 35.9219 136.129C36.1641 136.392 36.5052 136.523 36.9453 136.523C37.2161 136.523 37.4557 136.499 37.6641 136.449C37.8724 136.4 38.0885 136.327 38.3125 136.23V136.801C38.0964 136.897 37.8815 136.967 37.668 137.012C37.457 137.056 37.207 137.078 36.918 137.078C36.5065 137.078 36.1471 136.995 35.8398 136.828C35.5352 136.659 35.2982 136.411 35.1289 136.086C34.9596 135.76 34.875 135.362 34.875 134.891C34.875 134.43 34.9518 134.031 35.1055 133.695C35.2617 133.357 35.4805 133.096 35.7617 132.914C36.0456 132.732 36.3789 132.641 36.7617 132.641ZM36.7539 133.172C36.4076 133.172 36.1315 133.285 35.9258 133.512C35.7201 133.738 35.5977 134.055 35.5586 134.461H37.8242C37.8216 134.206 37.7812 133.982 37.7031 133.789C37.6276 133.594 37.5117 133.443 37.3555 133.336C37.1992 133.227 36.9987 133.172 36.7539 133.172ZM44.4531 135.828C44.4531 136.102 44.3841 136.332 44.2461 136.52C44.1107 136.704 43.9154 136.844 43.6602 136.938C43.4076 137.031 43.1055 137.078 42.7539 137.078C42.4544 137.078 42.1953 137.055 41.9766 137.008C41.7578 136.961 41.5664 136.895 41.4023 136.809V136.211C41.5768 136.297 41.7852 136.375 42.0273 136.445C42.2695 136.516 42.5169 136.551 42.7695 136.551C43.1393 136.551 43.4076 136.491 43.5742 136.371C43.7409 136.251 43.8242 136.089 43.8242 135.883C43.8242 135.766 43.7904 135.663 43.7227 135.574C43.6576 135.483 43.5469 135.396 43.3906 135.312C43.2344 135.227 43.0182 135.133 42.7422 135.031C42.4688 134.927 42.2318 134.824 42.0312 134.723C41.8333 134.618 41.6797 134.492 41.5703 134.344C41.4635 134.195 41.4102 134.003 41.4102 133.766C41.4102 133.404 41.556 133.126 41.8477 132.934C42.1419 132.738 42.5273 132.641 43.0039 132.641C43.2617 132.641 43.5026 132.667 43.7266 132.719C43.9531 132.768 44.1641 132.836 44.3594 132.922L44.1406 133.441C43.9635 133.366 43.7747 133.302 43.5742 133.25C43.3737 133.198 43.1693 133.172 42.9609 133.172C42.6615 133.172 42.431 133.221 42.2695 133.32C42.1107 133.419 42.0312 133.555 42.0312 133.727C42.0312 133.859 42.0677 133.969 42.1406 134.055C42.2161 134.141 42.3359 134.221 42.5 134.297C42.6641 134.372 42.8802 134.461 43.1484 134.562C43.4167 134.661 43.6484 134.764 43.8438 134.871C44.0391 134.975 44.1888 135.103 44.293 135.254C44.3997 135.402 44.4531 135.594 44.4531 135.828ZM49.1875 134.852C49.1875 135.203 49.1419 135.517 49.0508 135.793C48.9596 136.069 48.8281 136.302 48.6562 136.492C48.4844 136.682 48.276 136.828 48.0312 136.93C47.7891 137.029 47.5143 137.078 47.207 137.078C46.9206 137.078 46.6576 137.029 46.418 136.93C46.181 136.828 45.9753 136.682 45.8008 136.492C45.6289 136.302 45.4948 136.069 45.3984 135.793C45.3047 135.517 45.2578 135.203 45.2578 134.852C45.2578 134.383 45.3372 133.984 45.4961 133.656C45.6549 133.326 45.8815 133.074 46.1758 132.902C46.4727 132.728 46.8255 132.641 47.2344 132.641C47.625 132.641 47.9661 132.728 48.2578 132.902C48.5521 133.077 48.7799 133.329 48.9414 133.66C49.1055 133.988 49.1875 134.385 49.1875 134.852ZM45.9297 134.852C45.9297 135.195 45.9753 135.493 46.0664 135.746C46.1576 135.999 46.2982 136.194 46.4883 136.332C46.6784 136.47 46.9232 136.539 47.2227 136.539C47.5195 136.539 47.763 136.47 47.9531 136.332C48.1458 136.194 48.2878 135.999 48.3789 135.746C48.4701 135.493 48.5156 135.195 48.5156 134.852C48.5156 134.51 48.4701 134.216 48.3789 133.969C48.2878 133.719 48.1471 133.526 47.957 133.391C47.7669 133.255 47.5208 133.188 47.2188 133.188C46.7734 133.188 46.4466 133.335 46.2383 133.629C46.0326 133.923 45.9297 134.331 45.9297 134.852ZM53.8438 132.719V137H53.3125L53.2188 136.398H53.1836C53.0951 136.547 52.9805 136.672 52.8398 136.773C52.6992 136.875 52.5404 136.951 52.3633 137C52.1888 137.052 52.0026 137.078 51.8047 137.078C51.4661 137.078 51.1823 137.023 50.9531 136.914C50.724 136.805 50.5508 136.635 50.4336 136.406C50.319 136.177 50.2617 135.883 50.2617 135.523V132.719H50.918V135.477C50.918 135.833 50.9987 136.1 51.1602 136.277C51.3216 136.452 51.5677 136.539 51.8984 136.539C52.2161 136.539 52.4688 136.479 52.6562 136.359C52.8464 136.24 52.9831 136.064 53.0664 135.832C53.1497 135.598 53.1914 135.311 53.1914 134.973V132.719H53.8438ZM57.1602 132.641C57.2461 132.641 57.3359 132.646 57.4297 132.656C57.5234 132.664 57.6068 132.676 57.6797 132.691L57.5977 133.293C57.5273 133.275 57.4492 133.26 57.3633 133.25C57.2773 133.24 57.1966 133.234 57.1211 133.234C56.9492 133.234 56.7865 133.27 56.6328 133.34C56.4818 133.408 56.349 133.507 56.2344 133.637C56.1198 133.764 56.0299 133.919 55.9648 134.102C55.8997 134.281 55.8672 134.482 55.8672 134.703V137H55.2148V132.719H55.7539L55.8242 133.508H55.8516C55.9401 133.349 56.0469 133.204 56.1719 133.074C56.2969 132.941 56.4414 132.836 56.6055 132.758C56.7721 132.68 56.957 132.641 57.1602 132.641ZM60.2031 137.078C59.8177 137.078 59.4779 136.999 59.1836 136.84C58.8893 136.681 58.6602 136.439 58.4961 136.113C58.332 135.788 58.25 135.378 58.25 134.883C58.25 134.365 58.3359 133.941 58.5078 133.613C58.6823 133.283 58.9219 133.038 59.2266 132.879C59.5312 132.72 59.8776 132.641 60.2656 132.641C60.4792 132.641 60.6849 132.663 60.8828 132.707C61.0833 132.749 61.2474 132.802 61.375 132.867L61.1797 133.41C61.0495 133.358 60.8984 133.311 60.7266 133.27C60.5573 133.228 60.3984 133.207 60.25 133.207C59.9531 133.207 59.7057 133.271 59.5078 133.398C59.3125 133.526 59.1654 133.714 59.0664 133.961C58.9701 134.208 58.9219 134.513 58.9219 134.875C58.9219 135.221 58.9688 135.517 59.0625 135.762C59.1589 136.007 59.3008 136.194 59.4883 136.324C59.6784 136.452 59.9154 136.516 60.1992 136.516C60.4258 136.516 60.6302 136.492 60.8125 136.445C60.9948 136.396 61.1602 136.339 61.3086 136.273V136.852C61.1654 136.924 61.0052 136.98 60.8281 137.02C60.6536 137.059 60.4453 137.078 60.2031 137.078ZM63.9727 132.641C64.3372 132.641 64.6497 132.721 64.9102 132.883C65.1706 133.044 65.3698 133.271 65.5078 133.562C65.6458 133.852 65.7148 134.19 65.7148 134.578V134.98H62.7578C62.7656 135.483 62.8906 135.866 63.1328 136.129C63.375 136.392 63.7161 136.523 64.1562 136.523C64.4271 136.523 64.6667 136.499 64.875 136.449C65.0833 136.4 65.2995 136.327 65.5234 136.23V136.801C65.3073 136.897 65.0924 136.967 64.8789 137.012C64.668 137.056 64.418 137.078 64.1289 137.078C63.7174 137.078 63.3581 136.995 63.0508 136.828C62.7461 136.659 62.5091 136.411 62.3398 136.086C62.1706 135.76 62.0859 135.362 62.0859 134.891C62.0859 134.43 62.1628 134.031 62.3164 133.695C62.4727 133.357 62.6914 133.096 62.9727 132.914C63.2565 132.732 63.5898 132.641 63.9727 132.641ZM63.9648 133.172C63.6185 133.172 63.3424 133.285 63.1367 133.512C62.931 133.738 62.8086 134.055 62.7695 134.461H65.0352C65.0326 134.206 64.9922 133.982 64.9141 133.789C64.8385 133.594 64.7227 133.443 64.5664 133.336C64.4102 133.227 64.2096 133.172 63.9648 133.172Z",
					fill: "#596168"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 16,
					y: 144,
					width: 80,
					height: 6,
					rx: 2,
					fill: "#D0D4D9"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 16,
					y: 154,
					width: 40,
					height: 6,
					rx: 2,
					fill: "#D0D4D9"
				})
			]
		}),
		/* @__PURE__ */ (0, J.jsxs)("defs", { children: [
			/* @__PURE__ */ (0, J.jsxs)("filter", {
				id: "filter0_d_3050_39389",
				x: 6,
				y: 47,
				width: 116,
				height: 50,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ (0, J.jsx)("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ (0, J.jsx)("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ (0, J.jsx)("feMorphology", {
						radius: 2,
						operator: "dilate",
						in: "SourceAlpha",
						result: "effect1_dropShadow_3050_39389"
					}),
					/* @__PURE__ */ (0, J.jsx)("feOffset", {}),
					/* @__PURE__ */ (0, J.jsx)("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ (0, J.jsx)("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.821419 0 0 0 0 0.91071 0 0 0 0 1 0 0 0 1 0"
					}),
					/* @__PURE__ */ (0, J.jsx)("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_3050_39389"
					}),
					/* @__PURE__ */ (0, J.jsx)("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_3050_39389",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ (0, J.jsxs)("filter", {
				id: "filter1_b_3050_39389",
				x: -118.72,
				y: -4.71999,
				width: 365.44,
				height: 299.44,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ (0, J.jsx)("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ (0, J.jsx)("feGaussianBlur", {
						in: "BackgroundImageFix",
						stdDeviation: 63.36
					}),
					/* @__PURE__ */ (0, J.jsx)("feComposite", {
						in2: "SourceAlpha",
						operator: "in",
						result: "effect1_backgroundBlur_3050_39389"
					}),
					/* @__PURE__ */ (0, J.jsx)("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_backgroundBlur_3050_39389",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ (0, J.jsxs)("linearGradient", {
				id: "paint0_linear_3050_39389",
				x1: 221.964,
				y1: 125.676,
				x2: 236.13,
				y2: 184.811,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, J.jsx)("stop", { stopColor: "#2A318C" }), /* @__PURE__ */ (0, J.jsx)("stop", {
					offset: 1,
					stopColor: "#1D225F"
				})]
			}),
			/* @__PURE__ */ (0, J.jsxs)("linearGradient", {
				id: "paint1_linear_3050_39389",
				x1: 216.445,
				y1: 49.4004,
				x2: 216.445,
				y2: 126.883,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, J.jsx)("stop", { stopColor: "#EEEEEE" }), /* @__PURE__ */ (0, J.jsx)("stop", {
					offset: 1,
					stopColor: "#D6D7D8"
				})]
			})
		] })
	]
}), Ph = () => /* @__PURE__ */ (0, J.jsx)("div", { className: "shimmer-loading w-100 h-132" }), Fh = ({ count: e, areFiltersLoading: t }) => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: `flexbox-col dc__gap-12 dc__align-items-center h-100 w-100 dc__overflow-auto ${t ? "bg__primary px-20" : ""}`,
	children: [t && /* @__PURE__ */ (0, J.jsx)("div", {
		className: "flexbox dc__align-items-center dc__content-space pt-20 pb-16 w-100",
		children: /* @__PURE__ */ (0, J.jsx)("div", { className: "shimmer-loading h-20 w-100px" })
	}), Array.from({ length: e }).map((e, t) => /* @__PURE__ */ (0, J.jsx)(Ph, {}, t))]
}), Ih = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M11.0111 6.23225H14.0111M14.0111 6.23225V3.23225M14.0111 6.23225L11.8898 4.11091C11.379 3.60019 10.7727 3.19506 10.1054 2.91866C9.43814 2.64226 8.72295 2.5 8.00068 2.5C7.27841 2.5 6.56321 2.64226 5.89592 2.91866C5.22863 3.19506 4.62231 3.60019 4.11159 4.11091M4.99023 9.76775H1.99023M1.99023 9.76775V12.7678M1.99023 9.76775L4.11158 11.8891C4.62231 12.3998 5.22862 12.8049 5.89591 13.0813C6.5632 13.3577 7.2784 13.5 8.00067 13.5C8.72294 13.5 9.43814 13.3577 10.1054 13.0813C10.7727 12.8049 11.379 12.3998 11.8898 11.8891",
		stroke: "#596168",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Lh = ({ isLoading: e, handleFetchMoreData: t }) => /* @__PURE__ */ (0, J.jsx)("button", {
	className: "show-older-images-cta cta ghosted flex h-32",
	onClick: t,
	disabled: e,
	type: "button",
	children: e ? /* @__PURE__ */ (0, J.jsx)(_n, { styles: { height: "32px" } }) : "Fetch more images"
}), Rh = ({ materialInformationList: e }) => /* @__PURE__ */ (0, J.jsx)(J.Fragment, { children: e.map((e, t) => {
	let n = mr(e);
	return (n.WebhookData?.Data || n.Author || n.Message || n.Date || n.Commit) && /* @__PURE__ */ (0, J.jsx)("div", {
		className: "bg__primary br-4 en-2 bw-1 m-12",
		children: /* @__PURE__ */ (0, J.jsx)(qt, {
			index: t,
			materialUrl: e.url,
			showMaterialInfoHeader: !0,
			commitInfo: n,
			materialSourceType: e.type,
			selectedCommitInfo: "",
			materialSourceValue: e.branch
		})
	}, t);
}) }), zh = ({ handleImageSelection: e, selectedArtifactId: t, artifactId: n, selectedReleaseVersion: r, currentRelease: i }) => {
	let a = n === t;
	return (r ? i && a && r === i.releaseVersion : !i && a) ? /* @__PURE__ */ (0, J.jsx)(Xi, {
		className: "dc__align-right icon-dim-24 cursor circle-fill-b5",
		"data-testid": `deployment-source-artifact-check-${n}`
	}) : /* @__PURE__ */ (0, J.jsx)("button", {
		className: "p-0 flex dc__no-border dc__no-background dc__outline-none-imp dc__tab-focus dc__tab-focus dc__uppercase",
		type: "button",
		onClick: () => {
			e(n, i);
		},
		"data-testid": `deployment-source-artifact-select-${n}`,
		children: Ro.SELECT_ARTIFACT_CTA
	});
}, Bh = ({ materialResponse: e, isSecurityModuleInstalled: t, isFetchingMoreImages: n, handleFetchMoreImages: r, applicationId: i, handleImageSelection: a, selectedArtifactId: o, isReleaseFilterActive: s, selectedReleaseVersion: c }) => {
	let { isSuperAdmin: l } = si(), [u, d] = A(/* @__PURE__ */ new Map()), f = e?.materials || [], p = f.length < e?.totalCount, m = (e) => {
		let t = new Map(u);
		t.set(e, !t.get(e)), d(t);
	}, h = (e, t) => ({
		isLatest: s ? null : e.latest,
		isRunningOnParentCD: e.runningOnParentCd,
		artifactStatus: e.artifactStatus,
		environmentName: null,
		parentEnvironmentName: null,
		stageType: s ? null : Dn.CD,
		showLatestTag: !1,
		isVirtualEnvironment: !1,
		deployedOn: e.deployedOnEnvironments,
		additionalInfo: t ? /* @__PURE__ */ (0, J.jsx)(Ch, {
			releaseVersion: t,
			isCardView: !0
		}) : null,
		targetPlatforms: e.targetPlatforms
	}), g = (e) => ({
		imagePath: e.imagePath,
		registryName: e.registryName,
		registryType: e.registryType,
		image: e.image,
		deployedTime: null,
		deployedBy: e.deployedBy,
		isRollbackTrigger: !1,
		excludedImagePathNode: null,
		approvalChecksNode: null
	}), _ = (t) => ({
		ciPipelineId: null,
		artifactId: +t.id,
		imageComment: t.imageComment,
		imageReleaseTags: t.imageReleaseTags,
		appReleaseTagNames: e?.appReleaseTagNames,
		setAppReleaseTagNames: null,
		tagsEditable: e?.tagsEditable,
		setTagsEditable: null,
		toggleCardMode: m,
		hideHardDelete: e?.hideImageTaggingHardDelete,
		updateCurrentAppMaterial: null,
		isSuperAdmin: l,
		forceReInit: !0
	}), v = (e, n) => {
		let r = vr(e.materialInfo), l = u.get(+e.id), d = s ? `${e.id}-${n?.releaseVersion}` : e.id;
		return /* @__PURE__ */ (0, J.jsx)(Zt, {
			testIdLocator: d,
			cta: /* @__PURE__ */ (0, J.jsx)(zh, {
				handleImageSelection: a,
				selectedArtifactId: o,
				artifactId: +e.id,
				currentRelease: n,
				selectedReleaseVersion: c
			}),
			sequentialCDCardTitleProps: h(e, n?.releaseVersion),
			artifactInfoProps: g(e),
			imageTagContainerProps: _(e),
			children: e.materialInfo.length > 0 && !l && r && /* @__PURE__ */ (0, J.jsx)(Qt, {
				environmentId: null,
				isSecurityModuleInstalled: t,
				artifactId: +e.id,
				applicationId: i,
				changesCard: /* @__PURE__ */ (0, J.jsx)(Rh, { materialInformationList: e.materialInfo }),
				isScanned: e.scanned,
				isScanEnabled: e.scanEnabled,
				SecurityModalSidebar: Xy
			})
		}, d);
	};
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col",
		children: [f.map((e) => {
			if (s) {
				let { configuredInReleases: t } = e;
				return t.map((t) => v(e, t));
			}
			return v(e);
		}), p && /* @__PURE__ */ (0, J.jsx)(Lh, {
			isLoading: n,
			handleFetchMoreData: r
		})]
	});
}, Vh = ({ handleImageSelection: e, selectedApplicationName: t, applicationDetailsMap: n }) => {
	let { id: r, track: i } = Q(), { getModuleInfo: a } = ci(), [o, s] = A(""), c = Pe(new AbortController()), { selectedWorkflowId: l, artifactSourceAppWorkflowId: u } = n[t], [d, f] = A(u === +l && !!n[t].sourceReleaseConfiguration?.releaseVersion), p = (e) => rr(() => du({
		releaseId: r,
		applicationName: t,
		workflowId: l,
		searchInput: o,
		searchType: o ? Gs.IMAGE_TAG : null,
		trackName: d ? i : null,
		signal: c.current.signal,
		offset: e ?? 0
	}), c), [m, h, g, _] = K(p, [
		r,
		l,
		o,
		d
	]), [v, y] = A(null), [b, x] = A(!1), [S, C] = A(!1), [w, T] = A(!1), ee = async () => {
		try {
			let { result: e } = await a(dn.SECURITY);
			e?.status === fn.INSTALLED && x(!0);
		} catch (e) {
			W(e);
		}
	};
	O(() => {
		ee();
	}, []), O(() => {
		!m && h && y(h.applicationsToArtifactsMap[t]);
	}, [m, h]);
	let E = async () => {
		try {
			T(!0);
			let { applicationsToArtifactsMap: e } = await p(v?.materials?.length);
			y((n) => ({
				...e[t],
				materials: [...n.materials, ...e[t].materials]
			}));
		} catch {} finally {
			T(!1);
		}
	}, te = () => {
		C(!0);
	}, ne = () => {
		C(!1), s("");
	};
	return /* @__PURE__ */ (0, J.jsx)("div", {
		className: "flexbox-col w-100 h-100",
		children: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "px-16 dc__overflow-auto h-100",
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox dc__content-space dc__position-sticky dc__top-0 dc__zi-1 bg__secondary py-16",
				children: [/* @__PURE__ */ (0, J.jsx)("div", {
					className: "flexbox dc__align-items-center",
					children: /* @__PURE__ */ (0, J.jsx)(it, {
						isChecked: d,
						onChange: () => {
							f((e) => !e);
						},
						rootClassName: "icon-dim-20 w-100 mb-0",
						dataTestId: "toggle-image-selection",
						tabIndex: 0,
						value: rt.CHECKED,
						children: /* @__PURE__ */ (0, J.jsx)("span", {
							className: "cn-9 fs-13 fw-4 lh-20 dc__truncate",
							children: Vo(i)
						})
					})
				}), /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox dc__gap-4",
					children: [S ? /* @__PURE__ */ (0, J.jsx)(On, {
						initialSearchText: o ?? "",
						containerClassName: "dc__mxw-250 flex-grow-1",
						handleEnter: (e) => {
							s(e);
						},
						inputProps: {
							placeholder: Ro.SEARCH_SOURCE.SEARCH_IMAGE_TAG,
							autoFocus: !0
						}
					}) : /* @__PURE__ */ (0, J.jsx)("button", {
						type: "button",
						className: "flex dc__align-center dc__outline-none-imp dc__no-background dc__no-border dc__tab-focus",
						onClick: te,
						"data-testid": "show-search-bar",
						"aria-label": "show search bar",
						children: /* @__PURE__ */ (0, J.jsx)(Se, { className: `icon-dim-18 ${S ? "" : "icon-color-n6"}` })
					}), /* @__PURE__ */ (0, J.jsx)("button", {
						className: "pt-0 pb-0 pl-0 pr-8 flex dc__outline-none-imp dc__no-background dc__no-border dc__tab-focus",
						onClick: () => {
							_(), o || ne();
						},
						type: "button",
						"aria-label": "refresh materials",
						children: /* @__PURE__ */ (0, J.jsx)(Ih, { className: "icon-dim-16 scn-6 cursor" })
					})]
				})]
			}), m || yr(g) ? /* @__PURE__ */ (0, J.jsx)(Fh, { count: 4 }) : g ? /* @__PURE__ */ (0, J.jsx)(It, {
				code: g.code,
				reload: _
			}) : v?.materials?.length ? /* @__PURE__ */ (0, J.jsx)(Bh, {
				materialResponse: v,
				isSecurityModuleInstalled: b,
				isFetchingMoreImages: w,
				handleFetchMoreImages: E,
				applicationId: n[t].appId,
				selectedArtifactId: n[t].artifactId,
				handleImageSelection: (t, n) => {
					let { imagePath: r, registryType: i, registryName: a, id: o, appWorkflowId: s } = v.materials.find((e) => +e.id === t);
					e({
						selectedImage: r,
						registryType: i,
						registryName: a,
						artifactId: +o,
						sourceReleaseConfiguration: n || null,
						artifactSourceAppWorkflowId: s
					});
				},
				isReleaseFilterActive: d,
				selectedReleaseVersion: n[t].sourceReleaseConfiguration?.releaseVersion
			}) : o ? /* @__PURE__ */ (0, J.jsx)(F, {
				title: Ro.NO_ARTIFACT_FROM_SEARCH.title,
				subTitle: Ro.NO_ARTIFACT_FROM_SEARCH.subTitle,
				isButtonAvailable: !0,
				renderButton: () => /* @__PURE__ */ (0, J.jsx)("button", {
					className: "cta secondary h-36 flex",
					type: "button",
					onClick: ne,
					"data-testid": "clear-filters",
					children: Ro.CLEAR_ARTIFACT_FILTERS
				})
			}) : d ? /* @__PURE__ */ (0, J.jsx)(F, {
				title: zo(t, i),
				subTitle: Bo(t, i),
				image: ji
			}) : /* @__PURE__ */ (0, J.jsx)(F, {
				title: Ro.NO_ARTIFACT_FOUND.title,
				subTitle: Ro.NO_ARTIFACT_FOUND.subTitle,
				image: ji
			})]
		})
	});
}, Hh = () => /* @__PURE__ */ (0, J.jsx)("div", {
	className: "px-16 py-10",
	children: /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col dc__gap-8 p-12 dc__border-dashed br-4",
		children: [/* @__PURE__ */ (0, J.jsx)("div", {
			className: "flex",
			children: /* @__PURE__ */ (0, J.jsx)(Oe, { className: "icon-dim-24 dc__no-shrink" })
		}), /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col dc__gap-2 dc__text-center",
			children: [/* @__PURE__ */ (0, J.jsx)("h4", {
				className: "m-0 cn-7 fs-12 fw-6 lh-20",
				children: Ro.NO_WORKFLOW_EMPTY_STATE.title
			}), /* @__PURE__ */ (0, J.jsx)("p", {
				className: "m-0 cn-7 fs-12 fw-4",
				children: Ro.NO_WORKFLOW_EMPTY_STATE.subTitle
			})]
		})]
	})
}), Uh = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M5 8H7.5M10 11.5H9C8.60218 11.5 8.22064 11.342 7.93934 11.0607C7.65804 10.7794 7.5 10.3978 7.5 10V6C7.5 5.60218 7.65804 5.22064 7.93934 4.93934C8.22064 4.65804 8.60218 4.5 9 4.5H10M2 6.25H4.5C4.77614 6.25 5 6.47386 5 6.75V9.25C5 9.52614 4.77614 9.75 4.5 9.75H2C1.72386 9.75 1.5 9.52614 1.5 9.25V6.75C1.5 6.47386 1.72386 6.25 2 6.25ZM10.5 2.5H13.5C13.7761 2.5 14 2.72386 14 3V6C14 6.27614 13.7761 6.5 13.5 6.5H10.5C10.2239 6.5 10 6.27614 10 6V3C10 2.72386 10.2239 2.5 10.5 2.5ZM10.5 9.5H13.5C13.7761 9.5 14 9.72386 14 10V13C14 13.2761 13.7761 13.5 13.5 13.5H10.5C10.2239 13.5 10 13.2761 10 13V10C10 9.72386 10.2239 9.5 10.5 9.5Z",
		stroke: "#596168",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wh = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M3.1875 7.50011C2.46263 7.50011 1.875 8.08774 1.875 8.81261C1.875 9.53749 2.46263 10.1251 3.1875 10.1251C3.91237 10.1251 4.5 9.53749 4.5 8.81261C4.5 8.08774 3.91237 7.50011 3.1875 7.50011ZM3.1875 7.50011V7.12511C3.18751 6.82675 3.30603 6.54061 3.51701 6.32964C3.72798 6.11867 4.01412 6.00015 4.31248 6.00015L7.68752 6.00008C7.98588 6.00008 8.27202 5.88156 8.48299 5.67059C8.69397 5.45962 8.81249 5.17348 8.8125 4.87512V4.5M3.1875 7.50011V4.5M8.8125 4.5C9.53737 4.5 10.125 3.91237 10.125 3.1875C10.125 2.46263 9.53737 1.875 8.8125 1.875C8.08763 1.875 7.5 2.46263 7.5 3.1875C7.5 3.91237 8.08763 4.5 8.8125 4.5ZM3.1875 4.5C3.91237 4.5 4.5 3.91237 4.5 3.1875C4.5 2.46263 3.91237 1.875 3.1875 1.875C2.46263 1.875 1.875 2.46263 1.875 3.1875C1.875 3.91237 2.46263 4.5 3.1875 4.5Z",
		stroke: "#596168",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gh = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	width: 24,
	height: 24,
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		fill: "#F4511E",
		d: "M42.2,22.1L25.9,5.8C25.4,5.3,24.7,5,24,5c0,0,0,0,0,0c-0.7,0-1.4,0.3-1.9,0.8l-3.5,3.5l4.1,4.1c0.4-0.2,0.8-0.3,1.3-0.3c1.7,0,3,1.3,3,3c0,0.5-0.1,0.9-0.3,1.3l4,4c0.4-0.2,0.8-0.3,1.3-0.3c1.7,0,3,1.3,3,3s-1.3,3-3,3c-1.7,0-3-1.3-3-3c0-0.5,0.1-0.9,0.3-1.3l-4-4c-0.1,0-0.2,0.1-0.3,0.1v10.4c1.2,0.4,2,1.5,2,2.8c0,1.7-1.3,3-3,3s-3-1.3-3-3c0-1.3,0.8-2.4,2-2.8V18.8c-1.2-0.4-2-1.5-2-2.8c0-0.5,0.1-0.9,0.3-1.3l-4.1-4.1L5.8,22.1C5.3,22.6,5,23.3,5,24c0,0.7,0.3,1.4,0.8,1.9l16.3,16.3c0,0,0,0,0,0c0.5,0.5,1.2,0.8,1.9,0.8s1.4-0.3,1.9-0.8l16.3-16.3c0.5-0.5,0.8-1.2,0.8-1.9C43,23.3,42.7,22.6,42.2,22.1z"
	})
}), Kh = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsx)("rect", {
			x: 1.66675,
			y: 12.7778,
			width: 5.55556,
			height: 5.55556,
			fill: "#023E8A"
		}),
		/* @__PURE__ */ (0, J.jsx)("rect", {
			x: 1.66675,
			y: 7.22168,
			width: 5.55556,
			height: 5.55556,
			fill: "#0077B6"
		}),
		/* @__PURE__ */ (0, J.jsx)("rect", {
			x: 7.22217,
			y: 12.7778,
			width: 5.55556,
			height: 5.55556,
			fill: "#0077B6"
		}),
		/* @__PURE__ */ (0, J.jsx)("rect", {
			x: 7.22217,
			y: 7.22168,
			width: 5.55556,
			height: 5.55556,
			fill: "#0096C7"
		}),
		/* @__PURE__ */ (0, J.jsx)("rect", {
			x: 12.7778,
			y: 12.7778,
			width: 5.55556,
			height: 5.55556,
			fill: "#0096C7"
		}),
		/* @__PURE__ */ (0, J.jsx)("rect", {
			x: 12.7778,
			y: 7.22168,
			width: 5.55556,
			height: 5.55556,
			fill: "#00B4D8"
		}),
		/* @__PURE__ */ (0, J.jsx)("rect", {
			x: 12.7778,
			y: 1.6665,
			width: 5.55556,
			height: 5.55556,
			fill: "#48CAE4"
		})
	]
}), qh = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M5.69742 14.1868C4.29084 14.2602 1.88669 15.0582 2.11885 16.7252C2.70606 20.9546 -1.91771 22.3125 4.23562 22.3125C7.33113 22.3125 9.28225 20.9546 9.57715 18.1046L8.74149 14.8733L5.69742 14.1868Z",
			fill: "#FE636E"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M6.80407 15.3052C6.15159 15.3394 5.03488 15.7093 5.14152 16.4845C5.41506 18.4491 3.26693 19.0787 6.12525 19.0787C7.5632 19.0787 8.4704 18.4491 8.60717 17.1242L8.29096 15.5281L6.80407 15.3052Z",
			fill: "#FFD659"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M8.21573 18.2287C7.38007 19.75 5.72251 20.4834 3.44766 20.4834C2.55679 20.4834 1.89176 20.4543 1.40493 20.3935C0.747379 21.7919 0.427434 22.3125 4.23562 22.3125C7.33113 22.3125 9.28225 20.9546 9.57715 18.1046L8.87448 17.3953L8.6348 17.1533C8.61349 17.2356 8.59089 17.3154 8.56579 17.3953C8.50181 17.7208 8.38257 17.9982 8.21573 18.2287Z",
			fill: "#FB2A39"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M7.95223 16.4643C7.64483 17.4143 6.80664 17.869 5.58448 17.869C5.33982 17.869 5.13275 17.8652 4.95709 17.8551C4.59697 18.7569 4.08126 19.0787 6.12528 19.0787C7.07889 19.0787 7.79913 18.8026 8.21571 18.2288C8.3826 17.9982 8.5018 17.7208 8.56578 17.3953C8.58335 17.3079 8.59714 17.218 8.6072 17.1242L7.95223 16.4643Z",
			fill: "#FFBF00"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M7.39895 11.8688L5.56449 12.9454C5.1956 13.162 5.25709 13.7422 5.5507 14.0398L5.69752 14.1868L6.80422 15.3053L8.60732 17.1242L9.57725 18.1046L10.0829 18.6151C10.3778 18.9115 10.9525 18.9723 11.167 18.6012L12.2323 16.748L11.0265 12.0563L7.39895 11.8688Z",
			fill: "#99B4CD"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M22.264 1.05771C21.3819 0.894299 19.7746 1.06531 17.8171 1.73412L18.698 5.00215L22.2753 6.22323C22.9403 4.23456 23.1072 2.60561 22.9391 1.72149C22.8412 1.20591 22.7784 1.15271 22.264 1.05771Z",
			fill: "#99B4CD"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M12.1857 4.69556C9.7364 3.80254 7.8392 4.20915 5.91566 5.9673C5.02355 6.83372 3.53915 7.97244 4.76505 9.20998L6.28958 10.749L10.6712 8.51457L12.1857 4.69556Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M19.3393 11.9156L15.2211 13.6345L13.3428 17.8689L14.8673 19.408C16.0932 20.6455 17.2212 19.147 18.0795 18.2464C18.9691 17.2534 20.5539 15.3622 19.3393 11.9156Z",
			fill: "#0066CC"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M22.2754 6.2231C22.1723 6.53373 22.0559 6.85272 21.928 7.17838C21.3454 8.65389 20.5013 10.2791 19.3393 11.9154C17.8799 13.97 15.9198 16.0436 13.3426 17.8692L13.0403 17.5639L12.2325 16.7482L10.0511 14.546L9.81555 14.3085L9.58004 14.0706L7.39907 11.8689L6.28979 10.7488C8.09762 8.14742 10.152 6.16858 12.186 4.69578C14.1633 3.26548 16.1221 2.31287 17.817 1.73421L22.2754 6.2231Z",
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M21.9866 1.01968C22.0732 1.94691 21.8787 3.44028 21.2827 5.2225L22.2752 6.22315C22.9403 4.23447 23.1072 2.60553 22.939 1.72141C22.8411 1.20587 22.7784 1.15267 22.2639 1.05767C22.1774 1.04121 22.0858 1.02858 21.9866 1.01968Z",
			fill: "#6C9ABB"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M20.9339 6.17885C20.3517 7.65452 19.5085 9.27839 18.3453 10.9162C17.8422 11.6243 17.28 12.3348 16.6527 13.0366C16.0228 13.7422 15.3289 14.4376 14.5647 15.114C13.8834 15.7169 13.1468 16.3046 12.3513 16.8683L13.0402 17.5637L13.3426 17.869C15.9199 16.0437 17.8798 13.9701 19.3391 11.9156C20.501 10.279 21.3455 8.65393 21.9277 7.17825C22.0557 6.85272 22.1723 6.53351 22.2752 6.22319L21.2827 5.22253C21.2174 5.41632 21.1484 5.61269 21.0731 5.81279C21.0292 5.93311 20.9828 6.056 20.9339 6.17885Z",
			fill: "#C7C7C7"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M11.0239 15.5282L9.95861 17.3813C9.74407 17.7525 9.16936 17.6917 8.87451 17.3953L9.57718 18.1046L10.0828 18.6151C10.3777 18.9115 10.9524 18.9723 11.1669 18.6011L12.2322 16.748L11.0239 15.5282Z",
			fill: "#6C9ABB"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M19.3393 11.9156C19.1373 12.2006 18.9252 12.4856 18.7044 12.7693C18.9904 15.1849 17.7821 16.6188 17.0468 17.4396C16.3417 18.178 15.457 19.3193 14.4846 19.0216L14.8673 19.408C16.0932 20.6455 17.2212 19.147 18.0795 18.2464C18.9691 17.2534 20.5539 15.3622 19.3393 11.9156Z",
			fill: "#0053A6"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M10.6336 4.29402C8.80294 5.67976 6.97222 7.48097 5.33228 9.7825L6.28966 10.7489C8.09778 8.1472 10.1518 6.16866 12.1858 4.69552C11.6437 4.49799 11.128 4.36372 10.6336 4.29402Z",
			fill: "#0053A6"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M11.7631 12.8189L10.0531 14.5443C10.0522 14.5452 10.0518 14.5456 10.0509 14.546L9.81535 14.3085L9.57983 14.0706L11.2881 12.3474C11.4182 12.2158 11.6302 12.215 11.7613 12.3452C11.8923 12.476 11.8932 12.6877 11.7631 12.8189Z",
			fill: "#C7C7C7"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.0407 23.0063C12.6564 23.2559 12.1979 23.4009 11.7055 23.4009C10.3499 23.4009 9.25098 22.302 9.25098 20.9463V18.4918C9.25098 17.1362 10.3499 16.0373 11.7055 16.0373H12.2998C12.086 15.9249 11.8853 15.7789 11.7055 15.5991C10.747 14.6405 10.747 13.0864 11.7055 12.1279C12.3513 11.4821 13.118 10.9698 13.9618 10.6203C14.8055 10.2708 15.7099 10.0909 16.6232 10.0909C17.5364 10.0909 18.4408 10.2708 19.2845 10.6203C19.6034 10.7524 19.9112 10.9076 20.2056 11.0846C20.5899 10.835 21.0484 10.69 21.5408 10.69C22.8964 10.69 23.9953 11.789 23.9953 13.1446V15.5991C23.9953 16.9547 22.8964 18.0537 21.5408 18.0537H20.9465C21.1603 18.166 21.361 18.3121 21.5408 18.4918C22.4993 19.4504 22.4993 21.0045 21.5408 21.9631C20.895 22.6089 20.1283 23.1211 19.2845 23.4706C18.4408 23.8201 17.5364 24 16.6232 24C15.7099 24 14.8055 23.8201 13.9618 23.4706C13.643 23.3386 13.3351 23.1833 13.0407 23.0063Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.6255 13.3582C16.142 13.3582 15.6632 13.4534 15.2165 13.6384C14.7698 13.8235 14.3639 14.0947 14.022 14.4366C13.7025 14.7561 13.1845 14.7561 12.8649 14.4366C12.5454 14.117 12.5454 13.599 12.8649 13.2795C13.3588 12.7856 13.9451 12.3939 14.5903 12.1266C15.2355 11.8594 15.9271 11.7218 16.6255 11.7218C17.3239 11.7218 18.0154 11.8594 18.6606 12.1266C19.3059 12.3939 19.8921 12.7856 20.386 13.2795L20.7249 13.6184V13.1391C20.7249 12.6872 21.0912 12.3209 21.5431 12.3209C21.995 12.3209 22.3613 12.6872 22.3613 13.1391V15.5937C22.3613 16.0455 21.995 16.4118 21.5431 16.4118H19.0885C18.6367 16.4118 18.2704 16.0455 18.2704 15.5937C18.2704 15.1418 18.6367 14.7755 19.0885 14.7755H19.5678L19.2289 14.4366C18.887 14.0947 18.4811 13.8235 18.0344 13.6384C17.5877 13.4534 17.109 13.3582 16.6255 13.3582ZM10.8896 18.4863C10.8896 18.0345 11.256 17.6682 11.7078 17.6682H14.1624C14.6142 17.6682 14.9806 18.0345 14.9806 18.4863C14.9806 18.9382 14.6142 19.3045 14.1624 19.3045H13.6831L14.022 19.6434C14.3639 19.9853 14.7698 20.2565 15.2165 20.4416C15.6632 20.6266 16.142 20.7218 16.6255 20.7218C17.109 20.7218 17.5877 20.6266 18.0344 20.4416C18.4811 20.2565 18.887 19.9853 19.2289 19.6434C19.5484 19.3239 20.0665 19.3239 20.386 19.6434C20.7055 19.963 20.7055 20.481 20.386 20.8005C19.8921 21.2944 19.3059 21.6861 18.6606 21.9534C18.0154 22.2206 17.3239 22.3582 16.6255 22.3582C15.9271 22.3582 15.2355 22.2206 14.5903 21.9534C13.945 21.6861 13.3588 21.2944 12.8649 20.8005L12.526 20.4616V20.9409C12.526 21.3928 12.1597 21.7591 11.7078 21.7591C11.256 21.7591 10.8896 21.3928 10.8896 20.9409V18.4863Z",
			fill: "#CC7700"
		})
	]
}), Jh = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.9137 3.5137L17.8388 5.5854C17.5759 5.84916 17.5759 6.27477 17.8388 6.53853L19.3818 8.07912C19.646 8.34168 20.0722 8.34168 20.3364 8.07912L22.4113 6.00622C22.553 5.86475 22.7955 5.93069 22.8484 6.12371C23.2422 7.57438 22.8688 9.1893 21.7281 10.3283C20.4865 11.5679 18.6806 11.8988 17.1364 11.3234L8.15472 21.1304C7.23374 22.1375 5.65715 22.1734 4.69054 21.2071C3.71913 20.2384 3.75995 18.6534 4.77939 17.7363L14.6232 8.8716C13.9988 7.31062 14.3194 5.45952 15.5862 4.19588C16.7269 3.05692 18.3443 2.68526 19.7973 3.0773C19.9906 3.13005 20.0566 3.37223 19.9149 3.5137H19.9137ZM5.71839 19.4975C5.71839 19.8931 6.04019 20.2156 6.43644 20.2156C6.83269 20.2156 7.15569 19.8943 7.15569 19.4975C7.15569 19.1018 6.83389 18.7805 6.43644 18.7805C6.04019 18.7805 5.71839 19.1018 5.71839 19.4975Z",
			fill: "#8898A6"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.65479 9.28372L9.11622 6.82609L21.0031 18.6946C21.4718 19.1626 21.4718 19.9222 21.0031 20.3901L20.2398 21.1522C19.7711 21.6202 19.0103 21.6202 18.5417 21.1522L6.65479 9.28372V9.28372Z",
			fill: "#F4910D"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.81229 11.8914L5.50173 11.203L5.56711 10.7427C5.62315 10.3544 5.984 10.084 6.37202 10.1391C6.42551 10.1467 6.47731 10.1595 6.52655 10.1798L9.60356 7.10755L9.48129 6.13772C9.39723 5.45867 9.62988 4.77708 10.1155 4.29217C10.608 3.80047 11.2754 3.5241 11.9716 3.5241L13.1934 3.52495C11.2703 1.60479 9.45327 1.49798 7.74411 3.2045L3.51153 7.43054C3.2687 7.673 2.93417 7.80016 2.59199 7.78066L2.04095 7.7476L1.35151 8.43597C0.882829 8.90393 0.882829 9.66352 1.35151 10.1315L3.11417 11.8914C3.58285 12.3594 4.34361 12.3594 4.81229 11.8914Z",
			fill: "#66757F"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.7273 13.8577C14.3217 13.5348 13.8079 13.3418 13.2491 13.3418H10.7859C9.37192 13.3418 8.01589 13.9035 7.01608 14.9033C6.01628 15.9031 5.45459 17.2591 5.45459 18.6731C5.45459 20.087 6.01628 21.4431 7.01608 22.4429C8.01589 23.4427 9.37192 24.0044 10.7859 24.0044H13.2491C13.8079 24.0044 14.3217 23.8114 14.7273 23.4885C15.133 23.8114 15.6467 24.0044 16.2055 24.0044H18.6688C20.0827 24.0044 21.4387 23.4427 22.4386 22.4429C23.4384 21.4431 24 20.087 24 18.6731C24 17.2591 23.4384 15.9031 22.4386 14.9033C21.4387 13.9035 20.0827 13.3418 18.6688 13.3418H16.2055C15.6467 13.3418 15.133 13.5348 14.7273 13.8577Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.56879 18.6731C8.56879 19.2611 8.80236 19.825 9.21811 20.2407C9.63387 20.6565 10.1978 20.89 10.7857 20.89H13.249C13.6571 20.89 13.988 21.2209 13.988 21.629C13.988 22.0372 13.6571 22.368 13.249 22.368H10.7857C9.80578 22.368 8.86597 21.9787 8.17304 21.2858C7.4801 20.5929 7.09082 19.6531 7.09082 18.6731C7.09082 17.6931 7.4801 16.7533 8.17304 16.0604C8.86597 15.3675 9.80578 14.9782 10.7857 14.9782H13.249C13.6571 14.9782 13.988 15.309 13.988 15.7172C13.988 16.1253 13.6571 16.4562 13.249 16.4562H10.7857C10.1978 16.4562 9.63387 16.6897 9.21811 17.1055C8.80236 17.5212 8.56879 18.0851 8.56879 18.6731ZM11.0325 18.6729C11.0325 18.2647 11.3633 17.9339 11.7715 17.9339H17.6833C18.0915 17.9339 18.4223 18.2647 18.4223 18.6729C18.4223 19.081 18.0915 19.4118 17.6833 19.4118H11.7715C11.3633 19.4118 11.0325 19.081 11.0325 18.6729ZM15.4664 21.629C15.4664 21.2209 15.7972 20.89 16.2054 20.89H18.6686C19.2566 20.89 19.8205 20.6565 20.2363 20.2407C20.652 19.825 20.8856 19.2611 20.8856 18.6731C20.8856 18.0851 20.652 17.5212 20.2363 17.1055C19.8205 16.6897 19.2566 16.4562 18.6686 16.4562H16.2054C15.7972 16.4562 15.4664 16.1253 15.4664 15.7172C15.4664 15.309 15.7972 14.9782 16.2054 14.9782H18.6686C19.6486 14.9782 20.5884 15.3675 21.2813 16.0604C21.9743 16.7533 22.3635 17.6931 22.3635 18.6731C22.3635 19.653 21.9743 20.5929 21.2813 21.2858C20.5884 21.9787 19.6486 22.368 18.6686 22.368H16.2054C15.7972 22.368 15.4664 22.0372 15.4664 21.629Z",
			fill: "#664BEE"
		})
	]
}), Yh = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.00089 1.86328C5.50296 1.86328 5.90998 2.2703 5.90998 2.77237C5.90998 2.93288 5.86838 3.08367 5.79538 3.21455L6.97043 5.1751L6.99992 5.16439C7.19321 5.09905 7.3958 5.05977 7.60319 5.04849L7.72816 5.0451C8.98335 5.0451 10.0009 6.06263 10.0009 7.31783C10.0009 8.57302 8.98335 9.59055 7.72816 9.59055C7.14751 9.59055 6.59998 9.37132 6.18279 8.98431C5.99875 8.81358 5.98796 8.52598 6.15869 8.34194C6.32942 8.1579 6.61702 8.1471 6.80106 8.31783C7.05175 8.55039 7.37911 8.68146 7.72816 8.68146C8.48128 8.68146 9.0918 8.07094 9.0918 7.31783C9.0918 6.56471 8.48128 5.95419 7.72816 5.95419C7.47647 5.95419 7.23585 6.02205 7.02554 6.14882C6.82553 6.26938 6.56991 6.21785 6.43091 6.03714L6.40099 5.99317L5.01543 3.68101L5.00089 3.68146C4.52163 3.68146 4.12899 3.31061 4.09429 2.84022L4.0918 2.77237C4.0918 2.2703 4.49881 1.86328 5.00089 1.86328Z",
			fill: "#4A4A4A"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M4.99964 0.5C6.25484 0.5 7.27237 1.51753 7.27237 2.77273C7.27237 3.02377 7.06887 3.22727 6.81783 3.22727C6.58472 3.22727 6.3926 3.0518 6.36634 2.82574L6.36328 2.77273C6.36328 2.01961 5.75276 1.40909 4.99964 1.40909C4.24653 1.40909 3.63601 2.01961 3.63601 2.77273C3.63601 3.28748 3.92345 3.75082 4.37235 3.98394C4.61008 4.10739 4.69004 4.40861 4.54484 4.63372L3.0814 6.90313C3.14536 7.02756 3.18146 7.16865 3.18146 7.31818C3.18146 7.82026 2.77445 8.22727 2.27237 8.22727C1.7703 8.22727 1.36328 7.82026 1.36328 7.31818C1.36328 6.8161 1.7703 6.40909 2.27237 6.40909C2.28723 6.40909 2.302 6.40945 2.31669 6.41015L3.53964 4.51409L3.52319 4.50085C3.0534 4.09942 2.75908 3.5168 2.7294 2.87944L2.72692 2.77273C2.72692 1.51753 3.74445 0.5 4.99964 0.5Z",
			fill: "#EB456D"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.08094 5.45419C2.16642 5.69022 2.04437 5.95087 1.80833 6.03635C1.27307 6.2302 0.909091 6.74017 0.909091 7.319C0.909091 8.07211 1.51961 8.68264 2.27273 8.68264C2.99895 8.68264 3.59257 8.11494 3.63405 7.39912L3.63636 7.319C3.63636 7.08589 3.81184 6.89377 4.0379 6.86751L4.09091 6.86445L6.93989 6.8643C7.0971 6.59266 7.39084 6.40991 7.72727 6.40991C8.22935 6.40991 8.63636 6.81692 8.63636 7.319C8.63636 7.82108 8.22935 8.22809 7.72727 8.22809C7.39084 8.22809 7.0971 8.04534 6.93989 7.77369L4.49909 7.77309L4.49438 7.80035C4.28026 8.79332 3.41733 9.54498 2.37131 9.58963L2.27273 9.59173C1.01753 9.59173 0 8.57419 0 7.319C0 6.35444 0.606439 5.50475 1.49878 5.18158C1.73481 5.0961 1.99545 5.21815 2.08094 5.45419Z",
			fill: "#4A4A4A"
		})
	]
}), Xh = (e) => {
	switch (e) {
		case nt.CI_JOB: return /* @__PURE__ */ (0, J.jsx)(Kh, { className: "icon-dim-16 mt-2 dc__no-shrink" });
		case nt.WEBHOOK: return /* @__PURE__ */ (0, J.jsx)(Yh, { className: "icon-dim-16 mt-2 dc__no-shrink" });
		case nt.LINKED_CI: return /* @__PURE__ */ (0, J.jsx)(Jh, { className: "icon-dim-16 mt-2 dc__no-shrink" });
		case nt.LINKED_CD: return /* @__PURE__ */ (0, J.jsx)(qh, { className: "icon-dim-16 mt-2 dc__no-shrink" });
		default: return /* @__PURE__ */ (0, J.jsx)(Gh, { className: "icon-dim-16 dc__no-shrink" });
	}
}, Zh = (e, t) => {
	let n = bc(e), r = Object.keys(n), i = Object.keys(t);
	return r.length === i.length ? i.some((e) => {
		let { sourceReleaseConfiguration: r, artifactId: i } = t[e];
		return ll(n[e], r, i);
	}) : !0;
}, Qh = ({ repositoryName: e, sourceValue: t, sourceType: n, pipelineType: r }) => {
	let [i, a] = K(() => Au(t), [t], n === In.WEBHOOK);
	return /* @__PURE__ */ (0, J.jsx)("div", {
		className: "flexbox-col dc__gap-8 w-100",
		children: /* @__PURE__ */ (0, J.jsx)("div", {
			className: "flexbox dc__gap-4 w-100",
			children: n === In.WEBHOOK ? i ? /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col dc__gap-4 w-100",
				children: [/* @__PURE__ */ (0, J.jsx)("div", { className: "shimmer-loading h-16 w-75" }), /* @__PURE__ */ (0, J.jsx)("div", { className: "shimmer-loading h-16 w-50" })]
			}) : /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col dc__gap-4",
				children: [Xh(r), Pr(a)]
			}), /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col dc__gap-4",
				children: [/* @__PURE__ */ (0, J.jsx)("p", {
					className: "m-0 cn-9 fs-12 fw-4 lh-16 dc__align-left dc__truncate",
					children: e || "-"
				}), /* @__PURE__ */ (0, J.jsx)("p", {
					className: "m-0 cn-7 fs-12 fw-4 lh-14 dc__align-left dc__truncate",
					children: a || Ro.UNABLE_TO_FETCH_EVENT_NAME
				})]
			})] }) : /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col dc__gap-4",
				children: [Xh(r), /* @__PURE__ */ (0, J.jsx)(Wh, { className: "icon-dim-12 dc__no-shrink" })]
			}), /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col dc__gap-4",
				children: [/* @__PURE__ */ (0, J.jsx)("p", {
					className: "m-0 cn-9 fs-12 fw-4 lh-16 dc__align-left dc__truncate",
					children: e || "-"
				}), /* @__PURE__ */ (0, J.jsx)("p", {
					className: "m-0 cn-7 fs-12 fw-4 lh-14 dc__align-left dc__truncate",
					children: t ?? "-"
				})]
			})] })
		})
	});
}, $h = ({ children: e }) => /* @__PURE__ */ (0, J.jsx)("div", {
	className: "flexbox-col p-10 dc__gap-8 br-4 dc__border bg__primary w-100",
	children: e
}), eg = ({ isLoading: e, ...t }) => {
	if (e) return /* @__PURE__ */ (0, J.jsx)($h, { children: /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col dc__gap-4",
		children: [/* @__PURE__ */ (0, J.jsx)("div", { className: "shimmer-loading h-16 w-75" }), /* @__PURE__ */ (0, J.jsx)("div", { className: "shimmer-loading h-16 w-50" })]
	}) });
	let { pipelineType: n, sourceInfo: r, pipelineName: i } = t;
	return n === nt.CI ? /* @__PURE__ */ (0, J.jsx)("div", {
		className: "flexbox-col dc__gap-6 w-100",
		children: r.map((e) => {
			let { ciMaterialId: t, repositoryName: r, sourceValue: i, sourceType: a } = e;
			return /* @__PURE__ */ (0, J.jsx)($h, { children: /* @__PURE__ */ (0, J.jsx)(Qh, {
				repositoryName: r,
				sourceValue: i,
				sourceType: a,
				pipelineType: n
			}) }, t);
		})
	}) : /* @__PURE__ */ (0, J.jsx)($h, { children: /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox dc__gap-6 w-100",
		children: [Xh(n), /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col",
			children: [/* @__PURE__ */ (0, J.jsx)("h4", {
				className: "m-0 cn-9 fs-13 fw-4 lh-20 dc__align-left dc__truncate",
				children: Go(n)
			}), /* @__PURE__ */ (0, J.jsx)("p", {
				className: "m-0 dc__truncate cn-9 fs-12 fw-4 lh-18 dc__align-left",
				children: Ko(n, i)
			})]
		})]
	}) });
}, tg = ({ isLoading: e, ...t }) => {
	if (e) return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "py-10 px-16 flexbox-col dc__gap-4",
		children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox dc__align-items-center dc__gap-8",
			children: [/* @__PURE__ */ (0, J.jsx)(Uh, { className: "icon-dim-16 dc__no-shrink" }), /* @__PURE__ */ (0, J.jsx)("div", { className: "shimmer-loading h-16 w-100" })]
		}), /* @__PURE__ */ (0, J.jsx)(eg, { isLoading: !0 })]
	});
	let { workflow: n, handleWorkflowSelection: r, selectedWorkflowId: i } = t, { id: a, workflowName: o, pipelineType: s, sourceInfo: c, environments: l, pipelineName: u } = n, d = +a == +i, f = () => {
		r(a);
	}, p = () => /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col",
		children: [/* @__PURE__ */ (0, J.jsx)("h4", {
			className: "m-0 text__white fs-12 fw-6 lh-18 dc__ellipsis-right",
			children: Ro.RIGHT_PANEL_ENVIRONMENTS_HEADING
		}), l.map((e) => /* @__PURE__ */ (0, J.jsx)("p", {
			className: "m-0 text__white fs-12 fw-4 lh-18 dc__ellipsis-right",
			children: e.environmentName
		}, e.environmentId))]
	});
	return /* @__PURE__ */ (0, J.jsx)(lt, {
		condition: l.length > 0,
		wrap: (e) => /* @__PURE__ */ (0, J.jsx)(D, {
			content: p(),
			className: "default-tt w-200 mxh-210 dc__overflow-auto",
			interactive: !0,
			placement: "right",
			arrow: !1,
			children: e
		}),
		children: /* @__PURE__ */ (0, J.jsxs)("button", {
			className: `py-10 px-16 flexbox-col dc__gap-4 dc__tab-focus dc__outline-none-imp dc__no-border dc__select-text ${d ? "bg__secondary" : "bg__primary"}`,
			onClick: f,
			type: "button",
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox dc__align-items-center dc__gap-8",
				children: [/* @__PURE__ */ (0, J.jsx)(Uh, { className: "icon-dim-16 dc__no-shrink" }), /* @__PURE__ */ (0, J.jsx)("h4", {
					className: "m-0 cn-9 fs-12 fw-6 lh-20 dc__truncate",
					children: o
				})]
			}), /* @__PURE__ */ (0, J.jsx)(eg, {
				pipelineType: s,
				sourceInfo: c,
				pipelineName: u
			})]
		}, a)
	});
}, ng = ({ selectedApplicationName: e, handleApplicationSelection: t, selectedLabel: n, currentApplicationName: r, handleWorkflowSelection: i, registryType: a, selectedImage: o, selectedWorkflowId: s, workflowDetailsAsyncResponse: c, sourceReleaseConfiguration: l }) => {
	let { isLoadingWorkflows: u, workflowDetails: d, workflowError: f, reloadWorkflows: p } = c, m = e === r, h = n && !o;
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: `flexbox-col dc__border-top-n1 last-child__border-bottom-n1 ${m ? "releases__deployment-source-active-card-border" : ""}`,
		children: [/* @__PURE__ */ (0, J.jsxs)("button", {
			className: `flexbox dc__content-space pr-8 py-12 dc__tab-focus dc__outline-none-imp dc__no-border bg__primary dc__select-text ${m ? "pl-13" : "pl-16 dc__hover-n50"}`,
			type: "button",
			onClick: () => {
				t(r);
			},
			disabled: m,
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col dc__gap-4",
				children: [
					/* @__PURE__ */ (0, J.jsx)("h4", {
						className: `m-0 fs-13 fw-6 lh-16 dc__truncate dc__align-left ${m ? "cb-5" : "cn-9"}`,
						children: r
					}),
					h && /* @__PURE__ */ (0, J.jsx)("p", {
						className: "m-0 cr-5 dc__truncate fs-12 fw-4 lh-16",
						children: Yo(n)
					}),
					/* @__PURE__ */ (0, J.jsx)(wh, {
						selectedImage: o,
						registryType: a,
						releaseVersion: l?.releaseVersion,
						selectedImageClass: "fs-13 cn-7"
					})
				]
			}), h && /* @__PURE__ */ (0, J.jsx)(ce, { className: "icon-dim-16 dc__no-shrink form__icon--error" })]
		}), m && /* @__PURE__ */ (0, J.jsx)(Ie, {
			isLoading: u,
			customLoader: /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)(tg, { isLoading: !0 }), /* @__PURE__ */ (0, J.jsx)(tg, { isLoading: !0 })] }),
			error: f,
			genericSectionErrorProps: { reload: p },
			children: d?.length ? d.map((e) => /* @__PURE__ */ (0, J.jsx)(tg, {
				workflow: e,
				handleWorkflowSelection: i,
				selectedWorkflowId: s
			}, e.id)) : /* @__PURE__ */ (0, J.jsx)(Hh, {})
		})]
	});
}, rg = ({ selectedApplicationName: e, applicationDetailsMap: t, handleApplicationSelection: n, handleWorkflowSelection: r, handleLabelSelection: i, selectedLabel: a, workflowDetailsAsyncResponse: o }) => {
	let s = Object.keys(t), [c, l] = K(() => he(s), [JSON.stringify(s)], s.length > 0), u = (e) => {
		i(e.value);
	}, d = l?.map((e) => ({
		value: e,
		label: e,
		startIcon: /* @__PURE__ */ (0, J.jsx)(ae, { className: "icon-dim-16 mr-4 mw-18" })
	})) ?? [];
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col dc__mxw-234 w-100 h-100 flex-grow-1 dc__overflow-auto",
		children: [
			/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col dc__gap-6 px-16 pt-12",
				children: [/* @__PURE__ */ (0, J.jsx)("label", {
					htmlFor: Xo,
					className: "m-0 cn-9 fs-13 fw-4 lh-20",
					children: Ro.SELECT_LABEL.LABEL
				}), /* @__PURE__ */ (0, J.jsx)(jn, {
					inputId: Xo,
					value: a ? {
						value: a,
						label: a
					} : null,
					options: d,
					placeholder: Ro.SELECT_LABEL.PLACEHOLDER,
					isSearchable: !0,
					isLoading: c,
					onChange: u
				})]
			}),
			/* @__PURE__ */ (0, J.jsx)("div", {
				className: "py-12 px-16 flexbox dc__align-items-center dc__gap-8",
				children: /* @__PURE__ */ (0, J.jsx)("h3", {
					className: "m-0 cn-9 fs-13 fw-6 lh-20 dc__uppercase dc__ellipsis-right",
					children: Wo(s.length)
				})
			}),
			/* @__PURE__ */ (0, J.jsx)("div", {
				className: "flexbox-col h-100 dc__overflow-auto",
				children: s.map((i) => {
					let { selectedImage: s, registryType: c, sourceReleaseConfiguration: l } = t[i];
					return /* @__PURE__ */ (0, J.jsx)(ng, {
						selectedApplicationName: e,
						handleApplicationSelection: n,
						selectedLabel: a,
						currentApplicationName: i,
						handleWorkflowSelection: r,
						registryType: c,
						selectedImage: s,
						selectedWorkflowId: t[i].selectedWorkflowId,
						workflowDetailsAsyncResponse: o,
						sourceReleaseConfiguration: l
					}, i);
				})
			})
		]
	});
}, ig = ({ environments: e = [], workflowName: t }) => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "flexbox-col h-100 dc__mxw-250 w-100 p-16 dc__overflow-auto dc__border-left-n1 dc__gap-12",
	children: [/* @__PURE__ */ (0, J.jsx)("h3", {
		className: "m-0 cn-9 fs-13 fw-6 lh-20",
		children: Ro.RIGHT_PANEL_ENVIRONMENTS_HEADING
	}), e.length ? /* @__PURE__ */ (0, J.jsx)("div", {
		className: "flexbox-col",
		children: e.map((e) => /* @__PURE__ */ (0, J.jsx)("p", {
			className: "py-6 cn-9 fs-13 lh-20 dc__truncate m-0",
			children: e.environmentName
		}, e.environmentName))
	}) : /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "p-24 flex column dc__text-center fs-12 lh-20 cn-7 dc__gap-8",
		children: [/* @__PURE__ */ (0, J.jsx)(Oe, { className: "icon-dim-24 dc__no-shrink fcn-6" }), Jo(t)]
	})]
}), ag = ({ selectedApplicationName: e, handleApplicationSelection: t, applicationDetailsMap: n, handleWorkflowSelection: r, handleImageSelection: i, handleLabelSelection: a, selectedLabel: o }) => {
	let s = Pe(new AbortController()), [c, l, u, d] = K(() => rr(() => uu(e, s.current.signal), s), [e, !!n[e]], !!e && !!n[e]);
	O(() => {
		if (!c && l?.length > 0) {
			l.length === 1 && r(l[0].id);
			let t = n[e]?.artifactSourceAppWorkflowId;
			l.find((e) => t === +e.id) && r(t);
		}
	}, [c, JSON.stringify(l)]);
	let f = c || yr(u), p = k(() => ({
		isLoadingWorkflows: f,
		workflowDetails: l,
		workflowError: u,
		reloadWorkflows: d
	}), [
		c,
		l,
		u,
		d
	]);
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox dc__overflow-auto h-100",
		children: [/* @__PURE__ */ (0, J.jsx)(rg, {
			selectedApplicationName: e,
			applicationDetailsMap: n,
			handleApplicationSelection: t,
			handleWorkflowSelection: r,
			handleLabelSelection: a,
			selectedLabel: o,
			workflowDetailsAsyncResponse: p
		}), /* @__PURE__ */ (0, J.jsx)("div", {
			className: "flexbox bg__secondary w-100 h-100 dc__overflow-auto",
			children: (() => {
				if (!e || !n[e]?.selectedWorkflowId || p.isLoadingWorkflows) return /* @__PURE__ */ (0, J.jsx)(F, {
					title: Uo(n[e] ? e : null),
					SvgImage: Nh,
					imageType: en.Large,
					classname: "dc__align-center w-100"
				});
				if (u) return /* @__PURE__ */ (0, J.jsx)("div", {
					className: "h-100 w-100 flexbox-col flex-grow-1",
					children: /* @__PURE__ */ (0, J.jsx)(It, {
						code: u.code,
						reload: d
					})
				});
				let { selectedWorkflowId: t } = n[e], r = l?.find((e) => e.id === t), a = r?.environments || [];
				return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)(Vh, {
					handleImageSelection: i,
					selectedApplicationName: e,
					applicationDetailsMap: n
				}, `${t}-content`), /* @__PURE__ */ (0, J.jsx)(ig, {
					environments: a,
					workflowName: r?.workflowName
				}, `${t}-right-panel`)] });
			})()
		})]
	});
}, og = ({ originalReleaseOrdering: e, applicationDetailsMap: t, handleSuccess: n }) => {
	let { id: r } = Q(), i = k(() => Zh(e, t), [t, JSON.stringify(e)]), [a, o] = A(!1), s = qo(a, i);
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox dc__align-items-center dc__content-end dc__gap-12 pt-12 pb-12 pl-16 pr-16 bg__primary dc__border-top dc__no-shrink",
		children: [i && /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox dc__align-item-center dc__gap-6",
			children: [/* @__PURE__ */ (0, J.jsx)(jo, { className: "icon-dim-20 dc__no-shrink" }), /* @__PURE__ */ (0, J.jsx)("span", {
				className: "cn-9 fs-13 fw-4 lh-20",
				children: Ro.UNSAVED_CHANGES_INDICATOR
			})]
		}), /* @__PURE__ */ (0, J.jsx)(lt, {
			wrap: (e) => /* @__PURE__ */ (0, J.jsx)(D, {
				content: s,
				className: "default-tt",
				arrow: !1,
				children: /* @__PURE__ */ (0, J.jsx)("span", { children: e })
			}),
			condition: !!s,
			children: /* @__PURE__ */ (0, J.jsx)(et, {
				rootClassName: "flex cta h-32",
				isLoading: a,
				disabled: !!s,
				onClick: async () => {
					try {
						o(!0), await lu(r, e, t), await n(), B.showToast({
							variant: V.success,
							description: Ro.SUCCESS_SAVE_MESSAGE
						});
					} catch (e) {
						W(e), o(!1);
					}
				},
				children: Ro.IMAGE_CTA
			})
		})]
	});
}, sg = ({ releaseOrdering: e, handleSuccess: t }) => {
	let n = ki(), { appName: r } = Ai(), { id: i, name: a } = Q(), [o, s] = A(bc(e)), [c, l] = A(r), [u, d] = A(!1), [f, p] = A(""), m = () => {
		n("..");
	}, h = (e) => {
		l(e), s({
			...o,
			[c]: {
				...o[c],
				selectedWorkflowId: null
			}
		});
	}, g = (e) => {
		s({
			...o,
			[c]: {
				...o[c],
				selectedWorkflowId: e
			}
		});
	}, _ = async (e) => {
		if (!e) {
			p("");
			return;
		}
		p(e);
		try {
			d(!0);
			let { applicationsToArtifactsMap: t, appNameToIdMap: n } = await du({
				releaseId: i,
				applicationName: "*",
				searchInput: e,
				searchType: Gs.IMAGE_LABEL
			});
			s(Object.keys(t).reduce((e, r) => {
				let i = t[r]?.materials?.[0];
				return e[r] = {
					name: r,
					selectedImage: i?.imagePath ?? "",
					registryName: i?.registryName ?? "",
					registryType: i?.registryType || wn.OTHER,
					artifactId: i?.id ? +i.id : null,
					appId: n[r],
					artifactSourceAppWorkflowId: i?.appWorkflowId ?? null,
					sourceReleaseConfiguration: null,
					selectedWorkflowId: null,
					isRequired: null,
					isDeleted: null
				}, e;
			}, {}));
		} catch {
			p("");
		} finally {
			d(!1);
		}
	};
	return /* @__PURE__ */ (0, J.jsx)(Qn, {
		className: "",
		onEscape: m,
		close: m,
		children: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col dc__content-space w-1200",
			onClick: ei,
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col h-100 dc__content-space bg__primary dc__overflow-auto",
				children: [/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox dc__content-space dc__align-items-center dc__border-bottom-n1 pb-12 pt-12 pl-20 pr-20",
					children: [/* @__PURE__ */ (0, J.jsx)("h2", {
						className: "m-0 cn-9 fs-16 fw-6 lh-24 dc__ellipsis-right",
						children: Ho(a)
					}), /* @__PURE__ */ (0, J.jsx)("button", {
						className: "flex dc__transparent dc__outline-none-imp dc__no-border p-0 dc__tab-focus",
						type: "button",
						onClick: m,
						"aria-label": "close-deployment-source-modal",
						children: /* @__PURE__ */ (0, J.jsx)(Ee, { className: "icon-dim-24 dc__no-shrink fcn-6" })
					})]
				}), /* @__PURE__ */ (0, J.jsx)(Ie, {
					isLoading: u,
					progressingProps: { pageLoader: !0 },
					children: /* @__PURE__ */ (0, J.jsx)(ag, {
						selectedApplicationName: c,
						applicationDetailsMap: o,
						handleApplicationSelection: h,
						handleWorkflowSelection: g,
						handleImageSelection: ({ selectedImage: e, registryType: t, registryName: n, artifactId: r, sourceReleaseConfiguration: i, artifactSourceAppWorkflowId: a }) => {
							_(), s({
								...o,
								[c]: {
									...o[c],
									selectedImage: e,
									registryType: t,
									registryName: n,
									artifactId: r,
									sourceReleaseConfiguration: i,
									artifactSourceAppWorkflowId: a
								}
							});
						},
						handleLabelSelection: _,
						selectedLabel: f
					})
				})]
			}), /* @__PURE__ */ (0, J.jsx)(og, {
				originalReleaseOrdering: e,
				applicationDetailsMap: o,
				handleSuccess: async () => {
					await t(), m();
				}
			})]
		})
	});
}, cg = /* @__PURE__ */ function(e) {
	return e.manageApplication = "manageApplications", e.activeReleases = "activeReleases", e;
}({}), lg = ({ handleClose: e }) => {
	let { track: t } = Q(), n = `${window.__BASE_URL__}${q(I.RELEASES.TRACK_DETAIL, { trackName: t })}?tab=${cg.manageApplication}`;
	return /* @__PURE__ */ (0, J.jsx)(ut, {
		variant: dt.info,
		title: `No applications added to '${t}'`,
		subtitle: `Only applications added to '${t}' can be included in the release.`,
		buttonConfig: {
			secondaryButtonConfig: {
				onClick: e,
				text: "Cancel"
			},
			primaryButtonConfig: {
				onClick: hr(n),
				text: "Add applications",
				endIcon: /* @__PURE__ */ (0, J.jsx)(we, {})
			}
		},
		handleClose: e,
		children: /* @__PURE__ */ (0, J.jsxs)("span", {
			className: "fs-13 lh-20 cn-8",
			children: [
				"Please add applications to\xA0",
				/* @__PURE__ */ (0, J.jsx)("span", {
					className: "dc__word-break",
					children: t
				}),
				"\xA0first."
			]
		})
	});
}, ug = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M4 13.6667C4 12.1939 5.19391 11 6.66667 11H49.3333C50.8061 11 52 12.1939 52 13.6667V43C52 44.4728 50.8061 45.6667 49.3333 45.6667H6.66667C5.19391 45.6667 4 44.4728 4 43V13.6667Z",
			fill: "url(#paint0_linear_7740_40028)"
		}),
		/* @__PURE__ */ (0, J.jsx)("ellipse", {
			cx: 14.667,
			cy: 21.6666,
			rx: 4,
			ry: 4,
			fill: "#FCC817"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M16.667 22L9.66699 38H34.667L16.667 22Z",
			fill: "#81AEF2"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M28 26.6666L23 38H43.3333L28 26.6666Z",
			fill: "#A1C3FC"
		}),
		/* @__PURE__ */ (0, J.jsxs)("mask", {
			id: "path-5-outside-1_7740_40028",
			maskUnits: "userSpaceOnUse",
			x: 28.667,
			y: 1.33423,
			width: 27,
			height: 26,
			fill: "black",
			children: [
				/* @__PURE__ */ (0, J.jsx)("rect", {
					fill: "white",
					x: 28.667,
					y: 1.33423,
					width: 27,
					height: 26
				}),
				/* @__PURE__ */ (0, J.jsx)("path", { d: "M46.9652 11.066L52.8978 13.262C53.026 13.3087 53.1368 13.3937 53.215 13.5054C53.2933 13.6172 53.3353 13.7503 53.3354 13.8868C53.3355 14.0232 53.2936 14.1563 53.2154 14.2682C53.1373 14.38 53.0267 14.4651 52.8985 14.512L46.9678 16.7073L44.7518 24.1893C44.7112 24.3273 44.6269 24.4484 44.5117 24.5345C44.3966 24.6207 44.2566 24.6673 44.1128 24.6674C43.9689 24.6675 43.8289 24.621 43.7136 24.535C43.5984 24.4489 43.514 24.3279 43.4732 24.19L41.2572 16.708L35.3272 14.5126C35.1994 14.4654 35.0891 14.3802 35.0112 14.2684C34.9334 14.1566 34.8916 14.0236 34.8916 13.8873C34.8916 13.7511 34.9334 13.6181 35.0112 13.5063C35.0891 13.3945 35.1994 13.3092 35.3272 13.262L41.2605 11.066L43.4752 3.80532C43.517 3.66894 43.6015 3.54958 43.7162 3.46478C43.831 3.37999 43.9699 3.33423 44.1125 3.33423C44.2552 3.33423 44.3941 3.37999 44.5088 3.46478C44.6235 3.54958 44.708 3.66894 44.7498 3.80532L46.9652 11.066Z" }),
				/* @__PURE__ */ (0, J.jsx)("path", { d: "M38.0226 20.0254L39.5652 20.596C39.6935 20.6426 39.8042 20.7276 39.8825 20.8393C39.9608 20.9511 40.0028 21.0842 40.0028 21.2207C40.0028 21.3571 39.9608 21.4903 39.8825 21.602C39.8042 21.7138 39.6935 21.7987 39.5652 21.8453L38.0312 22.414L37.4266 24.8287C37.3905 24.9729 37.3073 25.1008 37.1902 25.1923C37.0731 25.2838 36.9288 25.3335 36.7802 25.3336C36.6316 25.3337 36.4872 25.2841 36.37 25.1927C36.2528 25.1014 36.1694 24.9735 36.1332 24.8293L35.5286 22.4147L33.9946 21.846C33.8668 21.7988 33.7565 21.7135 33.6786 21.6017C33.6007 21.4899 33.559 21.3569 33.559 21.2207C33.559 21.0844 33.6007 20.9514 33.6786 20.8396C33.7565 20.7278 33.8668 20.6426 33.9946 20.5954L35.5366 20.0247L36.1366 17.8247C36.1743 17.6829 36.2579 17.5576 36.3742 17.4683C36.4905 17.3789 36.6331 17.3305 36.7798 17.3306C36.9265 17.3307 37.0691 17.3792 37.1853 17.4687C37.3015 17.5582 37.385 17.6836 37.4226 17.8254L38.0226 20.0254Z" }),
				/* @__PURE__ */ (0, J.jsx)("path", { d: "M35.0972 5.57068L36.6732 6.15402C36.801 6.20125 36.9113 6.28651 36.9892 6.39831C37.0671 6.51011 37.1088 6.6431 37.1088 6.77935C37.1088 6.91561 37.0671 7.04859 36.9892 7.16039C36.9113 7.2722 36.801 7.35745 36.6732 7.40468L35.0966 7.98802L34.5132 9.56468C34.466 9.69249 34.3807 9.80275 34.2689 9.88063C34.1571 9.95851 34.0242 10.0003 33.8879 10.0003C33.7516 10.0003 33.6187 9.95851 33.5069 9.88063C33.3951 9.80275 33.3098 9.69249 33.2626 9.56468L32.6792 7.98802L31.1026 7.40468C30.9748 7.35745 30.8645 7.2722 30.7866 7.16039C30.7087 7.04859 30.667 6.91561 30.667 6.77935C30.667 6.6431 30.7087 6.51011 30.7866 6.39831C30.8645 6.28651 30.9748 6.20125 31.1026 6.15402L32.6792 5.57068L33.2626 3.99402C33.3095 3.86592 33.3947 3.75533 33.5065 3.6772C33.6183 3.59907 33.7515 3.55718 33.8879 3.55718C34.0243 3.55718 34.1575 3.59907 34.2693 3.6772C34.3811 3.75533 34.4663 3.86592 34.5132 3.99402L35.0972 5.57068Z" })
			]
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M46.9652 11.066L52.8978 13.262C53.026 13.3087 53.1368 13.3937 53.215 13.5054C53.2933 13.6172 53.3353 13.7503 53.3354 13.8868C53.3355 14.0232 53.2936 14.1563 53.2154 14.2682C53.1373 14.38 53.0267 14.4651 52.8985 14.512L46.9678 16.7073L44.7518 24.1893C44.7112 24.3273 44.6269 24.4484 44.5117 24.5345C44.3966 24.6207 44.2566 24.6673 44.1128 24.6674C43.9689 24.6675 43.8289 24.621 43.7136 24.535C43.5984 24.4489 43.514 24.3279 43.4732 24.19L41.2572 16.708L35.3272 14.5126C35.1994 14.4654 35.0891 14.3802 35.0112 14.2684C34.9334 14.1566 34.8916 14.0236 34.8916 13.8873C34.8916 13.7511 34.9334 13.6181 35.0112 13.5063C35.0891 13.3945 35.1994 13.3092 35.3272 13.262L41.2605 11.066L43.4752 3.80532C43.517 3.66894 43.6015 3.54958 43.7162 3.46478C43.831 3.37999 43.9699 3.33423 44.1125 3.33423C44.2552 3.33423 44.3941 3.37999 44.5088 3.46478C44.6235 3.54958 44.708 3.66894 44.7498 3.80532L46.9652 11.066Z",
			fill: "#FFAC33"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M38.0226 20.0254L39.5652 20.596C39.6935 20.6426 39.8042 20.7276 39.8825 20.8393C39.9608 20.9511 40.0028 21.0842 40.0028 21.2207C40.0028 21.3571 39.9608 21.4903 39.8825 21.602C39.8042 21.7138 39.6935 21.7987 39.5652 21.8453L38.0312 22.414L37.4266 24.8287C37.3905 24.9729 37.3073 25.1008 37.1902 25.1923C37.0731 25.2838 36.9288 25.3335 36.7802 25.3336C36.6316 25.3337 36.4872 25.2841 36.37 25.1927C36.2528 25.1014 36.1694 24.9735 36.1332 24.8293L35.5286 22.4147L33.9946 21.846C33.8668 21.7988 33.7565 21.7135 33.6786 21.6017C33.6007 21.4899 33.559 21.3569 33.559 21.2207C33.559 21.0844 33.6007 20.9514 33.6786 20.8396C33.7565 20.7278 33.8668 20.6426 33.9946 20.5954L35.5366 20.0247L36.1366 17.8247C36.1743 17.6829 36.2579 17.5576 36.3742 17.4683C36.4905 17.3789 36.6331 17.3305 36.7798 17.3306C36.9265 17.3307 37.0691 17.3792 37.1853 17.4687C37.3015 17.5582 37.385 17.6836 37.4226 17.8254L38.0226 20.0254Z",
			fill: "#FFAC33"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M35.0972 5.57068L36.6732 6.15402C36.801 6.20125 36.9113 6.28651 36.9892 6.39831C37.0671 6.51011 37.1088 6.6431 37.1088 6.77935C37.1088 6.91561 37.0671 7.04859 36.9892 7.16039C36.9113 7.2722 36.801 7.35745 36.6732 7.40468L35.0966 7.98802L34.5132 9.56468C34.466 9.69249 34.3807 9.80275 34.2689 9.88063C34.1571 9.95851 34.0242 10.0003 33.8879 10.0003C33.7516 10.0003 33.6187 9.95851 33.5069 9.88063C33.3951 9.80275 33.3098 9.69249 33.2626 9.56468L32.6792 7.98802L31.1026 7.40468C30.9748 7.35745 30.8645 7.2722 30.7866 7.16039C30.7087 7.04859 30.667 6.91561 30.667 6.77935C30.667 6.6431 30.7087 6.51011 30.7866 6.39831C30.8645 6.28651 30.9748 6.20125 31.1026 6.15402L32.6792 5.57068L33.2626 3.99402C33.3095 3.86592 33.3947 3.75533 33.5065 3.6772C33.6183 3.59907 33.7515 3.55718 33.8879 3.55718C34.0243 3.55718 34.1575 3.59907 34.2693 3.6772C34.3811 3.75533 34.4663 3.86592 34.5132 3.99402L35.0972 5.57068Z",
			fill: "#FFAC33"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M52.8978 13.262L52.2036 15.1376L52.2131 15.1411L52.8978 13.262ZM46.9652 11.066L45.0522 11.6496L45.3415 12.5976L46.2709 12.9416L46.9652 11.066ZM53.215 13.5054L54.8533 12.3582L54.8533 12.3582L53.215 13.5054ZM53.3354 13.8868L51.3354 13.8878V13.8878L53.3354 13.8868ZM53.2154 14.2682L51.576 13.1227L51.576 13.1227L53.2154 14.2682ZM52.8985 14.512L52.2117 12.6336L52.2042 12.6364L52.8985 14.512ZM46.9678 16.7073L46.2736 14.8317L45.3345 15.1793L45.0502 16.1394L46.9678 16.7073ZM44.7518 24.1893L42.8342 23.6213L42.8336 23.6235L44.7518 24.1893ZM44.5117 24.5345L45.7097 26.1361L45.7097 26.136L44.5117 24.5345ZM44.1128 24.6674L44.1138 26.6674L44.1128 24.6674ZM43.7136 24.535L44.91 22.9322L44.91 22.9322L43.7136 24.535ZM43.4732 24.19L45.3909 23.6222L45.3908 23.622L43.4732 24.19ZM41.2572 16.708L43.1748 16.14L42.8905 15.18L41.9515 14.8324L41.2572 16.708ZM35.3272 14.5126L36.0215 12.6371L36.0205 12.6367L35.3272 14.5126ZM35.0112 14.2684L36.6524 13.1252L36.6523 13.1252L35.0112 14.2684ZM35.0112 13.5063L36.6523 14.6494L36.6523 14.6494L35.0112 13.5063ZM35.3272 13.262L36.0205 15.138L36.0214 15.1376L35.3272 13.262ZM41.2605 11.066L41.9547 12.9416L42.8843 12.5976L43.1735 11.6495L41.2605 11.066ZM43.4752 3.80532L41.5632 3.21859L41.5622 3.22181L43.4752 3.80532ZM44.5088 3.46478L43.32 5.07312L43.32 5.07312L44.5088 3.46478ZM44.7498 3.80532L46.6628 3.22165L46.6618 3.21858L44.7498 3.80532ZM39.5652 20.596L38.8713 22.4718L38.8819 22.4757L39.5652 20.596ZM38.0226 20.0254L36.093 20.5516L36.3637 21.5442L37.3287 21.9011L38.0226 20.0254ZM39.8825 20.8393L41.5206 19.6919L41.5206 19.6919L39.8825 20.8393ZM39.8825 21.602L38.2444 20.4546L38.2444 20.4546L39.8825 21.602ZM39.5652 21.8453L38.8819 19.9657L38.87 19.9701L39.5652 21.8453ZM38.0312 22.414L37.336 20.5387L36.3473 20.9053L36.0911 21.9282L38.0312 22.414ZM37.4266 24.8287L35.4865 24.3429L35.4863 24.3435L37.4266 24.8287ZM37.1902 25.1923L38.4214 26.7685L38.4214 26.7685L37.1902 25.1923ZM36.7802 25.3336L36.7812 27.3336H36.7812L36.7802 25.3336ZM36.37 25.1927L37.5995 23.6153L37.5995 23.6153L36.37 25.1927ZM36.1332 24.8293L34.1931 25.3152L34.1935 25.3166L36.1332 24.8293ZM35.5286 22.4147L37.4687 21.9289L37.2125 20.9059L36.2238 20.5394L35.5286 22.4147ZM33.9946 21.846L34.6898 19.9707L34.6878 19.97L33.9946 21.846ZM33.6786 21.6017L32.0375 22.7448L32.0375 22.7448L33.6786 21.6017ZM33.6786 20.8396L32.0375 19.6965L32.0375 19.6965L33.6786 20.8396ZM33.9946 20.5954L34.6878 22.4714L34.6887 22.471L33.9946 20.5954ZM35.5366 20.0247L36.2307 21.9004L37.1954 21.5433L37.4661 20.5509L35.5366 20.0247ZM36.1366 17.8247L38.0661 18.3509L38.0692 18.3395L36.1366 17.8247ZM36.3742 17.4683L35.156 15.8822L35.1559 15.8822L36.3742 17.4683ZM36.7798 17.3306L36.7788 19.3306H36.7788L36.7798 17.3306ZM37.1853 17.4687L35.9654 19.0536L35.9654 19.0536L37.1853 17.4687ZM37.4226 17.8254L35.4894 18.3382L35.493 18.3516L37.4226 17.8254ZM36.6732 6.15402L35.979 8.02966L35.98 8.03002L36.6732 6.15402ZM35.0972 5.57068L33.2218 6.26536L33.541 7.12727L34.403 7.44633L35.0972 5.57068ZM36.9892 6.39831L38.6303 5.25519L38.6303 5.25519L36.9892 6.39831ZM36.9892 7.16039L38.6303 8.30352L38.6303 8.30351L36.9892 7.16039ZM36.6732 7.40468L35.98 5.52868L35.9793 5.52895L36.6732 7.40468ZM35.0966 7.98802L34.4026 6.11228L33.54 6.43143L33.2208 7.29403L35.0966 7.98802ZM34.5132 9.56468L32.6375 8.8707L32.6372 8.87141L34.5132 9.56468ZM33.2626 9.56468L35.1386 8.87141L35.1383 8.8707L33.2626 9.56468ZM32.6792 7.98802L34.555 7.29403L34.2358 6.43143L33.3732 6.11228L32.6792 7.98802ZM31.1026 7.40468L31.7966 5.52895L31.7958 5.52868L31.1026 7.40468ZM31.1026 6.15402L31.7958 8.03002L31.7966 8.02975L31.1026 6.15402ZM32.6792 5.57068L33.3732 7.44642L34.2358 7.12727L34.555 6.26467L32.6792 5.57068ZM33.2626 3.99402L35.1383 4.688L35.1404 4.68219L33.2626 3.99402ZM34.2693 3.6772L35.4147 2.03764L35.4147 2.03764L34.2693 3.6772ZM34.5132 3.99402L32.6353 4.68219L32.6378 4.6887L34.5132 3.99402ZM53.5921 11.3864L47.6595 9.19035L46.2709 12.9416L52.2036 15.1376L53.5921 11.3864ZM54.8533 12.3582C54.5397 11.9105 54.0961 11.57 53.5826 11.3829L52.2131 15.1411C51.9559 15.0474 51.7338 14.8769 51.5768 14.6527L54.8533 12.3582ZM55.3354 13.8857C55.3351 13.3391 55.1668 12.8059 54.8533 12.3582L51.5768 14.6527C51.4198 14.4285 51.3355 14.1615 51.3354 13.8878L55.3354 13.8857ZM54.8549 15.4137C55.1679 14.9657 55.3357 14.4322 55.3354 13.8857L51.3354 13.8878C51.3352 13.6142 51.4192 13.347 51.576 13.1227L54.8549 15.4137ZM53.5853 16.3904C54.0986 16.2027 54.5418 15.8618 54.8549 15.4137L51.576 13.1227C51.7328 12.8983 51.9547 12.7276 52.2117 12.6336L53.5853 16.3904ZM47.6621 18.5829L53.5928 16.3876L52.2042 12.6364L46.2736 14.8317L47.6621 18.5829ZM46.6695 24.7573L48.8855 17.2753L45.0502 16.1394L42.8342 23.6213L46.6695 24.7573ZM45.7097 26.136C46.1705 25.7914 46.5074 25.307 46.6701 24.7551L42.8336 23.6235C42.9149 23.3476 43.0834 23.1054 43.3137 22.9331L45.7097 26.136ZM44.1138 26.6674C44.6892 26.6671 45.249 26.4807 45.7097 26.1361L43.3138 22.933C43.5441 22.7607 43.824 22.6675 44.1117 22.6674L44.1138 26.6674ZM42.5173 26.1377C42.9784 26.4819 43.5385 26.6677 44.1138 26.6674L44.1117 22.6674C44.3994 22.6672 44.6794 22.7601 44.91 22.9322L42.5173 26.1377ZM41.5555 24.7578C41.7188 25.3095 42.0562 25.7936 42.5173 26.1377L44.91 22.9322C45.1405 23.1043 45.3092 23.3463 45.3909 23.6222L41.5555 24.7578ZM39.3395 17.276L41.5555 24.7579L45.3908 23.622L43.1748 16.14L39.3395 17.276ZM34.6328 16.3882L40.5628 18.5836L41.9515 14.8324L36.0215 12.6371L34.6328 16.3882ZM33.3701 15.4115C33.6816 15.8587 34.1227 16.1997 34.6339 16.3886L36.0205 12.6367C36.276 12.7311 36.4966 12.9016 36.6524 13.1252L33.3701 15.4115ZM32.8916 13.8873C32.8916 14.4323 33.0586 14.9643 33.3701 15.4115L36.6523 13.1252C36.8081 13.3488 36.8916 13.6148 36.8916 13.8873H32.8916ZM33.3701 12.3632C33.0586 12.8104 32.8916 13.3423 32.8916 13.8873H36.8916C36.8916 14.1598 36.8081 14.4258 36.6523 14.6494L33.3701 12.3632ZM34.6339 11.386C34.1227 11.5749 33.6816 11.9159 33.3701 12.3632L36.6523 14.6494C36.4966 14.873 36.2761 15.0435 36.0205 15.138L34.6339 11.386ZM40.5663 9.19033L34.633 11.3863L36.0214 15.1376L41.9547 12.9416L40.5663 9.19033ZM41.5622 3.22181L39.3475 10.4825L43.1735 11.6495L45.3882 4.38882L41.5622 3.22181ZM42.5274 1.85645C42.0686 2.19563 41.7306 2.67306 41.5632 3.21859L45.3872 4.39204C45.3035 4.66482 45.1345 4.90353 44.9051 5.07312L42.5274 1.85645ZM44.1125 1.33423C43.5419 1.33423 42.9863 1.51727 42.5274 1.85645L44.9051 5.07312C44.6756 5.24271 44.3978 5.33423 44.1125 5.33423V1.33423ZM45.6976 1.85645C45.2387 1.51727 44.6831 1.33423 44.1125 1.33423V5.33423C43.8272 5.33423 43.5494 5.24271 43.32 5.07312L45.6976 1.85645ZM46.6618 3.21858C46.4944 2.67307 46.1565 2.19564 45.6976 1.85645L43.32 5.07312C43.0905 4.90352 42.9215 4.6648 42.8378 4.39206L46.6618 3.21858ZM48.8781 10.4823L46.6628 3.22165L42.8369 4.38898L45.0522 11.6496L48.8781 10.4823ZM40.2591 18.7202L38.7165 18.1496L37.3287 21.9011L38.8713 22.4718L40.2591 18.7202ZM41.5206 19.6919C41.2068 19.2439 40.7627 18.9033 40.2486 18.7164L38.8819 22.4757C38.6243 22.382 38.4017 22.2113 38.2444 21.9868L41.5206 19.6919ZM42.0028 21.2207C42.0028 20.6737 41.8345 20.1399 41.5206 19.6919L38.2444 21.9868C38.0872 21.7623 38.0028 21.4948 38.0028 21.2207H42.0028ZM41.5206 22.7495C41.8345 22.3014 42.0028 21.7677 42.0028 21.2207H38.0028C38.0028 20.9466 38.0872 20.6791 38.2444 20.4546L41.5206 22.7495ZM40.2486 23.725C40.7627 23.5381 41.2068 23.1975 41.5206 22.7495L38.2444 20.4546C38.4017 20.23 38.6243 20.0594 38.8819 19.9657L40.2486 23.725ZM38.7264 24.2893L40.2604 23.7206L38.87 19.9701L37.336 20.5387L38.7264 24.2893ZM39.3667 25.3145L39.9713 22.8998L36.0911 21.9282L35.4865 24.3429L39.3667 25.3145ZM38.4214 26.7685C38.8898 26.4025 39.2226 25.8906 39.3668 25.3139L35.4863 24.3435C35.5584 24.0551 35.7248 23.7992 35.959 23.6162L38.4214 26.7685ZM36.7812 27.3336C37.3756 27.3333 37.9529 27.1344 38.4214 26.7685L35.959 23.6162C36.1933 23.4332 36.4819 23.3338 36.7791 23.3336L36.7812 27.3336ZM35.1404 26.7702C35.6092 27.1356 36.1867 27.3339 36.7812 27.3336L36.7791 23.3336C37.0764 23.3335 37.3651 23.4326 37.5995 23.6153L35.1404 26.7702ZM34.1935 25.3166C34.3383 25.8931 34.6716 26.4047 35.1404 26.7702L37.5995 23.6153C37.8339 23.7981 38.0006 24.0539 38.073 24.3421L34.1935 25.3166ZM33.5885 22.9005L34.1931 25.3152L38.0733 24.3435L37.4687 21.9289L33.5885 22.9005ZM33.2994 23.7213L34.8334 24.29L36.2238 20.5394L34.6898 19.9707L33.2994 23.7213ZM32.0375 22.7448C32.349 23.1921 32.7901 23.5331 33.3013 23.722L34.6878 19.97C34.9435 20.0645 35.164 20.235 35.3197 20.4586L32.0375 22.7448ZM31.559 21.2207C31.559 21.7657 31.726 22.2976 32.0375 22.7448L35.3197 20.4586C35.4755 20.6822 35.559 20.9482 35.559 21.2207H31.559ZM32.0375 19.6965C31.726 20.1437 31.559 20.6757 31.559 21.2207H35.559C35.559 21.4932 35.4755 21.7592 35.3197 21.9828L32.0375 19.6965ZM33.3013 18.7193C32.7901 18.9083 32.349 19.2493 32.0375 19.6965L35.3197 21.9828C35.164 22.2064 34.9435 22.3769 34.6878 22.4714L33.3013 18.7193ZM34.8424 18.149L33.3004 18.7197L34.6887 22.471L36.2307 21.9004L34.8424 18.149ZM34.207 17.2984L33.607 19.4984L37.4661 20.5509L38.0661 18.3509L34.207 17.2984ZM35.1559 15.8822C34.6899 16.2401 34.3552 16.742 34.204 17.3098L38.0692 18.3395C37.9934 18.6239 37.8258 18.8752 37.5925 19.0544L35.1559 15.8822ZM36.7809 15.3306C36.1932 15.3303 35.622 15.5242 35.156 15.8822L37.5925 19.0544C37.3591 19.2337 37.0731 19.3308 36.7788 19.3306L36.7809 15.3306ZM38.4052 15.8838C37.9396 15.5254 37.3685 15.3309 36.7809 15.3306L36.7788 19.3306C36.4845 19.3305 36.1986 19.2331 35.9654 19.0536L38.4052 15.8838ZM39.3557 17.3125C39.205 16.7445 38.8709 16.2423 38.4052 15.8838L35.9654 19.0536C35.7322 18.8741 35.5649 18.6226 35.4894 18.3382L39.3557 17.3125ZM39.9521 19.4991L39.3521 17.2991L35.493 18.3516L36.093 20.5516L39.9521 19.4991ZM37.3675 4.27838L35.7915 3.69504L34.403 7.44633L35.979 8.02966L37.3675 4.27838ZM38.6303 5.25519C38.3188 4.80797 37.8777 4.46694 37.3665 4.27802L35.98 8.03002C35.7244 7.93556 35.5038 7.76504 35.3481 7.54143L38.6303 5.25519ZM39.1088 6.77935C39.1088 6.23433 38.9418 5.70241 38.6303 5.25519L35.3481 7.54143C35.1923 7.31782 35.1088 7.05186 35.1088 6.77935H39.1088ZM38.6303 8.30351C38.9418 7.8563 39.1088 7.32437 39.1088 6.77935H35.1088C35.1088 6.50684 35.1923 6.24088 35.3481 6.01727L38.6303 8.30351ZM37.3665 9.28069C37.8777 9.09176 38.3188 8.75073 38.6303 8.30352L35.3481 6.01727C35.5038 5.79366 35.7244 5.62314 35.98 5.52868L37.3665 9.28069ZM35.7906 9.86375L37.3672 9.28042L35.9793 5.52895L34.4026 6.11228L35.7906 9.86375ZM36.389 10.2587L36.9723 8.682L33.2208 7.29403L32.6375 8.8707L36.389 10.2587ZM35.4121 11.5218C35.8593 11.2102 36.2003 10.7692 36.3892 10.258L32.6372 8.87141C32.7317 8.61579 32.9022 8.39526 33.1258 8.23951L35.4121 11.5218ZM33.8879 12.0003C34.4329 12.0003 34.9649 11.8333 35.4121 11.5218L33.1258 8.23951C33.3494 8.08376 33.6154 8.00026 33.8879 8.00026V12.0003ZM32.3637 11.5218C32.8109 11.8333 33.3429 12.0003 33.8879 12.0003V8.00026C34.1604 8.00026 34.4264 8.08376 34.65 8.23951L32.3637 11.5218ZM31.3866 10.258C31.5755 10.7692 31.9165 11.2102 32.3637 11.5218L34.65 8.23951C34.8736 8.39527 35.0441 8.6158 35.1386 8.87141L31.3866 10.258ZM30.8035 8.682L31.3868 10.2587L35.1383 8.8707L34.555 7.29403L30.8035 8.682ZM30.4086 9.28042L31.9853 9.86375L33.3732 6.11228L31.7966 5.52895L30.4086 9.28042ZM29.1455 8.30351C29.457 8.75073 29.8981 9.09176 30.4093 9.28068L31.7958 5.52868C32.0515 5.62315 32.272 5.79366 32.4277 6.01727L29.1455 8.30351ZM28.667 6.77935C28.667 7.32437 28.834 7.8563 29.1455 8.30351L32.4277 6.01727C32.5835 6.24088 32.667 6.50684 32.667 6.77935H28.667ZM29.1455 5.25519C28.834 5.70241 28.667 6.23433 28.667 6.77935H32.667C32.667 7.05186 32.5835 7.31782 32.4277 7.54143L29.1455 5.25519ZM30.4093 4.27802C29.8981 4.46694 29.457 4.80797 29.1455 5.25519L32.4277 7.54143C32.272 7.76504 32.0515 7.93556 31.7958 8.03002L30.4093 4.27802ZM31.9853 3.69495L30.4086 4.27828L31.7966 8.02975L33.3732 7.44642L31.9853 3.69495ZM31.3868 3.30004L30.8035 4.8767L34.555 6.26467L35.1383 4.688L31.3868 3.30004ZM32.3611 2.03764C31.9135 2.35039 31.5726 2.79308 31.3847 3.30585L35.1404 4.68219C35.0464 4.93876 34.8759 5.16027 34.6519 5.31677L32.3611 2.03764ZM33.8879 1.55718C33.3418 1.55718 32.8088 1.72489 32.3611 2.03764L34.6519 5.31677C34.4278 5.47326 34.1612 5.55718 33.8879 5.55718V1.55718ZM35.4147 2.03764C34.967 1.72489 34.434 1.55718 33.8879 1.55718V5.55718C33.6146 5.55718 33.348 5.47326 33.124 5.31677L35.4147 2.03764ZM36.3911 3.30585C36.2032 2.79308 35.8624 2.35039 35.4147 2.03764L33.124 5.31677C32.8999 5.16028 32.7294 4.93876 32.6354 4.68219L36.3911 3.30585ZM36.9727 4.876L36.3887 3.29934L32.6378 4.6887L33.2218 6.26536L36.9727 4.876Z",
			fill: "white",
			mask: "url(#path-5-outside-1_7740_40028)"
		}),
		/* @__PURE__ */ (0, J.jsx)("defs", { children: /* @__PURE__ */ (0, J.jsxs)("linearGradient", {
			id: "paint0_linear_7740_40028",
			x1: 4,
			y1: 28.6374,
			x2: 52,
			y2: 28.6373,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ (0, J.jsx)("stop", { stopColor: "#EDEDED" }), /* @__PURE__ */ (0, J.jsx)("stop", {
				offset: 1,
				stopColor: "#D6D7D8"
			})]
		}) })
	]
}), dg = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M27.9997 13.2L12.5215 21.913V38.6674C12.5215 39.0275 12.7151 39.3597 13.0283 39.5373L27.9997 48.025V13.2Z",
			fill: "#376CFB"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M28.0022 13.2L43.4805 21.913V38.6674C43.4805 39.0275 43.2869 39.3597 42.9736 39.5373L28.0022 48.025V13.2Z",
			fill: "#275ED8"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M22.9123 35.4244C23.3316 35.6576 23.8574 35.5602 24.1653 35.1922L28.0001 30.6088L12.5217 21.9132L8.80636 26.2002C8.39063 26.6799 8.52125 27.4205 9.076 27.729L22.9123 35.4244Z",
			fill: "#4294FF"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M33.3788 35.4287C32.9699 35.6608 32.4546 35.5767 32.1407 35.2266L28 30.6088L43.4783 21.9132L47.2007 26.2084C47.6141 26.6854 47.4876 27.4214 46.9386 27.733L33.3788 35.4287Z",
			fill: "#4294FF"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M22.7682 8.39901C23.1817 8.16673 23.7015 8.2568 24.0126 8.61467L28 13.2001L12.5217 21.9132L8.80284 17.6221C8.38826 17.1438 8.51684 16.4054 9.06874 16.0954L22.7682 8.39901Z",
			fill: "#4294FF"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M33.2318 8.39901C32.8183 8.16673 32.2985 8.2568 31.9874 8.61467L28 13.2001L43.4783 21.9132L47.1972 17.6221C47.6117 17.1438 47.4832 16.4054 46.9313 16.0954L33.2318 8.39901Z",
			fill: "#4294FF"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M40.0004 3.94696C38.0261 4.33966 36.2115 5.30492 34.7826 6.72188C34.4577 6.05663 33.7746 5.59838 32.9844 5.59838C31.8798 5.59838 30.9844 6.49381 30.9844 7.59838V11.3484C30.9844 12.4529 31.8798 13.3484 32.9844 13.3484H36.7344C37.8389 13.3484 38.7344 12.4529 38.7344 11.3484C38.7344 10.5583 38.2762 9.87521 37.6111 9.55029C38.4805 8.69275 39.5824 8.10846 40.7807 7.8701C40.8082 7.86463 40.8357 7.85934 40.8633 7.85425C40.3417 8.2152 40 8.8177 40 9.5V14C40 14.7145 40.3812 15.3748 41 15.7321L44.8971 17.9821C45.488 18.3232 46.1807 18.3286 46.754 18.0573C46.1155 18.8055 45.3069 19.3952 44.3918 19.7743C43.2498 20.2473 41.9931 20.3711 40.7807 20.1299C39.5683 19.8888 38.4547 19.2935 37.5806 18.4194C36.7996 17.6384 35.5332 17.6384 34.7522 18.4194C33.9711 19.2005 33.9711 20.4668 34.7522 21.2479C36.1857 22.6813 38.012 23.6576 40.0004 24.0531C41.9887 24.4486 44.0496 24.2456 45.9225 23.4698C47.7955 22.694 49.3963 21.3802 50.5226 19.6946C51.6489 18.009 52.25 16.0273 52.25 14C52.25 11.9727 51.6489 9.99101 50.5226 8.30541L49.7381 8.82957L50.5226 8.30541C49.3963 6.6198 47.7955 5.30604 45.9225 4.53024C44.0496 3.75444 41.9887 3.55146 40.0004 3.94696ZM36.8735 8.87348L37.5003 9.50029C37.5003 9.50029 37.5003 9.50029 37.5003 9.50029C37.5003 9.50029 37.5003 9.50029 37.5003 9.50029L36.8735 8.87348ZM44 9.5C44 8.8177 43.6584 8.21519 43.1368 7.85425C43.5649 7.93342 43.9856 8.0575 44.3918 8.22576C45.5338 8.69881 46.51 9.49988 47.1967 10.5277C47.8835 11.5555 48.25 12.7639 48.25 14C48.25 14.7153 48.1273 15.4213 47.8908 16.0884C47.839 15.4563 47.488 14.8591 46.8971 14.518L44 12.8453V9.5Z",
			fill: "#FFAC33",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
}), fg = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 14,
	viewBox: "0 0 16 14",
	fill: "none",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M10.8439 7C10.8439 8.57056 9.57068 9.84375 8.00012 9.84375C6.42956 9.84375 5.15637 8.57056 5.15637 7M10.8439 7C10.8439 5.42944 9.57068 4.15625 8.00012 4.15625C6.42956 4.15625 5.15637 5.42944 5.15637 7M10.8439 7H14.5626M5.15637 7H1.43762",
		stroke: "#3B444C",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pg = ({ shortHash: e, message: t, handleOpenArtifactInfoModal: n }) => e ? /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "releases__commit-info-card--shadow br-8 dc__info-card dc__info-card--no-hover bg__primary dc__backdrop-filter dc__overflow-hidden h-96 flexbox-col dc__content-space",
	children: [/* @__PURE__ */ (0, J.jsxs)("div", {
		className: "px-12 pt-12 pb-8 flexbox dc__gap-12 dc__border-bottom-n1 w-100 dc__border-bottom-n1",
		children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col w-100",
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox dc__gap-4",
				children: [/* @__PURE__ */ (0, J.jsx)("h4", {
					className: "m-0 cn-7 fs-12 fw-4 lh-20",
					children: "Commit"
				}), /* @__PURE__ */ (0, J.jsx)(D, {
					className: "default-tt w-200",
					arrow: !1,
					content: "Commit(s) selected to be deployed for this application",
					children: /* @__PURE__ */ (0, J.jsx)("span", {
						className: "flex",
						children: /* @__PURE__ */ (0, J.jsx)(i, { className: "icon-dim-14 dc__no-shrink fcn-5" })
					})
				})]
			}), /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox dc__gap-4 dc__align-items-center",
				children: [/* @__PURE__ */ (0, J.jsx)(fg, { className: "icon-dim-14 dc__no-shrink scn-6" }), /* @__PURE__ */ (0, J.jsx)("span", {
					className: "dc__truncate cn-9 fs-14 fw-4 lh-20 mono",
					children: e
				})]
			})]
		}), /* @__PURE__ */ (0, J.jsx)(Gh, { className: "icon-dim-24 dc__no-shrink" })]
	}), /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "px-12 py-8 flex dc__content-space dc__gap-4",
		children: [/* @__PURE__ */ (0, J.jsx)("p", {
			className: "m-0 cn-9 fs-12 fw-4 lh-18 dc__ellipsis-right",
			children: t || "-"
		}), /* @__PURE__ */ (0, J.jsx)("button", {
			className: "p-0 dc__no-border dc__outline-none-imp flex dc__no-shrink fs-12 fw-6 lh-18 anchor",
			type: "button",
			onClick: n,
			children: "Details"
		})]
	})]
}) : null, mg = ({ imagePath: e, registryType: t, sourceMessage: n, handleOpenDeploymentSourceModal: a, handleOpenArtifactInfoModal: o }) => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "w-200 br-8 dc__info-card dc__info-card--no-hover bg__primary dc__backdrop-filter dc__overflow-hidden h-96 flexbox-col dc__content-space",
	children: [/* @__PURE__ */ (0, J.jsxs)("div", {
		className: "px-12 pt-12 pb-8 flexbox dc__content-space dc__gap-12",
		children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col",
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox dc__align-items-center dc__gap-4",
				children: [/* @__PURE__ */ (0, J.jsx)("span", {
					className: "fs-12 lh-20 cn-7",
					children: "Image"
				}), /* @__PURE__ */ (0, J.jsx)(D, {
					className: "default-tt w-200",
					arrow: !1,
					content: "Image selected to be deployed for this application",
					children: /* @__PURE__ */ (0, J.jsx)("span", {
						className: "flex",
						children: /* @__PURE__ */ (0, J.jsx)(i, { className: "icon-dim-14 dc__no-shrink fcn-5" })
					})
				})]
			}), /* @__PURE__ */ (0, J.jsx)("div", {
				className: "fs-13 lh-20",
				children: e ? /* @__PURE__ */ (0, J.jsx)("span", {
					className: "dc__truncate cn-9 mono fs-14",
					children: e
				}) : /* @__PURE__ */ (0, J.jsx)("span", {
					className: "cn-7",
					children: "Not Selected"
				})
			})]
		}), /* @__PURE__ */ (0, J.jsx)("div", {
			className: "dc__no-shrink",
			children: e ? /* @__PURE__ */ (0, J.jsx)(Cn, {
				registryType: t,
				size: 24
			}) : /* @__PURE__ */ (0, J.jsx)(r, { className: "icon-dim-24" })
		})]
	}), /* @__PURE__ */ (0, J.jsx)("div", {
		className: "py-8 px-12 dc__border-top-n1 flex dc__content-space dc__gap-4",
		children: e ? /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)("span", {
			className: "cn-9 fs-12 lh-18 dc__truncate",
			children: n || "-"
		}), /* @__PURE__ */ (0, J.jsx)("button", {
			className: "p-0 dc__no-border dc__outline-none-imp flex dc__no-shrink fs-12 fw-6 lh-18 anchor",
			type: "button",
			onClick: o,
			children: "Details"
		})] }) : /* @__PURE__ */ (0, J.jsx)("button", {
			className: "p-0 dc__no-border dc__outline-none-imp flex dc__no-shrink fs-12 fw-6 lh-18 anchor",
			type: "button",
			onClick: a,
			children: "Select an image"
		})
	})]
}), hg = "not-subscribed-release-channel-block", gg = ({ tenantInstallationDetailsMap: e, installationsMappedToRelease: t }) => {
	let n = Object.values(t.installations || {}).reduce((e, t) => (e[t.identifier] = t, e), {});
	return Object.entries(e).reduce((e, [r, i]) => (e[r] = {
		...i,
		isSelected: i.tenantInstallationConfig.isReleaseTriggered || t.areAllInstallationsTargeted || !!n[r],
		isLoading: !1
	}, e), {});
}, _g = (e, t) => t ? hg : `release-channel-${e}`, vg = (e, t) => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "flexbox-col dc__gap-2 dc__overflow-auto",
	children: [
		/* @__PURE__ */ (0, J.jsx)("h6", {
			className: "m-0 fs-12 fw-6 lh-18 dc__word-break dc__align-left",
			children: t
		}),
		/* @__PURE__ */ (0, J.jsx)("p", {
			className: "m-0 fs-12 fw-4 lh-18 dc__align-left",
			children: "Environments"
		}),
		/* @__PURE__ */ (0, J.jsx)("ul", {
			className: "flexbox-col dc__gap-4 pt-4 pl-16 m-0",
			children: e.map((e) => /* @__PURE__ */ (0, J.jsx)("li", {
				className: "dc__word-break fs-12 fw-4 lh-18 dc__align-left",
				children: e
			}, e))
		})
	]
}), yg = ({ formState: e, handleToggleTenantInstallationSelection: t, hasRequestedUpdate: n, sortedTenantInstallations: r }) => r.map((r) => {
	let i = e[r], { isReleaseTriggered: a, image: o, displayText: s } = i.tenantInstallationConfig, c = Array.from(i.environments).sort(G);
	return {
		type: "item",
		id: `map-tenant-installation-${r}`,
		as: "div",
		title: s,
		customTooltipConfig: {
			alwaysShowTippyOnHover: !0,
			placement: "left",
			className: "mxh-250 dc__overflow-auto mr-42",
			interactive: !0,
			content: vg(c, s)
		},
		startIconConfig: { customIcon: /* @__PURE__ */ (0, J.jsx)(sf, { imageProps: {
			src: o,
			height: 20,
			width: 20,
			alt: s
		} }) },
		trailingItem: {
			type: "switch",
			config: {
				name: `map-tenant-installation-${r}`,
				ariaLabel: `Toggle tenant installation ${s}`,
				tooltipContent: a ? /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col dc__gap-2",
					children: [/* @__PURE__ */ (0, J.jsx)("h6", {
						className: "m-0 fs-12 fw-6 lh-18",
						children: "Not allowed"
					}), /* @__PURE__ */ (0, J.jsxs)("p", {
						className: "m-0 fs-12 fw-4 lh-18 dc__word-break",
						children: ["This release has already been rolled out to ", s]
					})]
				}) : null,
				isChecked: i.isSelected,
				isDisabled: a || n,
				isLoading: i.isLoading,
				onChange: () => {
					t({ installationIdentifier: r });
				}
			}
		}
	};
}), bg = ({ formState: e, handleToggleTenantInstallationSelection: t, tenantInstallationsNotSubscribedToReleaseChannel: n, releaseChannelToTenantInstallationMap: r, hasRequestedUpdate: i, releaseChannelId: a, isNotSubscribedBlock: o }) => {
	let s = o ? n : r[a].tenantDetails, c = Array.from(s).sort((t, n) => G(e[t]?.tenantInstallationConfig.displayText || "", e[n]?.tenantInstallationConfig.displayText || "")), l = o ? "Not subscribed Installations" : r[a].releaseChannelName, u = c.filter((t) => e[t]?.isSelected).length, d = c.every((t) => e[t]?.tenantInstallationConfig.isReleaseTriggered), f = c.some((t) => e[t].isLoading);
	return {
		type: "heading",
		id: _g(a, o),
		customTooltipConfig: o ? {
			alwaysShowTippyOnHover: !0,
			content: "Installations are not subscribed to any release channel"
		} : null,
		title: l,
		subtitle: `${u} of ${s.size} Tenant Installations selected`,
		trailingItem: {
			type: "switch",
			config: {
				name: `map-complete-release-channel-${a || "not-subscribed-block"}`,
				ariaLabel: `Toggle complete release channel ${l}`,
				tooltipContent: d ? /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col dc__gap-2",
					children: [/* @__PURE__ */ (0, J.jsx)("h6", {
						className: "m-0 fs-12 fw-6 lh-18",
						children: "Not allowed"
					}), /* @__PURE__ */ (0, J.jsx)("p", {
						className: "m-0 fs-12 fw-4 lh-18",
						children: "Release has already been rolled out for all tenant installations in this channel"
					})]
				}) : null,
				isChecked: u > 0,
				indeterminate: u !== s.size,
				onChange: () => {
					t({ channelSelectionDetails: o ? { isNotSubscribedBlock: !0 } : { channelId: a } });
				},
				isDisabled: d || i,
				isLoading: f
			}
		},
		items: yg({
			formState: e,
			handleToggleTenantInstallationSelection: t,
			hasRequestedUpdate: i,
			sortedTenantInstallations: c
		})
	};
}, xg = ({ releaseChannelToTenantInstallationMap: e, formState: t, handleToggleTenantInstallationSelection: n, hasRequestedUpdate: r, tenantInstallationsNotSubscribedToReleaseChannel: i }) => {
	let a = Object.keys(e).sort((t, n) => G(e[t].releaseChannelName, e[n].releaseChannelName));
	return /* @__PURE__ */ (0, J.jsx)(qn, {
		mode: "form",
		defaultExpandedMap: a.length === 1 && i.size === 0 ? { [_g(a[0], !1)]: !0 } : a.length === 0 && i.size > 0 ? { [_g("", !0)]: !0 } : {},
		nodes: (() => {
			let o = a.map((a) => bg({
				releaseChannelId: a,
				formState: t,
				handleToggleTenantInstallationSelection: n,
				tenantInstallationsNotSubscribedToReleaseChannel: i,
				releaseChannelToTenantInstallationMap: e,
				hasRequestedUpdate: r
			}));
			return i.size > 0 ? [...o, bg({
				isNotSubscribedBlock: !0,
				formState: t,
				handleToggleTenantInstallationSelection: n,
				tenantInstallationsNotSubscribedToReleaseChannel: i,
				releaseChannelToTenantInstallationMap: e,
				hasRequestedUpdate: r
			})] : o;
		})(),
		variant: "secondary"
	});
}, Sg = async ({ mapTenantInstallationFormState: e, releaseId: t }) => {
	try {
		let n = Object.keys(e).filter((t) => e[t].isSelected);
		return await Xl({
			id: t,
			query: [{
				op: hn.replace,
				path: "target",
				value: n
			}]
		}), !0;
	} catch (e) {
		return W(e), !1;
	}
}, Cg = ({ unmappedEnvironments: e }) => {
	let [t, n] = A(!1);
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "p-12",
		children: [/* @__PURE__ */ (0, J.jsx)(nn, {
			layout: "column",
			variant: "warning",
			heading: `${e.length} Unmapped Environments`,
			description: "Map these environments to a tenant installation to deploy this release",
			buttonProps: {
				dataTestId: "view-unmapped-environments",
				text: "View Unmapped Environments",
				onClick: () => {
					n(!0);
				},
				variant: N.text
			}
		}), t && /* @__PURE__ */ (0, J.jsx)(_f, {
			unmappedEnvironments: e,
			handleClose: () => {
				n(!1);
			}
		})]
	});
}, wg = ({ unmappedEnvironments: e, tenantInstallationDetailsMap: t, releaseChannelToTenantInstallationMap: n, tenantInstallationsNotSubscribedToReleaseChannel: r }) => {
	let { installationsMappedToRelease: i, track: a, version: o, areAllImagesSelected: s, refetchReleaseDetail: c, id: l } = Q(), [u, d] = A(gg({
		tenantInstallationDetailsMap: t,
		installationsMappedToRelease: i
	})), [f, p] = A(!1);
	O(() => {
		d(gg({
			tenantInstallationDetailsMap: t,
			installationsMappedToRelease: i
		}));
	}, [JSON.stringify(i), t]);
	let m = ai(async (e) => {
		if (p(!0), !await Sg({
			mapTenantInstallationFormState: e,
			releaseId: l
		})) {
			d(gg({
				tenantInstallationDetailsMap: t,
				installationsMappedToRelease: i
			})), p(!1);
			return;
		}
		await c(), p(!1);
	}, 1500), h = Object.keys(n).length + r.size > 0, g = q(I.RELEASES.DETAIL.ROLLOUT_RELEASE, {
		releaseTrack: a,
		releaseVersion: o
	});
	return /* @__PURE__ */ (0, J.jsxs)("aside", {
		className: "flexbox-col dc__content-space bg__secondary border__secondary--bottom w-300 dc__no-shrink dc__overflow-auto",
		"aria-labelledby": "map-target-tenant-installations-heading",
		children: [/* @__PURE__ */ (0, J.jsxs)("header", {
			className: "px-16 py-12 border__secondary--bottom flexbox dc__gap-8 dc__content-space dc__no-shrink dc__align-items-center",
			children: [/* @__PURE__ */ (0, J.jsx)("h4", {
				className: "m-0 cn-9 fs-13 fw-6 lh-20",
				id: "map-target-tenant-installations-heading",
				children: "Target Tenant Installations"
			}), /* @__PURE__ */ (0, J.jsx)(rn, {
				heading: "Target Tenant Installations",
				documentationLinkText: "What is Tenant Installation",
				documentationLink: "TENANT_INSTALLATION",
				additionalContent: /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col dc__gap-20 fs-13 fw-4 lh-20 p-12",
					children: [/* @__PURE__ */ (0, J.jsx)("p", {
						className: "m-0 cn-9",
						children: "Enable Tenant Installations on which this release will be deployed."
					}), /* @__PURE__ */ (0, J.jsxs)("p", {
						className: "m-0 cn-9",
						children: [
							"Only enabled Tenant Installations will be available in\xA0",
							/* @__PURE__ */ (0, J.jsx)(wi, {
								to: g,
								className: "anchor",
								children: "Rollout Release"
							}),
							"."
						]
					})]
				}),
				buttonPadding: "p-4",
				iconClassName: "icon-dim-16 dc__no-shrink"
			})]
		}), /* @__PURE__ */ (0, J.jsxs)("section", {
			className: "flexbox-col dc__content-space flex-grow-1 dc__overflow-auto",
			children: [h ? /* @__PURE__ */ (0, J.jsx)("div", {
				className: "flexbox-col flex-grow-1 dc__overflow-auto px-6 pt-6",
				children: /* @__PURE__ */ (0, J.jsx)(xg, {
					releaseChannelToTenantInstallationMap: n,
					formState: u,
					handleToggleTenantInstallationSelection: ({ installationIdentifier: e, channelSelectionDetails: t }) => {
						let i = structuredClone(u);
						if (e) i[e] = {
							...i[e],
							isSelected: !i[e].isSelected,
							isLoading: !0
						};
						else {
							let { channelId: e, isNotSubscribedBlock: a } = t, o = Array.from(a ? r : n[e].tenantDetails), s = o.every((e) => i[e].isSelected);
							Array.from(o).forEach((e) => {
								i[e] = {
									...i[e],
									isSelected: i[e].tenantInstallationConfig.isReleaseTriggered || !s,
									isLoading: !i[e].tenantInstallationConfig.isReleaseTriggered
								};
							});
						}
						d(i), m(i);
					},
					hasRequestedUpdate: f,
					tenantInstallationsNotSubscribedToReleaseChannel: r
				})
			}) : /* @__PURE__ */ (0, J.jsx)("div", {
				className: "flex p-12 flex-grow-1",
				children: /* @__PURE__ */ (0, J.jsx)(Kt, {
					title: e.length === 0 ? "No deployment pipelines exist in applications in this release" : "No environments are mapped to Tenant Installations",
					subTitle: e.length === 0 ? "Create deployment pipelines for applications in this release and map the corresponding environments to tenant installations" : "",
					description: "",
					useInfoIcon: !0
				})
			}), (e.length > 0 || s) && /* @__PURE__ */ (0, J.jsxs)("footer", {
				className: "flexbox-col",
				children: [e.length > 0 && /* @__PURE__ */ (0, J.jsx)(Cg, { unmappedEnvironments: e }), s && /* @__PURE__ */ (0, J.jsx)("div", {
					className: "p-12",
					children: /* @__PURE__ */ (0, J.jsx)(M, {
						dataTestId: "footer__cta--go-to-rollout-release",
						fullWidth: !0,
						component: Qe.link,
						text: "Go to rollout release",
						endIcon: /* @__PURE__ */ (0, J.jsx)(Yt, {
							name: "ic-arrow-right",
							color: null
						}),
						size: P.large,
						linkProps: { to: g }
					})
				})]
			})]
		})]
	});
}, Tg = ({ handleClose: e, selectedAppName: t, handleSuccess: n }) => {
	let [r, i] = A(!1), [a, o] = A(!1), [s, c] = A(!1), [l, u] = A(null), [d, f] = A(null), m = Pe(new AbortController()), { id: h, track: g } = Q(), { searchKey: _, handleSearch: v, clearFilters: y } = mi(), b = (e) => rr(() => du({
		releaseId: h,
		applicationName: t,
		workflowId: null,
		trackName: g,
		searchInput: _,
		searchType: Gs.RELEASE,
		signal: m.current.signal,
		offset: e ?? 0
	}), m), [x, S, C, w] = K(() => b(), [_, t]), { flatArtifactListForApp: T, shouldShowViewAllButton: ee } = k(() => {
		let e = (d?.materials ?? []).reduce((e, { configuredInReleases: t, ...n }) => (e.push(...t.map((e) => ({
			...n,
			releaseConfig: e
		}))), e), []), t = !s && e.length > 3;
		return {
			flatArtifactListForApp: t ? e.slice(0, 3) : e,
			shouldShowViewAllButton: t
		};
	}, [d, s]), E = !ee && d?.materials?.length < d?.totalCount, te = !!_;
	O(() => {
		!x && S && f(S.applicationsToArtifactsMap[t]);
	}, [x, S]);
	let ne = () => {
		c(!0);
	}, re = async () => {
		try {
			o(!0);
			let { applicationsToArtifactsMap: e } = await b(d?.materials?.length);
			f((n) => ({
				...e[t],
				materials: [...n.materials, ...e[t].materials]
			}));
		} catch {} finally {
			o(!1);
		}
	}, ie = async () => {
		try {
			i(!0), await cu({
				id: h,
				appName: t,
				...l
			}), n(), e(), B.showToast({
				variant: V.success,
				description: "Image updated successfully"
			});
		} catch (e) {
			W(e), i(!1);
		}
	}, ae = (e) => () => {
		u(e);
	};
	return /* @__PURE__ */ (0, J.jsx)($n, {
		className: "visible-modal__body",
		children: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: `flexbox-col ${x || C ? "dc__content-center" : "dc__content-space"} dc__overflow-hidden dc__m-auto mt-40 br-8 bg__primary w-450 mh-300 mxh-600`,
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col flex-grow-1 dc__overflow-auto",
				children: [/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flex dc__content-space px-20 py-12 dc__border-bottom",
					children: [/* @__PURE__ */ (0, J.jsx)("h2", {
						className: "m-0 fs-16 fw-6 lh-24 cn-9",
						children: "Select image from previous release"
					}), /* @__PURE__ */ (0, J.jsx)("button", {
						type: "button",
						className: "dc__transparent dc__no-shrink flexbox",
						"aria-label": "close-modal",
						onClick: e,
						children: /* @__PURE__ */ (0, J.jsx)(Ee, { className: "icon-dim-20 fcn-6" })
					})]
				}), /* @__PURE__ */ (0, J.jsx)(Ie, {
					isLoading: x,
					progressingProps: {
						pageLoader: !0,
						styles: { flexGrow: 1 }
					},
					error: C,
					genericSectionErrorProps: {
						rootClassName: "flex-grow-1",
						reload: w
					},
					children: T.length ? /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox-col flex-grow-1 dc__overflow-auto",
						children: [/* @__PURE__ */ (0, J.jsx)(On, {
							containerClassName: "px-20 py-12",
							initialSearchText: _,
							inputProps: { placeholder: `Search previous releases of '${t}'` },
							handleSearchChange: v,
							shouldDebounce: !0
						}), /* @__PURE__ */ (0, J.jsxs)("div", {
							className: "flexbox-col dc__overflow-auto flex-grow-1",
							children: [
								T.map(({ releaseConfig: e, ...t }) => {
									let n = l?.artifactId === +t.id && l?.sourceReleaseConfiguration?.id === e.id;
									return /* @__PURE__ */ (0, J.jsxs)("button", {
										type: "button",
										className: `flex top left dc__gap-8 w-100 dc__no-border px-20 py-8 ${n ? "bcb-1" : "dc__hover-n50 bg__primary"}`,
										onClick: ae({
											artifactId: +t.id,
											artifactSourceAppWorkflowId: t.appWorkflowId,
											registryName: t.registryName,
											registryType: t.registryType,
											sourceReleaseConfiguration: e
										}),
										children: [
											/* @__PURE__ */ (0, J.jsx)(id, { className: "dc__no-shrink icon-dim-20" }),
											/* @__PURE__ */ (0, J.jsxs)("div", {
												className: "flex column top left flex-grow-1",
												children: [/* @__PURE__ */ (0, J.jsx)("span", {
													className: "fs-13 fw-4 lh-20 cn-9 dc__truncate",
													children: e.name
												}), /* @__PURE__ */ (0, J.jsx)("span", {
													className: "fs-14 fw-4 lh-20 cn-7 mono dc__truncate",
													children: e.releaseVersion
												})]
											}),
											n && /* @__PURE__ */ (0, J.jsx)(p, { className: "dc__no-shrink scb-5 icon-dim-20 dc__align-self-center" })
										]
									}, `${e.id}-${t.id}`);
								}),
								a && /* @__PURE__ */ (0, J.jsx)(_n, {}),
								ee && /* @__PURE__ */ (0, J.jsxs)("button", {
									type: "button",
									className: "flex left dc__gap-8 w-100 dc__no-border px-20 py-12 dc__hover-n50 bg__primary",
									onClick: ne,
									children: [/* @__PURE__ */ (0, J.jsx)(No, { className: "dc__no-shrink icon-dim-20 icon-color-n6 dc__flip-90" }), /* @__PURE__ */ (0, J.jsx)("span", {
										className: "fs-13 fw-6 lh-20 cb-5",
										children: "View all releases"
									})]
								}),
								E && !a && /* @__PURE__ */ (0, J.jsx)(Et, { callback: re })
							]
						})]
					}) : /* @__PURE__ */ (0, J.jsx)(Kt, {
						title: te ? "No results" : `No previous releases of '${t}'`,
						useInfoIcon: !0,
						subTitle: te ? "We couldn’t find any matching results" : "",
						description: "",
						rootClassName: "flex-grow-1",
						...te && {
							reload: y,
							buttonText: "Clear Filters"
						}
					})
				})]
			}), !C && /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "px-20 py-16 flex dc__gap-12 dc__content-end",
				children: [/* @__PURE__ */ (0, J.jsx)("button", {
					type: "button",
					className: "cta cancel",
					disabled: x,
					onClick: e,
					children: "Cancel"
				}), /* @__PURE__ */ (0, J.jsx)(et, {
					type: "button",
					rootClassName: "cta",
					disabled: x || !l || r,
					onClick: ie,
					isLoading: r,
					children: "Use Image"
				})]
			})]
		})
	});
}, Eg = ({ appName: e, refetchReleaseOrdering: t, releaseOrderingResponse: n }) => {
	let [r, i] = A(null), [a, o] = A(!1), [s, c] = A(!1), { id: l, track: u } = Q(), d = ki(), { releaseTrack: f, releaseVersion: p } = Ai(), [m, h, g, _] = K(() => iu(l, e), [l, e], !!e, { resetOnChange: !1 }), y = () => {
		c((e) => !e);
	}, b = async () => {
		await t(), d(q(I.RELEASES.DETAIL.REQUIREMENTS, {
			releaseTrack: u,
			releaseVersion: p,
			appName: null
		}));
	}, x = () => {
		let e = `${q(I.RELEASES.TRACK_DETAIL, { trackName: u })}?tab=${cg.manageApplication}`;
		return /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flex column dc__gap-20",
			children: [/* @__PURE__ */ (0, J.jsxs)("button", {
				type: "button",
				className: "cta delete flex dc__gap-8 releases__remove-from-release-btn",
				onClick: y,
				children: [/* @__PURE__ */ (0, J.jsx)(T, { className: "icon-dim-16 dc__no-shrink scr-5 dc__no-svg-fill" }), "Remove from release"]
			}), /* @__PURE__ */ (0, J.jsxs)(wi, {
				to: e,
				target: "_blank",
				className: "anchor flex dc__gap-4 fs-13 fw-6 lh-20 cb-5",
				children: ["Remove from Release Track", /* @__PURE__ */ (0, J.jsx)(we, { className: "dc__no-shrink icon-dim-16 scb-5" })]
			})]
		});
	};
	if (!e) return /* @__PURE__ */ (0, J.jsx)(F, {
		title: "Please select an application",
		subTitle: "Select an application to configure the release requirements",
		classname: "flex-grow-1"
	});
	if (m && !h) return /* @__PURE__ */ (0, J.jsx)("div", {
		className: "flex flex-grow-1",
		children: /* @__PURE__ */ (0, J.jsx)(_n, { pageLoader: !0 })
	});
	if (g || h?.isDeleted) return h?.isDeleted ? /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)(F, {
		title: `'${e}' not found`,
		subTitle: `Application '${e}' is not found in the system`,
		classname: "flex-grow-1",
		image: Wi,
		isButtonAvailable: !0,
		renderButton: x
	}), s && /* @__PURE__ */ (0, J.jsx)(Th, {
		appName: e,
		handleClose: y,
		handleSuccess: b
	})] }) : g.code === Le.NOT_FOUND ? /* @__PURE__ */ (0, J.jsx)(F, {
		title: `'${e}' not found`,
		subTitle: `Application '${e}' is not available in the system`,
		classname: "flex-grow-1"
	}) : /* @__PURE__ */ (0, J.jsx)("div", {
		className: "flex flex-grow-1",
		children: /* @__PURE__ */ (0, J.jsx)(It, {
			code: g.code,
			redirectURL: I.RELEASES.ROOT,
			reload: _
		})
	});
	let { imageDetails: S, name: C, releaseInstructions: w, commitDetails: ee } = h, E = !!S?.image, te = () => {
		o((e) => !e);
	}, ne = async (t) => {
		try {
			await su({
				id: l,
				releaseInstructions: t,
				appName: e
			}), B.showToast({
				variant: V.success,
				description: Nc
			}), await _();
		} catch (e) {
			W(e);
		}
	}, re = () => {
		d(q(I.RELEASES.DETAIL.REQUIREMENTS_DEPLOYMENT_SOURCE, {
			releaseTrack: f,
			releaseVersion: p,
			appName: e
		}));
	}, ie = () => /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flex dc__gap-20",
		children: [/* @__PURE__ */ (0, J.jsxs)("button", {
			type: "button",
			className: "w-200 h-200 dc__border-dashed--n3 br-12 flex column dc__gap-12 p-24 dc__bg-transparent dc__hover-n0",
			onClick: re,
			children: [/* @__PURE__ */ (0, J.jsx)("div", {
				className: "p-4 h-56 w-56",
				children: /* @__PURE__ */ (0, J.jsx)(ug, { className: "h-100-imp w-100-imp" })
			}), /* @__PURE__ */ (0, J.jsx)("span", {
				className: "fs-13 fw-6 lh-20 cb-5",
				children: "Select a image"
			})]
		}), /* @__PURE__ */ (0, J.jsxs)("button", {
			type: "button",
			className: "w-200 h-200 dc__border-dashed--n3 br-12 flex column dc__gap-12 p-24 dc__bg-transparent dc__hover-n0",
			onClick: te,
			children: [/* @__PURE__ */ (0, J.jsx)("div", {
				className: "p-4 h-56 w-56",
				children: /* @__PURE__ */ (0, J.jsx)(dg, { className: "h-100-imp w-100-imp" })
			}), /* @__PURE__ */ (0, J.jsx)("span", {
				className: "fs-13 fw-6 lh-20 cb-5",
				children: "Select from previous release version"
			})]
		})]
	}), ae = () => {
		i(null);
	}, oe = () => {
		i({ ciArtifactId: S?.artifactId });
	}, se = ee?.some((e) => e.shortHash) || !1;
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox flex-grow-1 w-100",
		children: [
			/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "w-100 flexbox-col h-100 border__primary--right",
				children: [/* @__PURE__ */ (0, J.jsx)("div", {
					className: "flexbox dc__content-space border__secondary--bottom px-16 py-12 dc__no-shrink",
					children: /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flex dc__content-start dc__gap-8",
						children: [/* @__PURE__ */ (0, J.jsx)(me, { className: "icon-dim-24 dc__no-shrink" }), /* @__PURE__ */ (0, J.jsx)("h3", {
							className: "m-0 fs-13 lh-20 fw-6 cn-9 dc__truncate",
							children: C
						})]
					})
				}), E ? /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "px-16 py-12 flexbox-col flex-grow-1 dc__gap-12 dc__overflow-auto",
					children: [/* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox dc__gap-8",
						children: [se && /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)("div", {
							className: "flexbox releases__commit-info-card",
							children: ee.map((e, t) => /* @__PURE__ */ (0, J.jsx)(pg, {
								shortHash: e.shortHash,
								message: e.message,
								handleOpenArtifactInfoModal: oe
							}, t))
						}), /* @__PURE__ */ (0, J.jsxs)("div", {
							className: "flex column dc__gap-6",
							children: [
								/* @__PURE__ */ (0, J.jsx)("div", { className: "h-20 dc__border-dashed--n3-right" }),
								/* @__PURE__ */ (0, J.jsx)(we, { className: "icon-dim-16 dc__no-shrink scn-6" }),
								/* @__PURE__ */ (0, J.jsx)("div", { className: "h-20 dc__border-dashed--n3-right" })
							]
						})] }), /* @__PURE__ */ (0, J.jsxs)("div", {
							className: "flexbox dc__gap-12",
							children: [/* @__PURE__ */ (0, J.jsx)(mg, {
								...S,
								handleOpenDeploymentSourceModal: re,
								handleOpenArtifactInfoModal: oe
							}), /* @__PURE__ */ (0, J.jsx)(D, {
								content: "Change image",
								className: "default-tt",
								arrow: !1,
								placement: "right",
								children: /* @__PURE__ */ (0, J.jsx)("button", {
									className: "flex h-100 px-8 br-8 bg__primary dc__tab-focus dc__info-card dc__hover-border-b5 dc__no-shrink",
									type: "button",
									"aria-label": "open-deployment-source-modal",
									onClick: re,
									children: /* @__PURE__ */ (0, J.jsx)(v, { className: "icon-dim-20 dc__no-shrink" })
								})
							})]
						})]
					}), /* @__PURE__ */ (0, J.jsx)(Wt, {
						text: w || hh,
						title: "Instructions",
						updateDescription: ne
					})]
				}) : /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)(F, {
					title: `Select an image for ${e}`,
					subTitle: "Select an image to be included in this release",
					isButtonAvailable: !0,
					renderButton: ie,
					classname: "flex-grow-1",
					noImage: !0
				}), a && /* @__PURE__ */ (0, J.jsx)(Tg, {
					handleClose: te,
					selectedAppName: e,
					handleSuccess: t
				})] })]
			}),
			/* @__PURE__ */ (0, J.jsx)(wg, {
				unmappedEnvironments: n.unmappedEnvironments,
				tenantInstallationDetailsMap: n.tenantInstallationDetailsMap,
				releaseChannelToTenantInstallationMap: n.releaseChannelToTenantInstallationMap,
				tenantInstallationsNotSubscribedToReleaseChannel: n.tenantInstallationsNotSubscribedToReleaseChannel
			}),
			r && /* @__PURE__ */ (0, J.jsx)(Ge, {
				...r,
				handleClose: ae,
				renderCIListHeader: ld,
				fetchOnlyArtifactInfo: !0
			})
		]
	});
}, Dg = () => {
	let { id: e, name: t, trackId: n, refetchReleaseDetail: r } = Q(), { appName: i, releaseTrack: a, releaseVersion: s } = Ai(), [c, l, u, d] = K(() => Promise.all([nu(e, L.release), Mu(e)]), [e]), f = ki(), [p, m] = A(!1), [h, g] = A(!1), _ = l?.[0] ?? {}, v = l?.[1] ?? [];
	O(() => {
		l && _?.releaseOrdering?.length && !i && f(q(I.RELEASES.DETAIL.REQUIREMENTS, {
			releaseTrack: a,
			releaseVersion: s,
			appName: _.releaseOrdering[0].applications?.[0]?.name
		}), { replace: !0 });
	}, [l, i]);
	let y = () => {
		m(!0);
	}, b = () => {
		m(!1);
	}, x = () => {
		g(!1);
	}, { releaseOrdering: S, applicationCount: C } = _ ?? {
		releaseOrdering: [],
		applicationCount: 0
	}, w = () => {
		if (_.isDepsPresentOnParent) {
			y();
			return;
		}
		g(!0);
	}, T = async () => {
		await r(), d();
	};
	return /* @__PURE__ */ (0, J.jsx)(Ie, {
		isLoading: c,
		customLoader: /* @__PURE__ */ (0, J.jsx)("div", {
			className: "flex flex-grow-1",
			children: /* @__PURE__ */ (0, J.jsx)(Dt, {})
		}),
		error: u,
		errorScreenManagerProps: {
			code: u?.code,
			reload: d,
			redirectURL: I.RELEASES.ROOT
		},
		children: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox bg__primary flex-grow-1 h-100 dc__overflow-hidden",
			children: [
				!C || !S.length ? /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)(F, {
					title: "Add Applications to this release",
					subTitle: "Applications are missing from your release! Add them now to kickstart your deployment.",
					isButtonAvailable: !0,
					renderButton: () => /* @__PURE__ */ (0, J.jsxs)("button", {
						className: "cta flex dc__gap-8",
						type: "button",
						onClick: w,
						children: [/* @__PURE__ */ (0, J.jsx)(o, { className: "icon-dim-16 dc__no-shrink" }), /* @__PURE__ */ (0, J.jsx)("span", { children: "Add Application" })]
					}),
					image: Ui,
					classname: "w-100"
				}), h && /* @__PURE__ */ (0, J.jsx)(lg, { handleClose: x })] }) : /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox flex-grow-1",
					children: [/* @__PURE__ */ (0, J.jsx)(Mh, {
						appName: i,
						applicationCount: C,
						releaseOrdering: S,
						handleShowManageReleaseModal: y,
						reload: d,
						changesForReview: v
					}), /* @__PURE__ */ (0, J.jsx)(Eg, {
						appName: i,
						refetchReleaseOrdering: d,
						releaseOrderingResponse: _
					}, i)]
				}),
				p && /* @__PURE__ */ (0, J.jsx)(hs, {
					handleCloseManageReleaseModal: b,
					handleSuccess: T,
					parentResourceKind: L.release,
					resourceName: t,
					resourceId: e,
					trackId: n
				}),
				/* @__PURE__ */ (0, J.jsx)(Di, { children: /* @__PURE__ */ (0, J.jsx)(Ei, {
					path: j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.DETAIL.REQUIREMENTS.DEPLOYMENT_SOURCE,
					element: /* @__PURE__ */ (0, J.jsx)(sg, {
						releaseOrdering: S,
						handleSuccess: T
					})
				}) })
			]
		})
	});
}, Og = () => {
	let { releaseTrack: e, releaseVersion: t } = Ai(), [n, r] = A(!0), [i, a, o, s] = K(() => ql({
		releaseTrack: e,
		releaseVersion: t
	}), [e, t], !0, { resetOnChange: !1 }), c = k(() => ({
		...a,
		refetchReleaseDetail: s
	}), [a]);
	return /* @__PURE__ */ (0, J.jsx)(Ie, {
		isLoading: i && !a,
		customLoader: /* @__PURE__ */ (0, J.jsx)("div", {
			className: "flex h-100 w-100",
			children: /* @__PURE__ */ (0, J.jsx)(Dt, {})
		}),
		error: o,
		errorScreenManagerProps: {
			code: o?.code,
			reload: s,
			redirectURL: I.RELEASES.ROOT
		},
		children: /* @__PURE__ */ (0, J.jsx)(Fu, {
			value: c,
			children: /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col h-100 dc__overflow-hidden",
				children: [/* @__PURE__ */ (0, J.jsx)(Zp, {}), /* @__PURE__ */ (0, J.jsxs)(Di, { children: [
					/* @__PURE__ */ (0, J.jsx)(Ei, {
						path: j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.DETAIL.OVERVIEW,
						element: /* @__PURE__ */ (0, J.jsx)(xh, {})
					}),
					/* @__PURE__ */ (0, J.jsx)(Ei, {
						path: `${j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.DETAIL.REQUIREMENTS.ROOT}/*`,
						element: /* @__PURE__ */ (0, J.jsx)(Dg, {})
					}),
					/* @__PURE__ */ (0, J.jsx)(Ei, {
						path: j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.DETAIL.ROLLOUT_RELEASE,
						element: /* @__PURE__ */ (0, J.jsx)(Lp, {})
					}),
					/* @__PURE__ */ (0, J.jsx)(Ei, {
						path: `${j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.DETAIL.HISTORY}/*`,
						element: /* @__PURE__ */ (0, J.jsx)(_d, {
							showCurrentReleaseDeployments: n,
							setShowCurrentReleaseDeployments: r
						})
					}),
					/* @__PURE__ */ (0, J.jsx)(Ei, {
						path: `${j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.DETAIL.CONFIGURATIONS}/*`,
						element: /* @__PURE__ */ (0, J.jsx)(zu, {})
					}),
					/* @__PURE__ */ (0, J.jsx)(Ei, {
						path: "*",
						element: /* @__PURE__ */ (0, J.jsx)(Ti, {
							to: (() => {
								switch (a?.status) {
									case Z.READY_FOR_RELEASE:
									case Js.PARTIALLY_RELEASED:
									case Js.COMPLETELY_RELEASED: return `${j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.DETAIL.ROLLOUT_RELEASE}?tab=${Fd(a.status)}`;
									default: return j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.DETAIL.REQUIREMENTS.ROOT.split("/")[0];
								}
							})(),
							replace: !0
						})
					})
				] })]
			})
		})
	});
}, kg = () => {
	let { releaseTrack: e, releaseVersion: t } = Ai();
	return /* @__PURE__ */ (0, J.jsx)(Og, {}, `${e}-${t}`);
}, Ag = (e) => e ? e.map((e) => {
	let t = e?.overview?.releaseChannelId, n = e?.name ?? "", r = (e?.mappingConfig ?? []).map((e) => Os({
		...e,
		releaseChannelId: t,
		releaseChannelName: n
	}));
	return {
		channelId: t,
		description: e?.overview?.description ?? "",
		name: n,
		subscribedInstallations: r,
		subscribedInstallationsCount: r.length,
		isDefault: e?.overview.isDefault ?? !1
	};
}) : [], jg = async ({ lite: e = !0 } = {}) => {
	try {
		let { result: t } = await H(Tr({
			baseUrl: _.RESOURCE_LIST,
			kind: L.releaseChannel,
			version: R.alpha1,
			queryParams: { lite: e }
		}));
		return Ag(t?.data);
	} catch (e) {
		throw W(e), e;
	}
}, Mg = (e) => ti(Tr({
	baseUrl: _.RESOURCE,
	kind: L.releaseChannel,
	version: R.alpha1,
	queryParams: { identifier: e }
})), Ng = ({ name: e, channelId: t, isDefault: n, description: r }) => Wr(Tr({
	baseUrl: _.RESOURCE,
	kind: L.releaseChannel,
	version: R.alpha1
}), {
	identifier: t,
	query: [
		{
			op: hn.replace,
			path: "name",
			value: e
		},
		{
			op: hn.replace,
			path: "description",
			value: r
		},
		{
			op: hn.replace,
			path: "isDefault",
			value: n
		}
	]
}), Pg = ({ name: e, channelId: t, isDefault: n, description: r }) => Gr(Tr({
	baseUrl: _.RESOURCE,
	kind: L.releaseChannel,
	version: R.alpha1
}), {
	name: e,
	overview: {
		isDefault: n,
		description: r,
		releaseChannelId: t
	}
}), Fg = /* @__PURE__ */ function(e) {
	return e.tenantInstallation = "tenantInstallation", e;
}({}), Ig = Array.from([
	,
	,
	,
].keys()).map((e) => ({
	tenantConfig: ks(e),
	lastTriggeredRelease: {
		version: `${e}.${e}.${e}`,
		name: `release-${e}`,
		deployStatus: Y.PROGRESSING,
		triggerTime: ""
	},
	apps: Array.from([
		,
		,
		,
		,
		,
	].keys()).map((t) => ({
		appId: t,
		envId: t,
		appName: `app-${t}`,
		envName: `env-${t}`,
		lastTriggeredRelease: {
			version: `${e}.${e}.${e}`,
			name: `release-${e}`,
			deployStatus: Y.PROGRESSING,
			triggerTime: ""
		},
		pipelineId: t,
		cdWorkflowRunnerId: t
	}))
})), Lg = /* @__PURE__ */ function(e) {
	return e.application = "application", e.lastTriggeredRelease = "lastTriggeredRelease", e.deploymentStatus = "deploymentStatus", e.triggerTime = "triggerTime", e;
}({}), Rg = ({ appliedReleaseChannelIds: e, handleApplyFilter: t, releaseChannelList: n, isReleaseChannelLoading: r }) => {
	let i = [{ ...Wu }, ...(n ?? []).map(({ name: e, channelId: t }) => ({
		label: e,
		value: t
	}))];
	return /* @__PURE__ */ (0, J.jsx)(Ht, {
		inputId: "release-channel-filter",
		placeholder: "Release Channel",
		appliedFilterOptions: i.filter((t) => e.includes(t.value)),
		handleApplyFilter: t,
		isDisabled: r,
		isLoading: r,
		options: i
	});
}, zg = (e) => Gu[e] ?? null, Bg = ({ isLoading: e, handleSearchEnter: t, searchKey: n, versionOptions: r, appliedVersions: i, appliedReleaseChannelIds: a, filterConfig: { clearFilters: o, updateSearchParams: s }, refetchTrackSummaryAndChannelList: c, releaseChannelList: l, isReleaseChannelLoading: u, getFormattedFilterValue: d }) => /* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
	className: "flex dc__content-space dc__gap-8 px-16 pt-16 pb-6",
	children: [/* @__PURE__ */ (0, J.jsx)(On, {
		inputProps: {
			placeholder: "Search tenant",
			disabled: e
		},
		handleEnter: t,
		initialSearchText: n,
		containerClassName: "w-250"
	}), /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flex dc__gap-8",
		children: [
			/* @__PURE__ */ (0, J.jsx)(D, {
				className: "default-tt",
				arrow: !1,
				placement: "top",
				content: "Refresh active releases",
				children: /* @__PURE__ */ (0, J.jsx)("button", {
					className: `dc__transparent br-4 flex ${e ? "dc__disabled" : "dc__hover-n50 dc__tab-focus"}`,
					type: "button",
					"aria-label": "Refresh active releases & release channels",
					onClick: c,
					disabled: e,
					children: e ? /* @__PURE__ */ (0, J.jsx)(_n, { size: 16 }) : /* @__PURE__ */ (0, J.jsx)(ge, { className: "dc__no-shrink scn-6 icon-dim-16" })
				})
			}),
			/* @__PURE__ */ (0, J.jsx)(Rg, {
				appliedReleaseChannelIds: a,
				handleApplyFilter: (e) => {
					s({ releaseChannelId: e.map((e) => e.value) });
				},
				releaseChannelList: l,
				isReleaseChannelLoading: u
			}),
			/* @__PURE__ */ (0, J.jsx)(Ht, {
				inputId: "release-version-filter",
				placeholder: "Release version",
				appliedFilterOptions: i.map((e) => ({
					label: e,
					value: e
				})),
				handleApplyFilter: (e) => {
					s({ version: e.map((e) => e.value) });
				},
				isDisabled: e,
				isLoading: e,
				options: r,
				shouldMenuAlignRight: !0
			})
		]
	})]
}), /* @__PURE__ */ (0, J.jsx)(Bt, {
	clearFilters: o,
	filterConfig: {
		version: i,
		releaseChannelId: a
	},
	onRemoveFilter: (e) => {
		s(e);
	},
	getFormattedLabel: zg,
	getFormattedValue: d,
	className: "px-16"
})] }), Vg = ({ version: e, className: t }) => {
	let { name: n } = vs(), r = q(I.RELEASES.DETAIL.OVERVIEW, {
		releaseTrack: n,
		releaseVersion: e
	});
	return e ? /* @__PURE__ */ (0, J.jsxs)(wi, {
		to: r,
		target: "_blank",
		className: `flex dc__gap-6 dc__transparent px-6 br-4 ${t} dc__no-decor cursor dc__w-fit-content`,
		children: [/* @__PURE__ */ (0, J.jsx)(id, { className: "icon-dim-14 dc__no-shrink" }), /* @__PURE__ */ (0, J.jsx)("span", {
			className: "dc__truncate cn-7 fs-14 fw-4 lh-20 mono",
			children: e
		})]
	}) : /* @__PURE__ */ (0, J.jsx)("span", { children: "-" });
}, Hg = ({ appName: e, appId: t, envId: n, envName: r, pipelineId: i, cdWorkflowRunnerId: a, lastTriggeredRelease: o }) => {
	let { name: s } = vs(), c = Nf(o.deployStatus, {
		appId: t,
		envId: n,
		pipelineId: i,
		releaseTrack: s,
		releaseVersion: o.version,
		triggerId: a
	});
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "display-grid dc__align-items-center dc__column-gap-16 releases__active-releases-apps-table fs-12 lh-20 cn-7 dc__border-bottom-n1 last-child__no-border px-16",
		children: [/* @__PURE__ */ (0, J.jsx)("div", { children: /* @__PURE__ */ (0, J.jsx)(lt, {
			condition: !!c,
			wrap: (e) => /* @__PURE__ */ (0, J.jsx)(wi, {
				to: c,
				target: "_blank",
				className: "anchor dc__w-fit-content dc__truncate",
				children: e
			}),
			children: /* @__PURE__ */ (0, J.jsx)(D, {
				content: /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox dc__gap-4",
					children: [/* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox-col dc__align-items-center p-6",
						children: [
							/* @__PURE__ */ (0, J.jsx)("div", { className: "w-8 h-8 dc__border-radius-50-per bw-1 en-0" }),
							/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__divider bcn-6" }),
							/* @__PURE__ */ (0, J.jsx)("div", { className: "w-8 h-8 dc__border-radius-50-per bg__primary" })
						]
					}), /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox-col dc__gap-4",
						children: [/* @__PURE__ */ (0, J.jsx)("p", {
							className: "m-0 cn-0 fs-12 fw-6 lh-20 dc__truncate",
							children: e
						}), /* @__PURE__ */ (0, J.jsx)("p", {
							className: "m-0 cn-0 fs-12 fw-6 lh-20 dc__truncate",
							children: r
						})]
					})]
				}),
				arrow: !1,
				className: "default-tt",
				children: /* @__PURE__ */ (0, J.jsx)("div", {
					className: "dc__w-fit-content dc__truncate",
					children: e
				})
			})
		}) }), o.version ? /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [
			/* @__PURE__ */ (0, J.jsx)("div", { children: /* @__PURE__ */ (0, J.jsx)(Vg, {
				version: o.version,
				className: "bg__primary"
			}) }),
			/* @__PURE__ */ (0, J.jsx)("div", {
				className: "dc__truncate",
				children: /* @__PURE__ */ (0, J.jsx)(Lf, { status: o.deployStatus })
			}),
			/* @__PURE__ */ (0, J.jsx)(D, {
				content: o.triggerTime,
				arrow: !1,
				className: "default-tt",
				placement: "top",
				children: /* @__PURE__ */ (0, J.jsx)("div", {
					className: "dc__truncate",
					children: Rr(o.triggerTime, !0)
				})
			})
		] }) : /* @__PURE__ */ (0, J.jsx)("div", { children: "No release triggered" })]
	});
}, Ug = ({ apps: e }) => {
	let { sortBy: t, sortOrder: n, handleSorting: r } = mi({ initialSortKey: Lg.triggerTime }), i = k(() => {
		if (e?.length) switch (t) {
			case Lg.application: return e.sort((e, t) => G(e.appName, t.appName, n));
			case Lg.lastTriggeredRelease: return e.sort((e, t) => G(e.lastTriggeredRelease.version, t.lastTriggeredRelease.version, n));
			case Lg.deploymentStatus: return e.sort((e, t) => G(e.lastTriggeredRelease.deployStatus, t.lastTriggeredRelease.deployStatus, n));
			case Lg.triggerTime:
			default: return e.sort((e, t) => Lr(e.lastTriggeredRelease.triggerTime, t.lastTriggeredRelease.triggerTime, n));
		}
		return [];
	}, [
		e,
		t,
		n
	]);
	return /* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
		className: "releases__active-releases-apps-table dc__column-gap-16 display-grid dc__align-items-center fs-12 lh-20 fw-6 cn-7 dc__uppercase dc__border-bottom-n1 px-16",
		children: [
			/* @__PURE__ */ (0, J.jsx)(z, {
				isSorted: t === Lg.application,
				disabled: !1,
				sortOrder: n,
				title: "Application",
				triggerSorting: () => {
					r(Lg.application);
				}
			}),
			/* @__PURE__ */ (0, J.jsx)(z, {
				isSorted: t === Lg.lastTriggeredRelease,
				disabled: !1,
				sortOrder: n,
				title: "Last triggered Release",
				triggerSorting: () => {
					r(Lg.lastTriggeredRelease);
				}
			}),
			/* @__PURE__ */ (0, J.jsx)(z, {
				isSorted: t === Lg.deploymentStatus,
				disabled: !1,
				sortOrder: n,
				title: "Deployment Status",
				triggerSorting: () => {
					r(Lg.deploymentStatus);
				}
			}),
			/* @__PURE__ */ (0, J.jsx)(z, {
				isSorted: t === Lg.triggerTime,
				disabled: !1,
				sortOrder: n,
				title: "Trigger Time",
				triggerSorting: () => {
					r(Lg.triggerTime);
				}
			})
		]
	}), /* @__PURE__ */ (0, J.jsx)("div", {
		className: "bg__secondary",
		children: i.map((e) => /* @__PURE__ */ Me(Hg, {
			...e,
			key: `${e.appId}-${e.envId}`
		}))
	})] });
}, Wg = (e) => /* @__PURE__ */ (0, J.jsx)(D, {
	className: "default-tt",
	arrow: !1,
	content: "No applications available",
	children: e
}), Gg = ({ lastTriggeredRelease: e, apps: t }) => {
	let [n, r] = A(!1), { name: i } = vs(), a = t.length === 0;
	return /* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
		className: "px-12 py-10 flexbox dc__align-items-center dc__gap-20 fs-12 fw-4 lh-20 cn-7",
		children: [/* @__PURE__ */ (0, J.jsx)("div", {
			className: "flex dc__gap-8 dc__content-space",
			children: t.length === 0 || !e.version ? /* @__PURE__ */ (0, J.jsxs)("span", { children: [
				"No release triggered from ‘",
				i,
				"’"
			] }) : /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)(Vg, {
				version: e.version,
				className: "bcn-1"
			}), /* @__PURE__ */ (0, J.jsx)(Lf, {
				status: e.deployStatus,
				showTippy: !0
			})] })
		}), /* @__PURE__ */ (0, J.jsx)(lt, {
			condition: a,
			wrap: Wg,
			children: /* @__PURE__ */ (0, J.jsxs)("button", {
				type: "button",
				className: `flex dc__content-end flex-grow-1 dc__transparent p-0 dc__gap-4 dc__hover-n50 br-4 cursor dc__no-shrink ${a ? "dc__disabled" : ""}`,
				onClick: () => {
					r((e) => !e);
				},
				disabled: a,
				children: [!a && /* @__PURE__ */ (0, J.jsx)("span", {
					className: "cn-9 fs-12 lh-20 fw-4 dc__truncate",
					children: n ? "Hide apps" : "View apps"
				}), /* @__PURE__ */ (0, J.jsx)(g, { className: `icon-dim-16 icon-color-n6 dc__no-shrink dc__transition--transform ${n ? "dc__flip-180" : ""}` })]
			})
		})]
	}), !a && n && /* @__PURE__ */ (0, J.jsx)(Ug, { apps: t })] });
}, Kg = ({ isSummaryLoading: e, filterConfig: { sortBy: t, sortOrder: n, handleSorting: r, clearFilters: i }, filteredTrackSummaryList: a }) => !e && !a.length ? /* @__PURE__ */ (0, J.jsx)(Gt, {
	handleClearFilters: i,
	classname: "mh-440 flex-grow-1"
}) : /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "flexbox-col flex-grow-1 dc__overflow-auto",
	children: [/* @__PURE__ */ (0, J.jsxs)("div", {
		className: "display-grid releases__active-releases-table releases__active-releases-table--header dc__align-items-center fs-12 lh-20 fw-6 cn-7 dc__uppercase dc__border-bottom-n1 bg__primary",
		children: [/* @__PURE__ */ (0, J.jsx)("div", {
			className: "px-16 py-8",
			children: /* @__PURE__ */ (0, J.jsx)(z, {
				isSorted: t === Fg.tenantInstallation,
				disabled: e,
				sortOrder: n,
				title: "Tenant (Installation)",
				triggerSorting: () => {
					r(Fg.tenantInstallation);
				}
			})
		}), /* @__PURE__ */ (0, J.jsx)("div", {
			className: "px-12 py-8",
			children: "Last Triggered Release"
		})]
	}), /* @__PURE__ */ (0, J.jsx)("div", {
		className: "flexbox-col flex-grow-1 dc__overflow-auto",
		children: e ? Ig.map((e) => /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "display-grid releases__active-releases-table fs-13 lh-20 cn-9 dc__border-bottom-n1 show-shimmer-loading",
			children: [/* @__PURE__ */ (0, J.jsx)("div", {
				className: "px-16 py-10 dc__border-right--n1",
				children: /* @__PURE__ */ (0, J.jsx)("div", { className: "child-shimmer-loading h-16 w-100" })
			}), /* @__PURE__ */ (0, J.jsx)("div", {
				className: "px-12 py-10",
				children: /* @__PURE__ */ (0, J.jsx)("div", { className: "child-shimmer-loading h-16 w-100" })
			})]
		}, e.tenantConfig.identifier)) : a.map(({ tenantConfig: e, lastTriggeredRelease: t, apps: n }) => /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "display-grid releases__active-releases-table fs-13 lh-20 cn-9 dc__border-bottom-n1",
			children: [/* @__PURE__ */ (0, J.jsx)("div", {
				className: "flexbox dc__align-items-center px-16 py-10 dc__border-right--n1",
				children: /* @__PURE__ */ (0, J.jsx)(kf, {
					tenantConfig: e,
					children: /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox dc__align-items-center dc__gap-8 dc__w-fit-content dc__align-self-start",
						children: [/* @__PURE__ */ (0, J.jsx)(sf, { imageProps: {
							src: e.image,
							height: 20,
							width: 20
						} }), /* @__PURE__ */ (0, J.jsx)("span", {
							className: "dc__truncate",
							children: e.displayText
						})]
					})
				})
			}), /* @__PURE__ */ (0, J.jsx)(Gg, {
				lastTriggeredRelease: t,
				apps: n
			})]
		}, e.identifier))
	})]
}), qg = (e) => ({
	version: e.getAll("version").map((e) => e.trim()).filter((e) => !!e),
	releaseChannelId: e.getAll(Uu.releaseChannelId).map((e) => e.trim()).filter((e) => !!e)
}), Jg = (e, { searchKey: t, version: n, sortOrder: r, releaseChannelId: i }) => {
	if (e?.length) {
		let a = t.trim().toLowerCase(), o = structuredClone(e);
		if (a && (o = o.filter((e) => e.tenantConfig.displayText.toLowerCase().includes(a))), n.length) {
			let e = n.reduce((e, t) => (e[t] = !0, e), {});
			o = o.map(({ apps: t, ...n }) => ({
				...n,
				apps: t.filter((t) => e[t.lastTriggeredRelease.version])
			})).filter((e) => e.apps.length);
		}
		if (i.length) {
			let e = i.reduce((e, t) => (e[t] = !0, e), {});
			o = o.filter((t) => {
				let { releaseChannelId: n } = t.tenantConfig.installationConfig;
				return n ? e[n] : e[Wu.value];
			});
		}
		return {
			filteredTrackSummaryList: o.sort((e, t) => G(e.tenantConfig.displayText, t.tenantConfig.displayText, r)),
			versionOptions: [...new Set(e.flatMap((e) => e.apps).map(({ lastTriggeredRelease: e }) => e.version).filter((e) => !!e))].map((e) => ({
				label: e,
				value: e
			}))
		};
	}
	return {
		filteredTrackSummaryList: [],
		versionOptions: []
	};
}, Yg = () => {
	let { name: e } = vs(), { searchKey: t, handleSearch: n, sortBy: r, sortOrder: i, handleSorting: a, clearFilters: o, version: s, releaseChannelId: c, updateSearchParams: l } = gi({
		initialSortKey: Fg.tenantInstallation,
		parseSearchParams: qg
	}), [u, d, f, p] = K(() => Ol(e)), [m, h, , g] = K(() => jg(), []), _ = u && (!d || f), v = !_ && f, { filteredTrackSummaryList: y, versionOptions: b } = k(() => Jg(d, {
		searchKey: t,
		sortOrder: i,
		version: s,
		releaseChannelId: c
	}), [
		d,
		t,
		i,
		s.toString(),
		c.toString()
	]), x = k(() => Ud(h), [h]);
	return /* @__PURE__ */ (0, J.jsx)("div", {
		className: `flexbox-col dc__overflow-auto bg__primary br-4 dc__info-card dc__info-card--no-hover dc__info-card--no-box-shadow ${v ? "p-16" : ""}`,
		children: /* @__PURE__ */ (0, J.jsx)(Ie, {
			isLoading: !1,
			error: v,
			errorScreenManagerProps: {
				code: f?.code,
				reload: p
			},
			children: _ || d?.length ? /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)(Bg, {
				isLoading: u,
				handleSearchEnter: (e) => {
					n(e);
				},
				searchKey: t,
				appliedVersions: s,
				versionOptions: b,
				filterConfig: {
					clearFilters: o,
					updateSearchParams: l
				},
				refetchTrackSummaryAndChannelList: () => {
					p(), g();
				},
				appliedReleaseChannelIds: c,
				getFormattedFilterValue: (e, t) => e === Uu.releaseChannelId ? x[t] : null,
				releaseChannelList: h,
				isReleaseChannelLoading: m
			}), /* @__PURE__ */ (0, J.jsx)(Kg, {
				isSummaryLoading: _,
				filterConfig: {
					sortBy: r,
					sortOrder: i,
					handleSorting: a,
					clearFilters: o
				},
				filteredTrackSummaryList: y
			})] }) : /* @__PURE__ */ (0, J.jsx)(F, {
				title: `No releases are active in ‘${e}’`,
				subTitle: "Release version deployed and active on tenants will be available here",
				image: Ri,
				classname: "flex-grow-1 mh-500"
			})
		})
	});
}, Xg = () => {
	let { name: e } = vs(), { breadcrumbs: t } = ri(I.RELEASES.TRACK_DETAIL, { alias: {
		...bl(),
		releases: {
			component: /* @__PURE__ */ (0, J.jsx)(Je, { heading: "Release Hub" }),
			linked: !0
		},
		track: { component: null },
		detail: { component: null },
		":trackName": { component: /* @__PURE__ */ (0, J.jsx)(Je, {
			heading: e,
			isActive: !0
		}) }
	} });
	return /* @__PURE__ */ (0, J.jsx)(pn, {
		isBreadcrumbs: !0,
		breadCrumbs: () => /* @__PURE__ */ (0, J.jsx)("div", {
			className: "flexbox dc__align-items-center",
			children: /* @__PURE__ */ (0, J.jsx)(qe, {
				breadcrumbs: t,
				path: I.RELEASES.TRACK_DETAIL
			})
		}),
		docPath: vt.SOFTWARE_DISTRIBUTION_HUB
	});
}, Zg = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	"data-style-override": "false",
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M29.2212 2.52637H10.2271C9.51922 2.52637 8.94531 3.10027 8.94531 3.80816V19.9532C8.94531 20.6611 9.51922 21.235 10.2271 21.235H29.2213C29.9291 21.235 30.503 20.6611 30.503 19.9532V3.80816C30.503 3.10027 29.9291 2.52637 29.2212 2.52637Z",
			fill: "#7E604A"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M19.7241 2.52637H10.2271C9.51922 2.52637 8.94531 3.10027 8.94531 3.80816V19.9532C8.94531 20.6611 9.51922 21.235 10.2271 21.235H19.7241V2.52637Z",
			fill: "#AC825A"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M19.7241 6.31637C20.432 6.31637 21.0059 5.74246 21.0059 5.03457V2.52637H18.4424V5.03457C18.4423 5.74246 19.0162 6.31637 19.7241 6.31637Z",
			fill: "#FF9900"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M19.7242 6.31637V2.52637H18.4424V5.03457C18.4424 5.74246 19.0163 6.31637 19.7242 6.31637Z",
			fill: "#FAD52A"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M20.2759 18.7646H1.2818C0.573906 18.7646 0 19.3386 0 20.0464V36.1915C0 36.8994 0.573906 37.4732 1.2818 37.4732H20.2759C20.9838 37.4732 21.5577 36.8993 21.5577 36.1914V20.0464C21.5577 19.3386 20.9838 18.7646 20.2759 18.7646Z",
			fill: "#FF9900"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M10.7788 18.7646H1.2818C0.573906 18.7646 0 19.3386 0 20.0464V36.1915C0 36.8994 0.573906 37.4732 1.2818 37.4732H10.7788V18.7646Z",
			fill: "#FAD52A"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M10.7788 22.5546C11.4867 22.5546 12.0606 21.9807 12.0606 21.2729V18.7646H9.49707V21.2729C9.49699 21.9807 10.0709 22.5546 10.7788 22.5546Z",
			fill: "#7E604A"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M10.7789 22.5546V18.7646H9.49707V21.2729C9.49707 21.9807 10.071 22.5546 10.7789 22.5546Z",
			fill: "#AC825A"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M38.7183 18.7646H19.7242C19.0163 18.7646 18.4424 19.3386 18.4424 20.0464V36.1915C18.4424 36.8994 19.0163 37.4733 19.7242 37.4733H38.7183C39.4262 37.4733 40.0001 36.8994 40.0001 36.1915V20.0464C40.0001 19.3386 39.4262 18.7646 38.7183 18.7646Z",
			fill: "#D83249"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M29.2212 18.7646H19.7242C19.0163 18.7646 18.4424 19.3386 18.4424 20.0464V36.1915C18.4424 36.8994 19.0163 37.4733 19.7242 37.4733H29.2212V18.7646Z",
			fill: "#FF4F59"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M29.2212 22.5546C29.9291 22.5546 30.503 21.9807 30.503 21.2729V18.7646H27.9395V21.2729C27.9395 21.9807 28.5133 22.5546 29.2212 22.5546Z",
			fill: "#FF9900"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M29.2213 22.5546V18.7646H27.9395V21.2729C27.9395 21.9807 28.5134 22.5546 29.2213 22.5546Z",
			fill: "#FAD52A"
		})
	]
}), Qg = () => {
	let { id: e, name: t, description: n, createdBy: r, createdOn: i, refetchTrackDetail: a } = vs();
	return /* @__PURE__ */ (0, J.jsxs)("aside", {
		className: "flexbox-col dc__gap-16",
		children: [
			/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col dc__gap-12",
				children: [
					/* @__PURE__ */ (0, J.jsx)(Zg, { className: "icon-dim-48 br-4 p-4" }),
					/* @__PURE__ */ (0, J.jsx)("h3", {
						className: "fs-16 fw-7 lh-24 cn-9 dc__word-break font-merriweather m-0",
						children: t
					}),
					/* @__PURE__ */ (0, J.jsx)(Pt, {
						emptyState: "Write a short description for this release track",
						placeholder: "Write a short description for this release track",
						initialText: n,
						updateContent: async (t) => {
							let n = {
								id: e,
								description: t
							};
							try {
								await El(n), B.showToast({
									variant: V.success,
									description: "Successfully saved"
								}), await a();
							} catch (e) {
								throw W(e), e;
							}
						},
						validations: { maxLength: {
							value: 300,
							message: "Max 300 characters allowed"
						} }
					})
				]
			}),
			/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-top-n1" }),
			/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col dc__gap-12",
				children: [/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("div", {
					className: "fs-13 fw-4 lh-20 cn-7 mb-4",
					children: "Added on"
				}), /* @__PURE__ */ (0, J.jsx)("div", {
					className: "fs-13 fw-6 lh-20 cn-9 dc__truncate",
					children: i
				})] }), /* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("div", {
					className: "fs-13 fw-4 lh-20 cn-7 mb-4",
					children: "Added by"
				}), /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "fs-13 fw-6 lh-20 cn-9 dc__word-break flexbox flex-align-center dc__gap-8",
					children: [/* @__PURE__ */ (0, J.jsx)("div", {
						className: "icon-dim-20 mw-20 flexbox flex-justify-center flex-align-center dc__border-radius-50-per dc__uppercase cn-0 fw-4",
						style: { backgroundColor: Cr(r) },
						children: r[0]
					}), r]
				})] })]
			})
		]
	});
}, $g = () => {
	let e = ki(), { trackName: t } = Ai(), { queryParams: n } = pi(), r = n.get("tab"), i = r === cg.manageApplication, [a, o, s, c] = K(() => wl(t), [t], !0, { resetOnChange: !1 }), l = k(() => ({
		...o,
		refetchTrackDetail: c
	}), [o]), u = (t) => {
		let r = new URLSearchParams(n);
		r.set("tab", t), e({ search: r.toString() }, { replace: !0 });
	};
	return O(() => {
		(!r || !Object.values(cg).some((e) => e === r)) && u(cg.activeReleases);
	}, [n]), /* @__PURE__ */ (0, J.jsx)(Ie, {
		isLoading: a && !o,
		customLoader: /* @__PURE__ */ (0, J.jsx)("div", {
			className: "flex h-100 w-100",
			children: /* @__PURE__ */ (0, J.jsx)(Dt, {})
		}),
		errorScreenManagerProps: {
			code: s?.code,
			redirectURL: I.RELEASES.ROOT,
			reload: c
		},
		error: s,
		children: /* @__PURE__ */ (0, J.jsx)(_s, {
			value: l,
			children: /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col h-100 dc__overflow-hidden",
				children: [/* @__PURE__ */ (0, J.jsx)(Xg, {}), /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "pl-20 pr-20 pt-20 pb-20 software-hub__overview display-grid dc__gap-32 dc__content-center flex-grow-1 dc__overflow-auto",
					children: [/* @__PURE__ */ (0, J.jsx)(Qg, {}), /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox-col dc__gap-12 flex-grow-1 dc__overflow-auto",
						children: [/* @__PURE__ */ (0, J.jsx)("div", { children: /* @__PURE__ */ (0, J.jsx)(kn, {
							segments: [{
								label: "Active Releases",
								value: cg.activeReleases
							}, {
								label: "Manage Applications",
								value: cg.manageApplication
							}],
							value: r,
							onChange: (e) => {
								let t = e.value;
								u(t);
							},
							name: "track-detail-tabs"
						}) }), i ? /* @__PURE__ */ (0, J.jsx)(jl, {}) : /* @__PURE__ */ (0, J.jsx)(Yg, {})]
					})]
				})]
			})
		})
	});
}, e_ = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	"data-style-override": "false",
	width: 560,
	height: 250,
	viewBox: "0 0 560 250",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsx)("style", { children: "\n    @keyframes moving-border{0%{stroke-dashoffset:9}to{stroke-dashoffset:0}}\n  " }),
		/* @__PURE__ */ (0, J.jsxs)("g", {
			clipPath: "url(#clip0_6302_74385)",
			children: [
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#06C",
					d: "M0 0h560v250H0z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "url(#pattern0_6302_74385)",
					fillOpacity: .4,
					style: { mixBlendMode: "soft-light" },
					d: "M0 0h560v250H0z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M13 1h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M143 0h1v144h-1zM0 0h1v144H0z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M1 131v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M0 1V0h144v1zm0 143v-1h144v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M13 144h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M143 143h1v144h-1zM0 143h1v144H0z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M1 248v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M0 144v-1h144v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M156 1h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M286 0h1v144h-1zM143 0h1v144h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M144 131v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M143 1V0h144v1zm0 143v-1h144v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M156 144h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M286 143h1v144h-1zm-143 0h1v144h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M144 248v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M143 144v-1h144v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M299 1h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M429 0h1v144h-1zM286 0h1v144h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M287 131v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M286 1V0h144v1zm0 143v-1h144v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M299 144h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M429 143h1v144h-1zm-143 0h1v144h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M287 248v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M286 144v-1h144v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M442 1h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M429 0h1v144h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M430 131v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M429 1V0h144v1zm0 143v-1h144v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M442 144h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M429 143h1v144h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M430 248v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M429 144v-1h144v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					stroke: "#fff",
					strokeLinecap: "round",
					strokeDasharray: "3 5",
					d: "M10 10h540v230H10z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M20 10c0 5.523-4.477 10-10 10m530-10c0 5.523 4.477 10 10 10m-10 220c0-5.523 4.477-10 10-10M20 240c0-5.523-4.477-10-10-10",
					stroke: "#fff",
					strokeLinecap: "round",
					strokeDasharray: "3 5"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "m526.114 223.628-2.922-4.6a1.22 1.22 0 0 1-.01-1.3l3.768-6.099a1.33 1.33 0 0 1 1.134-.629l5.439.019.036.001c.531.028.822.635.529 1.078l-3.775 5.721a.733.733 0 1 1-1.31-.656h.001v-.001l.001-.001a.7.7 0 0 1 .079-.121l.575-.879a.408.408 0 0 0-.292-.632l-1.382-.105a.94.94 0 0 0-.7.241c-.25.292-1.361 2.084-1.868 2.924a.79.79 0 0 0 .04.867l-.006.003 1.759 2.763.33.524a1 1 0 0 1 .089.143l.013.019-.001.005a.846.846 0 0 1-.621 1.182.844.844 0 0 1-.906-.467m9.749-11.064 2.942 4.588c.254.394.26.899.015 1.3l-3.74 6.115a1.33 1.33 0 0 1-1.131.634l-5.439.005-.037-.001c-.53-.024-.824-.63-.533-1.075l3.749-5.737a.735.735 0 0 1 .83-.397.73.73 0 0 1 .483 1.046v.001l-.001.002a1 1 0 0 1-.079.121l-.571.881a.408.408 0 0 0 .295.631l1.382.099a.94.94 0 0 0 .699-.244c.249-.293 1.351-2.09 1.855-2.932a.79.79 0 0 0-.044-.867l.007-.003-1.772-2.755-.332-.523a1 1 0 0 1-.091-.142l-.012-.019.001-.005a.846.846 0 0 1 .615-1.185.845.845 0 0 1 .909.462",
					fill: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsxs)("g", {
					opacity: .6,
					children: [/* @__PURE__ */ (0, J.jsx)("path", {
						d: "M261 84a4 4 0 0 1 4-4h30a4 4 0 0 1 4 4v2h-38z",
						fill: "#0158CB"
					}), /* @__PURE__ */ (0, J.jsx)("path", {
						d: "M261 84a4 4 0 0 1 4-4h30a4 4 0 0 1 4 4v2h-38z",
						stroke: "#fff"
					})]
				}),
				/* @__PURE__ */ (0, J.jsxs)("g", {
					opacity: .8,
					children: [/* @__PURE__ */ (0, J.jsx)("path", {
						d: "M255 92a6 6 0 0 1 6-6h38a6 6 0 0 1 6 6z",
						fill: "#0158CB"
					}), /* @__PURE__ */ (0, J.jsx)("path", {
						d: "M255 92a6 6 0 0 1 6-6h38a6 6 0 0 1 6 6z",
						stroke: "#fff"
					})]
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 247,
					y: 92,
					width: 66,
					height: 66,
					rx: 8,
					fill: "#0151C9",
					fillOpacity: .7
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 247,
					y: 92,
					width: 66,
					height: 66,
					rx: 8,
					stroke: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M280 126.013a.65.65 0 0 1-.32-.084l-7.174-4.036a.65.65 0 0 1-.332-.568v-4.551m7.826 9.239a.65.65 0 0 0 .32-.084l7.174-4.036a.65.65 0 0 0 .332-.568v-4.526M280 126.013l.077-8.709m0 0-2.26 2.609-7.817-4.348 2.261-2.608m7.816 4.347-7.816-4.347m7.816 4.347 2.262 2.609 7.661-4.348-2.261-2.608m-7.662 4.347 7.662-4.347m-15.478 0L270 110.348l7.739-4.348 2.261 2.6m-7.739 4.357L280 108.6m7.739 4.357 2.261-2.609-7.739-4.348-2.261 2.6m7.739 4.357L280 108.6",
					stroke: "#fff",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "m263.477 146-2.04-6.516h1.716l1.956 6.516zm.492 0v-1.368h1.764V146zm.66 0 1.68-6.516h1.608L266.153 146zm7.272.228q-1.008 0-1.74-.384a2.8 2.8 0 0 1-1.104-1.02 2.77 2.77 0 0 1-.384-1.44h1.644q0 .636.42 1.032.432.384 1.164.384.492 0 .84-.18.36-.192.552-.516a1.5 1.5 0 0 0 .192-.768q0-.648-.42-1.056-.42-.42-1.152-.42-.36 0-.636.096a1.8 1.8 0 0 0-.468.252l-.78-1.344 2.88-1.968-.108-.204h-3.768v-1.452h5.724v1.752l-2.964 1.968-.924-.168q.228-.072.492-.108.264-.048.576-.048.996 0 1.704.348.72.336 1.104.936t.384 1.38v.156q0 .756-.384 1.392-.384.624-1.104 1.008-.72.372-1.74.372m4.523-.228v-1.92h1.872V146zm3.319 0v-1.68q0-.552.168-.96.18-.408.576-.72.408-.324 1.068-.612l1.488-.66q.552-.252.84-.612.3-.372.3-.948 0-.636-.384-1.008-.372-.384-1.068-.384t-1.08.384q-.372.384-.372 1.068h-1.644q0-.816.348-1.464.348-.66 1.032-1.032.684-.384 1.716-.384t1.716.372 1.032.996q.348.612.348 1.368v.156q0 .984-.552 1.644-.552.648-1.62 1.128l-1.488.66q-.42.18-.588.384-.168.192-.168.528v.768l-.408-.444h4.86V146zm7.427 0v-1.92h1.872V146zm7.087.228q-1.032 0-1.752-.336a3.25 3.25 0 0 1-1.176-.936 4 4 0 0 1-.672-1.368 6.4 6.4 0 0 1-.204-1.632v-.672q0-1.212.408-2.184a3.4 3.4 0 0 1 1.248-1.536q.84-.576 2.148-.576 1.296 0 2.136.576.84.564 1.236 1.536.408.972.408 2.184v.672q0 .852-.216 1.632a3.9 3.9 0 0 1-.66 1.368 3.14 3.14 0 0 1-1.164.936q-.72.336-1.74.336m0-1.56q1.068 0 1.572-.732.504-.744.504-2.304 0-1.656-.516-2.364-.516-.72-1.56-.72-1.056 0-1.584.72-.516.708-.516 2.34 0 1.572.516 2.316t1.584.744M256.638 176v-8.832h1.968V176zm5.316 0-2.568-3.768h2.16l2.688 3.768zm-3.876-2.808v-1.548h2.16q.432 0 .744-.168.324-.18.492-.492.18-.324.18-.744t-.18-.732a1.13 1.13 0 0 0-.492-.492 1.46 1.46 0 0 0-.744-.18h-2.16v-1.668h2.004q1.092 0 1.896.336.804.324 1.236.972t.432 1.632v.192q0 .972-.444 1.62-.432.636-1.236.96-.792.312-1.884.312zm10.113 3.036q-.84 0-1.488-.288a3.2 3.2 0 0 1-1.068-.768 3.7 3.7 0 0 1-.648-1.092 3.7 3.7 0 0 1-.216-1.248v-.24q0-.66.216-1.26.228-.612.648-1.092a2.95 2.95 0 0 1 1.044-.756 3.45 3.45 0 0 1 1.44-.288q1.056 0 1.776.48.732.468 1.116 1.236.384.756.384 1.656v.648h-5.82v-1.092h4.656l-.624.504q0-.588-.168-1.008a1.3 1.3 0 0 0-.504-.636q-.324-.228-.816-.228-.504 0-.852.228a1.4 1.4 0 0 0-.528.672q-.18.432-.18 1.068 0 .588.168 1.032.168.432.528.672t.936.24q.528 0 .864-.204t.456-.504h1.764q-.144.66-.564 1.176a2.86 2.86 0 0 1-1.056.804q-.636.288-1.464.288m4.56-.228v-8.76h1.932V176zm-.78-7.344v-1.416h2.712v1.416zm7.493 7.572q-.84 0-1.488-.288a3.2 3.2 0 0 1-1.068-.768 3.7 3.7 0 0 1-.648-1.092 3.7 3.7 0 0 1-.216-1.248v-.24q0-.66.216-1.26.228-.612.648-1.092a2.95 2.95 0 0 1 1.044-.756 3.45 3.45 0 0 1 1.44-.288q1.056 0 1.776.48.732.468 1.116 1.236.384.756.384 1.656v.648h-5.82v-1.092h4.656l-.624.504q0-.588-.168-1.008a1.3 1.3 0 0 0-.504-.636q-.324-.228-.816-.228-.504 0-.852.228a1.4 1.4 0 0 0-.528.672q-.18.432-.18 1.068 0 .588.168 1.032.168.432.528.672t.936.24q.528 0 .864-.204t.456-.504h1.764q-.144.66-.564 1.176a2.86 2.86 0 0 1-1.056.804q-.636.288-1.464.288m8.448-.228v-1.944h-.324v-2.112q0-.504-.24-.756t-.768-.252q-.264 0-.696.012t-.888.036-.828.048v-1.62a30 30 0 0 1 1.416-.084q.396-.012.744-.012 1.008 0 1.692.288.696.288 1.056.876.36.576.36 1.488V176zm-2.1.168q-.708 0-1.248-.252a1.96 1.96 0 0 1-.828-.72q-.3-.48-.3-1.14 0-.72.372-1.176.372-.468 1.044-.684.672-.228 1.548-.228h1.404v1.068h-1.416q-.504 0-.78.252-.264.24-.264.66 0 .396.264.648.276.24.78.24.324 0 .576-.108a1 1 0 0 0 .432-.396q.168-.276.192-.768l.456.48q-.06.684-.336 1.152a1.8 1.8 0 0 1-.744.72q-.468.252-1.152.252m7.749.036q-1.404 0-2.196-.576t-.84-1.62h1.704q.048.312.372.564.336.24.996.24.504 0 .828-.168.336-.18.336-.504a.52.52 0 0 0-.252-.456q-.252-.18-.9-.252l-.516-.048q-1.188-.12-1.788-.66-.588-.54-.588-1.38 0-.696.348-1.164t.96-.708q.624-.24 1.416-.24 1.272 0 2.052.564.78.552.816 1.608h-1.704a.8.8 0 0 0-.336-.54q-.288-.228-.852-.228-.444 0-.708.168a.52.52 0 0 0-.264.456q0 .276.228.42t.744.204l.516.048q1.212.132 1.884.672t.672 1.452q0 .66-.36 1.152-.36.48-1.02.744-.66.252-1.548.252m7.184.024q-.84 0-1.488-.288a3.2 3.2 0 0 1-1.068-.768 3.7 3.7 0 0 1-.648-1.092 3.7 3.7 0 0 1-.216-1.248v-.24q0-.66.216-1.26.228-.612.648-1.092a2.95 2.95 0 0 1 1.044-.756 3.45 3.45 0 0 1 1.44-.288q1.056 0 1.776.48.732.468 1.116 1.236.384.756.384 1.656v.648h-5.82v-1.092h4.656l-.624.504q0-.588-.168-1.008a1.3 1.3 0 0 0-.504-.636q-.324-.228-.816-.228-.504 0-.852.228a1.4 1.4 0 0 0-.528.672q-.18.432-.18 1.068 0 .588.168 1.032.168.432.528.672t.936.24q.528 0 .864-.204t.456-.504h1.764q-.144.66-.564 1.176a2.86 2.86 0 0 1-1.056.804q-.636.288-1.464.288",
					fill: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 41.5,
					y: 38.5,
					width: 125,
					height: 41,
					rx: 7.5,
					fill: "#0151C9",
					fillOpacity: .7
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 41.5,
					y: 38.5,
					width: 125,
					height: 41,
					rx: 7.5,
					stroke: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M54.269 56.725q.169-.355.394-.681l-.025-1.625a.51.51 0 0 1 .18-.394 6.5 6.5 0 0 1 1.976-1.144c.144-.05.3-.037.425.044l1.394.837q.394-.027.787 0l1.394-.837a.52.52 0 0 1 .431-.044A6.5 6.5 0 0 1 63.2 54.02a.5.5 0 0 1 .175.393l-.025 1.625c.15.22.281.444.394.682l1.419.787c.13.075.225.2.25.35a6.5 6.5 0 0 1 0 2.275.5.5 0 0 1-.25.35l-1.42.788a5 5 0 0 1-.393.68l.025 1.626a.51.51 0 0 1-.181.394 6.5 6.5 0 0 1-1.975 1.143.48.48 0 0 1-.425-.043l-1.394-.84a5.5 5.5 0 0 1-.787 0l-1.394.838a.52.52 0 0 1-.431.043 6.5 6.5 0 0 1-1.975-1.137.5.5 0 0 1-.175-.394l.025-1.625a5 5 0 0 1-.394-.681l-1.419-.788a.5.5 0 0 1-.25-.35 6.5 6.5 0 0 1 0-2.275.5.5 0 0 1 .25-.35z",
					stroke: "#fff",
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M59 61.4a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8",
					stroke: "#fff",
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "m73.485 54 2.63-7.3h1.66l2.71 7.3h-1.01l-2.45-6.66.48.24h-1.18l.51-.24-2.37 6.66zm1.57-2.18.33-.88h3.15l.33.88zM81.684 56v-7.34h.76v2.31l-.18-.02q.05-.86.36-1.4.32-.55.83-.81t1.11-.26q.579 0 1.05.22.48.22.82.6t.52.88.18 1.06v.18q0 .56-.19 1.06a2.7 2.7 0 0 1-.54.88 2.47 2.47 0 0 1-1.86.82q-.57 0-1.09-.25t-.86-.81-.39-1.47l.44.8V56zm2.71-2.66q.54 0 .94-.25.4-.26.62-.71.22-.46.22-1.05 0-.6-.22-1.05a1.69 1.69 0 0 0-1.56-.96q-.48 0-.89.22-.411.21-.66.62-.24.4-.24.97v.46q0 .55.25.94.249.39.66.6.41.21.88.21M88.578 56v-7.34h.76v2.31l-.18-.02q.05-.86.36-1.4.32-.55.83-.81t1.11-.26q.58 0 1.05.22.48.22.82.6t.52.88.18 1.06v.18q0 .56-.19 1.06a2.7 2.7 0 0 1-.54.88 2.47 2.47 0 0 1-1.86.82q-.57 0-1.09-.25t-.86-.81-.39-1.47l.44.8V56zm2.71-2.66q.54 0 .94-.25.4-.26.62-.71.22-.46.22-1.05 0-.6-.22-1.05a1.69 1.69 0 0 0-1.56-.96q-.48 0-.89.22-.41.21-.66.62-.24.4-.24.97v.46q0 .55.25.94t.66.6.88.21m4.245.66v-7.3h.96V54zm-.74-6.54v-.76h1.7v.76zM98.594 54v-5.34h.96V54zm-.82-4.58v-.76h1.78v.76zm1.09-1.62q-.32 0-.48-.17a.63.63 0 0 1-.15-.43q0-.26.15-.43.16-.17.48-.17t.47.17q.16.17.16.43a.6.6 0 0 1-.16.43q-.15.17-.47.17m4.836 6.38q-.69 0-1.2-.24a2.4 2.4 0 0 1-.83-.64 3 3 0 0 1-.5-.9 3.2 3.2 0 0 1-.16-.98v-.18q0-.51.16-1 .17-.49.5-.88a2.5 2.5 0 0 1 .84-.64q.501-.24 1.17-.24.67 0 1.2.25.54.25.86.71.33.45.37 1.07h-.92q-.07-.5-.46-.83-.39-.34-1.05-.34-.57 0-.95.26a1.6 1.6 0 0 0-.57.71q-.19.45-.19 1.02 0 .55.19 1.01.19.45.57.72.39.26.97.26.45 0 .78-.16t.53-.43a1.24 1.24 0 0 0 .24-.61h.92q-.03.63-.37 1.09a2.23 2.23 0 0 1-.88.72q-.54.25-1.22.25m7.005-.18v-1.6h-.16v-1.85q0-.55-.29-.83-.28-.28-.83-.28-.31 0-.64.01l-.63.02a9 9 0 0 0-.52.03v-.84q.22-.02.46-.03.249-.02.51-.02.26-.01.5-.01.82 0 1.34.2.52.19.77.63t.25 1.19V54zm-1.75.14q-.6 0-1.04-.2-.43-.21-.67-.6-.23-.39-.23-.94 0-.57.25-.95a1.56 1.56 0 0 1 .75-.57q.49-.2 1.18-.2h1.45v.72h-1.49q-.58 0-.89.28a.93.93 0 0 0-.31.72q0 .44.31.71t.89.27q.34 0 .65-.12a1.16 1.16 0 0 0 .51-.42q.21-.3.23-.82l.26.38q-.05.57-.28.96a1.45 1.45 0 0 1-.62.58q-.39.2-.95.2m6.352-.08q-.6 0-1.04-.17a1.32 1.32 0 0 1-.67-.58q-.23-.42-.23-1.13v-5.14h.92v5.26q0 .43.23.67.24.23.67.23h.94v.86zm-2.86-4.68v-.72h3.68v.72zm5.297 4.62v-5.34h.96V54zm-.82-4.58v-.76h1.78v.76zm1.09-1.62q-.32 0-.48-.17a.63.63 0 0 1-.15-.43q0-.26.15-.43.16-.17.48-.17t.47.17q.16.17.16.43a.6.6 0 0 1-.16.43q-.15.17-.47.17m5.007 6.38q-.7 0-1.23-.24a2.8 2.8 0 0 1-.9-.63 2.9 2.9 0 0 1-.55-.89 2.9 2.9 0 0 1-.18-1v-.18q0-.51.19-1 .19-.5.56-.89.369-.4.9-.63a2.9 2.9 0 0 1 1.21-.24q.68 0 1.21.24.53.23.9.63.37.39.56.89.19.49.19 1v.18q0 .51-.19 1-.18.49-.55.89-.36.39-.89.63-.531.24-1.23.24m0-.86q.6 0 1.02-.26.43-.27.65-.72.23-.45.23-1.01 0-.57-.23-1.02a1.75 1.75 0 0 0-.66-.71q-.42-.26-1.01-.26-.58 0-1.01.26t-.66.71a2.2 2.2 0 0 0-.23 1.02q0 .56.22 1.01.23.45.65.72.43.26 1.03.26m4.297.68v-5.34h.76v2.29h-.12q0-.79.21-1.33.22-.55.66-.83.441-.29 1.11-.29h.04q1.01 0 1.49.63.49.63.49 1.82V54h-.96v-3.25q0-.62-.35-.99-.35-.38-.96-.38-.63 0-1.02.39t-.39 1.04V54zm-49.29 16.216q-.804 0-1.416-.336a2.43 2.43 0 0 1-.96-1.008q-.348-.66-.384-1.596h.252V70H74.2v-8.76h1.668v4.38l-.444.684q.048-1.008.396-1.68.36-.672.96-1.008t1.356-.336q.672 0 1.224.252t.948.708q.396.444.6 1.044.216.6.216 1.308v.252q0 .708-.216 1.32a3.3 3.3 0 0 1-.624 1.08q-.408.456-.984.72-.564.252-1.272.252m-.372-1.404q.54 0 .936-.264.408-.276.636-.744t.228-1.08q0-.624-.228-1.08a1.7 1.7 0 0 0-.636-.708 1.7 1.7 0 0 0-.936-.252q-.492 0-.912.216a1.76 1.76 0 0 0-.672.636q-.252.42-.252 1.008v.48q0 .564.264.96t.684.612.888.216M86.539 70v-1.932h-.276V65.92q0-.564-.276-.84t-.852-.276q-.3 0-.72.012t-.852.036q-.42.012-.756.036v-1.416q.276-.024.624-.048t.708-.024q.372-.012.696-.012 1.008 0 1.668.264.672.264 1.008.828.348.564.348 1.476V70zm-2.1.168q-.708 0-1.248-.252a1.96 1.96 0 0 1-.828-.72q-.288-.468-.288-1.128 0-.72.348-1.176.36-.456.996-.684.648-.228 1.512-.228h1.512v.996h-1.536q-.576 0-.888.288-.3.276-.3.72t.3.72q.312.276.888.276.348 0 .636-.12.3-.132.492-.432.204-.312.228-.84l.408.468q-.06.684-.336 1.152a1.8 1.8 0 0 1-.744.72q-.468.24-1.152.24m8.098.06q-.852 0-1.476-.288a3.1 3.1 0 0 1-1.032-.768 3.3 3.3 0 0 1-.612-1.08 3.8 3.8 0 0 1-.204-1.224v-.228q0-.66.204-1.26.216-.612.636-1.08.42-.48 1.032-.756.624-.288 1.44-.288.852 0 1.524.336.672.324 1.068.912.408.588.456 1.368h-1.62a1.3 1.3 0 0 0-.432-.84q-.36-.336-.996-.336-.552 0-.924.264-.36.264-.54.732-.18.456-.18 1.056 0 .576.168 1.044.18.468.54.732.372.264.948.264.432 0 .744-.156t.492-.432q.192-.276.24-.624h1.62a2.66 2.66 0 0 1-.468 1.392q-.408.588-1.092.924-.672.336-1.536.336M101.53 70l-2.183-3.048h-.972l2.771-3.468h1.74l-2.556 3.204.036-.84L103.413 70zm-4.56 0v-8.76h1.669V70zm10.112.228q-.84 0-1.476-.288a3.1 3.1 0 0 1-1.044-.768 3.6 3.6 0 0 1-.624-1.092 3.8 3.8 0 0 1-.204-1.224v-.228q0-.648.204-1.248.216-.612.624-1.08.42-.48 1.032-.756.612-.288 1.416-.288 1.056 0 1.764.468.72.456 1.08 1.212.36.744.36 1.608v.6h-5.772v-1.02h4.728l-.516.504q0-.624-.18-1.068a1.43 1.43 0 0 0-.552-.684q-.36-.24-.912-.24t-.936.252a1.6 1.6 0 0 0-.588.732q-.192.468-.192 1.128 0 .612.192 1.092.192.468.588.744.396.264 1.008.264t.996-.24q.384-.252.492-.612h1.536q-.144.672-.552 1.176a2.7 2.7 0 0 1-1.044.78q-.624.276-1.428.276m4.525-.228v-6.516h1.32v2.796h-.12q0-.996.264-1.656.264-.672.78-1.008.528-.336 1.308-.336h.072q1.164 0 1.764.756.6.744.6 2.232V70h-1.668v-3.876q0-.6-.348-.972-.336-.372-.936-.372-.612 0-.996.384-.372.372-.372 1.008V70zm10.481.216a3.1 3.1 0 0 1-1.26-.252 2.9 2.9 0 0 1-.996-.708 3.2 3.2 0 0 1-.648-1.056 3.8 3.8 0 0 1-.228-1.32v-.252q0-.696.216-1.308.228-.612.624-1.068.408-.456.972-.708a3 3 0 0 1 1.272-.264q.768 0 1.344.336.588.324.936.984t.384 1.656l-.492-.576v-4.44h1.668V70h-1.32v-2.772h.288q-.036.996-.408 1.668-.372.66-.984.996-.6.324-1.368.324m.372-1.404q.492 0 .9-.216.408-.228.648-.648.252-.432.252-1.008v-.48q0-.576-.252-.96a1.64 1.64 0 0 0-.66-.6 1.9 1.9 0 0 0-.888-.216q-.54 0-.96.264a1.77 1.77 0 0 0-.648.72 2.5 2.5 0 0 0-.228 1.092q0 .624.24 1.092.24.456.648.708.42.252.948.252m4.983-1.452v-1.464h4.86v1.464zM137.808 70v-1.932h-.276V65.92q0-.564-.276-.84t-.852-.276q-.3 0-.72.012t-.852.036q-.42.012-.756.036v-1.416q.276-.024.624-.048t.708-.024q.372-.012.696-.012 1.008 0 1.668.264.672.264 1.008.828.348.564.348 1.476V70zm-2.1.168q-.708 0-1.248-.252a1.96 1.96 0 0 1-.828-.72q-.288-.468-.288-1.128 0-.72.348-1.176.36-.456.996-.684.648-.228 1.512-.228h1.512v.996h-1.536q-.576 0-.888.288-.3.276-.3.72t.3.72q.312.276.888.276.348 0 .636-.12.3-.132.492-.432.204-.312.228-.84l.408.468q-.06.684-.336 1.152a1.8 1.8 0 0 1-.744.72q-.468.24-1.152.24m5.207 2.232v-8.916h1.32v2.808l-.204-.012q.048-.996.408-1.668.372-.672.984-.996a2.8 2.8 0 0 1 1.368-.336q.696 0 1.248.252.564.252.96.708.408.456.624 1.068.216.6.216 1.296v.252q0 .708-.216 1.32-.204.6-.612 1.068a2.9 2.9 0 0 1-.96.72 3.1 3.1 0 0 1-1.26.252q-.732 0-1.344-.3a2.4 2.4 0 0 1-.972-.948q-.372-.648-.42-1.668l.528.804V72.4zm3.456-3.588q.54 0 .936-.264.408-.264.636-.732.228-.48.228-1.08 0-.624-.228-1.08a1.7 1.7 0 0 0-.636-.708 1.65 1.65 0 0 0-.936-.264q-.492 0-.912.216a1.76 1.76 0 0 0-.672.636q-.252.42-.252 1.008v.48q0 .564.264.96t.684.612.888.216m4.934 3.588v-8.916h1.32v2.808l-.204-.012q.048-.996.408-1.668.372-.672.984-.996a2.8 2.8 0 0 1 1.368-.336q.696 0 1.248.252.564.252.96.708.408.456.624 1.068.216.6.216 1.296v.252q0 .708-.216 1.32-.204.6-.612 1.068a2.9 2.9 0 0 1-.96.72 3.1 3.1 0 0 1-1.26.252q-.732 0-1.344-.3a2.4 2.4 0 0 1-.972-.948q-.372-.648-.42-1.668l.528.804V72.4zm3.456-3.588q.54 0 .936-.264.408-.264.636-.732.228-.48.228-1.08 0-.624-.228-1.08a1.7 1.7 0 0 0-.636-.708 1.65 1.65 0 0 0-.936-.264q-.492 0-.912.216a1.76 1.76 0 0 0-.672.636q-.252.42-.252 1.008v.48q0 .564.264.96t.684.612.888.216",
					fill: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 41.5,
					y: 104.5,
					width: 125,
					height: 41,
					rx: 7.5,
					fill: "#0151C9",
					fillOpacity: .7
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 41.5,
					y: 104.5,
					width: 125,
					height: 41,
					rx: 7.5,
					stroke: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M54.269 122.725q.169-.355.394-.681l-.025-1.625c0-.15.062-.294.18-.394a6.5 6.5 0 0 1 1.976-1.144c.144-.05.3-.037.425.044l1.394.837q.394-.027.787 0l1.394-.837a.52.52 0 0 1 .431-.044 6.5 6.5 0 0 1 1.975 1.138.5.5 0 0 1 .175.393l-.025 1.625q.225.327.394.682l1.419.787c.13.075.225.2.25.35a6.5 6.5 0 0 1 0 2.275.5.5 0 0 1-.25.35l-1.42.788a5 5 0 0 1-.393.681l.025 1.625a.51.51 0 0 1-.181.394 6.5 6.5 0 0 1-1.975 1.143.49.49 0 0 1-.425-.043l-1.394-.838a5.5 5.5 0 0 1-.787 0l-1.394.838a.52.52 0 0 1-.431.043 6.5 6.5 0 0 1-1.975-1.137.5.5 0 0 1-.175-.394l.025-1.625a5 5 0 0 1-.394-.681l-1.419-.788a.5.5 0 0 1-.25-.35 6.5 6.5 0 0 1 0-2.275.5.5 0 0 1 .25-.35z",
					stroke: "#fff",
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M59 127.4a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8",
					stroke: "#fff",
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "m73.485 120 2.63-7.3h1.66l2.71 7.3h-1.01l-2.45-6.66.48.24h-1.18l.51-.24-2.37 6.66zm1.57-2.18.33-.88h3.15l.33.88zm6.629 4.18v-7.34h.76v2.31l-.18-.02q.05-.86.36-1.4.32-.55.83-.81t1.11-.26q.579 0 1.05.22.48.22.82.6t.52.88.18 1.06v.18q0 .56-.19 1.06a2.7 2.7 0 0 1-.54.88 2.47 2.47 0 0 1-1.86.82 2.5 2.5 0 0 1-1.09-.25q-.52-.25-.86-.81t-.39-1.47l.44.8V122zm2.71-2.66q.54 0 .94-.25.4-.26.62-.71.22-.46.22-1.05 0-.6-.22-1.05a1.69 1.69 0 0 0-1.56-.96q-.48 0-.89.22-.411.21-.66.62-.24.4-.24.97v.46q0 .55.25.94.249.39.66.6.41.21.88.21m4.184 2.66v-7.34h.76v2.31l-.18-.02q.05-.86.36-1.4.32-.55.83-.81t1.11-.26q.58 0 1.05.22.48.22.82.6t.52.88.18 1.06v.18q0 .56-.19 1.06a2.7 2.7 0 0 1-.54.88 2.47 2.47 0 0 1-1.86.82 2.5 2.5 0 0 1-1.09-.25q-.52-.25-.86-.81t-.39-1.47l.44.8V122zm2.71-2.66q.54 0 .94-.25.4-.26.62-.71.22-.46.22-1.05 0-.6-.22-1.05a1.69 1.69 0 0 0-1.56-.96q-.48 0-.89.22a1.64 1.64 0 0 0-.66.62q-.24.4-.24.97v.46q0 .55.25.94t.66.6.88.21m4.245.66v-7.3h.96v7.3zm-.74-6.54v-.76h1.7v.76zm3.801 6.54v-5.34h.96V120zm-.82-4.58v-.76h1.78v.76zm1.09-1.62q-.32 0-.48-.17a.63.63 0 0 1-.15-.43q0-.26.15-.43.16-.17.48-.17t.47.17q.16.17.16.43a.6.6 0 0 1-.16.43q-.15.17-.47.17m4.836 6.38q-.69 0-1.2-.24a2.4 2.4 0 0 1-.83-.64 3 3 0 0 1-.5-.9 3.2 3.2 0 0 1-.16-.98v-.18q0-.51.16-1 .17-.49.5-.88.34-.4.84-.64.501-.24 1.17-.24.67 0 1.2.25.54.25.86.71.33.45.37 1.07h-.92q-.07-.5-.46-.83-.39-.34-1.05-.34-.57 0-.95.26t-.57.71-.19 1.02q0 .55.19 1.01.19.45.57.72.39.26.97.26.45 0 .78-.16t.53-.43.24-.61h.92q-.03.63-.37 1.09-.33.46-.88.72-.54.25-1.22.25m7.005-.18v-1.6h-.16v-1.85q0-.55-.29-.83-.28-.28-.83-.28-.31 0-.64.01l-.63.02a10 10 0 0 0-.52.03v-.84q.22-.02.46-.03.249-.02.51-.02.26-.01.5-.01.82 0 1.34.2.52.19.77.63t.25 1.19V120zm-1.75.14a2.5 2.5 0 0 1-1.04-.2q-.43-.21-.67-.6-.23-.39-.23-.94 0-.57.25-.95.26-.38.75-.57.49-.2 1.18-.2h1.45v.72h-1.49q-.58 0-.89.28a.93.93 0 0 0-.31.72q0 .44.31.71t.89.27q.34 0 .65-.12.309-.13.51-.42.21-.3.23-.82l.26.38q-.05.57-.28.96a1.45 1.45 0 0 1-.62.58q-.39.2-.95.2m6.352-.08q-.6 0-1.04-.17a1.32 1.32 0 0 1-.67-.58q-.23-.42-.23-1.13v-5.14h.92v5.26q0 .43.23.67.24.23.67.23h.94v.86zm-2.86-4.68v-.72h3.68v.72zm5.297 4.62v-5.34h.96V120zm-.82-4.58v-.76h1.78v.76zm1.09-1.62q-.32 0-.48-.17a.63.63 0 0 1-.15-.43q0-.26.15-.43.16-.17.48-.17t.47.17q.16.17.16.43a.6.6 0 0 1-.16.43q-.15.17-.47.17m5.007 6.38q-.7 0-1.23-.24a2.8 2.8 0 0 1-.9-.63 2.9 2.9 0 0 1-.55-.89 2.9 2.9 0 0 1-.18-1v-.18q0-.51.19-1 .19-.5.56-.89.369-.4.9-.63a2.9 2.9 0 0 1 1.21-.24q.68 0 1.21.24.53.23.9.63.37.39.56.89.19.49.19 1v.18q0 .51-.19 1-.18.49-.55.89-.36.39-.89.63-.531.24-1.23.24m0-.86q.6 0 1.02-.26.43-.27.65-.72.23-.45.23-1.01 0-.57-.23-1.02a1.75 1.75 0 0 0-.66-.71q-.42-.26-1.01-.26-.58 0-1.01.26t-.66.71a2.2 2.2 0 0 0-.23 1.02q0 .56.22 1.01.23.45.65.72.43.26 1.03.26m4.297.68v-5.34h.76v2.29h-.12q0-.79.21-1.33.22-.55.66-.83.441-.29 1.11-.29h.04q1.01 0 1.49.63.49.63.49 1.82V120h-.96v-3.25q0-.62-.35-.99-.35-.38-.96-.38-.63 0-1.02.39t-.39 1.04V120zm-53.335 18.4v-8.916h1.32v2.808l-.204-.012q.048-.996.408-1.668.372-.672.984-.996a2.8 2.8 0 0 1 1.368-.336q.696 0 1.248.252.564.252.96.708.408.456.624 1.068.216.6.216 1.296v.252q0 .708-.216 1.32-.204.6-.612 1.068a2.9 2.9 0 0 1-.96.72 3.1 3.1 0 0 1-1.26.252q-.732 0-1.344-.3a2.4 2.4 0 0 1-.972-.948q-.372-.648-.42-1.668l.528.804v4.296zm3.456-3.588q.54 0 .936-.264.408-.264.636-.732.228-.48.228-1.08 0-.624-.228-1.08a1.7 1.7 0 0 0-.636-.708 1.65 1.65 0 0 0-.936-.264q-.492 0-.912.216a1.76 1.76 0 0 0-.672.636q-.252.42-.252 1.008v.48q0 .564.264.96t.684.612.888.216M86.322 136v-1.932h-.276v-2.148q0-.564-.276-.84t-.852-.276q-.3 0-.72.012t-.852.036q-.42.012-.756.036v-1.416q.276-.024.624-.048t.708-.024q.372-.012.696-.012 1.008 0 1.668.264.672.264 1.008.828.348.564.348 1.476V136zm-2.1.168q-.708 0-1.248-.252a1.96 1.96 0 0 1-.828-.72q-.288-.468-.288-1.128 0-.72.348-1.176.36-.456.996-.684.648-.228 1.512-.228h1.512v.996H84.69q-.576 0-.888.288-.3.276-.3.72t.3.72q.312.276.888.276.348 0 .636-.12.3-.132.492-.432.204-.312.228-.84l.408.468q-.06.684-.336 1.152a1.8 1.8 0 0 1-.744.72q-.468.24-1.152.24m4.932 2.4v-1.428h1.224q.348 0 .576-.096a.84.84 0 0 0 .396-.288q.156-.192.24-.54l1.752-6.732h1.596l-1.932 7.092q-.192.732-.54 1.164a1.9 1.9 0 0 1-.9.636q-.54.192-1.344.192zm2.028-2.712v-1.32h1.392v1.32zm-.564 0-2.112-6.372h1.68l2.004 6.372zm5.467.144v-6.516h1.32v2.796h-.12q0-.984.252-1.644.252-.672.744-1.008.504-.348 1.248-.348h.072q.756 0 1.248.348.504.336.744 1.008.252.66.252 1.644h-.42q0-.984.252-1.644.264-.672.756-1.008.504-.348 1.248-.348h.072q.756 0 1.26.348.504.336.756 1.008.264.66.264 1.644V136h-1.668v-3.876q0-.612-.312-.972-.312-.372-.888-.372t-.924.384q-.348.372-.348 1.008V136h-1.668v-3.876q0-.612-.312-.972-.312-.372-.888-.372t-.924.384q-.348.372-.348 1.008V136zm14.646.228q-.84 0-1.476-.288a3.1 3.1 0 0 1-1.044-.768 3.6 3.6 0 0 1-.624-1.092 3.8 3.8 0 0 1-.204-1.224v-.228q0-.648.204-1.248.216-.612.624-1.08.42-.48 1.032-.756.612-.288 1.416-.288 1.056 0 1.764.468.72.456 1.08 1.212.36.744.36 1.608v.6h-5.772v-1.02h4.728l-.516.504q0-.624-.18-1.068a1.43 1.43 0 0 0-.552-.684q-.36-.24-.912-.24t-.936.252a1.6 1.6 0 0 0-.588.732q-.192.468-.192 1.128 0 .612.192 1.092.192.468.588.744.396.264 1.008.264t.996-.24q.384-.252.492-.612h1.536q-.144.672-.552 1.176a2.7 2.7 0 0 1-1.044.78q-.624.276-1.428.276m4.526-.228v-6.516h1.32v2.796h-.12q0-.996.264-1.656.264-.672.78-1.008.528-.336 1.308-.336h.072q1.164 0 1.764.756.6.744.6 2.232V136h-1.668v-3.876q0-.6-.348-.972-.336-.372-.936-.372-.612 0-.996.384-.372.372-.372 1.008V136zm10.613.084q-.9 0-1.488-.228a1.67 1.67 0 0 1-.864-.792q-.288-.564-.288-1.512l.012-5.904h1.56l-.012 6.012q0 .48.252.744.264.252.744.252h1.02v1.428zm-3.672-5.376v-1.224h4.608v1.224zm5.461 2.652v-1.464h4.86v1.464zm10.366 2.64v-1.932h-.276v-2.148q0-.564-.276-.84t-.852-.276q-.3 0-.72.012t-.852.036q-.42.012-.756.036v-1.416q.276-.024.624-.048t.708-.024q.372-.012.696-.012 1.008 0 1.668.264.672.264 1.008.828.348.564.348 1.476V136zm-2.1.168q-.708 0-1.248-.252a1.96 1.96 0 0 1-.828-.72q-.288-.468-.288-1.128 0-.72.348-1.176.36-.456.996-.684.648-.228 1.512-.228h1.512v.996h-1.536q-.576 0-.888.288-.3.276-.3.72t.3.72q.312.276.888.276.348 0 .636-.12.3-.132.492-.432.204-.312.228-.84l.408.468q-.06.684-.336 1.152a1.8 1.8 0 0 1-.744.72q-.468.24-1.152.24m5.207 2.232v-8.916h1.32v2.808l-.204-.012q.048-.996.408-1.668.372-.672.984-.996a2.8 2.8 0 0 1 1.368-.336q.696 0 1.248.252.564.252.96.708.408.456.624 1.068.216.6.216 1.296v.252q0 .708-.216 1.32-.204.6-.612 1.068a2.9 2.9 0 0 1-.96.72 3.1 3.1 0 0 1-1.26.252q-.732 0-1.344-.3a2.4 2.4 0 0 1-.972-.948q-.372-.648-.42-1.668l.528.804v4.296zm3.456-3.588q.54 0 .936-.264.408-.264.636-.732.228-.48.228-1.08 0-.624-.228-1.08a1.7 1.7 0 0 0-.636-.708 1.65 1.65 0 0 0-.936-.264q-.492 0-.912.216a1.76 1.76 0 0 0-.672.636q-.252.42-.252 1.008v.48q0 .564.264.96t.684.612.888.216m4.934 3.588v-8.916h1.32v2.808l-.204-.012q.048-.996.408-1.668.372-.672.984-.996a2.8 2.8 0 0 1 1.368-.336q.696 0 1.248.252.564.252.96.708.408.456.624 1.068.216.6.216 1.296v.252q0 .708-.216 1.32-.204.6-.612 1.068a2.9 2.9 0 0 1-.96.72 3.1 3.1 0 0 1-1.26.252q-.732 0-1.344-.3a2.4 2.4 0 0 1-.972-.948q-.372-.648-.42-1.668l.528.804v4.296zm3.456-3.588q.54 0 .936-.264.408-.264.636-.732.228-.48.228-1.08 0-.624-.228-1.08a1.7 1.7 0 0 0-.636-.708 1.65 1.65 0 0 0-.936-.264q-.492 0-.912.216a1.76 1.76 0 0 0-.672.636q-.252.42-.252 1.008v.48q0 .564.264.96t.684.612.888.216",
					fill: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 40.5,
					y: 170.5,
					width: 126,
					height: 41,
					rx: 7.5,
					fill: "#0151C9",
					fillOpacity: .7
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 40.5,
					y: 170.5,
					width: 126,
					height: 41,
					rx: 7.5,
					stroke: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M53.269 188.725q.169-.355.394-.681l-.025-1.625c0-.15.062-.294.18-.394a6.5 6.5 0 0 1 1.976-1.144c.144-.05.3-.037.425.044l1.394.837q.394-.027.787 0l1.394-.837a.52.52 0 0 1 .431-.044 6.5 6.5 0 0 1 1.975 1.138.5.5 0 0 1 .175.393l-.025 1.625q.225.327.394.682l1.419.787c.13.075.225.2.25.35a6.5 6.5 0 0 1 0 2.275.5.5 0 0 1-.25.35l-1.42.788a5 5 0 0 1-.393.681l.025 1.625a.51.51 0 0 1-.181.394 6.5 6.5 0 0 1-1.975 1.143.49.49 0 0 1-.425-.043l-1.394-.838a5.5 5.5 0 0 1-.787 0l-1.394.838a.52.52 0 0 1-.431.043 6.5 6.5 0 0 1-1.975-1.137.5.5 0 0 1-.175-.394l.025-1.625a5 5 0 0 1-.394-.681l-1.419-.788a.5.5 0 0 1-.25-.35 6.5 6.5 0 0 1 0-2.275.5.5 0 0 1 .25-.35z",
					stroke: "#fff",
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M58 193.4a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8",
					stroke: "#fff",
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "m72.485 186 2.63-7.3h1.66l2.71 7.3h-1.01l-2.45-6.66.48.24h-1.18l.51-.24-2.37 6.66zm1.57-2.18.33-.88h3.15l.33.88zm6.629 4.18v-7.34h.76v2.31l-.18-.02q.05-.86.36-1.4.32-.55.83-.81t1.11-.26q.579 0 1.05.22.48.22.82.6t.52.88.18 1.06v.18q0 .56-.19 1.06a2.7 2.7 0 0 1-.54.88 2.47 2.47 0 0 1-1.86.82 2.5 2.5 0 0 1-1.09-.25q-.52-.25-.86-.81t-.39-1.47l.44.8V188zm2.71-2.66q.54 0 .94-.25.4-.26.62-.71.22-.46.22-1.05 0-.6-.22-1.05a1.69 1.69 0 0 0-1.56-.96q-.48 0-.89.22-.411.21-.66.62-.24.4-.24.97v.46q0 .55.25.94.249.39.66.6.41.21.88.21m4.184 2.66v-7.34h.76v2.31l-.18-.02q.05-.86.36-1.4.32-.55.83-.81t1.11-.26q.58 0 1.05.22.48.22.82.6t.52.88.18 1.06v.18q0 .56-.19 1.06a2.7 2.7 0 0 1-.54.88 2.47 2.47 0 0 1-1.86.82 2.5 2.5 0 0 1-1.09-.25q-.52-.25-.86-.81t-.39-1.47l.44.8V188zm2.71-2.66q.54 0 .94-.25.4-.26.62-.71.22-.46.22-1.05 0-.6-.22-1.05a1.69 1.69 0 0 0-1.56-.96q-.48 0-.89.22a1.64 1.64 0 0 0-.66.62q-.24.4-.24.97v.46q0 .55.25.94t.66.6.88.21m4.245.66v-7.3h.96v7.3zm-.74-6.54v-.76h1.7v.76zm3.801 6.54v-5.34h.96V186zm-.82-4.58v-.76h1.78v.76zm1.09-1.62q-.32 0-.48-.17a.63.63 0 0 1-.15-.43q0-.26.15-.43.16-.17.48-.17t.47.17q.16.17.16.43a.6.6 0 0 1-.16.43q-.15.17-.47.17m4.836 6.38q-.69 0-1.2-.24a2.4 2.4 0 0 1-.83-.64 3 3 0 0 1-.5-.9 3.2 3.2 0 0 1-.16-.98v-.18q0-.51.16-1 .17-.49.5-.88.34-.4.84-.64.501-.24 1.17-.24.67 0 1.2.25.54.25.86.71.33.45.37 1.07h-.92q-.07-.5-.46-.83-.39-.34-1.05-.34-.57 0-.95.26t-.57.71-.19 1.02q0 .55.19 1.01.19.45.57.72.39.26.97.26.45 0 .78-.16t.53-.43.24-.61h.92q-.03.63-.37 1.09-.33.46-.88.72-.54.25-1.22.25m7.005-.18v-1.6h-.16v-1.85q0-.55-.29-.83-.28-.28-.83-.28-.31 0-.64.01l-.63.02a10 10 0 0 0-.52.03v-.84q.22-.02.46-.03.249-.02.51-.02.26-.01.5-.01.82 0 1.34.2.52.19.77.63t.25 1.19V186zm-1.75.14a2.5 2.5 0 0 1-1.04-.2q-.43-.21-.67-.6-.23-.39-.23-.94 0-.57.25-.95.26-.38.75-.57.49-.2 1.18-.2h1.45v.72h-1.49q-.58 0-.89.28a.93.93 0 0 0-.31.72q0 .44.31.71t.89.27q.34 0 .65-.12.309-.13.51-.42.21-.3.23-.82l.26.38q-.05.57-.28.96a1.45 1.45 0 0 1-.62.58q-.39.2-.95.2m6.352-.08q-.6 0-1.04-.17a1.32 1.32 0 0 1-.67-.58q-.23-.42-.23-1.13v-5.14h.92v5.26q0 .43.23.67.24.23.67.23h.94v.86zm-2.86-4.68v-.72h3.68v.72zm5.297 4.62v-5.34h.96V186zm-.82-4.58v-.76h1.78v.76zm1.09-1.62q-.32 0-.48-.17a.63.63 0 0 1-.15-.43q0-.26.15-.43.16-.17.48-.17t.47.17q.16.17.16.43a.6.6 0 0 1-.16.43q-.15.17-.47.17m5.007 6.38q-.7 0-1.23-.24a2.8 2.8 0 0 1-.9-.63 2.9 2.9 0 0 1-.55-.89 2.9 2.9 0 0 1-.18-1v-.18q0-.51.19-1 .19-.5.56-.89.369-.4.9-.63a2.9 2.9 0 0 1 1.21-.24q.68 0 1.21.24.53.23.9.63.37.39.56.89.19.49.19 1v.18q0 .51-.19 1-.18.49-.55.89-.36.39-.89.63-.531.24-1.23.24m0-.86q.6 0 1.02-.26.43-.27.65-.72.23-.45.23-1.01 0-.57-.23-1.02a1.75 1.75 0 0 0-.66-.71q-.42-.26-1.01-.26-.58 0-1.01.26t-.66.71a2.2 2.2 0 0 0-.23 1.02q0 .56.22 1.01.23.45.65.72.43.26 1.03.26m4.297.68v-5.34h.76v2.29h-.12q0-.79.21-1.33.22-.55.66-.83.441-.29 1.11-.29h.04q1.01 0 1.49.63.49.63.49 1.82V186h-.96v-3.25q0-.62-.35-.99-.35-.38-.96-.38-.63 0-1.02.39t-.39 1.04V186zm-52.761 16v-6.672q0-1.116.612-1.644.624-.54 1.836-.54h.816v1.284h-.936q-.372 0-.576.204-.192.192-.192.552V202zm-.816-5.184v-1.224h4.188v1.224zM77.948 202v-6.516h1.32v2.76h-.036q0-1.404.6-2.124t1.764-.72h.24v1.452h-.456q-.84 0-1.308.456-.456.444-.456 1.296V202zm8.089.228q-.864 0-1.524-.276a3.3 3.3 0 0 1-1.116-.744 3.4 3.4 0 0 1-.696-1.08 3.5 3.5 0 0 1-.228-1.248v-.252q0-.672.24-1.272.252-.612.708-1.08.468-.48 1.128-.744.66-.276 1.488-.276t1.488.276q.66.264 1.116.744.468.468.708 1.08.24.6.24 1.272v.252q0 .648-.24 1.248-.228.6-.684 1.08-.456.468-1.116.744t-1.512.276m0-1.428q.612 0 1.032-.264.42-.276.636-.732.216-.468.216-1.056 0-.6-.228-1.056a1.65 1.65 0 0 0-.648-.732q-.42-.276-1.008-.276t-1.02.276q-.42.264-.648.732a2.3 2.3 0 0 0-.228 1.056q0 .588.216 1.056.228.456.648.732.42.264 1.032.264m5.013 1.2v-6.516h1.32v2.796h-.12q0-.996.264-1.656.264-.672.78-1.008.528-.336 1.308-.336h.072q1.164 0 1.764.756.6.744.6 2.232V202H95.37v-3.876q0-.6-.348-.972-.336-.372-.936-.372-.612 0-.996.384-.372.372-.372 1.008V202zm10.613.084q-.9 0-1.488-.228a1.67 1.67 0 0 1-.864-.792q-.288-.564-.288-1.512l.012-5.904h1.56l-.012 6.012q0 .48.252.744.264.252.744.252h1.02v1.428zm-3.672-5.376v-1.224h4.608v1.224zm8.889 5.52q-.84 0-1.476-.288a3.1 3.1 0 0 1-1.044-.768 3.6 3.6 0 0 1-.624-1.092 3.8 3.8 0 0 1-.204-1.224v-.228q0-.648.204-1.248.216-.612.624-1.08.42-.48 1.032-.756.612-.288 1.416-.288 1.056 0 1.764.468.72.456 1.08 1.212.36.744.36 1.608v.6h-5.772v-1.02h4.728l-.516.504q0-.624-.18-1.068a1.43 1.43 0 0 0-.552-.684q-.36-.24-.912-.24t-.936.252a1.6 1.6 0 0 0-.588.732q-.192.468-.192 1.128 0 .612.192 1.092.192.468.588.744.396.264 1.008.264t.996-.24q.384-.252.492-.612h1.536q-.144.672-.552 1.176a2.7 2.7 0 0 1-1.044.78q-.624.276-1.428.276m4.525-.228v-6.516h1.32v2.796h-.12q0-.996.264-1.656.264-.672.78-1.008.528-.336 1.308-.336h.072q1.164 0 1.764.756.6.744.6 2.232V202h-1.668v-3.876q0-.6-.348-.972-.336-.372-.936-.372-.612 0-.996.384-.372.372-.372 1.008V202zm10.481.216a3.1 3.1 0 0 1-1.26-.252 2.9 2.9 0 0 1-.996-.708 3.2 3.2 0 0 1-.648-1.056 3.8 3.8 0 0 1-.228-1.32v-.252q0-.696.216-1.308.228-.612.624-1.068.408-.456.972-.708a3 3 0 0 1 1.272-.264q.768 0 1.344.336.588.324.936.984t.384 1.656l-.492-.576v-4.44h1.668V202h-1.32v-2.772h.288q-.036.996-.408 1.668-.372.66-.984.996-.6.324-1.368.324m.372-1.404q.492 0 .9-.216.408-.228.648-.648.252-.432.252-1.008v-.48q0-.576-.252-.96a1.64 1.64 0 0 0-.66-.6 1.9 1.9 0 0 0-.888-.216q-.54 0-.96.264a1.77 1.77 0 0 0-.648.72 2.5 2.5 0 0 0-.228 1.092q0 .624.24 1.092.24.456.648.708.42.252.948.252m4.983-1.452v-1.464h4.86v1.464zm10.366 2.64v-1.932h-.276v-2.148q0-.564-.276-.84t-.852-.276q-.3 0-.72.012t-.852.036q-.42.012-.756.036v-1.416q.276-.024.624-.048t.708-.024q.372-.012.696-.012 1.008 0 1.668.264.672.264 1.008.828.348.564.348 1.476V202zm-2.1.168q-.708 0-1.248-.252a1.96 1.96 0 0 1-.828-.72q-.288-.468-.288-1.128 0-.72.348-1.176.36-.456.996-.684.648-.228 1.512-.228h1.512v.996h-1.536q-.576 0-.888.288-.3.276-.3.72t.3.72q.312.276.888.276.348 0 .636-.12.3-.132.492-.432.204-.312.228-.84l.408.468q-.06.684-.336 1.152a1.8 1.8 0 0 1-.744.72q-.468.24-1.152.24m5.207 2.232v-8.916h1.32v2.808l-.204-.012q.048-.996.408-1.668.372-.672.984-.996a2.8 2.8 0 0 1 1.368-.336q.696 0 1.248.252.564.252.96.708.408.456.624 1.068.216.6.216 1.296v.252q0 .708-.216 1.32-.204.6-.612 1.068a2.9 2.9 0 0 1-.96.72 3.1 3.1 0 0 1-1.26.252q-.732 0-1.344-.3a2.4 2.4 0 0 1-.972-.948q-.372-.648-.42-1.668l.528.804v4.296zm3.456-3.588q.54 0 .936-.264.408-.264.636-.732.228-.48.228-1.08 0-.624-.228-1.08a1.7 1.7 0 0 0-.636-.708 1.65 1.65 0 0 0-.936-.264q-.492 0-.912.216a1.76 1.76 0 0 0-.672.636q-.252.42-.252 1.008v.48q0 .564.264.96t.684.612.888.216m4.934 3.588v-8.916h1.32v2.808l-.204-.012q.048-.996.408-1.668.372-.672.984-.996a2.8 2.8 0 0 1 1.368-.336q.696 0 1.248.252.564.252.96.708.408.456.624 1.068.216.6.216 1.296v.252q0 .708-.216 1.32-.204.6-.612 1.068a2.9 2.9 0 0 1-.96.72 3.1 3.1 0 0 1-1.26.252q-.732 0-1.344-.3a2.4 2.4 0 0 1-.972-.948q-.372-.648-.42-1.668l.528.804v4.296zm3.456-3.588q.54 0 .936-.264.408-.264.636-.732.228-.48.228-1.08 0-.624-.228-1.08a1.7 1.7 0 0 0-.636-.708 1.65 1.65 0 0 0-.936-.264q-.492 0-.912.216a1.76 1.76 0 0 0-.672.636q-.252.42-.252 1.008v.48q0 .564.264.96t.684.612.888.216",
					fill: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 393.5,
					y: 38.5,
					width: 120,
					height: 41,
					rx: 7.5,
					fill: "#0151C9",
					fillOpacity: .7
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 393.5,
					y: 38.5,
					width: 120,
					height: 41,
					rx: 7.5,
					stroke: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M404 64.499h14m-6 0v-11a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0-.5.5v11m12 0v-7a.5.5 0 0 0-.5-.5H412m-5-1.5h2m-1 4h2m-3 2.5h2m5 0h1m-1-2.5h1",
					stroke: "#fff",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M427.871 54v-6.62h.98V54zm-2.22-6.42v-.88h5.42v.88zm8.223 6.6q-.7 0-1.21-.24t-.83-.63a2.8 2.8 0 0 1-.48-.89q-.15-.49-.15-1v-.18q0-.52.15-1.01.159-.49.48-.88a2.2 2.2 0 0 1 .81-.63q.5-.24 1.17-.24.87 0 1.43.38.57.37.84.96.28.59.28 1.26v.43h-4.74v-.72h4.04l-.22.39q0-.57-.18-.98-.18-.42-.54-.65t-.91-.23q-.57 0-.95.26-.37.26-.56.71-.18.45-.18 1.04 0 .57.18 1.03.19.45.58.72.39.26.99.26.63 0 1.02-.28.399-.28.48-.65h.9q-.11.55-.44.95t-.83.61-1.13.21m3.853-.18v-5.34h.76v2.29h-.12q0-.79.21-1.33.219-.55.66-.83.44-.29 1.11-.29h.04q1.01 0 1.49.63.49.63.49 1.82V54h-.96v-3.25q0-.62-.35-.99-.351-.38-.96-.38-.63 0-1.02.39t-.39 1.04V54zm9.626 0v-1.6h-.16v-1.85q0-.55-.29-.83-.28-.28-.83-.28-.31 0-.64.01l-.63.02q-.3.01-.52.03v-.84q.22-.02.46-.03.25-.02.51-.02.26-.01.5-.01.82 0 1.34.2.52.19.77.63t.25 1.19V54zm-1.75.14q-.6 0-1.04-.2-.43-.21-.67-.6-.23-.39-.23-.94 0-.57.25-.95a1.56 1.56 0 0 1 .75-.57q.49-.2 1.18-.2h1.45v.72h-1.49q-.58 0-.89.28a.93.93 0 0 0-.31.72q0 .44.31.71t.89.27q.34 0 .65-.12a1.15 1.15 0 0 0 .51-.42q.21-.3.23-.82l.26.38q-.05.57-.28.96a1.45 1.45 0 0 1-.62.58q-.39.2-.95.2m4.272-.14v-5.34h.76v2.29h-.12q0-.79.21-1.33.22-.55.66-.83.44-.29 1.11-.29h.04q1.01 0 1.49.63.49.63.49 1.82V54h-.96v-3.25q0-.62-.35-.99-.35-.38-.96-.38-.63 0-1.02.39t-.39 1.04V54zm8.477.06q-.6 0-1.04-.17a1.32 1.32 0 0 1-.67-.58q-.23-.42-.23-1.13v-5.14h.92v5.26q0 .43.23.67.24.23.67.23h.94v.86zm-2.86-4.68v-.72h3.68v.72zm-24.987 20.848q-1.188 0-2.04-.42a4.05 4.05 0 0 1-1.392-1.092 4.6 4.6 0 0 1-.78-1.464 5 5 0 0 1-.252-1.524v-.264q0-.816.252-1.608a4.4 4.4 0 0 1 .804-1.44q.54-.648 1.368-1.032.84-.396 1.98-.396 1.188 0 2.064.432.888.42 1.416 1.2.528.768.636 1.8h-1.716a2.06 2.06 0 0 0-.432-1.008 1.95 1.95 0 0 0-.828-.624 2.9 2.9 0 0 0-1.14-.216q-.648 0-1.152.228a2.2 2.2 0 0 0-.84.624 2.9 2.9 0 0 0-.516.96 4.2 4.2 0 0 0-.168 1.224q0 .648.168 1.2.18.552.528.972.348.408.852.636.516.228 1.188.228.984 0 1.656-.48.684-.492.828-1.368h1.716a4 4 0 0 1-.636 1.716 3.7 3.7 0 0 1-1.416 1.248q-.9.468-2.148.468m7.725-.024q-1.127 0-1.751-.744-.612-.744-.612-2.208v-3.78h1.668v3.924q0 .6.336.96.336.348.912.348t.936-.372q.372-.372.372-1.008v-3.852h1.668V70h-1.32v-2.772h.132q0 .984-.252 1.644t-.756.996-1.26.336zm7.809 0q-1.344 0-2.112-.564-.756-.576-.792-1.584h1.5q.036.336.372.612t1.056.276q.6 0 .948-.216.36-.216.36-.588a.6.6 0 0 0-.276-.516q-.264-.192-.912-.252l-.576-.06q-1.092-.12-1.68-.624t-.588-1.344q0-.672.336-1.128t.924-.684q.6-.24 1.368-.24 1.2 0 1.944.528t.78 1.548h-1.5q-.024-.336-.336-.576t-.9-.24q-.528 0-.816.204a.62.62 0 0 0-.288.528.56.56 0 0 0 .228.48q.24.168.768.228l.576.06q1.152.12 1.8.636.66.516.66 1.392 0 .648-.36 1.128-.348.468-.984.732t-1.5.264m7.054-.12q-.9 0-1.488-.228a1.67 1.67 0 0 1-.864-.792q-.288-.564-.288-1.512l.012-5.904h1.56l-.012 6.012q0 .48.252.744.264.252.744.252h1.02v1.428zm-3.672-5.376v-1.224h4.608v1.224zm9.104 5.52q-.864 0-1.524-.276a3.3 3.3 0 0 1-1.116-.744 3.4 3.4 0 0 1-.696-1.08 3.5 3.5 0 0 1-.228-1.248v-.252q0-.672.24-1.272.252-.612.708-1.08.468-.48 1.128-.744.66-.276 1.488-.276t1.488.276q.66.264 1.116.744.468.468.708 1.08.24.6.24 1.272v.252q0 .648-.24 1.248-.228.6-.684 1.08-.456.468-1.116.744t-1.512.276m0-1.428q.612 0 1.032-.264.42-.276.636-.732.216-.468.216-1.056 0-.6-.228-1.056a1.65 1.65 0 0 0-.648-.732q-.42-.276-1.008-.276t-1.02.276q-.42.264-.648.732a2.3 2.3 0 0 0-.228 1.056q0 .588.216 1.056.228.456.648.732.42.264 1.032.264m5.013 1.2v-6.516h1.32v2.796h-.12q0-.984.252-1.644.252-.672.744-1.008.504-.348 1.248-.348h.072q.756 0 1.248.348.504.336.744 1.008.252.66.252 1.644h-.42q0-.984.252-1.644.264-.672.756-1.008.504-.348 1.248-.348h.072q.756 0 1.26.348.504.336.756 1.008.264.66.264 1.644V70h-1.668v-3.876q0-.612-.312-.972-.312-.372-.888-.372t-.924.384q-.348.372-.348 1.008V70h-1.668v-3.876q0-.612-.312-.972-.312-.372-.888-.372t-.924.384q-.348.372-.348 1.008V70zm14.646.228q-.84 0-1.476-.288a3.1 3.1 0 0 1-1.044-.768 3.6 3.6 0 0 1-.624-1.092 3.8 3.8 0 0 1-.204-1.224v-.228q0-.648.204-1.248.216-.612.624-1.08.42-.48 1.032-.756.612-.288 1.416-.288 1.056 0 1.764.468.72.456 1.08 1.212.36.744.36 1.608v.6h-5.772v-1.02h4.728l-.516.504q0-.624-.18-1.068a1.43 1.43 0 0 0-.552-.684q-.36-.24-.912-.24t-.936.252a1.6 1.6 0 0 0-.588.732q-.192.468-.192 1.128 0 .612.192 1.092.192.468.588.744.396.264 1.008.264t.996-.24q.384-.252.492-.612h1.536q-.144.672-.552 1.176a2.7 2.7 0 0 1-1.044.78q-.624.276-1.428.276M482.71 70v-6.516h1.32v2.76h-.036q0-1.404.6-2.124t1.764-.72h.24v1.452h-.456q-.84 0-1.308.456-.456.444-.456 1.296V70zm11.193.228q-1.032 0-1.752-.336a3.25 3.25 0 0 1-1.176-.936 4 4 0 0 1-.672-1.368 6.4 6.4 0 0 1-.204-1.632v-.672q0-1.212.408-2.184a3.4 3.4 0 0 1 1.248-1.536q.84-.576 2.148-.576 1.296 0 2.136.576.84.564 1.236 1.536.408.972.408 2.184v.672q0 .852-.216 1.632a3.9 3.9 0 0 1-.66 1.368 3.14 3.14 0 0 1-1.164.936q-.72.336-1.74.336m0-1.56q1.068 0 1.572-.732.504-.744.504-2.304 0-1.656-.516-2.364-.516-.72-1.56-.72-1.056 0-1.584.72-.516.708-.516 2.34 0 1.572.516 2.316t1.584.744M500.646 70v-7.704l.528.408h-2.316V61.24h3.48V70z",
					fill: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 393.5,
					y: 104.5,
					width: 122,
					height: 41,
					rx: 7.5,
					fill: "#0151C9",
					fillOpacity: .7
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 393.5,
					y: 104.5,
					width: 122,
					height: 41,
					rx: 7.5,
					stroke: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M404 130.499h14m-6 0v-11a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0-.5.5v11m12 0v-7a.5.5 0 0 0-.5-.5H412m-5-1.5h2m-1 4h2m-3 2.5h2m5 0h1m-1-2.5h1",
					stroke: "#fff",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M427.871 120v-6.62h.98V120zm-2.22-6.42v-.88h5.42v.88zm8.223 6.6q-.7 0-1.21-.24t-.83-.63a2.8 2.8 0 0 1-.48-.89 3.4 3.4 0 0 1-.15-1v-.18q0-.52.15-1.01.159-.49.48-.88.32-.4.81-.63.5-.24 1.17-.24.87 0 1.43.38.57.37.84.96.28.59.28 1.26v.43h-4.74v-.72h4.04l-.22.39q0-.57-.18-.98-.18-.42-.54-.65t-.91-.23q-.57 0-.95.26-.37.26-.56.71-.18.45-.18 1.04 0 .57.18 1.03.19.45.58.72.39.26.99.26.63 0 1.02-.28.399-.28.48-.65h.9q-.11.55-.44.95t-.83.61-1.13.21m3.853-.18v-5.34h.76v2.29h-.12q0-.79.21-1.33.219-.55.66-.83.44-.29 1.11-.29h.04q1.01 0 1.49.63.49.63.49 1.82V120h-.96v-3.25q0-.62-.35-.99-.351-.38-.96-.38-.63 0-1.02.39t-.39 1.04V120zm9.626 0v-1.6h-.16v-1.85q0-.55-.29-.83-.28-.28-.83-.28-.31 0-.64.01l-.63.02q-.3.01-.52.03v-.84q.22-.02.46-.03.25-.02.51-.02.26-.01.5-.01.82 0 1.34.2.52.19.77.63t.25 1.19V120zm-1.75.14a2.5 2.5 0 0 1-1.04-.2q-.43-.21-.67-.6-.23-.39-.23-.94 0-.57.25-.95.26-.38.75-.57.49-.2 1.18-.2h1.45v.72h-1.49q-.58 0-.89.28a.93.93 0 0 0-.31.72q0 .44.31.71t.89.27q.34 0 .65-.12.31-.13.51-.42.21-.3.23-.82l.26.38q-.05.57-.28.96a1.45 1.45 0 0 1-.62.58q-.39.2-.95.2m4.272-.14v-5.34h.76v2.29h-.12q0-.79.21-1.33.22-.55.66-.83.44-.29 1.11-.29h.04q1.01 0 1.49.63.49.63.49 1.82V120h-.96v-3.25q0-.62-.35-.99-.35-.38-.96-.38-.63 0-1.02.39t-.39 1.04V120zm8.477.06q-.6 0-1.04-.17a1.32 1.32 0 0 1-.67-.58q-.23-.42-.23-1.13v-5.14h.92v5.26q0 .43.23.67.24.23.67.23h.94v.86zm-2.86-4.68v-.72h3.68v.72zm-25.2 20.848q-1.188 0-2.04-.42a4.05 4.05 0 0 1-1.392-1.092 4.6 4.6 0 0 1-.78-1.464 5 5 0 0 1-.252-1.524v-.264q0-.816.252-1.608a4.4 4.4 0 0 1 .804-1.44q.54-.648 1.368-1.032.84-.396 1.98-.396 1.188 0 2.064.432.888.42 1.416 1.2.528.768.636 1.8h-1.716a2.06 2.06 0 0 0-.432-1.008 1.95 1.95 0 0 0-.828-.624 2.9 2.9 0 0 0-1.14-.216q-.648 0-1.152.228a2.2 2.2 0 0 0-.84.624 2.9 2.9 0 0 0-.516.96 4.2 4.2 0 0 0-.168 1.224q0 .648.168 1.2.18.552.528.972.348.408.852.636.516.228 1.188.228.984 0 1.656-.48.684-.492.828-1.368h1.716a4 4 0 0 1-.636 1.716 3.7 3.7 0 0 1-1.416 1.248q-.9.468-2.148.468m7.726-.024q-1.128 0-1.752-.744-.612-.744-.612-2.208v-3.78h1.668v3.924q0 .6.336.96.336.348.912.348t.936-.372q.372-.372.372-1.008v-3.852h1.668V136h-1.32v-2.772h.132q0 .984-.252 1.644t-.756.996-1.26.336zm7.808 0q-1.344 0-2.112-.564-.756-.576-.792-1.584h1.5q.036.336.372.612t1.056.276q.6 0 .948-.216.36-.216.36-.588a.6.6 0 0 0-.276-.516q-.264-.192-.912-.252l-.576-.06q-1.092-.12-1.68-.624t-.588-1.344q0-.672.336-1.128t.924-.684q.6-.24 1.368-.24 1.2 0 1.944.528t.78 1.548h-1.5q-.024-.336-.336-.576t-.9-.24q-.528 0-.816.204a.62.62 0 0 0-.288.528.56.56 0 0 0 .228.48q.24.168.768.228l.576.06q1.152.12 1.8.636.66.516.66 1.392 0 .648-.36 1.128-.348.468-.984.732t-1.5.264m7.054-.12q-.9 0-1.488-.228a1.67 1.67 0 0 1-.864-.792q-.288-.564-.288-1.512l.012-5.904h1.56l-.012 6.012q0 .48.252.744.264.252.744.252h1.02v1.428zm-3.672-5.376v-1.224h4.608v1.224zm9.104 5.52q-.864 0-1.524-.276a3.3 3.3 0 0 1-1.116-.744 3.4 3.4 0 0 1-.696-1.08 3.5 3.5 0 0 1-.228-1.248v-.252q0-.672.24-1.272.252-.612.708-1.08.468-.48 1.128-.744.66-.276 1.488-.276t1.488.276q.66.264 1.116.744.468.468.708 1.08.24.6.24 1.272v.252q0 .648-.24 1.248-.228.6-.684 1.08-.456.468-1.116.744t-1.512.276m0-1.428q.612 0 1.032-.264.42-.276.636-.732.216-.468.216-1.056 0-.6-.228-1.056a1.65 1.65 0 0 0-.648-.732q-.42-.276-1.008-.276t-1.02.276q-.42.264-.648.732a2.3 2.3 0 0 0-.228 1.056q0 .588.216 1.056.228.456.648.732.42.264 1.032.264m5.013 1.2v-6.516h1.32v2.796h-.12q0-.984.252-1.644.252-.672.744-1.008.504-.348 1.248-.348h.072q.756 0 1.248.348.504.336.744 1.008.252.66.252 1.644h-.42q0-.984.252-1.644.264-.672.756-1.008.504-.348 1.248-.348h.072q.756 0 1.26.348.504.336.756 1.008.264.66.264 1.644V136h-1.668v-3.876q0-.612-.312-.972-.312-.372-.888-.372t-.924.384q-.348.372-.348 1.008V136h-1.668v-3.876q0-.612-.312-.972-.312-.372-.888-.372t-.924.384q-.348.372-.348 1.008V136zm14.646.228q-.84 0-1.476-.288a3.1 3.1 0 0 1-1.044-.768 3.6 3.6 0 0 1-.624-1.092 3.8 3.8 0 0 1-.204-1.224v-.228q0-.648.204-1.248.216-.612.624-1.08.42-.48 1.032-.756.612-.288 1.416-.288 1.056 0 1.764.468.72.456 1.08 1.212.36.744.36 1.608v.6h-5.772v-1.02h4.728l-.516.504q0-.624-.18-1.068a1.43 1.43 0 0 0-.552-.684q-.36-.24-.912-.24t-.936.252a1.6 1.6 0 0 0-.588.732q-.192.468-.192 1.128 0 .612.192 1.092.192.468.588.744.396.264 1.008.264t.996-.24q.384-.252.492-.612h1.536q-.144.672-.552 1.176a2.7 2.7 0 0 1-1.044.78q-.624.276-1.428.276m4.526-.228v-6.516h1.32v2.76h-.036q0-1.404.6-2.124t1.764-.72h.24v1.452h-.456q-.84 0-1.308.456-.456.444-.456 1.296V136zm11.194.228q-1.032 0-1.752-.336a3.25 3.25 0 0 1-1.176-.936 4 4 0 0 1-.672-1.368 6.4 6.4 0 0 1-.204-1.632v-.672q0-1.212.408-2.184a3.4 3.4 0 0 1 1.248-1.536q.84-.576 2.148-.576 1.296 0 2.136.576.84.564 1.236 1.536.408.972.408 2.184v.672q0 .852-.216 1.632a3.9 3.9 0 0 1-.66 1.368 3.14 3.14 0 0 1-1.164.936q-.72.336-1.74.336m0-1.56q1.068 0 1.572-.732.504-.744.504-2.304 0-1.656-.516-2.364-.516-.72-1.56-.72-1.056 0-1.584.72-.516.708-.516 2.34 0 1.572.516 2.316t1.584.744m5.302 1.332v-1.68q0-.552.168-.96.18-.408.576-.72.408-.324 1.068-.612l1.488-.66q.552-.252.84-.612.3-.372.3-.948 0-.636-.384-1.008-.372-.384-1.068-.384t-1.08.384q-.372.384-.372 1.068h-1.644q0-.816.348-1.464.348-.66 1.032-1.032.684-.384 1.716-.384t1.716.372 1.032.996q.348.612.348 1.368v.156q0 .984-.552 1.644-.552.648-1.62 1.128l-1.488.66q-.42.18-.588.384-.168.192-.168.528v.768l-.408-.444h4.86V136z",
					fill: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 393.5,
					y: 170.5,
					width: 122,
					height: 41,
					rx: 7.5,
					fill: "#0151C9",
					fillOpacity: .7
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 393.5,
					y: 170.5,
					width: 122,
					height: 41,
					rx: 7.5,
					stroke: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M404 196.499h14m-6 0v-11a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0-.5.5v11m12 0v-7a.5.5 0 0 0-.5-.5H412m-5-1.5h2m-1 4h2m-3 2.5h2m5 0h1m-1-2.5h1",
					stroke: "#fff",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M427.871 186v-6.62h.98V186zm-2.22-6.42v-.88h5.42v.88zm8.223 6.6q-.7 0-1.21-.24t-.83-.63a2.8 2.8 0 0 1-.48-.89 3.4 3.4 0 0 1-.15-1v-.18q0-.52.15-1.01.159-.49.48-.88.32-.4.81-.63.5-.24 1.17-.24.87 0 1.43.38.57.37.84.96.28.59.28 1.26v.43h-4.74v-.72h4.04l-.22.39q0-.57-.18-.98-.18-.42-.54-.65t-.91-.23q-.57 0-.95.26-.37.26-.56.71-.18.45-.18 1.04 0 .57.18 1.03.19.45.58.72.39.26.99.26.63 0 1.02-.28.399-.28.48-.65h.9q-.11.55-.44.95t-.83.61-1.13.21m3.853-.18v-5.34h.76v2.29h-.12q0-.79.21-1.33.219-.55.66-.83.44-.29 1.11-.29h.04q1.01 0 1.49.63.49.63.49 1.82V186h-.96v-3.25q0-.62-.35-.99-.351-.38-.96-.38-.63 0-1.02.39t-.39 1.04V186zm9.626 0v-1.6h-.16v-1.85q0-.55-.29-.83-.28-.28-.83-.28-.31 0-.64.01l-.63.02q-.3.01-.52.03v-.84q.22-.02.46-.03.25-.02.51-.02.26-.01.5-.01.82 0 1.34.2.52.19.77.63t.25 1.19V186zm-1.75.14a2.5 2.5 0 0 1-1.04-.2q-.43-.21-.67-.6-.23-.39-.23-.94 0-.57.25-.95.26-.38.75-.57.49-.2 1.18-.2h1.45v.72h-1.49q-.58 0-.89.28a.93.93 0 0 0-.31.72q0 .44.31.71t.89.27q.34 0 .65-.12.31-.13.51-.42.21-.3.23-.82l.26.38q-.05.57-.28.96a1.45 1.45 0 0 1-.62.58q-.39.2-.95.2m4.272-.14v-5.34h.76v2.29h-.12q0-.79.21-1.33.22-.55.66-.83.44-.29 1.11-.29h.04q1.01 0 1.49.63.49.63.49 1.82V186h-.96v-3.25q0-.62-.35-.99-.35-.38-.96-.38-.63 0-1.02.39t-.39 1.04V186zm8.477.06q-.6 0-1.04-.17a1.32 1.32 0 0 1-.67-.58q-.23-.42-.23-1.13v-5.14h.92v5.26q0 .43.23.67.24.23.67.23h.94v.86zm-2.86-4.68v-.72h3.68v.72zm-25.194 20.848q-1.188 0-2.04-.42a4.05 4.05 0 0 1-1.392-1.092 4.6 4.6 0 0 1-.78-1.464 5 5 0 0 1-.252-1.524v-.264q0-.816.252-1.608a4.4 4.4 0 0 1 .804-1.44q.54-.648 1.368-1.032.84-.396 1.98-.396 1.188 0 2.064.432.888.42 1.416 1.2.528.768.636 1.8h-1.716a2.06 2.06 0 0 0-.432-1.008 1.95 1.95 0 0 0-.828-.624 2.9 2.9 0 0 0-1.14-.216q-.648 0-1.152.228a2.2 2.2 0 0 0-.84.624 2.9 2.9 0 0 0-.516.96 4.2 4.2 0 0 0-.168 1.224q0 .648.168 1.2.18.552.528.972.348.408.852.636.516.228 1.188.228.984 0 1.656-.48.684-.492.828-1.368h1.716a4 4 0 0 1-.636 1.716 3.7 3.7 0 0 1-1.416 1.248q-.9.468-2.148.468m7.725-.024q-1.128 0-1.752-.744-.612-.744-.612-2.208v-3.78h1.668v3.924q0 .6.336.96.336.348.912.348t.936-.372q.372-.372.372-1.008v-3.852h1.668V202h-1.32v-2.772h.132q0 .984-.252 1.644t-.756.996-1.26.336zm7.809 0q-1.344 0-2.112-.564-.756-.576-.792-1.584h1.5q.036.336.372.612t1.056.276q.6 0 .948-.216.36-.216.36-.588a.6.6 0 0 0-.276-.516q-.264-.192-.912-.252l-.576-.06q-1.092-.12-1.68-.624t-.588-1.344q0-.672.336-1.128t.924-.684q.6-.24 1.368-.24 1.2 0 1.944.528t.78 1.548h-1.5q-.024-.336-.336-.576t-.9-.24q-.528 0-.816.204a.62.62 0 0 0-.288.528.56.56 0 0 0 .228.48q.24.168.768.228l.576.06q1.152.12 1.8.636.66.516.66 1.392 0 .648-.36 1.128-.348.468-.984.732t-1.5.264m7.053-.12q-.9 0-1.488-.228a1.67 1.67 0 0 1-.864-.792q-.288-.564-.288-1.512l.012-5.904h1.56l-.012 6.012q0 .48.252.744.264.252.744.252h1.02v1.428zm-3.672-5.376v-1.224h4.608v1.224zm9.105 5.52q-.864 0-1.524-.276a3.3 3.3 0 0 1-1.116-.744 3.4 3.4 0 0 1-.696-1.08 3.5 3.5 0 0 1-.228-1.248v-.252q0-.672.24-1.272.252-.612.708-1.08.468-.48 1.128-.744.66-.276 1.488-.276t1.488.276q.66.264 1.116.744.468.468.708 1.08.24.6.24 1.272v.252q0 .648-.24 1.248-.228.6-.684 1.08-.456.468-1.116.744t-1.512.276m0-1.428q.612 0 1.032-.264.42-.276.636-.732.216-.468.216-1.056 0-.6-.228-1.056a1.65 1.65 0 0 0-.648-.732q-.42-.276-1.008-.276t-1.02.276q-.42.264-.648.732a2.3 2.3 0 0 0-.228 1.056q0 .588.216 1.056.228.456.648.732.42.264 1.032.264m5.013 1.2v-6.516h1.32v2.796h-.12q0-.984.252-1.644.252-.672.744-1.008.504-.348 1.248-.348h.072q.756 0 1.248.348.504.336.744 1.008.252.66.252 1.644h-.42q0-.984.252-1.644.264-.672.756-1.008.504-.348 1.248-.348h.072q.756 0 1.26.348.504.336.756 1.008.264.66.264 1.644V202h-1.668v-3.876q0-.612-.312-.972-.312-.372-.888-.372t-.924.384q-.348.372-.348 1.008V202h-1.668v-3.876q0-.612-.312-.972-.312-.372-.888-.372t-.924.384q-.348.372-.348 1.008V202zm14.646.228q-.84 0-1.476-.288a3.1 3.1 0 0 1-1.044-.768 3.6 3.6 0 0 1-.624-1.092 3.8 3.8 0 0 1-.204-1.224v-.228q0-.648.204-1.248.216-.612.624-1.08.42-.48 1.032-.756.612-.288 1.416-.288 1.056 0 1.764.468.72.456 1.08 1.212.36.744.36 1.608v.6h-5.772v-1.02h4.728l-.516.504q0-.624-.18-1.068a1.43 1.43 0 0 0-.552-.684q-.36-.24-.912-.24t-.936.252a1.6 1.6 0 0 0-.588.732q-.192.468-.192 1.128 0 .612.192 1.092.192.468.588.744.396.264 1.008.264t.996-.24q.384-.252.492-.612h1.536q-.144.672-.552 1.176a2.7 2.7 0 0 1-1.044.78q-.624.276-1.428.276m4.526-.228v-6.516h1.32v2.76h-.036q0-1.404.6-2.124t1.764-.72h.24v1.452h-.456q-.84 0-1.308.456-.456.444-.456 1.296V202zm11.193.228q-1.032 0-1.752-.336a3.25 3.25 0 0 1-1.176-.936 4 4 0 0 1-.672-1.368 6.4 6.4 0 0 1-.204-1.632v-.672q0-1.212.408-2.184a3.4 3.4 0 0 1 1.248-1.536q.84-.576 2.148-.576 1.296 0 2.136.576.84.564 1.236 1.536.408.972.408 2.184v.672q0 .852-.216 1.632a3.9 3.9 0 0 1-.66 1.368 3.14 3.14 0 0 1-1.164.936q-.72.336-1.74.336m0-1.56q1.068 0 1.572-.732.504-.744.504-2.304 0-1.656-.516-2.364-.516-.72-1.56-.72-1.056 0-1.584.72-.516.708-.516 2.34 0 1.572.516 2.316t1.584.744m8.195 1.56q-1.008 0-1.74-.384a2.8 2.8 0 0 1-1.104-1.02 2.77 2.77 0 0 1-.384-1.44h1.644q0 .636.42 1.032.432.384 1.164.384.492 0 .84-.18.36-.192.552-.516a1.5 1.5 0 0 0 .192-.768q0-.648-.42-1.056-.42-.42-1.152-.42-.36 0-.636.096a1.8 1.8 0 0 0-.468.252l-.78-1.344 2.88-1.968-.108-.204h-3.768v-1.452h5.724v1.752l-2.964 1.968-.924-.168q.228-.072.492-.108.264-.048.576-.048.996 0 1.704.348.72.336 1.104.936t.384 1.38v.156q0 .756-.384 1.392-.384.624-1.104 1.008-.72.372-1.74.372",
					fill: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M313 125h80m-80 0h24c8.837 0 16 7.163 16 16v34c0 8.837 7.163 16 16 16h24m-80-66h24c8.837 0 16-7.163 16-16V75c0-8.837 7.163-16 16-16h24",
					stroke: "#fff",
					strokeWidth: 1.5,
					style: {
						strokeDasharray: "4 5",
						strokeLinecap: "round",
						animation: "moving-border .5s infinite linear"
					}
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "m164.113 125 2.887 2.887 2.887-2.887-2.887-2.887zm2.887.5h80v-1h-80z",
					fill: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "m164.113 191 2.887-2.887 2.887 2.887-2.887 2.887zm26.887.5h-24v-1h24zm56-66h-24v-1h24zM207.5 141v34h-1v-34zm15.5-15.5c-8.56 0-15.5 6.94-15.5 15.5h-1c0-9.113 7.387-16.5 16.5-16.5zm-32 65c8.56 0 15.5-6.94 15.5-15.5h1c0 9.113-7.387 16.5-16.5 16.5z",
					fill: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M164.113 59 167 56.113 169.887 59 167 61.887zm26.887.5h-24v-1h24zm56 66h-24v-1h24zM206.5 109V75h1v34zm16.5 16.5c-9.113 0-16.5-7.387-16.5-16.5h1c0 8.56 6.94 15.5 15.5 15.5zm-32-67c9.113 0 16.5 7.387 16.5 16.5h-1c0-8.56-6.94-15.5-15.5-15.5z",
					fill: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("circle", {
					cx: 313,
					cy: 125,
					r: 3,
					fill: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("circle", {
					cx: 247,
					cy: 125,
					r: 3,
					fill: "#fff"
				})
			]
		}),
		/* @__PURE__ */ (0, J.jsxs)("defs", { children: [/* @__PURE__ */ (0, J.jsx)("clipPath", {
			id: "clip0_6302_74385",
			children: /* @__PURE__ */ (0, J.jsx)("path", {
				fill: "#fff",
				d: "M0 0h560v250H0z"
			})
		}), /* @__PURE__ */ (0, J.jsx)("pattern", {
			id: "pattern0_6302_74385",
			patternContentUnits: "objectBoundingBox",
			width: 1.829,
			height: 4.096,
			children: /* @__PURE__ */ (0, J.jsx)("use", {
				xlinkHref: "#image0_6302_74385",
				transform: "scale(.00179 .004)"
			})
		})] })
	]
}), t_ = () => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "fs-13 fw-4 lh-20 cn-9",
	children: [/* @__PURE__ */ (0, J.jsx)("div", { children: "The Software Release Management provides a unified platform to efficiently package, version, and deliver software products to customers’ environments." }), /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "mt-20",
		children: [
			/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("span", {
				className: "fw-6",
				children: "1. Release Hub: "
			}), /* @__PURE__ */ (0, J.jsx)("span", { children: "Create, collaborate and deploy your software's versions across multiple tenant installations." })] }),
			/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("span", {
				className: "fw-6",
				children: "2. Tenants: "
			}), /* @__PURE__ */ (0, J.jsx)("span", { children: "Tenants represent the organizations you deliver software to." })] }),
			/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("span", {
				className: "fw-6",
				children: "3. Tenant Installations: "
			}), /* @__PURE__ */ (0, J.jsx)("span", { children: "Each tenant can have multiple installations. An installation represents deployment of your software across the tenant's environments." })] })
		]
	})]
}), n_ = ({ headerType: e }) => {
	let t = e === "releases" ? I.RELEASES.ROOT : I.TENANTS.ROOT, { breadcrumbs: n } = ri(t, { alias: {
		...bl(),
		releases: {
			component: /* @__PURE__ */ (0, J.jsx)(Je, {
				heading: "Release Hub",
				isActive: !0
			}),
			linked: !1
		},
		tenants: {
			component: /* @__PURE__ */ (0, J.jsx)(Je, {
				heading: "Tenants",
				isActive: !0
			}),
			linked: !1
		}
	} });
	return /* @__PURE__ */ (0, J.jsx)(pn, {
		additionalHeaderInfo: () => /* @__PURE__ */ (0, J.jsx)(Rt, {
			breadCrumbs: n,
			pathPattern: t,
			SVGImage: e_,
			docLink: "SOFTWARE_DISTRIBUTION_HUB",
			title: "Software Release Management",
			renderDescriptionContent: t_
		}),
		docPath: vt.SOFTWARE_DISTRIBUTION_HUB
	});
}, r_ = "data:image/svg+xml,%3c!--%20-%20Copyright%20(c)%202024.%20Devtron%20Inc.%20--%3e%3csvg%20data-style-override='false'%20width='300'%20height='240'%20viewBox='0%200%20300%20240'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cstyle%3e%20.drone%20{%20animation:%20fly%202s%20alternate%20infinite%20ease-in-out;%20transform-origin:%2070%25%20-50%25;%20}%20@keyframes%20fly%20{%200%25%20{%20transform:%20rotate(-10deg);%20}%20100%25%20{%20transform:%20rotate(10deg);%20}%20}%20.drone_rotor%20{%20animation:%20scale_rotor%200.03s%20alternate%20infinite;%20transform-origin:%20center%20center;%20transform-box:%20fill-box;%20}%20@keyframes%20scale_rotor%20{%200%25%20{%20transform:%20scaleX(0);%20}%20100%25%20{%20transform:%20scaleX(1);%20}%20}%20%3c/style%3e%3cg%20clip-path='url(%23clip0_6556_12156)'%3e%3crect%20x='147.816'%20y='173.797'%20width='82.2993'%20height='66.3308'%20fill='url(%23paint0_linear_6556_12156)'/%3e%3crect%20x='205.549'%20y='119.75'%20width='70.0159'%20height='54.0473'%20fill='url(%23paint1_linear_6556_12156)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M236.387%20156.007C236.715%20155.679%20237.247%20155.679%20237.575%20156.007L239.585%20158.017C239.913%20158.345%20239.913%20158.877%20239.585%20159.206C239.257%20159.534%20238.725%20159.534%20238.397%20159.206L237.821%20158.63V163.972C237.821%20164.436%20237.445%20164.812%20236.981%20164.812C236.517%20164.812%20236.141%20164.436%20236.141%20163.972V158.63L235.565%20159.206C235.237%20159.534%20234.705%20159.534%20234.377%20159.206C234.049%20158.877%20234.049%20158.345%20234.377%20158.017L236.387%20156.007ZM243.853%20155.761C244.076%20155.761%20244.289%20155.85%20244.447%20156.007L246.457%20158.017C246.785%20158.345%20246.785%20158.877%20246.457%20159.206C246.129%20159.534%20245.597%20159.534%20245.269%20159.206L244.693%20158.63V163.972C244.693%20164.436%20244.317%20164.812%20243.853%20164.812C243.389%20164.812%20243.013%20164.436%20243.013%20163.972V158.63L242.437%20159.206C242.109%20159.534%20241.577%20159.534%20241.249%20159.206C240.921%20158.877%20240.921%20158.345%20241.249%20158.017L243.259%20156.007C243.416%20155.85%20243.63%20155.761%20243.853%20155.761ZM235.359%20166.735C235.359%20166.271%20235.735%20165.895%20236.199%20165.895H244.914C245.378%20165.895%20245.754%20166.271%20245.754%20166.735C245.754%20167.199%20245.378%20167.576%20244.914%20167.576H236.199C235.735%20167.576%20235.359%20167.199%20235.359%20166.735Z'%20fill='white'/%3e%3cellipse%20cx='233.187'%20cy='137.56'%20rx='1.84252'%20ry='1.84252'%20fill='%23151A4F'/%3e%3cellipse%20cx='240.557'%20cy='137.56'%20rx='1.84252'%20ry='1.84252'%20fill='%23151A4F'/%3e%3cellipse%20cx='247.927'%20cy='137.56'%20rx='1.84252'%20ry='1.84252'%20fill='%23151A4F'/%3e%3crect%20x='230.116'%20y='184.239'%20width='58.9607'%20height='55.8898'%20fill='url(%23paint2_linear_6556_12156)'/%3e%3crect%20x='249.77'%20y='193.45'%20width='19.6536'%20height='3.68504'%20rx='1.84252'%20fill='%23151A4F'/%3e%3crect%20x='230.116'%20y='173.797'%20width='58.9607'%20height='10.441'%20fill='%23E94A47'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M193.265%20172.174C193.822%20172.174%20194.274%20172.625%20194.274%20173.182C194.274%20179.14%20194.139%20185.071%20194.004%20190.987C193.736%20202.764%20193.47%20214.482%20194.271%20226.24C194.585%20230.849%20195.05%20235.897%20196.091%20240.52C196.213%20241.063%20195.872%20241.603%20195.329%20241.725C194.785%20241.847%20194.246%20241.506%20194.124%20240.963C193.047%20236.181%20192.575%20231.004%20192.259%20226.377C191.452%20214.531%20191.721%20202.649%20191.99%20190.816C192.124%20184.922%20192.257%20179.041%20192.257%20173.182C192.257%20172.625%20192.708%20172.174%20193.265%20172.174Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M188.671%20172.184C189.222%20172.263%20189.605%20172.773%20189.527%20173.324C186.895%20191.814%20183.478%20220.034%20182.842%20227.069C182.276%20233.322%20182.532%20236.625%20182.766%20239.637C182.792%20239.983%20182.819%20240.326%20182.844%20240.668C182.884%20241.224%20182.467%20241.707%20181.912%20241.747C181.356%20241.787%20180.873%20241.37%20180.833%20240.815C180.808%20240.475%20180.782%20240.135%20180.755%20239.789C180.519%20236.744%20180.253%20233.308%20180.834%20226.888C181.475%20219.803%20184.896%20191.543%20187.531%20173.04C187.609%20172.489%20188.12%20172.106%20188.671%20172.184Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M188.99%20172.182C189.542%20172.252%20189.934%20172.756%20189.864%20173.308C188.439%20184.606%20188.07%20201.14%20188.438%20209.065C188.648%20213.596%20189.202%20218.198%20189.762%20222.854C189.84%20223.501%20189.918%20224.148%20189.995%20224.796C190.626%20230.097%20191.203%20235.455%20191.203%20240.741C191.203%20241.298%20190.751%20241.75%20190.195%20241.75C189.638%20241.75%20189.186%20241.298%20189.186%20240.741C189.186%20235.587%20188.623%20230.335%20187.993%20225.035C187.916%20224.39%20187.838%20223.745%20187.761%20223.099C187.201%20218.45%20186.638%20213.769%20186.423%20209.158C186.051%20201.132%20186.422%20184.482%20187.863%20173.056C187.933%20172.504%20188.437%20172.112%20188.99%20172.182Z'%20fill='white'/%3e%3cg%20class='drone'%3e%3crect%20x='193'%20y='62'%20width='38'%20height='22'%20fill='url(%23paint3_linear_6556_12156)'/%3e%3crect%20x='193'%20y='62'%20width='38'%20height='1'%20fill='%23BF2525'/%3e%3crect%20x='192'%20y='56'%20width='40'%20height='6'%20fill='%23E94A47'/%3e%3crect%20x='226'%20y='32'%20width='27'%20height='2'%20fill='%2378A9EF'/%3e%3crect%20x='171'%20y='32'%20width='27'%20height='2'%20fill='%2378A9EF'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M189%2054C189%2042.402%20198.402%2033%20210%2033H214C225.598%2033%20235%2042.402%20235%2054V64H233V54C233%2043.5066%20224.493%2035%20214%2035H210C199.507%2035%20191%2043.5066%20191%2054V64H189V54Z'%20fill='%23D6D7D8'/%3e%3cpath%20d='M228%2036C217.333%2036%20206.667%2036%20196%2036C196%2027.1634%20203.163%2020%20212%2020C220.837%2020%20228%2027.1634%20228%2036Z'%20fill='%231F2463'/%3e%3cpath%20d='M257%2027H255V29H254C252.895%2029%20252%2029.8954%20252%2031V33C252%2034.1046%20252.895%2035%20254%2035H255V37H257V35H258C259.105%2035%20260%2034.1046%20260%2033V31C260%2029.8954%20259.105%2029%20258%2029H257V27Z'%20fill='%23A1C3FC'/%3e%3cpath%20d='M213%2027H211V29H210C208.895%2029%20208%2029.8954%20208%2031V33C208%2034.1046%20208.895%2035%20210%2035H211V37H213V35H214C215.105%2035%20216%2034.1046%20216%2033V31C216%2029.8954%20215.105%2029%20214%2029H213V27Z'%20fill='%23A1C3FC'/%3e%3cpath%20d='M169%2027H167V29H166C164.895%2029%20164%2029.8954%20164%2031V33C164%2034.1046%20164.895%2035%20166%2035H167V37H169V35H170C171.105%2035%20172%2034.1046%20172%2033V31C172%2029.8954%20171.105%2029%20170%2029H169V27Z'%20fill='%23A1C3FC'/%3e%3crect%20x='208'%20y='67'%20width='8'%20height='2'%20rx='1'%20fill='%23151A4F'/%3e%3cpath%20class='drone_rotor'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M161.365%2026.4992L154.98%2025.9985L155.02%2025.5L167.76%2026.4992H185V26.9992H174.135L180.52%2027.5L180.48%2027.9985L167.74%2026.9992H150.5V26.4992H161.365Z'%20fill='%231D72D8'/%3e%3cpath%20class='drone_rotor'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M256.812%2026.9988L241.524%2028.4976L241.476%2028L251.688%2026.9988H237V26.4988H256.788L266.976%2025.5L267.024%2025.9976L261.912%2026.4988H271.5V26.9988H256.812Z'%20fill='%231D72D8'/%3e%3cpath%20class='drone_rotor'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M212.812%2026.9988L197.524%2028.4976L197.476%2028L207.688%2026.9988H193V26.4988H212.788L222.976%2025.5L223.024%2025.9976L217.912%2026.4988H227.5V26.9988H212.812Z'%20fill='%231D72D8'/%3e%3c/g%3e%3cpath%20d='M46.1272%2074.9719C46.1891%2071.2917%2046.1891%2069.4685%2046.7969%2065.822C45.1346%2065.3137%2041.625%2065.8811%2038.8766%2065.9505C38.9239%2067.7818%2038.7071%2071.4913%2037.3062%2074.0927C38.4603%2076.2632%2039.953%2077.326%2041.7853%2077.2805C43.6171%2077.2342%2045.0635%2076.4651%2046.1272%2074.9719Z'%20fill='%23F3A29D'/%3e%3cpath%20d='M46.593%2048.1657C48.4263%2049.1325%2050.0236%2050.8593%2051.0436%2052.9882C51.3636%2053.6561%2051.1843%2053.998%2051.8239%2055.0625C52.4367%2056.0823%2053.2588%2057.3061%2054.2914%2058.7318L52.2697%2060.1461C51.5661%2063.5582%2050.0087%2065.8175%2047.6002%2066.9264C45.1915%2068.0329%2042.9945%2068.0293%2041.0103%2066.9114C36.8241%2064.4409%2035.4614%2061.0199%2036.9209%2056.6506C38.3803%2052.2812%2041.6047%2049.4527%2046.593%2048.1657Z'%20fill='%23FAB6AF'/%3e%3cpath%20d='M46.4534%2057.872C45.9829%2056.424%2046.5494%2054.9216%2047.7558%2054.5296C48.6926%2054.2253%2049.7108%2054.6894%2050.3394%2055.59C50.5375%2055.3339%2050.7395%2055.1261%2050.9453%2054.9655L51.0929%2054.8588C51.2781%2054.7356%2051.4426%2054.6468%2051.5907%2054.5954C51.2599%2053.4471%2051.6791%2052.2876%2052.598%2051.989C53.5434%2051.6818%2054.5966%2052.4228%2054.9802%2053.6034C55.3638%2054.7839%2054.9473%2056.0025%2054.0019%2056.3096C53.1605%2056.583%2052.2338%2056.0262%2051.7696%2055.0683C51.6784%2055.0972%2051.5425%2055.166%2051.3725%2055.2791C51.1291%2055.441%2050.8806%2055.6948%2050.6297%2056.0413L50.6139%2056.0644C50.6748%2056.1932%2050.7285%2056.328%2050.774%2056.4681C51.2445%2057.9161%2050.678%2059.4185%2049.4716%2059.8104C48.2652%2060.2024%2046.9238%2059.3199%2046.4534%2057.872ZM52.754%2052.4691C52.1086%2052.6788%2051.7942%2053.5988%2052.0998%2054.5393C52.4053%2055.4798%2053.2005%2056.0393%2053.8459%2055.8296C54.4913%2055.6199%2054.8057%2054.6999%2054.5001%2053.7594C54.1945%2052.8188%2053.3994%2052.2594%2052.754%2052.4691ZM47.9118%2055.0097C46.997%2055.3069%2046.5424%2056.5126%2046.9334%2057.716C47.3245%2058.9194%2048.4009%2059.6276%2049.3156%2059.3304C50.2303%2059.0332%2050.685%2057.8275%2050.2939%2056.6241C49.9029%2055.4207%2048.8265%2054.7125%2047.9118%2055.0097Z'%20fill='%23222768'/%3e%3cpath%20d='M60.7751%20108.972C58.344%20107.027%2054.0898%20103.3%2052.2665%20101.679L49.2278%20116.873L71.1068%20118.088L72.9301%20115.05C69.8913%20113.834%2063.2061%20110.917%2060.7751%20108.972Z'%20fill='%23FBB4AD'/%3e%3cpath%20d='M57.7363%20122.343L60.7751%2098.0328C56.7234%2098.0328%2047.5261%2096.8173%2043.1503%2091.9553C37.6805%2085.8778%2039.5038%2077.9771%2035.2495%2078.5848C30.9953%2079.1926%2024.9178%20104.11%2027.9565%20113.834C30.3875%20121.614%2048.8226%20122.748%2057.7363%20122.343Z'%20fill='url(%23paint4_linear_6556_12156)'/%3e%3cpath%20d='M48.62%2098.6406C46.6752%2091.3476%2046.189%2079.3952%2046.189%2074.3306C43.1502%2074.9383%2036.2219%2075.9107%2032.8185%2074.9383C24.9177%2093.1708%2010.9395%20104.718%2010.9395%20113.227C10.9395%20116.63%2012.5601%20118.696%2013.3705%20119.304C15.3963%20120.114%2022.1221%20121.735%2032.8185%20121.735C43.5149%20121.735%2051.8613%20116.873%2054.6975%20114.442C53.482%20112.214%2050.5648%20105.934%2048.62%2098.6406Z'%20fill='url(%23paint5_linear_6556_12156)'/%3e%3cpath%20d='M-5.72205e-05%20240L5.40217%20223.658H17.2871C17.6247%20225.66%2022.7568%20229.226%2024.9177%20230.522C27.6188%20232.143%2032.9535%20234.598%2035.1144%20236.218C36.8431%20237.515%2038.3558%20239.28%2038.896%20240H-5.72205e-05Z'%20fill='url(%23paint6_linear_6556_12156)'/%3e%3cpath%20d='M29.1721%20240L35.0065%20223.658H46.4592C46.7968%20225.66%2051.929%20229.226%2054.0898%20230.522C56.791%20232.143%2062.1257%20234.598%2064.2866%20236.218C66.0153%20237.515%2067.5279%20239.28%2068.0681%20240H29.1721Z'%20fill='url(%23paint7_linear_6556_12156)'/%3e%3cpath%20d='M23.7022%20147.868C26.1332%20137.658%2025.5255%20120.52%2024.9177%20113.227H45.5813C45.3787%20119.304%2045.0951%20133.525%2045.5813%20141.791C46.0675%20150.056%2027.1462%20200.338%2017.6247%20224.445H4.86197C4.05163%20220.596%202.67406%20211.074%203.64646%20203.781C4.86197%20194.665%2020.6635%20160.631%2023.7022%20147.868Z'%20fill='url(%23paint8_linear_6556_12156)'/%3e%3cpath%20d='M23.7022%20127.205C22.7298%20122.343%2023.297%20115.86%2023.7022%20113.227H45.5812C48.8226%20126.8%2055.4268%20155.769%2055.913%20163.062C56.3992%20170.355%2050.0381%20207.023%2046.7967%20224.445H34.6417C33.2236%20222.419%2030.2659%20217.152%2029.7797%20212.29C29.1719%20206.212%2030.9952%20200.743%2031.6029%20197.096C32.2107%20193.45%2030.9952%20186.988%2030.9952%20181.902C30.9952%20176.817%2034.034%20164.885%2033.4262%20157.592C32.8184%20150.299%2024.9177%20133.282%2023.7022%20127.205Z'%20fill='url(%23paint9_linear_6556_12156)'/%3e%3crect%20x='23.0405'%20y='169.248'%20width='115.473'%20height='8.50851'%20transform='rotate(-46%2023.0405%20169.248)'%20fill='%23F04C49'/%3e%3cpath%20d='M20.3574%20163.277L100.571%2080.2133L103.255%2086.1838L23.0405%20169.248L20.3574%20163.277Z'%20fill='url(%23paint10_linear_6556_12156)'/%3e%3cpath%20d='M29.161%20175.158L109.375%2092.0941L115.436%2094.5672L35.2215%20177.631L29.161%20175.158Z'%20fill='url(%23paint11_linear_6556_12156)'/%3e%3cpath%20d='M117.882%2071.5835L128.268%2066.4057L123.456%2076.9663L117.882%2071.5835Z'%20fill='%23171C54'/%3e%3cpath%20d='M117.882%2071.5835L100.571%2080.2132L103.254%2086.1837L109.375%2092.0942L115.436%2094.5673L123.456%2076.9663L117.882%2071.5835Z'%20fill='%23D2D2D2'/%3e%3cpath%20d='M59.5596%20138.752C55.1838%20137.78%2045.9865%20131.864%2041.9348%20129.028L47.4046%20115.05C48.4175%20116.67%2051.4157%20121.249%2055.3053%20126.597C59.1949%20131.945%2063.8138%20134.093%2065.6371%20134.498C68.0681%20131.459%2072.0793%20129.636%2075.118%20127.205C75.3206%20127.61%2075.8473%20128.663%2075.3611%20129.636C74.7534%20130.851%2071.1069%20132.675%2072.9301%20133.89C74.3887%20134.862%2078.3999%20132.675%2080.2231%20131.459C80.2231%20133.485%2079.3723%20137.901%2075.9689%20139.36C71.7146%20141.183%2065.0293%20139.968%2059.5596%20138.752Z'%20fill='%23FBB4AD'/%3e%3cpath%20d='M43.758%20137.537L53.482%20112.619C49.4303%20112.011%2040.8408%20109.094%2038.896%20102.287C36.9512%2095.4803%2042.9477%2080.8132%2046.189%2074.3306C46.189%2074.3306%2042.2029%2075.3524%2039.5037%2075.5461C37.1246%2075.7168%2033.4262%2075.5461%2033.4262%2075.5461C30.9952%2078.1797%2025.5254%2084.2977%2023.0944%2087.7011C20.0557%2091.9553%2013.3704%20105.326%2015.1937%20113.227C17.0169%20121.127%2021.8789%20120.52%2026.7409%20124.774C31.603%20129.028%2032.2107%20133.282%2036.465%20135.713C39.8684%20137.658%2042.7451%20137.739%2043.758%20137.537Z'%20fill='%23428DFB'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M42.8863%2060.7564C42.5006%2061.8583%2042.2386%2063.267%2042.2386%2065.2142C42.2386%2069.2602%2045.08%2072.5714%2046.3472%2074.0482C46.3719%2074.0771%2046.3961%2074.1052%2046.4196%2074.1327L45.9582%2074.5282C45.9285%2074.4936%2045.8977%2074.4577%2045.8658%2074.4206C44.6027%2072.9499%2041.6309%2069.4896%2041.6309%2065.2142C41.6309%2063.211%2041.9006%2061.7329%2042.3126%2060.5557C42.7249%2059.3779%2043.2746%2058.5159%2043.8129%2057.7469C43.9138%2057.6028%2044.0135%2057.4628%2044.1115%2057.3254C44.5409%2056.7229%2044.9368%2056.1675%2045.25%2055.5112C45.6287%2054.7177%2045.8851%2053.775%2045.8851%2052.4514L46.4928%2052.4514C46.4928%2053.8627%2046.2174%2054.8952%2045.7985%2055.773C45.4603%2056.4817%2045.0273%2057.0886%2044.5956%2057.6937C44.5003%2057.8273%2044.405%2057.9609%2044.3108%2058.0954C43.7855%2058.8458%2043.2717%2059.6551%2042.8863%2060.7564Z'%20fill='black'/%3e%3cpath%20d='M41.3273%2046.0103C44.187%2045.9507%2045.9956%2046.1254%2047.5961%2047.1771C47.6217%2047.1988%2047.6472%2047.2203%2047.6725%2047.2418C48.8964%2048.2773%2049.8419%2049.0773%2050.356%2051.7759C49.5378%2050.3921%2048.2393%2050.0075%2047.6559%2050.037C47.9221%2051.7299%2047.2662%2054.6285%2045.5815%2056.0986C42.4434%2058.8369%2040.9626%2060.3528%2040.9626%2063.3916C40.9626%2069.4691%2043.1505%2073.1156%2044.9738%2075.5466C44.9738%2075.5466%2040.5446%2077.8629%2034.0343%2078.5854C27.524%2079.3078%2023.2621%2077.9561%2023.2621%2077.9561C22.4804%2076.1133%2022.2738%2072.0646%2022.9583%2069.8548C22.8588%2070.0046%2022.7629%2070.156%2022.6714%2070.3086C22.0038%2071.4212%2021.5752%2072.582%2021.5752%2073.7228C21.5752%2075.6335%2021.9745%2076.8808%2022.1508%2077.2334L21.6072%2077.5052C21.3784%2077.0474%2020.9674%2075.7016%2020.9674%2073.7228C20.9674%2072.4325%2021.4504%2071.1623%2022.1502%2069.9959C22.8511%2068.8278%2023.7809%2067.7446%2024.7029%2066.8226C25.6703%2065.8552%2026.6073%2064.9138%2027.2767%2063.8146C27.4619%2063.3196%2027.5861%2062.7779%2027.6236%2062.1763C27.6868%2061.1624%2027.7104%2060.25%2027.7322%2059.4061C27.8124%2056.3033%2027.8687%2054.1266%2029.7799%2051.237C32.3907%2047.2898%2037.4381%2046.0913%2041.3273%2046.0103Z'%20fill='%2323286B'/%3e%3cpath%20d='M78.3998%20124.166C78.3998%20126.597%2080.0204%20129.231%2080.8308%20130.244C81.8437%20129.636%2083.8695%20129.028%2085.6928%20127.205C87.516%20125.382%2088.3264%20123.558%2088.7315%20122.343C88.1238%20121.127%2086.6652%20118.818%2085.6928%20119.304C84.7204%20119.791%2085.6928%20122.343%2086.3005%20123.559C84.6799%20121.938%2081.1954%20118.818%2080.223%20119.304C79.0075%20119.912%2078.3998%20121.128%2078.3998%20124.166Z'%20fill='%23FBB4AD'/%3e%3c/g%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_6556_12156'%20x1='147.816'%20y1='206.962'%20x2='230.116'%20y2='206.962'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23E94A47'/%3e%3cstop%20offset='0.855185'%20stop-color='%23D62929'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_6556_12156'%20x1='205.549'%20y1='146.773'%20x2='275.565'%20y2='146.773'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23E94A47'/%3e%3cstop%20offset='0.855185'%20stop-color='%23D62929'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear_6556_12156'%20x1='230.116'%20y1='212.183'%20x2='289.076'%20y2='212.183'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23E94A47'/%3e%3cstop%20offset='0.855185'%20stop-color='%23D62929'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint3_linear_6556_12156'%20x1='193'%20y1='73'%20x2='231'%20y2='73'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23E94A47'/%3e%3cstop%20offset='0.855185'%20stop-color='%23D62929'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint4_linear_6556_12156'%20x1='45.5813'%20y1='101.071'%20x2='46.3957'%20y2='124.159'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23428DFC'/%3e%3cstop%20offset='1'%20stop-color='%231D72D9'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint5_linear_6556_12156'%20x1='43.1502'%20y1='72.5073'%20x2='30.7978'%20y2='124.044'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.217556'%20stop-color='%23428DFC'/%3e%3cstop%20offset='1'%20stop-color='%230C5FC4'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint6_linear_6556_12156'%20x1='36.0266'%20y1='223.967'%20x2='24.0649'%20y2='250.748'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.090505'%20stop-color='%232C7DE7'/%3e%3cstop%20offset='0.492038'%20stop-color='%231D72D9'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint7_linear_6556_12156'%20x1='65.1987'%20y1='223.967'%20x2='53.2371'%20y2='250.748'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.0747083'%20stop-color='%23428DFC'/%3e%3cstop%20offset='1'%20stop-color='%23428DFC'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint8_linear_6556_12156'%20x1='27.3076'%20y1='113.227'%20x2='-8.66675'%20y2='213.763'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.332054'%20stop-color='%23181D55'/%3e%3cstop%20offset='1'%20stop-color='%231A1F58'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint9_linear_6556_12156'%20x1='36.9461'%20y1='113.227'%20x2='36.5008'%20y2='224.444'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23191D52'/%3e%3cstop%20offset='0.537265'%20stop-color='%23272D78'/%3e%3cstop%20offset='1'%20stop-color='%2323286B'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint10_linear_6556_12156'%20x1='103.195'%20y1='82.7464'%20x2='109.765'%20y2='90.2669'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23D53B3A'/%3e%3cstop%20offset='1'%20stop-color='%23E64542'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint11_linear_6556_12156'%20x1='113.687'%20y1='92.8785'%20x2='120.257'%20y2='100.399'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23E24442'/%3e%3cstop%20offset='1'%20stop-color='%23CC3434'/%3e%3c/linearGradient%3e%3cclipPath%20id='clip0_6556_12156'%3e%3crect%20width='300'%20height='240'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", i_ = 2, a_ = {
	TRACK_NAME_STATE_KEY: "track",
	INITIAL_CLONE_SOURCE_STATE_KEY: "selectedReleaseSource"
}, o_ = Array.from(Array(i_).keys()).map((e) => ({
	id: e,
	name: "",
	description: "",
	createdBy: "",
	createdOn: "",
	releases: Array.from(Array(i_ - e).keys()).map((t) => ({
		id: t,
		name: "",
		status: Z.DRAFT,
		isLocked: !1,
		description: "",
		note: Tc,
		track: "",
		trackId: e,
		version: "",
		createdBy: "",
		createdOn: "",
		tags: [],
		firstReleasedOn: "",
		areAllImagesSelected: !1,
		areDepPresent: !1,
		installationsMappedToRelease: { areAllInstallationsTargeted: !0 }
	}))
})), s_ = /* @__PURE__ */ function(e) {
	return e.track = "track", e;
}({}), c_ = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	"data-style-override": "false",
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M29.2211 2.52661H10.227C9.51914 2.52661 8.94524 3.10052 8.94524 3.80841V19.9535C8.94524 20.6614 9.51914 21.2353 10.227 21.2353H29.2212C29.9291 21.2353 30.503 20.6614 30.503 19.9535V3.80841C30.5029 3.10052 29.929 2.52661 29.2211 2.52661Z",
			fill: "#7E604A"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M19.7241 2.52661H10.227C9.51914 2.52661 8.94524 3.10052 8.94524 3.80841V19.9535C8.94524 20.6614 9.51914 21.2353 10.227 21.2353H19.7241V2.52661Z",
			fill: "#AC825A"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M19.7241 6.31661C20.432 6.31661 21.0059 5.74271 21.0059 5.03481V2.52661H18.4423V5.03481C18.4423 5.74271 19.0162 6.31661 19.7241 6.31661Z",
			fill: "#FF9900"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M19.7241 6.31661V2.52661H18.4423V5.03481C18.4423 5.74271 19.0162 6.31661 19.7241 6.31661Z",
			fill: "#FAD52A"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M20.2759 18.7649H1.2818C0.573906 18.7649 0 19.3388 0 20.0467V36.1918C0 36.8997 0.573906 37.4735 1.2818 37.4735H20.2759C20.9838 37.4735 21.5577 36.8996 21.5577 36.1917V20.0467C21.5577 19.3388 20.9838 18.7649 20.2759 18.7649Z",
			fill: "#FF9900"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M10.7788 18.7649H1.2818C0.573906 18.7649 0 19.3388 0 20.0467V36.1918C0 36.8997 0.573906 37.4735 1.2818 37.4735H10.7788V18.7649Z",
			fill: "#FAD52A"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M10.7788 22.5549C11.4867 22.5549 12.0606 21.981 12.0606 21.2731V18.7649H9.49711V21.2731C9.49703 21.981 10.0709 22.5549 10.7788 22.5549Z",
			fill: "#7E604A"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M10.7788 22.5549V18.7649H9.49703V21.2731C9.49703 21.981 10.0709 22.5549 10.7788 22.5549Z",
			fill: "#AC825A"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M38.7182 18.7649H19.7241C19.0162 18.7649 18.4423 19.3388 18.4423 20.0467V36.1918C18.4423 36.8997 19.0162 37.4736 19.7241 37.4736H38.7182C39.4261 37.4736 40 36.8997 40 36.1918V20.0467C40 19.3388 39.4261 18.7649 38.7182 18.7649Z",
			fill: "#D83249"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M29.2211 18.7649H19.7241C19.0162 18.7649 18.4423 19.3388 18.4423 20.0467V36.1918C18.4423 36.8997 19.0162 37.4736 19.7241 37.4736H29.2211V18.7649Z",
			fill: "#FF4F59"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M29.2211 22.5549C29.929 22.5549 30.5029 21.981 30.5029 21.2731V18.7649H27.9394V21.2731C27.9394 21.981 28.5132 22.5549 29.2211 22.5549Z",
			fill: "#FF9900"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M29.2211 22.5549V18.7649H27.9393V21.2731C27.9394 21.981 28.5132 22.5549 29.2211 22.5549Z",
			fill: "#FAD52A"
		})
	]
}), l_ = ({ handleClose: e, handleSuccess: t }) => {
	let { id: n } = Ai(), r = n !== "add", [i, a, o, s] = K(() => mu(n), [n], r), [c, l] = A(Mc), [u, d] = A(Mc), [f, p] = A(!1);
	O(() => {
		a && (l({
			value: a.name,
			error: ""
		}), d({
			value: a.description,
			error: ""
		}));
	}, [a]);
	let m = (e) => {
		let { isValid: t, message: n } = xi(e);
		return t || l((e) => ({
			...e,
			error: n
		})), t;
	}, h = (e) => {
		let { isValid: t, message: n } = vi(e);
		return t || d((e) => ({
			...e,
			error: n
		})), t;
	};
	return /* @__PURE__ */ (0, J.jsx)($n, {
		className: "visible-modal__body",
		children: /* @__PURE__ */ (0, J.jsx)("div", {
			className: "flexbox bg__primary w-800 h-500 dc__m-auto mt-40 dc__border-radius-8-imp dc__overflow-hidden",
			children: /* @__PURE__ */ (0, J.jsxs)(Ie, {
				error: r && o,
				errorScreenManagerProps: {
					code: o?.code,
					reload: s,
					redirectURL: I.RELEASES.ROOT
				},
				children: [/* @__PURE__ */ (0, J.jsxs)(un, {
					rootClassName: "p-24",
					heading: "Release Track",
					icon: /* @__PURE__ */ (0, J.jsx)(c_, {}),
					documentationLink: "RELEASE_TRACKS",
					children: [
						/* @__PURE__ */ (0, J.jsx)("p", {
							className: "m-0",
							children: "A \"Release Track\" in Devtron is where you organise software releases, like a project or application."
						}),
						/* @__PURE__ */ (0, J.jsx)("p", { children: "Each release within a Release Track is a unique version of your software." }),
						/* @__PURE__ */ (0, J.jsx)("p", {
							className: "m-0",
							children: "Eg. You can think of Kubernetes as a release track, with \"v1.28.8\" as one of its releases."
						})
					]
				}), /* @__PURE__ */ (0, J.jsxs)("form", {
					className: "flexbox-col flex-grow-1 h-100",
					onSubmit: async (i) => {
						if (i.preventDefault(), !m(c.value) || !h(u.value)) {
							B.showToast({
								variant: V.error,
								description: b
							});
							return;
						}
						p(!0);
						let { value: a } = c, o = {
							id: r ? +n : 0,
							name: a,
							description: u.value
						};
						try {
							await hu(o, r), B.showToast({
								variant: V.success,
								description: `Release track ${r ? "updated" : "created"} successfully`
							}), p(!1), t && t(), e(a);
						} catch (e) {
							W(e), p(!1);
						}
					},
					noValidate: !0,
					children: [/* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox-col flex-grow-1 pt-24 pb-24 p-lr-20 dc__gap-16",
						children: [/* @__PURE__ */ (0, J.jsx)(pt, {
							name: "release-track-name",
							value: c.value,
							label: "Release track name",
							placeholder: "Enter a name for this release track",
							onChange: (e) => {
								let { value: t } = e.target;
								l({
									value: t,
									error: ""
								}), m(t);
							},
							required: !0,
							error: c.error,
							disabled: r || i
						}), /* @__PURE__ */ (0, J.jsx)(Un, {
							label: "Description",
							name: "release-track-description",
							value: u.value,
							placeholder: "Write a description for this release track",
							onChange: (e) => {
								let { value: t } = e.target;
								d({
									value: t,
									error: ""
								}), h(t);
							},
							error: u.error
						})]
					}), /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox flex-justify-end dc__gap-12 p-lr-20 pt-20 pb-20",
						children: [/* @__PURE__ */ (0, J.jsx)(M, {
							dataTestId: "cancel-add-edit-release-track",
							text: "Cancel",
							variant: N.secondary,
							style: $e.neutral,
							onClick: () => {
								e();
							}
						}), /* @__PURE__ */ (0, J.jsx)(M, {
							dataTestId: "create-update-release-track",
							text: r ? "Save changes" : "Create release track",
							disabled: i,
							isLoading: f,
							buttonProps: { type: "submit" }
						})]
					})]
				})]
			})
		})
	});
}, u_ = /* @__PURE__ */ function(e) {
	return e.FROM_SCRATCH = "FROM_SCRATCH", e.CLONE = "CLONE", e;
}({}), d_ = (e) => e ? /^.{0,50}$/.test(e) ? { isValid: !0 } : {
	isValid: !1,
	message: sn.getMaxCharMessage(50)
} : { isValid: !0 }, f_ = (e) => ({ track: e.getAll(s_.track).map((e) => e.trim()).filter((e) => !!e) }), p_ = ({ releaseTracks: e, searchKey: t, filterConfig: { track: n } }) => {
	if (e?.length) {
		let r = t.trim().toLowerCase(), i = e.map(({ name: e }) => ({
			label: e,
			value: e
		})), a = n.reduce((e, t) => (e[t] = !0, e), {}), o = r ? e.map(({ releases: e, ...t }) => ({
			...t,
			releases: e.filter((e) => e.name.toLowerCase().includes(r) || e.version.toLowerCase().includes(r))
		})).filter((e) => e.releases.length > 0) : structuredClone(e);
		return n.length > 0 && (o = o.filter(({ name: e }) => a[e])), {
			filteredReleaseTracks: o,
			releaseTrackOptions: i,
			selectedFilterTrackMap: a
		};
	}
	return {
		filteredReleaseTracks: [],
		releaseTrackOptions: [],
		selectedFilterTrackMap: {}
	};
}, m_ = "select-release-clone-source", h_ = {
	NO_CLONE_OPTIONS: "No releases available in this release track",
	SOURCE_RELEASE_TRACK_TOOLTIP: "Releases can only be cloned from the same release track.",
	SOURCE_RELEASE_TRACK_TITLE: "Release track",
	NO_RELEASE_TRACK_FOR_SOURCE_INFO_BAR: "Select a release track first. You'll be able to clone a release from the selected track.",
	SELECT_SOURCE_CLONE_SELECT_LABEL: "Select a release to clone",
	SELECT_SOURCE_CLONE_SELECT_PLACEHOLDER: "Select release",
	CREATE_RELEASE_FROM_SCRATCH: "Create from scratch",
	CLONE_EXISTING_RELEASE: "Clone existing release"
}, g_ = (e) => {
	let { label: t, data: { status: n } } = e;
	return /* @__PURE__ */ (0, J.jsx)(Ii.Option, {
		...e,
		children: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox dc__content-space dc__gap-8",
			children: [/* @__PURE__ */ (0, J.jsx)("h4", {
				className: "m-0 cn-9 fs-13 fw-4 lh-20 dc__truncate",
				children: t
			}), /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox dc__align-items-center dc__gap-4 dc__no-shrink",
				children: [/* @__PURE__ */ (0, J.jsx)("span", {
					className: `icon-dim-14 flex dc__no-shrink dc__fill-available-space ${Bp(n)}`,
					children: qd[n]
				}), /* @__PURE__ */ (0, J.jsx)("p", {
					className: `m-0 cn-7 fs-12 fw-4 lh-20 dc__truncate ${Vp(n)}`,
					children: Gd[n].label
				})]
			})]
		})
	});
}, __ = ({ version: e, id: t, status: n }) => t ? {
	label: e,
	value: String(t),
	status: n
} : null, v_ = ({ releaseCreationType: e, selectedReleaseTrack: t, trackError: n, reloadReleaseList: r, releaseListError: i, releaseList: a, selectedReleaseSource: o, isLoading: s, handleChange: c, handleBlur: l, errorMessage: u }) => {
	if (e !== u_.CLONE) return null;
	if (n || !t) return /* @__PURE__ */ (0, J.jsx)(nn, { description: h_.NO_RELEASE_TRACK_FOR_SOURCE_INFO_BAR });
	let d = a?.map((e) => __({
		id: e.id,
		version: e.version,
		status: e.status
	})) || [];
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox dc__gap-8 dc__align-start w-100",
		children: [
			/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col dc__gap-6",
				children: [/* @__PURE__ */ (0, J.jsx)("span", {
					className: "cn-7 fs-13 fw-4 lh-20",
					children: h_.SOURCE_RELEASE_TRACK_TITLE
				}), /* @__PURE__ */ (0, J.jsx)(D, {
					className: "default-tt w-200",
					content: h_.SOURCE_RELEASE_TRACK_TOOLTIP,
					arrow: !1,
					children: /* @__PURE__ */ (0, J.jsx)("span", {
						className: "p-8 br-4 dc__border bcn-1 cn-6 fs-13 fw-4 lh-20 dc__ellipsis-right w-200 h-36 cursor-not-allowed dc__word-break-all",
						children: t
					})
				})]
			}),
			/* @__PURE__ */ (0, J.jsx)("span", {
				className: "flexbox-col fs-20 fw-4 lh-36 pt-24",
				children: "/"
			}),
			/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col dc__gap-6 w-100",
				children: [
					/* @__PURE__ */ (0, J.jsx)("label", {
						className: "m-0 cn-7 fs-13 fw-4 lh-20 dc__required-field",
						htmlFor: m_,
						children: h_.SELECT_SOURCE_CLONE_SELECT_LABEL
					}),
					/* @__PURE__ */ (0, J.jsx)(Fi, {
						value: o ?? null,
						options: d,
						placeholder: h_.SELECT_SOURCE_CLONE_SELECT_PLACEHOLDER,
						onChange: c,
						onBlur: l,
						isLoading: s,
						isDisabled: s,
						styles: Dc,
						components: {
							IndicatorSeparator: null,
							LoadingIndicator: an,
							NoOptionsMessage: () => i ? /* @__PURE__ */ (0, J.jsx)(Kt, {
								withBorder: !0,
								reload: r
							}) : /* @__PURE__ */ (0, J.jsx)("p", {
								className: "m-0 cn-7 fs-13 fw-4 lh-20 py-6 px-8",
								children: h_.NO_CLONE_OPTIONS
							}),
							Option: g_
						},
						maxMenuHeight: 200,
						inputId: m_
					}),
					u && /* @__PURE__ */ (0, J.jsxs)("span", {
						className: "form__error",
						children: [/* @__PURE__ */ (0, J.jsx)(ce, { className: "form__icon form__icon--error dc__no-shrink" }), u]
					})
				]
			})
		]
	});
}, y_ = ({ releaseCreationType: e, handleReleaseCreationTypeChange: t }) => /* @__PURE__ */ (0, J.jsx)("div", {
	className: "flexbox dc__gap-16 dc__align-items-center",
	children: /* @__PURE__ */ (0, J.jsxs)(xn, {
		className: "radio-group-no-border releases__create-release-modal-radio-group",
		value: e,
		name: "release-creation-type",
		onChange: t,
		children: [/* @__PURE__ */ (0, J.jsx)(Sn, {
			dataTestId: `${u_.FROM_SCRATCH}-radio-item`,
			value: u_.FROM_SCRATCH,
			children: /* @__PURE__ */ (0, J.jsx)("span", {
				className: "cn-9 fs-13 fw-4 lh-20",
				children: h_.CREATE_RELEASE_FROM_SCRATCH
			})
		}), /* @__PURE__ */ (0, J.jsx)(Sn, {
			dataTestId: `${u_.CLONE}-radio-item`,
			value: u_.CLONE,
			children: /* @__PURE__ */ (0, J.jsx)("span", {
				className: "cn-9 fs-13 fw-4 lh-20",
				children: h_.CLONE_EXISTING_RELEASE
			})
		})]
	})
}), b_ = ({ handleClose: e, handleSuccess: t }) => {
	let n = ki(), r = Ai(), i = Oi(), a = Pe(new AbortController()), { releaseId: o } = Ai(), s = !!o, { TRACK_NAME_STATE_KEY: c, INITIAL_CLONE_SOURCE_STATE_KEY: l } = a_, u = i.state?.[c], d = i.state?.[l], [f, p] = A(Mc), [m, h] = A(Mc), [g, _] = A(Mc), [v, y] = A(Mc), [x, S] = A(u_.FROM_SCRATCH), [C, w] = A(null), [T, ee] = A(!1), [E, te, ne, re] = K(pu, [], !d && !s), [ie, ae, oe, D] = K(() => rr(() => _u({
		trackName: f.value,
		signal: a.current.signal
	}), a), [f.value], !f.error && !!f.value && !s), [se, ce, le, ue] = K(() => ql({ id: +o }), [o], s), de = (te ?? []).map((e) => ({
		label: e,
		value: e
	})), fe = k(() => s ? {
		label: ce?.track,
		value: ce?.track
	} : d && u ? {
		label: u,
		value: u
	} : de.find((e) => e.value === f.value) ?? null, [
		JSON.stringify(de),
		f.value,
		ce?.track
	]);
	O(() => {
		u && p({
			...f,
			value: u,
			error: ""
		}), d && (S(u_.CLONE), w({
			value: d,
			error: ""
		}));
	}, [i]), O(() => {
		if (d && f.value === u) {
			w({
				value: d,
				error: ""
			});
			return;
		}
		if (ie || oe) {
			w(null);
			return;
		}
		if (ae?.length > 0) {
			let { id: e, version: t, status: n } = ae[0];
			w({
				value: __({
					id: e,
					version: t,
					status: n
				}),
				error: ""
			});
		}
	}, [
		ie,
		oe,
		JSON.stringify(ae)
	]), O(() => {
		!se && ce && (p({
			value: ce.track,
			error: ""
		}), h({
			value: ce.version,
			error: ""
		}), _({
			value: ce.name,
			error: ""
		}), y({
			value: ce.description,
			error: ""
		}));
	}, [
		se,
		le,
		ce
	]);
	let pe = (e) => e ? fe ? !0 : (p({
		...f,
		error: kc
	}), !1) : (p({
		...f,
		error: Oc
	}), !1), me = (e) => {
		let { isValid: t, message: n } = Si(e);
		return t || h((e) => ({
			...e,
			error: n
		})), t;
	}, he = (e) => {
		let { isValid: t, message: n } = d_(e);
		return t || _((e) => ({
			...e,
			error: n
		})), t;
	}, ge = (e) => {
		let { isValid: t, message: n } = vi(e);
		return t || y((e) => ({
			...e,
			error: n
		})), t;
	}, _e = (e) => x !== u_.CLONE || e?.value ? !0 : (w({
		value: null,
		error: "A release source is required to clone."
	}), !1), ve = (r) => {
		B.showToast({
			variant: V.success,
			description: r
		}), r === "Release created successfully" ? n(q(I.RELEASES.DETAIL.ROOT, {
			releaseTrack: f.value,
			releaseVersion: m.value
		})) : e(), t();
	}, ye = async () => {
		try {
			await Jl({
				id: 0,
				name: g.value,
				description: v.value,
				track: f.value,
				version: m.value,
				tags: [],
				cloneSourceId: x === u_.CLONE ? C?.value?.value : null
			}), ve(Ac);
		} catch (e) {
			W(e), ee(!1);
		}
	}, be = async () => {
		try {
			await Ql({
				id: +o,
				name: g.value,
				description: v.value
			}), ve(jc);
		} catch (e) {
			W(e), ee(!1);
		}
	};
	return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)(Mt, {
		position: "right",
		width: "1024px",
		onEscape: e,
		children: /* @__PURE__ */ (0, J.jsxs)("form", {
			className: "flexbox-col flex-grow-1 bg__primary h-100",
			onSubmit: async (e) => {
				if (e.preventDefault(), ![
					pe(f.value),
					me(m.value),
					ge(v.value),
					he(g.value),
					_e(C?.value)
				].every((e) => e)) {
					B.showToast({
						variant: V.error,
						description: b
					});
					return;
				}
				if (ee(!0), s) {
					await be();
					return;
				}
				await ye();
			},
			onKeyDown: (e) => {
				e.key === "Enter" && e.preventDefault();
			},
			noValidate: !0,
			children: [
				/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox dc__content-space dc__align-items-center pt-12 pb-11 pl-20 pr-20 dc__border-bottom",
					children: [/* @__PURE__ */ (0, J.jsx)("h2", {
						className: "fs-16 fw-6 lh-24 cn-9 m-0-imp dc__truncate",
						children: s ? `Edit release ${ce?.version ? `'${ce.version}'` : ""}` : "Create a new release"
					}), /* @__PURE__ */ (0, J.jsx)(M, {
						dataTestId: "close-create-release-modal",
						onClick: e,
						ariaLabel: "close-modal",
						showAriaLabelInTippy: !1,
						icon: /* @__PURE__ */ (0, J.jsx)(Yt, {
							name: "ic-close-large",
							color: null
						}),
						size: P.xs,
						variant: N.borderLess,
						style: $e.negativeGrey
					})]
				}),
				/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox flex-grow-1 dc__overflow-auto w-100",
					children: [/* @__PURE__ */ (0, J.jsxs)(un, {
						rootClassName: "pl-24 pr-24 pt-24 pb-16 dc__no-shrink",
						heading: "Release",
						icon: /* @__PURE__ */ (0, J.jsx)(id, {}),
						documentationLink: "RELEASES",
						children: [
							/* @__PURE__ */ (0, J.jsx)("p", {
								className: "m-0",
								children: "Each release within a Release Track is a unique version of your software."
							}),
							/* @__PURE__ */ (0, J.jsx)("p", { children: "Eg. You can think of Android as a release track, with \"v15.0\" as one of its releases." }),
							/* @__PURE__ */ (0, J.jsx)("p", {
								className: "m-0",
								children: "Tip: You can also name a release for easier identification like “Marshmallow” or “Nougat”."
							})
						]
					}), /* @__PURE__ */ (0, J.jsx)("div", {
						className: "flexbox-col flex-grow-1 dc__gap-16 pt-20 pb-20 pl-20 pr-20 dc__overflow-auto",
						children: /* @__PURE__ */ (0, J.jsxs)(Ie, {
							isLoading: se,
							progressingProps: { pageLoader: !0 },
							error: le,
							errorScreenManagerProps: {
								code: le?.code,
								reload: ue,
								redirectURL: I.RELEASES.ROOT
							},
							children: [
								/* @__PURE__ */ (0, J.jsxs)("div", {
									className: "flexbox dc__gap-8",
									children: [
										/* @__PURE__ */ (0, J.jsx)("div", {
											className: "w-200",
											children: /* @__PURE__ */ (0, J.jsx)(jn, {
												inputId: "release-track-select",
												label: "Release Track",
												options: de,
												isLoading: E,
												isDisabled: E || !!d || s,
												onChange: (e) => {
													p({
														value: e.value,
														error: ""
													});
												},
												onBlur: () => {
													pe(f.value);
												},
												menuListFooterConfig: {
													type: "button",
													buttonProps: {
														variant: N.borderLess,
														text: "Create release track",
														startIcon: /* @__PURE__ */ (0, J.jsx)(Yt, {
															name: "ic-add",
															color: null
														}),
														onClick: () => {
															n(s ? q(I.RELEASES.EDIT_RELEASE_TRACK_ADD_EDIT, {
																releaseId: r.releaseId,
																id: "add"
															}) : q(I.RELEASES.CREATE_RELEASE_TRACK_ADD_EDIT, { id: "add" }));
														},
														dataTestId: "create-release-track"
													}
												},
												value: fe,
												size: P.large,
												optionListError: ne,
												reloadOptionList: re,
												error: f.error,
												required: !0
											})
										}),
										/* @__PURE__ */ (0, J.jsx)("span", {
											className: "flexbox-col fs-20 fw-4 lh-36 pt-24",
											children: "/"
										}),
										/* @__PURE__ */ (0, J.jsx)(pt, {
											name: "release-version",
											label: "Release Version",
											value: m.value,
											placeholder: "e.g. 1.1.0",
											onChange: (e) => {
												let { value: t } = e.target;
												h({
													value: t,
													error: ""
												}), me(t);
											},
											required: !0,
											error: m.error,
											autoFocus: !s,
											disabled: s,
											helperText: /* @__PURE__ */ (0, J.jsxs)("span", { children: [
												"Version cannot be changed later. Using",
												/* @__PURE__ */ (0, J.jsx)("a", {
													href: En,
													target: "_blank",
													rel: "noreferrer",
													className: "cb-5 dc__no-decor cursor",
													children: "\xA0semantic versioning\xA0"
												}),
												"is recommended for best practices."
											] })
										})
									]
								}),
								/* @__PURE__ */ (0, J.jsx)(pt, {
									name: "release-name",
									label: "Release Name",
									value: g.value,
									placeholder: "Enter a Release Name",
									onChange: (e) => {
										let { value: t } = e.target;
										_({
											value: t,
											error: ""
										}), he(t);
									},
									error: g.error,
									autoFocus: !!s
								}),
								/* @__PURE__ */ (0, J.jsx)(Un, {
									label: "Description",
									name: "release-description",
									value: v.value,
									placeholder: "Write a description for this release",
									onChange: (e) => {
										let { value: t } = e.target;
										y({
											value: t,
											error: ""
										}), ge(t);
									},
									error: v.error
								}),
								!s && /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [
									/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-bottom" }),
									/* @__PURE__ */ (0, J.jsx)(y_, {
										releaseCreationType: x,
										handleReleaseCreationTypeChange: (e) => {
											S(e.target.value);
										}
									}),
									/* @__PURE__ */ (0, J.jsx)(v_, {
										releaseCreationType: x,
										selectedReleaseTrack: fe?.label,
										trackError: f.error,
										reloadReleaseList: D,
										releaseList: ae,
										releaseListError: oe,
										selectedReleaseSource: C?.value,
										errorMessage: C?.error,
										isLoading: ie || E,
										handleChange: (e) => {
											w({
												value: e,
												error: ""
											});
										},
										handleBlur: () => {
											_e(C?.value);
										}
									})
								] })
							]
						})
					})]
				}),
				/* @__PURE__ */ (0, J.jsx)("div", {
					className: "flexbox flex-justify-end pl-20 pr-20 pt-15 pb-16 dc__border-top",
					children: /* @__PURE__ */ (0, J.jsx)("button", {
						type: "submit",
						className: "flex cta h-36",
						disabled: T || E || se || le || x === u_.CLONE && ie && !C,
						children: T ? /* @__PURE__ */ (0, J.jsx)(_n, {}) : /* @__PURE__ */ (0, J.jsx)("span", {
							className: "fs-13 fw-6 lh-20",
							children: s ? "Save changes" : "Create release"
						})
					})
				})
			]
		})
	}), /* @__PURE__ */ (0, J.jsx)(Di, { children: /* @__PURE__ */ (0, J.jsx)(Ei, {
		path: j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.TRACK_ADD_EDIT,
		element: /* @__PURE__ */ (0, J.jsx)(l_, {
			handleClose: (e) => {
				n({ pathname: s ? q(I.RELEASES.EDIT, { releaseId: o }) : I.RELEASES.CREATE }, { ...e ? { state: { [c]: e } } : {} });
			},
			handleSuccess: () => {
				re(), t();
			}
		})
	}) })] });
}, x_ = ({ deleteTrackModalConfig: e, setDeleteTrackModalConfig: t, handleSuccess: n }) => {
	let r = e.name;
	return /* @__PURE__ */ (0, J.jsx)(St, {
		title: r,
		component: "Release Track",
		onDelete: async () => {
			await gu(e.id), n(), t(null);
		},
		subtitle: "Deleting a release track will delete all its release and any requirements added against them.",
		closeConfirmationModal: () => {
			t(null);
		},
		confirmationConfig: {
			identifier: "delete-release-track-confirmation",
			confirmationKeyword: r
		},
		successToastMessage: "Release track deleted successfully",
		onError: (e) => {
			e?.code === Le.BAD_REQUEST ? B.showToast({
				variant: V.warn,
				title: "Cannot delete release track",
				description: "Please delete releases in this track first and try again."
			}) : W(e);
		}
	});
}, S_ = ({ id: e, name: t, track: n, status: r, version: i, refetchReleaseTracks: a }) => {
	let o = ki(), [s, c] = A(!1);
	return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsxs)(gn, {
		autoPosition: !0,
		autoClose: !0,
		children: [/* @__PURE__ */ (0, J.jsx)(gn.Button, {
			isKebab: !0,
			rootClassName: "icon-dim-20 dc__no-shrink p-0 dc__no-background dc__no-border dc__outline-none-imp flex dc__tab-focus dc__hover-n50",
			dataTestId: `edit-${t}-options-button`,
			children: /* @__PURE__ */ (0, J.jsx)(No, { className: "flex icon-dim-16 dc__no-shrink icon-color-n6" })
		}), /* @__PURE__ */ (0, J.jsxs)(gn.Body, {
			rootClassName: "br-4 py-4 dc__overflow-hidden dc__border dc__box-shadow--menu",
			children: [
				/* @__PURE__ */ (0, J.jsxs)("button", {
					type: "button",
					"aria-label": `edit ${t} name`,
					"data-testid": `edit-${t}-name`,
					className: "flexbox dc__transparent dc__hover-n50 dc__align-items-center py-6 px-8 w-100 dc__gap-8",
					onClick: () => {
						o(q(I.RELEASES.EDIT, { releaseId: String(e) }));
					},
					children: [/* @__PURE__ */ (0, J.jsx)(v, { className: "icon-dim-16 dc__no-shrink scn-6" }), /* @__PURE__ */ (0, J.jsx)("span", {
						className: "cn-9 fs-13 fw-4 lh-20",
						children: "Edit release"
					})]
				}),
				/* @__PURE__ */ (0, J.jsxs)("button", {
					type: "button",
					"aria-label": `clone ${t}`,
					"data-testid": `clone-${t}`,
					className: "flexbox dc__transparent dc__hover-n50 dc__align-items-center py-6 px-8 w-100 dc__gap-8",
					onClick: () => {
						let { TRACK_NAME_STATE_KEY: t, INITIAL_CLONE_SOURCE_STATE_KEY: a } = a_, s = __({
							id: e,
							version: i,
							status: r
						});
						o({ pathname: I.RELEASES.CREATE }, { state: {
							[t]: n,
							[a]: s
						} });
					},
					children: [/* @__PURE__ */ (0, J.jsx)(ko, { className: "icon-dim-16 dc__no-shrink" }), /* @__PURE__ */ (0, J.jsx)("span", {
						className: "cn-9 fs-13 fw-4 lh-20",
						children: "Clone release"
					})]
				}),
				/* @__PURE__ */ (0, J.jsxs)("button", {
					type: "button",
					"aria-label": `delete ${t}`,
					"data-testid": `delete-${t}`,
					className: "flexbox dc__transparent dc__hover-n50 dc__align-items-center py-6 px-8 w-100 dc__gap-8",
					onClick: () => {
						c(!0);
					},
					children: [/* @__PURE__ */ (0, J.jsx)(T, { className: "icon-dim-16 scr-5 dc__no-shrink" }), /* @__PURE__ */ (0, J.jsx)("span", {
						className: "cr-5 fs-13 fw-4 lh-20",
						children: "Delete release"
					})]
				})
			]
		})]
	}), s && /* @__PURE__ */ (0, J.jsx)(Dh, {
		handleClose: () => {
			c(!1);
		},
		handleSuccess: a,
		id: e,
		name: t
	})] });
}, C_ = ({ name: e, description: t, createdBy: n, firstReleasedOn: r, status: i, version: a, track: o, id: s, refetchReleaseTracks: c, searchKey: l }) => {
	let u = ki();
	return /* @__PURE__ */ (0, J.jsxs)("button", {
		type: "button",
		className: "dc__transparent p-0 bg__primary br-8 dc__info-card dc__info-card w-100",
		onClick: () => {
			u(q(I.RELEASES.DETAIL.ROOT, {
				releaseTrack: o,
				releaseVersion: a
			}));
		},
		children: [/* @__PURE__ */ (0, J.jsx)("div", {
			className: "p-16 flexbox-col dc__gap-12",
			children: /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col dc__gap-8",
				children: [/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flex dc__content-space",
					children: [/* @__PURE__ */ (0, J.jsx)(id, { className: "icon-dim-32 dc__no-shrink" }), /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox dc__gap-4 dc__align-items-center",
						children: [/* @__PURE__ */ (0, J.jsx)(Yp, {
							id: s,
							currentStatus: i,
							handleStatusChangeSuccess: c
						}, i), /* @__PURE__ */ (0, J.jsx)(S_, {
							id: s,
							name: e,
							track: o,
							status: i,
							version: a,
							refetchReleaseTracks: c
						})]
					})]
				}), /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col dc__gap-4",
					children: [
						/* @__PURE__ */ (0, J.jsx)(D, {
							content: e,
							arrow: !1,
							className: "default-tt dc__word-break",
							placement: "top",
							children: /* @__PURE__ */ (0, J.jsx)("h3", {
								className: "fs-13 lh-20 fw-6 dc__truncate m-0 dc__w-fit-content",
								dangerouslySetInnerHTML: { __html: C.sanitize(zr({
									searchText: l,
									text: e,
									highlightClasses: "bcy-2"
								})) }
							})
						}),
						/* @__PURE__ */ (0, J.jsx)(D, {
							content: a,
							arrow: !1,
							className: "default-tt dc__word-break",
							placement: "top",
							children: /* @__PURE__ */ (0, J.jsx)("span", {
								className: "mono fs-14 lh-20 cn-9 dc__truncate dc__w-fit-content",
								dangerouslySetInnerHTML: { __html: C.sanitize(zr({
									searchText: l,
									text: a,
									highlightClasses: "bcy-2"
								})) }
							})
						}),
						t && /* @__PURE__ */ (0, J.jsx)(D, {
							content: t,
							arrow: !1,
							className: "default-tt dc__word-break",
							placement: "top",
							children: /* @__PURE__ */ (0, J.jsx)("p", {
								className: "fs-12 lh-18 cn-7 dc__ellipsis-right__2nd-line dc__w-fit-content m-0 dc__align-left",
								children: t
							})
						})
					]
				})]
			})
		}), /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flex dc__content-space dc__gap-16 dc__border-top-n1 pt-12 pb-12 pl-16 pr-16 fs-12 lh-18 cn-7",
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "fs-12 lh-18 cn-7 dc__word-break flexbox flex-align-center dc__gap-6",
				children: [/* @__PURE__ */ (0, J.jsx)("div", {
					className: "icon-dim-20 dc__no-shrink flexbox flex-justify-center flex-align-center dc__border-radius-50-per dc__uppercase cn-0 fw-4",
					style: { backgroundColor: Cr(n) },
					children: n[0]
				}), /* @__PURE__ */ (0, J.jsx)("span", {
					className: "dc__truncate",
					children: n
				})]
			}), /* @__PURE__ */ (0, J.jsx)("span", {
				className: "dc__truncate dc__no-shrink",
				children: r ? /* @__PURE__ */ (0, J.jsx)(D, {
					content: "First release date",
					arrow: !1,
					className: "default-tt",
					placement: "top",
					children: /* @__PURE__ */ (0, J.jsx)("span", {
						className: "dc__truncate",
						children: r
					})
				}) : "Not released"
			})]
		})]
	});
}, w_ = ({ id: e, name: t, description: n, releases: r, openDeleteReleaseTrackModal: i, refetchReleaseTracks: a, searchKey: s }) => {
	let c = ki(), l = q(I.RELEASES.TRACK_DETAIL, { trackName: t }), u = () => {
		c(q(I.RELEASES.TRACK_ADD_EDIT, { id: String(e) }));
	}, d = () => {
		c({ pathname: I.RELEASES.CREATE }, { state: { [a_.TRACK_NAME_STATE_KEY]: t } });
	}, f = () => {
		i({
			id: e,
			name: t
		});
	}, p = (e) => /* @__PURE__ */ (0, J.jsx)(D, {
		content: n,
		arrow: !1,
		className: "default-tt dc__word-break",
		placement: "top",
		children: e
	}), m = (e) => {
		switch (e.id) {
			case "edit":
				u();
				break;
			case "delete":
				f();
				break;
			default: break;
		}
	};
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "bg__secondary mw-400 dc__mxw-500 w-100 dc__top-radius-8 flexbox-col flex-grow-1",
		children: [/* @__PURE__ */ (0, J.jsx)("div", {
			className: "flexbox dc__content-space dc__align-start dc__gap-16 pt-12 pb-12 pr-16 pl-16 dc__border-bottom-n1 dc__no-shrink",
			children: /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox dc__gap-4 dc__content-space flex-grow-1",
				children: [/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col",
					children: [/* @__PURE__ */ (0, J.jsx)(D, {
						content: t,
						arrow: !1,
						className: "default-tt dc__word-break",
						placement: "top",
						children: /* @__PURE__ */ (0, J.jsxs)(wi, {
							to: l,
							className: "flexbox dc__align-items-center dc__no-decor fs-14 fw-6 cn-9 m-0 lh-20 dc__w-fit-content",
							children: [/* @__PURE__ */ (0, J.jsx)("span", {
								className: "dc__truncate",
								children: t
							}), /* @__PURE__ */ (0, J.jsx)(g, { className: "icon-dim-24 p-4 dc__no-shrink icon-color-n6 dc__flip-270" })]
						})
					}), /* @__PURE__ */ (0, J.jsx)(lt, {
						condition: !!n,
						wrap: p,
						children: /* @__PURE__ */ (0, J.jsx)("p", {
							className: "cn-7 fs-12 lh-18 m-0 dc__truncate dc__w-fit-content",
							children: n || "No description"
						})
					})]
				}), /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flex top left dc__no-shrink",
					children: [/* @__PURE__ */ (0, J.jsxs)(wi, {
						state: { [a_.TRACK_NAME_STATE_KEY]: t },
						to: { pathname: I.RELEASES.CREATE },
						className: "anchor dc__no-shrink flex py-2 px-4 dc__gap-4 fs-13 lh-20 fw-6",
						onClick: d,
						children: [/* @__PURE__ */ (0, J.jsx)(o, { className: "icon-dim-16 fcb-5" }), /* @__PURE__ */ (0, J.jsx)("span", { children: "New Release" })]
					}), /* @__PURE__ */ (0, J.jsx)(ze, {
						id: "release-track-card-action-menu",
						onClick: m,
						options: [{ items: [{
							id: "edit",
							label: "Edit",
							startIcon: { name: "ic-pencil" }
						}, {
							id: "delete",
							label: "Delete",
							startIcon: { name: "ic-delete" },
							type: "negative"
						}] }],
						buttonProps: {
							dataTestId: "release-track-card-action-menu-button",
							icon: /* @__PURE__ */ (0, J.jsx)(Yt, {
								name: "ic-more-vertical",
								color: null
							}),
							variant: N.borderLess,
							ariaLabel: "Open action menu",
							style: $e.neutral,
							size: P.xs
						}
					})]
				})]
			})
		}), /* @__PURE__ */ (0, J.jsx)("div", {
			className: "flexbox-col dc__gap-12 p-12 dc__overflow-auto flex-grow-1",
			children: r.length ? r.map((t) => /* @__PURE__ */ (0, J.jsx)(C_, {
				...t,
				refetchReleaseTracks: a,
				searchKey: s
			}, `release-${e}-${t.id}`)) : /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col p-16 br-4 dc__border-dashed--n3 dc__gap-8",
				children: [/* @__PURE__ */ (0, J.jsx)("div", {
					className: "flex",
					children: /* @__PURE__ */ (0, J.jsx)(id, { className: "icon-dim-32 dc__blend-luminosity" })
				}), /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flex column dc__gap-4",
					children: [/* @__PURE__ */ (0, J.jsx)("span", {
						className: "fs-13 fw-6 lh-20 cn-9",
						children: "No releases"
					}), /* @__PURE__ */ (0, J.jsx)("span", {
						className: "fs-13 fw-4 lh-20 cn-7",
						children: "No releases are created in this release track"
					})]
				})]
			})
		})]
	});
}, T_ = () => /* @__PURE__ */ (0, J.jsx)("div", {
	className: "flexbox dc__gap-16 pl-20 pr-20 flex-grow-1",
	children: o_.map((e) => /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col bg__secondary dc__top-radius-8 flex-grow-1 dc__mxw-500",
		children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col pl-16 pr-16 pt-12 pb-12 dc__gap-6 show-shimmer-loading dc__border-bottom-n1",
			children: [/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading w-200 h-20" }), /* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading w-100 h-20" })]
		}), /* @__PURE__ */ (0, J.jsx)("div", {
			className: "flexbox-col p-12 dc__gap-12",
			children: e.releases.map((t) => /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col br-8 bg__primary dc__info-card",
				children: [/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col dc__gap-8 p-16 dc__border-bottom-n1",
					children: [/* @__PURE__ */ (0, J.jsx)(id, { className: "icon-dim-32 dc__opacity-0_5 dc__blend-luminosity" }), /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox-col dc__gap-6 show-shimmer-loading",
						children: [/* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading w-200 h-16" }), /* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading w-120 h-16" })]
					})]
				}), /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox pr-16 pl-16 pt-12 pb-12 dc__content-space dc__align-items-center",
					children: [/* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox show-shimmer-loading dc__gap-6 dc__align-items-center",
						children: [/* @__PURE__ */ (0, J.jsx)("span", { className: "w-20 h-20 child child-shimmer-loading dc__border-radius-50-per-imp" }), /* @__PURE__ */ (0, J.jsx)("span", { className: "w-100px h-16 child child-shimmer-loading" })]
					}), /* @__PURE__ */ (0, J.jsx)("div", {
						className: "flex show-shimmer-loading",
						children: /* @__PURE__ */ (0, J.jsx)("span", { className: "child child-shimmer-loading h-16 w-60" })
					})]
				})]
			}, `${e.id}-${t.id}`))
		})]
	}, e.id))
}), E_ = () => {
	let e = ki(), [t, n] = A(null), { searchKey: r = "", handleSearch: i, clearFilters: a, track: s, updateSearchParams: c } = gi({ parseSearchParams: f_ }), [l, u, d, f] = K(() => fu({
		lite: !1,
		fetchChild: !0
	})), { filterConfig: p, filteredReleaseTracks: m, releaseTrackOptions: h, selectedFilterTrackMap: g } = k(() => {
		let e = { track: s };
		return {
			...p_({
				releaseTracks: u,
				searchKey: r,
				filterConfig: e
			}),
			filterConfig: e
		};
	}, [
		r,
		u,
		`${s}`
	]), _ = h.filter((e) => g[e.value]), v = (e) => (t) => {
		c({ [e]: t.map(({ value: e }) => e) });
	}, y = () => {
		e("..");
	};
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col flex-grow-1 dc__overflow-hidden",
		children: [
			/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flex dc__gap-8 dc__content-space py-12 px-20 dc__no-shrink",
				children: [/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flex left dc__gap-8",
					children: [/* @__PURE__ */ (0, J.jsx)(On, {
						inputProps: {
							placeholder: "Search by release name or version",
							disabled: l
						},
						handleEnter: (e) => {
							i(e?.trim());
						},
						initialSearchText: r,
						containerClassName: "w-250",
						keyboardShortcut: "/"
					}), /* @__PURE__ */ (0, J.jsx)(Ht, {
						placeholder: "Release Track",
						options: h,
						isDisabled: l,
						isLoading: l,
						inputId: "release-track-filter",
						appliedFilterOptions: _,
						handleApplyFilter: v(s_.track),
						menuPosition: "absolute"
					})]
				}), /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flex right dc__gap-8",
					children: [/* @__PURE__ */ (0, J.jsx)(M, {
						component: Qe.link,
						linkProps: { to: q(j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.TRACK_ADD_EDIT, { id: "add" }) },
						variant: N.secondary,
						size: P.medium,
						dataTestId: "create-release-track",
						startIcon: /* @__PURE__ */ (0, J.jsx)(o, {}),
						text: "Release Track"
					}), /* @__PURE__ */ (0, J.jsx)(M, {
						component: Qe.link,
						linkProps: { to: q(j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.CREATE) },
						size: P.medium,
						dataTestId: "create-release",
						startIcon: /* @__PURE__ */ (0, J.jsx)(o, {}),
						text: "Create release"
					})]
				})]
			}),
			/* @__PURE__ */ (0, J.jsx)(Bt, {
				filterConfig: p,
				onRemoveFilter: c,
				clearFilters: a,
				className: "px-20"
			}),
			/* @__PURE__ */ (0, J.jsx)(Ie, {
				isLoading: l,
				customLoader: /* @__PURE__ */ (0, J.jsx)(T_, {}),
				error: d,
				errorScreenManagerProps: {
					code: d?.code,
					reload: f
				},
				children: u?.length ? m.length ? /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)("div", {
					className: "flexbox-col flex-grow-1 dc__overflow-auto",
					children: /* @__PURE__ */ (0, J.jsx)("div", {
						className: "flexbox dc__gap-16 fw-4 pt-8 pl-20 pr-20 dc__w-fit-content mw-100p h-100",
						children: m.map((e) => /* @__PURE__ */ (0, J.jsx)(w_, {
							...e,
							openDeleteReleaseTrackModal: n,
							refetchReleaseTracks: f,
							searchKey: r
						}, `release-track-${e.id}`))
					})
				}), !!t && /* @__PURE__ */ (0, J.jsx)(x_, {
					deleteTrackModalConfig: t,
					setDeleteTrackModalConfig: n,
					handleSuccess: f
				})] }) : /* @__PURE__ */ (0, J.jsx)(Gt, { handleClearFilters: a }) : /* @__PURE__ */ (0, J.jsx)(F, {
					title: "Create your first release",
					subTitle: "Release is a snapshot of your software at a specific time, including all components needed for deployment. It adds value by ensuring stability, consistency, traceability, and facilitating collaboration among team members.",
					renderButton: () => /* @__PURE__ */ (0, J.jsx)(M, {
						component: Qe.link,
						linkProps: { to: j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.CREATE },
						dataTestId: "create-release",
						text: "Create release",
						startIcon: /* @__PURE__ */ (0, J.jsx)(o, {})
					}),
					isButtonAvailable: !0,
					image: r_
				})
			}),
			/* @__PURE__ */ (0, J.jsxs)(Di, { children: [
				/* @__PURE__ */ (0, J.jsx)(Ei, {
					path: `${j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.CREATE}/*`,
					element: /* @__PURE__ */ (0, J.jsx)(b_, {
						handleClose: y,
						handleSuccess: U
					})
				}),
				/* @__PURE__ */ (0, J.jsx)(Ei, {
					path: `${j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.EDIT}/*`,
					element: /* @__PURE__ */ (0, J.jsx)(b_, {
						handleClose: y,
						handleSuccess: f
					})
				}),
				/* @__PURE__ */ (0, J.jsx)(Ei, {
					path: j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.TRACK_ADD_EDIT,
					element: /* @__PURE__ */ (0, J.jsx)(l_, {
						handleClose: y,
						handleSuccess: f
					})
				}),
				/* @__PURE__ */ (0, J.jsx)(Ei, {
					path: "*",
					element: /* @__PURE__ */ (0, J.jsx)(Ti, {
						to: "",
						replace: !0
					})
				})
			] })
		]
	});
}, D_ = () => /* @__PURE__ */ (0, J.jsx)("div", {
	className: "flexbox-col bg__primary h-100 dc__overflow-hidden",
	children: /* @__PURE__ */ (0, J.jsx)(E_, {})
}), O_ = () => /* @__PURE__ */ (0, J.jsxs)(Di, { children: [
	/* @__PURE__ */ (0, J.jsx)(Ei, {
		path: `${j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.DETAIL.ROOT}/*`,
		element: /* @__PURE__ */ (0, J.jsx)(kg, {})
	}),
	/* @__PURE__ */ (0, J.jsx)(Ei, {
		path: `${j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.TRACK_DETAIL}/*`,
		element: /* @__PURE__ */ (0, J.jsx)($g, {})
	}),
	/* @__PURE__ */ (0, J.jsx)(Ei, {
		index: !0,
		path: "/*",
		element: /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)(n_, { headerType: "releases" }), /* @__PURE__ */ (0, J.jsx)(D_, {})] })
	})
] }), k_ = (e) => ({ partOfReleaseTracks: (e?.releaseTrackDownstreams ?? []).filter((e) => e.resourceKind === L.releaseTrack).map(({ id: e, identifier: t }) => ({
	id: e,
	name: t,
	redirectUrl: q(I.RELEASES.TRACK_DETAIL, { trackName: t })
})) }), A_ = async (e) => {
	let { result: t } = await H(Tr({
		kind: L.devtronApplication,
		baseUrl: _.RESOURCE,
		version: R.v1,
		queryParams: { id: e }
	}));
	return k_(t);
}, j_ = ({ appId: e }) => {
	let [, t, n] = K(() => A_(e), [e]);
	if (n) return null;
	let r = t?.partOfReleaseTracks ?? [];
	return r.length ? /* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("div", {
		className: "fs-13 fw-4 lh-20 cn-7 mb-4",
		children: "Part of release track"
	}), /* @__PURE__ */ (0, J.jsx)("div", {
		className: "flex column left top dc__gap-4",
		children: r.map((e) => e.name && /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flex left flex-grow-1 dc__gap-8",
			children: [/* @__PURE__ */ (0, J.jsx)(Zg, { className: "icon-dim-20 dc__no-shrink" }), /* @__PURE__ */ (0, J.jsx)(wi, {
				to: e.redirectUrl,
				target: "_blank",
				className: "anchor fs-13 fw-6 lh-20 cn-9 dc__truncate",
				children: e.name
			})]
		}, e.id))
	})] }) : null;
}, M_ = async (e, t) => {
	try {
		let { result: { data: n } } = await H(Tr({
			baseUrl: _.RESOURCE_LIST,
			kind: L.tenant,
			version: R.alpha1,
			queryParams: {
				fetchChild: !0,
				filterCriteria: Ts(e)
			}
		}), { signal: t });
		return n?.map(ws) ?? [];
	} catch (e) {
		throw yr(e) || W(e), e;
	}
}, N_ = async () => {
	let { result: { data: e } } = await H(Tr({
		baseUrl: _.RESOURCE_LIST,
		kind: L.tenant,
		version: R.alpha1
	}));
	return [{
		label: "All Tenants",
		options: (e ?? []).map(ws).map(({ name: e, tenantId: t }) => ({
			label: e,
			value: t,
			description: t
		}))
	}];
}, P_ = async (e) => {
	try {
		let { result: t } = await H(Tr({
			baseUrl: _.RESOURCE,
			kind: L.tenant,
			version: R.alpha1,
			queryParams: { identifier: e }
		}));
		return ws(t);
	} catch (e) {
		throw W(e), e;
	}
}, F_ = (e) => Wr(Tr({
	baseUrl: _.RESOURCE,
	kind: L.tenant,
	version: R.alpha1
}), e), I_ = (e) => {
	let { name: t, description: n, image: r, tenantId: i } = e;
	return F_({
		identifier: i,
		query: [
			{
				op: hn.replace,
				path: "name",
				value: t
			},
			{
				op: hn.replace,
				path: "description",
				value: n
			},
			{
				op: hn.replace,
				path: "icon",
				value: r
			}
		]
	});
}, L_ = (e) => {
	let { tenantId: t, name: n, description: r, image: i } = e;
	return Gr(Tr({
		baseUrl: _.RESOURCE,
		kind: L.tenant,
		version: R.alpha1
	}), {
		name: n,
		overview: {
			icon: i,
			description: r,
			tenantId: t
		}
	});
}, R_ = async (e) => ti(Tr({
	baseUrl: _.RESOURCE,
	kind: L.tenant,
	version: R.alpha1,
	queryParams: { identifier: e }
})), z_ = async ({ tenantId: e, description: t }) => F_({
	identifier: e,
	query: [{
		op: hn.replace,
		path: "description",
		value: t
	}]
}), B_ = async ({ tenantId: e, note: t }) => F_({
	identifier: e,
	query: [{
		op: hn.replace,
		path: "readme",
		value: t
	}]
}), V_ = async (e) => {
	try {
		let { result: { data: t } } = await H(Tr({
			baseUrl: _.RESOURCE_LIST,
			kind: L.installation,
			version: R.alpha1,
			queryParams: { filterCriteria: `${L.tenant}|identifier|${e}` }
		}));
		return t?.map(xs) ?? [];
	} catch (e) {
		throw W(e), e;
	}
}, H_ = async (e) => {
	let t = { identifier: Ms(e) };
	try {
		let [e, n] = await Promise.all([H(Tr({
			baseUrl: _.RESOURCE_DEPENDENCIES,
			kind: L.installation,
			version: R.alpha1,
			queryParams: t
		})), H(Tr({
			baseUrl: _.RESOURCE,
			kind: L.installation,
			version: R.alpha1,
			queryParams: t
		}))]);
		return Cs(e?.result, n?.result);
	} catch (e) {
		throw e?.code !== Nt.NOT_FOUND && W(e), e;
	}
}, U_ = async (e) => ti(Tr({
	baseUrl: _.RESOURCE,
	kind: L.installation,
	version: R.alpha1,
	queryParams: { identifier: Ms(e) }
})), W_ = async ({ name: e, installationId: t, tenantId: n, releaseChannelId: r }) => Wr(Tr({
	baseUrl: _.RESOURCE,
	kind: L.installation,
	version: R.alpha1
}), {
	identifier: Ms({
		tenantId: n,
		installationId: t
	}),
	query: [{
		op: hn.replace,
		path: "name",
		value: e
	}, r ? {
		op: hn.replace,
		path: "releaseChannel",
		value: r
	} : {
		op: hn.remove,
		path: "releaseChannel"
	}]
}), G_ = async ({ tenantId: e, installationId: t, pushToRemote: n, repository: r, dockerRegistryId: i }) => Wr(Tr({
	baseUrl: _.RESOURCE,
	kind: L.installation,
	version: R.alpha1
}), {
	identifier: Ms({
		tenantId: e,
		installationId: t
	}),
	query: [{
		op: hn.replace,
		path: "deploymentConfiguration",
		value: n ? {
			pushToRemote: n,
			repository: r,
			dockerRegistryId: i
		} : {
			pushToRemote: n,
			repository: null,
			dockerRegistryId: null
		}
	}]
}), K_ = async ({ name: e, installationId: t, tenantId: n, releaseChannelId: r }) => Gr(Tr({
	baseUrl: _.RESOURCE,
	kind: L.installation,
	version: R.alpha1
}), {
	name: e,
	overview: { installationId: t },
	parentConfig: {
		identifier: n,
		resourceKind: L.tenant,
		resourceVersion: R.alpha1
	},
	subscriptionConfig: r ? {
		resourceKind: L.releaseChannel,
		resourceVersion: R.alpha1,
		identifier: r
	} : null
}), q_ = async (e) => {
	try {
		let { result: t } = await H(Tr({
			baseUrl: _.RESOURCE_DEPENDENCIES_OPTIONS,
			kind: L.installation,
			version: R.alpha1,
			queryParams: { filterCriteria: `${L.cluster}|identifier|${e}` }
		}));
		return t?.map(As) ?? [];
	} catch (e) {
		throw W(e), e;
	}
}, J_ = async () => {
	try {
		let { result: e } = await H(Tr({
			baseUrl: _.RESOURCE_DEPENDENCIES_OPTIONS,
			kind: L.installation,
			version: R.alpha1
		}));
		return e ? e.map(({ identifier: e, id: t, data: n }) => ({
			id: t,
			name: e,
			isVirtual: n?.isVirtualCluster ?? !1,
			isProd: n?.isProd ?? !1
		})).sort((e, t) => G(e.name, t.name)) : [];
	} catch (e) {
		throw W(e), e;
	}
}, Y_ = async ({ tenantId: e, installationId: t, selectedEnvironmentMap: n }) => Yr(Tr({
	baseUrl: _.RESOURCE_DEPENDENCIES,
	kind: L.installation,
	version: R.alpha1
}), {
	identifier: Ms({
		tenantId: e,
		installationId: t
	}),
	dependencies: js(n)
}), X_ = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M4.16671 39C3.70654 39 3.33301 38.6265 3.33301 38.1675V33.1675C3.33301 32.7061 3.70654 32.3325 4.16671 32.3325C4.62695 32.3325 4.99986 32.706 4.99986 33.1675V38.1675C4.99978 38.6265 4.62695 39 4.16671 39Z",
			fill: "#965353"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M4.16654 24C3.09479 24 2.30133 25.1878 1.59326 27.8513C1.12394 29.6177 0.832764 31.5538 0.832764 32.3325C0.832764 34.1709 2.32812 35.6676 4.16646 35.6676C6.00425 35.6676 7.49961 34.1709 7.49961 32.3325C7.49961 31.5537 7.20906 29.6177 6.73967 27.8513C6.03168 25.1878 5.23829 24 4.16654 24Z",
			fill: "#A0D468"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M20.9996 6H4.99965C4.53941 6 4.1665 6.37282 4.1665 6.83307V38.1675C4.1665 38.6265 4.53941 39 4.99965 39H20.9997C21.4599 39 21.8322 38.6265 21.8322 38.1675V6.83307C21.8322 6.37282 21.4598 6 20.9996 6Z",
			fill: "#007CA6"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M12.9997 39C12.5395 39 12.1665 38.6265 12.1665 38.1675V36.5C12.1665 36.0398 12.5394 35.6675 12.9997 35.6675C13.4599 35.6675 13.8328 36.0399 13.8328 36.5V38.1675C13.8327 38.6265 13.4598 39 12.9997 39Z",
			fill: "#434A54"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M18.4997 32.8013H7.49966C7.03941 32.8013 6.6665 32.4278 6.6665 31.9688C6.6665 31.5074 7.03941 31.1339 7.49966 31.1339H18.4997C18.9598 31.1339 19.3321 31.5073 19.3321 31.9688C19.3321 32.4278 18.9597 32.8013 18.4997 32.8013Z",
			fill: "#22637D"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M18.4997 29.3339H7.49966C7.03941 29.3339 6.6665 28.9603 6.6665 28.4988C6.6665 28.0398 7.03941 27.6663 7.49966 27.6663H18.4997C18.9598 27.6663 19.3321 28.0398 19.3321 28.4988C19.3321 28.9603 18.9597 29.3339 18.4997 29.3339Z",
			fill: "#22637D"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M18.4997 25.8663H7.49966C7.03941 25.8663 6.6665 25.494 6.6665 25.0339C6.6665 24.5737 7.03941 24.2013 7.49966 24.2013H18.4997C18.9598 24.2013 19.3321 24.5737 19.3321 25.0339C19.3321 25.494 18.9597 25.8663 18.4997 25.8663Z",
			fill: "#22637D"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M18.4997 22.4013H7.49966C7.03941 22.4013 6.6665 22.0278 6.6665 21.5688C6.6665 21.1074 7.03941 20.7338 7.49966 20.7338H18.4997C18.9598 20.7338 19.3321 21.1073 19.3321 21.5688C19.3321 22.0278 18.9597 22.4013 18.4997 22.4013Z",
			fill: "#22637D"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M18.4997 18.9338H7.49966C7.03941 18.9338 6.6665 18.5603 6.6665 18.0995C6.6665 17.6392 7.03941 17.2663 7.49966 17.2663H18.4997C18.9598 17.2663 19.3321 17.6392 19.3321 18.0995C19.3321 18.5603 18.9597 18.9338 18.4997 18.9338Z",
			fill: "#22637D"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M18.4997 15.4663H7.49966C7.03941 15.4663 6.6665 15.0934 6.6665 14.6332C6.6665 14.1729 7.03941 13.8 7.49966 13.8H18.4997C18.9598 13.8 19.3321 14.1729 19.3321 14.6332C19.3321 15.0934 18.9597 15.4663 18.4997 15.4663Z",
			fill: "#22637D"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M18.4997 12H7.49966C7.03941 12 6.6665 11.6271 6.6665 11.1669C6.6665 10.7066 7.03941 10.3332 7.49966 10.3332H18.4997C18.9598 10.3332 19.3321 10.7066 19.3321 11.1669C19.3321 11.6271 18.9597 12 18.4997 12Z",
			fill: "#22637D"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M21.8323 7.66685H4.16654C3.70629 7.66685 3.33276 7.29332 3.33276 6.83307C3.33276 6.37282 3.70637 6 4.16654 6H21.8322C22.2936 6 22.6672 6.37282 22.6672 6.83307C22.6672 7.29332 22.2937 7.66685 21.8323 7.66685Z",
			fill: "#3BAFDA"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M34.6668 14H18.6669C18.2066 14 17.8337 14.3728 17.8337 14.8331V38.1675C17.8337 38.6265 18.2066 39 18.6669 39H34.6669C35.1271 39 35.4994 38.6265 35.4994 38.1675V14.8331C35.4994 14.3728 35.1271 14 34.6668 14Z",
			fill: "#4FC2E9"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M26.6669 39C26.2067 39 25.8337 38.6265 25.8337 38.1675V36.5C25.8337 36.0398 26.2066 35.6675 26.6669 35.6675C27.1271 35.6675 27.5 36.0399 27.5 36.5V38.1675C27.5 38.6265 27.1271 39 26.6669 39Z",
			fill: "#434A54"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M35.4995 15.6668H17.8338C17.3735 15.6668 17 15.2933 17 14.8331C17 14.3728 17.3736 14 17.8338 14H35.4995C35.9609 14 36.3345 14.3728 36.3345 14.8331C36.3345 15.2933 35.961 15.6668 35.4995 15.6668Z",
			fill: "#3BAFDA"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M39.3334 39.3333H0.666641C0.297969 39.3333 0 39.0353 0 38.6666C0 38.298 0.297969 38 0.666641 38H39.3333C39.702 38 39.9999 38.298 39.9999 38.6666C40 39.0353 39.702 39.3333 39.3334 39.3333Z",
			fill: "#556080"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M22.6666 15.0001C22.298 15.0001 22 14.7021 22 14.3334V11.0001C22 10.6314 22.298 10.3334 22.6666 10.3334C23.0353 10.3334 23.3333 10.6314 23.3333 11.0001V14.3334C23.3333 14.7021 23.0353 15.0001 22.6666 15.0001Z",
			fill: "#ECF0F1"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M30.6666 15.0001C30.298 15.0001 30 14.7021 30 14.3334V11.0001C30 10.6314 30.298 10.3334 30.6666 10.3334C31.0353 10.3334 31.3333 10.6314 31.3333 11.0001V14.3334C31.3333 14.7021 31.0353 15.0001 30.6666 15.0001Z",
			fill: "#ECF0F1"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M20 10.9999H33.3333V1.66656H20V10.9999Z",
			fill: "#F33E3E"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M28.9755 7.6668C29.203 7.27436 29.3333 6.81886 29.3333 6.33344V4.33344C29.3333 3.96477 29.0353 3.6668 28.6666 3.6668H24.6666C24.298 3.6668 24 3.96477 24 4.33344V6.33344C24 6.81886 24.1303 7.27436 24.3578 7.6668H24.0001C23.6315 7.6668 23.3335 7.96477 23.3335 8.33344C23.3335 8.70211 23.6315 9.00008 24.0001 9.00008H29.3335C29.7022 9.00008 30.0001 8.70211 30.0001 8.33344C30.0001 7.96477 29.7022 7.6668 29.3335 7.6668H28.9755ZM25.3333 6.33344V5.00008H28V6.33344C28 7.06883 27.402 7.6668 26.6666 7.6668C25.9312 7.6668 25.3333 7.06875 25.3333 6.33344Z",
			fill: "white"
		}),
		/* @__PURE__ */ (0, J.jsx)("rect", {
			x: 21,
			y: 18,
			width: 5,
			height: 6,
			rx: .5,
			fill: "#49869E"
		}),
		/* @__PURE__ */ (0, J.jsx)("rect", {
			x: 21,
			y: 25.33,
			width: 5,
			height: 6,
			rx: .5,
			fill: "#49869E"
		}),
		/* @__PURE__ */ (0, J.jsx)("rect", {
			x: 27.3301,
			y: 18,
			width: 5,
			height: 6,
			rx: .5,
			fill: "#49869E"
		}),
		/* @__PURE__ */ (0, J.jsx)("rect", {
			x: 27.3301,
			y: 25.33,
			width: 5,
			height: 6,
			rx: .5,
			fill: "#49869E"
		})
	]
}), Z_ = {
	ADD_TENANT: "Add tenant",
	EDIT_TENANT: "Edit tenant",
	CTA: "Save",
	CANCEL: "Cancel",
	EDIT_IMAGE_CTA: "Preview",
	EDIT_IMAGE_LABEL: "Image URL",
	EDIT_IMAGE_PLACEHOLDER: "Enter image url",
	TENANT_NAME_LABEL: "Tenant display name",
	TENANT_NAME_PLACEHOLDER: "Eg. Acme Inc.",
	TENANT_ID_LABEL: "Tenant ID",
	TENANT_ID_PLACEHOLDER: "Eg. acme-inc",
	TENANT_ID_FIELD_SUBTITLE: "Tenant ID is a unique identifier for a tenant. This cannot be changed once set.",
	DESCRIPTION_LABEL: "Description",
	DESCRIPTION_PLACEHOLDER: "Write a description for this tenant",
	CREATE_SUCCESS: "Tenant created successfully",
	UPDATE_SUCCESS: "Tenant updated successfully"
}, Q_ = {
	tenantId: null,
	tenantName: null,
	installationId: null,
	installationName: null,
	description: null,
	image: null
}, $_ = {
	tenantId: "",
	tenantName: "",
	installationId: null,
	installationName: null,
	description: null,
	image: null
}, ev = {
	name: "",
	tenantId: "",
	description: "",
	image: "",
	installations: []
}, tv = {
	isLoading: !1,
	isEditing: !1,
	src: ""
}, nv = 2 * 1024 * 1024, rv = /* @__PURE__ */ function(e) {
	return e.UPDATE_DESCRIPTION = "updateDescription", e.UPDATE_INSTALLATION_ID = "updateInstallationId", e.UPDATE_INSTALLATION_NAME = "updateInstallationName", e.UPDATE_TENANT_ID = "updateTenantId", e.UPDATE_TENANT_NAME = "updateTenantName", e.UPDATE_IMAGE = "updateImage", e.ENABLE_IMAGE_EDIT = "enableImageEdit", e.CANCEL_IMAGE_CHANGES = "cancelImageChanges", e.PREVIEW_IMAGE = "previewImage", e.ADD_INSTALLATION = "addInstallation", e.REMOVE_INSTALLATION = "removeInstallation", e;
}({}), iv = ({ value: e, error: t, handleTenantInputChange: n }) => /* @__PURE__ */ (0, J.jsx)(Un, {
	name: "tenant-description",
	placeholder: Z_.DESCRIPTION_PLACEHOLDER,
	value: e,
	onChange: (e) => {
		n({
			action: rv.UPDATE_DESCRIPTION,
			value: e.currentTarget.value
		});
	},
	label: Z_.DESCRIPTION_LABEL,
	error: t
}), av = ({ value: e, error: t, handleTenantInputChange: n }) => /* @__PURE__ */ (0, J.jsx)(pt, {
	name: "tenant-display-name",
	label: Z_.TENANT_NAME_LABEL,
	placeholder: Z_.TENANT_NAME_PLACEHOLDER,
	value: e,
	onChange: (e) => {
		n({
			action: rv.UPDATE_TENANT_NAME,
			value: e.currentTarget.value
		});
	},
	error: t,
	required: !0,
	fullWidth: !0
}), ov = ({ value: e, error: t, handleTenantInputChange: n, isEditMode: r }) => /* @__PURE__ */ (0, J.jsx)(pt, {
	name: "tenant-id-field",
	label: Z_.TENANT_ID_LABEL,
	placeholder: Z_.TENANT_ID_PLACEHOLDER,
	value: e,
	onChange: (e) => {
		n({
			action: rv.UPDATE_TENANT_ID,
			value: e.currentTarget.value
		});
	},
	error: t,
	required: !0,
	disabled: r,
	helperText: Z_.TENANT_ID_FIELD_SUBTITLE,
	fullWidth: !0
}), sv = () => /* @__PURE__ */ (0, J.jsx)("div", {
	className: "flex p-4 br-4 dc__border edit-image-icon dc__zi-1 bg__primary dc__hover-n50 icon-dim-24",
	children: /* @__PURE__ */ (0, J.jsx)(v, { className: "dc__no-shrink icon-dim-16" })
}), cv = ({ value: e, error: t, isEditing: n, isLoading: r, src: i, handleTenantInputChange: a }) => {
	let o = r || !!t, s = () => {
		a({ action: rv.ENABLE_IMAGE_EDIT });
	}, c = (e) => {
		a({
			action: rv.UPDATE_IMAGE,
			value: e.currentTarget.value
		});
	}, l = () => {
		a({
			action: rv.PREVIEW_IMAGE,
			value: e
		});
	};
	return n ? /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox dc__gap-20",
		children: [/* @__PURE__ */ (0, J.jsx)(sf, { imageProps: {
			src: i,
			height: 72,
			width: 72
		} }), n && /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col dc__gap-16 flex-grow-1",
			children: [/* @__PURE__ */ (0, J.jsx)(pt, {
				name: "tenant-image-url",
				label: Z_.EDIT_IMAGE_LABEL,
				placeholder: Z_.EDIT_IMAGE_PLACEHOLDER,
				value: e,
				onChange: c,
				error: t,
				required: !0,
				onKeyDown: (e) => {
					!o && e.key === "Enter" && (e.preventDefault(), l());
				},
				fullWidth: !0
			}), /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox dc__gap-8",
				children: [/* @__PURE__ */ (0, J.jsx)(et, {
					isLoading: r,
					rootClassName: "cta h-28 flex",
					type: "button",
					disabled: o,
					"data-testid": "preview-tenant-image-update",
					onClick: l,
					children: Z_.EDIT_IMAGE_CTA
				}), /* @__PURE__ */ (0, J.jsx)("button", {
					className: "cta secondary h-28 flex",
					"data-testid": "cancel-image-url-edit",
					type: "button",
					disabled: r,
					onClick: () => {
						a({ action: rv.CANCEL_IMAGE_CHANGES });
					},
					children: Z_.CANCEL
				})]
			})]
		})]
	}) : /* @__PURE__ */ (0, J.jsxs)("button", {
		className: "dc__no-background dc__no-border dc__outline-none-imp tenants__tenant-figure-container p-0 icon-dim-72 dc__no-shrink",
		type: "button",
		"data-testid": "edit-tenant-image",
		"aria-label": "edit tenant image",
		onClick: s,
		children: [/* @__PURE__ */ (0, J.jsx)(sf, {
			imageProps: {
				src: i,
				height: 72,
				width: 72
			},
			fallbackImageProps: { showEditIcon: !0 }
		}), /* @__PURE__ */ (0, J.jsx)(sv, {})]
	});
}, lv = ({ handleTenantInputChange: e, tenantInput: t, tenantInputErrors: n, imageFieldInfo: r, isEditMode: i }) => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "flexbox-col py-24 px-20 dc__gap-16 w-100 dc__overflow-auto",
	children: [
		/* @__PURE__ */ (0, J.jsx)(cv, {
			value: t.image,
			error: n.image,
			isEditing: r.isEditing,
			isLoading: r.isLoading,
			src: r.src,
			handleTenantInputChange: e
		}),
		/* @__PURE__ */ (0, J.jsx)(av, {
			value: t.name,
			error: n.tenantName,
			handleTenantInputChange: e
		}),
		/* @__PURE__ */ (0, J.jsx)(ov, {
			value: t.tenantId,
			error: n.tenantId,
			handleTenantInputChange: e,
			isEditMode: i
		}),
		/* @__PURE__ */ (0, J.jsx)(iv, {
			value: t.description,
			error: n.description,
			handleTenantInputChange: e
		})
	]
}), uv = ({ handleClose: e, handleSuccess: t, tenantId: n }) => {
	let { tenantId: r } = Ai(), i = n || r, a = !!i, [o, s] = A(!1), [c, l] = A(structuredClone(ev)), [u, d] = A(a ? { ...Q_ } : { ...$_ }), [f, p] = A(structuredClone(tv)), [m, h, g, _] = K(() => P_(i), [i, a], a), v = k(() => Object.values(u).filter((e) => e != null).length > 0, [u]);
	O(() => {
		a && h && (l({
			tenantId: h.tenantId,
			name: h.name,
			description: h.description,
			image: h.image,
			installations: []
		}), p({
			...f,
			src: h.image
		}));
	}, [h]);
	let y = async (e) => {
		try {
			p({
				...f,
				isLoading: !0
			});
			let t = await fetch(e, { mode: "cors" });
			if (!t.ok) throw Error("Invalid network response");
			let n = await t.blob();
			if (n.size > 2097152) throw Error(`Add an image smaller than ${nv}`);
			let r = URL.createObjectURL(n), i = await bi(r);
			if (URL.revokeObjectURL(r), i.isValid) p({
				isEditing: !1,
				isLoading: !1,
				src: e
			});
			else throw Error(i.message);
		} catch (e) {
			d({
				...u,
				image: e.message || "Failed to load image"
			}), p({
				...f,
				isLoading: !1
			});
		}
	}, x = (e) => xi(e).message;
	return /* @__PURE__ */ (0, J.jsx)(Qn, {
		className: "",
		onEscape: e,
		close: e,
		children: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col dc__content-space w-1024",
			onClick: ei,
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col h-100 dc__content-space bg__primary dc__overflow-auto",
				children: [/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox dc__content-space dc__align-items-center dc__border-bottom-n1 pb-12 pt-12 pl-20 pr-20",
					children: [/* @__PURE__ */ (0, J.jsx)("h2", {
						className: "m-0 cn-9 fs-16 fw-6 lh-24 dc__ellipsis-right",
						children: a ? Z_.EDIT_TENANT : Z_.ADD_TENANT
					}), /* @__PURE__ */ (0, J.jsx)("button", {
						className: "flex dc__transparent dc__outline-none-imp dc__no-border p-0 dc__tab-focus",
						type: "button",
						onClick: e,
						"aria-label": "close upsert tenant modal",
						children: /* @__PURE__ */ (0, J.jsx)(Ee, { className: "icon-dim-24 dc__no-shrink fcn-6" })
					})]
				}), /* @__PURE__ */ (0, J.jsx)(Ie, {
					isLoading: m,
					progressingProps: { pageLoader: !0 },
					error: g,
					errorScreenManagerProps: {
						code: g?.code,
						reload: _
					},
					children: /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox w-100 h-100 dc__overflow-auto",
						children: [/* @__PURE__ */ (0, J.jsx)(un, {
							rootClassName: "pl-24 pr-24 pt-24 pb-24 dc__no-shrink",
							heading: "Tenant",
							icon: /* @__PURE__ */ (0, J.jsx)(X_, { className: "dc__no-shrink icon-dim-40" }),
							documentationLink: "TENANTS",
							children: /* @__PURE__ */ (0, J.jsxs)("div", {
								className: "flexbox-col dc__gap-24",
								children: [/* @__PURE__ */ (0, J.jsx)("p", {
									className: "m-0",
									children: "A tenant represents an organization or team you deliver software to using Devtron."
								}), /* @__PURE__ */ (0, J.jsx)("p", {
									className: "m-0",
									children: "A tenant can have multiple installations of your software. Relevant environments can be mapped to each tenant installation."
								})]
							})
						}), /* @__PURE__ */ (0, J.jsx)(lv, {
							tenantInput: c,
							tenantInputErrors: u,
							handleTenantInputChange: async ({ action: e, value: t }) => {
								let n = structuredClone(c), r = { ...u }, i = { ...f };
								switch (e) {
									case rv.UPDATE_DESCRIPTION:
										n.description = t, r.description = vi(t).message;
										break;
									case rv.UPDATE_IMAGE:
										n.image = t, r.image = Ci(t, !1).message;
										break;
									case rv.ENABLE_IMAGE_EDIT:
										i.isEditing = !0, r.image = f.src ? Ci(f.src, !1).message : "";
										break;
									case rv.CANCEL_IMAGE_CHANGES:
										i.isEditing = !1, n.image = i.src, r.image = null;
										break;
									case rv.PREVIEW_IMAGE:
										y(t);
										return;
									case rv.UPDATE_INSTALLATION_ID: {
										let e = n.installations?.[0] ?? {
											name: "",
											installationId: ""
										};
										e.installationId = t, n.installations = [{ ...e }], r.installationId = x(t), e.name || (r.installationName = yi(e.name).message);
										break;
									}
									case rv.UPDATE_INSTALLATION_NAME: {
										let e = n.installations?.[0] ?? {
											name: "",
											installationId: ""
										};
										e.name = t, n.installations = [e], r.installationName = yi(t).message, e.installationId || (r.installationId = x(e.installationId));
										break;
									}
									case rv.ADD_INSTALLATION:
										r.installationId = "", r.installationName = "";
										break;
									case rv.REMOVE_INSTALLATION:
										n.installations = [{
											name: "",
											installationId: ""
										}], r.installationId = null, r.installationName = null;
										break;
									case rv.UPDATE_TENANT_ID:
										n.tenantId = t, r.tenantId = xi(t).message;
										break;
									case rv.UPDATE_TENANT_NAME:
										n.name = t, r.tenantName = yi(t).message;
										break;
									default: throw Error("Invalid action type");
								}
								l(n), p(i), d(r);
							},
							imageFieldInfo: f,
							isEditMode: a
						})]
					})
				})]
			}), !m && !g && /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox dc__content-end dc__no-shrink px-20 py-16 dc__gap-12 dc__border-top",
				children: [/* @__PURE__ */ (0, J.jsx)("button", {
					className: "cta secondary flex h-36",
					type: "button",
					onClick: e,
					"data-testid": "cancel-upsert-tenant",
					disabled: o,
					children: Z_.CANCEL
				}), /* @__PURE__ */ (0, J.jsx)(lt, {
					condition: v,
					wrap: Xr,
					children: /* @__PURE__ */ (0, J.jsx)("div", {
						className: "flexbox dc__align-items-center",
						children: /* @__PURE__ */ (0, J.jsx)(et, {
							rootClassName: "cta flex h-36",
							type: "button",
							onClick: async () => {
								if (v) {
									B.showToast({
										variant: V.error,
										description: b
									});
									return;
								}
								s(!0);
								try {
									let n = {
										installations: a || !(c.installations?.[0]?.installationId && c.installations?.[0]?.name) ? null : c.installations,
										tenantId: c.tenantId,
										name: c.name,
										description: c.description,
										image: c.image
									};
									await (a ? I_(n) : L_(n)), B.showToast({
										variant: V.success,
										description: a ? Z_.UPDATE_SUCCESS : Z_.CREATE_SUCCESS
									}), t(), e();
								} catch (e) {
									W(e), s(!1);
								}
							},
							"data-testid": "save-upsert-tenant-changes",
							disabled: v || o,
							isLoading: o,
							children: Z_.CTA
						})
					})
				})]
			})]
		})
	});
}, dv = ({ handleClose: e, handleSuccess: t, tenantId: n, name: r }) => /* @__PURE__ */ (0, J.jsx)(St, {
	title: r,
	onDelete: async () => {
		await R_(n), t();
	},
	subtitle: "Deleting a tenant will delete all the information added to it.",
	closeConfirmationModal: e,
	confirmationConfig: {
		identifier: "delete-tenant-confirmation",
		confirmationKeyword: r
	},
	successToastMessage: "Tenant deleted successfully"
}), fv = ({ tenantId: e, name: t, handleSuccess: n, openTenantEditModal: r }) => {
	let [i, a] = A(!1);
	return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsxs)(gn, {
		autoPosition: !0,
		autoClose: !0,
		children: [/* @__PURE__ */ (0, J.jsx)(gn.Button, {
			isKebab: !0,
			rootClassName: "icon-dim-20 dc__no-shrink p-0 dc__no-background dc__no-border dc__outline-none-imp flex dc__tab-focus dc__hover-n50",
			dataTestId: `edit-${t}-options-button`,
			children: /* @__PURE__ */ (0, J.jsx)(No, { className: "flex icon-dim-16 dc__no-shrink icon-color-n6" })
		}), /* @__PURE__ */ (0, J.jsxs)(gn.Body, {
			rootClassName: "br-4 py-4 dc__overflow-hidden dc__border dc__box-shadow--menu",
			children: [/* @__PURE__ */ (0, J.jsxs)("button", {
				type: "button",
				"aria-label": `edit ${t}`,
				"data-testid": `edit-${t}-name`,
				className: "flexbox dc__transparent dc__hover-n50 dc__align-items-center py-6 px-8 w-100 dc__gap-8",
				onClick: r,
				children: [/* @__PURE__ */ (0, J.jsx)(v, { className: "icon-dim-16 dc__no-shrink scn-6" }), /* @__PURE__ */ (0, J.jsx)("span", {
					className: "cn-9 fs-13 fw-4 lh-20",
					children: "Edit tenant"
				})]
			}), /* @__PURE__ */ (0, J.jsxs)("button", {
				type: "button",
				"aria-label": `delete ${t}`,
				"data-testid": `delete-${t}`,
				className: "flexbox dc__transparent dc__hover-n50 dc__align-items-center py-6 px-8 w-100 dc__gap-8",
				onClick: () => {
					a(!0);
				},
				children: [/* @__PURE__ */ (0, J.jsx)(T, { className: "icon-dim-16 scr-5 dc__no-shrink" }), /* @__PURE__ */ (0, J.jsx)("span", {
					className: "cr-5 fs-13 fw-4 lh-20",
					children: "Delete tenant"
				})]
			})]
		})]
	}), i && /* @__PURE__ */ (0, J.jsx)(dv, {
		tenantId: e,
		name: t,
		handleClose: () => {
			a(!1);
		},
		handleSuccess: n
	})] });
}, pv = je(null), mv = ({ value: e, children: t }) => /* @__PURE__ */ (0, J.jsx)(pv.Provider, {
	value: e,
	children: t
}), hv = () => {
	let e = Ne(pv);
	if (!e) throw Error("Wrap with TenantDetailProvider");
	return e;
}, gv = () => {
	let e = ki(), t = Oi(), { tenantId: n, name: r } = hv(), i = {
		label: r,
		value: n
	}, a = (r) => {
		if (r.value === n) return;
		let i = q(I.TENANTS.DETAIL.INSTALLATIONS, {
			tenantId: n,
			installationId: null
		}), a = t.pathname.replace(i, "").split("/")[1], o = q(I.TENANTS.DETAIL.ROOT, { tenantId: r.value });
		Ir({
			category: "Tenant Selector",
			action: Fc.SDH_SWITCH_TENANTS_ITEM_CLICKED
		}), e(`${o}/${a}`);
	}, [o, s, c, l] = K(() => N_(), [n]);
	return /* @__PURE__ */ (0, J.jsx)(ft, {
		options: s ?? [],
		onChange: a,
		value: i,
		inputId: `tenant-switcher-${n}`,
		isLoading: o,
		optionListError: c,
		reloadOptionList: l,
		resource: "Tenant"
	});
}, _v = ({ openTenantEditModal: e }) => {
	let t = ki(), { tenantId: n, name: r } = hv(), { breadcrumbs: i } = ri(I.TENANTS.DETAIL.ROOT, { alias: {
		...bl(),
		tenants: {
			component: /* @__PURE__ */ (0, J.jsx)(Je, { heading: "Tenants" }),
			linked: !0
		},
		detail: { component: null },
		":tenantId": { component: /* @__PURE__ */ (0, J.jsx)(gv, {}) }
	} }), a = () => {
		t(I.TENANTS.ROOT);
	}, o = () => /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox dc__gap-12 dc__align-items-center",
		children: [/* @__PURE__ */ (0, J.jsx)("div", {
			className: "flexbox dc__align-items-center",
			children: /* @__PURE__ */ (0, J.jsx)(qe, {
				breadcrumbs: i,
				path: I.TENANTS.DETAIL.ROOT
			})
		}), /* @__PURE__ */ (0, J.jsx)(fv, {
			tenantId: n,
			name: r,
			handleSuccess: a,
			openTenantEditModal: e
		})]
	}), s = [{
		id: "tenants-overview-tab",
		tabType: "navLink",
		label: "Overview",
		props: {
			to: j.SOFTWARE_RELEASE_MANAGEMENT.TENANTS.DETAIL.OVERVIEW,
			"data-testid": "Tenant-Overview-click",
			"data-action": "Tenant Overview Clicked"
		}
	}, {
		id: "tenants-installations-tab",
		tabType: "navLink",
		label: "Installations",
		props: {
			to: j.SOFTWARE_RELEASE_MANAGEMENT.TENANTS.DETAIL.INSTALLATIONS.split("/")[0],
			"data-testid": "Installations-click",
			"data-action": "Installations Clicked"
		}
	}];
	return /* @__PURE__ */ (0, J.jsx)(pn, {
		showTabs: !0,
		renderHeaderTabs: () => /* @__PURE__ */ (0, J.jsx)(Vn, {
			tabs: s,
			hideTopPadding: !0
		}),
		isBreadcrumbs: !0,
		breadCrumbs: o,
		docPath: vt.SOFTWARE_DISTRIBUTION_HUB
	});
}, vv = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M18.6401 14.3522L20.9955 11.9961L18.6401 9.64M15.3393 11.9961H20.9939M16.1384 6.33201L16.138 3.00044L12.8064 3M12.8455 6.29289L16.1368 3.00159M16.1384 17.668L16.138 20.9996L12.8064 21M12.8455 17.7071L16.1368 20.9984M10.1896 13.8469V10.1531C10.1896 10.1 10.1754 10.0478 10.1486 10.0019C10.1218 9.95601 10.0832 9.9181 10.0369 9.89204L6.74166 8.03847C6.69682 8.01325 6.64624 8 6.59479 8C6.54335 8 6.49277 8.01325 6.44793 8.03847L3.1527 9.89204C3.10637 9.9181 3.06781 9.95601 3.04098 10.0019C3.01414 10.0478 3 10.1 3 10.1531V13.8469C3 13.9 3.01414 13.9522 3.04098 13.9981C3.06781 14.044 3.10637 14.0819 3.1527 14.108L6.44793 15.9615C6.49277 15.9868 6.54335 16 6.59479 16C6.64624 16 6.69682 15.9868 6.74166 15.9615L10.0369 14.108C10.0832 14.0819 10.1218 14.044 10.1486 13.9981C10.1754 13.9522 10.1896 13.9 10.1896 13.8469Z",
		stroke: "#0066CC",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yv = /* @__PURE__ */ function(e) {
	return e.name = "name", e.subscribedInstallationCount = "subscribedInstallationCount", e;
}({}), bv = Array.from([
	,
	,
	,
].keys()).map((e) => ({
	channelId: `channel-${e}`,
	description: "Description",
	name: `channel name ${e}`,
	subscribedInstallations: [],
	subscribedInstallationsCount: 0,
	isDefault: e === 1
})), xv = {
	channelId: "",
	name: "",
	description: "",
	isDefault: !1
}, Sv = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	"data-style-override": "false",
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M22.2759 11H3.2818C2.57391 11 2 11.5522 2 12.2332V27.7668C2 28.4478 2.57391 29 3.2818 29H22.2759C22.9838 29 23.5577 28.4478 23.5577 27.7668V12.2332C23.5577 11.5522 22.9838 11 22.2759 11Z",
			fill: "#7E604A"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M12.7788 11H3.2818C2.57391 11 2 11.5522 2 12.2332V27.7668C2 28.4478 2.57391 29 3.2818 29H12.7788V11Z",
			fill: "#AC825A"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M12.7788 14.79C13.4867 14.79 14.0606 14.2161 14.0606 13.5082V11H11.4971V13.5082C11.497 14.2161 12.0709 14.79 12.7788 14.79Z",
			fill: "#FF9900"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M12.7789 14.79V11H11.4971V13.5082C11.4971 14.2161 12.071 14.79 12.7789 14.79Z",
			fill: "#FAD52A"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M26.7527 6.625L26.7519 1.00075L21.1277 1M20 7.75268L26.75 1.00268",
			stroke: "#7E604A",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			opacity: .9,
			d: "M20.1277 38.7527L25.7519 38.7519L25.7527 33.1277M19 32L25.75 38.75",
			stroke: "#FF9900",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			opacity: .9,
			d: "M33.7974 23.7523L37.7738 19.7749L33.7974 15.7974M28.2251 19.7749L37.7711 19.7749",
			stroke: "#FF4F59",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
}), Cv = /* @__PURE__ */ function(e) {
	return e.updateName = "updateName", e.updateChannelId = "updateChannelId", e.updateDescription = "updateDescription", e.toggleIsDefault = "toggleIsDefault", e;
}({}), wv = ({ handleClose: e, handleSuccess: t, releaseChannelConfig: n }) => {
	let { name: r, description: i, channelId: a, isDefault: o } = n, s = !!n?.channelId, [c, l] = A(structuredClone(xv)), [u, d] = A({
		description: null,
		...s ? {
			name: null,
			channelId: null
		} : {
			name: "",
			channelId: ""
		}
	}), [f, p] = A(!1), m = k(() => Object.values(u).filter((e) => !Br(e)).length > 0, [u]);
	O(() => {
		n && l({
			name: r,
			channelId: a,
			isDefault: o,
			description: i
		});
	}, [n]);
	let h = async (n) => {
		if (n.preventDefault(), m) {
			B.showToast({
				variant: V.error,
				description: b
			});
			return;
		}
		p(!0);
		let r = {
			name: c.name,
			channelId: c.channelId,
			isDefault: c.isDefault,
			description: c.description.trim()
		};
		try {
			await (s ? Ng(r) : Pg(r)), B.showToast({
				variant: V.success,
				description: `Release channel ${s ? "updated" : "created"} successfully`
			}), p(!1), t(), e();
		} catch (e) {
			W(e), p(!1);
		}
	}, g = ({ action: e, value: t }) => {
		let n = structuredClone(c), r = structuredClone(u);
		switch (e) {
			case Cv.updateName:
				n.name = t, r.name = yi(t).message;
				break;
			case Cv.updateChannelId:
				n.channelId = t, r.channelId = xi(t).message;
				break;
			case Cv.toggleIsDefault:
				n.isDefault = !n.isDefault;
				break;
			case Cv.updateDescription:
				n.description = t, r.description = vi(t.trim()).message;
				break;
			default: throw Error(`Action ${e} is not supported`);
		}
		l(n), d(r);
	}, _ = (e) => (t) => {
		g({
			action: e,
			value: t.target.value
		});
	};
	return /* @__PURE__ */ (0, J.jsx)($n, {
		className: "visible-modal__body",
		children: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox bg__primary w-800 h-500 dc__m-auto mt-40 dc__border-radius-8-imp dc__overflow-hidden",
			children: [/* @__PURE__ */ (0, J.jsx)(un, {
				rootClassName: "pl-24 pr-24 pt-24 pb-24 dc__no-shrink",
				heading: "Release Channel",
				icon: /* @__PURE__ */ (0, J.jsx)(Sv, { className: "dc__no-shrink icon-dim-40" }),
				documentationLink: "DOC_HOME_PAGE",
				children: /* @__PURE__ */ (0, J.jsx)("div", {
					className: "flexbox-col dc__gap-24",
					children: /* @__PURE__ */ (0, J.jsx)("p", {
						className: "m-0",
						children: "Release channel is way to be subscribed by one or group of tenant (installation) for easy management (such as bulk deployments, user access management etc)."
					})
				})
			}), /* @__PURE__ */ (0, J.jsxs)("form", {
				className: "flexbox-col flex-grow-1 h-100",
				onSubmit: h,
				noValidate: !0,
				children: [/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col flex-grow-1 py-24 px-20 dc__gap-16",
					children: [
						/* @__PURE__ */ (0, J.jsx)(pt, {
							name: "release-channel-name",
							value: c.name,
							label: "Release channel display name",
							placeholder: "Eg. Acme Inc.",
							onChange: _(Cv.updateName),
							required: !0,
							fullWidth: !0,
							error: u.name,
							autoFocus: !0
						}),
						/* @__PURE__ */ (0, J.jsx)(pt, {
							name: "release-channel-id",
							value: c.channelId,
							label: "Release channel ID",
							placeholder: "Eg. acme-inc",
							onChange: _(Cv.updateChannelId),
							required: !0,
							error: u.channelId,
							disabled: s,
							helperText: "This is a unique identifier for a release channel. It cannot be changed once set."
						}),
						/* @__PURE__ */ (0, J.jsx)(Un, {
							label: "Description",
							name: "release-channel-description",
							placeholder: "Write a description for this release channel",
							value: c.description,
							onChange: _(Cv.updateDescription),
							error: u.description
						}),
						/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-bottom-n1" }),
						/* @__PURE__ */ (0, J.jsx)("div", {
							className: "flex left",
							children: /* @__PURE__ */ (0, J.jsx)(it, {
								isChecked: c.isDefault,
								onChange: () => {
									g({ action: Cv.toggleIsDefault });
								},
								value: rt.CHECKED,
								rootClassName: "mb-0 dc__align-self-start dc__no-shrink",
								children: /* @__PURE__ */ (0, J.jsx)("span", {
									className: "fs-13 fw-4 lh-20 cn-9",
									children: "Set as default release channel"
								})
							})
						})
					]
				}), /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox flex-justify-end dc__gap-12 p-lr-20 pt-20 pb-20",
					children: [/* @__PURE__ */ (0, J.jsx)("button", {
						type: "button",
						className: "flex cta secondary h-36 fs-13 fw-6 lh-20-imp",
						disabled: f,
						onClick: e,
						children: "Cancel"
					}), /* @__PURE__ */ (0, J.jsx)(lt, {
						condition: m,
						wrap: Xr,
						children: /* @__PURE__ */ (0, J.jsx)("div", {
							className: "flexbox dc__align-items-center",
							children: /* @__PURE__ */ (0, J.jsx)(et, {
								isLoading: f,
								type: "submit",
								rootClassName: "flex cta h-36 fs-13 fw-6 lh-20-imp",
								disabled: f || m,
								children: "Save"
							})
						})
					})]
				})]
			})]
		})
	});
}, Tv = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	...e,
	children: [/* @__PURE__ */ (0, J.jsxs)("g", {
		clipPath: "url(#clip0_6196_69525)",
		children: [
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M18.3426 22.181C17.9138 21.9334 17.264 21.9065 16.8926 22.1209L4.77906 29.1148C4.40763 29.3292 4.45427 29.7043 4.88302 29.9519L21.6259 39.6184C22.0548 39.866 22.7046 39.8929 23.076 39.6785L35.1896 32.6848C35.561 32.4704 35.5144 32.0953 35.0854 31.8475L18.3426 22.181Z",
				fill: "#4762AF"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M17.707 34.4449C17.9109 34.5627 18.0766 34.8496 18.0766 35.0851C18.0766 35.3207 17.9109 35.4164 17.707 35.2986C17.5029 35.1808 17.3374 34.894 17.3374 34.6584C17.3374 34.4228 17.5029 34.3272 17.707 34.4449ZM19.1877 35.2999C19.3916 35.4177 19.5573 35.7045 19.5573 35.9401C19.5573 36.1756 19.3916 36.2711 19.1877 36.1533C18.9837 36.0357 18.8181 35.7487 18.8181 35.5133C18.8181 35.2778 18.9837 35.1821 19.1877 35.2999ZM20.6683 36.1548C20.8723 36.2726 21.0379 36.5594 21.0379 36.795C21.0379 37.0304 20.8723 37.1261 20.6683 37.0083C20.4644 36.8905 20.2987 36.6037 20.2987 36.3681C20.2987 36.1327 20.4644 36.037 20.6683 36.1548Z",
				fill: "#448FFF"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M4.5314 24.5276C4.5314 24.5276 4.49379 29.5469 4.53656 29.5401C4.57914 29.5335 6.60605 30.5847 6.60605 30.5847L8.67333 28.5042L8.80107 27.0105L4.5314 24.5276ZM35.4403 27.3433V32.3197L32.3065 34.1423L30.6914 30.304L35.4403 27.3433Z",
				fill: "#4762AF"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M18.3426 17.2031C17.9138 16.9555 17.264 16.9286 16.8926 17.143L4.77906 24.1367C4.40763 24.3513 4.45427 24.7264 4.88302 24.974L21.6259 34.6405C22.0548 34.8881 22.7046 34.915 23.076 34.7006L35.1896 27.7069C35.561 27.4923 35.5144 27.1172 35.0854 26.8696L18.3426 17.2031Z",
				fill: "#6D8ACA"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M19.978 32.2327C19.978 32.2327 21.8818 33.5939 23.0276 32.961C24.1734 32.3278 34.2785 26.4039 34.2785 26.4039L34.2693 24.6743L19.978 30.168V32.2327Z",
				fill: "#5D7BC1"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M7.78027 23.1254V25.1901L19.9843 32.2361V30.1714L7.78027 23.1254Z",
				fill: "#5D7BC1"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M14.5836 33.0684C14.5836 32.8328 14.4402 32.5587 14.2636 32.4568L6.14715 27.7709C5.97056 27.6687 5.82715 27.7771 5.82715 28.0127C5.82715 28.2483 5.97056 28.5224 6.14715 28.6243L14.2636 33.3102C14.4402 33.4123 14.5836 33.3039 14.5836 33.0684Z",
				fill: "#6D8ACA"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M18.3426 22.181C17.9138 21.9334 17.264 21.9065 16.8926 22.1209L4.77906 29.1148C4.40763 29.3292 4.45427 29.7043 4.88302 29.9519L21.6259 39.6184C22.0548 39.866 22.7046 39.8929 23.076 39.6785L35.1896 32.6848C35.561 32.4704 35.5144 32.0953 35.0854 31.8475L18.3426 22.181Z",
				fill: "#4762AF"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M17.707 34.4449C17.9109 34.5627 18.0766 34.8496 18.0766 35.0851C18.0766 35.3207 17.9109 35.4164 17.707 35.2986C17.5029 35.1808 17.3374 34.894 17.3374 34.6584C17.3374 34.4228 17.5029 34.3272 17.707 34.4449ZM19.1877 35.2999C19.3916 35.4177 19.5573 35.7045 19.5573 35.9401C19.5573 36.1756 19.3916 36.2711 19.1877 36.1533C18.9837 36.0357 18.8181 35.7487 18.8181 35.5133C18.8181 35.2778 18.9837 35.1821 19.1877 35.2999ZM20.6683 36.1548C20.8723 36.2726 21.0379 36.5594 21.0379 36.795C21.0379 37.0304 20.8723 37.1261 20.6683 37.0083C20.4644 36.8905 20.2987 36.6037 20.2987 36.3681C20.2987 36.1327 20.4644 36.037 20.6683 36.1548Z",
				fill: "#448FFF"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M4.5314 24.5276C4.5314 24.5276 4.49379 29.5469 4.53656 29.5401C4.57914 29.5335 6.60605 30.5847 6.60605 30.5847L8.67333 28.5042L8.80107 27.0105L4.5314 24.5276ZM35.4403 27.3433V32.3197L32.3065 34.1423L30.6914 30.304L35.4403 27.3433Z",
				fill: "#4762AF"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M18.3426 17.2031C17.9138 16.9555 17.264 16.9286 16.8926 17.143L4.77906 24.1367C4.40763 24.3513 4.45427 24.7264 4.88302 24.974L21.6259 34.6405C22.0548 34.8881 22.7046 34.915 23.076 34.7006L35.1896 27.7069C35.561 27.4923 35.5144 27.1172 35.0854 26.8696L18.3426 17.2031Z",
				fill: "#6D8ACA"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M19.978 32.2327C19.978 32.2327 21.8818 33.5939 23.0276 32.961C24.1734 32.3278 34.2785 26.4039 34.2785 26.4039L34.2693 24.6743L19.978 30.168V32.2327Z",
				fill: "#5D7BC1"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M7.78027 23.1254V25.1901L19.9843 32.2361V30.1714L7.78027 23.1254Z",
				fill: "#5D7BC1"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M14.5836 33.0684C14.5836 32.8328 14.4402 32.5587 14.2636 32.4568L6.14715 27.7709C5.97056 27.6687 5.82715 27.7771 5.82715 28.0127C5.82715 28.2483 5.97056 28.5224 6.14715 28.6243L14.2636 33.3102C14.4402 33.4123 14.5836 33.3039 14.5836 33.0684Z",
				fill: "#6D8ACA"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M18.3426 13.682C17.9138 13.4343 17.264 13.4074 16.8926 13.6217L4.77906 20.6157C4.40763 20.83 4.45427 21.2052 4.88302 21.4527L21.6259 31.1193C22.0548 31.3668 22.7046 31.3937 23.076 31.1793L35.1896 24.1856C35.561 23.9712 35.5144 23.5961 35.0854 23.3484L18.3426 13.682Z",
				fill: "#4762AF"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M17.707 25.9458C17.9109 26.0636 18.0766 26.3504 18.0766 26.586C18.0766 26.8216 17.9109 26.9172 17.707 26.7994C17.5029 26.6817 17.3374 26.3948 17.3374 26.1593C17.3374 25.9237 17.5029 25.828 17.707 25.9458ZM19.1877 26.8007C19.3916 26.9185 19.5573 27.2053 19.5573 27.4409C19.5573 27.6765 19.3916 27.772 19.1877 27.6542C18.9837 27.5366 18.8181 27.2496 18.8181 27.0142C18.8181 26.7786 18.9837 26.6829 19.1877 26.8007ZM20.6683 27.6557C20.8723 27.7735 21.0379 28.0603 21.0379 28.2958C21.0379 28.5312 20.8723 28.6269 20.6683 28.5091C20.4644 28.3913 20.2987 28.1045 20.2987 27.8689C20.2987 27.6335 20.4644 27.5379 20.6683 27.6557Z",
				fill: "#448FFF"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M4.5314 16.0284C4.5314 16.0284 4.49379 21.0478 4.53656 21.041C4.57914 21.0343 6.60605 22.0856 6.60605 22.0856L8.67333 20.005L8.80107 18.5114L4.5314 16.0284ZM35.4403 18.8443V23.8205L32.3065 25.6432L30.6914 21.8048L35.4403 18.8443Z",
				fill: "#4762AF"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M18.3426 8.70395C17.9138 8.45639 17.264 8.42948 16.8926 8.64386L4.77906 15.6376C4.40763 15.8522 4.45427 16.2273 4.88302 16.4748L21.6259 26.1414C22.0548 26.3889 22.7046 26.4158 23.076 26.2015L35.1896 19.2077C35.561 18.9932 35.5144 18.6181 35.0854 18.3705L18.3426 8.70395ZM14.5833 24.5692C14.5833 24.3336 14.4399 24.0595 14.2633 23.9576L6.1468 19.2717C5.97021 19.1696 5.8268 19.278 5.8268 19.5135C5.8268 19.7491 5.97021 20.0232 6.1468 20.1251L14.2633 24.811C14.4399 24.9132 14.5833 24.8048 14.5833 24.5692Z",
				fill: "#6D8ACA"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M19.978 23.746C19.978 23.746 21.8818 25.1074 23.0276 24.4743C24.1734 23.8413 34.2785 17.9172 34.2785 17.9172L34.2693 16.1876L19.978 21.6814V23.746Z",
				fill: "#5D7BC1"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M7.78027 14.6389V16.7036L19.9843 23.7497V21.685L7.78027 14.6389Z",
				fill: "#5D7BC1"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M18.3426 5.18288C17.9138 4.93514 17.264 4.90822 16.8926 5.1226L4.77906 12.1165C4.40763 12.3309 4.45427 12.706 4.88302 12.9536L21.6259 22.6201C22.0548 22.8677 22.7046 22.8948 23.076 22.6802L35.1896 15.6865C35.561 15.4721 35.5144 15.097 35.0854 14.8492L18.3426 5.18288Z",
				fill: "#4762AF"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M17.707 17.4467C17.9109 17.5644 18.0766 17.8513 18.0766 18.0868C18.0766 18.3224 17.9109 18.4181 17.707 18.3003C17.5029 18.1825 17.3374 17.8957 17.3374 17.6601C17.3374 17.4245 17.5029 17.3289 17.707 17.4467ZM19.1877 18.3016C19.3916 18.4194 19.5573 18.7062 19.5573 18.9418C19.5573 19.1773 19.3916 19.2728 19.1877 19.155C18.9837 19.0374 18.8181 18.7504 18.8181 18.515C18.8181 18.2795 18.9837 18.1838 19.1877 18.3016ZM20.6683 19.1565C20.8723 19.2743 21.0379 19.5611 21.0379 19.7967C21.0379 20.0321 20.8723 20.1278 20.6683 20.01C20.4644 19.8922 20.2987 19.6054 20.2987 19.3698C20.2987 19.1344 20.4644 19.0387 20.6683 19.1565Z",
				fill: "#448FFF"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M4.5314 7.52917C4.5314 7.52917 4.49379 12.5485 4.53656 12.5417C4.57914 12.5351 6.60605 13.5863 6.60605 13.5863L8.67333 11.5058L8.80107 10.0121L4.5314 7.52917ZM35.4403 10.345V15.3212L32.3065 17.1439L30.6914 13.3056L35.4403 10.345Z",
				fill: "#4762AF"
			}),
			/* @__PURE__ */ (0, J.jsx)("path", {
				d: "M18.3426 0.204806C17.9138 -0.0427516 17.264 -0.069664 16.8926 0.144714L4.77906 7.13845C4.40763 7.35301 4.45427 7.72812 4.88302 7.97568L21.6259 17.6422C22.0548 17.8898 22.7046 17.9167 23.076 17.7023L35.1896 10.7086C35.561 10.494 35.5144 10.1189 35.0854 9.87135L18.3426 0.204806ZM14.5833 16.0701C14.5833 15.8345 14.4399 15.5604 14.2633 15.4584L6.1468 10.7725C5.97021 10.6704 5.8268 10.779 5.8268 11.0144C5.8268 11.25 5.97021 11.5241 6.1468 11.626L14.2633 16.3121C14.4399 16.414 14.5833 16.3056 14.5833 16.0701Z",
				fill: "#6D8ACA"
			})
		]
	}), /* @__PURE__ */ (0, J.jsx)("defs", { children: /* @__PURE__ */ (0, J.jsx)("clipPath", {
		id: "clip0_6196_69525",
		children: /* @__PURE__ */ (0, J.jsx)("rect", {
			width: 40,
			height: 40,
			fill: "white"
		})
	}) })]
}), Ev = /* @__PURE__ */ function(e) {
	return e.updateName = "updateName", e.updateInstallationId = "updateInstallationId", e.toggleShouldSubscribeToReleaseChannel = "toggleShouldSubscribeToReleaseChannel", e.updateReleaseChannel = "updateReleaseChannel", e;
}({}), Dv = {
	installationId: "",
	name: "",
	releaseChannelId: null
}, Ov = {
	name: null,
	installationId: null,
	releaseChannelId: null
}, kv = {
	name: "",
	installationId: "",
	releaseChannelId: null
}, Av = ({ handleClose: e, handleSuccess: t, installationConfig: n }) => {
	let [r, i] = A(!1), a = Pe(null), { image: o, name: s, tenantId: c } = hv(), [l, u, , d] = K(() => jg()), { installationId: f, name: p, releaseChannelId: m } = n, h = !!f, [g, _] = A(structuredClone(Dv)), [v, y] = A(structuredClone(h ? Ov : kv)), [x, S] = A(!1), C = k(() => Object.values(v).filter((e) => !Br(e)).length > 0 || l, [v, l]), w = (u ?? []).map(({ name: e, channelId: t }) => ({
		label: e,
		value: t,
		startIcon: /* @__PURE__ */ (0, J.jsx)(vv, {})
	})), T = !Br(g.releaseChannelId);
	O(() => {
		n && _({
			name: p,
			installationId: f,
			releaseChannelId: m
		});
	}, [n]);
	let ee = async (n) => {
		if (n.preventDefault(), C) {
			B.showToast({
				variant: V.error,
				description: b
			});
			return;
		}
		S(!0);
		let r = {
			name: g.name,
			installationId: g.installationId,
			tenantId: c,
			releaseChannelId: g.releaseChannelId
		};
		try {
			await (h ? W_(r) : K_(r)), B.showToast({
				variant: V.success,
				description: `Installation ${h ? "updated" : "created"} successfully`
			}), S(!1), t(), e();
		} catch (e) {
			W(e), S(!1);
		}
	}, E = (e, t) => {
		let n = structuredClone(g), r = structuredClone(v);
		switch (e) {
			case Ev.updateName:
				n.name = t, r.name = yi(t).message;
				break;
			case Ev.updateInstallationId:
				n.installationId = t, r.installationId = xi(t).message;
				break;
			case Ev.toggleShouldSubscribeToReleaseChannel: {
				let e = T ? null : "";
				n.releaseChannelId = e, r.releaseChannelId = e;
				break;
			}
			case Ev.updateReleaseChannel:
				n.releaseChannelId = t, r.releaseChannelId = null;
				break;
			default: throw Error(`Action ${e} is not supported`);
		}
		_(n), y(r);
	}, te = (e) => {
		E(Ev.updateName, e.target.value);
	}, ne = (e) => {
		E(Ev.updateInstallationId, e.target.value);
	}, re = () => {
		E(Ev.toggleShouldSubscribeToReleaseChannel, null);
	}, ie = (e) => {
		E(Ev.updateReleaseChannel, e.value);
	}, ae = () => {
		i((e) => (e || a.current.blur(), !e));
	};
	return /* @__PURE__ */ (0, J.jsx)(Qn, {
		className: "visible-modal__body",
		children: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox bg__primary w-800 h-500 dc__m-auto mt-40 dc__border-radius-8-imp dc__overflow-hidden",
			children: [
				/* @__PURE__ */ (0, J.jsx)(un, {
					rootClassName: "pl-24 pr-24 pt-24 pb-24 dc__no-shrink",
					heading: "Installation",
					icon: /* @__PURE__ */ (0, J.jsx)(Tv, { className: "dc__no-shrink icon-dim-40" }),
					documentationLink: "TENANTS_INSTALLATION",
					children: /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox-col dc__gap-24",
						children: [/* @__PURE__ */ (0, J.jsx)("p", {
							className: "m-0",
							children: "A tenant can have multiple installations of your software."
						}), /* @__PURE__ */ (0, J.jsx)("p", {
							className: "m-0",
							children: "An installation represents a deployment of your software across one or more environments of a tenant."
						})]
					})
				}),
				/* @__PURE__ */ (0, J.jsxs)("form", {
					className: "flexbox-col flex-grow-1 h-100",
					onSubmit: ee,
					children: [/* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox-col flex-grow-1 py-24 px-20 dc__gap-16",
						children: [
							/* @__PURE__ */ (0, J.jsxs)("div", {
								className: "flexbox dc__gap-8",
								children: [
									/* @__PURE__ */ (0, J.jsxs)("div", {
										className: "flexbox-col",
										children: [/* @__PURE__ */ (0, J.jsx)("span", {
											className: "form__label dc__required-field",
											children: "Tenant"
										}), /* @__PURE__ */ (0, J.jsxs)("div", {
											className: "dc__border br-4 bg__primary h-36 w-150 p-8 flex dc__content-start dc__gap-8 cursor-not-allowed",
											children: [/* @__PURE__ */ (0, J.jsx)(sf, { imageProps: {
												src: o,
												alt: `Logo for tenant: ${s}`,
												height: 20,
												width: 20,
												loading: "lazy"
											} }), /* @__PURE__ */ (0, J.jsx)("span", {
												className: "fs-13 fw-4 lh-20 cn-9 dc__truncate",
												children: s
											})]
										})]
									}),
									/* @__PURE__ */ (0, J.jsx)("span", {
										className: "flexbox-col fs-20 fw-4 lh-36 pt-24",
										children: "/"
									}),
									/* @__PURE__ */ (0, J.jsx)(pt, {
										fullWidth: !0,
										name: "installation-name",
										value: g.name,
										label: "Installation display name",
										placeholder: "Eg. Production",
										onChange: te,
										required: !0,
										error: v.name,
										autoFocus: !0
									})
								]
							}),
							/* @__PURE__ */ (0, J.jsx)(pt, {
								name: "installation-id",
								value: g.installationId,
								label: "Installation ID",
								placeholder: "Eg. acme-prod",
								onChange: ne,
								required: !0,
								error: v.installationId,
								disabled: h,
								helperText: "This cannot be changed later."
							}),
							/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-bottom-n1 w-100" }),
							/* @__PURE__ */ (0, J.jsxs)("div", {
								className: "flex left dc__gap-8",
								children: [/* @__PURE__ */ (0, J.jsx)(it, {
									isChecked: T,
									onChange: re,
									value: rt.CHECKED,
									rootClassName: "mb-0 w-20 p-2 dc__align-self-start dc__no-shrink",
									id: "subscribe-to-release-channel"
								}), /* @__PURE__ */ (0, J.jsxs)("div", {
									className: "flexbox-col dc__gap-8",
									children: [/* @__PURE__ */ (0, J.jsxs)("label", {
										htmlFor: "subscribe-to-release-channel",
										className: "m-0 fw-4 flexbox-col cursor",
										children: [/* @__PURE__ */ (0, J.jsx)("span", {
											className: "fs-13 fw-6 lh-20 cn-9",
											children: "Subscribe to a release channel"
										}), /* @__PURE__ */ (0, J.jsx)("span", {
											className: "fs-12 fw-4 lh-18 cn-7",
											children: "For easy management (such as bulk deployments, user access management etc), subscribe to a release channel."
										})]
									}), T && /* @__PURE__ */ (0, J.jsx)(jn, {
										inputId: "subscribe-release-channel",
										options: w,
										value: w.find((e) => e.value === g.releaseChannelId) ?? null,
										required: !0,
										placeholder: "Select a release channel to subscribe",
										onChange: ie,
										isDisabled: l,
										isLoading: l,
										icon: /* @__PURE__ */ (0, J.jsx)(vv, {}),
										showSelectedOptionIcon: !1,
										menuListFooterConfig: {
											type: "button",
											buttonProps: {
												variant: N.borderLess,
												text: "Create Release Channel",
												startIcon: /* @__PURE__ */ (0, J.jsx)(Yt, {
													name: "ic-add",
													color: null
												}),
												onClick: ae,
												dataTestId: "create-release-channel"
											}
										},
										selectRef: a
									})]
								})]
							})
						]
					}), /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox flex-justify-end dc__gap-12 p-lr-20 pt-20 pb-20",
						children: [/* @__PURE__ */ (0, J.jsx)("button", {
							type: "button",
							className: "flex cta secondary h-36 fs-13 fw-6 lh-20-imp",
							disabled: x,
							onClick: e,
							children: "Cancel"
						}), /* @__PURE__ */ (0, J.jsx)(lt, {
							condition: C,
							wrap: Xr,
							children: /* @__PURE__ */ (0, J.jsx)("div", {
								className: "flexbox dc__align-items-center",
								children: /* @__PURE__ */ (0, J.jsx)(et, {
									isLoading: x,
									type: "submit",
									rootClassName: "flex cta h-36 fs-13 fw-6 lh-20-imp",
									disabled: x || C,
									children: "Save"
								})
							})
						})]
					})]
				}),
				r && /* @__PURE__ */ (0, J.jsx)(wv, {
					handleClose: ae,
					handleSuccess: d,
					releaseChannelConfig: structuredClone(xv)
				})
			]
		})
	});
}, jv = () => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "fs-13 fw-4 lh-20 cn-9",
	children: [
		/* @__PURE__ */ (0, J.jsx)("div", { children: "Devtron enables you to distribute software to your customers even when their Kubernetes clusters are not directly connected to Devtron." }),
		/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "mt-20",
			children: ["For such software distribution, Devtron at your infrastructure pushes the following artifacts to OCI registry:", /* @__PURE__ */ (0, J.jsxs)("ul", { children: [/* @__PURE__ */ (0, J.jsxs)("li", { children: [/* @__PURE__ */ (0, J.jsx)("span", {
				className: "fw-6",
				children: "Helm packages"
			}), " for each deployment stage"] }), /* @__PURE__ */ (0, J.jsxs)("li", { children: [/* @__PURE__ */ (0, J.jsx)("span", {
				className: "fw-6",
				children: "A release orchestration manifest"
			}), " (containing instructions & references to respective Helm charts for each deployment stage)"] })] })]
		}),
		/* @__PURE__ */ (0, J.jsx)("div", {
			className: "mt-20",
			children: "A deployment agent, installed in the customer's infrastructure, pulls artifacts & executes the installation by applying the manifest."
		})
	]
}), Mv = (e, t) => {
	if (!t?.searchKey) return !0;
	let n = t.searchKey.toLowerCase();
	return e.data.name.toLowerCase().includes(n) || e.data.namespace.toLowerCase().includes(n) || e.data.cluster.toLowerCase().includes(n);
}, Nv = ({ field: e, row: t, filterData: n }) => /* @__PURE__ */ (0, J.jsx)("span", {
	className: "dc__truncate",
	dangerouslySetInnerHTML: { __html: C.sanitize(zr({
		searchText: n?.searchKey || "",
		text: t.data[e],
		highlightClasses: "bcy-2"
	})) }
}), Pv = [
	{
		field: "name",
		label: "Environment",
		isSortable: !0,
		CellComponent: Nv,
		comparator: G,
		size: null
	},
	{
		field: "namespace",
		label: "Namespace",
		isSortable: !0,
		CellComponent: Nv,
		comparator: G,
		size: null
	},
	{
		field: "envType",
		label: "Environment Type",
		isSortable: !0,
		comparator: G,
		size: null
	},
	{
		field: "cluster",
		label: "Cluster",
		isSortable: !0,
		CellComponent: Nv,
		comparator: G,
		size: null
	}
], Fv = ({ children: e, handleSearch: t, searchKey: n, renderMapEnvButton: r, areRowsLoading: i }) => /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
	className: "flex dc__content-space dc__gap-16 px-20 py-16",
	children: [/* @__PURE__ */ (0, J.jsx)(On, {
		inputProps: {
			placeholder: "Search",
			disabled: i
		},
		handleEnter: t,
		initialSearchText: n,
		containerClassName: "w-250"
	}), r()]
}), /* @__PURE__ */ (0, J.jsx)("div", {
	className: "flexbox-col flex-grow-1 dc__overflow-auto",
	children: e
})] }), Iv = ({ isInstallationLoading: e, environments: t = [], renderMapEnvButton: n }) => /* @__PURE__ */ (0, J.jsx)(Hn, {
	id: "table__installation-environment-list",
	rows: k(() => t.map((e) => ({
		id: e.name,
		data: {
			...e,
			envType: e.isVirtual ? "-" : e.environmentType
		}
	})), [t]),
	columns: Pv,
	filtersVariant: Ut.STATE,
	filter: Mv,
	additionalProps: { renderMapEnvButton: n },
	loading: e,
	ViewWrapper: Fv,
	additionalFilterProps: { initialSortKey: "name" },
	paginationVariant: mn.NOT_PAGINATED,
	emptyStateConfig: {
		noRowsConfig: {
			title: "No environments found",
			subTitle: "Please add an environment to see it here."
		},
		noRowsForFilterConfig: {
			title: "No matching environments",
			subTitle: "We couldn’t find any matching environments."
		}
	},
	rowStartIconConfig: {
		name: "ic-environment",
		color: "B500",
		size: 24
	}
}), Lv = /* @__PURE__ */ function(e) {
	return e.uploadManifestToOCI = "uploadManifestToOCI", e.downloadManifestToLocal = "downloadManifestToLocal", e;
}({}), Rv = {
	pushToRemote: !1,
	dockerRegistryId: null,
	repository: ""
}, zv = {
	pushToRemote: null,
	dockerRegistryId: null,
	repository: null
}, Bv = async () => {
	let { result: e } = await H("docker/registry");
	return e ? e.filter(({ active: e, isOCICompliantRegistry: t, ociRegistryConfig: n }) => e && t && ["PUSH", "PULL/PUSH"].includes(n?.CHART)).map(({ id: e, registryType: t }) => ({
		label: e,
		value: e,
		startIcon: /* @__PURE__ */ (0, J.jsx)(Cn, { registryType: t })
	})) : [];
}, Vv = async ({ tenantId: e, installationId: t, shouldAddTimeStamp: n }) => {
	let r = window.location.origin, i = Ms({
		tenantId: e,
		installationId: t
	}), a = (/* @__PURE__ */ new Date()).getTime(), { result: o } = await Gr("api-token", {
		name: `${i}${n ? `-${a}` : ""}`,
		description: `API Token for isolated installation with identifier: ${i}`,
		expireAtInMs: 0
	});
	return await Gr(_.USER, {
		id: o.userId,
		email_id: o.userIdentifier,
		userRoleGroups: [],
		superAdmin: !1,
		roleFilters: [],
		userStatus: Zn.active,
		userGroups: []
	}), Wr(Tr({
		baseUrl: _.RESOURCE,
		kind: L.installation,
		version: R.alpha1
	}), {
		identifier: i,
		query: [{
			op: hn.replace,
			path: "tokenId",
			value: o.id
		}, {
			op: hn.replace,
			path: "hostName",
			value: r
		}]
	});
}, Hv = /* @__PURE__ */ function(e) {
	return e.updatePushToRemote = "updatePushToRemote", e.updateRegistry = "updateRegistry", e.updateRepository = "updateRepository", e;
}({}), Uv = ({ handleClose: e, handleSuccess: t, installationId: n, deploymentConfig: r }) => {
	let { tenantId: i } = hv(), [a, o] = K(() => Bv()), [s, c] = A(structuredClone(Rv)), [l, u] = A(structuredClone(zv)), [f, p] = A(!1), m = k(() => a || Object.values(l).filter((e) => !Br(e)).length > 0, [l, a]), { dockerRegistryId: h, pushToRemote: g, repository: _ } = r ?? {};
	O(() => {
		r && c({
			dockerRegistryId: h,
			pushToRemote: g,
			repository: _
		});
	}, [r]);
	let v = async (r) => {
		if (r.preventDefault(), m) {
			B.showToast({
				variant: V.error,
				description: b
			});
			return;
		}
		p(!0);
		let a = {
			installationId: n,
			tenantId: i,
			repository: s.repository,
			dockerRegistryId: s.dockerRegistryId,
			pushToRemote: s.pushToRemote
		};
		try {
			await G_(a), B.showToast({
				variant: V.success,
				description: "Isolated deployment settings updated successfully"
			}), p(!1), t(), e();
		} catch (e) {
			W(e), p(!1);
		}
	}, y = ({ action: e, value: t }) => {
		let n = structuredClone(s), r = structuredClone(l);
		switch (e) {
			case Hv.updatePushToRemote:
				n.pushToRemote = t, t ? (r.dockerRegistryId = n.dockerRegistryId ? null : "", r.repository = Zr(n.repository).isValid ? null : "") : (r.dockerRegistryId = null, r.repository = null);
				break;
			case Hv.updateRegistry:
				n.dockerRegistryId = t, r.dockerRegistryId = t ? null : "This field is required";
				break;
			case Hv.updateRepository:
				n.repository = t, r.repository = Zr(t).message;
				break;
			default: throw Error(`Action ${e} is not supported`);
		}
		c(n), u(r);
	};
	return /* @__PURE__ */ (0, J.jsx)($n, {
		className: "visible-modal__body",
		children: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col bg__primary w-600 dc__m-auto mt-40 dc__border-radius-8-imp",
			children: [
				/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flex left dc__gap-8 dc__content-space dc__border-bottom py-12 px-16",
					children: [/* @__PURE__ */ (0, J.jsx)("h2", {
						className: "fs-16 fw-6 lh-24 cn-9 m-0",
						children: "Release orchestration manifest delivery"
					}), /* @__PURE__ */ (0, J.jsx)("button", {
						type: "button",
						"aria-label": "close modal",
						onClick: e,
						className: "dc__transparent p-4 flex dc__no-shrink",
						children: /* @__PURE__ */ (0, J.jsx)(d, { className: "fcn-6 icon-dim-16" })
					})]
				}),
				/* @__PURE__ */ (0, J.jsx)(nn, {
					description: "A release orchestration manifest is generated when a release is triggered for an isolated tenant installation.",
					borderConfig: {
						top: !1,
						left: !1,
						right: !1
					},
					borderRadiusConfig: {
						top: !1,
						left: !1,
						right: !1,
						bottom: !1
					}
				}),
				/* @__PURE__ */ (0, J.jsxs)("form", {
					className: "flexbox-col flex-grow-1",
					onSubmit: v,
					children: [/* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox-col flex-grow-1 p-20 dc__gap-12",
						children: [/* @__PURE__ */ (0, J.jsx)("h3", {
							className: "fs-13 fw-6 lh-20 cn-9 m-0",
							children: "How do you want to deliver the manifest?"
						}), /* @__PURE__ */ (0, J.jsxs)("div", {
							className: "flexbox-col dc__gap-8",
							children: [/* @__PURE__ */ (0, J.jsx)(xn, {
								name: "push-to-remote",
								value: s.pushToRemote ? Lv.uploadManifestToOCI : Lv.downloadManifestToLocal,
								disabled: !1,
								onChange: (e) => {
									y({
										action: Hv.updatePushToRemote,
										value: e.target.value === Lv.uploadManifestToOCI
									});
								},
								className: "radio-group-no-border w-100",
								children: /* @__PURE__ */ (0, J.jsxs)("div", {
									className: "flex column dc__gap-8 left",
									children: [/* @__PURE__ */ (0, J.jsx)(Sn, {
										value: Lv.downloadManifestToLocal,
										children: "Download manifest to local machine"
									}), /* @__PURE__ */ (0, J.jsx)(Sn, {
										value: Lv.uploadManifestToOCI,
										children: "Upload manifest to OCI registry"
									})]
								})
							}), s.pushToRemote && /* @__PURE__ */ (0, J.jsxs)("div", {
								className: "pl-28 flex left top dc__gap-12",
								children: [/* @__PURE__ */ (0, J.jsx)("div", {
									className: "w-200",
									children: /* @__PURE__ */ (0, J.jsx)(jn, {
										inputId: "docker-registry",
										options: o,
										value: o?.find((e) => e.value === s.dockerRegistryId) ?? null,
										error: l.dockerRegistryId,
										placeholder: "Select registry",
										label: "Registry",
										required: !0,
										menuPosition: "absolute",
										isLoading: a,
										isDisabled: a || f,
										onChange: (e) => {
											y({
												action: Hv.updateRegistry,
												value: e.value
											});
										},
										size: P.large
									})
								}), /* @__PURE__ */ (0, J.jsx)(pt, {
									name: "repository",
									value: s.repository,
									onChange: (e) => {
										y({
											action: Hv.updateRepository,
											value: e.target.value
										});
									},
									label: "Repository (desired format: username/repo-name)",
									required: !0,
									placeholder: "Enter repository name",
									error: l.repository
								})]
							})]
						})]
					}), /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox flex-justify-end dc__gap-12 p-16 dc__border-top",
						children: [/* @__PURE__ */ (0, J.jsx)(M, {
							text: "Cancel",
							variant: N.secondary,
							style: $e.neutral,
							disabled: f,
							onClick: e,
							dataTestId: "close-manifest-modal"
						}), /* @__PURE__ */ (0, J.jsx)(M, {
							text: "Save",
							disabled: f || m,
							isLoading: f,
							onClick: v,
							dataTestId: "save-manifest",
							showTooltip: m,
							tooltipProps: { content: "Valid input is required for all mandatory fields." }
						})]
					})]
				})
			]
		})
	});
}, Wv = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...e,
	children: [/* @__PURE__ */ (0, J.jsx)("path", {
		d: "M16.6665 5.00016H9.1665L7.49984 3.3335H3.33317C2.4165 3.3335 1.6665 4.0835 1.6665 5.00016V8.3335H18.3332V6.66683C18.3332 5.75016 17.5832 5.00016 16.6665 5.00016Z",
		fill: "#72ACE6"
	}), /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M16.6665 5H3.33317C2.4165 5 1.6665 5.75 1.6665 6.66667V15C1.6665 15.9167 2.4165 16.6667 3.33317 16.6667H16.6665C17.5832 16.6667 18.3332 15.9167 18.3332 15V6.66667C18.3332 5.75 17.5832 5 16.6665 5Z",
		fill: "#ABCFF3"
	})]
}), Gv = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	"data-style-override": "false",
	width: 560,
	height: 250,
	viewBox: "0 0 560 250",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsx)("style", { children: "@keyframes moving-border{0%{stroke-dashoffset:9}to{stroke-dashoffset:0}}.svg__connector{stroke-dasharray:4 5;stroke-linecap:round;animation:moving-border .5s infinite linear}" }),
		/* @__PURE__ */ (0, J.jsxs)("g", {
			clipPath: "url(#clip0_9067_37937)",
			children: [
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#06C",
					d: "M0 0h560v250H0z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M13 1h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M143 0h1v144h-1zM0 0h1v144H0z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M1 131v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M0 1V0h144v1zm0 143v-1h144v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M13 144h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M143 143h1v144h-1zM0 143h1v144H0z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M1 248v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M0 144v-1h144v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M156 1h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M286 0h1v144h-1zM143 0h1v144h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M144 131v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M143 1V0h144v1zm0 143v-1h144v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M156 144h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M286 143h1v144h-1zm-143 0h1v144h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M144 248v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M143 144v-1h144v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M299 1h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M429 0h1v144h-1zM286 0h1v144h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M287 131v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M286 1V0h144v1zm0 143v-1h144v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M299 144h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M429 143h1v144h-1zm-143 0h1v144h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M287 248v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M286 144v-1h144v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M442 1h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M429 0h1v144h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M430 131v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M429 1V0h144v1zm0 143v-1h144v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M442 144h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1zm13 0h1v142h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M429 143h1v144h-1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#1A75D1",
					d: "M430 248v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1zm0-13v-1h142v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fill: "#358CE6",
					d: "M429 144v-1h144v1z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					stroke: "#fff",
					strokeLinecap: "round",
					strokeDasharray: "3 5",
					d: "M10 10h540v230H10z"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M20 10c0 5.523-4.477 10-10 10m530-10c0 5.523 4.477 10 10 10m-10 220c0-5.523 4.477-10 10-10M20 240c0-5.523-4.477-10-10-10",
					stroke: "#fff",
					strokeLinecap: "round",
					strokeDasharray: "3 5"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M491.579 225.364q.542 0 .872-.219.329-.22.513-.55.183-.329.241-.71.059-.38.059-.703t-.059-.703a2.1 2.1 0 0 0-.241-.711 1.6 1.6 0 0 0-.513-.549q-.33-.22-.872-.22t-.871.22a1.5 1.5 0 0 0-.506.549 2.2 2.2 0 0 0-.234.711 5 5 0 0 0-.059.703q0 .322.059.703t.234.71q.176.33.506.55.329.219.871.219m1.685-5.041V217h1.743v6.167q0 .762-.147 1.333a4 4 0 0 1-.388.989 2.7 2.7 0 0 1-.549.688q-.308.272-.63.447a3.8 3.8 0 0 1-1.714.41q-.981-.014-1.743-.41a3.7 3.7 0 0 1-.637-.447 2.7 2.7 0 0 1-.557-.681 3.8 3.8 0 0 1-.388-.981 5.4 5.4 0 0 1-.147-1.333q0-.762.14-1.333.138-.572.366-.989a2.9 2.9 0 0 1 1.106-1.15 3.36 3.36 0 0 1 1.611-.439q.454.043.879.219.366.162.747.491.254.22.308.342m7.749 1.907a4 4 0 0 0-.183-.469 1.5 1.5 0 0 0-.3-.425 1.4 1.4 0 0 0-.454-.3 1.6 1.6 0 0 0-.616-.11q-.351 0-.615.11a1.4 1.4 0 0 0-.454.3 1.6 1.6 0 0 0-.308.425 2.3 2.3 0 0 0-.176.469zm1.846 0q.029.22.051.454t.022.498v.263h-5.127q.029.25.073.506t.147.505q.16.381.498.674t.937.293q.601 0 .938-.293t.498-.674h1.904q-.117.513-.329.894a3.4 3.4 0 0 1-.469.659 2.7 2.7 0 0 1-.549.461 4 4 0 0 1-.572.301 3.9 3.9 0 0 1-1.421.263q-.981-.014-1.743-.41a3.7 3.7 0 0 1-.637-.446 2.7 2.7 0 0 1-.557-.682 3.8 3.8 0 0 1-.388-.981 5.4 5.4 0 0 1-.146-1.333q0-.762.146-1.333.147-.572.388-.989t.557-.696q.315-.278.637-.454.762-.41 1.743-.439.805.029 1.509.336.293.132.593.345t.557.527q.256.315.454.747t.286 1.004m3.237 4.658h2.402l2.417-7.427h-1.802l-1.816 5.552-1.816-5.552h-1.802zm7.397-5.684v3.267a.8.8 0 0 0 .161.322q.103.118.286.22a1 1 0 0 0 .476.102h1.113v1.773h-1.787a2.5 2.5 0 0 1-1.025-.322 2.3 2.3 0 0 1-.696-.652q-.315-.432-.315-1.194v-6.267h1.787v1.008h1.685v1.743zm3.194-.769q-.322.432-.322 1.194v5.259h1.801v-5.01a.84.84 0 0 1 .161-.322.97.97 0 0 1 .762-.323h1.377v-1.772h-2.05a2.5 2.5 0 0 0-1.026.322 2.4 2.4 0 0 0-.703.652m8.027.564q-.542 0-.872.22a1.5 1.5 0 0 0-.505.549 2.2 2.2 0 0 0-.234.711 5 5 0 0 0-.059.703q0 .322.059.703t.234.71q.176.33.505.55.33.219.872.219.543 0 .872-.219.33-.22.505-.55.175-.329.235-.71.058-.38.058-.703t-.058-.703a2.3 2.3 0 0 0-.235-.711 1.5 1.5 0 0 0-.505-.549q-.33-.22-.872-.22m-3.472 2.183q0-.762.147-1.333.146-.572.388-.989t.557-.696q.315-.278.637-.454.762-.41 1.743-.44.967.03 1.729.44.322.176.637.454.316.279.556.696.243.417.396.989.154.571.154 1.333t-.154 1.333a4 4 0 0 1-.396.981 2.6 2.6 0 0 1-.556.681q-.316.272-.637.447-.762.396-1.729.41-.981-.014-1.743-.41a3.7 3.7 0 0 1-.637-.447 2.7 2.7 0 0 1-.557-.681 3.8 3.8 0 0 1-.388-.981 5.4 5.4 0 0 1-.147-1.333m11.405-3.897q-.271-.015-.316-.015-.058 0-.322.015-.263.014-.63.125a3.8 3.8 0 0 0-.776.344 2.7 2.7 0 0 0-.762.674 3.6 3.6 0 0 0-.578 1.106q-.227.666-.227 1.648v3.706h1.787v-3.706q0-.323.058-.659a1.8 1.8 0 0 1 .22-.616q.162-.278.454-.461t.776-.183.777.183.454.461.22.616q.058.336.058.659v3.706h1.787v-3.706q0-.982-.227-1.648a3.6 3.6 0 0 0-.578-1.106 2.7 2.7 0 0 0-.762-.674 3.8 3.8 0 0 0-.776-.344 2.8 2.8 0 0 0-.637-.125m-61.533 8.343-2.922-4.6a1.22 1.22 0 0 1-.01-1.3l3.768-6.099a1.33 1.33 0 0 1 1.134-.629l5.439.019.036.001c.531.028.822.635.529 1.078l-3.775 5.721a.733.733 0 1 1-1.31-.656h.001v-.001l.001-.001a.7.7 0 0 1 .079-.121l.575-.879a.408.408 0 0 0-.292-.632l-1.382-.105a.94.94 0 0 0-.7.241c-.25.292-1.361 2.084-1.868 2.924a.79.79 0 0 0 .04.867l-.006.003 1.759 2.763.33.524a1 1 0 0 1 .089.143l.013.019-.001.005a.846.846 0 0 1-.621 1.182.844.844 0 0 1-.906-.467m9.749-11.064 2.942 4.588c.254.394.26.899.015 1.3l-3.74 6.115a1.33 1.33 0 0 1-1.131.634l-5.439.005-.037-.001c-.53-.024-.824-.63-.533-1.075l3.749-5.737a.735.735 0 0 1 .83-.397.73.73 0 0 1 .483 1.046v.001l-.001.002a1 1 0 0 1-.079.121l-.571.881a.408.408 0 0 0 .295.631l1.382.099a.94.94 0 0 0 .699-.244c.249-.293 1.351-2.09 1.855-2.932a.79.79 0 0 0-.044-.867l.007-.003-1.772-2.755-.332-.523a1 1 0 0 1-.091-.142l-.012-.019.001-.005a.846.846 0 0 1 .615-1.185.845.845 0 0 1 .909.462",
					fill: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 32,
					y: 46,
					width: 112,
					height: 84,
					rx: 8,
					fill: "#0151C9",
					fillOpacity: .7
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 32,
					y: 46,
					width: 112,
					height: 84,
					rx: 8,
					stroke: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M88 62h6m-6 12h6m-4 9h6m-6 0a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1m4 0a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1m-6 0h6m2-17v4m0 8v4M78 58h20v8H78zm6 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-6 8h20v8H78zm6 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
					stroke: "#fff",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M65.554 104.048v-1.584h1.812q.684 0 1.212-.204.54-.216.912-.6t.564-.9q.204-.528.204-1.164 0-.66-.204-1.176a2.4 2.4 0 0 0-.564-.9 2.4 2.4 0 0 0-.912-.564 3.5 3.5 0 0 0-1.212-.192h-1.812V95.18h1.704q1.188 0 2.076.348a4.1 4.1 0 0 1 1.476.96q.588.6.876 1.38.3.768.3 1.596v.264q0 .792-.3 1.56a4.1 4.1 0 0 1-.876 1.392 4.25 4.25 0 0 1-1.476.996q-.888.372-2.076.372zm-1.464 0V95.18h1.704v8.868zm12.206.18q-.84 0-1.476-.288a3.1 3.1 0 0 1-1.044-.768 3.6 3.6 0 0 1-.624-1.092 3.8 3.8 0 0 1-.204-1.224v-.228q0-.648.204-1.248.216-.612.624-1.08.42-.48 1.032-.756.612-.288 1.416-.288 1.056 0 1.764.468.72.456 1.08 1.212.36.744.36 1.608v.6h-5.772v-1.02h4.728l-.516.504q0-.624-.18-1.068a1.43 1.43 0 0 0-.552-.684q-.36-.24-.912-.24t-.936.252a1.6 1.6 0 0 0-.588.732q-.192.468-.192 1.128 0 .612.192 1.092.192.468.588.744.396.264 1.008.264t.996-.24q.384-.252.492-.612h1.536q-.144.672-.552 1.176a2.7 2.7 0 0 1-1.044.78q-.624.276-1.428.276M82.07 104l-2.04-6.516h1.716L83.703 104zm.493 0v-1.368h1.763V104zm.66 0 1.68-6.516h1.607L84.747 104zm7.496.084q-.9 0-1.487-.228a1.67 1.67 0 0 1-.864-.792q-.288-.564-.288-1.512l.011-5.904h1.56l-.011 6.012q0 .48.251.744.264.252.744.252h1.02v1.428zm-3.671-5.376v-1.224h4.608v1.224zM93.055 104v-6.516h1.32v2.76h-.036q0-1.404.6-2.124t1.764-.72h.24v1.452h-.456q-.84 0-1.308.456-.456.444-.456 1.296V104zm8.089.228q-.864 0-1.523-.276a3.3 3.3 0 0 1-1.117-.744 3.4 3.4 0 0 1-.696-1.08 3.5 3.5 0 0 1-.228-1.248v-.252q0-.672.24-1.272.253-.612.709-1.08.468-.48 1.127-.744a3.8 3.8 0 0 1 1.488-.276q.828 0 1.488.276.66.264 1.116.744.468.468.708 1.08.24.6.24 1.272v.252q0 .648-.24 1.248-.228.6-.684 1.08-.456.468-1.116.744t-1.512.276m0-1.428q.612 0 1.032-.264.42-.276.636-.732.216-.468.216-1.056 0-.6-.228-1.056a1.65 1.65 0 0 0-.648-.732q-.42-.276-1.008-.276t-1.02.276a1.75 1.75 0 0 0-.647.732 2.3 2.3 0 0 0-.228 1.056q0 .588.216 1.056.227.456.647.732.42.264 1.032.264m5.013 1.2v-6.516h1.32v2.796h-.12q0-.996.264-1.656.264-.672.78-1.008.528-.336 1.308-.336h.072q1.164 0 1.764.756.6.744.6 2.232V104h-1.668v-3.876q0-.6-.348-.972-.336-.372-.936-.372-.612 0-.996.384-.372.372-.372 1.008V104zm-39.905 11.16-2.32-4.46h1.02l1.96 3.82-.38-.11h1.18l-.4.11 1.84-3.82h.96l-2.18 4.46zm.36 2.84v-3.04h.96V118zm6.506.18q-.699 0-1.23-.24a2.8 2.8 0 0 1-.9-.63 2.9 2.9 0 0 1-.55-.89 2.9 2.9 0 0 1-.18-1v-.18q0-.51.19-1a2.7 2.7 0 0 1 .56-.89 2.6 2.6 0 0 1 .9-.63q.53-.24 1.21-.24t1.21.24q.531.23.9.63.37.39.56.89.19.49.19 1v.18q0 .51-.19 1-.18.49-.55.89-.36.39-.89.63t-1.23.24m0-.86q.6 0 1.02-.26.43-.27.65-.72.23-.45.23-1.01 0-.57-.23-1.02a1.74 1.74 0 0 0-.66-.71q-.42-.26-1.01-.26-.58 0-1.01.26-.429.26-.66.71-.23.45-.23 1.02 0 .56.22 1.01.23.45.65.72.43.26 1.03.26m6.148.84q-.95 0-1.46-.62t-.51-1.79v-3.1h.96v3.29q0 .63.34.99.34.35.92.35.6 0 .98-.38.38-.39.38-1.06v-3.19h.96V118h-.76v-2.29h.12q0 .79-.21 1.34-.21.54-.63.83-.41.28-1.05.28zm4.43-.16v-5.34h.76v2.2h-.04q0-1.17.51-1.71.52-.55 1.55-.55h.18v.86h-.34q-.801 0-1.23.43-.43.42-.43 1.22V118zm6.636 0v-5.34h.96V118zm-.82-4.58v-.76h1.78v.76zm1.09-1.62q-.32 0-.48-.17a.63.63 0 0 1-.15-.43q0-.26.15-.43.16-.17.48-.17t.47.17q.16.17.16.43a.6.6 0 0 1-.16.43q-.15.17-.47.17m2.546 6.2v-5.34h.76v2.29h-.12q0-.79.21-1.33.22-.55.66-.83.441-.29 1.11-.29h.04q1.01 0 1.49.63.49.63.49 1.82V118h-.96v-3.25q0-.62-.35-.99-.35-.38-.96-.38-.63 0-1.02.39t-.39 1.04V118zm6.537 0v-5.61q0-.89.47-1.31t1.38-.42h.66v.8h-.82q-.37 0-.57.21-.2.2-.2.56V118zm-.74-4.56v-.72h3.35v.72zm4.37 4.56v-5.34h.76v2.2h-.04q0-1.17.51-1.71.52-.55 1.55-.55h.18v.86h-.34q-.801 0-1.23.43-.43.42-.43 1.22V118zm7.312 0v-1.6h-.16v-1.85q0-.55-.29-.83-.28-.28-.83-.28-.31 0-.64.01l-.63.02a10 10 0 0 0-.52.03v-.84q.22-.02.46-.03.249-.02.51-.02.26-.01.5-.01.82 0 1.34.2.52.19.77.63t.25 1.19V118zm-1.75.14a2.5 2.5 0 0 1-1.04-.2q-.43-.21-.67-.6-.23-.39-.23-.94 0-.57.25-.95.26-.38.75-.57.49-.2 1.18-.2h1.45v.72h-1.49q-.58 0-.89.28a.93.93 0 0 0-.31.72q0 .44.31.71t.89.27q.34 0 .65-.12.309-.13.51-.42.21-.3.23-.82l.26.38q-.05.57-.28.96a1.45 1.45 0 0 1-.62.58q-.39.2-.95.2",
					fill: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsxs)("g", {
					opacity: .6,
					children: [/* @__PURE__ */ (0, J.jsx)("path", {
						d: "M251 37a4 4 0 0 1 4-4h50a4 4 0 0 1 4 4v2h-58z",
						fill: "#0158CB"
					}), /* @__PURE__ */ (0, J.jsx)("path", {
						d: "M251 37a4 4 0 0 1 4-4h50a4 4 0 0 1 4 4v2h-58z",
						stroke: "#fff"
					})]
				}),
				/* @__PURE__ */ (0, J.jsxs)("g", {
					opacity: .8,
					children: [/* @__PURE__ */ (0, J.jsx)("path", {
						d: "M243 45a6 6 0 0 1 6-6h62a6 6 0 0 1 6 6z",
						fill: "#0158CB"
					}), /* @__PURE__ */ (0, J.jsx)("path", {
						d: "M243 45a6 6 0 0 1 6-6h62a6 6 0 0 1 6 6z",
						stroke: "#fff"
					})]
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 236,
					y: 45,
					width: 88,
					height: 84,
					rx: 8,
					fill: "#0151C9",
					fillOpacity: .7
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 236,
					y: 45,
					width: 88,
					height: 84,
					rx: 8,
					stroke: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M285.366 64.633a7.59 7.59 0 0 1 0 10.733m0-10.733a7.59 7.59 0 0 0-10.732 0m10.732 0 2.907-2.906m-2.907 13.64a7.59 7.59 0 0 1-10.732 0m10.732 0 2.907 2.906m-13.639-2.907a7.59 7.59 0 0 1 0-10.733m0 10.733-2.907 2.907m2.907-13.64-2.907-2.906M280 58.3v4.11m0 15.179v4.11M268.3 70h4.111m15.178 0h4.111m-7.905 0a3.795 3.795 0 1 1-7.59 0 3.795 3.795 0 0 1 7.59 0",
					stroke: "#fff",
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M255.712 103.228q-1.188 0-2.064-.42a4.4 4.4 0 0 1-1.44-1.092 5 5 0 0 1-.852-1.464 4.6 4.6 0 0 1-.276-1.524v-.264q0-.804.288-1.596.288-.804.864-1.452a4.3 4.3 0 0 1 1.452-1.032q.864-.396 2.028-.396 1.152 0 2.016.396a4.15 4.15 0 0 1 1.44 1.032q.588.648.876 1.452a4.6 4.6 0 0 1 .288 1.596v.264q0 .732-.288 1.524a4.7 4.7 0 0 1-.852 1.464 4.2 4.2 0 0 1-1.44 1.092q-.864.42-2.04.42m0-1.584q.672 0 1.2-.24.54-.24.912-.66.384-.432.576-.972a3.3 3.3 0 0 0 .204-1.164q0-.66-.204-1.212a2.7 2.7 0 0 0-.576-.96 2.6 2.6 0 0 0-.912-.636 3.1 3.1 0 0 0-1.2-.228q-.672 0-1.212.228t-.924.636a2.9 2.9 0 0 0-.576.96 3.7 3.7 0 0 0-.192 1.212q0 .612.192 1.164.204.54.576.972.384.42.924.66t1.212.24m10.214 1.584q-1.188 0-2.04-.42a4.05 4.05 0 0 1-1.392-1.092 4.6 4.6 0 0 1-.78-1.464 5 5 0 0 1-.252-1.524v-.264q0-.816.252-1.608a4.4 4.4 0 0 1 .804-1.44q.54-.648 1.368-1.032.84-.396 1.98-.396 1.188 0 2.064.432.888.42 1.416 1.2.528.768.636 1.8h-1.716a2.06 2.06 0 0 0-.432-1.008 1.95 1.95 0 0 0-.828-.624 2.9 2.9 0 0 0-1.14-.216q-.648 0-1.152.228a2.2 2.2 0 0 0-.84.624 2.9 2.9 0 0 0-.516.96 4.2 4.2 0 0 0-.168 1.224q0 .648.168 1.2.18.552.528.972.348.408.852.636.516.228 1.188.228.984 0 1.656-.48.684-.492.828-1.368h1.716a4 4 0 0 1-.636 1.716 3.7 3.7 0 0 1-1.416 1.248q-.9.468-2.148.468m5.662-.228v-8.76h1.704V103zm6.48 0v-8.82h1.704V103zm5.352 0-2.688-3.816h1.908l2.772 3.816zm-4.152-2.928v-1.38h2.232q.468 0 .804-.192a1.35 1.35 0 0 0 .54-.54q.192-.348.192-.792 0-.456-.192-.804a1.35 1.35 0 0 0-.54-.54 1.6 1.6 0 0 0-.804-.192h-2.232V94.18h2.052q1.056 0 1.824.312.78.312 1.2.948t.42 1.596v.192q0 .972-.432 1.596-.42.624-1.188.936t-1.824.312zm10.104 3.156q-.84 0-1.476-.288a3.1 3.1 0 0 1-1.044-.768 3.6 3.6 0 0 1-.624-1.092 3.8 3.8 0 0 1-.204-1.224v-.228q0-.648.204-1.248.216-.612.624-1.08.42-.48 1.032-.756.612-.288 1.416-.288 1.056 0 1.764.468.72.456 1.08 1.212.36.744.36 1.608v.6h-5.772v-1.02h4.728l-.516.504q0-.624-.18-1.068a1.43 1.43 0 0 0-.552-.684q-.36-.24-.912-.24t-.936.252a1.6 1.6 0 0 0-.588.732q-.192.468-.192 1.128 0 .612.192 1.092.192.468.588.744.396.264 1.008.264t.996-.24q.384-.252.492-.612h1.536q-.144.672-.552 1.176a2.7 2.7 0 0 1-1.044.78q-.624.276-1.428.276m4.525 2.172v-8.916h1.32v2.808l-.204-.012q.048-.996.408-1.668.372-.672.984-.996a2.8 2.8 0 0 1 1.368-.336q.696 0 1.248.252.564.252.96.708.408.456.624 1.068.216.6.216 1.296v.252q0 .708-.216 1.32-.204.6-.612 1.068a2.9 2.9 0 0 1-.96.72 3.1 3.1 0 0 1-1.26.252q-.732 0-1.344-.3a2.4 2.4 0 0 1-.972-.948q-.372-.648-.42-1.668l.528.804v4.296zm3.456-3.588q.54 0 .936-.264.408-.264.636-.732.228-.48.228-1.08 0-.624-.228-1.08a1.7 1.7 0 0 0-.636-.708 1.65 1.65 0 0 0-.936-.264q-.492 0-.912.216a1.76 1.76 0 0 0-.672.636q-.252.42-.252 1.008v.48q0 .564.264.96t.684.612.888.216m8.067 1.416q-.864 0-1.524-.276a3.3 3.3 0 0 1-1.116-.744 3.4 3.4 0 0 1-.696-1.08 3.5 3.5 0 0 1-.228-1.248v-.252q0-.672.24-1.272.252-.612.708-1.08.468-.48 1.128-.744.66-.276 1.488-.276t1.488.276q.66.264 1.116.744.468.468.708 1.08.24.6.24 1.272v.252q0 .648-.24 1.248-.228.6-.684 1.08-.456.468-1.116.744t-1.512.276m0-1.428q.612 0 1.032-.264.42-.276.636-.732.216-.468.216-1.056 0-.6-.228-1.056a1.65 1.65 0 0 0-.648-.732q-.42-.276-1.008-.276t-1.02.276q-.42.264-.648.732a2.3 2.3 0 0 0-.228 1.056q0 .588.216 1.056.228.456.648.732.42.264 1.032.264M246.931 119v-7.34h.76v2.31l-.18-.02q.05-.86.36-1.4.32-.55.83-.81t1.11-.26q.579 0 1.05.22.48.22.82.6t.52.88.18 1.06v.18q0 .56-.19 1.06a2.7 2.7 0 0 1-.54.88 2.48 2.48 0 0 1-1.86.82q-.57 0-1.09-.25a2.04 2.04 0 0 1-.86-.81q-.34-.56-.39-1.47l.44.8V119zm2.71-2.66q.54 0 .94-.25.4-.26.62-.71.22-.46.22-1.05 0-.6-.22-1.05a1.68 1.68 0 0 0-1.56-.96q-.48 0-.89.22-.411.21-.66.62-.24.4-.24.97v.46q0 .55.25.94.249.39.66.6.41.21.88.21m6.454.84q-.7 0-1.21-.24a2.35 2.35 0 0 1-.83-.63 2.8 2.8 0 0 1-.48-.89 3.4 3.4 0 0 1-.15-1v-.18q0-.52.15-1.01a2.7 2.7 0 0 1 .48-.88 2.24 2.24 0 0 1 .81-.63q.501-.24 1.17-.24.87 0 1.43.38.57.37.84.96.28.59.28 1.26v.43h-4.74v-.72h4.04l-.22.39q0-.57-.18-.98-.18-.42-.54-.65t-.91-.23q-.57 0-.95.26-.37.26-.56.71-.18.45-.18 1.04 0 .57.18 1.03.19.45.58.72.39.26.99.26.63 0 1.02-.28.4-.28.48-.65h.9q-.11.55-.44.95t-.83.61-1.13.21m3.853-.18v-5.34h.76v2.2h-.04q0-1.17.51-1.71.52-.55 1.55-.55h.18v.86h-.34q-.8 0-1.23.43-.43.42-.43 1.22V117zm8.667.18q-.69 0-1.2-.24a2.4 2.4 0 0 1-.83-.64 3 3 0 0 1-.5-.9 3.2 3.2 0 0 1-.16-.98v-.18q0-.51.16-1 .17-.49.5-.88.34-.4.84-.64.501-.24 1.17-.24.67 0 1.2.25.54.25.86.71.33.45.37 1.07h-.92q-.07-.5-.46-.83-.39-.34-1.05-.34-.57 0-.95.26t-.57.71-.19 1.02q0 .55.19 1.01.19.45.57.72.39.26.97.26.45 0 .78-.16t.53-.43.24-.61h.92q-.03.63-.37 1.09-.33.46-.88.72-.54.25-1.22.25m5.625-.02q-.95 0-1.46-.62t-.51-1.79v-3.1h.96v3.29q0 .63.34.99.34.35.92.35.6 0 .98-.38.38-.39.38-1.06v-3.19h.96V117h-.76v-2.29h.12q0 .79-.21 1.34-.21.54-.63.83-.411.28-1.05.28zm6.179 0q-1.05 0-1.63-.45-.57-.45-.59-1.23h.9q.02.31.31.59.3.27 1.01.27.64 0 .98-.25.34-.26.34-.63a.59.59 0 0 0-.25-.51q-.25-.19-.81-.25l-.58-.06q-.76-.08-1.24-.45-.48-.38-.48-1.06 0-.51.26-.87a1.6 1.6 0 0 1 .72-.56q.46-.2 1.06-.2.9 0 1.46.4t.58 1.19h-.9q-.01-.32-.3-.54-.28-.23-.84-.23t-.85.23a.71.71 0 0 0-.29.58q0 .3.2.48.21.18.68.23l.58.06q.86.09 1.38.48.52.38.52 1.08 0 .5-.29.89a1.9 1.9 0 0 1-.78.6q-.5.21-1.15.21m5.691-.1q-.6 0-1.04-.17a1.33 1.33 0 0 1-.67-.58q-.23-.42-.23-1.13v-5.14h.92v5.26q0 .43.23.67.24.23.67.23h.94v.86zm-2.86-4.68v-.72h3.68v.72zm7.459 4.8q-.7 0-1.23-.24a2.9 2.9 0 0 1-.9-.63 2.9 2.9 0 0 1-.55-.89 2.9 2.9 0 0 1-.18-1v-.18q0-.51.19-1a2.7 2.7 0 0 1 .56-.89q.37-.4.9-.63.53-.24 1.21-.24t1.21.24q.53.23.9.63.37.39.56.89.19.49.19 1v.18q0 .51-.19 1a2.6 2.6 0 0 1-.55.89q-.36.39-.89.63t-1.23.24m0-.86q.6 0 1.02-.26.43-.27.65-.72.23-.45.23-1.01 0-.57-.23-1.02a1.73 1.73 0 0 0-.66-.71q-.42-.26-1.01-.26-.58 0-1.01.26t-.66.71-.23 1.02q0 .56.22 1.01.23.45.65.72.43.26 1.03.26m4.298.68v-5.34h.76v2.29h-.12q0-.78.2-1.32.21-.55.62-.84t1.04-.29h.04q.63 0 1.04.29.42.29.62.84.2.54.2 1.32h-.28q0-.78.21-1.32.21-.55.62-.84.42-.29 1.05-.29h.04q.63 0 1.05.29t.62.84q.21.54.21 1.32V117h-.96v-3.26q0-.65-.32-1-.32-.36-.89-.36-.59 0-.95.38-.36.37-.36 1.04v3.2h-.96v-3.26q0-.65-.32-1-.32-.36-.89-.36-.59 0-.95.38-.36.37-.36 1.04v3.2zm11.948.18q-.7 0-1.21-.24t-.83-.63a2.8 2.8 0 0 1-.48-.89 3.4 3.4 0 0 1-.15-1v-.18q0-.52.15-1.01.159-.49.48-.88.32-.4.81-.63.5-.24 1.17-.24.87 0 1.43.38.57.37.84.96.28.59.28 1.26v.43h-4.74v-.72h4.04l-.22.39q0-.57-.18-.98-.18-.42-.54-.65t-.91-.23q-.57 0-.95.26-.37.26-.56.71-.18.45-.18 1.04 0 .57.18 1.03.19.45.58.72.39.26.99.26.63 0 1.02-.28.399-.28.48-.65h.9q-.11.55-.44.95t-.83.61-1.13.21m3.853-.18v-5.34h.76v2.2h-.04q0-1.17.51-1.71.52-.55 1.55-.55h.18v.86h-.34q-.801 0-1.23.43-.43.42-.43 1.22V117z",
					fill: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsxs)("g", {
					opacity: .6,
					children: [/* @__PURE__ */ (0, J.jsx)("path", {
						d: "M428 38a4 4 0 0 1 4-4h72a4 4 0 0 1 4 4v2h-80z",
						fill: "#0158CB"
					}), /* @__PURE__ */ (0, J.jsx)("path", {
						d: "M428 38a4 4 0 0 1 4-4h72a4 4 0 0 1 4 4v2h-80z",
						stroke: "#fff"
					})]
				}),
				/* @__PURE__ */ (0, J.jsxs)("g", {
					opacity: .8,
					children: [/* @__PURE__ */ (0, J.jsx)("path", {
						d: "M420 46a6 6 0 0 1 6-6h84a6 6 0 0 1 6 6z",
						fill: "#0158CB"
					}), /* @__PURE__ */ (0, J.jsx)("path", {
						d: "M420 46a6 6 0 0 1 6-6h84a6 6 0 0 1 6 6z",
						stroke: "#fff"
					})]
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 416,
					y: 46,
					width: 104,
					height: 84,
					rx: 8,
					fill: "#0151C9",
					fillOpacity: .7
				}),
				/* @__PURE__ */ (0, J.jsx)("rect", {
					x: 416,
					y: 46,
					width: 104,
					height: 84,
					rx: 8,
					stroke: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M468 62h6m-6 12h6m-4 9h6m-6 0a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1m4 0a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1m-6 0h6m2-17v4m0 8v4m-10-24h20v8h-20zm6 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-6 8h20v8h-20zm6 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
					stroke: "#fff",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "m449.331 104 2.988-8.76h2.784l3.072 8.76h-1.752l-2.604-7.596.612.264h-1.5l.624-.264-2.52 7.596zm2.088-2.328.54-1.44h3.552l.528 1.44zm10.376 4.896a13 13 0 0 1-1.86-.132v-1.392q.432.048.924.084.492.048.924.048.804 0 1.296-.192.504-.192.732-.612.24-.408.24-1.044v-1.284l.36-.816q-.036.9-.372 1.536a2.4 2.4 0 0 1-.912.96q-.576.324-1.332.324-.672 0-1.224-.252-.54-.252-.936-.696a3.3 3.3 0 0 1-.6-1.044 3.8 3.8 0 0 1-.216-1.284v-.252q0-.684.216-1.272.228-.6.636-1.044t.972-.684 1.248-.24q.804 0 1.392.348.6.348.936 1.008t.372 1.62l-.288.048v-2.82h1.32v5.748q0 1.188-.408 1.92t-1.26 1.068q-.84.348-2.16.348m.48-3.948a1.8 1.8 0 0 0 .876-.216q.396-.216.636-.624t.24-.984v-.42q0-.552-.252-.936a1.5 1.5 0 0 0-.636-.576 1.86 1.86 0 0 0-.864-.204q-.528 0-.936.252a1.67 1.67 0 0 0-.624.684q-.228.444-.228 1.056 0 .6.228 1.044t.624.684q.408.24.936.24m8.083 1.608q-.84 0-1.476-.288a3.1 3.1 0 0 1-1.044-.768 3.6 3.6 0 0 1-.624-1.092 3.8 3.8 0 0 1-.204-1.224v-.228q0-.648.204-1.248.216-.612.624-1.08.42-.48 1.032-.756.612-.288 1.416-.288 1.056 0 1.764.468.72.456 1.08 1.212.36.744.36 1.608v.6h-5.772v-1.02h4.728l-.516.504q0-.624-.18-1.068a1.43 1.43 0 0 0-.552-.684q-.36-.24-.912-.24t-.936.252a1.6 1.6 0 0 0-.588.732q-.192.468-.192 1.128 0 .612.192 1.092.192.468.588.744.396.264 1.008.264t.996-.24q.384-.252.492-.612h1.536q-.144.672-.552 1.176a2.7 2.7 0 0 1-1.044.78q-.624.276-1.428.276m4.526-.228v-6.516h1.32v2.796h-.12q0-.996.264-1.656.264-.672.78-1.008.528-.336 1.308-.336h.072q1.164 0 1.764.756.6.744.6 2.232V104h-1.668v-3.876q0-.6-.348-.972-.336-.372-.936-.372-.612 0-.996.384-.372.372-.372 1.008V104zm10.613.084q-.9 0-1.488-.228a1.67 1.67 0 0 1-.864-.792q-.288-.564-.288-1.512l.012-5.904h1.56l-.012 6.012q0 .48.252.744.264.252.744.252h1.02v1.428zm-3.672-5.376v-1.224h4.608v1.224zm-51.348 19.472q-1 0-1.71-.35a3.2 3.2 0 0 1-1.13-.91 3.8 3.8 0 0 1-.63-1.21q-.2-.66-.2-1.27v-.22q0-.66.2-1.32.21-.66.64-1.2t1.12-.87 1.65-.33q.98 0 1.68.34t1.11.95.5 1.44h-1q-.08-.62-.4-1.02a1.93 1.93 0 0 0-.81-.61 2.8 2.8 0 0 0-1.08-.2q-.65 0-1.14.23a2.2 2.2 0 0 0-.82.63 2.9 2.9 0 0 0-.49.93q-.16.53-.16 1.15 0 .59.16 1.12.17.53.5.94.34.41.84.65.5.23 1.17.23.94 0 1.58-.47t.78-1.36h1a3.2 3.2 0 0 1-.51 1.37q-.4.62-1.12.99-.71.37-1.73.37m6.489-.02q-.95 0-1.46-.62t-.51-1.79v-3.1h.96v3.29q0 .63.34.99.34.35.92.35.6 0 .98-.38.38-.39.38-1.06v-3.19h.96V118h-.76v-2.29h.12q0 .79-.21 1.34-.21.54-.63.83-.41.28-1.05.28zm6.18 0q-1.05 0-1.63-.45-.57-.45-.59-1.23h.9q.02.31.31.59.3.27 1.01.27.64 0 .98-.25.34-.26.34-.63 0-.33-.25-.51-.25-.19-.81-.25l-.58-.06q-.76-.08-1.24-.45-.48-.38-.48-1.06 0-.51.26-.87a1.6 1.6 0 0 1 .72-.56q.46-.2 1.06-.2.9 0 1.46.4t.58 1.19h-.9q-.01-.32-.3-.54-.28-.23-.84-.23t-.85.23a.71.71 0 0 0-.29.58q0 .3.2.48.21.18.68.23l.58.06q.86.09 1.38.48.52.38.52 1.08 0 .5-.29.89a1.9 1.9 0 0 1-.78.6q-.5.21-1.15.21m5.691-.1q-.6 0-1.04-.17a1.32 1.32 0 0 1-.67-.58q-.23-.42-.23-1.13v-5.14h.92v5.26q0 .43.23.67.24.23.67.23h.94v.86zm-2.86-4.68v-.72h3.68v.72zm7.459 4.8q-.7 0-1.23-.24a2.8 2.8 0 0 1-.9-.63 2.9 2.9 0 0 1-.55-.89 2.9 2.9 0 0 1-.18-1v-.18q0-.51.19-1 .19-.5.56-.89.369-.4.9-.63a2.9 2.9 0 0 1 1.21-.24q.68 0 1.21.24.53.23.9.63.37.39.56.89.19.49.19 1v.18q0 .51-.19 1-.18.49-.55.89-.36.39-.89.63-.531.24-1.23.24m0-.86q.6 0 1.02-.26.43-.27.65-.72.23-.45.23-1.01 0-.57-.23-1.02a1.75 1.75 0 0 0-.66-.71q-.42-.26-1.01-.26-.58 0-1.01.26t-.66.71a2.2 2.2 0 0 0-.23 1.02q0 .56.22 1.01.23.45.65.72.43.26 1.03.26m4.297.68v-5.34h.76v2.29h-.12q0-.78.2-1.32.21-.55.62-.84t1.04-.29h.04q.63 0 1.04.29.42.29.62.84.2.54.2 1.32h-.28q0-.78.21-1.32.21-.55.62-.84.42-.29 1.05-.29h.04q.63 0 1.05.29t.62.84q.21.54.21 1.32V118h-.96v-3.26q0-.65-.32-1-.32-.36-.89-.36-.59 0-.95.38-.36.37-.36 1.04v3.2h-.96v-3.26q0-.65-.32-1-.32-.36-.89-.36-.59 0-.95.38-.36.37-.36 1.04v3.2zm11.948.18q-.7 0-1.21-.24a2.35 2.35 0 0 1-.83-.63 2.8 2.8 0 0 1-.48-.89 3.4 3.4 0 0 1-.15-1v-.18q0-.52.15-1.01a2.7 2.7 0 0 1 .48-.88 2.24 2.24 0 0 1 .81-.63q.501-.24 1.17-.24.87 0 1.43.38.57.37.84.96.28.59.28 1.26v.43h-4.74v-.72h4.04l-.22.39q0-.57-.18-.98-.18-.42-.54-.65t-.91-.23q-.57 0-.95.26-.37.26-.56.71-.18.45-.18 1.04 0 .57.18 1.03.19.45.58.72.39.26.99.26.63 0 1.02-.28.4-.28.48-.65h.9q-.11.55-.44.95t-.83.61-1.13.21m3.853-.18v-5.34h.76v2.2h-.04q0-1.17.51-1.71.52-.55 1.55-.55h.18v.86h-.34q-.8 0-1.23.43-.43.42-.43 1.22V118zm5.852.16q-1.05 0-1.63-.45-.57-.45-.59-1.23h.9q.02.31.31.59.3.27 1.01.27.64 0 .98-.25.34-.26.34-.63 0-.33-.25-.51-.25-.19-.81-.25l-.58-.06q-.76-.08-1.24-.45-.48-.38-.48-1.06 0-.51.26-.87a1.6 1.6 0 0 1 .72-.56q.46-.2 1.06-.2.9 0 1.46.4t.58 1.19h-.9q-.01-.32-.3-.54-.28-.23-.84-.23t-.85.23a.71.71 0 0 0-.29.58q0 .3.2.48.21.18.68.23l.58.06q.86.09 1.38.48.52.38.52 1.08 0 .5-.29.89a1.9 1.9 0 0 1-.78.6q-.5.21-1.15.21m3.054-4.42v-.52h.09q.32 0 .51-.11a.6.6 0 0 0 .27-.34q.09-.24.09-.6v-.75l.24.45a.6.6 0 0 1-.19.06q-.11.02-.22.02a.68.68 0 0 1-.47-.17q-.18-.18-.18-.49 0-.29.17-.48.18-.19.48-.19.19 0 .36.09t.28.32.11.66v.21q0 .73-.18 1.13t-.51.56q-.33.15-.78.15zm5.417 4.26v-5.34h.96V118zm-.82-4.58v-.76h1.78v.76zm1.09-1.62q-.321 0-.48-.17a.63.63 0 0 1-.15-.43q0-.26.15-.43.159-.17.48-.17t.47.17q.16.17.16.43a.6.6 0 0 1-.16.43q-.15.17-.47.17m2.546 6.2v-5.34h.76v2.29h-.12q0-.79.21-1.33.22-.55.66-.83.44-.29 1.11-.29h.04q1.01 0 1.49.63.49.63.49 1.82V118h-.96v-3.25q0-.62-.35-.99-.35-.38-.96-.38-.63 0-1.02.39t-.39 1.04V118zm6.536 0v-5.61q0-.89.47-1.31.471-.42 1.38-.42h.66v.8h-.82q-.369 0-.57.21-.2.2-.2.56V118zm-.74-4.56v-.72h3.35v.72zm4.37 4.56v-5.34h.76v2.2h-.04q0-1.17.51-1.71.52-.55 1.55-.55h.18v.86h-.34q-.8 0-1.23.43-.43.42-.43 1.22V118zm7.312 0v-1.6h-.16v-1.85q0-.55-.29-.83-.28-.28-.83-.28-.31 0-.64.01l-.63.02q-.3.01-.52.03v-.84q.22-.02.46-.03.25-.02.51-.02.26-.01.5-.01.82 0 1.34.2.52.19.77.63t.25 1.19V118zm-1.75.14a2.5 2.5 0 0 1-1.04-.2q-.43-.21-.67-.6-.23-.39-.23-.94 0-.57.25-.95.26-.38.75-.57.49-.2 1.18-.2h1.45v.72h-1.49q-.58 0-.89.28a.93.93 0 0 0-.31.72q0 .44.31.71t.89.27q.34 0 .65-.12.31-.13.51-.42.21-.3.23-.82l.26.38q-.05.57-.28.96a1.45 1.45 0 0 1-.62.58q-.39.2-.95.2",
					fill: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					className: "svg__connector",
					d: "M144 88h92m88 0h92",
					stroke: "#fff",
					strokeWidth: 1.5,
					strokeDasharray: "3 5"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					className: "svg__connector",
					d: "M472 130v34c0 8.837-7.163 16-16 16H104c-8.837 0-16-7.163-16-16v-34",
					stroke: "#fff",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeDasharray: "3 5"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "M170.517 57.492v-1.704h1.572q.456 0 .78-.18.336-.18.516-.504a1.6 1.6 0 0 0 .18-.768q0-.456-.18-.78a1.16 1.16 0 0 0-.516-.504 1.6 1.6 0 0 0-.78-.18h-1.572v-1.704h1.476q1.116 0 1.908.372.804.372 1.224 1.056.432.684.432 1.644v.192q0 .936-.432 1.632-.42.684-1.224 1.056-.792.372-1.908.372zM168.789 60v-8.832h1.968V60zm10.116.204q-1.14 0-1.752-.732-.612-.744-.612-2.232v-3.816h1.92v3.912q0 .528.3.84t.804.312q.516 0 .84-.324t.324-.876v-3.864h1.92V60h-1.524v-2.772h.132q0 .996-.264 1.668-.252.66-.756.984t-1.248.324zm8.01 0q-1.404 0-2.196-.576t-.84-1.62h1.704q.048.312.372.564.336.24.996.24.504 0 .828-.168.336-.18.336-.504a.52.52 0 0 0-.252-.456q-.252-.18-.9-.252l-.516-.048q-1.188-.12-1.788-.66-.588-.54-.588-1.38 0-.696.348-1.164t.96-.708q.624-.24 1.416-.24 1.272 0 2.052.564.78.552.816 1.608h-1.704a.8.8 0 0 0-.336-.54q-.288-.228-.852-.228-.444 0-.708.168a.52.52 0 0 0-.264.456q0 .276.228.42t.744.204l.516.048q1.212.132 1.884.672t.672 1.452q0 .66-.36 1.152-.36.48-1.02.744-.66.252-1.548.252m4.172-.204v-8.76h1.92v5.052h-.288q0-.996.252-1.68t.744-1.032q.492-.36 1.236-.36h.084q1.092 0 1.668.78.576.768.576 2.256V60h-1.92v-3.864q0-.54-.324-.864-.312-.336-.828-.336-.54 0-.876.348-.324.348-.324.924V60zm10.84.228q-.84 0-1.488-.288a3.2 3.2 0 0 1-1.068-.768 3.7 3.7 0 0 1-.648-1.092 3.7 3.7 0 0 1-.216-1.248v-.24q0-.66.216-1.26.228-.612.648-1.092a2.95 2.95 0 0 1 1.044-.756 3.45 3.45 0 0 1 1.44-.288q1.056 0 1.776.48.732.468 1.116 1.236.384.756.384 1.656v.648h-5.82v-1.092h4.656l-.624.504q0-.588-.168-1.008a1.3 1.3 0 0 0-.504-.636q-.324-.228-.816-.228-.504 0-.852.228a1.4 1.4 0 0 0-.528.672q-.18.432-.18 1.068 0 .588.168 1.032.168.432.528.672t.936.24q.528 0 .864-.204t.456-.504h1.764q-.144.66-.564 1.176a2.86 2.86 0 0 1-1.056.804q-.636.288-1.464.288m6.972-.024q-1.404 0-2.196-.576t-.84-1.62h1.704q.048.312.372.564.336.24.996.24.504 0 .828-.168.336-.18.336-.504a.52.52 0 0 0-.252-.456q-.252-.18-.9-.252l-.516-.048q-1.188-.12-1.788-.66-.588-.54-.588-1.38 0-.696.348-1.164t.96-.708q.624-.24 1.416-.24 1.272 0 2.052.564.78.552.816 1.608h-1.704a.8.8 0 0 0-.336-.54q-.288-.228-.852-.228-.444 0-.708.168a.52.52 0 0 0-.264.456q0 .276.228.42t.744.204l.516.048q1.212.132 1.884.672t.672 1.452q0 .66-.36 1.152-.36.48-1.02.744-.66.252-1.548.252M168.657 76v-1.944h-.324v-2.112q0-.504-.24-.756t-.768-.252q-.264 0-.696.012t-.888.036-.828.048v-1.62a30 30 0 0 1 1.416-.084q.396-.012.744-.012 1.008 0 1.692.288.696.288 1.056.876.36.576.36 1.488V76zm-2.1.168q-.708 0-1.248-.252a1.96 1.96 0 0 1-.828-.72q-.3-.48-.3-1.14 0-.72.372-1.176.372-.468 1.044-.684.672-.228 1.548-.228h1.404v1.068h-1.416q-.504 0-.78.252-.264.24-.264.66 0 .396.264.648.276.24.78.24.324 0 .576-.108a1 1 0 0 0 .432-.396q.168-.276.192-.768l.456.48q-.06.684-.336 1.152a1.8 1.8 0 0 1-.744.72q-.468.252-1.152.252M171.81 76v-6.576h1.524v2.82h-.036q0-1.392.588-2.148.6-.756 1.728-.756h.252v1.656h-.48q-.792 0-1.224.432-.432.42-.432 1.224V76zm8.191.084q-.996 0-1.608-.24a1.7 1.7 0 0 1-.9-.828q-.276-.588-.276-1.584v-5.784h1.788v5.856q0 .468.24.72.252.24.708.24h.972v1.62zm-3.78-5.256v-1.404h4.704v1.404zM182.528 76v-6.576h1.92V76zm-.876-5.16v-1.416h2.796v1.416zm1.62-2.064q-.54 0-.804-.276a1.05 1.05 0 0 1-.252-.72q0-.444.252-.72.264-.288.804-.288t.792.288q.264.276.264.72 0 .432-.264.72-.252.276-.792.276M186.368 76v-6.636q0-1.14.648-1.692t1.908-.552h.84v1.44h-.924q-.324 0-.504.18t-.18.504V76zm-.78-5.04v-1.404h4.272v1.404zm9.166 5.04v-1.944h-.324v-2.112q0-.504-.24-.756t-.768-.252q-.264 0-.696.012t-.888.036-.828.048v-1.62a30 30 0 0 1 1.416-.084q.396-.012.744-.012 1.008 0 1.692.288.696.288 1.056.876.36.576.36 1.488V76zm-2.1.168q-.708 0-1.248-.252a1.96 1.96 0 0 1-.828-.72q-.3-.48-.3-1.14 0-.72.372-1.176.372-.468 1.044-.684.672-.228 1.548-.228h1.404v1.068h-1.416q-.504 0-.78.252-.264.24-.264.66 0 .396.264.648.276.24.78.24.324 0 .576-.108a1 1 0 0 0 .432-.396q.168-.276.192-.768l.456.48q-.06.684-.336 1.152a1.8 1.8 0 0 1-.744.72q-.468.252-1.152.252m8.205.06q-.852 0-1.488-.276a3.1 3.1 0 0 1-1.044-.768 3.2 3.2 0 0 1-.624-1.08 4 4 0 0 1-.204-1.26v-.228q0-.672.216-1.284.216-.624.636-1.104a2.95 2.95 0 0 1 1.044-.756q.636-.276 1.452-.276.888 0 1.572.348.684.336 1.092.948t.456 1.404h-1.884a1.18 1.18 0 0 0-.36-.744q-.3-.312-.876-.312-.48 0-.804.24-.312.24-.468.66t-.156.996q0 .528.144.96.144.42.456.66.324.228.84.228.384 0 .648-.132.276-.144.432-.384.168-.252.204-.576h1.872a2.74 2.74 0 0 1-.456 1.44q-.42.612-1.116.96-.696.336-1.584.336m7.372-.144q-.996 0-1.608-.24a1.7 1.7 0 0 1-.9-.828q-.276-.588-.276-1.584v-5.784h1.788v5.856q0 .468.24.72.252.24.708.24h.972v1.62zm-3.78-5.256v-1.404h4.704v1.404zm8.444 5.376q-1.404 0-2.196-.576t-.84-1.62h1.704q.048.312.372.564.336.24.996.24.504 0 .828-.168.336-.18.336-.504a.52.52 0 0 0-.252-.456q-.252-.18-.9-.252l-.516-.048q-1.188-.12-1.788-.66-.588-.54-.588-1.38 0-.696.348-1.164t.96-.708q.624-.24 1.416-.24 1.272 0 2.052.564.78.552.816 1.608h-1.704a.8.8 0 0 0-.336-.54q-.288-.228-.852-.228-.444 0-.708.168a.52.52 0 0 0-.264.456q0 .276.228.42t.744.204l.516.048q1.212.132 1.884.672t.672 1.452q0 .66-.36 1.152-.36.48-1.02.744-.66.252-1.548.252m-7.855 121.288v-1.704h1.572q.456 0 .78-.18.336-.18.516-.504a1.6 1.6 0 0 0 .18-.768q0-.456-.18-.78a1.16 1.16 0 0 0-.516-.504 1.6 1.6 0 0 0-.78-.18h-1.572v-1.704h1.476q1.116 0 1.908.372.804.372 1.224 1.056.432.684.432 1.644v.192q0 .936-.432 1.632-.42.684-1.224 1.056-.792.372-1.908.372zM203.312 200v-8.832h1.968V200zm10.826.228q-.84 0-1.488-.288a3.2 3.2 0 0 1-1.068-.768 3.7 3.7 0 0 1-.648-1.092 3.7 3.7 0 0 1-.216-1.248v-.24q0-.66.216-1.26.228-.612.648-1.092a2.95 2.95 0 0 1 1.044-.756 3.45 3.45 0 0 1 1.44-.288q1.056 0 1.776.48.732.468 1.116 1.236.384.756.384 1.656v.648h-5.82v-1.092h4.656l-.624.504q0-.588-.168-1.008a1.3 1.3 0 0 0-.504-.636q-.324-.228-.816-.228-.504 0-.852.228a1.4 1.4 0 0 0-.528.672q-.18.432-.18 1.068 0 .588.168 1.032.168.432.528.672t.936.24q.528 0 .864-.204t.456-.504h1.764q-.144.66-.564 1.176a2.86 2.86 0 0 1-1.056.804q-.636.288-1.464.288m4.476-.228v-6.576h1.524v2.82h-.036q0-1.392.588-2.148.6-.756 1.728-.756h.252v1.656h-.48q-.792 0-1.224.432-.432.42-.432 1.224V200zm5.363 0v-6.576h1.92V200zm-.876-5.16v-1.416h2.796v1.416zm1.62-2.064q-.54 0-.804-.276a1.05 1.05 0 0 1-.252-.72q0-.444.252-.72.264-.288.804-.288t.792.288q.264.276.264.72 0 .432-.264.72-.252.276-.792.276m6.156 7.452q-.864 0-1.536-.264a3.4 3.4 0 0 1-1.14-.744 3.2 3.2 0 0 1-.696-1.068 3.5 3.5 0 0 1-.24-1.284v-.276q0-.684.24-1.296.252-.624.72-1.092.48-.468 1.152-.732a3.9 3.9 0 0 1 1.5-.276q.852 0 1.512.276.672.264 1.14.732t.72 1.092q.252.612.252 1.296v.276q0 .672-.24 1.284-.24.6-.708 1.068-.456.468-1.128.744-.672.264-1.548.264m0-1.62q.564 0 .936-.24t.564-.672a2.2 2.2 0 0 0 .204-.96q0-.564-.204-.984a1.63 1.63 0 0 0-.588-.684q-.372-.252-.912-.252-.528 0-.912.252a1.63 1.63 0 0 0-.588.684q-.192.42-.192.984 0 .528.192.96t.576.672.924.24m7.676 1.608a3.1 3.1 0 0 1-1.272-.252 3.1 3.1 0 0 1-.984-.696 3.2 3.2 0 0 1-.648-1.068 4 4 0 0 1-.216-1.32v-.276q0-.708.204-1.32a3.3 3.3 0 0 1 .612-1.068 2.8 2.8 0 0 1 .972-.72 2.9 2.9 0 0 1 1.26-.264q.792 0 1.368.348.576.336.9 1.008.324.66.36 1.632l-.504-.468v-4.512h1.932V200h-1.524v-2.724h.264q-.036.936-.396 1.596-.348.66-.948 1.008-.6.336-1.38.336m.48-1.608q.444 0 .804-.192.372-.204.588-.588.228-.384.228-.924v-.444q0-.528-.228-.888a1.53 1.53 0 0 0-.6-.552 1.7 1.7 0 0 0-.804-.192q-.48 0-.864.252-.372.24-.588.672-.216.42-.216.984 0 .576.216.996t.6.648.864.228M244.59 200v-6.576h1.92V200zm-.876-5.16v-1.416h2.796v1.416zm1.62-2.064q-.54 0-.804-.276a1.05 1.05 0 0 1-.252-.72q0-.444.252-.72.264-.288.804-.288t.792.288q.264.276.264.72 0 .432-.264.72-.252.276-.792.276m5.904 7.452q-.852 0-1.488-.276a3.1 3.1 0 0 1-1.044-.768 3.2 3.2 0 0 1-.624-1.08 4 4 0 0 1-.204-1.26v-.228q0-.672.216-1.284.216-.624.636-1.104a2.95 2.95 0 0 1 1.044-.756q.636-.276 1.452-.276.888 0 1.572.348.684.336 1.092.948t.456 1.404h-1.884a1.18 1.18 0 0 0-.36-.744q-.3-.312-.876-.312-.48 0-.804.24-.312.24-.468.66t-.156.996q0 .528.144.96.144.42.456.66.324.228.84.228.384 0 .648-.132.276-.144.432-.384.168-.252.204-.576h1.872a2.74 2.74 0 0 1-.456 1.44q-.42.612-1.116.96-.696.336-1.584.336m8.356-.228v-1.944h-.324v-2.112q0-.504-.24-.756t-.768-.252q-.264 0-.696.012t-.888.036-.828.048v-1.62a30 30 0 0 1 1.416-.084q.396-.012.744-.012 1.008 0 1.692.288.696.288 1.056.876.36.576.36 1.488V200zm-2.1.168q-.708 0-1.248-.252a1.96 1.96 0 0 1-.828-.72q-.3-.48-.3-1.14 0-.72.372-1.176.372-.468 1.044-.684.672-.228 1.548-.228h1.404v1.068h-1.416q-.504 0-.78.252-.264.24-.264.66 0 .396.264.648.276.24.78.24.324 0 .576-.108a1 1 0 0 0 .432-.396q.168-.276.192-.768l.456.48q-.06.684-.336 1.152a1.8 1.8 0 0 1-.744.72q-.468.252-1.152.252m5.337-.168v-8.76h1.932V200zm-.78-7.344v-1.416h2.712v1.416zm4.565 7.344v-8.76h1.932V200zm-.78-7.344v-1.416h2.712v1.416zm4.409 9.948v-1.632h1.368q.312 0 .528-.084a.7.7 0 0 0 .348-.252q.132-.18.216-.492l1.62-6.72h1.824l-1.836 7.104q-.192.768-.54 1.224a1.8 1.8 0 0 1-.912.648q-.564.204-1.44.204zm2.064-2.748v-1.5h1.392v1.5zm-.792 0-2.016-6.432h1.932l1.908 6.432zm10.66.348q-1.404 0-2.196-.576t-.84-1.62h1.704q.048.312.372.564.336.24.996.24.504 0 .828-.168.336-.18.336-.504a.52.52 0 0 0-.252-.456q-.252-.18-.9-.252l-.516-.048q-1.188-.12-1.788-.66-.588-.54-.588-1.38 0-.696.348-1.164t.96-.708q.624-.24 1.416-.24 1.272 0 2.052.564.78.552.816 1.608h-1.704a.8.8 0 0 0-.336-.54q-.288-.228-.852-.228-.444 0-.708.168a.52.52 0 0 0-.264.456q0 .276.228.42t.744.204l.516.048q1.212.132 1.884.672t.672 1.452q0 .66-.36 1.152-.36.48-1.02.744-.66.252-1.548.252m7.184.024q-.84 0-1.488-.288a3.2 3.2 0 0 1-1.068-.768 3.7 3.7 0 0 1-.648-1.092 3.7 3.7 0 0 1-.216-1.248v-.24q0-.66.216-1.26.228-.612.648-1.092a2.95 2.95 0 0 1 1.044-.756 3.45 3.45 0 0 1 1.44-.288q1.056 0 1.776.48.732.468 1.116 1.236.384.756.384 1.656v.648h-5.82v-1.092h4.656l-.624.504q0-.588-.168-1.008a1.3 1.3 0 0 0-.504-.636q-.324-.228-.816-.228-.504 0-.852.228a1.4 1.4 0 0 0-.528.672q-.18.432-.18 1.068 0 .588.168 1.032.168.432.528.672t.936.24q.528 0 .864-.204t.456-.504h1.764q-.144.66-.564 1.176a2.86 2.86 0 0 1-1.056.804q-.636.288-1.464.288m4.476-.228v-6.576h1.524v2.82h-.108q0-1.008.252-1.68.264-.672.792-1.008t1.284-.336h.084q1.152 0 1.752.756.612.744.612 2.268V200h-1.92v-3.864q0-.528-.312-.864t-.84-.336q-.54 0-.876.348-.324.336-.324.888V200zm10.54.216a3.1 3.1 0 0 1-1.272-.252 3.1 3.1 0 0 1-.984-.696 3.2 3.2 0 0 1-.648-1.068 4 4 0 0 1-.216-1.32v-.276q0-.708.204-1.32a3.3 3.3 0 0 1 .612-1.068 2.8 2.8 0 0 1 .972-.72 2.9 2.9 0 0 1 1.26-.264q.792 0 1.368.348.576.336.9 1.008.324.66.36 1.632l-.504-.468v-4.512h1.932V200h-1.524v-2.724h.264q-.036.936-.396 1.596-.348.66-.948 1.008-.6.336-1.38.336m.48-1.608q.444 0 .804-.192.372-.204.588-.588.228-.384.228-.924v-.444q0-.528-.228-.888a1.53 1.53 0 0 0-.6-.552 1.7 1.7 0 0 0-.804-.192q-.48 0-.864.252-.372.24-.588.672-.216.42-.216.984 0 .576.216.996t.6.648.864.228m7.742 1.596q-1.404 0-2.196-.576t-.84-1.62h1.704q.048.312.372.564.336.24.996.24.504 0 .828-.168.336-.18.336-.504a.52.52 0 0 0-.252-.456q-.252-.18-.9-.252l-.516-.048q-1.188-.12-1.788-.66-.588-.54-.588-1.38 0-.696.348-1.164t.96-.708q.624-.24 1.416-.24 1.272 0 2.052.564.78.552.816 1.608h-1.704a.8.8 0 0 0-.336-.54q-.288-.228-.852-.228-.444 0-.708.168a.52.52 0 0 0-.264.456q0 .276.228.42t.744.204l.516.048q1.212.132 1.884.672t.672 1.452q0 .66-.36 1.152-.36.48-1.02.744-.66.252-1.548.252m6.691-.204v-8.76h1.92v5.052h-.288q0-.996.252-1.68t.744-1.032q.492-.36 1.236-.36h.084q1.092 0 1.668.78.576.768.576 2.256V200h-1.92v-3.864q0-.54-.324-.864-.312-.336-.828-.336-.54 0-.876.348-.324.348-.324.924V200zm10.84.228q-.84 0-1.488-.288a3.2 3.2 0 0 1-1.068-.768 3.7 3.7 0 0 1-.648-1.092 3.7 3.7 0 0 1-.216-1.248v-.24q0-.66.216-1.26.228-.612.648-1.092a2.95 2.95 0 0 1 1.044-.756 3.45 3.45 0 0 1 1.44-.288q1.056 0 1.776.48.732.468 1.116 1.236.384.756.384 1.656v.648h-5.82v-1.092h4.656l-.624.504q0-.588-.168-1.008a1.3 1.3 0 0 0-.504-.636q-.324-.228-.816-.228-.504 0-.852.228a1.4 1.4 0 0 0-.528.672q-.18.432-.18 1.068 0 .588.168 1.032.168.432.528.672t.936.24q.528 0 .864-.204t.456-.504h1.764q-.144.66-.564 1.176a2.86 2.86 0 0 1-1.056.804q-.636.288-1.464.288m8.448-.228v-1.944h-.324v-2.112q0-.504-.24-.756t-.768-.252q-.264 0-.696.012t-.888.036-.828.048v-1.62a30 30 0 0 1 1.416-.084q.396-.012.744-.012 1.008 0 1.692.288.696.288 1.056.876.36.576.36 1.488V200zm-2.1.168q-.708 0-1.248-.252a1.96 1.96 0 0 1-.828-.72q-.3-.48-.3-1.14 0-.72.372-1.176.372-.468 1.044-.684.672-.228 1.548-.228h1.404v1.068h-1.416q-.504 0-.78.252-.264.24-.264.66 0 .396.264.648.276.24.78.24.324 0 .576-.108a1 1 0 0 0 .432-.396q.168-.276.192-.768l.456.48q-.06.684-.336 1.152a1.8 1.8 0 0 1-.744.72q-.468.252-1.152.252m5.337-.168v-8.76h1.932V200zm-.78-7.344v-1.416h2.712v1.416zm7.47 7.428q-.996 0-1.608-.24a1.7 1.7 0 0 1-.9-.828q-.276-.588-.276-1.584v-5.784h1.788v5.856q0 .468.24.72.252.24.708.24h.972v1.62zm-3.78-5.256v-1.404h4.704v1.404zM350.72 200v-8.76h1.92v5.052h-.288q0-.996.252-1.68t.744-1.032q.492-.36 1.236-.36h.084q1.092 0 1.668.78.576.768.576 2.256V200h-1.92v-3.864q0-.54-.324-.864-.312-.336-.828-.336-.54 0-.876.348-.324.348-.324.924V200zm-138.182 16-3.348-3.612q-.552-.6-.876-1.044a3.5 3.5 0 0 1-.468-.876 2.8 2.8 0 0 1-.144-.912q0-.744.324-1.284t.996-.84q.684-.312 1.764-.312.444 0 .9.048.468.036.816.096v1.584a13 13 0 0 0-.588-.072q-.348-.036-.696-.048a8 8 0 0 0-.552-.024q-.708 0-.948.252t-.24.696q0 .408.192.792.204.372.66.864l4.332 4.692zm-2.868.252q-.972 0-1.704-.372-.72-.384-1.128-1.032a2.73 2.73 0 0 1-.408-1.464v-.168q0-.876.492-1.56t1.272-1.032l.78 1.008q-.324.216-.552.624a1.9 1.9 0 0 0-.216.936q0 .42.168.768.18.336.528.528.348.18.876.18.696 0 1.272-.372.588-.372.936-1.176.36-.804.36-2.1h1.68q0 1.272-.348 2.244-.336.972-.948 1.644-.6.66-1.392 1.008a4.2 4.2 0 0 1-1.668.336m1.548-4.98v-1.404h3.408v1.404zm7.109 4.728v-6.576h1.524v2.82h-.036q0-1.392.588-2.148.6-.756 1.728-.756h.252v1.656h-.48q-.792 0-1.224.432-.432.42-.432 1.224V216zm8.028.228q-.84 0-1.488-.288a3.2 3.2 0 0 1-1.068-.768 3.7 3.7 0 0 1-.648-1.092 3.7 3.7 0 0 1-.216-1.248v-.24q0-.66.216-1.26.228-.612.648-1.092a2.95 2.95 0 0 1 1.044-.756 3.45 3.45 0 0 1 1.44-.288q1.056 0 1.776.48.732.468 1.116 1.236.384.756.384 1.656v.648h-5.82v-1.092h4.656l-.624.504q0-.588-.168-1.008a1.3 1.3 0 0 0-.504-.636q-.324-.228-.816-.228-.504 0-.852.228a1.4 1.4 0 0 0-.528.672q-.18.432-.18 1.068 0 .588.168 1.032.168.432.528.672t.936.24q.528 0 .864-.204t.456-.504h1.764q-.144.66-.564 1.176a2.86 2.86 0 0 1-1.056.804q-.636.288-1.464.288m4.56-.228v-8.76h1.932V216zm-.78-7.344v-1.416h2.712v1.416zm7.493 7.572q-.84 0-1.488-.288a3.2 3.2 0 0 1-1.068-.768 3.7 3.7 0 0 1-.648-1.092 3.7 3.7 0 0 1-.216-1.248v-.24q0-.66.216-1.26.228-.612.648-1.092a2.95 2.95 0 0 1 1.044-.756 3.45 3.45 0 0 1 1.44-.288q1.056 0 1.776.48.732.468 1.116 1.236.384.756.384 1.656v.648h-5.82v-1.092h4.656l-.624.504q0-.588-.168-1.008a1.3 1.3 0 0 0-.504-.636q-.324-.228-.816-.228-.504 0-.852.228a1.4 1.4 0 0 0-.528.672q-.18.432-.18 1.068 0 .588.168 1.032.168.432.528.672t.936.24q.528 0 .864-.204t.456-.504h1.764q-.144.66-.564 1.176a2.86 2.86 0 0 1-1.056.804q-.636.288-1.464.288m8.449-.228v-1.944h-.324v-2.112q0-.504-.24-.756t-.768-.252q-.264 0-.696.012t-.888.036-.828.048v-1.62a30 30 0 0 1 1.416-.084q.396-.012.744-.012 1.008 0 1.692.288.696.288 1.056.876.36.576.36 1.488V216zm-2.1.168q-.708 0-1.248-.252a1.96 1.96 0 0 1-.828-.72q-.3-.48-.3-1.14 0-.72.372-1.176.372-.468 1.044-.684.672-.228 1.548-.228h1.404v1.068h-1.416q-.504 0-.78.252-.264.24-.264.66 0 .396.264.648.276.24.78.24.324 0 .576-.108a1 1 0 0 0 .432-.396q.168-.276.192-.768l.456.48q-.06.684-.336 1.152a1.8 1.8 0 0 1-.744.72q-.468.252-1.152.252m7.749.036q-1.404 0-2.196-.576t-.84-1.62h1.704q.048.312.372.564.336.24.996.24.504 0 .828-.168.336-.18.336-.504a.52.52 0 0 0-.252-.456q-.252-.18-.9-.252l-.516-.048q-1.188-.12-1.788-.66-.588-.54-.588-1.38 0-.696.348-1.164t.96-.708q.624-.24 1.416-.24 1.272 0 2.052.564.78.552.816 1.608h-1.704a.8.8 0 0 0-.336-.54q-.288-.228-.852-.228-.444 0-.708.168a.52.52 0 0 0-.264.456q0 .276.228.42t.744.204l.516.048q1.212.132 1.884.672t.672 1.452q0 .66-.36 1.152-.36.48-1.02.744-.66.252-1.548.252m7.183.024q-.84 0-1.488-.288a3.2 3.2 0 0 1-1.068-.768 3.7 3.7 0 0 1-.648-1.092 3.7 3.7 0 0 1-.216-1.248v-.24q0-.66.216-1.26.228-.612.648-1.092a2.95 2.95 0 0 1 1.044-.756 3.45 3.45 0 0 1 1.44-.288q1.056 0 1.776.48.732.468 1.116 1.236.384.756.384 1.656v.648h-5.82v-1.092h4.656l-.624.504q0-.588-.168-1.008a1.3 1.3 0 0 0-.504-.636q-.324-.228-.816-.228-.504 0-.852.228a1.4 1.4 0 0 0-.528.672q-.18.432-.18 1.068 0 .588.168 1.032.168.432.528.672t.936.24q.528 0 .864-.204t.456-.504h1.764q-.144.66-.564 1.176a2.86 2.86 0 0 1-1.056.804q-.636.288-1.464.288m10.968-.228v-1.944h-.324v-2.112q0-.504-.24-.756t-.768-.252q-.264 0-.696.012t-.888.036-.828.048v-1.62a30 30 0 0 1 1.416-.084q.396-.012.744-.012 1.008 0 1.692.288.696.288 1.056.876.36.576.36 1.488V216zm-2.1.168q-.708 0-1.248-.252a1.96 1.96 0 0 1-.828-.72q-.3-.48-.3-1.14 0-.72.372-1.176.372-.468 1.044-.684.672-.228 1.548-.228h1.404v1.068h-1.416q-.504 0-.78.252-.264.24-.264.66 0 .396.264.648.276.24.78.24.324 0 .576-.108a1 1 0 0 0 .432-.396q.168-.276.192-.768l.456.48q-.06.684-.336 1.152a1.8 1.8 0 0 1-.744.72q-.468.252-1.152.252m5.253 2.232v-8.976h1.524v2.844l-.204-.012q.048-.984.408-1.656.36-.684.972-1.02a2.74 2.74 0 0 1 1.38-.348q.684 0 1.236.252.564.252.96.708.408.444.612 1.056.216.6.216 1.32v.276q0 .708-.204 1.332a3.1 3.1 0 0 1-.6 1.068 2.7 2.7 0 0 1-.948.72 3 3 0 0 1-1.272.252q-.744 0-1.344-.3a2.37 2.37 0 0 1-.948-.936q-.36-.636-.396-1.608l.528.72v4.308zm3.54-3.792a1.5 1.5 0 0 0 .852-.24q.372-.24.576-.672t.204-.996-.204-.984a1.52 1.52 0 0 0-1.428-.888q-.432 0-.816.204a1.63 1.63 0 0 0-.624.588q-.228.372-.228.912v.444q0 .516.24.888.252.36.636.552t.792.192m4.898 3.792v-8.976h1.524v2.844l-.204-.012q.048-.984.408-1.656.36-.684.972-1.02a2.74 2.74 0 0 1 1.38-.348q.684 0 1.236.252.564.252.96.708.408.444.612 1.056.216.6.216 1.32v.276q0 .708-.204 1.332a3.1 3.1 0 0 1-.6 1.068 2.7 2.7 0 0 1-.948.72 3 3 0 0 1-1.272.252q-.744 0-1.344-.3a2.37 2.37 0 0 1-.948-.936q-.36-.636-.396-1.608l.528.72v4.308zm3.54-3.792a1.5 1.5 0 0 0 .852-.24q.372-.24.576-.672t.204-.996-.204-.984a1.52 1.52 0 0 0-1.428-.888q-.432 0-.816.204a1.63 1.63 0 0 0-.624.588q-.228.372-.228.912v.444q0 .516.24.888.252.36.636.552t.792.192m4.981 1.392v-8.76h1.932V216zm-.78-7.344v-1.416h2.712v1.416zm4.793 7.344v-6.576h1.92V216zm-.876-5.16v-1.416h2.796v1.416zm1.62-2.064q-.54 0-.804-.276a1.05 1.05 0 0 1-.252-.72q0-.444.252-.72.264-.288.804-.288t.792.288q.264.276.264.72 0 .432-.264.72-.252.276-.792.276m5.964 7.452q-.84 0-1.488-.288a3.2 3.2 0 0 1-1.068-.768 3.7 3.7 0 0 1-.648-1.092 3.7 3.7 0 0 1-.216-1.248v-.24q0-.66.216-1.26.228-.612.648-1.092a2.95 2.95 0 0 1 1.044-.756 3.45 3.45 0 0 1 1.44-.288q1.056 0 1.776.48.732.468 1.116 1.236.384.756.384 1.656v.648h-5.82v-1.092h4.656l-.624.504q0-.588-.168-1.008a1.3 1.3 0 0 0-.504-.636q-.324-.228-.816-.228-.504 0-.852.228a1.4 1.4 0 0 0-.528.672q-.18.432-.18 1.068 0 .588.168 1.032.168.432.528.672t.936.24q.528 0 .864-.204t.456-.504h1.764q-.144.66-.564 1.176a2.86 2.86 0 0 1-1.056.804q-.636.288-1.464.288m7.189-.012a3.1 3.1 0 0 1-1.272-.252 3.1 3.1 0 0 1-.984-.696 3.2 3.2 0 0 1-.648-1.068 4 4 0 0 1-.216-1.32v-.276q0-.708.204-1.32a3.3 3.3 0 0 1 .612-1.068 2.8 2.8 0 0 1 .972-.72 2.9 2.9 0 0 1 1.26-.264q.792 0 1.368.348.576.336.9 1.008.324.66.36 1.632l-.504-.468v-4.512h1.932V216h-1.524v-2.724h.264q-.036.936-.396 1.596-.348.66-.948 1.008-.6.336-1.38.336m.48-1.608q.444 0 .804-.192.372-.204.588-.588.228-.384.228-.924v-.444q0-.528-.228-.888a1.53 1.53 0 0 0-.6-.552 1.7 1.7 0 0 0-.804-.192q-.48 0-.864.252-.372.24-.588.672-.216.42-.216.984 0 .576.216.996t.6.648.864.228m10.261 1.596q-1.404 0-2.196-.576t-.84-1.62h1.704q.048.312.372.564.336.24.996.24.504 0 .828-.168.336-.18.336-.504a.52.52 0 0 0-.252-.456q-.252-.18-.9-.252l-.516-.048q-1.188-.12-1.788-.66-.588-.54-.588-1.38 0-.696.348-1.164t.96-.708q.624-.24 1.416-.24 1.272 0 2.052.564.78.552.816 1.608h-1.704a.8.8 0 0 0-.336-.54q-.288-.228-.852-.228-.444 0-.708.168a.52.52 0 0 0-.264.456q0 .276.228.42t.744.204l.516.048q1.212.132 1.884.672t.672 1.452q0 .66-.36 1.152-.36.48-1.02.744-.66.252-1.548.252m7.16-.12q-.996 0-1.608-.24a1.7 1.7 0 0 1-.9-.828q-.276-.588-.276-1.584v-5.784h1.788v5.856q0 .468.24.72.252.24.708.24h.972v1.62zm-3.78-5.256v-1.404h4.704v1.404zm9.943 5.172v-1.944h-.324v-2.112q0-.504-.24-.756t-.768-.252q-.264 0-.696.012t-.888.036-.828.048v-1.62a30 30 0 0 1 1.416-.084q.396-.012.744-.012 1.008 0 1.692.288.696.288 1.056.876.36.576.36 1.488V216zm-2.1.168q-.708 0-1.248-.252a1.96 1.96 0 0 1-.828-.72q-.3-.48-.3-1.14 0-.72.372-1.176.372-.468 1.044-.684.672-.228 1.548-.228h1.404v1.068h-1.416q-.504 0-.78.252-.264.24-.264.66 0 .396.264.648.276.24.78.24.324 0 .576-.108a1 1 0 0 0 .432-.396q.168-.276.192-.768l.456.48q-.06.684-.336 1.152a1.8 1.8 0 0 1-.744.72q-.468.252-1.152.252m8.241-.084q-.996 0-1.608-.24a1.7 1.7 0 0 1-.9-.828q-.276-.588-.276-1.584v-5.784h1.788v5.856q0 .468.24.72.252.24.708.24h.972v1.62zm-3.78-5.256v-1.404h4.704v1.404zm8.215 5.376q-1.14 0-1.752-.732-.612-.744-.612-2.232v-3.816h1.92v3.912q0 .528.3.84t.804.312q.516 0 .84-.324t.324-.876v-3.864h1.92V216h-1.524v-2.772h.132q0 .996-.264 1.668-.252.66-.756.984t-1.248.324zm8.011 0q-1.404 0-2.196-.576t-.84-1.62h1.704q.048.312.372.564.336.24.996.24.504 0 .828-.168.336-.18.336-.504a.52.52 0 0 0-.252-.456q-.252-.18-.9-.252l-.516-.048q-1.188-.12-1.788-.66-.588-.54-.588-1.38 0-.696.348-1.164t.96-.708q.624-.24 1.416-.24 1.272 0 2.052.564.78.552.816 1.608h-1.704a.8.8 0 0 0-.336-.54q-.288-.228-.852-.228-.444 0-.708.168a.52.52 0 0 0-.264.456q0 .276.228.42t.744.204l.516.048q1.212.132 1.884.672t.672 1.452q0 .66-.36 1.152-.36.48-1.02.744-.66.252-1.548.252m7.174-158.712v-1.704h1.572q.456 0 .78-.18.336-.18.516-.504a1.6 1.6 0 0 0 .18-.768q0-.456-.18-.78a1.16 1.16 0 0 0-.516-.504 1.6 1.6 0 0 0-.78-.18h-1.572v-1.704h1.476q1.116 0 1.908.372.804.372 1.224 1.056.432.684.432 1.644v.192q0 .936-.432 1.632-.42.684-1.224 1.056-.792.372-1.908.372zM355.996 60v-8.832h1.968V60zm10.116.204q-1.14 0-1.752-.732-.612-.744-.612-2.232v-3.816h1.92v3.912q0 .528.3.84t.804.312q.516 0 .84-.324t.324-.876v-3.864h1.92V60h-1.524v-2.772h.132q0 .996-.264 1.668-.252.66-.756.984t-1.248.324zM371.71 60v-8.76h1.932V60zm-.78-7.344V51.24h2.712v1.416zM375.495 60v-8.76h1.932V60zm-.78-7.344V51.24h2.712v1.416zm6.977 7.548q-1.404 0-2.196-.576t-.84-1.62h1.704q.048.312.372.564.336.24.996.24.504 0 .828-.168.336-.18.336-.504a.52.52 0 0 0-.252-.456q-.252-.18-.9-.252l-.516-.048q-1.188-.12-1.788-.66-.588-.54-.588-1.38 0-.696.348-1.164t.96-.708q.624-.24 1.416-.24 1.272 0 2.052.564.78.552.816 1.608h-1.704a.8.8 0 0 0-.336-.54q-.288-.228-.852-.228-.444 0-.708.168a.52.52 0 0 0-.264.456q0 .276.228.42t.744.204l.516.048q1.212.132 1.884.672t.672 1.452q0 .66-.36 1.152-.36.48-1.02.744-.66.252-1.548.252M348.657 76v-1.944h-.324v-2.112q0-.504-.24-.756t-.768-.252q-.264 0-.696.012t-.888.036-.828.048v-1.62a30 30 0 0 1 1.416-.084q.396-.012.744-.012 1.008 0 1.692.288.696.288 1.056.876.36.576.36 1.488V76zm-2.1.168q-.708 0-1.248-.252a1.96 1.96 0 0 1-.828-.72q-.3-.48-.3-1.14 0-.72.372-1.176.372-.468 1.044-.684.672-.228 1.548-.228h1.404v1.068h-1.416q-.504 0-.78.252-.264.24-.264.66 0 .396.264.648.276.24.78.24.324 0 .576-.108a1 1 0 0 0 .432-.396q.168-.276.192-.768l.456.48q-.06.684-.336 1.152a1.8 1.8 0 0 1-.744.72q-.468.252-1.152.252M351.81 76v-6.576h1.524v2.82h-.036q0-1.392.588-2.148.6-.756 1.728-.756h.252v1.656h-.48q-.792 0-1.224.432-.432.42-.432 1.224V76zm8.191.084q-.996 0-1.608-.24a1.7 1.7 0 0 1-.9-.828q-.276-.588-.276-1.584v-5.784h1.788v5.856q0 .468.24.72.252.24.708.24h.972v1.62zm-3.78-5.256v-1.404h4.704v1.404zM362.528 76v-6.576h1.92V76zm-.876-5.16v-1.416h2.796v1.416zm1.62-2.064q-.54 0-.804-.276a1.05 1.05 0 0 1-.252-.72q0-.444.252-.72.264-.288.804-.288t.792.288q.264.276.264.72 0 .432-.264.72-.252.276-.792.276M366.368 76v-6.636q0-1.14.648-1.692t1.908-.552h.84v1.44h-.924q-.324 0-.504.18t-.18.504V76zm-.78-5.04v-1.404h4.272v1.404zm9.166 5.04v-1.944h-.324v-2.112q0-.504-.24-.756t-.768-.252q-.264 0-.696.012t-.888.036-.828.048v-1.62a30 30 0 0 1 1.416-.084q.396-.012.744-.012 1.008 0 1.692.288.696.288 1.056.876.36.576.36 1.488V76zm-2.1.168q-.708 0-1.248-.252a1.96 1.96 0 0 1-.828-.72q-.3-.48-.3-1.14 0-.72.372-1.176.372-.468 1.044-.684.672-.228 1.548-.228h1.404v1.068h-1.416q-.504 0-.78.252-.264.24-.264.66 0 .396.264.648.276.24.78.24.324 0 .576-.108a1 1 0 0 0 .432-.396q.168-.276.192-.768l.456.48q-.06.684-.336 1.152a1.8 1.8 0 0 1-.744.72q-.468.252-1.152.252m8.205.06q-.852 0-1.488-.276a3.1 3.1 0 0 1-1.044-.768 3.2 3.2 0 0 1-.624-1.08 4 4 0 0 1-.204-1.26v-.228q0-.672.216-1.284.216-.624.636-1.104a2.95 2.95 0 0 1 1.044-.756q.636-.276 1.452-.276.888 0 1.572.348.684.336 1.092.948t.456 1.404h-1.884a1.18 1.18 0 0 0-.36-.744q-.3-.312-.876-.312-.48 0-.804.24-.312.24-.468.66t-.156.996q0 .528.144.96.144.42.456.66.324.228.84.228.384 0 .648-.132.276-.144.432-.384.168-.252.204-.576h1.872a2.74 2.74 0 0 1-.456 1.44q-.42.612-1.116.96-.696.336-1.584.336m7.372-.144q-.996 0-1.608-.24a1.7 1.7 0 0 1-.9-.828q-.276-.588-.276-1.584v-5.784h1.788v5.856q0 .468.24.72.252.24.708.24h.972v1.62zm-3.78-5.256v-1.404h4.704v1.404zm8.444 5.376q-1.404 0-2.196-.576t-.84-1.62h1.704q.048.312.372.564.336.24.996.24.504 0 .828-.168.336-.18.336-.504a.52.52 0 0 0-.252-.456q-.252-.18-.9-.252l-.516-.048q-1.188-.12-1.788-.66-.588-.54-.588-1.38 0-.696.348-1.164t.96-.708q.624-.24 1.416-.24 1.272 0 2.052.564.78.552.816 1.608h-1.704a.8.8 0 0 0-.336-.54q-.288-.228-.852-.228-.444 0-.708.168a.52.52 0 0 0-.264.456q0 .276.228.42t.744.204l.516.048q1.212.132 1.884.672t.672 1.452q0 .66-.36 1.152-.36.48-1.02.744-.66.252-1.548.252",
					fill: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("circle", {
					cx: 236,
					cy: 88,
					r: 3,
					fill: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("circle", {
					cx: 88,
					cy: 130,
					r: 3,
					fill: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("circle", {
					cx: 416,
					cy: 88,
					r: 3,
					fill: "#fff"
				}),
				/* @__PURE__ */ (0, J.jsx)("path", {
					d: "m140 88 4-4 4 4-4 4zm180 0 4-4 4 4-4 4zm148 42 4-4 4 4-4 4z",
					fill: "#fff"
				})
			]
		}),
		/* @__PURE__ */ (0, J.jsx)("defs", { children: /* @__PURE__ */ (0, J.jsx)("clipPath", {
			id: "clip0_9067_37937",
			children: /* @__PURE__ */ (0, J.jsx)("path", {
				fill: "#fff",
				d: "M0 0h560v250H0z"
			})
		}) })
	]
}), Kv = ({ installationDetail: e, refetchInstallationDetail: t, toggleIsolatedDeploymentConfigModal: n }) => {
	let [r, o] = A(!1), [s, c] = A(!1), [l, u] = A(!1), { tenantId: d, name: f } = hv();
	if (!e || !Rs(e.environments)) return null;
	let { deploymentConfig: p, name: m, installationId: h } = e, g = () => {
		c((e) => !e);
	}, _ = () => {
		o((e) => !e);
	}, v = (e = !1) => async () => {
		try {
			u(!0), await Vv({
				tenantId: d,
				installationId: h,
				shouldAddTimeStamp: !e
			}), t(), B.showToast({
				variant: V.success,
				description: "Authentication token generated"
			}), u(!1);
		} catch (t) {
			e ? await v(!1)() : (W(t), u(!1));
		}
	};
	return /* @__PURE__ */ (0, J.jsxs)("aside", {
		className: "w-320 dc__border-left-n1 flexbox-col dc__gap-16 flex-grow-1 bg__primary p-20 dc__no-shrink",
		children: [
			/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flex left dc__gap-6",
				children: [/* @__PURE__ */ (0, J.jsx)("h3", {
					className: "fs-16 fw-6 lh-24 cn-9 m-0",
					children: "Isolated delivery configurations"
				}), /* @__PURE__ */ (0, J.jsx)(i, {
					className: "icon-dim-20 fcn-6 dc__no-shrink cursor",
					onClick: g
				})]
			}),
			p ? /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [
				/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col dc__gap-12",
					children: [/* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flex dc__content-space dc__gap-4",
						children: [/* @__PURE__ */ (0, J.jsx)("span", {
							className: "fs-13 fw-6 lh-20 cn-9",
							children: "Release manifest delivery"
						}), /* @__PURE__ */ (0, J.jsx)(M, {
							text: "Change",
							size: P.medium,
							variant: N.text,
							dataTestId: "change-deployment-config",
							onClick: n
						})]
					}), /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox-col dc__gap-12 dc__border-left-n1 pl-12",
						children: [p.pushToRemote ? /* @__PURE__ */ (0, J.jsxs)("div", {
							className: "flexbox-col dc__gap-12 w-100",
							children: [/* @__PURE__ */ (0, J.jsx)("div", { children: "Release orchestration manifest will be pushed to the below OCI repository." }), /* @__PURE__ */ (0, J.jsxs)("div", {
								className: "flexbox-col dc__gap-8",
								children: [/* @__PURE__ */ (0, J.jsxs)("div", {
									className: "flexbox-col dc__gap-4 fs-13 fw-4 lh-20 cn-9",
									children: [/* @__PURE__ */ (0, J.jsx)("span", {
										className: "cn-7",
										children: "Registry"
									}), /* @__PURE__ */ (0, J.jsxs)("span", {
										className: "flex left dc__gap-6",
										children: [/* @__PURE__ */ (0, J.jsx)(Cn, { registryType: p.dockerRegistryType }), /* @__PURE__ */ (0, J.jsx)(Kn, {
											content: p.dockerRegistryId,
											showOnTruncate: !!p.dockerRegistryId,
											className: "mxh-250 dc__overflow-auto",
											interactive: !0,
											children: /* @__PURE__ */ (0, J.jsx)("span", {
												className: "dc__truncate",
												children: p.dockerRegistryId || "-"
											})
										})]
									})]
								}), /* @__PURE__ */ (0, J.jsxs)("div", {
									className: "flexbox-col dc__gap-4 fs-13 fw-4 lh-20 cn-9",
									children: [/* @__PURE__ */ (0, J.jsx)("span", {
										className: "cn-7",
										children: "Repository"
									}), /* @__PURE__ */ (0, J.jsxs)("span", {
										className: "flex left dc__gap-6",
										children: [/* @__PURE__ */ (0, J.jsx)(Wv, { className: "icon-dim-20 dc__no-shrink" }), /* @__PURE__ */ (0, J.jsx)(Kn, {
											content: p.repository,
											showOnTruncate: !!p.repository,
											className: "mxh-250 dc__overflow-auto",
											interactive: !0,
											children: /* @__PURE__ */ (0, J.jsx)("span", {
												className: "dc__truncate",
												children: p.repository || "-"
											})
										})]
									})]
								})]
							})]
						}) : /* @__PURE__ */ (0, J.jsx)("div", {
							className: "fs-13 fw-4 lh-20 cn-9",
							children: "Release orchestration manifest can be downloaded on every release trigger."
						}), /* @__PURE__ */ (0, J.jsxs)("div", {
							className: "flex column left dc__gap-4 fs-12 fw-4 lh-18 cn-7",
							children: [/* @__PURE__ */ (0, J.jsx)(M, {
								text: "How to deliver manifest to tenant",
								variant: N.text,
								size: P.small,
								dataTestId: "manifest-delivery-description",
								endIcon: /* @__PURE__ */ (0, J.jsx)(_e, { className: `dc__transition--transform ${r ? "dc__flip-180" : ""}` }),
								onClick: _
							}), r && /* @__PURE__ */ (0, J.jsxs)("div", { children: [
								/* @__PURE__ */ (0, J.jsx)("span", { children: p.pushToRemote ? "Add this OCI registry & repository to your deployment agent to pull and apply release orchestration manifest for new release versions." : "Release orchestration manifest can be shared offline or by any medium of your choice." }),
								"\xA0",
								/* @__PURE__ */ (0, J.jsx)("a", {
									className: "anchor",
									target: "_blank",
									href: yt,
									rel: "noreferrer",
									children: "Learn more"
								})
							] })]
						})]
					})]
				}),
				/* @__PURE__ */ (0, J.jsx)("div", { className: "w-100 h-1 dc__border-bottom-n1" }),
				/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col dc__gap-12",
					children: [/* @__PURE__ */ (0, J.jsxs)("div", {
						className: "fw-6",
						children: [
							"Receive application and deployment status from ‘",
							f,
							" (",
							m,
							")’"
						]
					}), /* @__PURE__ */ (0, J.jsx)("div", {
						className: "flexbox-col dc__gap-12 dc__border-left-n1 pl-12",
						children: p.tokenId ? /* @__PURE__ */ (0, J.jsxs)("div", {
							className: "flexbox-col dc__gap-8",
							children: [/* @__PURE__ */ (0, J.jsxs)("div", {
								className: "flexbox-col dc__gap-4 fs-13 fw-4 lh-20 cn-9",
								children: [/* @__PURE__ */ (0, J.jsx)("span", {
									className: "cn-7",
									children: "Host name"
								}), /* @__PURE__ */ (0, J.jsxs)("span", {
									className: "flex left dc__content-space dc__gap-4",
									children: [/* @__PURE__ */ (0, J.jsx)("span", {
										className: "dc__truncate",
										children: p.hostName ?? "-"
									}), p.hostName && /* @__PURE__ */ (0, J.jsx)(at, { content: p.hostName })]
								})]
							}), /* @__PURE__ */ (0, J.jsxs)("div", {
								className: "flexbox-col dc__gap-4 fs-13 fw-4 lh-20 cn-9",
								children: [/* @__PURE__ */ (0, J.jsx)("span", {
									className: "cn-7",
									children: /* @__PURE__ */ (0, J.jsxs)("span", { children: ["Auth token:\xA0", /* @__PURE__ */ (0, J.jsx)(wi, {
										to: q(a.AUTH_API_TOKEN_EDIT, { id: String(p.tokenId) }),
										className: "anchor cb-5 dc__word-break",
										target: "_blank",
										children: p.tokenName
									})] })
								}), /* @__PURE__ */ (0, J.jsxs)("span", {
									className: "flex left dc__content-space dc__gap-4",
									children: [/* @__PURE__ */ (0, J.jsx)("span", {
										className: "dc__truncate",
										children: p.token ?? "-"
									}), p.token && /* @__PURE__ */ (0, J.jsx)(at, { content: p.token })]
								})]
							})]
						}) : /* @__PURE__ */ (0, J.jsx)(M, {
							variant: N.text,
							size: P.medium,
							text: l ? "Generating token ..." : "Get hostname & Auth token",
							dataTestId: "get-hostname-and-api-token",
							onClick: v(!0),
							disabled: l
						})
					})]
				})
			] }) : /* @__PURE__ */ (0, J.jsx)(nn, {
				description: /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col dc__gap-4 fs-13 fw-4 lh-20 cn-9",
					children: [/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("h4", {
						className: "m-0 fw-6 lh-20",
						children: "Action required"
					}), /* @__PURE__ */ (0, J.jsx)("span", { children: "Configure how to deliver release orchestration manifest to this tenant." })] }), /* @__PURE__ */ (0, J.jsx)(M, {
						text: "Configure",
						dataTestId: "configure-manifest-delivery",
						onClick: n,
						variant: N.text,
						size: P.medium
					})]
				}),
				variant: "warning"
			}),
			s && /* @__PURE__ */ (0, J.jsx)(Lt, {
				SVGImage: Gv,
				docLink: "DOC_HOME_PAGE",
				title: "Isolated delivery configurations",
				renderDescriptionContent: jv,
				closeModal: g
			})
		]
	});
}, qv = ({ name: e, namespace: t, environmentType: n, tenantConfig: r, isChecked: i, isVirtual: a, toggleEnvironmentSelection: o, isEnvListLoading: s, installationName: c, searchKey: l }) => {
	let { name: u } = hv(), d = s || !Is({ tenantConfig: r }, {
		tenantName: u,
		installationName: c
	});
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "display-grid dc__column-gap-16 tenants__installation-env-row fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-20",
		children: [
			/* @__PURE__ */ (0, J.jsx)(lt, {
				condition: d,
				wrap: (e) => /* @__PURE__ */ (0, J.jsx)(D, {
					content: `The environment is currently mapped to the '${r.displayText}'. Each environment can only be mapped to one tenant installation at a time.`,
					placement: "top",
					className: "default-tt w-200 dc__word-break",
					arrow: !1,
					children: e
				}),
				children: /* @__PURE__ */ (0, J.jsx)("div", { children: /* @__PURE__ */ (0, J.jsx)(it, {
					isChecked: i ?? !1,
					onChange: () => {
						o({
							name: e,
							isVirtual: a
						});
					},
					rootClassName: "mb-0",
					value: rt.CHECKED,
					disabled: d
				}) })
			}),
			/* @__PURE__ */ (0, J.jsx)("span", {
				className: "dc__truncate",
				dangerouslySetInnerHTML: { __html: C.sanitize(zr({
					searchText: l,
					text: e,
					highlightClasses: "bcy-2"
				})) }
			}),
			/* @__PURE__ */ (0, J.jsx)("span", {
				className: "dc__truncate",
				dangerouslySetInnerHTML: { __html: C.sanitize(zr({
					searchText: l,
					text: t,
					highlightClasses: "bcy-2"
				})) }
			}),
			/* @__PURE__ */ (0, J.jsx)("span", {
				className: "dc__truncate",
				children: a ? "-" : n
			}),
			/* @__PURE__ */ (0, J.jsx)("span", {
				className: "dc__truncate",
				dangerouslySetInnerHTML: { __html: C.sanitize(zr({
					searchText: l,
					text: r.displayText,
					highlightClasses: "bcy-2"
				})) }
			})
		]
	});
}, Jv = ({ isEnvListLoading: e, envListResponse: t, updateEnvMapForSelectedCluster: n, selectedEnvMapForCluster: r, toggleEnvironmentSelection: i, installationName: a, filterConfig: { sortBy: o, sortOrder: s, handleSorting: c, searchKey: l, clearFilters: u } }) => {
	let { name: d } = hv(), f = k(() => t ? (l.toLowerCase() ? t.filter((e) => e.name.toLowerCase().includes(l) || e.namespace.toLowerCase().includes(l) || e.tenantConfig.name.toLowerCase().includes(l) || e.tenantConfig.installationConfig.name.toLowerCase().includes(l)) : structuredClone(t)).sort((e, t) => {
		switch (o) {
			case Ps.namespace: return G(e.namespace, t.namespace, s);
			case Ps.environmentType: return G(e.environmentType, t.environmentType, s);
			case Ps.tenantInstallation: return G(e.tenantConfig.displayText, t.tenantConfig.displayText, s);
			default: return G(e.name, t.name, s);
		}
	}) : [], [
		t,
		o,
		s,
		l
	]), p = f.length, m = k(() => {
		let e = Ls(r);
		return p > 0 && f.map((e) => e.name).every((e) => r[e]) ? rt.CHECKED : e > 0 ? rt.INTERMEDIATE : null;
	}, [f, r]), h = m === rt.CHECKED || m === rt.INTERMEDIATE;
	return /* @__PURE__ */ (0, J.jsx)("div", {
		className: "flexbox-col flex-grow-1 dc__overflow-auto",
		children: e || p ? /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "display-grid dc__column-gap-16 tenants__installation-env-row tenants__installation-env-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center px-20 dc__uppercase show-shimmer-loading",
			children: [
				e ? /* @__PURE__ */ (0, J.jsx)("span", { className: "child-shimmer-loading" }) : /* @__PURE__ */ (0, J.jsx)(it, {
					isChecked: m === rt.CHECKED || m === rt.INTERMEDIATE,
					onChange: () => {
						let e = f.filter(({ tenantConfig: e }) => Is({ tenantConfig: e }, {
							tenantName: d,
							installationName: a
						})).map(({ name: e, isVirtual: t }) => ({
							name: e,
							isVirtual: t
						}));
						if (h) {
							n({});
							return;
						}
						n(e.reduce((e, { name: t, isVirtual: n }) => (e[t] = { isVirtual: n }, e), {}));
					},
					rootClassName: "mb-0",
					value: m ?? void 0,
					disabled: p === 0
				}),
				/* @__PURE__ */ (0, J.jsx)(z, {
					disabled: e,
					isSorted: o === Ps.environment,
					sortOrder: s,
					title: "Environment",
					triggerSorting: () => {
						c(Ps.environment);
					}
				}),
				/* @__PURE__ */ (0, J.jsx)(z, {
					disabled: e,
					isSorted: o === Ps.namespace,
					sortOrder: s,
					title: "Namespace",
					triggerSorting: () => {
						c(Ps.namespace);
					}
				}),
				/* @__PURE__ */ (0, J.jsx)(z, {
					disabled: e,
					isSorted: o === Ps.environmentType,
					sortOrder: s,
					title: "Environment Type",
					triggerSorting: () => {
						c(Ps.environmentType);
					}
				}),
				/* @__PURE__ */ (0, J.jsx)(z, {
					disabled: e,
					isSorted: o === Ps.tenantInstallation,
					sortOrder: s,
					title: "Tenant (Installation)",
					triggerSorting: () => {
						c(Ps.tenantInstallation);
					}
				})
			]
		}), /* @__PURE__ */ (0, J.jsx)("div", {
			className: "flex-grow-1 dc__overflow-auto",
			children: e ? Fs.map((e) => /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "display-grid dc__column-gap-16 tenants__installation-env-row fs-13 fw-4 lh-20 cn-9 dc__align-items-center px-20 show-shimmer-loading",
				children: [
					/* @__PURE__ */ (0, J.jsx)("span", { className: "child-shimmer-loading" }),
					/* @__PURE__ */ (0, J.jsx)("span", { className: "child-shimmer-loading" }),
					/* @__PURE__ */ (0, J.jsx)("span", { className: "child-shimmer-loading" }),
					/* @__PURE__ */ (0, J.jsx)("span", { className: "child-shimmer-loading" }),
					/* @__PURE__ */ (0, J.jsx)("span", { className: "child-shimmer-loading" })
				]
			}, `env-list-loading-${e.name}`)) : f.map((t) => /* @__PURE__ */ Me(qv, {
				...t,
				isEnvListLoading: e,
				isChecked: !!r[t.name],
				toggleEnvironmentSelection: i,
				installationName: a,
				key: t.name,
				searchKey: l
			}))
		})] }) : /* @__PURE__ */ (0, J.jsx)(Gt, {
			handleClearFilters: u,
			classname: "flex-grow-1"
		})
	});
}, Yv = (e) => /* @__PURE__ */ (0, J.jsxs)(wi, {
	to: `${I.GLOBAL_CONFIG_CLUSTER_ENV}/${e}${a.CREATE_ENV}`,
	target: "_blank",
	className: "flex dc__content-start dc__gap-4 anchor cta h-32 pr-8-imp pl-8-imp dc__no-shrink",
	children: [/* @__PURE__ */ (0, J.jsx)(o, { className: "icon-dim-16 dc__no-shrink" }), /* @__PURE__ */ (0, J.jsx)("span", {
		className: "fw-6 lh-18 cn-0 fs-12",
		children: "Add Environment"
	})]
}), Xv = ({ selectedCluster: e, toggleEnvironmentSelection: t, selectedEnvMapForCluster: n, updateEnvMapForSelectedCluster: r, installationName: i }) => {
	let [a, o, s, c] = K(() => q_(e), [e], !!e), { sortBy: l, sortOrder: u, handleSorting: d, searchKey: f, handleSearch: p, clearFilters: m } = mi({ initialSortKey: Ps.environment });
	if (!e) return /* @__PURE__ */ (0, J.jsx)(F, {
		image: Gi,
		title: "Please select an cluster",
		subTitle: "Select a cluster to map environments",
		classname: "flex-grow-1"
	});
	let h = (e) => {
		p(e);
	}, g = () => Yv(e);
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col flex-grow-1 dc__overflow-auto dc__gap-12",
		children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flex dc__content-space py-10 px-20 dc__gap-6",
			children: [/* @__PURE__ */ (0, J.jsxs)("h3", {
				className: "dc__truncate cn-9 fs-16 lh-28 fw-6 cn-9 m-0",
				children: ["Cluster / ", e]
			}), /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox dc__align-items-center dc__gap-8 dc__no-shrink",
				children: [/* @__PURE__ */ (0, J.jsx)(On, {
					handleEnter: h,
					initialSearchText: f
				}), g()]
			})]
		}), /* @__PURE__ */ (0, J.jsx)(Ie, {
			isLoading: !1,
			error: s,
			errorScreenManagerProps: {
				code: s?.code,
				reload: c
			},
			children: /* @__PURE__ */ (0, J.jsx)("div", {
				className: "flexbox-col flex-grow-1 dc__overflow-auto",
				children: a || o?.length ? /* @__PURE__ */ (0, J.jsx)(Jv, {
					envListResponse: o,
					isEnvListLoading: a,
					selectedEnvMapForCluster: n,
					toggleEnvironmentSelection: t,
					updateEnvMapForSelectedCluster: r,
					installationName: i,
					filterConfig: {
						sortBy: l,
						sortOrder: u,
						handleSorting: d,
						searchKey: f,
						clearFilters: m
					}
				}) : /* @__PURE__ */ (0, J.jsx)(F, {
					image: Gi,
					title: "No environments added",
					subTitle: "This cluster doesn't have any environments yet.",
					classname: "flex-grow-1",
					isButtonAvailable: !0,
					renderButton: g
				})
			})
		})]
	});
}, Zv = (e) => /* @__PURE__ */ (0, J.jsx)("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ (0, J.jsx)("path", {
		d: "M13.6084 8.75V4.58333L9.99998 2.5L6.39154 4.58333V8.75M13.6084 8.75L9.99998 10.8333M13.6084 8.75L17.2167 10.8333V15L13.6083 17.0833L10.0001 15M9.99998 10.8333L6.39154 8.75M9.99998 10.8333L10.0001 15M6.39154 8.75L2.7832 10.8333V15L6.39164 17.0833L10.0001 15",
		stroke: "#0066CC",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qv = ({ name: e, isSelected: t, handleClick: n, selectedEnvCount: r, isVirtual: i }) => /* @__PURE__ */ (0, J.jsxs)("button", {
	type: "button",
	className: `dc__transparent px-8 py-6 flexbox dc__content-start br-4 dc__gap-8 ${i ? "" : "dc__align-items-center"} ${t ? "bcb-1" : "dc__hover-n50"}`,
	onClick: () => {
		n(e);
	},
	children: [
		/* @__PURE__ */ (0, J.jsx)(Zv, { className: `icon-dim-16 dc__no-shrink ${i ? "mt-2" : ""} ${t ? "" : "scn-6"}` }),
		/* @__PURE__ */ (0, J.jsxs)("span", {
			className: "flex column left flex-grow-1",
			children: [/* @__PURE__ */ (0, J.jsx)("span", {
				className: `fs-13 lh-20 dc__truncate flex-grow-1 ${t ? "cb-5 fw-6" : "cn-9 fw-4"}`,
				children: e
			}), i && /* @__PURE__ */ (0, J.jsx)("span", {
				className: "fs-12 lh-18 dc__truncate flex-grow-1 fw-4 cn-7",
				children: "Isolated cluster"
			})]
		}),
		r > 0 && /* @__PURE__ */ (0, J.jsx)("span", {
			className: `px-6 br-12 ${t ? "bcb-5 cn-0" : "bcn-1 cn-7"} dc__align-center fs-12 fw-6 lh-20 dc__truncate dc__no-shrink`,
			children: r
		})
	]
}), $v = ({ clusterList: e, handleClusterSelection: t, selectedCluster: n, selectedEnvMapByCluster: r }) => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "w-220 flexbox-col dc__no-shrink dc__overflow-auto dc__border-right--n1",
	children: [/* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flex dc__content-space dc__no-shrink py-12 pr-12 pl-20 dc__gap-6",
		children: [/* @__PURE__ */ (0, J.jsx)("span", {
			className: "cn-9 fw-6 lh-20 fs-13",
			children: "Clusters"
		}), /* @__PURE__ */ (0, J.jsxs)(wi, {
			to: `${I.GLOBAL_CONFIG_CLUSTER_ENV}${a.CONNECT_CLUSTER}`,
			target: "blank",
			className: "px-4 py-2 flex dc__content-start dc__gap-6 anchor fw-6 lh-20 fs-13 cb-5 h-24",
			children: [/* @__PURE__ */ (0, J.jsx)(o, { className: "icon-dim-16 dc__no-shrink fcb-5" }), "Add"]
		})]
	}), /* @__PURE__ */ (0, J.jsx)("div", {
		className: "flexbox-col flex-grow-1 dc__overflow-auto p-12",
		children: e.map(({ name: e, isVirtual: i }) => /* @__PURE__ */ (0, J.jsx)(Qv, {
			name: e,
			isSelected: e === n,
			handleClick: t,
			selectedEnvCount: Ls(r[e]),
			isVirtual: i
		}, e))
	})]
}), ey = () => /* @__PURE__ */ (0, J.jsxs)(wi, {
	to: `${I.GLOBAL_CONFIG_CLUSTER_ENV}${a.CONNECT_CLUSTER}`,
	target: "_blank",
	className: "flex dc__content-start dc__gap-6 anchor cta fw-6 lh-20-imp fs-13 cb-5 h-24",
	children: [/* @__PURE__ */ (0, J.jsx)(o, { className: "icon-dim-16 dc__no-shrink fcb-5 h-36" }), "Add Cluster"]
}), ty = ({ installationName: e, handleSuccess: t, getInitialEnvSelectionMap: n, deploymentConfig: r, openIsolatedDeploymentConfigModal: i, updateInstallationMappingRef: a }) => {
	let o = ki(), s = Ai(), { name: c } = hv(), [l, u] = A(!1), [d, f] = A(null), [p, m] = A(n()), [h, g] = A(null), [_, v, y, b] = K(J_);
	O(() => {
		v && !d && f(v?.[0]?.name);
	}, [v, d]);
	let x = (e) => {
		f(e);
	}, S = (e) => {
		if (Bs(p, e)) {
			g({ updatedEnvMapForSelectedCluster: e });
			return;
		}
		m({
			...p,
			[d]: { ...e }
		});
	}, C = () => {
		g(null);
	}, w = () => {
		m({ [d]: h.updatedEnvMapForSelectedCluster }), C();
	}, T = ({ name: e, isVirtual: t }) => {
		let n = structuredClone(p[d] ?? {});
		n[e] ? delete n[e] : n[e] = { isVirtual: t }, S(n);
	}, ee = () => {
		o(q(I.TENANTS.DETAIL.INSTALLATIONS, {
			tenantId: s.tenantId,
			installationId: s.installationId
		}));
	}, E = async () => {
		u(!0);
		try {
			await Y_({
				installationId: s.installationId,
				tenantId: s.tenantId,
				selectedEnvironmentMap: p
			}), u(!1), B.showToast({
				variant: V.success,
				description: "Environments mapped successfully"
			}), ee(), t();
		} catch (e) {
			W(e), u(!1);
		}
	};
	return O(() => (a.current = E, () => {
		a.current = null;
	}), [p]), /* @__PURE__ */ (0, J.jsx)(Qn, {
		className: "",
		onEscape: ee,
		close: ee,
		children: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "bg__primary dc__position-fixed dc__right-0 dc__top-0 h-100 flexbox-col dc__content-space w-1024",
			onClick: ei,
			children: [
				/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col h-100 dc__content-space bg__primary dc__overflow-auto",
					children: [/* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox dc__content-space dc__align-items-center dc__border-bottom py-12 px-20 dc__gap-8",
						children: [/* @__PURE__ */ (0, J.jsxs)("h2", {
							className: "m-0 cn-9 fs-16 fw-6 lh-24 dc__ellipsis-right",
							children: [
								"Map Environment to ",
								c,
								" (",
								e,
								")"
							]
						}), /* @__PURE__ */ (0, J.jsx)("button", {
							className: "flex dc__transparent dc__outline-none-imp dc__no-border p-0 dc__tab-focus",
							type: "button",
							onClick: ee,
							"aria-label": "close-deployment-source-modal",
							children: /* @__PURE__ */ (0, J.jsx)(Ee, { className: "icon-dim-24 dc__no-shrink fcn-6" })
						})]
					}), /* @__PURE__ */ (0, J.jsx)(Ie, {
						isLoading: _,
						progressingProps: { pageLoader: !0 },
						error: y,
						errorScreenManagerProps: {
							code: y?.code,
							reload: b
						},
						children: /* @__PURE__ */ (0, J.jsx)("div", {
							className: "flexbox flex-grow-1 dc__overflow-auto",
							children: v?.length ? /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)($v, {
								selectedCluster: d,
								clusterList: v,
								handleClusterSelection: x,
								selectedEnvMapByCluster: p
							}), /* @__PURE__ */ (0, J.jsx)(Xv, {
								selectedCluster: d,
								selectedEnvMapForCluster: p[d] ?? {},
								toggleEnvironmentSelection: T,
								updateEnvMapForSelectedCluster: S,
								installationName: e
							}, d)] }) : /* @__PURE__ */ (0, J.jsx)(F, {
								image: Gi,
								title: "No clusters",
								subTitle: "No clusters have been connected to Devtron",
								classname: "flex-grow-1",
								isButtonAvailable: !0,
								renderButton: ey
							})
						})
					})]
				}),
				!_ && !y && /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox dc__align-items-center dc__content-end dc__gap-12 pt-12 pb-12 pl-16 pr-16 bg__primary dc__border-top dc__no-shrink",
					children: [/* @__PURE__ */ (0, J.jsx)("button", {
						type: "button",
						className: "cta cancel lh-20-imp h-32",
						onClick: ee,
						disabled: l,
						children: "Cancel"
					}), /* @__PURE__ */ (0, J.jsx)(M, {
						dataTestId: "map-environments-save",
						text: "save",
						size: P.medium,
						isLoading: l,
						onClick: async () => {
							if (zs(p) === Ns.isolated && !r) {
								i();
								return;
							}
							await E();
						}
					})]
				}),
				!!h && /* @__PURE__ */ (0, J.jsx)(ut, {
					variant: dt.custom,
					Icon: /* @__PURE__ */ (0, J.jsx)(ue, {}),
					title: "Previous selections will be cleared",
					subtitle: "An installation can either have connected environments or isolated environments",
					buttonConfig: {
						secondaryButtonConfig: {
							text: "Cancel",
							onClick: C
						},
						primaryButtonConfig: {
							text: "Clear & continue",
							onClick: w
						}
					},
					handleClose: C
				})
			]
		})
	});
}, ny = ({ openEditInstallationModal: e, refetchInstallationList: t }) => {
	let [n, r] = A(!1), i = Pe(null), a = ki(), o = Ai(), { installationId: s } = o, { image: c, name: l, tenantId: u } = hv(), [d, f, p, m] = K(() => H_({
		tenantId: u,
		installationId: s
	}), [s], !!s), h = () => f?.environments?.reduce((e, t) => (e[t.cluster] || (e[t.cluster] = {}), e[t.cluster][t.name] = { isVirtual: t.isVirtual }, e), {});
	if (!s) return /* @__PURE__ */ (0, J.jsx)(F, {
		image: Ni,
		title: "Please select an installation",
		subTitle: "Select an installation to map environments",
		classname: "flex-grow-1"
	});
	let g = () => {
		e({
			installationId: f.installationId,
			name: f.name,
			releaseChannelId: f.releaseChannelId
		});
	}, _ = () => /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "p-20 flexbox dc__align-items-center dc__gap-16",
		children: [/* @__PURE__ */ (0, J.jsx)(sf, { imageProps: {
			src: c,
			alt: `Logo for tenant: ${l}`
		} }), /* @__PURE__ */ (0, J.jsx)("div", { children: d ? /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)("div", { className: "child-shimmer-loading w-120 h-22 mt-0" }), /* @__PURE__ */ (0, J.jsx)("div", { className: "child-shimmer-loading w-150 h-18" })] }) : /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flex dc__content-start dc__gap-6",
			children: [/* @__PURE__ */ (0, J.jsx)("h3", {
				className: "cn-9 fs-16 lh-24 fw-6 dc__truncate m-0",
				children: f.name
			}), /* @__PURE__ */ (0, J.jsx)("button", {
				type: "button",
				"aria-label": `edit ${f.name}`,
				"data-testid": `edit-${f.name}`,
				className: "flex dc__transparent p-0",
				onClick: g,
				children: /* @__PURE__ */ (0, J.jsx)(v, { className: "icon-dim-16 dc__no-shrink scn-6" })
			})]
		}), /* @__PURE__ */ (0, J.jsxs)("p", {
			className: "cn-9 fs-13 fw-4 lh-20 m-0 dc__truncate",
			children: [
				"Installation ID: ",
				f.installationId,
				" •\xA0",
				f.releaseChannelId ? `Release Channel: ${f.releaseChannelName}` : "No release channel subscribed"
			]
		})] }) })]
	}), y = () => {
		a(q(I.TENANTS.DETAIL.MAP_ENVIRONMENT, {
			tenantId: o.tenantId,
			installationId: s
		}));
	}, b = () => {
		t();
	}, x = () => {
		if (i.current) {
			i.current();
			return;
		}
		t();
	}, S = () => /* @__PURE__ */ (0, J.jsx)(M, {
		size: P.medium,
		variant: N.secondary,
		startIcon: /* @__PURE__ */ (0, J.jsx)(pe, {}),
		disabled: d,
		onClick: y,
		dataTestId: "map-env-button",
		text: "Map Environment"
	}), C = () => !d && !f.environments?.length ? /* @__PURE__ */ (0, J.jsx)(F, {
		image: Ni,
		title: `Map environments to '${f.name}'`,
		subTitle: "When deploying a release, you can target this installation. Mapped environments will be automatically selected for the deployment.",
		isButtonAvailable: !0,
		renderButton: S
	}) : /* @__PURE__ */ (0, J.jsx)(Iv, {
		isInstallationLoading: d,
		environments: f?.environments,
		renderMapEnvButton: S
	}), w = () => {
		r((e) => !e);
	};
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col flex-grow-1 dc__overflow-auto",
		children: [/* @__PURE__ */ (0, J.jsx)(Ie, {
			isLoading: !1,
			error: p,
			errorScreenManagerProps: {
				code: p?.code,
				reload: m,
				redirectURL: q(I.TENANTS.DETAIL.INSTALLATIONS, {
					tenantId: o.tenantId,
					installationId: void 0
				})
			},
			children: (d || !!f) && /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox flex-grow-1",
				children: [
					/* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox-col flex-grow-1 show-shimmer-loading dc__overflow-auto w-100",
						children: [_(), /* @__PURE__ */ (0, J.jsx)("div", {
							className: "flexbox-col flex-grow-1 dc__overflow-auto",
							children: C()
						})]
					}),
					/* @__PURE__ */ (0, J.jsx)(Kv, {
						installationDetail: f,
						refetchInstallationDetail: m,
						toggleIsolatedDeploymentConfigModal: w
					}),
					!d && !p && /* @__PURE__ */ (0, J.jsx)(Di, { children: /* @__PURE__ */ (0, J.jsx)(Ei, {
						path: j.SOFTWARE_RELEASE_MANAGEMENT.TENANTS.DETAIL.MAP_ENVIRONMENT,
						element: /* @__PURE__ */ (0, J.jsx)(ty, {
							installationName: f.name,
							deploymentConfig: f.deploymentConfig,
							handleSuccess: b,
							getInitialEnvSelectionMap: h,
							openIsolatedDeploymentConfigModal: w,
							updateInstallationMappingRef: i
						})
					}) })
				]
			})
		}), n && /* @__PURE__ */ (0, J.jsx)(Uv, {
			installationId: f?.installationId,
			handleClose: w,
			handleSuccess: x,
			deploymentConfig: f?.deploymentConfig
		})]
	});
}, ry = ({ handleClose: e, handleSuccess: t, installationId: n, name: r }) => {
	let { tenantId: i } = hv();
	return /* @__PURE__ */ (0, J.jsx)(St, {
		title: r,
		onDelete: async () => {
			await U_({
				tenantId: i,
				installationId: n
			}), t();
		},
		subtitle: "Deleting a installation will delete all the mapping added to it.",
		closeConfirmationModal: e,
		confirmationConfig: {
			identifier: "delete-installation-confirmation",
			confirmationKeyword: r
		},
		successToastMessage: "Installation deleted successfully"
	});
}, iy = ({ installationId: e, name: t, handleDeleteSuccess: n, handleEditInstallation: r }) => {
	let [i, a] = A(!1), o = () => {
		a(!0);
	};
	return /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)(ze, {
		id: "installation-list-options-menu",
		onClick: (e, t) => {
			switch (ei(t), e.id) {
				case "edit":
					r();
					break;
				case "delete":
					o();
					break;
				default: break;
			}
		},
		options: [{ items: [{
			id: "edit",
			label: `Edit ${t}`,
			startIcon: { name: "ic-pencil" }
		}, {
			id: "delete",
			label: `Delete ${t}`,
			startIcon: { name: "ic-delete" },
			type: "negative"
		}] }],
		buttonProps: {
			dataTestId: "installation-list-options-menu-button",
			icon: /* @__PURE__ */ (0, J.jsx)(Yt, {
				name: "ic-more-vertical",
				color: null
			}),
			variant: N.borderLess,
			ariaLabel: "Open action menu",
			style: $e.neutral,
			size: P.xs
		}
	}), i && /* @__PURE__ */ (0, J.jsx)(ry, {
		installationId: e,
		name: t,
		handleClose: () => {
			a(!1);
		},
		handleSuccess: n
	})] });
}, ay = ({ name: e, installationId: t, releaseChannelId: n, environmentCount: r, refetchInstallationList: i, openEditInstallationModal: a }) => {
	let o = Ai(), s = ki(), { refetchTenantDetail: c } = hv();
	return /* @__PURE__ */ (0, J.jsxs)(wi, {
		to: q(I.TENANTS.DETAIL.INSTALLATIONS, {
			tenantId: o.tenantId,
			installationId: t
		}),
		className: `anchor flexbox dc__content-space dc__gap-8 px-8 py-6 br-4 cursor dc__transparent w-100 ${o.installationId === t ? "bcb-1" : "dc__hover-n50"}`,
		children: [/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("h4", {
			className: "cb-5 fs-12 fw-6 lh-20 m-0",
			children: e
		}), /* @__PURE__ */ (0, J.jsxs)("p", {
			className: "cn-7 fs-12 fw-4 lh-18 m-0",
			children: [
				r,
				"\xA0",
				r === 1 ? "Environment" : "Environments"
			]
		})] }), /* @__PURE__ */ (0, J.jsx)(iy, {
			installationId: t,
			name: e,
			handleDeleteSuccess: async () => {
				await i(), await c(), s(q(I.TENANTS.DETAIL.INSTALLATIONS, {
					tenantId: o.tenantId,
					installationId: null
				}));
			},
			handleEditInstallation: () => {
				a({
					installationId: t,
					name: e,
					releaseChannelId: n
				});
			}
		})]
	});
}, oy = ({ openAddInstallationModal: e, installationList: t, refetchInstallationList: n, openEditInstallationModal: r }) => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "w-250 dc__no-shrink flexbox-col dc__border-right",
	children: [/* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flex dc__content-space dc__gap-8 py-12 pr-12 pl-20",
		children: [/* @__PURE__ */ (0, J.jsx)("div", {
			className: "cn-9 fs-13 fw-6 lh-20 dc__truncate",
			children: bs(t.length)
		}), /* @__PURE__ */ (0, J.jsxs)("button", {
			type: "button",
			className: "cta text flex h-24 dc__gap-6 anchor lh-20-imp dc__no-border-imp px-4 py-2",
			onClick: e,
			children: [/* @__PURE__ */ (0, J.jsx)(o, { className: "icon-dim-14 dc__no-shrink fcb-5" }), /* @__PURE__ */ (0, J.jsx)("span", { children: "Add" })]
		})]
	}), /* @__PURE__ */ (0, J.jsx)("div", {
		className: "flexbox-col p-12 flex-grow-1 dc__overflow-auto",
		children: t.map((e) => /* @__PURE__ */ Me(ay, {
			...e,
			key: e.installationId,
			refetchInstallationList: n,
			openEditInstallationModal: r
		}))
	})]
}), sy = () => {
	let [e, t] = A(), { installationId: n, ...r } = Ai(), i = ki(), { tenantId: a, name: s, refetchTenantDetail: c } = hv(), [l, u, d, f] = K(() => V_(a));
	O(() => {
		u && !n && i(q(I.TENANTS.DETAIL.INSTALLATIONS, {
			tenantId: r.tenantId,
			installationId: u[0]?.installationId
		}), { replace: !0 });
	}, [u, n]);
	let p = () => {
		t({
			installationId: "",
			name: "",
			releaseChannelId: null
		});
	}, m = (e) => {
		t(e);
	}, h = () => {
		t(null);
	};
	return /* @__PURE__ */ (0, J.jsxs)(Ie, {
		isLoading: l,
		progressingProps: { pageLoader: !0 },
		error: d,
		errorScreenManagerProps: {
			code: d?.code,
			reload: f
		},
		children: [u?.length ? /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox h-100 bg__primary dc__overflow-hidden",
			children: [/* @__PURE__ */ (0, J.jsx)(oy, {
				installationList: u,
				openAddInstallationModal: p,
				openEditInstallationModal: m,
				refetchInstallationList: f
			}), /* @__PURE__ */ (0, J.jsx)(ny, {
				openEditInstallationModal: m,
				refetchInstallationList: f
			}, n)]
		}) : /* @__PURE__ */ (0, J.jsx)(F, {
			image: Ni,
			title: `Add an installation for '${s}'`,
			subTitle: "A tenant can have multiple installations of your software. An installation represents a deployment of your software across one or more environments of a tenant.",
			isButtonAvailable: !0,
			renderButton: () => /* @__PURE__ */ (0, J.jsxs)("button", {
				type: "button",
				className: "flex cta h-36 dc__gap-8",
				onClick: p,
				children: [/* @__PURE__ */ (0, J.jsx)(o, { className: "icon-dim-16" }), /* @__PURE__ */ (0, J.jsx)("span", {
					className: "fs-13 lh-20",
					children: "Add Installation"
				})]
			}),
			classname: "flex-grow-1"
		}), e && /* @__PURE__ */ (0, J.jsx)(Av, {
			handleClose: h,
			handleSuccess: async () => {
				f(), await c(), h();
			},
			installationConfig: e
		})]
	});
}, cy = "## Describe this tenant\n\nDescribe this tenant in a few words. The description could include the purpose, features, benefits, and target audience of your tenant. A well-written description will help users know about this tenant and how it works. Keep it concise and informative!", ly = () => {
	let { tenantId: e, name: t, description: n, image: r, installationsCount: i, createdOn: a, createdBy: o, refetchTenantDetail: s } = hv();
	return /* @__PURE__ */ (0, J.jsxs)("aside", {
		className: "flexbox-col dc__gap-16",
		children: [
			/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col dc__gap-12",
				children: [
					/* @__PURE__ */ (0, J.jsx)(sf, { imageProps: {
						src: r,
						alt: `Logo for tenant: ${t}`,
						loading: "lazy"
					} }),
					/* @__PURE__ */ (0, J.jsx)("h3", {
						className: "fs-16 fw-7 lh-24 cn-9 dc__word-break font-merriweather m-0",
						children: t
					}),
					/* @__PURE__ */ (0, J.jsx)(Pt, {
						emptyState: "Write a short description for this tenant",
						placeholder: "Write a short description for this tenant",
						initialText: n,
						updateContent: async (t) => {
							let n = {
								tenantId: e,
								description: t
							};
							try {
								await z_(n), B.showToast({
									variant: V.success,
									description: "Successfully saved"
								}), await s();
							} catch (e) {
								throw W(e), e;
							}
						},
						validations: { maxLength: {
							value: 350,
							message: "Max 350 characters allowed"
						} }
					})
				]
			}),
			/* @__PURE__ */ (0, J.jsx)("div", { className: "dc__border-top-n1" }),
			/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col dc__gap-12",
				children: [
					/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("div", {
						className: "fs-13 fw-4 lh-20 cn-7 mb-4",
						children: "Tenant ID"
					}), /* @__PURE__ */ (0, J.jsx)("div", {
						className: "fs-13 fw-6 lh-20 cn-9 dc__truncate",
						children: e
					})] }),
					/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("div", {
						className: "fs-13 fw-4 lh-20 cn-7 mb-4",
						children: "Added on"
					}), /* @__PURE__ */ (0, J.jsx)("div", {
						className: "fs-13 fw-6 lh-20 cn-9 dc__truncate",
						children: a
					})] }),
					/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("div", {
						className: "fs-13 fw-4 lh-20 cn-7 mb-4",
						children: "Added by"
					}), /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "fs-13 fw-6 lh-20 cn-9 dc__word-break flexbox flex-align-center dc__gap-8",
						children: [/* @__PURE__ */ (0, J.jsx)("div", {
							className: "icon-dim-20 mw-20 flexbox flex-justify-center flex-align-center dc__border-radius-50-per dc__uppercase cn-0 fw-4",
							style: { backgroundColor: Cr(o) },
							children: o[0]
						}), o]
					})] }),
					/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)("div", {
						className: "fs-13 fw-4 lh-20 cn-7 mb-4",
						children: "Installations"
					}), /* @__PURE__ */ (0, J.jsx)("div", {
						className: "fs-13 fw-6 lh-20 cn-9 dc__truncate",
						children: bs(i)
					})] })
				]
			})
		]
	});
}, uy = () => {
	let { tenantId: e, note: t, refetchTenantDetail: n } = hv();
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "pl-20 pr-20 pt-20 pb-20 software-hub__overview display-grid dc__gap-32 dc__content-center flex-grow-1 dc__overflow-auto",
		children: [/* @__PURE__ */ (0, J.jsx)(ly, {}), /* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)(ph, {
			resourceType: L.tenant,
			resourceIdentifier: e,
			version: R.alpha1
		}), /* @__PURE__ */ (0, J.jsx)(Wt, {
			text: t || cy,
			title: "Readme",
			updateDescription: async (t) => {
				try {
					await B_({
						tenantId: e,
						note: t
					}), B.showToast({
						variant: V.success,
						description: Nc
					}), await n();
				} catch (e) {
					W(e);
				}
			}
		})] })]
	});
}, dy = () => {
	let { tenantId: e } = Ai(), [t, n] = A(!1), [r, i, a, o] = K(() => P_(e), [e], !0, { resetOnChange: !1 }), s = k(() => ({
		...i,
		refetchTenantDetail: o
	}), [i]);
	return /* @__PURE__ */ (0, J.jsx)(Ie, {
		isLoading: r && !i,
		customLoader: /* @__PURE__ */ (0, J.jsx)("div", {
			className: "flex h-100 w-100",
			children: /* @__PURE__ */ (0, J.jsx)(Dt, {})
		}),
		errorScreenManagerProps: {
			code: a?.code,
			redirectURL: I.TENANTS.ROOT,
			reload: o
		},
		error: a,
		children: /* @__PURE__ */ (0, J.jsx)(mv, {
			value: s,
			children: /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox-col h-100 dc__overflow-hidden",
				children: [
					/* @__PURE__ */ (0, J.jsx)(_v, { openTenantEditModal: () => {
						n(!0);
					} }),
					/* @__PURE__ */ (0, J.jsxs)(Di, { children: [
						/* @__PURE__ */ (0, J.jsx)(Ei, {
							path: j.SOFTWARE_RELEASE_MANAGEMENT.TENANTS.DETAIL.OVERVIEW,
							element: /* @__PURE__ */ (0, J.jsx)(uy, {})
						}),
						/* @__PURE__ */ (0, J.jsx)(Ei, {
							path: `${j.SOFTWARE_RELEASE_MANAGEMENT.TENANTS.DETAIL.INSTALLATIONS}/*`,
							element: /* @__PURE__ */ (0, J.jsx)(sy, {})
						}),
						/* @__PURE__ */ (0, J.jsx)(Ei, {
							path: "*",
							element: /* @__PURE__ */ (0, J.jsx)(Ti, {
								to: j.SOFTWARE_RELEASE_MANAGEMENT.TENANTS.DETAIL.INSTALLATIONS.split("/")[0],
								replace: !0
							})
						})
					] }),
					t && /* @__PURE__ */ (0, J.jsx)(uv, {
						handleClose: () => {
							n(!1);
						},
						handleSuccess: o
					})
				]
			})
		})
	});
}, fy = () => {
	let { tenantId: e } = Ai();
	return /* @__PURE__ */ (0, J.jsx)(dy, {}, `tenant-detail-${e}`);
}, py = ({ handleClose: e, handleSuccess: t, releaseChannelId: n, releaseChannelName: r }) => /* @__PURE__ */ (0, J.jsx)(St, {
	title: r,
	component: "release channel",
	onDelete: async () => {
		await Mg(n), t();
	},
	subtitle: "Deleting this release channel will unsubscribe any installations subscribed to it.",
	closeConfirmationModal: e,
	confirmationConfig: {
		identifier: "delete-release-channel-confirmation",
		confirmationKeyword: r
	},
	successToastMessage: "Release channel deleted successfully"
}), my = () => /* @__PURE__ */ (0, J.jsx)(J.Fragment, { children: bv.map(({ channelId: e }) => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "display-grid dc__align-items-center dc__column-gap-16 release-channel__table-row fs-13 fw-4 lh-24 cn-9 px-20 show-shimmer-loading",
	children: [
		/* @__PURE__ */ (0, J.jsx)("span", { className: "child-shimmer-loading" }),
		/* @__PURE__ */ (0, J.jsx)("span", { className: "child-shimmer-loading" }),
		/* @__PURE__ */ (0, J.jsx)("span", { className: "child-shimmer-loading" }),
		/* @__PURE__ */ (0, J.jsx)("span", { className: "child-shimmer-loading" })
	]
}, e)) }), hy = ({ name: e, channelId: t, subscribedInstallations: n, subscribedInstallationsCount: r, description: i, isDefault: a, searchKey: o, openDeleteReleaseChannelModal: s, openEditReleaseChannelModal: c }) => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "display-grid dc__align-items-center dc__column-gap-16 release-channel__table-row fs-13 fw-4 lh-20 cn-9 px-20 dc__hover-n50 dc__visible-hover dc__visible-hover--parent",
	children: [
		/* @__PURE__ */ (0, J.jsx)(vv, { className: "icon-dim-24" }),
		/* @__PURE__ */ (0, J.jsxs)("span", {
			className: "flexbox-col",
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flex left dc__gap-8",
				children: [/* @__PURE__ */ (0, J.jsx)("span", {
					className: "dc__truncate",
					dangerouslySetInnerHTML: { __html: C.sanitize(zr({
						searchText: o,
						text: e,
						highlightClasses: "bcy-2"
					})) }
				}), a && /* @__PURE__ */ (0, J.jsx)("span", {
					className: "dc__uppercase px-6 fs-12 fw-6 lh-20 cb-5 dc__no-shrink br-4 dc__border eb-2 bcb-1",
					children: "Default"
				})]
			}), /* @__PURE__ */ (0, J.jsx)("span", {
				className: "cn-7 dc__truncate",
				dangerouslySetInnerHTML: { __html: C.sanitize(zr({
					searchText: o,
					text: t,
					highlightClasses: "bcy-2"
				})) }
			})]
		}),
		/* @__PURE__ */ (0, J.jsx)(Wn, {
			theme: Gn.white,
			className: "w-400 dc__align-left mxh-250 dc__overflow-auto",
			placement: "bottom-start",
			Icon: de,
			iconClass: "fcv-5",
			infoText: r ? /* @__PURE__ */ (0, J.jsx)("ul", {
				className: "fs-14 fw-4 lh-20 cn-9 m-0 pl-24",
				children: n.map(({ displayText: e, identifier: t }) => /* @__PURE__ */ (0, J.jsx)("li", { children: e }, t))
			}) : /* @__PURE__ */ (0, J.jsx)(Kt, {
				title: "No installations subscribed",
				subTitle: `No installations are subscribed to '${e}'`,
				description: "",
				useInfoIcon: !0,
				rootClassName: "mh-150"
			}),
			heading: `Installations subscribed to ${e}`,
			showCloseButton: !0,
			trigger: "click",
			interactive: !0,
			children: /* @__PURE__ */ (0, J.jsx)("span", {
				className: "cb-5 dc__truncate cursor dc__w-fit-content dc__lowercase",
				children: bs(r)
			})
		}),
		/* @__PURE__ */ (0, J.jsx)("span", {
			className: "dc__truncate",
			children: i || "-"
		}),
		/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flex dc__gap-4",
			children: [/* @__PURE__ */ (0, J.jsx)("button", {
				type: "button",
				className: "dc__visible-hover--child dc__transparent p-4 flex",
				"data-testid": `release-channel__edit-button-${t}`,
				"aria-label": "Edit release channel",
				onClick: c({
					name: e,
					description: i,
					isDefault: a,
					channelId: t
				}),
				children: /* @__PURE__ */ (0, J.jsx)(v, { className: "scn-6 icon-dim-16 dc__no-shrink" })
			}), /* @__PURE__ */ (0, J.jsx)("button", {
				type: "button",
				className: "dc__visible-hover--child dc__transparent icon-delete p-4 flex",
				"data-testid": `release-channel__delete-button-${t}`,
				onClick: s({
					releaseChannelId: t,
					releaseChannelName: e
				}),
				"aria-label": "Delete release channel",
				children: /* @__PURE__ */ (0, J.jsx)(T, { className: "icon-delete__hover icon-dim-16 dc__no-shrink" })
			})]
		})
	]
}), gy = ({ handleClose: e }) => {
	let [t, n, r, i] = K(() => jg({ lite: !1 })), [a, s] = A(null), [c, l] = A(null), u = !!a, d = !!c, { searchKey: f, handleSearch: p, clearFilters: m, sortBy: h, sortOrder: g, handleSorting: _ } = mi({ initialSortKey: yv.name }), v = k(() => {
		if (n?.length) {
			let e = f.toLowerCase().trim() ? n.filter((e) => e.name.toLowerCase().includes(f) || e.channelId.toLowerCase().includes(f)) : structuredClone(n);
			return h === yv.subscribedInstallationCount ? e.sort((e, t) => Ur(e.subscribedInstallationsCount, t.subscribedInstallationsCount, g)) : e.sort((e, t) => G(e.name, t.name, g));
		}
		return [];
	}, [
		n,
		f,
		h,
		g
	]), y = !t && !v?.length, b = ({ releaseChannelId: e, releaseChannelName: t }) => () => {
		l({
			releaseChannelId: e,
			releaseChannelName: t
		});
	}, x = () => {
		l(null);
	}, S = () => {
		s(structuredClone(xv));
	}, C = (e) => () => {
		s(structuredClone(e));
	}, w = () => {
		s(null);
	}, T = () => /* @__PURE__ */ (0, J.jsxs)("button", {
		type: "button",
		className: "cta flex dc__gap-4 lh-20-imp h-32",
		onClick: S,
		children: [/* @__PURE__ */ (0, J.jsx)(o, { className: "icon-dim-16 dc__no-shrink fcn-0" }), /* @__PURE__ */ (0, J.jsx)("span", { children: "Add Release Channel" })]
	}), ee = (e) => () => {
		_(e);
	};
	return /* @__PURE__ */ (0, J.jsxs)(Mt, {
		position: "right",
		width: "1024px",
		onEscape: e,
		children: [
			/* @__PURE__ */ (0, J.jsx)("div", {
				className: "bg__primary h-100 flexbox-col show-shimmer-loading",
				children: /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col flex-grow-1 dc__overflow-auto",
					children: [/* @__PURE__ */ (0, J.jsx)("div", {
						className: "dc__position-sticky dc__top-0 bg__primary dc__zi-20",
						children: /* @__PURE__ */ (0, J.jsxs)("div", {
							className: "flex flex-justify dc__border-bottom pt-10 pr-20 pb-10 pl-20",
							children: [/* @__PURE__ */ (0, J.jsx)("h2", {
								className: "fs-16 fw-6 lh-24 m-0 dc__ellipsis-right",
								children: "Release Channels"
							}), /* @__PURE__ */ (0, J.jsx)("button", {
								type: "button",
								className: "dc__transparent dc__no-shrink flexbox",
								"aria-label": "close-modal",
								onClick: e,
								children: /* @__PURE__ */ (0, J.jsx)(Ee, { className: "icon-dim-24 icon-use-fill-n6" })
							})]
						})
					}), /* @__PURE__ */ (0, J.jsx)(Ie, {
						isLoading: !1,
						error: r,
						errorScreenManagerProps: {
							code: r?.code,
							reload: i
						},
						children: y && !f ? /* @__PURE__ */ (0, J.jsx)(F, {
							title: "No Release Channel is added",
							subTitle: "Release channel is way to subscribe one or group of tenant (installation) for easy management (such as bulk deployments, user access management etc).",
							classname: "flex flex-grow-1",
							image: Pi,
							isButtonAvailable: !0,
							renderButton: T
						}) : /* @__PURE__ */ (0, J.jsxs)("div", {
							className: "flexbox-col flex-grow-1",
							children: [/* @__PURE__ */ (0, J.jsxs)("div", {
								className: "flex dc__content-space dc__gap-12 px-20 py-12",
								children: [/* @__PURE__ */ (0, J.jsx)(On, {
									inputProps: { placeholder: "Search release channel" },
									initialSearchText: f,
									handleEnter: p,
									containerClassName: "w-250"
								}), T()]
							}), y && f ? /* @__PURE__ */ (0, J.jsx)(Gt, {
								classname: "flex flex-grow-1",
								handleClearFilters: m
							}) : /* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
								className: "display-grid dc__column-gap-16 release-channel__table-row release-channel__table-row--header dc__border-bottom-n1 fs-12 fw-6 lh-20 cn-7 dc__align-items-center dc__uppercase bg__primary px-20 dc__top-49 dc__position-sticky dc__zi-4",
								children: [
									/* @__PURE__ */ (0, J.jsx)("span", {}),
									/* @__PURE__ */ (0, J.jsx)(z, {
										isSorted: h === yv.name,
										sortOrder: g,
										title: "Channel Name",
										triggerSorting: ee(yv.name),
										disabled: !1
									}),
									/* @__PURE__ */ (0, J.jsx)(z, {
										isSorted: h === yv.subscribedInstallationCount,
										sortOrder: g,
										title: "Subscribed installation",
										triggerSorting: ee(yv.subscribedInstallationCount),
										disabled: t
									}),
									/* @__PURE__ */ (0, J.jsx)(z, {
										title: "Description",
										isSortable: !1
									}),
									/* @__PURE__ */ (0, J.jsx)("span", {})
								]
							}), /* @__PURE__ */ (0, J.jsx)("div", { children: t ? /* @__PURE__ */ (0, J.jsx)(my, {}) : v.map((e) => /* @__PURE__ */ (0, J.jsx)(hy, {
								...e,
								searchKey: f,
								openDeleteReleaseChannelModal: b,
								openEditReleaseChannelModal: C
							})) })] })]
						})
					})]
				})
			}),
			d && /* @__PURE__ */ (0, J.jsx)(py, {
				...c,
				handleClose: x,
				handleSuccess: i
			}),
			u && /* @__PURE__ */ (0, J.jsx)(wv, {
				handleClose: w,
				handleSuccess: i,
				releaseChannelConfig: a
			})
		]
	});
}, _y = ({ tenantId: e, image: t, name: n, description: r, installations: i, searchText: a, refetchTenantsList: o }) => {
	let s = ki();
	return /* @__PURE__ */ (0, J.jsx)("button", {
		type: "button",
		className: "dc__transparent p-0 bg__primary br-8 dc__info-card w-100",
		onClick: () => {
			s(q(I.TENANTS.DETAIL.ROOT, { tenantId: e }));
		},
		children: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "p-16 flexbox-col dc__gap-12",
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox dc__content-space dc__gap-4",
				children: [/* @__PURE__ */ (0, J.jsx)(sf, { imageProps: {
					src: t,
					alt: `Logo for tenant: ${n}`,
					loading: "lazy"
				} }), /* @__PURE__ */ (0, J.jsx)(fv, {
					tenantId: e,
					name: n,
					handleSuccess: o,
					openTenantEditModal: () => {
						s(q(I.TENANTS.EDIT, { tenantId: e }));
					}
				})]
			}), /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flex column left dc__content-space dc__gap-12 flex-grow-1",
				children: [/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col dc__gap-4",
					children: [/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsx)(D, {
						content: n,
						arrow: !1,
						className: "default-tt dc__word-break",
						placement: "top",
						children: /* @__PURE__ */ (0, J.jsx)("h3", {
							className: "cn-9 fs-16 fw-6 lh-24 dc__truncate m-0 dc__w-fit-content",
							dangerouslySetInnerHTML: { __html: C.sanitize(zr({
								searchText: a,
								text: n,
								highlightClasses: "bcy-2"
							})) }
						})
					}), /* @__PURE__ */ (0, J.jsx)(D, {
						content: e,
						arrow: !1,
						className: "default-tt dc__word-break",
						placement: "top",
						children: /* @__PURE__ */ (0, J.jsx)("p", {
							className: "cn-9 fs-13 fw-4 lh-20 dc__truncate m-0 mono dc__w-fit-content",
							dangerouslySetInnerHTML: { __html: C.sanitize(zr({
								searchText: a,
								text: e,
								highlightClasses: "bcy-2"
							})) }
						})
					})] }), /* @__PURE__ */ (0, J.jsx)(lt, {
						condition: !!r,
						wrap: (e) => /* @__PURE__ */ (0, J.jsx)(D, {
							content: r,
							arrow: !1,
							className: "default-tt dc__word-break",
							placement: "top",
							children: e
						}),
						children: /* @__PURE__ */ (0, J.jsx)("p", {
							className: "m-0 cn-7 fw-4 lh-18 fs-12 dc__ellipsis-right__2nd-line dc__w-fit-content dc__align-left",
							children: r || "No description"
						})
					})]
				}), /* @__PURE__ */ (0, J.jsx)("div", {
					className: "dc__truncate fs-13 fw-6 lh-20 cn-9",
					children: bs(i.length)
				})]
			})]
		})
	});
}, vy = Array.from([
	,
	,
	,
].keys()).map((e) => ({
	id: e,
	tenantId: `${e}`,
	name: "",
	description: "",
	image: "",
	installations: [],
	createdBy: "",
	createdOn: "",
	note: "",
	catalogSchemaResourceId: 0
})), yy = () => /* @__PURE__ */ (0, J.jsx)(J.Fragment, { children: vy.map(({ tenantId: e }) => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "dc__transparent br-4 p-16 flexbox-col dc__gap-12 bg__primary dc__info-card dc__info-card--no-hover show-shimmer-loading",
	children: [/* @__PURE__ */ (0, J.jsx)("div", {
		className: "flexbox dc__content-space dc__gap-4",
		children: /* @__PURE__ */ (0, J.jsx)("div", { className: "icon-dim-48 dc__chart-grid-item__icon br-4 child-shimmer-loading h-48" })
	}), /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col dc__content-space dc__gap-12 flex-grow-1",
		children: [/* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col dc__gap-4 h-100",
			children: [
				/* @__PURE__ */ (0, J.jsx)("div", { className: "child-shimmer-loading h-24" }),
				/* @__PURE__ */ (0, J.jsx)("p", { className: "m-0 child-shimmer-loading h-20" }),
				/* @__PURE__ */ (0, J.jsx)("p", { className: "m-0 child-shimmer-loading h-36" })
			]
		}), /* @__PURE__ */ (0, J.jsx)("div", { className: "child-shimmer-loading h-20" })]
	})]
}, e)) }), by = (e) => ({ releaseChannelId: e.getAll(Uu.releaseChannelId).map((e) => e.trim()).filter((e) => !!e) }), xy = () => {
	let [e, t] = A(!1), n = ki(), r = Pe(new AbortController()), { searchKey: i, handleSearch: a, clearFilters: s, releaseChannelId: c, updateSearchParams: l } = gi({ parseSearchParams: by }), u = c.length > 0 || !!i, [d, f, p, m] = K(() => rr(() => M_({ releaseChannelId: c }, r.current.signal), r), [c.toString()]), [h, g, , _] = K(() => jg()), v = k(() => Ud(g), [g]), y = d || yr(p), b = !y && !f?.length && !u, x = k(() => {
		if (f) {
			let e = i.trim().toLowerCase();
			return e ? f.filter((t) => t.name.toLowerCase().includes(e) || t.tenantId.toLowerCase().includes(e)) : f;
		}
		return [];
	}, [i, f]), S = () => {
		t((e) => !e);
	}, C = () => {
		S(), _(), m();
	}, w = () => {
		n(I.TENANTS.CREATE);
	}, T = () => {
		n("..");
	}, ee = (e) => {
		a(e?.trim());
	}, E = () => /* @__PURE__ */ (0, J.jsxs)("button", {
		className: "cta flex h-32 lh-20-imp dc__gap-6",
		type: "button",
		"data-testid": "add-tenant-button",
		onClick: w,
		children: [/* @__PURE__ */ (0, J.jsx)(o, { className: "icon-dim-14 dc__no-shrink" }), "Add tenant"]
	});
	return /* @__PURE__ */ (0, J.jsxs)(Ie, {
		isLoading: !1,
		error: p,
		errorScreenManagerProps: {
			code: p?.code,
			reload: m
		},
		children: [
			/* @__PURE__ */ (0, J.jsx)("div", {
				className: "flexbox-col dc__overflow-auto px-20 pb-12 bg__primary flex-grow-1",
				children: b ? /* @__PURE__ */ (0, J.jsx)(F, {
					title: "Add your first tenant",
					subTitle: "Tenants represent the organizations or teams you deliver software to. Create tenants to deploy and manage releases across multiple environments using Devtron's multi-tenant capabilities.",
					isButtonAvailable: !0,
					renderButton: E,
					image: Ki,
					classname: "flex-grow-1"
				}) : /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsxs)("div", { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox dc__align-items-center dc__content-space py-12",
					children: [/* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flex left dc__gap-8",
						children: [/* @__PURE__ */ (0, J.jsx)(On, {
							inputProps: {
								placeholder: "Search by tenant name or id",
								disabled: y
							},
							handleEnter: ee,
							initialSearchText: i,
							containerClassName: "w-250",
							keyboardShortcut: "/"
						}), /* @__PURE__ */ (0, J.jsx)(Rg, {
							appliedReleaseChannelIds: c,
							handleApplyFilter: (e) => {
								l({ releaseChannelId: e.map(({ value: e }) => e.toString()) });
							},
							releaseChannelList: g,
							isReleaseChannelLoading: h
						})]
					}), /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flex right dc__gap-12",
						children: [/* @__PURE__ */ (0, J.jsx)("button", {
							className: "cta secondary flex h-32 lh-20-imp",
							type: "button",
							"data-testid": "view-release-channel",
							onClick: S,
							children: /* @__PURE__ */ (0, J.jsx)("span", {
								className: "cn-7",
								children: "View Release Channels"
							})
						}), E()]
					})]
				}), !h && /* @__PURE__ */ (0, J.jsx)(Bt, {
					filterConfig: { releaseChannelId: c },
					clearFilters: s,
					onRemoveFilter: l,
					className: "pt-0-imp pb-12",
					getFormattedLabel: zg,
					getFormattedValue: (e, t) => e === Uu.releaseChannelId ? v[t] : null
				})] }), y || x.length ? /* @__PURE__ */ (0, J.jsx)("div", {
					className: "display-grid tenants__list-container dc__gap-16 flex-grow-1",
					children: y ? /* @__PURE__ */ (0, J.jsx)(yy, {}) : x.map((e) => /* @__PURE__ */ Me(_y, {
						...e,
						key: e.tenantId,
						searchText: i,
						refetchTenantsList: m
					}))
				}) : /* @__PURE__ */ (0, J.jsx)(Gt, {
					classname: "flex-grow-1",
					handleClearFilters: s
				})] })
			}),
			e && /* @__PURE__ */ (0, J.jsx)(gy, { handleClose: C }),
			/* @__PURE__ */ (0, J.jsxs)(Di, { children: [
				/* @__PURE__ */ (0, J.jsx)(Ei, {
					path: j.SOFTWARE_RELEASE_MANAGEMENT.TENANTS.CREATE,
					element: /* @__PURE__ */ (0, J.jsx)(uv, {
						handleClose: T,
						handleSuccess: m
					})
				}),
				/* @__PURE__ */ (0, J.jsx)(Ei, {
					path: j.SOFTWARE_RELEASE_MANAGEMENT.TENANTS.EDIT,
					element: /* @__PURE__ */ (0, J.jsx)(uv, {
						handleClose: T,
						handleSuccess: m
					})
				}),
				/* @__PURE__ */ (0, J.jsx)(Ei, {
					path: "*",
					element: /* @__PURE__ */ (0, J.jsx)(Ti, {
						to: "",
						replace: !0
					})
				})
			] })
		]
	});
}, Sy = () => /* @__PURE__ */ (0, J.jsxs)(Di, { children: [/* @__PURE__ */ (0, J.jsx)(Ei, {
	path: `${j.SOFTWARE_RELEASE_MANAGEMENT.TENANTS.DETAIL.ROOT}/*`,
	element: /* @__PURE__ */ (0, J.jsx)(fy, {})
}), /* @__PURE__ */ (0, J.jsx)(Ei, {
	index: !0,
	path: "/*",
	element: /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsx)(n_, { headerType: "tenants" }), /* @__PURE__ */ (0, J.jsx)(xy, {})] })
})] }), Cy = () => /* @__PURE__ */ (0, J.jsx)("div", {
	className: "flexbox-col h-100 dc__overflow-hidden",
	children: /* @__PURE__ */ (0, J.jsxs)(Di, { children: [
		/* @__PURE__ */ (0, J.jsx)(Ei, {
			path: `${j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.ROOT}/*`,
			element: /* @__PURE__ */ (0, J.jsx)(O_, {})
		}),
		/* @__PURE__ */ (0, J.jsx)(Ei, {
			path: `${j.SOFTWARE_RELEASE_MANAGEMENT.TENANTS.ROOT}/*`,
			element: /* @__PURE__ */ (0, J.jsx)(Sy, {})
		}),
		/* @__PURE__ */ (0, J.jsx)(Ei, {
			path: "*",
			element: /* @__PURE__ */ (0, J.jsx)(Ti, {
				to: j.SOFTWARE_RELEASE_MANAGEMENT.RELEASES.ROOT,
				replace: !0
			})
		})
	] })
}), wy = /* @__PURE__ */ function(e) {
	return e.Draft = "Draft", e.Propose = "Propose", e.Express = "Express", e;
}({}), Ty = {
	"last-version-outdated": "This file version is outdated. Please refresh to get the latest changes.",
	"already-in-terminal-state": "This draft no longer exists. The changes were either approved or discarded, please refresh to check the latest state.",
	"user-committed-to-draft": "You have made changes to this file. Users who have edited a file cannot approve the changes.",
	"template-outdated": "Configuration version being used for this file is outdated. Please discard this draft and create a new one.",
	"draft-exists-already": "A draft already exists against this file. Please refresh to view the latest state.",
	"config-protection-disabled": "Configuration protection for this environment has been disabled. Please refresh and try saving again."
}, Ey = {
	[wy.Draft]: {
		label: "Save as draft",
		description: "Others can make changes to the saved draft"
	},
	[wy.Propose]: {
		label: "Propose changes",
		description: "Submit changes for approval"
	},
	[wy.Express]: {
		label: "Express Create",
		description: "You’re allowed to create file without approval"
	}
}, Dy = {
	[wy.Draft]: null,
	[wy.Propose]: {
		label: "Propose Changes",
		description: "File will be deleted after the request is approved"
	},
	[wy.Express]: {
		label: "Express Delete",
		description: "Delete file without approval"
	}
}, Oy = "Create without approval", ky = (e) => {
	if (e instanceof Mn && Array.isArray(e.errors)) {
		let t = e.errors.find((e) => !!Ty[e.userMessage]);
		if (t) {
			B.showToast({
				variant: V.error,
				description: Ty[t.userMessage]
			});
			return;
		}
	}
	W(e);
}, Ay = (e) => Va(e).sort(G).map((e) => ({
	label: e,
	value: e,
	startIcon: dr(e, "mr-0-imp")
})), jy = (e, t, n = {}) => {
	let r = Qr(null), i = {
		[Ue.configMap]: r,
		[Ue.configSecret]: r,
		[Ue.deploymentTemplate]: r,
		[Ue.deploymentTrigger]: r
	};
	return (e ?? []).reduce((e, n) => {
		let r = (n?.approvalConfigurations ?? []).reduce((e, t) => (e[t.kind] = Qr(t), e), structuredClone(i));
		return e[n[t]] = {
			isApprovalApplicable: Object.values(r).some((e) => _r(e)) || !1,
			approvalConfigurationMap: r
		}, e;
	}, n);
}, My = (e) => Gr(_.CONFIG_DRAFTS, e), Ny = (e) => H(`${_.CONFIG_DRAFTS}/${e}`), Py = async (e, t, n, r, i) => {
	let a = await H(Nr(_.CONFIG_DRAFTS, {
		resourceName: r,
		resourceType: n,
		appId: e,
		envId: t
	}), { abortControllerRef: i });
	return {
		...a,
		result: {
			...a?.result,
			userApprovalMetadata: $r(a?.result?.userApprovalMetadata)
		}
	};
}, Fy = (e, t, n) => H(`${_.CONFIG_DRAFTS}/app?appId=${e}&envId=${t}&resourceType=${n}`), Iy = (e) => Yr(`${_.CONFIG_DRAFTS_VERSION}`, e), Ly = (e, t) => Gr(`${_.CONFIG_DRAFTS}/approve?draftId=${e}&draftVersionId=${t}`, {}), Ry = (e) => H(`${_.CONFIG_DRAFTS_COMMENTS}/${e}`), zy = (e, t) => ti(`${_.CONFIG_DRAFTS_COMMENTS}?draftId=${e}&draftCommentId=${t}`), By = async (e) => {
	let { result: t } = await H(Nr(_.CONFIG_PROTECT, { appId: e })), n = Qr(null), r = {
		[Ue.configMap]: n,
		[Ue.configSecret]: n,
		[Ue.deploymentTemplate]: n,
		[Ue.deploymentTrigger]: n
	};
	return jy(t, "envId", { [Ke]: {
		isApprovalApplicable: !1,
		approvalConfigurationMap: structuredClone(r)
	} });
}, Vy = async (e) => {
	let { result: t } = await H(Nr(`${_.CONFIG_PROTECT}/env`, { envId: e }));
	return jy(t, "appId");
}, Hy = (e) => /* @__PURE__ */ (0, J.jsxs)("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...e,
	children: [
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M7.97088 6.80423L7.24512 3.89335L4.33423 4.61911",
			stroke: "#8C6324",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M7.75093 19.0715C6.82227 18.5135 6.01261 17.7781 5.36818 16.9072C4.72375 16.0363 4.25716 15.047 3.99506 13.9958C3.73296 12.9445 3.68048 11.852 3.84062 10.7805C4.00076 9.70898 4.37037 8.6795 4.92837 7.75085L7.24604 3.89359",
			stroke: "#8C6324",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M16.0281 17.1954L16.7539 20.1063L19.6648 19.3805",
			stroke: "#8C6324",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M16.2491 4.9283C17.1777 5.48629 17.9874 6.22174 18.6318 7.09264C19.2763 7.96354 19.7428 8.95285 20.0049 10.0041C20.267 11.0553 20.3195 12.1479 20.1594 13.2194C19.9993 14.2909 19.6296 15.3203 19.0716 16.249L16.754 20.1062",
			stroke: "#8C6324",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M12 7.5V12.75",
			stroke: "#8C6324",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ (0, J.jsx)("path", {
			d: "M12 17.0571C12.5681 17.0571 13.0286 16.5966 13.0286 16.0286C13.0286 15.4605 12.5681 15 12 15C11.4319 15 10.9714 15.4605 10.9714 16.0286C10.9714 16.5966 11.4319 17.0571 12 17.0571Z",
			fill: "#8C6324"
		})
	]
}), Uy = ({ hasDrift: e, liveManifest: t, desiredManifest: n }) => /* @__PURE__ */ (0, J.jsx)(ot, {
	readOnly: !0,
	mode: ln.YAML,
	diffView: !0,
	noParsing: !0,
	modifiedValue: tr(t),
	originalValue: tr(n),
	height: "fitToParent",
	children: /* @__PURE__ */ (0, J.jsxs)(ot.Header, {
		hideDefaultSplitHeader: !0,
		children: [/* @__PURE__ */ (0, J.jsx)("p", {
			className: "m-0 fs-12 fw-6 lh-20 cn-9",
			children: "Desired Manifest"
		}), /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox dc__gap-8 pl-16 dc__align-items-center m-0 fs-12 fw-6 lh-20 cn-9",
			children: [/* @__PURE__ */ (0, J.jsx)("span", { children: "Live Manifest" }), e && /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox dc__gap-4 dc__align-items-center dc__no-shrink",
				children: [/* @__PURE__ */ (0, J.jsx)(Hy, { className: "icon-dim-16" }), /* @__PURE__ */ (0, J.jsx)("span", {
					className: "cy-7",
					children: "Config Drift"
				})]
			})]
		})]
	})
}), Wy = (e) => e?.hasDrift && /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [e.health?.status && /* @__PURE__ */ (0, J.jsx)("span", { className: "dc__bullet mw-4" }), /* @__PURE__ */ (0, J.jsx)("span", {
	className: "cy-7",
	children: "Config drift detected"
})] }), Gy = (e) => /* @__PURE__ */ (0, J.jsxs)("div", {
	className: "flexbox bcy-8 cn-0 px-20 py-4 dc__gap-8",
	children: [/* @__PURE__ */ (0, J.jsx)("span", { children: "Out of sync from desired manifest." }), /* @__PURE__ */ (0, J.jsx)("button", {
		className: "dc__unset-button-styles dc__underline",
		type: "button",
		onClick: e,
		children: "Check configuration drift"
	})]
}), Ky = (e) => {
	let t = e.resources.reduce((e, t) => (e[t.kind] || (e[t.kind] = {
		kind: t.kind,
		hasDrift: !1,
		nodes: []
	}), e[t.kind].nodes.push(t), e[t.kind].hasDrift = e[t.kind].hasDrift || t.hasDrift, e), {});
	return { resources: Object.values(t) };
}, qy = async ({ appId: e, envId: t, setSelectedNode: n, setExpandedState: r }) => {
	let i = {
		appId: e,
		envId: t
	}, a = Ky((await H(Nr(_.DRIFT_MANAGED_RESOURCES, i))).result);
	return a.resources.length && (r({ [a.resources[0].kind]: !0 }), n(a.resources[0].nodes[0])), a;
}, Jy = (e, t) => Gr(_.DRIFT_MANAGED_RESOURCE, e, { signal: t }), Yy = ({ appId: e, envId: t }) => {
	let [n, r] = A(null), [i, a] = A({}), [o, s, c, l] = K(() => qy({
		appId: +e,
		envId: +t,
		setSelectedNode: r,
		setExpandedState: a
	}), [e, t]), u = (e) => {
		r(e);
	}, d = (e) => {
		let t = i[e] ?? !1;
		a({
			...i,
			[e]: !t
		});
	}, f = k(() => s?.resources.map((e) => ({
		id: e.kind,
		header: e.kind,
		...e.hasDrift && !i[e.kind] && { headerIconConfig: { Icon: Hy } },
		items: e.nodes.map((e) => ({
			title: e.name,
			...e.hasDrift && { iconConfig: { Icon: Hy } },
			isActive: n?.name === e.name && n?.kind === e.kind,
			onClick: () => u(e)
		})),
		isExpanded: i[e.kind] ?? !1
	})) ?? [], [
		s,
		n,
		i
	]), { hasDrift: p, predictedLiveState: m, normalizedLiveState: h } = n ?? {};
	return /* @__PURE__ */ (0, J.jsx)(Ie, {
		isLoading: o,
		error: c,
		progressingProps: { pageLoader: !0 },
		errorScreenManagerProps: {
			code: c?.code,
			reload: l
		},
		children: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flex-grow-1 flexbox mh-0",
			children: [/* @__PURE__ */ (0, J.jsx)("div", {
				className: "w-240 dc__border-right p-8 dc__no-shrink dc__overflow-auto",
				children: /* @__PURE__ */ (0, J.jsx)(st, {
					config: f,
					tabType: "button",
					onCollapseBtnClick: d
				})
			}), n && /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "mw-none flexbox-col flex-grow-1",
				children: [/* @__PURE__ */ (0, J.jsx)("div", {
					className: "px-12 py-8 fs-13 fw-6 lh-20 cn-9",
					children: `${n.kind} / ${n.name}`
				}), /* @__PURE__ */ (0, J.jsx)(Uy, {
					hasDrift: p,
					liveManifest: h,
					desiredManifest: m
				}, `${n.kind} / ${n.name}`)]
			})]
		})
	});
}, Xy = ({ modalState: e, setModalState: t, scanResult: n }) => {
	let r = Dr({
		category: e.category,
		subCategory: e.subCategory
	}), i = kr({
		imageScan: !!n?.imageScan,
		codeScan: !!n?.codeScan,
		kubernetesManifest: !!n?.kubernetesManifest,
		imageScanLicenseRisks: !!n?.imageScan?.license,
		selectedId: r,
		scanResult: n
	});
	return /* @__PURE__ */ (0, J.jsx)("div", {
		className: "px-8 py-12 w-240 dc__no-shrink",
		children: /* @__PURE__ */ (0, J.jsx)(qn, {
			nodes: i,
			defaultExpandedMap: (() => {
				let e = {};
				return i.forEach((t) => {
					t.type === "heading" && (e[t.id] = !0, t.items?.forEach((e) => {
						if (e.type === "heading") throw Error("Please implement dfs based handling for nested headings in security sidebar");
					}));
				}), e;
			})(),
			selectedId: r,
			onSelect: (e) => {
				t({
					...Er(e.id),
					detailViewData: null
				});
			}
		})
	});
}, Zy = ({ intelligenceConfig: e, isIconButton: t = !1, debugAgentContext: n, onClick: r }) => {
	let { setIntelligenceConfig: i, setDebugAgentContext: a, sidePanelConfig: o, setSidePanelConfig: s, debugAgentContext: c } = ui(), { handleCloseThread: l, handleInitiateStream: u } = Do();
	return /* @__PURE__ */ (0, J.jsx)("div", {
		className: "explain-ai-button",
		children: /* @__PURE__ */ (0, J.jsx)(M, {
			dataTestId: "ai-explain-button",
			size: P.medium,
			onClick: async (t) => {
				t?.stopPropagation(), be.event({
					category: "Explain AI Button",
					action: `${e.analyticsCategory}_EXPLAIN`
				}), window._env_.FEATURE_ATHENA_DEBUG_MODE_ENABLE ? n && (o.state !== Nn.ASK_DEVTRON || !c || !cr(c, n)) && (a(n), s((e) => ({
					...e,
					state: Nn.ASK_DEVTRON
				})), await l(), u({
					messageInput: n.prompt,
					selectedThread: null,
					debugAgentContext: n
				})) : i(e), r?.();
			},
			...t ? {
				variant: N.borderLess,
				icon: /* @__PURE__ */ (0, J.jsx)(Yt, {
					name: "ic-sparkle-ai-color",
					color: null
				}),
				ariaLabel: "Explain with AI",
				style: $e.neutral
			} : {
				text: "Explain",
				variant: N.text,
				startIcon: /* @__PURE__ */ (0, J.jsx)(Yt, {
					name: "ic-sparkle-ai-color",
					color: null
				})
			}
		})
	});
};
//#endregion
//#region src/Components/Filters/AppliedFilters/FilterInfoTooltip.tsx
function Qy() {
	let [e, t, n] = K(le);
	return /* @__PURE__ */ (0, J.jsx)(rn, {
		heading: "Know more",
		additionalContent: /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox-col p-12 dc__gap-12 dc__align-self-stretch bg__primary",
			children: [
				/* @__PURE__ */ (0, J.jsxs)("p", {
					className: "cn-9 fs-13 fw-4 lh-20 m-0",
					children: [/* @__PURE__ */ (0, J.jsx)(Ot, {
						docLinkKey: "CEL",
						text: "CEL expression",
						dataTestId: "learn-more-about-filters-link",
						openInNewTab: !0
					}), "\xA0is used to define pass & fail filter conditions"]
				}),
				/* @__PURE__ */ (0, J.jsx)("div", { className: "bcn-1 h-1 w-100" }),
				n ? null : e ? /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col dc__gap-12 mxh-210 bg__primary dc__no-border dc__overflow-auto",
					children: [
						/* @__PURE__ */ (0, J.jsx)("div", { className: "shimmer-loading w-100 h-16" }),
						/* @__PURE__ */ (0, J.jsx)("div", { className: "shimmer-loading w-100 h-16" }),
						/* @__PURE__ */ (0, J.jsx)("div", { className: "shimmer-loading w-100 h-16" }),
						/* @__PURE__ */ (0, J.jsx)("div", { className: "shimmer-loading w-100 h-16" })
					]
				}) : /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col dc__align-self-stretch",
					children: [/* @__PURE__ */ (0, J.jsx)("p", {
						className: "m-0 fs-13 fw-6 lh-20 cn-9",
						children: "Possible filter criteria"
					}), t.map((e) => /* @__PURE__ */ (0, J.jsxs)("div", {
						className: "flexbox dc__content-space",
						children: [/* @__PURE__ */ (0, J.jsx)("p", {
							className: "m-0 cn-9 fs-13 fw-4 lh-20",
							children: e.label
						}), /* @__PURE__ */ (0, J.jsx)("p", {
							className: "m-0 cn-5 fs-13 fw-4 lh-20",
							children: e.type
						})]
					}, e.label))]
				})
			]
		}),
		children: /* @__PURE__ */ (0, J.jsxs)("button", {
			className: "h-20 fs-13 fw-4 lh-20 p-0 cb-5 dc__no-background dc__no-border dc__outline-none-imp flex dc__gap-4",
			type: "button",
			children: [/* @__PURE__ */ (0, J.jsx)(i, { className: "icon-dim-16 fcb-5" }), "Know more"]
		})
	});
}
//#endregion
//#region src/Components/Filters/AppliedFilters/ConfiguredFilters.tsx
var $y = /* @__PURE__ */ t({ default: () => eb }), eb = ({ isFromBulkCD: e, resourceFilters: t, handleDisableFiltersView: n, envName: r, closeModal: i, showDisableFiltersButton: a = !0, deployedTime: o }) => {
	let [s, c] = A(Vt.PASS), l = k(() => {
		let e = [];
		return t && t.forEach((t) => {
			t.conditions.forEach((n) => {
				n.conditionType === s && e.push({
					name: t.name,
					expression: n.expression
				});
			});
		}), e;
	}, [t, s]), u = (e) => {
		c(Number(e.value));
	}, d = (e) => /* @__PURE__ */ (0, J.jsx)("button", {
		type: "button",
		className: e,
		onClick: n,
		"aria-label": "Disable filters view",
		children: /* @__PURE__ */ (0, J.jsx)(Xa, { className: "icon-dim-16 scn-6 m-0" })
	});
	return /* @__PURE__ */ (0, J.jsxs)("div", {
		className: "flexbox-col h-100 dc__content-space",
		children: [e ? /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox p-16 bg__tertiary dc__content-space dc__align-self-stretch",
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox dc__align-items-center dc__gap-12",
				children: [a && d("bg__primary dc__outline-none-imp flex p-0 h-24 w-24 dc__border br-4 dc__hover-border-n300 dc__hover-n50"), /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col",
					children: [/* @__PURE__ */ (0, J.jsx)("p", {
						className: "m-0 cn-9 fs-14 fw-4 lh-24",
						children: xe.BULK_CD
					}), o && /* @__PURE__ */ (0, J.jsxs)("i", {
						className: "cn-6 fs-14 fw-4 lh-24",
						children: ["at the time image was deployed: ", o]
					})]
				})]
			}), /* @__PURE__ */ (0, J.jsx)(Qy, {})]
		}) : /* @__PURE__ */ (0, J.jsxs)("div", {
			className: "flexbox dc__content-space dc__align-items-center dc__align-self-stretch dc__border-bottom pt-12 pb-12 pl-20 pr-20 bg__primary",
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox dc__align-items-center dc__align-self-stretch dc__gap-16",
				children: [a && d("dc__no-background dc__no-border dc__outline-none-imp flex p-0"), /* @__PURE__ */ (0, J.jsxs)("div", {
					className: "flexbox-col",
					children: [/* @__PURE__ */ (0, J.jsx)("p", {
						className: "m-0 cn-9 fs-14 fw-4 lh-24",
						children: r ? /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [
							xe.CD,
							"\xA0",
							/* @__PURE__ */ (0, J.jsx)("span", {
								className: "m-0 cn-9 fs-16 fw-7",
								children: r
							})
						] }) : /* @__PURE__ */ (0, J.jsx)("p", {
							className: "m-0 cn-9 fs-14 fw-4 lh-24",
							children: xe.BULK_CD
						})
					}), o && /* @__PURE__ */ (0, J.jsxs)("i", {
						className: "cn-6 fs-13 fw-4 lh-24",
						children: ["at the time image was deployed: ", o]
					})]
				})]
			}), /* @__PURE__ */ (0, J.jsx)("button", {
				type: "button",
				className: "dc__no-background dc__no-border dc__outline-none-imp flex p-0",
				onClick: i,
				"aria-label": "Close",
				children: /* @__PURE__ */ (0, J.jsx)(Ee, { className: "icon-dim-20 fcn-6" })
			})]
		}), /* @__PURE__ */ (0, J.jsxs)("div", {
			className: `flexbox-col h-100 dc__align-self-stretch bg__tertiary ${e ? "pl-16 pr-16" : "pl-20 pr-20"}`,
			children: [/* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flexbox dc__align-items-center dc__content-space pt-14 pb-14 dc__align-self-stretch",
				children: [/* @__PURE__ */ (0, J.jsx)(kn, {
					segments: fe,
					value: String(s),
					onChange: u,
					name: "applied-filters-segmented-control"
				}), !e && /* @__PURE__ */ (0, J.jsx)(Qy, {})]
			}), /* @__PURE__ */ (0, J.jsx)("div", {
				className: "flexbox-col pt-0 pb-16 dc__gap-8 flex-grow-1 dc__align-self-stretch dc__overflow-auto",
				children: l.length ? /* @__PURE__ */ (0, J.jsx)(J.Fragment, { children: l.map((e) => /* @__PURE__ */ (0, J.jsx)(Za, {
					name: e.name,
					expression: e.expression
				}, e.name)) }) : /* @__PURE__ */ (0, J.jsx)(Gt, { title: `No ${(() => {
					switch (s) {
						case Vt.PASS: return "pass";
						case Vt.FAIL: return "fail";
						default: return "";
					}
				})()} conditions are defined` })
			})]
		})]
	});
}, tb = /* @__PURE__ */ t({ default: () => nb });
function nb({ userApprovalMetadata: e, showApprovalCounts: t, triggeredBy: r, neverShowConfiguredFilters: i = !1, appliedFilters: a, appliedFiltersTimestamp: o, promotionApprovalMetadata: s, selectedEnvironmentName: c, isDeploymentWithoutApproval: l }) {
	let [u, d] = A(!1), f = () => {
		d(!1);
	}, p = () => {
		d(!0);
	}, m = s?.approvedUsersData?.map((e) => e.userEmail);
	return !l && !_r(e?.approvalConfigData) && a.length === 0 && !s?.promotedFromType ? null : /* @__PURE__ */ (0, J.jsxs)(J.Fragment, { children: [/* @__PURE__ */ (0, J.jsxs)("div", {
		className: "w-100 bg__primary flex left dc__gap-8 px-12 pt-8 pb-7 border__primary dc__top-radius-4",
		children: [
			!!s?.promotedFromType && /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flex dc__gap-8",
				children: [/* @__PURE__ */ (0, J.jsx)(_a, {
					promotedTo: c,
					promotedFrom: s.promotedFrom,
					promotedFromType: s.promotedFromType,
					promotedBy: s.requestedUserData?.userEmail,
					approvedBy: m,
					promotionPolicyName: s.policy?.name,
					showBackgroundColor: !1
				}), (a.length > 0 || !!e) && /* @__PURE__ */ (0, J.jsx)("div", { className: "dc__bullet" })]
			}),
			l ? /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flex left dc__gap-6",
				children: [/* @__PURE__ */ (0, J.jsx)(Yt, {
					name: "ic-lightning-fill",
					color: "Y500"
				}), /* @__PURE__ */ (0, J.jsx)("p", {
					className: "m-0 fs-13 lh-20 cn-9",
					children: "Deployed by an exception user"
				})]
			}) : !!_r(e?.approvalConfigData) && /* @__PURE__ */ (0, J.jsxs)("div", {
				className: "flex dc__gap-8",
				children: [/* @__PURE__ */ (0, J.jsx)(Ya, {
					userApprovalMetadata: e,
					showCount: t,
					triggeredBy: r
				}), a.length > 0 && /* @__PURE__ */ (0, J.jsx)("div", { className: "dc__bullet" })]
			}),
			a.length > 0 && /* @__PURE__ */ (0, J.jsx)(D, {
				className: "default-tt",
				placement: "top",
				content: "Image filters configured at the time of deployment.",
				arrow: !1,
				children: /* @__PURE__ */ (0, J.jsxs)("button", {
					className: "flexbox dc__align-items-center dc__gap-4 fs-13 fw-4 lh-20 dc__hover-color-b500 cursor cn-9 dc__no-border dc__content-space dc__outline-none-imp p-0 bg__primary",
					onClick: p,
					type: "button",
					children: [!_r(e?.approvalConfigData) && /* @__PURE__ */ (0, J.jsx)(n, { className: "icon-dim-16" }), "Passing Filters"]
				})
			})
		]
	}), u && !i && /* @__PURE__ */ (0, J.jsx)(Qn, {
		className: "",
		parentClassName: "dc__overflow-hidden",
		close: f,
		children: /* @__PURE__ */ (0, J.jsx)("div", {
			className: "modal-body--cd-material h-100",
			onClick: ei,
			children: /* @__PURE__ */ (0, J.jsx)(eb, {
				isFromBulkCD: !1,
				resourceFilters: a,
				handleDisableFiltersView: f,
				closeModal: f,
				deployedTime: Rr(o),
				showDisableFiltersButton: !1
			})
		})
	})] });
}
//#endregion
export { md as $, Pa as $t, qh as A, eo as At, $ as B, za as Bt, Dy as C, Yi as Cn, vo as Ct, Cy as D, lo as Dt, wy as E, fo as Et, Fh as F, qa as Ft, xf as G, ka as Gt, $p as H, Va as Ht, Sh as I, Ka as It, Wd as J, Ca as Jt, bf as K, Oa as Kt, ph as L, Ga as Lt, Rh as M, Qa as Mt, Lh as N, Xa as Nt, j_ as O, ro as Ot, Ih as P, Ja as Pt, dd as Q, Ma as Qt, lh as R, Ua as Rt, ky as S, Xi as Sn, xo as St, Oy as T, qi as Tn, co as Tt, Cf as U, Ba as Ut, em as V, Ha as Vt, Sf as W, Sa as Wt, ld as X, Ta as Xt, gd as Y, Fa as Yt, ud as Z, ja as Zt, Py as _, ea as _n, jo as _t, Xy as a, ya as an, Zu as at, Iy as b, Qi as bn, Oo as bt, Wy as c, ua as cn, Ru as ct, Ly as d, oa as dn, rc as dt, Ea as en, hd as et, zy as f, ma as fn, ys as ft, Ny as g, ra as gn, Mo as gt, Vy as h, aa as hn, No as ht, Zy as i, ba as in, $u as it, Kh as j, $a as jt, Yh as k, to as kt, Gy as l, da as ln, Sc as lt, By as m, pa as mn, Po as mt, eb as n, Ia as nn, sd as nt, Yy as o, _a as on, Xu as ot, Fy as p, ca as pn, Io as pt, mf as q, wa as qt, $y as r, Na as rn, ad as rt, Jy as s, fa as sn, Hu as st, tb as t, Da as tn, fd as tt, Hy as u, sa as un, xc as ut, Ry as v, $i as vn, Ao as vt, Ey as w, Ji as wn, so as wt, Ay as x, Zi as xn, Do as xt, My as y, na as yn, ko as yt, Qm as z, Ra as zt };
